var App = App || {};

App.controls = {

};

;(function() {
	let self = App.controls.account_holidays = {
		is_updated: false,
		config: {
			holidays : {},
			extraday : {},
			saturday_work: false,
			firstDay: 0,
		},

		init: function() {
			self.is_updated = false;
			if ($('#override_is_wsat').length) {
				self.config.saturday_work = 1*$('#override_is_wsat').val() === 1;
				App.controls.datepicker.config.saturday_work = self.config.saturday_work;
			} // override by administative option

			let scrollZone = App.modal.obj_window.find('.scrollZone').get(0), scrollPointer = $('<div class="scrollPointer scrollPointer-on"></div>');
			if (scrollZone) {
				scrollPointer.append('<ws-icon name="arrows/chevron-down"></ws-icon>');
				$(scrollZone).on('ps-ready', function() {
					const ps = scrollZone.scrollBars;
					setTimeout(function(){
						$(scrollZone).addClass('scrollZone-bottom').after(scrollPointer);
					}, 300);

					scrollZone.addEventListener('ps-scroll-up', function () {
						scrollPointer.addClass('scrollPointer-on');
					});
					scrollZone.addEventListener('ps-y-reach-end', function () {
						scrollPointer.removeClass('scrollPointer-on');
					});
					scrollZone.addEventListener('ps-scroll-down', function () {
						$(".modal__header, .modal__header > .in").css({cursor: 'n-resize'});
					});
					scrollZone.addEventListener('ps-y-reach-start', function () {
						$(".modal__header, .modal__header > .in").css({cursor: 'initial'});
					});
					scrollPointer.click(function () {
						if (scrollPointer.hasClass('scrollPointer-on')) {
							App.controls.js_scrollbars.waitSmoothScrolling(ps);
							scrollZone.scrollTo({top: scrollZone.scrollHeight, behavior: 'smooth'});
						}
					});
					$(".modal__header, .modal__header > .in").on("click", function (event) {
						// If the clicked element is the same as the one listening for the click event
						if (event.target === this ) {
							App.controls.js_scrollbars.waitSmoothScrolling(ps);
							scrollZone.scrollTo({top: 0, behavior: 'smooth'});
						}
					});
				});
			}

			$("#dateend_div2").datepicker({
				rangeSelect: false,
				numberOfMonths: 12,
				stepMonths: 12,
				firstDay: App.datepicker_firstDay || 0,
				markCurrentDay: false,
				altField: '#adm_date_extra',
				altFormat: 'd.m.yy.w',
				beforeShowDay: function (date) {
					let date_str = App.helper.date.to_input(date);
					let is_weekend = date.getDay() === 0 || (!self.config.saturday_work && date.getDay() === 6);
					if (date_str in self.config.extraday && !is_weekend) delete self.config.extraday[date_str];
					if (self.config.holidays && (date_str in self.config.holidays)) return [true, 'ui-datepicker-holiday' + (is_weekend ? ' ui-datepicker-force-weekend' : '')];
					if (self.config.extraday && (date_str in self.config.extraday)) return [true, 'ui-datepicker-extraday'];
					return [true, ''];
				},
				onSelect: function (date) {
					$("#dateend_div2").css({height: $("#dateend_div2").height()}); // prevent scroll
					setTimeout(function() {
						$("#dateend_div2").css({height: ''});
					}, 50);
					$('#dateend').val(date);
					if (date) {
						self.is_updated = true;
						App.modal.obj_window.addClass('withCalChanges');
						let date_nice = $('#adm_date_extra').val();
						let adt = date_nice.split('.');
						let str = '';
						let dt = App.format.digits_2(adt[0]) + '.' + App.format.digits_2(adt[1]) + '.' + adt[2];
						let is_weekend = adt[3] == 7 || (!self.config.saturday_work && adt[3] == 6);
						if (is_weekend) { // common weekend
							if (dt in self.config.extraday) delete self.config.extraday[dt]; else self.config.extraday[dt] = 1;
							if (dt in self.config.holidays) delete self.config.holidays[dt];
						} else { // common workday
							if (dt in self.config.holidays) delete self.config.holidays[dt]; else self.config.holidays[dt] = 1;
							if (dt in self.config.extraday) delete self.config.extraday[dt];
						}
						for (let i in self.config.extraday) str += (str === '' ? '' : ',') + i;
						$('#ids_adm_extraday').val(str);
						str = '';
						for (let i in self.config.holidays) str += (str === '' ? '' : ',') + i;
						$('#ids_adm_holidays').val(str)
					}
				},
				defaultDate: new Date(new Date().getFullYear(), 0, 1),
				fullScreen: true
			});
		}

	}
})();

;(function() {


	let self = App.controls.account_phone_update = {
		CONTACT_TYPE_OWNER: 1,
		CONTACT_TYPE_OPERATIONAL: 2,
		CONTACT_TYPE_PAYMENT: 3,
		show_popup: false,
		obj_window: null,
		scroll_into_view: false,
		iti_instances: [],
		error_codes: {
			INVALID_COUNTRY_CODE: 1,
			REQUIRED_AGREE: 2,
		},
		// locale defaults, will be inited with translates later
		locale: {
			contact: 'Contact',
			try_again_later: 'Try again later',
			required: 'Required',
			phone_invalid: 'The phone is in the wrong format.',
			phone_errors: {
				"1": "Invalid country calling code",
				"2": "Phone number too short",
				"3": "Phone number too long",
			},
			menu_country_placeholder: 'Country',
		},
		modal: {
			is_shown: function () {
				return App.modal.is_shown() && App.modal.obj_window.find('input[name="action"]').val() == 'account_contacts:apply';
			},
			show: function () {

				if (self.modal.is_shown()) return;

				// we already have the same, but inline, at account settings page
				if ( App.page.where() == 'account' && $('.headerConfig__tabs').find('.act').attr('href')?.includes('tab=notifications') ) return;

				self.modal.shown = true;
				App.controls.loader.start();
				App.controls.account_phone_update.helpers.inject_script(() => {
					App.controls.loader.stop();
					App.modal.show({
						dismissible: false,
						backup: true,
						url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('account_contacts:show')),
						onhide: function (e, by_user) {
							// зберігаємо стан закриття, лише коли це сам юзера закрив
							if (by_user) {
								self.show_popup = false;
								$.post(App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('account_contacts:hide')));
							}
							try {
								self.iti_instances.forEach(iti => iti.destroy());
							} catch (error) {
								// ignore, cause modal.obj_window removed from DOM
							}
						}
					});
				});
			}
		},
		helpers: {
			inject_script: function (resolve) {
				App.core.inject_script_once(
					'/assets/js/vendor/phone_country/index.js',
					() => {
						if (window.intlTelInputUtils) {
							if (resolve) resolve();
							return;
						}
						window.intlTelInputGlobals.loadUtils('/assets/js/vendor/phone_country/utils.js')
							?.then(() => {
								if(resolve ) resolve();
							})
							?.catch(() => {
								throw new Error('Failed to load phone utils');
							});
					},
					() => {
						throw new Error('Failed to load phone plugin');
					}
				);
			},
		},
		init: function () {

			self.obj_window = $('#account-contacts').length ? $('#account-contacts') : App.modal.obj_window;


			if (self.scroll_into_view && self.obj_window.is('#account-contacts')) {
				self.obj_window.scrollIntoView({block: 'center'});
				self.scroll_into_view = false;
			}

			const form = self.obj_window.find('form');

			self._init_buttons(form);
			self._init_agree_input(form);
			self._init_phone_input(form);
			self._init_dropdown(form);
		},

		_init_buttons: function (form) {

			const button_primary = form.find('.item-setup-buttons').find('.button_primary');
			const button_primary_text = button_primary.attr('text');
			const button_primary_update_text = button_primary.attr('data-update-text');
			const agree_input = form.find('input[name=agree');
			const required_force_agree_input = agree_input.attr('data-required') == 'force';

			const show_agree = () => {
				if (!required_force_agree_input) {
					agree_input.attr('required', true);
				}
			};
			const hide_agree = () => {
				if (!required_force_agree_input) {
					// not required == hidden by css rule, so reset agree to initial state
					agree_input.removeAttr('required');
					// agree_input.prop('checked', false);
					agree_input.closest('.item-setup-buttons__checkbox').toggleClass('has-error', false);
					agree_input.closest('.item-setup-buttons__checkbox-wrapper').find('.error-text').addClass('error-text-hidden').text('');
				}
			};

			let initial_values = {};
			form.find('input[name^="id_user"], input[name^="phone\\["]').each(function () {
				initial_values[this.name] = $(this).val();
			});

			form.on('input change', function () {
				let is_changed = false;
				let is_agree_need = false;
				form.find('input[name^="id_user"], input[name^="phone\\["]').each(function () {

					let value = $(this).val();
					if ($(this).is('input[name^="phone\\["]')) {
						const iti = window.intlTelInputGlobals.getInstance(this);
						if (iti) {
							value = iti.getNumber();
						}
					}

					if (value && value.toInt() && value !== initial_values[this.name]) {
						is_agree_need = true;
					}
					if (value !== initial_values[this.name]) {
						is_changed = true;
					}
				});

				button_primary.attr('text', is_changed ? button_primary_update_text : button_primary_text);
				is_agree_need ? show_agree() : hide_agree();
			});
		},

		_init_agree_input: function (form) {

			const input = form.find('input[name=agree');
			input.next().on('keydown', function (e) {
				let key = e.keyCode ? e.keyCode : e.charCode;
				if (key === App.keycode.Space) {
					e.preventDefault();
					$(this).prev().trigger('click');
				}
			});
			input.on('change', function () {
				$(this).closest('.item-setup-buttons__checkbox').toggleClass('has-error', !$(this).prop('checked'));
				$(this).closest('.item-setup-buttons__checkbox-wrapper').find('.error-text').addClass('error-text-hidden').text('');
			});
		},

		_init_phone_input: function (form) {

			const inputs = form.find('.info-card').not('.info-card-disabled').find('input[name^=phone\\[]');

			inputs.each(function () {

				const country_menu_container = self._country_menu_container(this);

				const iti = window.intlTelInput(this, {
					excludeCountries: ['ru'],
					preferredCountries: ['ua', 'pl', 'de', 'fr', 'gb'],
					autoPlaceholder: 'off',
					dropdownContainer: country_menu_container.get(0),
				});

				self.iti_instances.push(iti);
				$(this).on('open:countrydropdown', function (e) {

					self._country_menu_wrap(iti);
					self._country_menu_process(iti);

					App.menu.show({
						anchor: this,
						type: 'parent width',
						box: '#'+country_menu_container.attr('id'),
						onhide: function () { // "after" hide
							if ($(iti.countryList).hasClass('iti__hide')) return;
							App.helper.nextTick(() => iti._closeDropdown());
						}
					});
				});
				$(this).on('close:countrydropdown', function (e) {
					if (App.menu.is_shown() && App.menu.obj_window.get(0) === country_menu_container.get(0)) {
						country_menu_container.get(0).appendChild(iti.dropdown);
						$(iti.countryList).removeClass('iti__hide');
						App.menu.hide();
						$(iti.countryList).addClass('iti__hide');
						if (iti.dropdown.parentNode) iti.dropdown.parentNode.removeChild(iti.dropdown);
					}
				});

				$(this).val($(this).val().replace(/[^0-9+]+/g, ''));
				if (!iti.isValidNumber()) {
					const formatted_number = iti.getNumber().replace(/\+/, '');
					if (iti.getNumber() != formatted_number) {
						iti.setNumber(formatted_number);
						$(this).val($(this).val().replace(/[^0-9+]+/g, ''));
					}
				}

				const validate_input = (input) => {
					const card = $(input).closest('.info-card');
					let is_valid = true;
					if ($(input).prop('required') && !$(input).val().trim()) {
						is_valid = false; // error: empty not allowed
					} else if ($(input).val().trim()) {
						is_valid = iti.isValidNumber(); // error: validation failed
					}
					card.toggleClass('has-error', !is_valid);
				};
				const clear_input_error = (input) => {
					const card = $(input).closest('.info-card');
					card.removeClass('has-error');
					card.find('.error-text').addClass('error-text-hidden').text('');
				};

				$(this)
					.on('input change', function () {
						clear_input_error(this);
						validate_input(this);
						$(this).closest('.info-card').toggleClass('info-card-empty-phone', this.value == '');
						$(this).closest('.info-card').find('.info-card__input-wrapper').find('[data-role="alert-icon"]').remove();
					})
					.on('focus', function (e, data) {
						if (data && data['skip-error-clear']) return;
						clear_input_error(this);
					})
					.on('blur', function () {
						validate_input(this);
					})
					.on('countrychange', () => {
						form.trigger('change');
					});
			});
		},

		_init_dropdown: function (form) {
			// show menu
			form.on('click', 'a.info-card__dropdown', function (e) {
				e.preventDefault();
				if ($(e.target).closest('.av_wrap').length) return true;
				self.menu.user.show(this);
			});
			// reset values
			form.on('click', '.av_wrap', function (e) {
				e.preventDefault();
				const card = $(this).closest('.info-card');
				card.find('input[name^=id_user]').val(0);
				card.find('input[name^=phone\\[]').val('').trigger('change');
				card.addClass('info-card-empty');
			});
		},

		_country_menu_container: function (input) {
			input = $(input).get(0);

			const menu_id = input.id + '__menu';
			if ($('#'+menu_id).length == 0) {
				$('#fixed_container').append($('<div>', { id: menu_id, class: 'menu menu-secondary' }));
			}

			return $('#' + menu_id);
		},

		_country_menu_wrap: function (iti) {

			// do it once
			if ($(iti.dropdown).hasClass('menu__group__wrapper')) return;

			$(iti.dropdown).addClass('menu__group__wrapper flex_column');

			$(iti.dropdown).prepend(`<div class="menu__group menu__group-search flex_row">
				<ws-icon name="search_sm"></ws-icon>
				<span class="in flex_content"><input type="text" onkeyup="App.context_search.menu.apply(this, App.menu.obj_window)" value="" placeholder="${self.locale.menu_country_placeholder}"></span>
				<a onclick="$(this).closest('.menu__group-search').find('input').val('').trigger('keyup');" class="delete svg_hover"><ws-icon name="cancel_sm:cancel_sm-solid"></ws-icon></a>
			</div>${self.locale.menu_county_empty_html}`);

			$(iti.dropdown).append();

			$(iti.countryList).addClass('scrollZone keyboardZone').attr('data-select', '.menu__item')
				.find('.iti__country').addClass('menu__item flex_row')
				.find('.iti__country-name').addClass('flex_content flex_overflow');

			const list = $(iti.countryList);
			const children = list.children().toArray();
			const grouped = [];

			let currentGroup = [];

			children.forEach((el) => {
				if (el.classList.contains('iti__divider')) {
					// створюємо групу з попередніх елементів
					if (currentGroup.length) {
						grouped.push(currentGroup);
						currentGroup = [];
					}
					// видаляємо розділювач (не включаємо його в жодну групу)
					el.remove();
				} else {
					currentGroup.push(el);
				}
			});

			// додаємо останню групу
			if (currentGroup.length || grouped.length === 0) {
				grouped.push(currentGroup);
			}

			// очищаємо список
			list.empty();

			// створюємо нову структуру з li.menu__group > ul > ...
			grouped.forEach((group, index) => {
				const groupLi = document.createElement('li');
				groupLi.className = 'menu__group';

				// перша група preffered, містить дублі з звичайної групи, тому виключимо з пошуку
				if (grouped.length > 1) {
					if (index === 0) groupLi.className += ' menu__group-exceptSearch';
					else groupLi.className += ' menu__group-searchable';
				}

				const ul = document.createElement('ul');
				group.forEach((item) => ul.appendChild(item));

				groupLi.appendChild(ul);
				list.append(groupLi);
			});
		},

		_country_menu_process: function (iti) {
			document.removeEventListener("keydown", iti._handleKeydownOnDropdown);
			document.documentElement.removeEventListener("click", iti._handleClickOffToClose);

			$(iti.countryList).find('.iti__country').removeClass('menu__item-active').filter('.iti__active').addClass('menu__item-active');
		},

		validate_form: function (form) {
			let is_valid = true;
			let error_code = -1;

			const agree_input = form.find('input[name=agree]');
			if (agree_input.prop('required')) {
				if (!agree_input.prop('checked')) {
					agree_input.closest('.item-setup-buttons__checkbox').addClass('has-error');
					is_valid = false;
					error_code = self.error_codes.REQUIRED_AGREE;
					agree_input.closest('.item-setup-buttons__checkbox-wrapper').find('.error-text').removeClass('error-text-hidden').text(self.locale.required);
				} else {
					agree_input.closest('.item-setup-buttons__checkbox').removeClass('has-error');
					agree_input.closest('.item-setup-buttons__checkbox-wrapper').find('.error-text').addClass('error-text-hidden').text('');
				}
			}

			form.find('.info-card').not('.info-card-disabled').find('input[name^=phone\\[]').each(function () {
				const card = $(this).closest('.info-card');
				const iti = window.intlTelInputGlobals.getInstance(this);
				let valid = true;
				let error_message = '';
				const value = $(this).val().trim();
				if ($(this).prop('required') && !value) {
					valid = false;
					error_message = self.locale.required;
				} else if (value) {
					valid = iti.isValidNumber();
					if (!valid) {
						const validation_error = iti.getValidationError();
						error_code = validation_error == window.intlTelInputUtils.validationError.INVALID_COUNTRY_CODE ? 1 : -1;
						error_message = self.locale.phone_errors[validation_error] ?? self.locale.phone_invalid;
					}
				}
				if (valid) {
					$(this).closest('.info-card').removeClass('has-error');
					card.find('input[name^=phone_list').val(iti.getNumber().replace(/\+/, ''));
					card.find('.error-text').addClass('error-text-hidden').text('');
				} else {
					is_valid = false;
					$(this).closest('.info-card').addClass('has-error');
					card.find('input[name^=phone_list').val('');
					card.find('.error-text').toggleClass('error-text-hidden', error_message == '').text(error_message);
				}
			});

			return { is_valid, error_code };
		},

		form_submit: function (form) {
			form = $(form);

			const { is_valid, error_code } = self.validate_form(form);

			if (!is_valid) {
				form.find('.button_primary').animate_css('head-shake');
				if (!App.device.is_mobile()) {
					if (error_code == self.error_codes.INVALID_COUNTRY_CODE) {
						form.find('.has-error').find('.iti__selected-flag').first().trigger('focus');
					} else if (error_code == self.error_codes.REQUIRED_AGREE) {
						form.find('.has-error').find('input[name=agree]').next().trigger('focus');
					} else {
						form.find('.has-error').find('input:visible').first().trigger('focus', {
							'skip-error-clear': true
						});
					}
				}
				return;
			}

			App.core.form_submit(form.get(0));
		},

		menu: {
			user: {
				show: function (anchor, data) {

					const url = $(anchor).attr('data-endpoint');

					data = $.extend({}, {
						anchor,
						url,
						type: 'parent width',
						title: ''
					}, data);

					App.menu.show($.extend({}, data, {
						onshow: function () {
							const menu = $(this);
							menu.find('.search_contact').off('click').on('click', function() {
								self.menu.contact.show(anchor, { ...data, replace: true });
								return false;
							});
						}
					}));
				},
				apply: function (menu_item, id_type, id) {
					menu_item = $(menu_item);

					const role = menu_item.find('.role_ico').clone();
					const avatar = menu_item.find('.av_sm').clone();
					const phone = menu_item.attr('data-phone');
					const name = menu_item.children('.in').contents().filter(function() {
						return this.nodeType === Node.TEXT_NODE;
					}).text().trim();
					role.attr('data-title-config', 'top_right');

					self.menu.apply_general(id_type, {
						role,
						avatar,
						phone,
						name,
						id
					});
				}
			},
			contact: {
				show: function(anchor, params) {
					params ||= {};
					App.controls.contact_select_and_go.show_context(anchor, null, {
						request: {init: 1, type: 'account_contacts'},
						type: params.type || '',
						replace: params.replace || false,
						backup: params.backup || false,
						text_position : params.text_position || null,
						no_anim : params.no_anim || false,
						width: 360,
						onload: function() {
							let menu = $(this);
							menu.on('click', '.menu__item[data-id]', function () {
								self.menu.contact.apply(this, self.CONTACT_TYPE_PAYMENT, $(this).attr('data-id'));
							});
						},
						// onshow: function () {
						// 	let menu = $(this);
						// 	menu.find('.search_mention').off('click').on('click', function() {
						// 		self.helper_mention({ ...params, replace: true });
						// 		return false
						// 	});
						// }
					});
				},
				apply: function (menu_item, id_type, id) {
					menu_item = $(menu_item);

					id = id.split('_')[0];

					const role = $('<span class="role_ico"><ws-icon name="contacts"></ws-icon></span>');
					const avatar = menu_item.find('.av_sm').clone();
					const phone = menu_item.attr('data-phone');
					const name = menu_item.children('.in').contents().filter(function() {
						return this.nodeType === Node.TEXT_NODE;
					}).text().trim();
					role.attr('data-title-config', 'top_right')
						.attr('data-title', self.locale.contact);

					self.menu.apply_general(id_type, {
						role,
						avatar,
						phone,
						name,
						id
					});
				},
				apply_general: function (id_type, data) {

					if (!id_type) {
						id_type = self.CONTACT_TYPE_PAYMENT;
					}

					const role = $('<span class="role_ico"><ws-icon name="contacts"></ws-icon></span>');
					role.attr('data-title-config', 'top_right')
						.attr('data-title', self.locale.contact);

					self.menu.apply_general(id_type, { ...data, role });
				}
			},
			apply_general: function (id_type, data) {

				const el = $('#account_contacts'+id_type).find('.info-card__dropdown-value');
				const card = el.closest('.info-card');
				const phone_input = card.find('input[name^=phone\\[]');

				const avatar = data.avatar;
				const phone = data.phone ?? '';
				const name = data.name;
				const id = data.id;
				const role = data.role ?? '';

				App.menu.hide(true);

				el.find('.in').find('[data-role="name"]').text(name);
				el.find('.av_sm').replaceWith(avatar);
				el.find('.role_ico').remove();
				if (role) el.find('.in').append(role);
				card.removeClass('info-card-empty');
				el.find('[data-role="alert-icon"]').remove();
				card.find('input[name^=id_user]').val(id);
				if (window.intlTelInputGlobals && window.intlTelInputGlobals.getInstance(phone_input.get(0))) {
					window.intlTelInputGlobals.getInstance(phone_input.get(0)).setNumber(phone);
				} else {
					phone_input.val(phone);
				}
				phone_input.trigger('change').focus_desktop();
			}
		},

		destructor: function () {

			// TODO: може винести в загальний контролер для всіх iti
			// а тут чистити тільки "свої" self.iti_instances інпути?
			if (window.intlTelInputGlobals) {
				Object.keys(window.intlTelInputGlobals.instances).forEach((key) => {
					window.intlTelInputGlobals.instances[key].destroy();
				});
			}

			self.obj_window?.removeWithComponents();

			self.show_popup = false;
			self.obj_window = null;
			self.scroll_into_view = false;
			self.iti_instances = [];
		},

		onLoadPage: function () {
			try {
				self.iti_instances.forEach(iti => iti.destroy());
			} catch (error) {
				// ignore, for safety ^_^
			}

			if (self.show_popup) {
				self.modal.show();
			}
		},
		onLogout: function () {
			self.destructor();
		}
	}
})();

;(function() {
	let self = App.controls.auth_2fa_off = {

		confirm: function (anchor) {

			if (!$(anchor).hasClass('sw_act')) return;

			App.controls.confirm.menu(anchor, {
				message: App.object_state.locale.confirm_2fa_off,
				onconfirm: function () {
					const url = $(anchor).attr('data-endpoint');
					$.ajax({
						url,
						success: function () {
							$(anchor).removeClass('sw_act');
						}
					});
				},
			});
		}
	};
})();

;(function() {
	let self = App.controls.auth_2fa_profile = {

		obj_window: null,
		obj_window_adm: null,

		init: function () {
			self.init_adm();
			self.init_usr();
		},

		init_adm: function () {
			if ($('#profile_setup_2fa_adm').length) {
				self.obj_window_adm = $('#profile_setup_2fa_adm');
			}
		},

		init_usr: function () {
			if ($('#profile_setup_2fa').length) {
				self.obj_window = $('#profile_setup_2fa');
				self.onload();
			}
		},

		load: function (query_params) {

			const id_user = +App.profile.modal_obj.attr('data-user');

			const url = App.helper.url.add_query(
				App.helper.endpoint.user(id_user),
				App.actions.get('user_profile_privacy:show_2fa'),
				query_params
			);

			App.core.async_task.ajax({
				id: 'auth_2fa_profile_load',
				type: 'GET',
				url,
				dataType: 'html',
				before_start: function () {
					App.controls.loader.overlay.start(self.obj_window, { overlayTheme: 'light' });
				}
			}).then(function (html) {
				self.obj_window.replaceWith(html);
				self.init_usr();

				// помагає, коли висота блоку різко зменшується)
				self.obj_window.closest('.scrollZone').scrollUpdate();
			}).finally(function () {
				App.controls.loader.overlay.stop(self.obj_window);
			});
		},

		reload: function () {
			self.load();
		},

		onload: function () {
			self.obj_window.find('ws-code-input').on('ws-code-input', function (e) {
				const form = $(this).closest('form');
				const btn = form.find('.button_primary');
				if (e.detail.status && e.detail.source === 'paste') {
					btn.prop('disabled', false);
					btn.click();
				} else if (e.detail.status) {
					btn.prop('disabled', false);
				} else {
					btn.prop('disabled', true);
				}
			});
			self.obj_window.find('.button_primary').on('click', function (e) {

				if ($(this).prop('disabled')) return false;
				if (self.obj_window.attr('data-loading') === 'true') return false;
				App.controls.loader.overlay.start(self.obj_window, { overlayTheme: 'light' });

				App.core.form_submit($(this).closest('form').get(0));
			});
			self.obj_window.find('.button_load').on('click', function (e) {

				const is_2fa = $(this).attr('data-load-is-2fa');
				const step = $(this).attr('data-load-step');

				self.load({ is_2fa, step });
			});
		},

		destructor: function () {

			if (!self.obj_window) return;

			App.core.async_task.abort('auth_2fa_profile_load');
			self.obj_window = null;
			self.obj_window_adm = null;
		},

		onBoot: function () {
			App.bus.state.on('user_security', function (payload, context) {

				if (!App.profile.is_shown_user(+payload.id)) return;

				const id_user = +payload.id;
				const { is_2fa: is_2fa_raw } = payload.data;
				const is_2fa = App.helper.parseBoolean(is_2fa_raw);

				if (self.obj_window_adm) {
					self.obj_window_adm.find('.sw_pre[data-user="'+id_user+'"]').toggleClass('sw_act', is_2fa);
				}

				if (self.obj_window && id_user === +App.profile.modal_obj.attr('data-user')) {
					if (context.active_tab) return;
					self.reload();
				}
			});

			App.bus.app.on('profile_loading profile_closed', function (payload, context) {
				self.destructor();
			});

			App.bus.app.on('profile_loaded', function (payload, context) {
				self.init();
			});
		}
	};
})();

;(function() {
	let self = App.controls.client_questions = {
		endpoint: '',
		locale: {},
		complete: false,
		init: function() {
			App.modal.dont_hide = true;
			App.modal.obj_overlay.off('click');
			App.modal.obj_window.addClass('client_questions_modal');
			$(window).on('touschmove', function() { return false;})
			/*if ($(window).width() <= 480) {
				App.modal.obj_window.find('.client_questions form').css('min-height', $(window).height() - 40);
			} else {
				$('body').addClass('bd_overflow');
			}*/
			let button = App.modal.obj_window.find('.questions_buttons ws-btn:last'),
				button_back = App.modal.obj_window.find('.questions_buttons ws-btn:first'),
				demo = App.modal.obj_window.find('.demo'),
				work_type;
			App.modal.obj_window.find('.step1 label').on('click', function() {
				work_type = $(this).attr('data-work-type');
				App.modal.obj_window.find('.step1 label:not([data-work-type='+work_type+'])').removeClass('act');
				$(this).addClass('act');
				App.modal.obj_window.find('input[name="is_business"]').val(work_type);
				button.prop('disabled', false).attr('text', work_type === 'work' ? self.locale['continue'] : self.locale['finish']);
			});
			button_back.on('click', function() {
				App.modal.obj_window.find('.options input').val('').addClass('hidden');
				App.modal.obj_window.find('.options ws-btn').removeClass('hidden act');
				App.modal.obj_window.find('.step1, .step2').toggleClass('hidden');
				App.modal.obj_window.find('.demo').addClass('hidden');
				button_back.addClass('hidden');
				button.prop('disabled', false).attr('text', self.locale['continue']);
				App.modal.update_size(-1);

			});
			button.on('click', function() {
				if (work_type === 'work' && !self.check_complete()) {
					button_back.removeClass('hidden');
					App.modal.obj_window.find('.step1').addClass('hidden');
					App.modal.obj_window.find('.step2').removeClass('hidden');
					button.prop('disabled', true).attr('text', self.locale['finish']);
					App.modal.update_size(-1);
				} else {
					let datastring = '&is_business=' + work_type;
					if (work_type === 'work') datastring += '&' + $('#modfrm').serialize();
					$.ajax({
						type: "POST",
						url: self.endpoint + datastring,
						dataType: 'html',
						cache: false,
						contentType: false,
						processData: false,
						success: function (url) {
							$('body').removeClass('bd_overflow');
							self.build_iframe(url);
							App.modal.hide();
						}
					});
					App.modal.dont_hide = false;
				}
			});
			App.modal.obj_window.find('.step2 .options ws-btn').on('click', function() {
				let option = $(this).attr('data-option');
				let value = $(this).attr('data-value');
				App.modal.obj_window.find('.step2 .options ws-btn[data-option=' + option + ']').removeClass('act');
				if (value === 'other') {
					$(this).addClass('hidden');
					$(this).parent().find('input').val('').removeClass('hidden').focus();
				} else {
					$(this).addClass('act');
					$(this).parent().find('ws-btn[data-value="other"]').removeClass('hidden');
					$(this).parent().find('input').val(value).addClass('hidden');
				}
				button.prop('disabled', !self.check_complete());
				demo.toggleClass('hidden', !self.check_complete());
				App.modal.update_size(-1);
			});
			App.modal.obj_window.find('.step2 .options input[type=text]').on('keyup', function() {
				button.prop('disabled', !self.check_complete());
				demo.toggleClass('hidden', !self.check_complete());
			}).on('blur', function() {
				$(this).val($(this).val().trim());
			});
		},
		check_complete: function () {
			let form = App.modal.obj_window.find('form');
			self.complete = true;
			form.find('input').each(function(){
				if ($(this).val().trim() === '') self.complete = false;
			});
			return self.complete;
		},
		build_iframe: function(url) {
			if (url) {
				let iframe = $('<iframe>', {
					id: 'datalayer_qualify',
					src: url,
					style: 'position: absolute !important; opacity: 0 !important; width: 1px !important; height: 1px !important; top: 0 !important; left: 0 !important; border: none !important; display: block !important; z-index: -1 !important; pointer-events: none;'
				}).appendTo(document.body);
				setTimeout(() => {
					iframe.remove();
				}, 5000);
			}
		}
	}
})();
;(function() {
	let self = App.controls.clipboard = {
		locale: {
			// без перекладів, але треба )
			copied: 'Copied'
		},

		onBoot: function () {

			const collect_options = (el) => {
				const button_options = {};
				const res = { button_el: el };
				const keys = [
					'is_textarea',
				];
				keys.forEach((key) => {
					if (el.attr('data-clipboard-'+key)) {
						res[key] = el.attr('data-clipboard-'+key);
					}
				});
				$.each(el.get(0).attributes, (_, attr) => {
					if (attr.name.startsWith('data-clipboard-button-')) {
						const tmpKey = attr.name.replace('data-clipboard-button-', '');
						button_options[tmpKey] = attr.value;
					}
				});
				if (!$.isEmptyObject(button_options)) {
					res.button_options = button_options;
				}
				return res;
			};

			$(document).on('click', '[data-clipboard-target]', function () {
				self.copy($($(this).attr('data-clipboard-target')), collect_options($(this)));
			});
			$(document).on('click', '[data-clipboard-text]', function () {
				self.copy($(this).attr('data-clipboard-text'), collect_options($(this)));
			});
		},

		copy: function (text, options = {}) {
			options = $.extend({}, {
				is_textarea: false,
				button_el: null,
			}, options);
			options.button_options = $.extend({}, {
				timeout: 1200,
				text: options.button_el && options.button_el.attr('text') ? self.locale.copied : undefined,
			}, options.button_options);

			if (!App.core.clipboard(text, options.is_textarea)) return;
			if (options.button_el) self._update_button(options.button_el, options.button_options);
		},

		_update_button: function (button_el, button_options) {

			if (!button_el.length) {
				console.warn('Button not found');
				return;
			}
			if (!button_el.is('ws-btn')) {
				console.warn('Unknown type of button');
				return;
			}

			const original_attributes = {};
			const btn_attributes = [
				'name',
				'text',
				'left-icon',
				'right-icon',
			];

			btn_attributes.forEach(attr => {
				if (button_options[attr] !== undefined) {
					original_attributes[attr] = button_el.attr(attr);
					button_el.attr(attr, button_options[attr]);
				}
			});

			button_el.addClass('clipboard-copied');

			setTimeout(() => {
				button_el.attr(original_attributes);
				button_el.removeClass('clipboard-copied');
			}, button_options.timeout);
		}
	}
})();

;(function() {
	let self = App.controls.code_highlight = {
		loaded: false,
		src: '//cdnjs.cloudflare.com/ajax/libs/highlight.js/9.13.1/highlight.min.js',
		init: function (o) {
			o = o ? o.find('code') : $('code');
			if (o.length) {
				if (!self.loaded) {
					self.loaded = true;
					const theme_path = $('body').attr('data-color') ? 'color/' : '';
					$('head').append(`<link rel="stylesheet" href="/assets/css/${theme_path}code.css" type="text/css" />`);
					$.getScript(self.src, self.init);
				} else {
					if (typeof hljs != 'undefined') o.once_by_criteria('init_hljs').each(function () {
						hljs.highlightBlock(this);
					});
				}
			}
		}
	}
})();

;(function() {
	let self = App.controls.confirm = {
		confirm_handler: null,

		// deprecated, use "App.controls.confirm.menu"
		delete: function (el, title, txt, menu_el, menu_type, but_txt, cancel_txt, on_confirm) {
			self.confirm_handler = on_confirm || null;

			$('#confirmMenu .menu__group-head .in').text(title);
			if (txt) $('#confirmMenu .menu__group-alert').show().find('.in').text(txt); else $('#confirmMenu .menu__group-alert').hide();
			$('#confirmMenu ws-btn[name*=confirm]').attr('data-onconfirm', $(el).attr('data-onconfirm'))
			$('#confirmMenu ws-btn[name*=confirm]').find('span').html(but_txt ? but_txt : $('#confirmMenu ws-btn[name*=confirm]').attr('data-txt'));
			$('#confirmMenu ws-btn[name*=cancel]').find('span').html(cancel_txt ? cancel_txt : $('#confirmMenu ws-btn[name*=cancel]').attr('data-txt'));
			// TODO: data-onconfirm is bad idea. better to use callback

			$('#confirmMenu ws-btn[name*=cancel]').off('click').on('click', function () {
				App.menu.hide();
			});
			$('#confirmMenu ws-btn[name*=confirm]').off('click').on('click', function () {
				App.menu.hide();
				App.controls.confirm.apply(this);
			});

			App.menu.show({
				anchor: menu_el ? menu_el : el,
				box: '#confirmMenu',
				type: menu_type || '',
				title: title
			});
		},

		apply: function (el) {
			if (typeof self.confirm_handler === 'function') {
				setTimeout(self.confirm_handler, 1);
				self.confirm_handler = null;
			} else if ($(el).attr('data-onconfirm')) {
				setTimeout($(el).attr('data-onconfirm'), 1);
			}
		},

		menu: function (el, params) {
			params = params || {};
			self.confirm_handler = params.onconfirm || params.on_confirm || null;
			let menu_type = params.menu_type || '';
			let variant = params.variant || 'w';
			let with_notify = params.with_notify ?? false;
			let old_template = params.template === 'old' || with_notify;

			let text_el = old_template ? $('#confirmMenuNotifyV2 .menu__group-head .in') : $('#confirmMenuV2 .menu__group-head .in');
			let cancel_btn = old_template ? $('#confirmMenuNotifyV2 .cancel') : $('#confirmMenuV2 .cancel');
			let confirm_btn = old_template ? $('#confirmMenuNotifyV2 .btn-primary') : $('#confirmMenuV2 .confirm');
			let message = params.message || text_el.data('txt');

			if (message.startsWith('#') && $(message).length === 1) {
				message = $(message).html();
			}

			text_el.html(message);

			const confirm_handler = function () {
				App.menu.hide_all();

				if (typeof self.confirm_handler === 'function') {
					App.helper.nextTick(self.confirm_handler);
					self.confirm_handler = null;
				}
			};
			const cancel_handler = function () {
				App.menu.hide();
				if (params.oncancel) params.oncancel();
			};

			if (old_template) {
				let confirm_btn2 = $('#confirmMenuNotifyV2 .confirm');
				let notify_btn = $('#confirmMenuNotifyV2 .confirm_with_notify');
				confirm_btn.find('span').html(params.ok_label || confirm_btn.data('txt'));
				notify_btn.find('.btn-double button').removeClass(['btn-a', 'btn-b', 'btn-g', 'btn-w']).addClass('btn-' + variant);

				if (with_notify) {
					notify_btn.show();
					confirm_btn2.hide();
				} else {
					confirm_btn2.attr('text', params.ok_label || confirm_btn2.data('txt')).attr('name', confirm_btn2.data('name') + (' btn-' + variant)).show();
					notify_btn.hide();
				}

				confirm_btn.add(confirm_btn2).off('click').on('click', confirm_handler);
			} else {
				confirm_btn.attr('text', params.ok_label || confirm_btn.data('txt'));
				confirm_btn.attr('name', confirm_btn.data('name') + (' btn-' + variant));
				confirm_btn.off('click').on('click', confirm_handler);
			}

			cancel_btn.attr('text', params.cancel_label || cancel_btn.data('txt'));
			cancel_btn.off('click').on('click', cancel_handler);

			if ($(el).closest('.menu__item').length || $(el).closest('.btns-row').length) {
				menu_type = menu_type || 'submenu';
			}
			$(old_template ? '#confirmMenuNotifyV2' : '#confirmMenuV2').toggleClass('confirmMenu__submenu', menu_type === 'submenu')

			App.menu.show({
				anchor: el,
				box: old_template ? '#confirmMenuNotifyV2' : '#confirmMenuV2',
				type: menu_type || '',
				backup: params.backup || menu_type === 'submenu',
				replace: params.replace || false,
				width: params.width || 'auto',
				onshow: params.onshow || null,
				onhide: params.onhide || null,
				force_dropdown: params.force_dropdown ?? true,
			});
		},

		simple: function(el, confirmTitle = '', confirmText = '', confirmScript = '', confirmColors = '', confirmBackup = 1, yesBtnText = '', confirmIcon = '') {
			self.confirm_handler = null;

			let title = confirmTitle || el.getAttribute('data-confirm-title') || '';
			let text = confirmText || el.getAttribute('data-confirm-text') || '';
			let script = confirmScript || el.getAttribute('data-confirm-script') || '';
			let colors = confirmColors || el.getAttribute('data-confirm-colors') || '';
			let backup = confirmBackup || el.getAttribute('data-confirm-backup') || 0;
			let yes_btn_text = yesBtnText || el.getAttribute('data-yes-btn-text') || App.object_state.locale['confirm'] || 'Confirm';
			let alert_icon = confirmIcon || el.getAttribute('data-confirm-icon') || '';

			let isScriptFunction = typeof script === 'function';

			if (!isScriptFunction && !script.trim().endsWith(';')) {
				script = script.trim() + ';';
			}

			const no_btn_text = App.object_state.locale['cancel'] || 'Cancel';
			const yes_btn_variant = colors.includes('alert') ? 'btn-w' : 'btn-a';
			const info_block_variant = colors.includes('alert') ? 'setupBlock__info-warning' : 'setupBlock__info-a';

			let html = `
			<div class="modal__content__block">
				<div class="setupBlock__info ${info_block_variant}">
					${alert_icon ? `<ws-icon name="${alert_icon}"></ws-icon>` : ''}
					<div class="setupBlock__info-text">
						<div class="setupBlock__text setupBlock__indent">${text}</div>
					</div>
				</div>
			</div>
			<div class="buttons_a_pre"></div>
			<div class="buttons btns-row btns-row-right">
				<ws-btn name="btn btn-36 btn-g btn-skeleton btn-cancel modal__closeButton" text="${no_btn_text}" onclick="App.modal.hide();"></ws-btn>
				<ws-btn name="btn btn-36 ${yes_btn_variant} btn-solid btn-ok" text="${yes_btn_text}" id="confirmbtn"></ws-btn>
			</div>
			`;

			App.modal.show({
				title: title,
				html: html,
				backup: backup
			});

			if (isScriptFunction) {
				$('#confirmbtn').on('click', function() {
					script();
					App.modal.hide();
				});
			} else {
				$('#confirmbtn').attr('onclick', script + ' App.modal.hide();');
			}
		},

		ask: function(anchor, data, type = 'left', options) {
			let container = $('#askMeToGoMenu').find('.menu__group');
			container.html('');
			$.each(data, function(_, item) {
				let anchor_class = item.anchor_class || '';
				let left_icon = item.left_icon || '';
				let right_icon = item.right_icon || '';
				let text = item.text || '';
				let callback = item.callback || null;
				let element = $('<a class="menu__item flex_row">' +
					(left_icon ? '<ws-icon name="' + left_icon + '"></ws-icon>' : '') +
					(text ? '<span class="in flex_content">' + text + '</span>' : '') +
					(right_icon ? '<ws-icon name="' + right_icon + '"></ws-icon>' : '') +
					'</a>')
					.addClass(anchor_class);

				if (callback) element.on('click', callback);
				container.append(element);
			});
			App.menu.show({
				...options,
				anchor: anchor,
				box: '#askMeToGoMenu',
				type: type,
				force_dropdown: true,
			});
		}
	}
})();

;(function () {
	let self = App.controls.contact_menu = {

		show: function (id, ids) {
			App.modal.show({
				url: '/ajax/user/?' + App.actions.get('contact_view:show') + '&id_contact=' + id + (ids ? '&ids=' + ids : ''),
				width: 532,
				title: '',
				group: 'contact'
			});
		},

		show_multiple: function (el, ids) {
			App.menu.show({
				anchor: el,
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('contact_list:show') + '&ids=' + ids),
				type: '',
				title: App.object_state.locale['contacts'],
				onload: function () {
					$(this).find('.menu__item[data-id]').bind('click', function () {
						App.modal.show({
							url: '/ajax/user/?' + App.actions.get('contact_view:show') + '&id_contact=' + $(this).attr('data-id'),
							width: 532,
							title: '',
							group: 'contact'
						});
					});
				}
			});
		},

		group_rename: {
			_sync_input: function (box, input) {
				let idGroup = parseInt(box.attr('data-edit-group'), 10);
				let fromRow = $.trim($('#obj-group' + idGroup + ' span.name').first().text());
				input.val(fromRow || box.attr('data-initial-name') || '');
				App.controls.menu.onkeyup_required(input.get(0));
			},

			_done: function (idGroup, name) {
				App.menu.hide_all();
				$('#obj-group' + idGroup + ' span.name').first().text(name);
				$('[data-load-menu]').filter(function () {
					let u = $(this).attr('data-load-menu') || '';
					return u.indexOf('contact_group_menu:show') !== -1 && u.indexOf('/ajax/user/g' + idGroup + '/') !== -1;
				}).invalidateMenu();
			},

			_onshow: function (menuRoot) {
				let box = $(menuRoot).find('#menuRenameContactGroup');
				let input = box.find('input[name=name]');
				if (!input.length) return;
				self.group_rename._sync_input(box, input);
			},

			_onload: function (menuRoot) {
				let box = $(menuRoot).find('#menuRenameContactGroup');
				let input = box.find('input[name=name]');
				if (!input.length) return;

				self.group_rename._sync_input(box, input);

				box.find('ws-btn').off('click').on('click', function (e) {
					e.preventDefault();
					e.stopPropagation();

					let btn = $(this).find('.btn');
					let name = input.val().trim();
					if (!name) {
						btn.animate_css('head-shake');
						return;
					}

					if (App.core.async_task.is_loading('contact_group_edit_submit')) return;

					let idGroup = parseInt(box.attr('data-edit-group'), 10);
					if (!idGroup) return;

					App.core.async_task.ajax({
						id: 'contact_group_edit_submit',
						method: 'POST',
						url: App.helper.url.add_query(App.helper.url.ajax.user_group(idGroup), box.attr('data-apply-query')),
						data: { name },
						dataType: 'script',
						before_start: function () {
							btn.ws_loading('start');
						}
					}).catch(function (err) {
						if (!err.is_aborted) btn.animate_css('head-shake');
					}).finally(function() {
						btn.ws_loading('stop');
					});
				});
			},
		},
	};
})();

;(function() {
	let self = App.controls.copyterm_picker = {
		onselect: function (date, onchange) {
			self.format_button_date($('#datezero').val());
			let dt_i = App.helper.work_days.diff(App.helper.date.from_input($('#datezero_old').val()), App.helper.date.from_input($('#datezero').val()));
			$('.modal__dataTable-onCopy .td_term2').each(function () {
				let a = $(this).attr('data-terms').split('|');
				if (1 * a[2]) {
				} else if (a[0] && a[1] && a[0] != a[1]) {
					$(this).html($.datepicker.formatDate('d L', App.helper.work_days.add(App.helper.date.from_input(a[0]), dt_i)) + ' - ' + $.datepicker.formatDate('d L', App.helper.work_days.add(App.helper.date.from_input(a[1]), dt_i)));
				} else if (a[1]) {
					$(this).html($.datepicker.formatDate('d LL', App.helper.work_days.add(App.helper.date.from_input(a[1]), dt_i)));
				} else if (a[0]) {
					$(this).html($.datepicker.formatDate('d L', App.helper.work_days.add(App.helper.date.from_input(a[0]), dt_i)) + ' - ...');
				}
				if (typeof onchange === 'function') onchange(this);
			});
		},
		format_button_date: function (date) {
			date ||= $('#datezero-button').find('[data-role=date]').text();
			const formatted_date = $.datepicker.formatDate('d L yy', App.helper.date.from_input(date));
			$('#datezero-button').find('[data-role=date]').text(formatted_date);
		}
	}
})();

;(function() {
	let self = App.controls.costs_add = {
		locale: {}, // from template
		config: {}, // from template
		has_costs: false,
		init: function() {

			App.modal.obj_window.find('[data-container=date]').datepicker({
				rangeSelect: false,
				numberOfMonths: 1,
				monthPicker: true,
				firstDay: App.datepicker_firstDay,
				minDate_: new Date(self.config['min_date_js']),
				maxDate: new Date(),
				unSelReplace: '&bull;',
				onSelect: function (dateText, inst) {
					App.modal.obj_window.find('[data-container=date]').val(dateText).next().attr('text', dateText);
				},
				beforeShowDay: function (date) {
					let override_class = '';
					let override_title = '';
					let override_weekend = '';
					let date_str = App.helper.date.to_input(date);
					if (App.controls.datepicker.config.holidays && (date_str in App.controls.datepicker.config.holidays)) {
						override_weekend = 'holiday';
						override_class = 'ui-datepicker-holiday ';
						override_title = self.locale['holiday']
					}
					if (date_str === self.config['min_date_dmy']) {
						override_class += ' ui-datepicker-us-addday';
						override_title = self.locale['task_start'];
					}
					return [true, override_class, override_title, override_weekend];
				}
			});
			App.modal.obj_window.find('[data-container=user]').bind('click', function () {
				App.controls.user_select_and_go.show_context(this, null, {
					request: {
						type: 'costs'
					},
					onload: function() {
						let menu = $(this);
						App.controls.menu.init(menu);
						$(this).on('click', '.menu__item', function() {
							App.controls.menu.item_set_active(this);
							App.modal.obj_window.find('[data-container=user] .space-ava').html($(this).find('.space-ava').html()).next().text($(this).find('.in').text());
							App.modal.obj_window.find('[data-container=user]').parent().next().val($(this).attr('data-id'));
							if (this.hasAttribute('data-rate')) App.modal.obj_window.find('input[name="rate"]').val($(this).attr('data-rate')).trigger('keyup');
							App.menu.hide();
						})
					},
					onshow: function() {
						$(this).find('.menu__item').each(function() {
							$(this).toggleClass('menu__item-active', $(this).attr('data-id') == App.modal.obj_window.find('[data-container=user]').next().val());
						});
					}
				});
			});

			const validate_time_money = () => {
				const $hours = $('.inputBlock__costs input[name="set_time"]');
				const $money = $('.inputBlock__costs input[name="set_money"]');

				const hoursVal = $hours.val()?.trim().replace(/\s+/g, '').replace(/[:,-]/g, '.') || '';
				const moneyVal = $money.val()?.trim().replace(/\s+/g, '').replace(/[:,-]/g, '.') || '';

				const hasHours = $hours.length > 0;
				const hasMoney = $money.length > 0;

				const hoursNum = hasHours ? parseFloat(hoursVal) : null;
				const moneyNum = hasMoney ? parseFloat(moneyVal) : null;

				// логіка: якщо є обидва поля, то хоча б одне має бути валідне
				const valid =
					(hasHours && hoursNum) ||
					(hasMoney && moneyNum) ||
					(!hasHours && !hasMoney);

				if (valid) return { valid: true };

				// знайти перше "доступне" поле, яке не валідне
				if (hasHours && !hoursNum) return { valid: false, el: $hours };
				if (hasMoney && !moneyNum) return { valid: false, el: $money };

				return { valid: false, el: null };
			};
			const toggle_delete_btn_if_needed = () => {
				if ($('#tm_delete').length && $('#tm_submit').length) {
					const { valid } = validate_time_money();
					$('#tm_delete').toggleClass('ws-utility-hidden', valid);
					$('#tm_submit').toggleClass('ws-utility-hidden', !valid);
				}
			};

			App.modal.obj_window.find('#tm_submit button').on('click', function () {
				if ($(this).hasClass('frm_sent')) return false;

				const { valid, el } = validate_time_money();
				if (!valid) {
					el?.closest('.inputBlock').animate_css('head-shake').then(() => {
						el.focus();
					});
					return false;
				}

				$(this).addClass('frm_sent');
				App.core.form_submit(this.form, () => {
					App.modal.invalidate_history_dom();
				});
			});

			let cost_block = $('.inputBlock__costs');
			cost_block.find('#tm_time').on('change', function (e) {
				App.controls.rate.time_to_money(e);
				toggle_delete_btn_if_needed();
			});
			cost_block.find('#tm_time, #tm_money, textarea').on('input', function () {

				if ($(this).prop('tagName') === 'INPUT') {
					this.value = this.value.replace(/[^0-9.,:;-]/g, '').replace(/([.,:;].*?)[.,:;]/g, '$1');
					toggle_delete_btn_if_needed();
				}

				// TODO підчистити кінці і видалити? Бо не знайшов де воно працювало б, поки просто кометую
				// if (self.has_costs) {
				// 	let hours = cost_block.find('input[name="set_time"]').val();
				// 	let money = cost_block.find('input[name="set_money"]').val();
				// 	let name = cost_block.find('textarea[name="set_name"]').val();
				// 	let cost_button = cost_block.find('.inputBlock__costs-spendAdd ws-btn.ws-btn-right button');
				// 	if (!hours && !money && !name) {
				// 		//cost_block.removeClass('inputBlock__costs-timeListHide');
				// 		cost_button.val(cost_button.attr('data-txt-big'));
				// 	} else {
				// 		//cost_block.addClass('inputBlock__costs-timeListHide');
				// 		cost_button.val(cost_button.attr('data-txt-small'));
				// 	}
				// }
			});
			setTimeout(function () {
				let title = App.modal.obj_window.find('.modal__header > .in');
				let limits_but = App.modal.obj_window.find('#modal__headerAppend');
				if (limits_but.length) {
					title.find('.av_place').remove();
					title.append(limits_but.contents());
					title.find('a.full_plan_tm').attr('data-modal-backup', 1);
					limits_but.remove();
				}
				App.fatforms.init();
				App.controls.time_input.init();
				self.init_fit_input_text_label();
			}, 100);
		},

		init_fit_input_text_label: function () {
			const isIntersect = function ($a, $b) {
				const a = $a[0].getBoundingClientRect();
				const b = $b[0].getBoundingClientRect();

				return !(
					a.right < b.left ||
					a.left > b.right ||
					a.bottom < b.top ||
					a.top > b.bottom
				);
			};

			App.modal.obj_window.find('.inputBlock__label:has(.text-label) input').each(function () {
				$(this).on('keydown focus blur change input', App.helper.debounce(function (e) {
					// console.trace(e.type, '            ->            ', e.target.value);
					const $input = $(e.target);
					const $textLabel = $input.nextAll('.text-label:not(.text-label--ghost)').first();
					let $ghostInputValue = $textLabel.prev('.ghostInputValue');
					let $ghostTextLabel = $textLabel.next('.text-label--ghost');
					if ($ghostInputValue.length === 0) {
						$ghostInputValue = $('<span class="ghostInputValue"></span>');
						$textLabel.before($ghostInputValue);
					}
					if ($ghostTextLabel.length === 0) {
						$ghostTextLabel = $textLabel.clone().addClass('text-label--ghost');
						$textLabel.after($ghostTextLabel);
					}
					$ghostInputValue.text($input.val());

					$textLabel.toggleClass('text-label--overlap', isIntersect($ghostInputValue, $ghostTextLabel));
				}));
			});
		}
	}
})();
;(function() {
	let self = App.controls.costs_bars = {
		reload_task: function(id, callback) {
			let o = App.task_view_cache.get_all().find('#obj-task-view' + id);
			o.add('#obj-task' + id).find('[data-container=progress]').each(function() {
				$(this).load($(this).attr('data-reload-url') + '?' + App.actions.get('task_reload_progress:do') + '&type=' + $(this).attr('data-type'), callback);
			});
		},
		reload_project: function(id, callback) {
			$('#obj-project-modal-info' + id).add('#obj-project' + id).find('[data-container=progress]').each(function() {
				if ($(this).attr('data-type') !== 'project_card') $(this).load(App.helper.endpoint.ajax(id) + '?' + App.actions.get('project_reload_progress:show')  + '&type=' + $(this).attr('data-type'), callback);
			});
		}
	}
})();
;(function() {
	let self = App.controls.costs_edit_date = {
		locale: {}, // from template
		config: {}, // from template
		init: function() {
			$("#dateend_div").datepicker({
				rangeSelect: false,
				numberOfMonths: 1,
				monthPicker: true,
				firstDay: App.datepicker_firstDay,
				minDate_: self.config['min_date_js'] ? new Date(self.config['min_date_js']) : null,
				maxDate_: self.config['max_date_js'] ? new Date(self.config['max_date_js']) : null,
				maxDate: new Date(),
				defaultDate: new Date(self.config['def_date_js']),
				altField: '#dateend_',
				altFormat: 'DD.d.LL.yy.D.L.w',
				onSelect: function (date) {
					$('#dateend_date').val(date);
					if (date) {
						let date_nice = $('#dateend_').val();
						let adt = date_nice.split('.');
						$('#dateend_nice').html('<font class="w360">' + adt[0] + ' </font><b>' + adt[1] + ' ' + adt[2] + '</b>' + ((new Date()).getFullYear() == adt[3] ? '' : ' ' + adt[3]));
					}
				},
				beforeShowDay: function (date) {
					let override_class = '';
					let override_title = '';
					let override_weekend = '';
					let date_str = App.helper.date.to_input(date);
					if (App.controls.datepicker.config.holidays && (date_str in App.controls.datepicker.config.holidays)) {
						override_weekend = 'holiday';
						override_class = 'ui-datepicker-holiday ';
						override_title = self.locale['holiday'];
					}
					if (date_str === self.config['task_start_dmy']) {
						override_class += ' ui-datepicker-us-addday';
						override_title = self.locale['task_start'];
					}
					return [true, override_class, override_title, override_weekend];
				}
			});
		}
	}
})();

;(function() {
	let self = App.controls.crm_integration = {
		obj_window: null,
		locale: {},
		type: '',
		init: function(type) {
			self.type = type || '';
			self.obj_window = App.modal.obj_window;

			self.obj_window.find('[data-container=priority]').on('click', function() {
				App.controls.priority.open(this, false, function() {
					if ($(this).attr('data-id') == 1) {
						self.obj_window.find('[data-container=priority]').html(App.helper.template.fill('task_create_priority_empty'));
					} else {
						self.obj_window.find('[data-container=priority]').html(App.helper.template.fill('task_create_priority', {
							priority: $(this).attr('data-id'),
							num: $(this).find('span').first().text(),
						}));
					}
					self.obj_window.trigger('change');
				});
			});

			self.obj_window.find('.av_place').on('click', function() {
				let anchor = $(this);
				let id_project = document.modfrm.id_project_to.value.toInt();
				if (id_project) App.controls.user_select_and_go.show_context(this, App.helper.url.add_query(App.helper.endpoint.project(id_project), App.actions.get('user_select_and_go:show')), {
					request: {type: 'assign'},
					onload: function() {
						$(this).on('click', '.menu__item', function() {
							anchor.html($(this).find('.space-ava').html()).next().val($(this).attr('data-id'));
							App.menu.hide();
							return false
						})
					}
				});
				return false
			});

			self.obj_window.find('#drop_project').on('click', function() {
				App.controls.project_select_and_go.show_context(this, null, {
					type: 'width',
					onload: function () {
						$(this).on('click', '.menu__item', function() {
							$('#drop_project .in').text($(this).find('.in').prev().text() + $(this).find('.in').text()).next().val($(this).attr('data-id'));
							$('.crm_automations_details').removeClass('frm_dis').find('.button_primary').toggleDisabled(false);
							$('#drop_assignee').html(self.locale['def_ava']).next().val(self.locale['def_id']);
							App.menu.hide();
							return false
						});
					},
				});
			});

			$('#drop_triggermenu .menu__item, #drop_resultmenu .menu__item').bind('click', function() {
				$(this).parents('.menu').find('.menu__item').removeClass('menu__item-active');
				$(this).addClass('menu__item-active');
			});

			$('#drop_fieldsmenu').on('click', '.menu__item', function() {
				$(this).toggleClass('menu__item-active');
				let keys = [], vals = [];
				$('#drop_fieldsmenu .menu__item-active').each(function() {
					keys.push($(this).attr('rel') ||  $(this).find('.in').justtext().trim());
					vals.push('<span class="field_tag">' + $(this).find('.in').justtext().trim() + '</span>');
				});
				document.modfrm.id_fields.value = keys.join(',');
				$('#drop_fields .in').html(vals.length ? vals.join(' ') : self.locale['no_fields']);
			});

			if (type === 'nethunt') {
				$('#drop_foldermenu').on('click', '.menu__item', function() {
					$('#drop_foldermenu .menu__item').removeClass('menu__item-active');
					$(this).addClass('menu__item-active');
					$('#drop_folder .in').html($(this).text()).next().val($(this).attr('data-key')).next().val($(this).text()); App.menu.hide(true);
					$.getScript('/account/apps/?' + App.actions.get('account_nethunt:load_data') + '&id_folder=' + encodeURIComponent($(this).attr('data-key')));
					return false;
				});
				$('#drop_fieldmenu').on('click', '.menu__item', function() {
					$('#drop_fieldmenu .menu__item').removeClass('menu__item-active');
					$(this).addClass('menu__item-active');
					$('#drop_field .in').html($(this).text()).next().val($(this).text().trim()); App.menu.hide(true);
					$.getScript('/account/apps/?' + App.actions.get('account_nethunt:load_data') + '&id_folder=' + encodeURIComponent($('#drop_folder .in').next().val()) + '&id_field=' + encodeURIComponent($(this).text().trim()));
					return false;
				});
				$('#drop_field_tomenu').on('click', '.menu__item', function() {
					$('#drop_field_tomenu .menu__item').removeClass('menu__item-active');
					$(this).addClass('menu__item-active');
					$('#drop_field_to .in').html($(this).text()).next().val($(this).text().trim()); App.menu.hide(true);
					$.getScript('/account/apps/?' + App.actions.get('account_nethunt:load_data') + '&id_folder=' + encodeURIComponent($('#drop_field_to .in').next().val()) + '&id_field_to=' + encodeURIComponent($(this).text().trim()));
					return false;
				});
			}
		},

		destructor: function () {
			self.obj_window = null;
			self.locale = {};
			self.type = '';
		},

		onLogout: () => self.destructor(),
	}
})();

;(function () {

	let self = App.controls.custom_fields = {

		show_remove_menu: function (menu_anchor, id_project, id_field) {
			let url = App.helper.url.add_query(
				App.helper.endpoint.primary(),
				App.actions.get('custom_field_remove:apply'),
				{ id_field, id_project }
			);

			App.controls.confirm.menu(menu_anchor, {
				message: App.i18n.t('task_controls.confirm_field_remove'),
				backup: true,
				onconfirm: function () {
					App.core.async_task.ajax(url);
					App.modal.hide();
				}
			})
		},

		show_types_menu: function (menu_anchor, params) {
			App.menu.show({
				anchor: menu_anchor,
				backup: params?.backup ?? false,
				type: params?.type,
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('custom_field_add:show'), { types: 1 }),
				onshow: function () {
					let menu = $(this);
					menu.find('.menu__item:not(.menu__item-disabled)[data-type]').off('click').on('click', function () {
						App.menu.hide_all();
						params?.select($(this).attr('data-type'));
					});
				}
			});
		},

		show_add_menu: function (menu_anchor, id_project, id_inst, params) {
			App.menu.show({
				anchor: menu_anchor,
				backup: params?.backup ?? false,
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('custom_field_add:show'), { id_inst, id_project }),
				onshow: function () {
					let menu = $(this);

					menu.find('.menu__item:not(.menu__item-disabled)[data-field-id]').off('click').on('click', function () {
						let item = $(this),
							id_field = +item.attr('data-field-id'),
							url = App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('custom_field_add:apply'), { id_field, id_project });

						App.core.async_task.ajax(url).then(function () {
							if (params?.callback) params.callback(id_field);
						});
						App.menu.hide_all();
					});

					menu.find('.menu__item:not(.menu__item-disabled)[data-action=create]').off('click').on('click', function () {
						self.show_types_menu(this, {
							backup: true,
							type: 'submenu',
							select(id_type) {
								App.controls.custom_fields.show_edit_field_modal({
									form_data: {
										id_type,
										id_inst,
										ids_project: id_project ? String(id_project) : '',
										is_all_projects: id_project ? '0' : '1',
									},
									after_submit: function () {
										if (params?.callback) params.callback(App.core.context.use('new_custom_field_id'));
										App.modal.hide();
									}
								})
							}
						})
					});
				}
			});
		},

		init_usage_tab: function (el, inputs) {
			el.find('.editBlock__bigSwitch').on('click', function () {
				inputs.is_all_projects.val(0);
				inputs.is_all_projects.trigger('change');
			})
			el.find('.editBlock__picker-projects').each(function () {
				let picker = $(this),
					menu = $('#menuFieldUsageProjects'),
					cb = function (ids) {
						inputs.ids_project.val(ids.join(','));
						inputs.ids_project.trigger('change');
					};

				App.controls.editBlock_picker.init(menu, picker, cb, {
					templates: {item: 'editBlock_picker_project', group: 'editBlock_picker_folder'},
					search_selector: '.menu__item[data-id]',
				});

				picker.find('.select-all').on('click', function (e) {
					e.stopPropagation();
					e.preventDefault();
					inputs.is_all_projects.val('1');
					inputs.is_all_projects.trigger('change');
				});
			});
			el.find('ws-btn[name*=clearprojects]').on('click', function () {
				let menu = $('#menuFieldUsageProjects');
				el.find('.editBlock__picker-projects .editBlock__picker__body .editBlock__picker__item').remove();
				inputs.ids_project.val('');
				inputs.ids_project.trigger('change');
				menu.find('.menu__item-picked').removeClass('menu__item-picked');
				menu.find('.editBlock__picker .editBlock__picker__body .editBlock__picker__item').remove();
			});
		},

		show_usage_modal(params) {
			App.modal.show({
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('custom_field_usage:show'), {
					id_field: params.id_field ?? 0,
					is_usage: 1,
				}),
				onload: function () {
					let modal = $(this),
						form = modal.find('form'),
						usage_content = modal.find('.tab_content[data-tab=usage]'),
						inputs = {
							is_all_projects: form.find('[name=is_all_projects]'),
							ids_project: form.find('[name=ids_project]'),
						};

					function render_usage() {
						let is_all_projects = inputs.is_all_projects.val() == 1,
							cnt_usage = inputs.ids_project.val().split(',').filter(i => +i).length;

						usage_content.find('.editBlock__bigSwitch').toggleClass('hiddenBlock', !is_all_projects);
						usage_content.find('.editBlock__picker-projects').toggleClass('hiddenBlock', is_all_projects);
						usage_content.find('ws-btn[name*=clearprojects]').toggleClass('hiddenBlock', is_all_projects || !cnt_usage);
					}

					render_usage();

					self.init_usage_tab(usage_content, inputs);

					inputs.is_all_projects.on('change', render_usage);
					inputs.ids_project.on('change', render_usage);

					modal.find('ws-btn[name*=apply]').on('click', function () {
						App.core.form_submit(form, params.after_submit);
					});
				}
			});
		},

		show_edit_field_modal: function (params) {
			App.modal.show({
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('custom_field_edit:show'), {
					...(params.form_data || {}),
					id_field: params.id_field ?? 0,
				}),
				onload: function () {
					let modal = $(this),
						form = modal.find('form'),
						tabs = modal.find('.modal__header__tabs'),
						configs = modal.find('.inputBlock-configs'),
						usage_content = modal.find('.tab_content[data-tab=usage]'),
						inputs = {
							name: form.find('[name=name]'),
							id_type: form.find('[name=id_type]'),
							is_internal: form.find('[name=is_internal]'),
							is_all_projects: form.find('[name=is_all_projects]'),
							ids_project: form.find('[name=ids_project]'),
						};

					tabs.on('click', 'a', function (e) {
						e.preventDefault();
						tabs.find('.act').removeClass('act');
						$(this).addClass('act');
						tabs.trigger('change');
					})

					function render_tabs() {
						let is_all_projects = +inputs.is_all_projects.val() === 1,
							cnt_usage = inputs.ids_project.val().split(',').filter(i => +i).length,
							active_key = tabs.find('a.act').attr('data-key');

						modal.find('.tab_content[data-tab]').addClass('hiddenBlock');
						modal.find('.tab_content[data-tab='+active_key+']').removeClass('hiddenBlock');

						tabs.find('a[data-key=usage] .cnt').text('(' + (is_all_projects ? App.i18n.t('all') : cnt_usage) + ')');
					}
					function render_usage() {
						let is_all_projects = +inputs.is_all_projects.val() === 1,
							cnt_usage = inputs.ids_project.val().split(',').filter(i => +i).length;

						usage_content.find('.editBlock__bigSwitch').toggleClass('hiddenBlock', !is_all_projects);
						usage_content.find('.editBlock__picker-projects').toggleClass('hiddenBlock', is_all_projects);
						usage_content.find('ws-btn[name*=clearprojects]').toggleClass('hiddenBlock', is_all_projects || !cnt_usage);
					}
					function render_edit() {
						let id_type = +inputs.id_type.val(),
							is_internal = +inputs.is_internal.val(),
							type = App.custom_fields.types[id_type];

						configs.find('.setupBlock[data-type]').addClass('hiddenBlock').filter('[data-type='+id_type+']').removeClass('hiddenBlock');
						configs.toggleClass('hiddenBlock', configs.find('.setupBlock:not(.hiddenBlock)').length === 0);

						let select = form.find('[name=id_type]').closest('.inputBlock');
						select.find('.drop_select > .in').text(type.name);
						select.find('.inputBlock__label > ws-icon').attr('name', type.icon);

						form.find('input[name=is_internal]').parent().find('.sw_pre').toggleClass('sw_act', is_internal === 1);

						if (id_type === 23) // CURRENCY
						{
							let block = configs.find('.setupBlock[data-type=23]');
							let id_currency = +block.find('input[name^=id]').val();
							block.find('.setupBlock__item-currency').toggleClass('hiddenBlock', id_currency !== 0);
						}

						if (id_type === 22) // MEASUREMENT
						{
							let block = configs.find('.setupBlock[data-type=22]');
							let id_unit = +block.find('input[name^=id]').val();
							block.find('.setupBlock__item-unit').toggleClass('hiddenBlock', id_unit !== 0);
						}

						App.controls.editblock.set_updated_state();
					}


					render_tabs();
					render_usage();
					render_edit();

					const submitHandler = function () {
						if (submitBtn.attr('disabled')) return;

						form.find('.input_error').removeClass('input_error');

						submitBtn.attr('disabled', true);
						App.core.form_submit(form, params.after_submit, function (xhr, body) {
							if (xhr.status === 422) {
								submitBtn.attr('disabled', false);
								const errors = JSON.parse(body)?.errors ?? {};
								if (errors.name) inputs.name.addClass('input_error').parent().animate_css('head-shake');
								App.message.validation(errors);
								return true;
							}
						});
					};

					App.controls.editblock.init({
						submit: submitHandler
					});

					self.init_usage_tab(usage_content, inputs);
					usage_content.find('ws-btn[name*=setprojects]').on('click', function () {
						tabs.find('[data-key=edit]').click();
					});

					tabs.on('change', render_tabs);
					form.on('change', render_edit);
					inputs.id_type.on('change', render_edit);
					inputs.is_internal.on('change', render_edit);
					inputs.is_all_projects.on('change', render_usage);
					inputs.is_all_projects.on('change', render_tabs);
					inputs.ids_project.on('change', render_tabs);
					inputs.ids_project.on('change', render_usage);

					form.find('[name=id_type]').closest('a').on('click', function () {
						App.menu.show({
							anchor: this,
							box: '#field_edit_type_menu',
							onshow: function () {
								$(this).once_by_criteria('init_select').on('click', '.menu__item[data-id]', function () {
									inputs.id_type.val($(this).attr('data-id'));
									inputs.id_type.trigger('change');
									App.menu.hide();
								});
							}
						})
					});

					form.find('.optionsListInput').each(function () {
						let is_bool_type = $(this).closest('.setupBlock[data-type]').attr('data-type') === '1';
						self.init_options_list_input(this, {
							allow_delete: !is_bool_type,
							has_colors: !is_bool_type,
						});
					})

					form.find('input[name=is_internal]').parent().find('.sw_pre').on('click', function () {
						inputs.is_internal.val(+inputs.is_internal.val() ? 0 : 1);
						inputs.is_internal.trigger('change');
					});

					const submitBtn = modal.find('ws-btn[name*=apply]');

					submitBtn.on('click', function (e) {
						e.preventDefault();
						submitHandler();
					});
					form.on('submit', function (e) {
						e.preventDefault();
						submitHandler();
					});

					modal.find('ws-btn[name*=delete]').on('click', function () {
						App.controls.confirm.menu(this, {
							message: App.i18n.t('custom_field.confirm_delete'),
							onconfirm: function () {
								let url = App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('custom_field_delete:apply'), { id_field: params.id_field });
								App.core.async_task.ajax(url);
								App.modal.hide();
							}
						})
					});

					App.fatforms.init({obj: App.modal.obj_window});
					App.helper.nextTick(() => {
						inputs.name.focus();
					})
				}
			});
		},

		init_options_list_input: function (el, params) {
			let allow_delete = params?.allow_delete ?? true, has_colors = params?.has_colors ?? true;
			let template_html = $(el).find('template').html();
			$(el).find('template').remove();

			let data_input = $(el).find('input[name*=options]');
			let default_value_input = $(el).find('input[name*=default_value]'),
				has_default_value = default_value_input.length === 1;
			let next_key_input = $(el).find('input[name*=next_key]');
			let items_el = $(el).find('.optionsListInput__items');
			let with_drag = $(el).hasClass('optionsListInput-withDrag') && App.device.is_lg_width();

			function get_items() {
				return data_input.val() ? JSON.parse(data_input.val()) : [];
			}
			function set_items(data) {
				data_input.val(JSON.stringify(data));
				data_input.trigger('change');
			}
			function nextkey() {
				let k = +next_key_input.val() || 0;
				next_key_input.val(k+1)
				return k;
			}
			function create_item_el(config) {
				let item = $(template_html);

				item.attr('data-key', config.key);
				item.find('.in').text(config.value);
				item.find('.space-icon.space-icon-before')
					.attr('class', 'space space-icon')
					.toggleClass('tag' + (config.color || 51), has_colors)
					.toggleClass('hiddenBlock', !has_colors)
					.find('ws-icon')
					.attr('name', (config.icon || 'shape-circle-12'));

				item.find('ws-btn[name*=default]').toggleClass('hiddenBlock', !config.is_default);

				return item;
			}
			function render() {
				let item_class = 'optionsListInput__item', drop_place_class = 'optionsListInput__dropPlace';
				items_el.find('.'+item_class+', .'+drop_place_class).remove();
				let def_value = has_default_value ? default_value_input.val() : '';
				if (with_drag) items_el.append('<div class="'+drop_place_class+'" data-pos="0"></div>');
				get_items().forEach((item, i) => {
					let item_el = create_item_el({
						...item,
						is_default: def_value === String(item.key),
					});
					items_el.append(item_el);
					if (with_drag) {
						item_el.attr('data-pos', i+1)
						items_el.append('<div class="'+drop_place_class+'" data-pos="'+(i+1)+'"></div>');
					}
				})
				if (with_drag) {
					items_el.find('.'+item_class).dragable({
						clone: true,
						opacity: 1,
						tolerance: 'none',
						target: '.'+drop_place_class,
						moveHandler: "ws-icon[name=drag_indicator]",
						autoscroll: true,
						target_self: false,
						renewTarget: true,
						start: function (o) {
							App.state.drag.start();
							$('body').addClass('body-dragInProgress');
							o.originalElem.addClass(item_class+'-dragThis');
						},
						end: function (o) {
							App.state.drag.stop();
							o.elem.removeClass(item_class+'-dragThis');
							o.target.removeClass(drop_place_class+'-hover');
							$('body').removeClass('body-dragInProgress');
						},
						drop: function (o) {
							const cur_key = 'k' + o.elem.attr('data-key'),
								cur_pos = parseInt(o.elem.attr('data-pos')),
								new_pos = parseInt($(o.currentTarget.t).attr('data-pos'));

							if (isNaN(new_pos) || cur_pos === new_pos) return;

							let by_key = get_items().reduce((acc, i) => { acc['k'+i.key] = i; return acc; }, {}),
								keys = Object.keys(by_key);

							set_items([
								...keys.slice(0, new_pos).filter(i => i !== cur_key),
								cur_key,
								...keys.slice(new_pos).filter(i => i !== cur_key)
							].map(k => by_key[k]));
						},
						move: function (o) {
							let min_distance = 9999, el_height = o.originalElem.outerHeight(), oy = o.top + el_height/2;

							o.targetMatrix.forEach((t) => {
								const distance = Math.abs((t.y1 + (t.y2 - t.y1)/2) - oy);
								if (distance > min_distance || distance > el_height) return;
								min_distance = distance;
								o.currentTarget = t;
							})

							o.target.removeClass(drop_place_class+'-hover');
							if (o.currentTarget) $(o.currentTarget.t).addClass(drop_place_class+'-hover');
						}
					});
				}
			}

			const actions = {
				edit(anchor, key, model) {
					self.show_option_edit_menu({
						anchor,
						model,
						onapply: (m) => set_items(get_items().map(i => ({ ...i, ...(i.key === key ? m : {}) }))),
						has_colors
					});
				},
				set_default(anchor, key, model) {
					let is_on = !$(anchor).hasClass('sw_act');
					$(anchor).toggleClass('sw_act', is_on);
					default_value_input.val(is_on ? key : '');
					render();
					App.menu.hide();
				},
				delete(anchor, key) {
					set_items(get_items().filter(i => i.key !== key));
					App.menu.hide();
				}
			}

			$(el).on('click', 'ws-btn[name*=more]', function (e) {
				let key = +$(this).closest('[data-key]').attr('data-key');
				let item = get_items().find((item) => item.key === key);
				App.menu.show({
					anchor: this,
					box: '#field_edit_select_option_menu',
					width: 220,
					onshow: function () {
						let menu = $(this), def_value = default_value_input.val();
						menu.find('.menu__item[data-key=delete]').toggleClass('menu__item-hidden', !allow_delete);
						menu.find('.menu__item[data-key=set_default]').toggleClass('menu__item-hidden', !has_default_value);
						menu.find('.menu__item[data-key=set_default]').toggleClass('sw_act', def_value === String(item.key));
						menu.find('.menu__item[data-key]').off('click').on('click', function () {
							let action = $(this).attr('data-key');
							if (action === 'set_default') {
								actions.set_default(this, key, item);
							} else if (actions[action]) {
								actions[action](e.target, key, item);
							}
						})
					}
				});
			});
			$(el).on('click', 'ws-btn[name*=edit]', function () {
				let key = +$(this).closest('[data-key]').attr('data-key');
				let item = get_items().find((item) => item.key === key);
				actions.edit(this, key, item);
			});
			$(el).on('click', 'ws-btn[name*=add]', function () {
				self.show_option_edit_menu({
					anchor: this,
					model: { value: '', color: 50, icon: null },
					onapply: (model) => set_items([...get_items(), { ...model, key: nextkey() }])
				});
			});
			$(el).on('click', 'ws-btn[name*=remove-all]', function () {
				set_items([])
			});

			data_input.on('change', render);
			render();
		},

		show_option_edit_menu: function (params) {
			const has_colors = params?.has_colors ?? true;

			function render_menu(menu, data) {
				if ('value' in data) menu.find('.editBlock__input input[name=name]').val(data.value);
				if ('icon' in data) menu.find('.editBlock__input .space ws-icon').attr('name', data.icon || 'shape-circle-12');
				if ('color' in data) {
					menu.find('.editBlock__input .space ws-icon').attr('class', 'tag tag'+data.color);
					menu.find('.tagColors__item').removeClass('tagColors__item-active')
						.filter('[data-color='+data.color+']').addClass('tagColors__item-active');
				}
			}

			App.menu.show({
				anchor: params.anchor,
				box: '#field_edit_option_edit_menu',
				width: 380,
				onshow: function () {
					let menu = $(this), model = { ...params.model };
					let btn_primary = menu.find('ws-btn[name*=primary]');
					let name_input = menu.find('input[name=name]');
					let name_max_length = +name_input.attr('data-maxlength');

					let check_valid = () => {
						let name_is_overflow = model.value.trim().length > name_max_length,
							name_is_empty = model.value.trim().length === 0;

						btn_primary.toggleClass('hiddenBlock', !model.color || name_is_empty || name_is_overflow);

						name_input.parent().parent()
							.find('.editBlock__input__counter')
							.toggleClass('editBlock__input__counter-error', name_is_overflow)
							.text(name_max_length - model.value.trim().length);

						return model.color && !name_is_empty && !name_is_overflow;
					}

					menu.find('.editBlock__input .space').toggleClass('hiddenBlock', !has_colors);
					menu.find('.menu__group-colors').toggleClass('hiddenBlock', !has_colors);
					render_menu(menu, model);
					check_valid();

					menu.find('.tagColors__item[data-color]').off('click').on('click', function () {
						model.color = +$(this).attr('data-color');
						render_menu(menu, { color: model.color });
						check_valid()
					});

					menu.find('input[name=name]').off('keyup').on('keyup', function (e) {
						model.value = e.target.value;
						render_menu(menu, { value: model.value });
						check_valid()
					});

					menu.find('ws-btn[name*=primary]').off('click').on('click', function () {
						params.onapply(model);
						App.menu.hide();
					});
					menu.find('ws-btn[name*=close]').off('click').on('click', function () {
						App.menu.hide();
					});
				}
			});
		},


	};

})();

;const SAVE_WIDGETS_STATE_OPERATION = 'save_widgets_state';
const FILL_SLOTS_OPERATION = 'fill_slots';
const DUPLICATE_WIDGET_OPERATION = 'duplicate_widget';
const REMOVE_WIDGET_OPERATION = 'remove_widget';
const RELOAD_MENU_OPERATION = 'reload_menu';

(function() {
	let self = App.controls.dashboard = {
		type: '',
		block_selected_by_extra: false,
		widgets_menu_act_obj: null,
		widgets_menu_reset: false,
		widgets_menu_hided: false,
		matrix: {},
		drag: {
			obj: null,
			objReal: null,
			defaultHeight: 0,
			touchStartY: 0,
			touchEndH: 0
		},
		init: function (obj) {
			(obj || App.page.blockObjs).each(function() {
				try {
					this.init();
				} catch (e) {
					console.error(e);
					console.error('failed to init dashboard block');
					console.error(this)
				}
			});
			self.init_matrix();

		},
		extra_dblclick_action: function(id) {
			let menu = $('#' + id);
			if (menu.find('a[href]').length) {
				menu.find('a[href]').first().trigger('click');
			} else if (menu.find('a [name=open_in_new]').length) {
				menu.find('a [name=open_in_new]').first().parent().trigger('click');
			} else if (menu.find('a.thickbox').length) {
				menu.find('a.thickbox').first().trigger('click');
			}
		},
		init_extra_menu: function(block, id) {
			let menu = $('#' + id);
			let row = block.closest('.dashboard__row');
			let type = block.attr('data-grid-type');
			let rowValue = block.attr('data-grid-row');
			let columnValue = block.attr('data-grid-column');

			menu.find('.menu__item').removeClass('menu__item-disabled');
			if (parseInt(columnValue) === 1) {
				menu.find('a[data-route=left]').addClass('menu__item-disabled');
			}
			if (parseInt(columnValue) === 2 || row.find('.dashboard__block[data-grid-row][data-grid-column]').length === 1) {
				menu.find('a[data-route=right]').addClass('menu__item-disabled');
			}
			if (parseInt(rowValue) === 1) {
				menu.find('a[data-route=up]').addClass('menu__item-disabled');
			}
			if (parseInt(rowValue) === $('.dashboard .dashboard__row').length) {
				menu.find('a[data-route=down]').addClass('menu__item-disabled');
			}
			menu.find('.menu__item').unbind('hover onselect').bind('hover onselect', function(e) {
				if ($(this).hasClass('menu__item-disabled')) return false;
				let route = $(this).attr('data-route');
				let tmpElem;
				$('.dashboard__block').removeClass('dashboard__block-selected');
				self.block_selected_by_extra = false;
				if (App.menu.is_shown() && (e.type === 'mouseenter' || e.type === 'onselect')) {
					if (route === 'left') {
						block.prevAll('.dashboard__block').removeClass('route-updown').addClass('dashboard__block-selected route-leftright');
						self.block_selected_by_extra = true;
					} else if (route === 'right') {
						block.nextAll('.dashboard__block').removeClass('route-updown').addClass('dashboard__block-selected route-leftright');
						self.block_selected_by_extra = true;
					} else if (route === 'up') {
						tmpElem = row.prev().find('.dashboard__block[data-grid-type='+type+'][data-grid-column='+columnValue+']');
						if (tmpElem.length) {
							tmpElem.removeClass('route-leftright').addClass('dashboard__block-selected route-updown');
							self.block_selected_by_extra = true;
						} else {
							row.prev().find('.dashboard__block[data-grid-row][data-grid-column]').removeClass('route-leftright').addClass('dashboard__block-selected route-updown');
							self.block_selected_by_extra = true;
						}
					} else if (route === 'down') {
						tmpElem = row.next().find('.dashboard__block[data-grid-type='+type+'][data-grid-column='+columnValue+']');
						if (tmpElem.length) {
							tmpElem.removeClass('route-leftright').addClass('dashboard__block-selected route-updown');
							self.block_selected_by_extra = true;
						} else {
							row.next().find('.dashboard__block[data-grid-row][data-grid-column]').removeClass('route-leftright').addClass('dashboard__block-selected route-updown');
							self.block_selected_by_extra = true;
						}
					}
				}
			});
			menu.find('.menu__item-delete').unbind('click').bind('click', function() {
				let blockName = block.attr('data-grid-name');
				if (blockName) {
					App.menu.hide();
					self.run_operation({
						operation: REMOVE_WIDGET_OPERATION,
						data: {
							block: blockName
						}
					})
				}
			});
			menu.find('.menu__item[data-route]').unbind('click').bind('click', function() {
				if ($(this).hasClass('menu__item-disabled')) return false;
				let route = $(this).attr('data-route');
				let gridName = block.attr('data-grid-name');
				let gridRow, gridColumn, tmpElem, tmpElemHeight, blockHeight;
				if (route === 'left') {
					gridColumn = block.prev().attr('data-grid-column');
					block.attr('data-grid-column', block.prev().attr('data-grid-column'));
					block.prev().attr('data-grid-column', columnValue);
					block.insertBefore(block.prev());
				} else if (route === 'right') {
					gridColumn = block.next().attr('data-grid-column');
					block.attr('data-grid-column', block.next().attr('data-grid-column'));
					block.next().attr('data-grid-column', columnValue);
					block.insertAfter(block.next());
				} else if (route === 'up') {
					tmpElem = row.prev().find('.dashboard__block[data-grid-type='+type+'][data-grid-column='+columnValue+']');
					if (tmpElem.length) {
						if (tmpElem.attr('data-grid-height-min') && block.attr('data-grid-height-min')) {
							blockHeight = block.height();
							tmpElemHeight = tmpElem.height();
						}
						gridRow = tmpElem.attr('data-grid-row');
						block.attr('data-grid-row', tmpElem.attr('data-grid-row'));
						tmpElem.attr('data-grid-row', rowValue);
						block.before($('<div id="grid-buffer" />'));
						if (blockHeight && tmpElemHeight) {
							tmpElem.before(block.css({height: tmpElemHeight + 'px'}));
							row.find('#grid-buffer').replaceWith(tmpElem.css({height: blockHeight + 'px'}));
						} else {
							tmpElem.before(block);
							row.find('#grid-buffer').replaceWith(tmpElem);
						}
					} else {
						gridRow = row.prev().find('.dashboard__block').attr('data-grid-row');
						row.find('.dashboard__block').attr('data-grid-row', row.prev().find('.dashboard__block').attr('data-grid-row'));
						row.prev().find('.dashboard__block').attr('data-grid-row', rowValue);
						row.insertBefore(row.prev());
					}
				} else if (route === 'down') {
					tmpElem = row.next().find('.dashboard__block[data-grid-type='+type+'][data-grid-column='+columnValue+']');
					if (tmpElem.length) {
						if (tmpElem.attr('data-grid-height-min') && block.attr('data-grid-height-min')) {
							blockHeight = block.height();
							tmpElemHeight = tmpElem.height();
						}
						gridRow = tmpElem.attr('data-grid-row');
						block.attr('data-grid-row', tmpElem.attr('data-grid-row'));
						tmpElem.attr('data-grid-row', rowValue);
						block.before($('<div id="grid-buffer" />'));
						if (blockHeight && tmpElemHeight) {
							tmpElem.before(block.css({height: tmpElemHeight + 'px'}));
							row.find('#grid-buffer').replaceWith(tmpElem.css({height: blockHeight + 'px'}));
						} else {
							tmpElem.before(block);
							row.find('#grid-buffer').replaceWith(tmpElem);
						}
					} else {
						gridRow = row.next().find('.dashboard__block').attr('data-grid-row');
						row.find('.dashboard__block').attr('data-grid-row', row.next().find('.dashboard__block').attr('data-grid-row'));
						row.next().find('.dashboard__block').attr('data-grid-row', rowValue);
						row.insertAfter(row.next());
					}
				}  else if (route === 'top') {
					row.insertBefore(row.parent().find('.dashboard__row:first'));
					gridRow = 1
					row.find('.dashboard__block').attr('data-grid-row', rowValue);
					row.scrollIntoView({block: 'start', inline: 'nearest', behavior: 'smooth'});
				} else if (route === 'bottom') {
					row.insertAfter(row.parent().find('.dashboard__row:last'));
					gridRow = $('.dashboard .dashboard__row').length;
					row.find('.dashboard__block').attr('data-grid-row', rowValue);
					row.scrollIntoView({block: 'start', inline: 'nearest', behavior: 'smooth'});
				}
				if (gridRow || gridColumn) {
					$.ajax({
						type: 'POST',
						url: App.helper.endpoint.ajax() + '?'
							+ App.actions.get(self.type + ':save_grid_config')
							+ '&grid_name=' + gridName
							+ (gridRow ? '&grid_row=' + gridRow : '')
							+ (gridColumn ? '&grid_column=' + gridColumn : '')
							+ (tmpElemHeight ? '&grid_height=' + tmpElemHeight : '')
					});
					if (tmpElemHeight && blockHeight) {
						$.ajax({
							type: 'POST',
							url: App.helper.endpoint.ajax() + '?'
								+ App.actions.get(self.type + ':save_grid_config')
								+ '&grid_name=' + tmpElem.attr('data-grid-name')
								+ '&grid_height=' + blockHeight
						});
					}
				}
				App.menu.hide_all();
			});
		},
		init_widgets_menu: function() {
			const menuCallback  = function(okCallback, okBtnSelector) {
				return function() {
					let menuID = $(this).attr('data-menu-id');
					let menuObj = $('#' + menuID);
					let resetBtn = menuObj.find('#dashboardmenu-btn-reset');
					if (menuObj.find('span.sw_act').length === menuObj.find('span.sw_pre').length) {
						resetBtn.parent().addClass('menu__group-hidden');
					} else {
						resetBtn.parent().removeClass('menu__group-hidden');
					}
					self.widgets_menu_act_obj = menuObj.find('span.sw_act');
					self.widgets_menu_hided = false;
					self.show_widgets_ok_btn(menuID, okBtnSelector);
					const anchor = $(this).find('[role="anchor"]');
					App.menu.show({
						anchor: anchor.length ? anchor[0] : this,
						box: '#' + menuID,
						onshow: function() {
							const okBtn = $(this).find(okBtnSelector);
							okBtn.off('click').on('click', okCallback(menuObj));
						},
						onhide: function() {
							self.widgets_menu_hided = true;
							$(this).find('span.sw_pre.sw_act').each(function() {
								$(this).parent().click();
							});
							self.widgets_menu_act_obj.each(function() {
								$(this).parent().click();
							});
						}
					});
				}
			}

			$('#dashboard-widgets, #dashboard-widgets-mobile').on('click', menuCallback((menuObj) => {
				return () =>{
					App.controls.dashboard.save_widgets_click(menuObj);
					App.menu.hide()
				}
			}, '#dashboardmenu-btn-ok'));
			$('.dashboard').on('click', '.dashboard__block-empty', menuCallback((menuObj) => {
				return () =>{
					App.controls.dashboard.fill_slots_by_menu(menuObj);
					App.menu.hide()
				}
			}, '#dashboardmenuempty-btn-ok'));
		},
		show_widgets_ok_btn: function(menuID, okBtnSelector) {
			if (self.widgets_menu_hided) return false;
			let menuObj = $('#' + menuID);
			let okBtn = menuObj.find(okBtnSelector);
			let showOkBtn = false;
			if (self.widgets_menu_act_obj.length !== menuObj.find('span.sw_act').length) showOkBtn = true;
			if (!showOkBtn) {
				self.widgets_menu_act_obj.each(function() {
					if (!$(this).hasClass('sw_act')) showOkBtn = true;
				});
			}
			if (showOkBtn) {
				okBtn.attr('name', okBtn.attr('name').replace(' btn-hide', ''));
			} else {
				if (okBtn.attr('name').indexOf('btn-hide') === -1) okBtn.attr('name', okBtn.attr('name') + ' btn-hide');
			}
		},
		dashboard_reload: function(reset) {
			if (reset) self.widgets_menu_reset = true;
			let timeout = 0;
			if (App.modal.is_shown()) {
				App.modal.hide();
				timeout = 200;
			}
			setTimeout(function() {
				App.controls.loader.start();
				$.ajax({
					type: 'POST',
					url: App.helper.endpoint.ajax() + '?' + App.actions.get(self.type + ':show') + (typeof(reset) !== 'undefined' && reset ? '&reset=1' : ''),
					success: function(html) {
						$('#dashboardmenu').remove();
						$('.dashboard').replaceWith(html);
						App.page.blockObjs = $('.dashboard .dashboard__block[data-container]');
						self.init(App.page.blockObjs);
						App.controls.loader.stop();
						$(document).trigger('page_onload.final').unbind('page_onload.final');
					},
					error: function() {
						App.core.reload();
					}
				});
			}, timeout);
			self.widgets_menu_reset = false;
		},
		dashboard_reload_confirm: function(elem) {
			App.controls.confirm.menu(elem, {
				message: $(elem).attr('data-confirm-text'),
				on_confirm: function() {
					App.menu.hide();
					self.dashboard_reload(true);
				}
			});
		},
		duplicate_block: function (elem, widget_name, settings = {}) {

			let menu = $(elem).closest('.menu');
			let block = $('#' + menu.attr('data-block-id'));
			switch (true) {
				case widget_name === 'priorities' && !settings.sel_user:
					App.controls.user_select_and_go.show_context(elem, App.helper.url.add_query('/ajax/user/', App.actions.get('user_select_and_go:show')), {
						backup: true,
						type: 'submenu',
						onload: function () {
							App.controls.menu.init($(this));
						},
						onshow: function () {
							$(this).off().on('click', '.menu__item', function () {
								App.menu.hide()
								self.duplicate_block(elem, widget_name, {
									sel_user: $(this).attr('data-id'),
								});
							})
						},
					});
					return false;
				case widget_name === 'project_tasks' && !settings.sel_project:
					App.controls.project_select_and_go.show_context(elem, null, {
						backup: true,
						type: 'submenu',
						onload: function () {
							App.controls.menu.init($(this));
						},
						onshow: function () {
							$(this).off().on('click', '.menu__item', function () {
								App.menu.hide()
								self.duplicate_block(elem, widget_name, {
									sel_project: $(this).attr('data-id'),
								});
							})
						},
					});
					return false;
			}
			App.menu.hide()
			self.run_operation({
				operation: DUPLICATE_WIDGET_OPERATION,
				data: {
					settings,
					duplicate_from: block.attr('data-grid-name')
				}
			})
		},
		run_operation: function ({operation, data}) {
			$.ajax({
				type: 'POST',
				url: App.helper.endpoint.ajax() + '?'
					+ App.actions.get(`${self.type}:${operation}`),
				data,
				success: function(response) {
					const {operation, operation_data, html, current_menu, current_empty_menu} = response;
					if (self.operations[operation] && self.operations[operation].length) {
						self.operations[operation]({operation_data, html});
						self.rearrange_grid();
						self.init_matrix();
						$('#dashboardmenu').replaceWith($(current_menu))
						$('#dashboardmenuempty').replaceWith($(current_empty_menu))


					} else {
						App.controls.dashboard.dashboard_reload();
					}
				}
			});
		},
		renderEmpty: function ({type, row, column}) {
			return $(App.helper.template.fill('dashboard_empty_block', {
				type: type,
				row: row,
				column: column
			}));
		},
		init_matrix: function() {
			const matrix = {};
			$('.dashboard').find('.dashboard__block').each(function() {
				const block = $(this);
				if (!matrix[block.attr('data-grid-row')]) {
					matrix[block.attr('data-grid-row')] = {}

					const blockSize = Number.parseInt(block.attr('data-grid-type').replace('block', ''));
					const maxColumns = Math.round(100 / blockSize);
					for (let i = 1; i <= maxColumns; i++) {
						matrix[block.attr('data-grid-row')][i] = self.renderEmpty({type: 'block' + blockSize, row: block.attr('data-grid-row'), column: i});
					}
				}
				matrix[block.attr('data-grid-row')][block.attr('data-grid-column')] = block;

			})
			self.matrix = matrix;
		},
		rearrange_grid: function() {
			$('.dashboard .dashboard__row[data-row]').each(function (index) {
				const rowBlock = $(this);
				const rowIndex = index + 1;
				rowBlock.attr('data-row', rowIndex);
				rowBlock.find('.dashboard__block').each(function (blockIndex) {
					$(this).attr({
						'data-grid-row': rowIndex,
						'data-grid-column': blockIndex + 1
					});
				});
			});

		},
		mark_cell_as_new: function (cell) {
			cell.toggleClass('dashboard__block--new', true);
		},
		operations: {
			none: function ({operation_data, html}) {},
			insert_row: function ({operation_data, html}) {
				const { row, type } = operation_data;
				const currentRow = $(`.dashboard .dashboard__row[data-row="${row}"]`);
				const lastRow = $('.dashboard .dashboard__row[data-row]:last');
				const newRow = currentRow.length ? currentRow.clone().empty() : lastRow.clone().empty();

				newRow.append($(html));
				newRow.append(self.renderEmpty({ type, row, column: 2 }));

				if (currentRow.length) {
					$('.dashboard .dashboard__row[data-row]').each(function () {
						const rowBlock = $(this);
						if (rowBlock.attr('data-row') >= row) {
							rowBlock.attr('data-row', +rowBlock.attr('data-row') + 1);
						}
						rowBlock.find('.dashboard__block').each(function (index) {
							$(this).attr({
								'data-grid-row': rowBlock.attr('data-row'),
								'data-grid-column': index + 1
							});
						});
					});
					newRow.find('.dashboard__block').each(function (index) {
						$(this).attr({
							'data-grid-row': row,
							'data-grid-column': index + 1
						});
					});
					newRow.insertBefore(currentRow);
				} else if (lastRow.length) {
					const newRowIndex = +lastRow.attr('data-row') + 1;
					newRow.attr('data-row', newRowIndex);
					newRow.find('.dashboard__block').each(function (index) {
						$(this).attr({
							'data-grid-row': newRowIndex,
							'data-grid-column': index + 1
						});
					});
					newRow.insertAfter(lastRow);
				}

				newRow[0].scrollIntoView({block: 'start', inline: 'nearest', behavior: 'smooth'});
				self.init(newRow.find('.dashboard__block[data-container]:not(.dashboard__block-collapsable)'));
				self.mark_cell_as_new(newRow.find('.dashboard__block[data-container]:not(.dashboard__block-collapsable)'));
			},
			fill_slot: function ({operation_data, html}) {
				let {row, column, type} = operation_data;
				const maxRow = Math.max(...Object.keys(self.matrix));
				if (row > maxRow) {
					row = maxRow;
				}
				const cell = $(html);
				self.matrix[row][column].replaceWith(cell);
				self.init(cell);
				self.mark_cell_as_new(cell);

				cell[0].scrollIntoView({block: 'start', inline: 'nearest', behavior: 'smooth'});
			},
			remove_cell: function ({operation_data, html}) {
				let {row, column} = operation_data;
				const cell = self.matrix[row][column];
				if (cell) {
					cell.replaceWith(self.renderEmpty({type: cell.attr('data-grid-type'), row, column}));
					self.init_matrix();
				}
			},
			remove_rows: function ({operation_data, html}) {
				const {rows} = operation_data;
				rows.forEach(function(row) {
					const rowBlock = $('.dashboard .dashboard__row[data-row="' + row + '"]');
					if (rowBlock.length) {
						rowBlock.remove();
					}
				});
			},
			update_state: function ({operation_data}) {
				const {removedCells, removedRows, showedRows, showedCells} = operation_data;
				let scrollTo;
				Object.entries(removedCells).forEach(function([row, columns]) {
					columns.forEach(function(column) {
						const cell = self.matrix[row][column];
						if (cell) {
							cell.replaceWith(self.renderEmpty({type: cell.attr('data-grid-type'), row, column}));
						}
					});
				});
				removedRows.forEach(function(row) {
					const rowBlock = $('.dashboard .dashboard__row[data-row="' + row + '"]');
					if (rowBlock.length) {
						rowBlock.remove();
					}
				});
				Object.entries(showedRows).forEach(function([row, columns]) {
					const prevRow = $('.dashboard .dashboard__row[data-row="' + (row - 1) + '"]');
					const lastRow = $('.dashboard .dashboard__row[data-row]:last');
					const currentRow = $('<div class="dashboard__row flex_row"></div>')

					currentRow.attr('data-row', row);

					Object.entries(columns).forEach(function([column, {html}]) {
						const cell = $(html)
						currentRow.append(cell);

					});
					if (prevRow.length) {
						currentRow.insertAfter(prevRow);
					} else if (lastRow.length) {
						currentRow.insertAfter(lastRow);
					} else {
						$('.dashboard').append(currentRow);
					}

					self.init(currentRow.find('.dashboard__block[data-container]:not(.dashboard__block-collapsable)'));
					self.mark_cell_as_new(currentRow.find('.dashboard__block[data-container]:not(.dashboard__block-collapsable)'));

					!scrollTo && (scrollTo = currentRow[0]);
				})
				showedCells.forEach(function ({row, column, html}) {
					const cell = $(html);
					self.matrix[row][column].replaceWith(cell);
					self.init(cell);
					self.mark_cell_as_new(cell);
					!scrollTo && (scrollTo = cell[0]);
				});
				if (scrollTo) {
					scrollTo.scrollIntoView({block: 'start', inline: 'nearest', behavior: 'smooth'});
				}
			}
		},
		save_widgets_click: function(menu) {
			if (!self.widgets_menu_reset) {
				let ajax;
				let blocks = [];

				menu.find('span.sw_act').each(function() {
					let name = $(this).parent().attr('data-grid-name');
					if (name) blocks.push($(this).parent().attr('data-grid-name'));
				});
				let currentBlocks = $('.dashboard .dashboard__block[data-action][data-grid-row][data-grid-column]');
				if (currentBlocks.length === blocks.length) {
					currentBlocks.each(function() {
						if (jQuery.inArray($(this).attr('data-grid-name'), blocks) === -1) ajax = true;
					});
				} else {
					ajax = true;
				}

				if (ajax) {
					self.run_operation({
						operation: SAVE_WIDGETS_STATE_OPERATION,
						data: {
							blocks
						}
					})
				}
			}
		},
		fill_slots_by_menu: function (menu) {
				const blocks = [];
				menu.find('span.sw_act').each(function() {
					let name = $(this).parent().attr('data-grid-name');
					name && blocks.push(name);
				});
				if (blocks.length) {
					self.run_operation({
						operation: FILL_SLOTS_OPERATION,
						data: {
							blocks
						}
					});
				}
		},
		ontouchstart_height: function (e) {
			if ($(window).width() <= APP_SCREEN_THRESHOLD) return true;
			self.drag.obj = $(this).closest('.dashboard__row').find('.dashboard__block');
			self.drag.objReal = self.drag.obj.filter('.dashboard__block[data-grid-name]').first();
			self.drag.defaultHeight = self.drag.objReal.height();
			if (e.type !== 'touchstart' && e.which !== 1) return true;
			let touch = e;
			if (e.type === 'touchstart') touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e;
			self.drag.touchStartY = touch.pageY;
		},
		ontouchmove_height: function (e) {
			// спочатку перевіряємо touchStartY, щоб не викликати зайвий reflow
			if (self.drag.touchStartY && $(window).height() > 550) {
				let touch = e;
				let maxHeight = (self.drag.objReal.attr('data-grid-height-max') ?? 750) - self.drag.defaultHeight;
				let minHeight = (self.drag.objReal.attr('data-grid-height-min') ?? 250) - self.drag.defaultHeight;
				if (e.type === 'touchmove') touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e;
				let this_h = self.drag.touchEndH + touch.pageY - self.drag.touchStartY;
				if (this_h > maxHeight) this_h = maxHeight;
				if (this_h < minHeight) this_h = minHeight;
				let height = this_h < 0 ? self.drag.defaultHeight - Math.abs(this_h) : self.drag.defaultHeight + Math.abs(this_h)
				self.drag.obj.css({height: height + 'px'});
			}
		},
		 ontouchend_height: function (e) {
			if ($(window).height() > 550 && self.drag.touchStartY) {
				let touch = e;
				let maxHeight = (self.drag.objReal.attr('data-grid-height-max') ?? 750) - self.drag.defaultHeight;
				let minHeight = (self.drag.objReal.attr('data-grid-height-min') ?? 250) - self.drag.defaultHeight;
				if (e.type === 'touchend') touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e;
				let this_h = self.drag.touchEndH + touch.pageY - self.drag.touchStartY;
				if (this_h > maxHeight) this_h = maxHeight;
				if (this_h < minHeight) this_h = minHeight;
				self.drag.touchStartY = 0;
				if (self.drag.defaultHeight !== self.drag.objReal.height()) {
					let tmpArray = [];
					self.drag.obj.each(function() {
						tmpArray.push(this);
					});
					self.drag.obj = null;

					(async function() {
						for (let key in tmpArray) {
							let me = tmpArray[key];
							await new Promise((resolve, reject) => {
								let body = $(me).find('.dashboard__block__body');
								$.ajax({
									type: 'POST',
									url: App.helper.endpoint.ajax() + '?'
										+ App.actions.get(self.type + ':save_grid_config')
										+ '&grid_name=' + $(me).attr('data-grid-name')
										+ '&grid_height=' + $(me).height(),
									success: function (data) {
										if (body.length) {
											me.callController('doFilter', me, true, true)
										}
										resolve(data);
									},
									error: App.core.create_jq_ajax_error(function (xhr, status, error) {
										reject(error);
									})
								});
							});
						}
					})();
				}
			}
		},
		// можна було б винести це в controls.dashboard_header, або взагалі кожен в свій контрол
		iceland: {
			init: function () {

				const do_debounced_save = App.helper.debounce(data => {
					if (App.offline_mode.is_on()) return;
					$('.dashboard__iceland .iceland__item[data-section]').addClass('iceland__item--loading');
					App.core.async_task.ajax({
						id: 'dashboard_iceland_save_config',
						type: 'POST',
						url: App.helper.endpoint.ajax() + '?'
							+ App.actions.get(self.type + ':save_user_config'),
						data
					});
				}, 400);

				$('#stats-config-form').on('change', () => {
					const value = $('#stats-interval-input').val();
					const name = $('#stats-interval-input').attr('name');
					do_debounced_save({ name, value });
				});
			},
			updated: function (is_ok, new_value) {
				self.iceland.fetch_stats();
			},
			fetch_stats_ajax: null,
			fetch_stats: function () {
				if (self.iceland.fetch_stats_ajax) {
					self.iceland.fetch_stats_ajax.abort();
				}

				$('.dashboard__iceland .iceland__item[data-section]').addClass('iceland__item--loading');

				self.iceland.fetch_stats_ajax = $.ajax({
					type: 'GET',
					url: App.helper.endpoint.ajax() + '?'
						+ App.actions.get(self.type + ':get_user_stats'),
					data: {
						debug: true
					},
					success: function (res) {
						Object.keys(res).forEach(section => {
							const data = res[section];
							const item = $('.dashboard__iceland .iceland__item[data-section="' + section + '"]');

							item.attr('onclick', data.onclick);
							item.find('.iceland__num').integerRoller({ end: parseInt(data.value), duration: 200 });
							item.find('.iceland__label > span:not(.short)').text(data.label);
							item.find('.iceland__label > span.short').text(data.label_short);
						});
					},
					complete: function () {
						self.iceland.fetch_stats_ajax = null;
						$('.dashboard__iceland .iceland__item[data-section]').removeClass('iceland__item--loading');
					}
				});
			},
			switcher_toggle: function (el, event, params) {

				el = $(el);
				params ||= {};

				const container = el.closest('.iceland');
				const next_index = params.next_index;

				const prev_index = container.find('.iceland__switcherItem--active').first().index() + 1;

				let next_item = null;
				if (event && $(event.target).closest('.iceland__switcherItem').length) {
					next_item = $(event.target).closest('.iceland__switcherItem');
					if (next_item.hasClass('iceland__switcherItem--active')) {
						next_item = null;
					}
				}
				else if (next_index) {
					next_item = container.find('.iceland__switcherItem').eq(next_index - 1);
				}
				if (!next_item || !next_item.length) {
					next_item = container.find('.iceland__switcherItem--active').first().next();
					if (!next_item.length) {
						next_item = container.find('.iceland__switcherItem').first();
					}
				}
				if (!next_item || !next_item.length) {
					return;
				}

				const value = $(next_item).attr('data-value');
				const label = $(next_item).attr('data-label');

				container.find('.iceland__switcherItem--active').removeClass('iceland__switcherItem--active');
				container.find('.iceland__switcherCaption--active').removeClass('iceland__switcherCaption--active');
				$(next_item).addClass('iceland__switcherItem--active');
				container.find('.iceland__switcherCaption[data-value="' + value + '"]').addClass('iceland__switcherCaption--active');
				const current_index = container.find('.iceland__switcherCaption--active').index() + 1;
				container.find('.iceland__switcher').removeClass('iceland__switcher--backward iceland__switcher--forward');
				if (current_index < prev_index) {
					container.find('.iceland__switcher').addClass('iceland__switcher--backward');
				} else if (current_index > prev_index) {
					container.find('.iceland__switcher').addClass('iceland__switcher--forward');
				}
				container.find('.iceland__switcher').css('--switcher-active-i', current_index);

				$('#stats-interval-input').val(value);
				$('#stats-interval .in').text(label);
				$('#stats-config-form').trigger('change');
			}
		},
		motto: {
			update_overflow: function (el) {
				el ||= $('.dashboard__motto .editing').length ? $('.dashboard__motto ws-editable input') : $('.dashboard__motto ws-editable');

				if (!el.length) {
					return;
				}

				if (!App.device.is_mobile()) {
					el.css('font-size', '');
				} else {
					let fontSize = 32;
					$('.dashboard__motto').css('--motto-font-size', '');
					$('.dashboard__motto').removeClass('motto--hasOverflow');
					// Lush хотів мінімум 22, але є 360px екрани, там воно не влізе
					while (el.hasScrollBar(true) && fontSize > 16) {
						fontSize -= 2;
						$('.dashboard__motto').css('--motto-font-size', fontSize+'px');
						$('.dashboard__motto').addClass('motto--hasOverflow');
					}
				}
			},
		},
		daily_overview: {
			onLoadPage: function () {

				const obj_window = $('.dashboard__date');
				if (!obj_window.length) return;

				const obj_date = obj_window.find('.daily-overview__date');
				if (!obj_date.length) return;

				const update_date = function () {
					const date_str = App.format.date(new Date(), DATE_DASHBOARD_HEADER);
					if (obj_date.text() !== date_str) {
						obj_date.text(date_str);
					}
				};

				App.helper.cron.add('dayily_overview__date', () => {
					update_date();
				});
			},

			onUnloadPage: function () {
				App.helper.cron.remove('dayily_overview__date');
			},
		},
		canvas: {
			whitePoint: function(ctx, x, y, borderColor, type) {
				if (type === 'small' || type === 'big') {
					let innerRadius = type === 'big' ? 5 : 2.5;
					let outerRadius = type === 'big' ? 7 : 4;
					ctx.beginPath();
					ctx.fillStyle = borderColor;
					ctx.arc(x, y, outerRadius, 0, 2 * Math.PI);
					ctx.fill();
					ctx.fillStyle = App.colors.css_var('--CHART_CIRCLE_WHITE');
					ctx.beginPath();
					ctx.arc(x, y, innerRadius, 0, 2 * Math.PI);
					ctx.fill();
				}
			},
			line: function(ctx, xFrom, yFrom, xTo, yTo, lineColor, lineWidth, dashed) {
				ctx.beginPath();
				ctx.strokeStyle = lineColor;
				ctx.lineWidth = lineWidth;
				if (dashed === 'small') ctx.setLineDash([2, 5]);
				else if (dashed === 'middle') ctx.setLineDash([7, 4]);
				else if (dashed === 'big') ctx.setLineDash([6, 5]);
				ctx.moveTo(xFrom, yFrom);
				ctx.lineTo(xTo, yTo);
				ctx.stroke();
			},
			getMousePos: function(canvas, evt) {
				let rect = canvas.getBoundingClientRect();
				return {
					x: evt.clientX - rect.left,
					y: evt.clientY - rect.top
				};
			},
			getStepSize: function(maxValue) {
				let a = (maxValue < 300 ? 15 : 150);
				let b = (maxValue < 300 ? 5 : 50);
				let stepSize = Math.ceil(maxValue / a) * b;
				if (maxValue < 3) stepSize = 1;
				else if (maxValue < 6) stepSize = 2;
				else if (maxValue < 9) stepSize = 3;
				else if (maxValue < 12) stepSize = 4;
				return stepSize;
			}
		},
		charts: {
			component: null,
			tasks_by_user: {
				init: function() {
					let component = App.core.context.use('dashboard.tasks_by_user');
					if (!component) return;
					this.component = component;
					component.ctx = document.getElementById('tasks_by_user').getContext('2d');
					component.avaWidth = $('#dashboard-tasks-by-user .av_sm:first').width();
					component.block = $(component.ctx.canvas).parent().parent();
					component.datasets = {
						undone: {
							hot: {
								data: component.values.undone.hot,
								labelText: component.locale.hot,
								pointLabelFontSize: 4,
								fill: true,
								backgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT3') : App.colors.css_var('--CHART_BAR_HOT'),
								hoverBackgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT4') : App.colors.adjust(App.colors.css_var('--CHART_BAR_HOT'), -20),
								barThickness: component.barWidth,
								maxValue: Math.max.apply(null, component.values.undone.hot),
								stack: 'Undone'
							},
							another: {
								data: component.values.undone.another,
								labelText: component.locale.undone_lowcase,
								pointLabelFontSize: 4,
								fill: true,
								backgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT2') : App.colors.css_var('--CHART_BAR_MEDIUM'),
								hoverBackgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT3') : App.colors.adjust(App.colors.css_var('--CHART_BAR_MEDIUM'), -20),
								barThickness: component.barWidth,
								maxValue: Math.max.apply(null, component.values.undone.another),
								stack: 'Undone'
							},
							total: {
								data: component.values.undone.total,
								labelText: component.locale.undone_lowcase,
								pointLabelFontSize: 4,
								fill: true,
								backgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT2') : App.colors.css_var('--CHART_BAR_MEDIUM'),
								hoverBackgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT3') : App.colors.adjust(App.colors.css_var('--CHART_BAR_MEDIUM'), -20),
								barThickness: component.barWidth,
								maxValue: Math.max.apply(null, component.values.undone.total),
								stack: 'Total'
							}
						},
						done: {
							ontime: {
								data: component.values.done.ontime,
								labelText: component.locale.done_ontime,
								pointLabelFontSize: 4,
								fill: true,
								backgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT2') : App.colors.css_var('--CHART_BAR_MEDIUM'),
								hoverBackgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT3') : App.colors.adjust(App.colors.css_var('--CHART_BAR_MEDIUM'), -20),
								barThickness: component.barWidth,
								maxValue: Math.max.apply(null, component.values.done.ontime),
								stack: 'Done'
							},
							ondelay: {
								data: component.values.done.ondelay,
								labelText: component.locale.done_overdue,
								pointLabelFontSize: 4,
								fill: true,
								backgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT3') : App.colors.css_var('--CHART_BAR_HOT'),
								hoverBackgroundColor: component.demo ? App.colors.adjust(App.colors.css_var('--CHART_DEMO_LIGHT3'), -20) : App.colors.adjust(App.colors.css_var('--CHART_BAR_HOT'), -20),
								barThickness: component.barWidth,
								maxValue: Math.max.apply(null, component.values.done.ondelay),
								stack: 'Done'
							},
							total: {
								data: component.values.done.total,
								labelText: component.locale.done_lowcase,
								pointLabelFontSize: 4,
								fill: true,
								backgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT3') : App.colors.css_var('--CHART_BAR_DARK'),
								hoverBackgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT4') : App.colors.adjust(App.colors.css_var('--CHART_BAR_DARK'), -20),
								barThickness: component.barWidth,
								maxValue: Math.max.apply(null, component.values.done.total),
								stack: 'Total'
							}
						},
						history: {
							undone: {
								data: component.values.undone.history,
								labelText: component.locale.undone_lowcase,
								pointLabelFontSize: 4,
								fill: true,
								backgroundColor: component.demo ? App.colors.add_alpha(App.colors.css_var('--CHART_DEMO_LIGHT2'), 0.3) : App.colors.css_var('--CHART_BAR_LIGHT'),
								hoverBackgroundColor: component.demo ? App.colors.add_alpha(App.colors.css_var('--CHART_DEMO_LIGHT3'), 0.3) : App.colors.adjust(App.colors.css_var('--CHART_BAR_LIGHT'), -20),
								barThickness: component.barWidth,
								maxValue: Math.max.apply(null, component.values.undone.history)
							},
							done: {
								data: component.values.done.history,
								labelText: component.locale.undone_lowcase,
								pointLabelFontSize: 4,
								fill: true,
								backgroundColor: component.demo ? App.colors.add_alpha(App.colors.css_var('--CHART_DEMO_LIGHT2'), 0.3) : App.colors.css_var('--CHART_BAR_LIGHT'),
								hoverBackgroundColor: component.demo ? App.colors.add_alpha(App.colors.css_var('--CHART_DEMO_LIGHT3'), 0.3) : App.colors.adjust(App.colors.css_var('--CHART_BAR_LIGHT'), -20),
								barThickness: component.barWidth,
								maxValue: Math.max.apply(null, component.values.undone.done)
							},
							total: {
								data: component.values.history,
								labelText: component.locale.done_lowcase,
								pointLabelFontSize: 4,
								fill: true,
								backgroundColor: component.demo ? App.colors.add_alpha(App.colors.css_var('--CHART_DEMO_LIGHT3'), 0.3) : App.colors.css_var('--CHART_BAR_LIGHT'),
								hoverBackgroundColor: component.demo ? App.colors.add_alpha(App.colors.css_var('--CHART_DEMO_LIGHT4'), 0.3) : App.colors.adjust(App.colors.css_var('--CHART_BAR_LIGHT'), -20),
								barThickness: component.barWidth,
								maxValue: Math.max.apply(null, component.values.history)
							}
						}
					}
					component.stepSize = {
						undone: self.canvas.getStepSize(Math.max(component.datasets.undone.total.maxValue, component.datasets.history.undone.maxValue)),
						done: self.canvas.getStepSize(Math.max(component.datasets.done.total.maxValue, component.datasets.history.done.maxValue)),
						all: component.stepSizeValue
					}
					component.data = {
						labels: component.ids,
						datasets: component.state === 'undone' ? [component.datasets.history.undone, component.datasets.undone.hot, component.datasets.undone.another] :
							(component.state === 'done' ? [component.datasets.history.done, component.datasets.done.ondelay, component.datasets.done.ontime] :
								[component.datasets.history.total, component.datasets.undone.total, component.datasets.done.total])
					}
					component.externalTooltip = (context) => {
						if (App.device.is_mobile()) {
							$('#project-dashboard .tooltip').each(function () {
								$(this).css('opacity', 0);
							});
						}
						const {
							chart,
							tooltip
						} = context;
						let tooltipEl = document.querySelector('div#tasksByUserTooltip');
						let yAxis = chart.scales.y;
						if (!component.mobile || !component.sidePadding) {
							component.sidePadding = $(chart.canvas).position().left - $(chart.canvas.parentNode).position().left;
						}
						if (!tooltipEl) {
							tooltipEl = document.createElement('div');
							tooltipEl.className = 'tooltip tasksByUserTooltip';
							chart.canvas.parentNode.appendChild(tooltipEl);
						}
						if (tooltip && tooltip.dataPoints) {
							component.tooltipX = {};
							component.tooltipY = {};
							let tmp = {
								min: 0,
								max: 0
							};
							tooltip.dataPoints.forEach(function (value) {
								if (!Object.keys(component.tooltipY).length || value.element.y < component.tooltipY.min) component.tooltipY = {
									min: value.element.y,
									max: yAxis.getPixelForValue(0)
								}
								if (!Object.keys(component.tooltipX).length || value.element.x < component.tooltipX.min) tmp.min = value.element.x - component.barWidth / 2;
								if (!Object.keys(component.tooltipX).length || value.element.x > component.tooltipX.max) tmp.max = value.element.x + component.barWidth / 2;
								component.tooltipX = {
									min: tmp.min,
									max: tmp.max
								}
							});
							let dataIndex = tooltip.dataPoints[0].dataIndex;
							if (tooltip.opacity === 0) {
								tooltipEl.style.opacity = 0;
								return;
							}
							if (tooltip.body) {
								let data, html = '';
								$(tooltipEl).find('.name').html(component.userValue[dataIndex]);
								if (component.state === 'all') {
									data = {
										raw1: component.datasets.done.total,
										raw2: component.datasets.undone.total,
										history: component.datasets.history.total
									};
								} else if (component.state === 'done') {
									data = {
										raw1: component.datasets.done.ontime,
										raw2: component.datasets.done.ondelay,
										history: component.datasets.history.done
									}
								} else {
									data = {
										raw1: component.datasets.undone.another,
										raw2: component.datasets.undone.hot,
										history: component.datasets.history.undone
									}
								}
								if (component.state === 'undone') {
									html += component.locale.undone + ': <span class="cnt">' + (parseInt(data.raw1.data[dataIndex]) + parseInt(data.raw2.data[dataIndex])) + '</span> ' + App.format.quantity(data.raw1.data[dataIndex] + data.raw2.data[dataIndex], component.locale.tasks_qty);
									if (data.raw2.data[dataIndex]) {
										html += ' <span class="hot">(' + data.raw2.data[dataIndex] + ' ' + App.format.quantity(data.raw2.data[dataIndex], component.locale.hot_qty) + ')</span>';
									}
								} else if (component.state === 'done') {
									html += component.locale.done + ': <span class="cnt">' + (parseInt(data.raw1.data[dataIndex]) + parseInt(data.raw2.data[dataIndex])) + '</span> ' + App.format.quantity(data.raw1.data[dataIndex] + data.raw2.data[dataIndex], component.locale.tasks_qty);
									if (data.raw2.data[dataIndex]) {
										html += ' <span class="hot">(' + data.raw2.data[dataIndex] + ' ' + component.locale.done_overdue + ')</span>';
									}
								} else {
									html +=
										'<table>' +
										'<tr>' +
										'<td><span class="circle" style="background: ' + data.raw1.backgroundColor + '"></span></td>' +
										'<td>' + data.raw1.labelText + '</td>' +
										'<td><span class="cnt">' + data.raw1.data[dataIndex] + '</span></td>' +
										'</tr>' +
										'<tr>' +
										'<td><span class="circle" style="background: ' + data.raw2.backgroundColor + '"></span></td>' +
										'<td>' + data.raw2.labelText + '</td>' +
										'<td><span class="cnt">' + data.raw2.data[dataIndex] + '</span></td>' +
										'</tr>' +
										'</table>';
									html += component.locale.total + ': <span class="cnt">' + (parseInt(data.raw1.data[dataIndex]) + parseInt(data.raw2.data[dataIndex])) + '</span> ' + App.format.quantity(data.raw1.data[dataIndex] + data.raw2.data[dataIndex], component.locale.tasks_qty);
								}
								html += '<br>' + component.locale.week_ago + ': <span class="cnt">' + data.history.data[dataIndex] + '</span> ' + App.format.quantity(data.history.data[dataIndex], component.locale.tasks_qty);
								$(tooltipEl).find('.body').html(html);
							}

							// Display, position, and set styles for font
							let styleLeft = component.sidePadding + tooltip.caretX - component.barWidth;
							tooltipEl.style.left = (styleLeft + component.block.offset().left > tooltipEl.clientWidth ? styleLeft - tooltipEl.clientWidth : styleLeft + 2 * component.barWidth) + 'px';
							tooltipEl.style.top = component.mobile ? (tooltip.caretY - tooltipEl.clientHeight > 0 ? tooltip.caretY - tooltipEl.clientHeight : 0) + 'px' : tooltip.caretY - tooltipEl.clientHeight + 'px';
							tooltipEl.style.opacity = 1;
						}
					}
					component.options = {
						scales: {
							x: {
								stacked: true,
								grid: {
									display: false,
									drawBorder: false
								},
								ticks: false
							},
							y: {
								stacked: true,
								grid: {
									display: true,
									drawTicks: false,
									drawBorder: false,
									color: App.colors.css_var('--CHART_GRID_LINE')
								},
								ticks: {
									stepSize: component.state === 'undone' ? component.stepSize.undone : (component.state === 'done' ? component.stepSize.done : component.stepSize.all),
									color: App.colors.css_var('--base-txt-muted'),
									padding: 10,
									font: {
										size: 13
									}
								},
								beginAtZero: true,
								min: 0,
								max: (component.state === 'undone' ? component.stepSize.undone : (component.state === 'done' ? component.stepSize.done : component.stepSize.all)) * 3
							}
						},
						layout: {
							padding: {
								top: 0,
								bottom: 30
							}
						},
						responsive: true,
						maintainAspectRatio: false,
						plugins: {
							legend: false,
							tooltip: component.demo ? false : {
								enabled: false,
								position: 'average',
								external: component.externalTooltip
							}
						},
						interaction: {
							mode: 'index',
							intersect: false
						}
					}
					component.chart = new Chart(component.ctx, {
						type: 'bar',
						data: component.data,
						options: component.options,
						plugins: [{
							afterDraw: chart => {
								let ctx = chart.ctx;
								let yAxis = chart.scales.y;
								let yZero = yAxis.getPixelForValue(0);
								let data = chart.getDatasetMeta(0).data;
								let yMin = yAxis.getPixelForValue(0);
								let width = data.length ? data[0].width : 0;
								if (!component.mobile || !component.sidePadding) {
									component.sidePadding = $(chart.canvas).position().left - $(chart.canvas.parentNode).position().left;
								}

								ctx.save();
								data.forEach(function (value, index) {
									let ava = document.getElementById('avatar_' + component.ids[index]);
									let active = !component.demo && chart.tooltip && chart.tooltip._active && chart.tooltip._active.length && chart.tooltip.caretX.toFixed(4) === (value.x + 6).toFixed(4);
									let data = {
										raw1: '',
										raw2: ''
									}

									if (component.state === 'undone') {
										if (!component.datasets.history.undone.data[index]) {
											data.raw1 = component.datasets.history.undone;
										}
										if (!component.datasets.undone.total.data[index]) {
											data.raw2 = component.datasets.undone.total;
										}
									} else if (component.state === 'done') {
										if (!component.datasets.history.done.data[index]) {
											data.raw1 = component.datasets.history.done;
										}
										if (!component.datasets.done.total.data[index]) {
											data.raw2 = component.datasets.done.total;
										}
									} else {
										if (!component.datasets.history.total.data[index]) {
											data.raw1 = component.datasets.history.total;
										}
										if (!(parseInt(component.datasets.undone.total.data[index]) + parseInt(component.datasets.done.total.data[index]))) {
											data.raw2 = component.datasets.undone.total;
										}
									}
									if (data.raw1) {
										ctx.beginPath();
										ctx.fillStyle = active ? data.raw1.hoverBackgroundColor : data.raw1.backgroundColor;
										ctx.rect(value.x - width / 2, yMin - 1, width, 1);
										ctx.fill();
									}
									if (data.raw2) {
										ctx.beginPath();
										ctx.fillStyle = active ? data.raw2.hoverBackgroundColor : data.raw2.backgroundColor;
										ctx.rect(value.x + component.barWidth - width / 2, yMin - 1, width, 1);
										ctx.fill();
									}
									if (ava) {
										ava.style.display = 'inline-block';
										ava.style.boxShadow = active ? '0 0 0 2px ' + App.colors.css_var('--CHART_TASK_INTIME') : 'none';
										ava.style.top = yZero + component.avaTopPadding + 'px';
										ava.style.left = component.sidePadding + value.x + component.barWidth / 2 - component.avaWidth / 2 + 'px';
									}
								});
							}
						}]
					});
					if (App.device.is_mobile()) component.mobile = true;
					if (!component.demo) {
						component.ctx.canvas.addEventListener('mousemove', function (evt) {
							let pos = self.canvas.getMousePos(component.ctx.canvas, evt);
							if (component.tooltipX && component.tooltipY) {
								if (pos.x >= component.tooltipX.min && pos.x <= component.tooltipX.max
									&& pos.y >= component.tooltipY.min && pos.y <= component.tooltipY.max) {
									$('#tasks_by_user').css('cursor', 'pointer');
									component.hover = true;
								} else {
									$('#tasks_by_user').css('cursor', 'default');
									component.hover = false;
								}
							}
						});
						$('#tasks_by_user').on('click', function () {
							if (App.device.is_mobile()) return false;
							let activePoints = component.chart.getActiveElements();
							if (activePoints.length && component.hover) {
								let index = activePoints[0].index;
								App.core.goto((component.state === 'undone' ? component.links.undone : (component.state === 'done' ? component.links.done : component.links.all)) + component.ids[index]);
							}
						});
					}
				},
				do_state: function(elem) {
					let component = this.component;
					App.menu.hide(true);
					let text = $(elem).attr('data-text');
					let state = $(elem).attr('data-state');
					let menu = $(elem).closest('.menu');
					let block = $('#' + menu.attr('data-block-id'));
					let notAssignedBtn = block.find('#tasksByUserNotAssigned');
					let notAssignedMenu = $('#quickDashboardTasksByUserMenu');
					if (state === 'done') {
						component.state = 'done';
						component.chart.config.options.scales.y.ticks.stepSize = component.stepSize.done;
						component.chart.config.options.scales.y.max = component.stepSize.done * 3;
						component.chart.data.datasets = [component.datasets.history.done, component.datasets.done.ondelay, component.datasets.done.ontime];
						notAssignedBtn.find('span b').html(component.values.notAssigned.done);
						notAssignedMenu.find('.menu__item').attr('onclick', "App.core.goto('"+component.links.done+"2')");
						$.ajax({url: component.stateURL + '&grid_name=tasks_by_user&state=done'});
					} else if (state === 'undone') {
						component.state = 'undone';
						component.chart.config.options.scales.y.ticks.stepSize = component.stepSize.undone;
						component.chart.config.options.scales.y.max = component.stepSize.undone * 3;
						component.chart.data.datasets = [component.datasets.history.undone, component.datasets.undone.hot, component.datasets.undone.another];
						notAssignedBtn.find('span b').html(component.values.notAssigned.undone);
						notAssignedMenu.find('.menu__item').attr('onclick', "App.core.goto('"+component.links.undone+"2')");
						$.ajax({url: component.stateURL + '&grid_name=tasks_by_user&state=undone'});
					} else if (state === 'all') {
						component.state = 'all';
						component.chart.config.options.scales.y.ticks.stepSize = component.stepSize.all;
						component.chart.config.options.scales.y.max = component.stepSize.all * 3;
						component.chart.data.datasets = [component.datasets.history.total, component.datasets.undone.total, component.datasets.done.total];
						notAssignedBtn.find('span b').html(component.values.notAssigned.all);
						notAssignedMenu.find('.menu__item').attr('onclick', "App.core.goto('"+component.links.all+"2')");
						$.ajax({url: component.stateURL + '&grid_name=tasks_by_user&state=all'});
					}
					component.chart.update();
					if (text) $('[data-menu-id=' + menu.attr('id') + ']').attr('text', text);
					menu.find('.menu__item').removeClass('menu__item-active');
					$(elem).addClass('menu__item-active');
				}
			},
			tasks_by_stage: {
				component: null,
				init: function() {
					let component = App.core.context.use('dashboard.tasks_by_stage');
					if (!component) return;
					this.component = component;
					component.canvas = document.getElementById('tasks_by_tag');
					component.ctx = document.getElementById('tasks_by_tag').getContext('2d');
					component.stageWidth = $('#dashboard-tasks-by-tag .tag:first').width();

					component.block = $(component.ctx.canvas).parent().parent();

					component.datasets = {
						undone: {
							hot: {
								data: component.values.undone.hot,
								labelText: component.locale.hot,
								pointLabelFontSize: 4,
								fill: true,
								backgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT3') : App.colors.css_var('--CHART_BAR_HOT'),
								hoverBackgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT4') : App.colors.adjust(App.colors.css_var('--CHART_BAR_HOT'), -20),
								barThickness: component.barWidth,
								maxValue: Math.max.apply(null, component.values.undone.hot),
								stack: 'Undone'
							},
							another: {
								data: component.values.undone.another,
								labelText: component.locale.undone_lowcase,
								pointLabelFontSize: 4,
								fill: true,
								backgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT2') : App.colors.css_var('--CHART_BAR_MEDIUM'),
								hoverBackgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT3') : App.colors.adjust(App.colors.css_var('--CHART_BAR_MEDIUM'), -20),
								barThickness: component.barWidth,
								maxValue: Math.max.apply(null, component.values.undone.another),
								stack: 'Undone'
							},
							total: {
								data: component.values.undone.total,
								labelText: component.locale.undone_lowcase,
								pointLabelFontSize: 4,
								fill: true,
								backgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT2') : App.colors.css_var('--CHART_BAR_MEDIUM'),
								hoverBackgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT3') : App.colors.adjust(App.colors.css_var('--CHART_BAR_MEDIUM'), -20),
								barThickness: component.barWidth,
								maxValue: Math.max.apply(null, component.values.undone.total),
								stack: 'Total'
							}
						},
						done: {
							ontime: {
								data: component.values.done.ontime,
								labelText: component.locale.done_ontime,
								pointLabelFontSize: 4,
								fill: true,
								backgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT2') : App.colors.css_var('--CHART_BAR_MEDIUM'),
								hoverBackgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT3') : App.colors.adjust(App.colors.css_var('--CHART_BAR_MEDIUM'), -20),
								barThickness: component.barWidth,
								maxValue: Math.max.apply(null, component.values.done.ontime),
								stack: 'Done'
							},
							ondelay: {
								data: component.values.done.ondelay,
								labelText: component.locale.done_overdue,
								pointLabelFontSize: 4,
								fill: true,
								backgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT3') : App.colors.css_var('--CHART_BAR_HOT'),
								hoverBackgroundColor: component.demo ? App.colors.adjust(App.colors.css_var('--CHART_DEMO_LIGHT3'), -20) : App.colors.adjust(App.colors.css_var('--CHART_BAR_HOT'), -20),
								barThickness: component.barWidth,
								maxValue: Math.max.apply(null, component.values.done.ondelay),
								stack: 'Done'
							},
							total: {
								data: component.values.done.total,
								labelText: component.locale.done_lowcase,
								pointLabelFontSize: 4,
								fill: true,
								backgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT3') : App.colors.css_var('--CHART_BAR_DARK'),
								hoverBackgroundColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT4') : App.colors.adjust(App.colors.css_var('--CHART_BAR_DARK'), -20),
								barThickness: component.barWidth,
								maxValue: Math.max.apply(null, component.values.done.total),
								stack: 'Total'
							}
						},
						history: {
							undone: {
								data: component.values.undone.history,
								labelText: component.locale.undone_lowcase,
								pointLabelFontSize: 4,
								fill: true,
								backgroundColor: component.demo ? App.colors.add_alpha(App.colors.css_var('--CHART_DEMO_LIGHT2'), 0.3) : App.colors.css_var('--CHART_BAR_LIGHT'),
								hoverBackgroundColor: component.demo ? App.colors.add_alpha(App.colors.css_var('--CHART_DEMO_LIGHT3'), 0.3) : App.colors.adjust(App.colors.css_var('--CHART_BAR_LIGHT'), -20),
								barThickness: component.barWidth,
								maxValue: Math.max.apply(null, component.values.undone.history)
							},
							done: {
								data: component.values.done.history,
								labelText: component.locale.undone_lowcase,
								pointLabelFontSize: 4,
								fill: true,
								backgroundColor: component.demo ? App.colors.add_alpha(App.colors.css_var('--CHART_DEMO_LIGHT2'), 0.3) : App.colors.css_var('--CHART_BAR_LIGHT'),
								hoverBackgroundColor: component.demo ? App.colors.add_alpha(App.colors.css_var('--CHART_DEMO_LIGHT3'), 0.3) : App.colors.adjust(App.colors.css_var('--CHART_BAR_LIGHT'), -20),
								barThickness: component.barWidth,
								maxValue: Math.max.apply(null, component.values.undone.done)
							},
							total: {
								data: component.values.history,
								labelText: component.locale.done_lowcase,
								pointLabelFontSize: 4,
								fill: true,
								backgroundColor: component.demo ? App.colors.add_alpha(App.colors.css_var('--CHART_DEMO_LIGHT3'), 0.3) : App.colors.css_var('--CHART_BAR_LIGHT'),
								hoverBackgroundColor: component.demo ? App.colors.add_alpha(App.colors.css_var('--CHART_DEMO_LIGHT4'), 0.3) : App.colors.adjust(App.colors.css_var('--CHART_BAR_LIGHT'), -20),
								barThickness: component.barWidth,
								maxValue: Math.max.apply(null, component.values.history)
							}
						}
					}
					component.stepSize = {
						undone: self.canvas.getStepSize(Math.max(component.datasets.undone.total.maxValue, component.datasets.history.undone.maxValue)),
						done: self.canvas.getStepSize(Math.max(component.datasets.done.total.maxValue, component.datasets.history.done.maxValue)),
						all: component.stepSizeValue
					}
					component.data = {
						labels: component.ids,
						datasets: component.state === 'undone' ? [component.datasets.history.undone, component.datasets.undone.hot, component.datasets.undone.another] :
							(component.state === 'done' ? [component.datasets.history.done, component.datasets.done.ondelay, component.datasets.done.ontime] :
								[component.datasets.history.total, component.datasets.undone.total, component.datasets.done.total])
					}
					component.externalTooltip = (context) => {
						if (App.device.is_mobile()) {
							$('#project-dashboard .tooltip').each(function () {
								$(this).css('opacity', 0);
							});
						}
						const {
							chart,
							tooltip
						} = context;
						let tooltipEl = document.querySelector('div#tasksByStatusTooltip');
						let yAxis = chart.scales.y;
						if (!component.mobile || !component.sidePadding) {
							component.sidePadding = $(chart.canvas).position().left - $(chart.canvas.parentNode).position().left;
						}
						if (!tooltipEl) {
							tooltipEl = document.createElement('div');
							tooltipEl.className = 'tooltip tasksByStatusTooltip';
							chart.canvas.parentNode.appendChild(tooltipEl);
						}
						if (tooltip && tooltip.dataPoints) {
							component.tooltipX = {};
							component.tooltipY = {};
							let tmp = {
								min: 0,
								max: 0
							};
							tooltip.dataPoints.forEach(function (value) {
								if (!Object.keys(component.tooltipY).length || value.element.y < component.tooltipY.min) component.tooltipY = {
									min: value.element.y,
									max: yAxis.getPixelForValue(0)
								}
								if (!Object.keys(component.tooltipX).length || value.element.x < component.tooltipX.min) tmp.min = value.element.x - component.barWidth / 2;
								if (!Object.keys(component.tooltipX).length || value.element.x > component.tooltipX.max) tmp.max = value.element.x + component.barWidth / 2;
								component.tooltipX = {
									min: tmp.min,
									max: tmp.max
								}
							});
							let dataIndex = tooltip.dataPoints[0].dataIndex;
							if (tooltip.opacity === 0) {
								tooltipEl.style.opacity = 0;
								return;
							}
							if (tooltip.body) {
								let data, html = '';
								$(tooltipEl).find('.name').html(component.stageNames[dataIndex]);
								if (component.state === 'all') {
									data = {
										raw1: component.datasets.done.total,
										raw2: component.datasets.undone.total,
										history: component.datasets.history.total
									};
								} else if (component.state === 'done') {
									data = {
										raw1: component.datasets.done.ontime,
										raw2: component.datasets.done.ondelay,
										history: component.datasets.history.done
									}
								} else {
									data = {
										raw1: component.datasets.undone.another,
										raw2: component.datasets.undone.hot,
										history: component.datasets.history.undone
									}
								}
								if (component.state === 'undone') {
									html += component.locale.undone + ': <span class="cnt">' + (parseInt(data.raw1.data[dataIndex]) + parseInt(data.raw2.data[dataIndex])) + '</span> ' + App.format.quantity(data.raw1.data[dataIndex] + data.raw2.data[dataIndex], component.locale.tasks_qty);
									if (data.raw2.data[dataIndex]) {
										html += ' <span class="hot">(' + data.raw2.data[dataIndex] + ' ' + App.format.quantity(data.raw2.data[dataIndex], component.locale.hot_qty) + ')</span>';
									}
								} else if (component.state === 'done') {
									html += component.locale.done + ': <span class="cnt">' + (parseInt(data.raw1.data[dataIndex]) + parseInt(data.raw2.data[dataIndex])) + '</span> ' + App.format.quantity(data.raw1.data[dataIndex] + data.raw2.data[dataIndex], component.locale.tasks_qty);
									if (data.raw2.data[dataIndex]) {
										html += ' <span class="hot">(' + data.raw2.data[dataIndex] + ' ' + component.locale.done_overdue + ')</span>';
									}
								} else {
									html +=
										'<table>' +
										'<tr>' +
										'<td><span class="circle" style="background: ' + data.raw1.backgroundColor + '"></span></td>' +
										'<td>' + data.raw1.labelText + '</td>' +
										'<td><span class="cnt">' + data.raw1.data[dataIndex] + '</span></td>' +
										'</tr>' +
										'<tr>' +
										'<td><span class="circle" style="background: ' + data.raw2.backgroundColor + '"></span></td>' +
										'<td>' + data.raw2.labelText + '</td>' +
										'<td><span class="cnt">' + data.raw2.data[dataIndex] + '</span></td>' +
										'</tr>' +
										'</table>';
									html += component.locale.total + ': <span class="cnt">' + (parseInt(data.raw1.data[dataIndex]) + parseInt(data.raw2.data[dataIndex])) + '</span> ' + App.format.quantity(data.raw1.data[dataIndex] + data.raw2.data[dataIndex], component.locale.tasks_qty);
								}
								html += '<br>' + component.locale.week_ago + ': <span class="cnt">' + data.history.data[dataIndex] + '</span> ' + App.format.quantity(data.history.data[dataIndex], component.locale.tasks_qty);
								$(tooltipEl).find('.body').html(html);
							}

							// Display, position, and set styles for font
							let styleLeft = component.sidePadding + tooltip.caretX - component.barWidth;
							tooltipEl.style.left = (styleLeft + component.block.offset().left > tooltipEl.clientWidth ? styleLeft - tooltipEl.clientWidth : styleLeft + 2 * component.barWidth) + 'px';
							tooltipEl.style.top = component.mobile ? (tooltip.caretY - tooltipEl.clientHeight > 0 ? tooltip.caretY - tooltipEl.clientHeight : 0) + 'px' : tooltip.caretY - tooltipEl.clientHeight + 'px';
							tooltipEl.style.opacity = 1;
						}
					}
					component.options = {
						scales: {
							x: {
								stacked: true,
								grid: {
									display: false,
									drawBorder: false
								},
								ticks: false
							},
							y: {
								stacked: true,
								grid: {
									display: true,
									drawTicks: false,
									drawBorder: false,
									color: App.colors.css_var('--CHART_GRID_LINE')
								},
								ticks: {
									stepSize: component.state === 'undone' ? component.stepSize.undone : (component.state === 'done' ? component.stepSize.done : component.stepSize.all),
									color: App.colors.css_var('--base-txt-muted'),
									padding: 10,
									font: {
										size: 13
									}
								},
								beginAtZero: true,
								min: 0,
								max: (component.state === 'undone' ? component.stepSize.undone : (component.state === 'done' ? component.stepSize.done : component.stepSize.all)) * 3
							}
						},
						layout: {
							padding: {
								top: 0,
								bottom: 30
							}
						},
						responsive: true,
						maintainAspectRatio: false,
						plugins: {
							legend: false,
							tooltip: component.demo ? false : {
								enabled: false,
								position: 'average',
								external: component.externalTooltip
							}
						},
						interaction: {
							mode: 'index',
							intersect: false
						}
					}
					component.chart = new Chart(component.ctx, {
						type: 'bar',
						data: component.data,
						options: component.options,
						plugins: [{
							afterDraw: chart => {
								let ctx = chart.ctx;
								let yAxis = chart.scales.y;
								let yZero = yAxis.getPixelForValue(0);
								let data = chart.getDatasetMeta(0).data;
								let yMin = yAxis.getPixelForValue(0);
								let width = data.length ? data[0].width : 0;
								if (!component.mobile || !component.sidePadding) {
									component.sidePadding = $(chart.canvas).position().left - $(chart.canvas.parentNode).position().left;
								}

								ctx.save();
								data.forEach(function (value, index) {
									let stage = document.getElementById('chart_status_' + component.ids[index]);
									let active = !component.demo && chart.tooltip && chart.tooltip._active && chart.tooltip._active.length && chart.tooltip.caretX.toFixed(4) === (value.x + 6).toFixed(4);
									let data = {
										raw1: '',
										raw2: ''
									}

									if (component.state === 'undone') {
										if (!component.datasets.history.undone.data[index]) {
											data.raw1 = component.datasets.history.undone;
										}
										if (!component.datasets.undone.total.data[index]) {
											data.raw2 = component.datasets.undone.total;
										}
									} else if (component.state === 'done') {
										if (!component.datasets.history.done.data[index]) {
											data.raw1 = component.datasets.history.done;
										}
										if (!component.datasets.done.total.data[index]) {
											data.raw2 = component.datasets.done.total;
										}
									} else {
										if (!component.datasets.history.total.data[index]) {
											data.raw1 = component.datasets.history.total;
										}
										if (!(parseInt(component.datasets.undone.total.data[index]) + parseInt(component.datasets.done.total.data[index]))) {
											data.raw2 = component.datasets.undone.total;
										}
									}
									if (data.raw1) {
										ctx.beginPath();
										ctx.fillStyle = active ? data.raw1.hoverBackgroundColor : data.raw1.backgroundColor;
										ctx.rect(value.x - width / 2, yMin - 1, width, 1);
										ctx.fill();
									}
									if (data.raw2) {
										ctx.beginPath();
										ctx.fillStyle = active ? data.raw2.hoverBackgroundColor : data.raw2.backgroundColor;
										ctx.rect(value.x + component.barWidth - width / 2, yMin - 1, width, 1);
										ctx.fill();
									}
									if (stage) {
										stage.style.display = 'inline-block';
										stage.style.boxShadow = active ? '0 0 0 2px ' + App.colors.css_var('--CHART_TASK_INTIME') : 'none';
										stage.style.top = yZero + component.stageTopPadding + 'px';
										stage.style.left = component.sidePadding + value.x + component.barWidth / 2 - component.stageWidth / 2 + 'px';
									}
								});
							}
						}]
					});

					if (App.device.is_mobile()) component.mobile = true;
					if (!component.demo) {
						component.ctx.canvas.addEventListener('mousemove', function (evt) {
							let pos = self.canvas.getMousePos(component.ctx.canvas, evt);
							if (component.tooltipX && component.tooltipY) {
								if (pos.x >= component.tooltipX.min && pos.x <= component.tooltipX.max
									&& pos.y >= component.tooltipY.min && pos.y <= component.tooltipY.max) {
									$('#tasks_by_user').css('cursor', 'pointer');
									component.hover = true;
								} else {
									$('#tasks_by_user').css('cursor', 'default');
									component.hover = false;
								}
							}
						});
						$('#tasks_by_tag').on('click', function () {
							if (App.device.is_mobile()) return false;
							let activePoints = component.chart.getActiveElements();
							if (activePoints.length && component.hover) {
								let index = activePoints[0].index;
								App.core.goto((component.state === 'undone' ? component.links.undone : (component.state === 'done' ? component.links.done : component.links.all)) + component.ids[index]);
							}
						});
					}
				},
				do_state: function(elem) {
					let component = this.component;
					App.menu.hide(true);
					let text = $(elem).attr('data-text');
					let state = $(elem).attr('data-state');
					let menu = $(elem).closest('.menu');
					let block = $('#' + menu.attr('data-block-id'));
					let backlogBtn = block.find('#tasksByStageBacklog');
					let backlogMenu = $('#quickDashboardTasksByTagMenu');
					if (state === 'done') {
						component.state = 'done';
						component.chart.config.options.scales.y.ticks.stepSize = component.stepSize.done;
						component.chart.config.options.scales.y.max = component.stepSize.done * 3;
						component.chart.data.datasets = [component.datasets.history.done, component.datasets.done.ondelay, component.datasets.done.ontime];
						backlogBtn.find('span b').html(component.values.backlog.done);
						backlogMenu.find('.menu__item').attr('onclick', "App.core.goto('"+component.links.done+"0')");
						$.ajax({url: component.stateURL + '&grid_name=tasks_by_tag&state=done'});
					} else if (state === 'undone') {
						component.state = 'undone';
						component.chart.config.options.scales.y.ticks.stepSize = component.stepSize.undone;
						component.chart.config.options.scales.y.max = component.stepSize.undone * 3;
						component.chart.data.datasets = [component.datasets.history.undone, component.datasets.undone.hot, component.datasets.undone.another];
						backlogBtn.find('span b').html(component.values.backlog.undone);
						backlogMenu.find('.menu__item').attr('onclick', "App.core.goto('"+component.links.undone+"0')");
						$.ajax({url: component.stateURL + '&grid_name=tasks_by_tag&state=undone'});
					} else if (state === 'all') {
						component.state = 'all';
						component.chart.config.options.scales.y.ticks.stepSize = component.stepSize.all;
						component.chart.config.options.scales.y.max = component.stepSize.all * 3;
						component.chart.data.datasets = [component.datasets.history.total, component.datasets.undone.total, component.datasets.done.total];
						backlogBtn.find('span b').html(component.values.backlog.all);
						backlogMenu.find('.menu__item').attr('onclick', "App.core.goto('"+component.links.all+"0')");
						$.ajax({url: component.stateURL + '&grid_name=tasks_by_tag&state=all'});
					}
					component.chart.update();
					if (text) $('[data-menu-id=' + menu.attr('id') + ']').attr('text', text);
					menu.find('.menu__item').removeClass('menu__item-active');
					$(elem).addClass('menu__item-active');
				}
			},
			tasks_speed_donut: {
				component: null,
				timeouts: [],
				reload: function(state) {
					let component = this.component;
					component.active = false;
					this.timeouts.push(setTimeout(function () {
						component.active = true;
						document.getElementById('tasks_donut_print').src = component.chart.toBase64Image();
					}, 1200));
					component.state = state;
					component.chartHover.data.datasets[0].labels = component.labels[state];
					component.chartHover.data.datasets[0].data = component.chartInner.data.datasets[0].data = component[state];
					component.chartInner.data.datasets[0].backgroundColor = (state === 'done' ? [App.colors.css_var('--trans'), App.colors.css_var('--trans'), App.colors.css_var('--trans')] :
						[App.colors.css_var('--trans'), App.colors.css_var('--trans'), App.colors.css_var('--trans'), App.colors.css_var('--trans'), App.colors.css_var('--trans')]);
					component.chart.data.datasets = [component.datasets[state]];
					component.count = component.sum[state];
					component.chart.update();
					component.chartHover.update();
					component.chartInner.update();
				},
				init: function() {
					let component = App.core.context.use('dashboard.tasks_speed_donut');
					if (!component) return;
					this.component = component;
					if (component.demo === 'undone' || component.preview) {
						component.colors.undone.bg[0] = App.colors.css_var('--CHART_DEMO_LIGHT2');
						component.undone = [1];
					}
					if (component.demo === 'done' || component.preview) {
						component.colors.done.bg[0] = App.colors.css_var('--CHART_DEMO_LIGHT2');
						component.done = [1];
					}
					component.datasets = {
						undone: {
							clip: 10,
							labels: component.labels.undone,
							data: component.undone,
							backgroundColor: [
								App.colors.css_var('--CHART_TASK_NODATES'),
								App.colors.css_var('--CHART_TASK_AWAITING'),
								App.colors.css_var('--CHART_TASK_STARTED'),
								App.colors.css_var('--CHART_TASK_COMING'),
								App.colors.css_var('--CHART_TASK_HOT')
							],
							borderWidth: 1,
							borderAlign: 'inner',
							borderColor: App.colors.css_var('--base-cont-top')
						},
						done: {
							clip: 10,
							labels: component.labels.done,
							data: component.done,
							backgroundColor: [
								App.colors.css_var('--CHART_TASK_INTIME'),
								App.colors.css_var('--CHART_TASK_DELAY'),
								App.colors.css_var('--CHART_TASK_NODATES')
							],
							borderWidth: 1,
							borderAlign: 'inner',
							borderColor: App.colors.css_var('--base-cont-top')
						}
					}
					let resetHovers = {};
					let label = '';
					component.chartInner = new Chart(document.getElementById('tasks_donut_inner'), {
						type: 'pie',
						data: {
							datasets: [{
								labels: component.labels.undone,
								data: component[component.state],
								backgroundColor: component.state === 'done' ? [App.colors.css_var('--trans'), App.colors.css_var('--trans'), App.colors.css_var('--trans')] :
									[App.colors.css_var('--trans'), App.colors.css_var('--trans'), App.colors.css_var('--trans'), App.colors.css_var('--trans'), App.colors.css_var('--trans')],
								borderColor: App.colors.css_var('--base-cont-top'),
								borderWidth: 1,
								borderAlign: 'inner'
							}]
						},
						options: {
							responsive: true,
							maintainAspectRatio: false,
							plugins: {
								legend: false,
								tooltip: false
							},
							layout: {
								padding: 5
							}
						}
					});
					component.chart = new Chart(document.getElementById('tasks_donut'), {
						type: 'doughnut',
						data: {
							datasets: [component.state === 'undone' ? component.datasets.undone : component.datasets.done]
						},
						options: {
							cutout: '85%',
							responsive: true,
							maintainAspectRatio: false,
							layout: {
								padding: 0
							},
							plugins: {
								legend: false,
								tooltip: false
							}
						},
						plugins: [{
							afterDraw: chart => {
								if (!component.active) {
									let textWidth;
									let ctx = chart.ctx;
									ctx.font = "bold 30px " + App.colors.css_var('--font-base');
									ctx.fillStyle = App.colors.css_var('--base-txt-primary');
									textWidth = ctx.measureText(component.count ? component.count : component.sum[component.state]).width;
									ctx.fillText(component.count ? component.count : component.sum[component.state], chart.chartArea.width / 2 - textWidth / 2, chart.chartArea.height / 2 + 10);
									component.chart.data.datasets[0].backgroundColor.forEach(function (value, index) {
										if (Object.keys(resetHovers).length && resetHovers.dataIndex === index) {
											component.chart.data.datasets[0].backgroundColor[resetHovers.dataIndex] = resetHovers.hover;
											component.chartInner.data.datasets[0].backgroundColor[resetHovers.dataIndex] = resetHovers.inner;
										} else {
											component.chart.data.datasets[0].backgroundColor[index] = component.colors[component.state].bg[index];
											component.chartInner.data.datasets[0].backgroundColor[index] = App.colors.css_var('--trans')
										}
									});
								}
							}
						}]
					});
					component.chartHover = new Chart(document.getElementById('tasks_donut_hover'), {
						type: 'pie',
						data: {
							datasets: [{
								labels: component.labels[component.state],
								data: component[component.state],
								backgroundColor: App.colors.css_var('--trans'),
								borderColor: App.colors.css_var('--trans'),
								borderWidth: 1,
								borderAlign: 'inner'
							}]
						},
						options: {
							responsive: true,
							maintainAspectRatio: false,
							plugins: {
								legend: false,
								tooltip: component.preview ? false : {
									enabled: false,
									external: function (context) {
										const {chart, tooltip} = context;
										if (component.state !== component.demo && component.active && tooltip.dataPoints) {
											let dataIndex = tooltip.dataPoints[0].dataIndex;
											if (tooltip.opacity) {
												$('#tasks_donut_hover').css('cursor', !(component.state === 'undone' && dataIndex === 2) ? 'pointer' : 'default');
												component.count = tooltip.dataPoints[0].parsed;
												label = component.labels[component.state][dataIndex];
												resetHovers.hover = component.colors[component.state].hover[dataIndex];
												resetHovers.inner = component.colors[component.state].inner[dataIndex];
												resetHovers.dataIndex = dataIndex;
											} else {
												$('#tasks_donut_hover').css('cursor', 'default');
												component.count = component.sum[component.state];
												label = '';
												resetHovers = {};
												component.dataIndex = dataIndex;
											}
										}
									}
								}
							},
							layout: {
								padding: 0
							}
						},
						plugins: [{
							afterDraw: chart => {
								let textWidth;
								let ctx = chart.ctx;
								if (component.active) {
									ctx.font = "normal 14px " + App.colors.css_var('--font-base');
									ctx.fillStyle = App.colors.css_var('--base-txt-tertiary');
									textWidth = ctx.measureText(label).width;
									ctx.fillText(label, chart.chartArea.width / 2 - textWidth / 2, chart.chartArea.height / 2 + 30);
								}
								ctx.font = "bold 30px " + App.colors.css_var('--font-base');
								ctx.fillStyle = App.colors.css_var('--base-txt-primary');
								textWidth = ctx.measureText(component.count ? component.count : component.sum[component.state]).width;
								ctx.fillText(component.count ? component.count : component.sum[component.state], chart.chartArea.width / 2 - textWidth / 2, chart.chartArea.height / 2 + 10);
								component.chart.data.datasets[0].backgroundColor.forEach(function (value, index) {
									if (Object.keys(resetHovers).length && resetHovers.dataIndex === index) {
										component.chart.data.datasets[0].backgroundColor[resetHovers.dataIndex] = resetHovers.hover;
										component.chartInner.data.datasets[0].backgroundColor[resetHovers.dataIndex] = resetHovers.inner;
									} else {
										component.chart.data.datasets[0].backgroundColor[index] = component.colors[component.state].bg[index];
										component.chartInner.data.datasets[0].backgroundColor[index] = App.colors.css_var('--trans')
									}
								});
								component.chart.update();
								component.chartInner.update();
							}
						}]
					});
					this.timeouts.push(setTimeout(function () {
						component.active = true;
						document.getElementById('tasks_donut_print').src = component.chart.toBase64Image();
					}, 1200));
					$('#tasks_donut_hover').on('click', function () {
						if (App.device.is_mobile() || component.preview || component.state === component.demo) return false;
						let activePoints = component.chartHover.getActiveElements();
						if (activePoints.length && component.links[component.state][activePoints[0].index]) {
							App.core.goto(component.links[component.state][activePoints[0].index]);
						}
					});
				},
				do_state: function(elem) {
					let component = this.component;
					App.menu.hide(true);
					let text = $(elem).attr('data-text');
					let state = $(elem).attr('data-state');
					let menu;
					menu = $(elem).hasClass('menu__item') ? $(elem).closest('.menu') : $('#' + $(elem).closest('.dashboard__block').attr('id') + '-statemenu');
					if (state === 'done') {
						$.ajax({url: component.stateURL + '&grid_name=tasks_speed_donut&state=done'});
						$('.tasks_donut .label.label_bottom_l')
							.attr('data-state', 'undone')
							.attr('data-text', component.locale.undone)
							.html('<b>' + component.sum.undone + '</b> ' + App.format.quantity(component.sum.undone, component.locale.undone_qty));
						$('.tasks_donut .label_top_l').attr('href', component.links.total.done);
					} else {
						$.ajax({url: component.stateURL + '&grid_name=tasks_speed_donut&state=undone'});
						$('.tasks_donut .label.label_bottom_l')
							.attr('data-state', 'done')
							.attr('data-text', component.locale.done)
							.html('<b>' + component.sum.done + '</b> ' + App.format.quantity(component.sum.done, component.locale.done_qty));
						$('.tasks_donut .label_top_l').attr('href', component.links.total.undone);
					}
					self.charts.tasks_speed_donut.reload(state);

					if (text) $('[data-menu-id=' + menu.attr('id') + ']').attr('text', text);
					menu.find('.menu__item').removeClass('menu__item-active');
					menu.find('a[data-text="'+text+'"]').addClass('menu__item-active');

					//$(elem).addClass('menu__item-active');
				},
				onUnloadPage: function () {
					while (this.timeouts.length) {
						clearTimeout(this.timeouts.pop());
					}
				},
			},
			tasks_donuts: {
				component: null,
				timeouts: [],
				init: function() {
					let component = App.core.context.use('dashboard.tasks_donuts');
					if (!component) return;
					this.component = component;
					for (let state of ['undone', 'done']) {
						if (component.demo === 'undone' || component.preview) {
							component.colors.undone.bg[0] = App.colors.css_var('--CHART_DEMO_LIGHT2');
							component.undone = [1];
						}
						if (component.demo === 'done' || component.preview) {
							component.colors.done.bg[0] = App.colors.css_var('--CHART_DEMO_LIGHT2');
							component.done = [1];
						}
						component.datasets = {
							undone: {
								clip: 10,
								labels: component.labels.undone,
								data: component.undone,
								backgroundColor: [
									App.colors.css_var('--CHART_TASK_NODATES'),
									App.colors.css_var('--CHART_TASK_AWAITING'),
									App.colors.css_var('--CHART_TASK_STARTED'),
									App.colors.css_var('--CHART_TASK_COMING'),
									App.colors.css_var('--CHART_TASK_HOT')
								],
								borderWidth: 1,
								borderAlign: 'inner',
								borderColor: App.colors.css_var('--base-cont-top')
							},
							done: {
								clip: 10,
								labels: component.labels.done,
								data: component.done,
								backgroundColor: [
									App.colors.css_var('--CHART_TASK_INTIME'),
									App.colors.css_var('--CHART_TASK_DELAY'),
									App.colors.css_var('--CHART_TASK_NODATES')
								],
								borderWidth: 1,
								borderAlign: 'inner',
								borderColor: App.colors.css_var('--base-cont-top')
							}
						}
						let resetHovers = {};
						let label = '';
						component.chartInner[state] = new Chart(document.getElementById('tasks_donut_inner_' + state), {
							type: 'pie',
							data: {
								datasets: [{
									labels: component.labels.undone,
									data: component[state],
									backgroundColor: state === 'done' ? [App.colors.css_var('--trans'), App.colors.css_var('--trans'), App.colors.css_var('--trans')] :
										[App.colors.css_var('--trans'), App.colors.css_var('--trans'), App.colors.css_var('--trans'), App.colors.css_var('--trans'), App.colors.css_var('--trans')],
									borderColor: App.colors.css_var('--base-cont-top'),
									borderWidth: 1,
									borderAlign: 'inner'
								}]
							},
							options: {
								responsive: true,
								maintainAspectRatio: false,
								plugins: {
									legend: false,
									tooltip: false
								},
								layout: {
									padding: 5
								}
							}
						});
						component.chart[state] = new Chart(document.getElementById('tasks_donut_' + state), {
							type: 'doughnut',
							data: {
								datasets: [state === 'undone' ? component.datasets.undone : component.datasets.done]
							},
							options: {
								cutout: '85%',
								responsive: true,
								maintainAspectRatio: false,
								layout: {
									padding: 0
								},
								plugins: {
									legend: false,
									tooltip: false
								}
							},
							plugins: [{
								afterDraw: chart => {
									if (!component.active) {
										let textWidth;
										let ctx = chart.ctx;
										ctx.font = "bold 30px " + App.colors.css_var('--font-base');
										ctx.fillStyle = App.colors.css_var('--base-txt-primary');
										textWidth = ctx.measureText(component.count ? component.count : component.sum[state]).width;
										ctx.fillText(component.count ? component.count : component.sum[state], chart.chartArea.width / 2 - textWidth / 2, chart.chartArea.height / 2 + 10);
										component.chart[state].data.datasets[0].backgroundColor.forEach(function (value, index) {
											if (Object.keys(resetHovers).length && resetHovers.dataIndex === index) {
												component.chart[state].data.datasets[0].backgroundColor[resetHovers.dataIndex] = resetHovers.hover;
												component.chartInner[state].data.datasets[0].backgroundColor[resetHovers.dataIndex] = resetHovers.inner;
											} else {
												component.chart[state].data.datasets[0].backgroundColor[index] = component.colors[state].bg[index];
												component.chartInner[state].data.datasets[0].backgroundColor[index] = App.colors.css_var('--trans')
											}
										});
									}
								}
							}]
						});
						component.chartHover[state] = new Chart(document.getElementById('tasks_donut_hover_' + state), {
							type: 'pie',
							data: {
								datasets: [{
									labels: component.labels[state],
									data: component[state],
									backgroundColor: App.colors.css_var('--trans'),
									borderColor: App.colors.css_var('--trans'),
									borderWidth: 1,
									borderAlign: 'inner'
								}]
							},
							options: {
								responsive: true,
								maintainAspectRatio: false,
								plugins: {
									legend: false,
									tooltip: component.preview ? false : {
										enabled: false,
										external: function (context) {
											const {chart, tooltip} = context;
											if (state !== component.demo && component.active && tooltip.dataPoints) {
												let dataIndex = tooltip.dataPoints[0].dataIndex;
												if (tooltip.opacity) {
													$('#tasks_donut_hover').css('cursor', !(state === 'undone' && dataIndex === 2) ? 'pointer' : 'default');
													component.count = tooltip.dataPoints[0].parsed;
													label = component.labels[state][dataIndex];
													resetHovers.hover = component.colors[state].hover[dataIndex];
													resetHovers.inner = component.colors[state].inner[dataIndex];
													resetHovers.dataIndex = dataIndex;
												} else {
													$('#tasks_donut_hover').css('cursor', 'default');
													component.count = component.sum[state];
													label = '';
													resetHovers = {};
													component.dataIndex = dataIndex;
												}
											}
										}
									}
								},
								layout: {
									padding: 0
								}
							},
							plugins: [{
								afterDraw: chart => {
									let textWidth;
									let ctx = chart.ctx;
									if (component.active) {
										ctx.font = "normal 14px " + App.colors.css_var('--font-base');
										ctx.fillStyle = App.colors.css_var('--base-txt-tertiary');
										textWidth = ctx.measureText(label).width;
										ctx.fillText(label, chart.chartArea.width / 2 - textWidth / 2, chart.chartArea.height / 2 + 30);
									}
									ctx.font = "bold 30px " + App.colors.css_var('--font-base');
									ctx.fillStyle = App.colors.css_var('--base-txt-primary');
									textWidth = ctx.measureText(component.count ? component.count : component.sum[state]).width;
									ctx.fillText(component.count ? component.count : component.sum[state], chart.chartArea.width / 2 - textWidth / 2, chart.chartArea.height / 2 + 10);
									component.chart[state].data.datasets[0].backgroundColor.forEach(function (value, index) {
										if (Object.keys(resetHovers).length && resetHovers.dataIndex === index) {
											component.chart[state].data.datasets[0].backgroundColor[resetHovers.dataIndex] = resetHovers.hover;
											component.chartInner[state].data.datasets[0].backgroundColor[resetHovers.dataIndex] = resetHovers.inner;
										} else {
											component.chart[state].data.datasets[0].backgroundColor[index] = component.colors[state].bg[index];
											component.chartInner[state].data.datasets[0].backgroundColor[index] = App.colors.css_var('--trans')
										}
									});
									component.chart[state].update();
									component.chartInner[state].update();
								}
							}]
						});
						this.timeouts.push(setTimeout(function () {
							component.active = true;
							document.getElementById('tasks_donut_print').src = component.chart[state].toBase64Image();
						}, 1200));
						$('#tasks_donut_hover').on('click', function () {
							if (App.device.is_mobile() || component.preview || state === component.demo) return false;
							let activePoints = component.chartHover[state].getActiveElements();
							if (activePoints.length && component.links[state][activePoints[0].index]) {
								App.core.goto(component.links[state][activePoints[0].index]);
							}
						});
					}
				},
				onUnloadPage: function () {
					while (this.timeouts.length) {
						clearTimeout(this.timeouts.pop());
					}
				},
			},
			speedometer: {
				defTicks: 15,
				ticks: 15,
				up: true,
				down: true,
				value: '',
				change: 0,
				text_obj: null,
				suggest_obj: null,
				component: null,
				speedUp: function(seconds) {
					let component = self.charts.speedometer;
					if (component.up && component.value < 100) {
						setTimeout(function() {
							component.ticks++;
							component.value += component.change;
							if (component.value > 100) {
								component.ticks = component.defTicks;
								component.value = 100;
							}
							if (component.value === 100) {
								component.suggest_obj.html(App.page.charts.tasksDonut.locale.optimal_speed);
								component.suggest_obj.addClass('act');
							}
							component.text_obj.html(component.value + '%');
							component.lastChange = new Date().getTime() / 1000;
							component.speedUp(seconds);
						}, seconds);
					}
				},
				speedDown: function(seconds) {
					let component = self.charts.speedometer;
					if (component.down && component.value > 0) {
						setTimeout(function() {
							component.ticks++;
							component.value -= component.change;
							if (component.value < component.defaultValue) {
								component.ticks = component.defTicks;
								component.value = component.defaultValue;
							}
							component.text_obj.html(component.value + '%');
							component.lastChange = new Date().getTime() / 1000;
							component.speedDown(seconds);
						}, seconds);
					}
				},
				init: function() {
					let component = self.charts.speedometer;
					component.suggest_obj = $('.block_combine .speedometer .suggest');
					component.defaultValue = parseInt($('.block_combine .speedometer b').html().replace(/%/, ''));
					component.defaultTxt = component.suggest_obj.html();
					$('.block_combine .speedometer').on('mouseover', function(e) {
						if (App.scroll_listener.is_scrolling) return;
						component.text_obj = $(this).find('b');
						let def = component.text_obj.html();
						component.value = parseInt(def.replace(/%/, ''));
						if ((new Date().getTime() / 1000) - component.lastChange > 2) component.ticks = component.defTicks;
						if (component.defaultValue < 100) {
							if (e.type === 'mouseenter') {
								component.change = Math.ceil((100 - component.value) / component.ticks);
								component.up = true;
								component.down = false;
								component.ticks = 0;
								component.speedUp(50);
							} else {
								component.change = Math.ceil(component.value / component.ticks);
								let seconds = component.ticks === component.defTicks ? 100 : 50;
								component.down = true;
								component.up = false;
								component.ticks = 0;
								component.suggest_obj.html(component.defaultTxt);
								component.suggest_obj.removeClass('act');
								component.speedDown(seconds);
							}
						}
					});
				}
			},
			activity: {
				component: null,
				init: function() {
					this.destroy();
					let component = App.core.context.use('dashboard.activity');
					if (!component) return;
					this.component = component;
					component.ctx = document.getElementById('dashboard-activity-canvas').getContext('2d');
					component.height = $('#dashboard-activity-canvas').parent().height();
					component.block = $(component.ctx.canvas).parent().parent();
					component.maxValueOffset = (component.maxValue ? component.maxValue : 3) * 1.2;
					component.gradient = component.ctx.createLinearGradient(
						0, component.height * (component.maxValueOffset - Math.max.apply(null, component.dataset.data)) / component.maxValueOffset,
						0, component.height
					);
					component.gradient.addColorStop(0, component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT3') : App.colors.css_var('--CHART_TASKS_PLAN_BORDER'));
					component.gradient.addColorStop(1, App.colors.css_var('--trans'))
					$.each(component.activity, function (key, value) {
						let weekend = false;
						component.weekend.forEach(function (val) {
							if (value.dayText === val) weekend = true;
						});
						component.ticksColor.push(weekend ? App.colors.css_var('--base-txt-muted') : App.colors.css_var('--base-txt-primary'));
					});

					component.data = {
						labels: component.labels,
						datasets: [{
							clip: 10,
							data: component.dataset.data,
							labelText: component.dataset.labelText,
							pointLabelFontSize: 4,
							fill: true,
							backgroundColor: component.gradient,
							borderColor: component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT3') : App.colors.css_var('--CHART_BLUE_BORDER'),
							borderWidth: 3,
							borderCapStyle: 'round',
							borderJoinStyle: 'round',
							pointRadius: 0,
							pointHitRadius: 3,
							pointHoverRadius: 5,
							pointHoverBorderWidth: 3,
							pointHoverBackgroundColor: App.colors.css_var('--base-cont-top'),
							snapGaps: true
						}]
					}
					component.externalTooltip = (context) => {
						if (App.device.is_mobile()) {
							$('#project-dashboard .tooltip').each(function () {
								$(this).css('opacity', 0);
							});
						}
						const {
							chart,
							tooltip
						} = context;
						if (tooltip && tooltip.dataPoints[0]) {
							let dataIndex = tooltip.dataPoints[0].dataIndex;
							let sidePadding = $(chart.canvas).position().left - $(chart.canvas.parentNode).position().left;
							let tooltipEl = chart.canvas.parentNode.querySelector('div.tooltip');
							if (!tooltipEl) {
								tooltipEl = document.createElement('div');
								tooltipEl.className = 'tooltip dashboardActivityTooltip';
								chart.canvas.parentNode.appendChild(tooltipEl);
							}
							if (tooltip.opacity === 0) {
								tooltipEl.style.opacity = 0;
								return;
							}
							if (tooltip.body) {
								$(tooltipEl).find('.name').html(component.dayValue[dataIndex]);
								$(tooltipEl).find('.body').html('<span class="cnt single">' + component.dataset.data[dataIndex] + '</span> ' + App.format.quantity(component.dataset.data[dataIndex], component.dataset.labelText));

							}

							// Display, position, and set styles for font
							let styleLeft = sidePadding + tooltip.caretX;
							tooltipEl.style.left = (styleLeft + component.block.offset().left > tooltipEl.clientWidth ? styleLeft - tooltipEl.clientWidth : styleLeft) + 'px';
							tooltipEl.style.top = tooltip.caretY - tooltipEl.clientHeight + 'px';
							tooltipEl.style.opacity = 1;
						}
					}
					component.options = {
						scales: {
							x: {
								grid: {
									display: true,
									tickMarkLength: 0,
									drawBorder: false,
									drawTicks: false,
									color: function (context) {
										let weekend = false;
										component.weekend.forEach(function (val) {
											if (context.tick.label === val) weekend = true;
										});
										return weekend ? App.colors.css_var('--CHART_TRANSPARENT') : App.colors.css_var('--CHART_GRID_LINE');
									}
								},
								ticks: {
									color: component.ticksColor,
									padding: 10,
									font: {
										size: 12
									}
								},
								offset: true
							},
							y: {
								grid: {
									display: false,
									drawBorder: false
								},
								ticks: {
									display: false
								},
								beginAtZero: true,
								min: 0,
								max: component.maxValueOffset
							}
						},
						layout: {
							padding: {
								top: 5
							}
						},
						responsive: true,
						maintainAspectRatio: false,
						plugins: {
							legend: false,
							tooltip: component.demo ? false : {
								enabled: false,
								position: 'average',
								yAlign: 'bottom',
								external: component.externalTooltip
							}
						},
						interaction: {
							mode: 'index',
							intersect: false
						}
					}
					component.chart = new Chart(component.ctx, {
						type: 'line',
						data: component.data,
						options: component.options,
						plugins: [{
							afterDraw: (chart) => {
								let ctx = chart.ctx;
								let data = chart.getDatasetMeta(0).data;
								let xTo = data[data.length - 1].x;
								let yToday = data[data.length - 1].y

								ctx.save();
								if (!component.demo && chart.tooltip && chart.tooltip._active && chart.tooltip._active.length) {
									let activePoint = chart.tooltip._active[0];
									ctx.beginPath();
									ctx.setLineDash([6, 5]);
									ctx.moveTo(activePoint.element.x, chart.chartArea.top);
									ctx.lineTo(activePoint.element.x, activePoint.element.y - 5);
									if (chart.chartArea.bottom !== chart.tooltip.caretY) {
										ctx.moveTo(activePoint.element.x, chart.chartArea.bottom);
										ctx.lineTo(activePoint.element.x, activePoint.element.y + 5);
									}
									ctx.lineWidth = 1;
									ctx.strokeStyle = 'grey';
									ctx.stroke();
									ctx.restore();
								}

								// today point
								ctx.fillStyle = component.demo ? App.colors.css_var('--CHART_DEMO_LIGHT3') : App.colors.css_var('--CHART_BLUE_BORDER');
								ctx.beginPath();
								ctx.arc(xTo, yToday, 7, 0, 2 * Math.PI);
								ctx.fill();
								ctx.beginPath();
								ctx.fillStyle = App.colors.css_var('--base-cont-top');
								ctx.arc(xTo, yToday, 4, 0, 2 * Math.PI);
								ctx.fill();
							}
						}]
					});
					$('#dashboard-activity-canvas').on('click', function () {
						if (App.device.is_mobile()) return;
						App.modal.show({
							url: App.helper.url.add_query(App.helper.endpoint.ajax(App.current_page.project), App.actions.get(self.type + ':activity_chart') + (component.demo ? '&demo=1' : '')),
							width: 1200,
							title: ' ',
							group: 'chart'
						});
					});
				},
				destroy: function () {
					this.component?.chart?.destroy();
				}
			}
		},

		people: {
			search: {
				container: '#dashboard-people .searchInput',
				list: '#dashboard-people .people_row .people_scroll',
				item: '.people_item',
				apply: function(el) {
					$(self.people.search.list).find('.emptyStateGlobal').hide();
					App.context_search.configurable.apply(el, self.people.search.list, {
						group_selector: self.people.search.item,
						group_title_selector: '.people_text',
						group_hidden_class: 'hidden',
					});
					if ($(self.people.search.list).width() < $(self.people.search.list).parent().width()) $('#dashboard-people .people_button').hide();
					if ($(self.people.search.list).find('.people_item:not(.hidden)').length === 0) $(self.people.search.list).find('.emptyStateGlobal').show();
				},
				clear: function() {
					let inp = $(self.people.search.container).find('.search_fld');
					inp.val('').trigger('keyup');
				}
			},
		},

		update_visibility: function () {
			self.motto.update_overflow();
		},

		onLoadPage: function () {
			App.bus.window.on('resize', function () {
				if (App.page.charts && App.page.charts.tasksByUser) App.page.charts.tasksByUser.mobile = !!App.device.is_mobile();
				if (App.page.charts && App.page.charts.tasksByStage) App.page.charts.tasksByStage.mobile = !!App.device.is_mobile();
			});

			self.daily_overview.onLoadPage();
		},
		onUnloadPage: function () {
			self.type = '';

			self.daily_overview.onUnloadPage();

			Object.keys(self.charts).forEach(key => {
				const chart = self.charts[key];
				const fn = chart?.onUnloadPage;
				if (typeof fn === 'function') fn.call(chart);
			});
		}
	}
})();

;(function() {
	let self = App.controls.datatable = {
		debug: false,
		obj: null,
		obj_head: null,
		obj_body: null,
		tableObjData: {
			obj: null,
			paddingLeft: 0,
			paddingTop: 0
		},
		wrapper: null,
		wrapperClass: 'dataTable__wrapper',
		resizeObserver: null,
		massInited: false,
		isResize: false,
		isLoaded: false,
		currentX: 0,
		currentY: 0,
		autoColumnMinWidth: 384,
		columnMinWidth: 40,
		columnPlusWidth: 50,
		columnHeight: 40,
		columnMainMobilePercent: 0.7,
		columnMainMobilePercentMin: 0.4,
		columnMobilePercent: 0.4,
		columnMobileLoaded: false,
		shadowsTimeoutMS: 0,
		trFirstID: 0,
		trCoords: {},
		trCoordsById: {},
		thFakeObj: null,
		config: {},
		clickCounter: 0,
		order: {
			fixed: 'fixed_order',
			relevant: 'relevant_order',
			surname: 'by_surname',
			team: 'by_team',
			asc: 'asc',
			desc: 'desc',
			time: 'by_time',
			money: 'by_money',
			name: 'by_name',
			backlogTop: 'backlog_top',
			backlogBottom: 'backlog_bottom',
			none: 'none'
		},
		rowsOrder: null,
		// init default datatable options
		init_config_default: function() {
			self.config = {
				disableColumnsAutoWidth: false,
				disableColumnsSameGroup: false,
				disableHalfColumnsLimitation: false,
				enableRowDragging: false,
				enableManualOrdering: false,
				enableUseRealColumnWidthIfHasSpace: false,
				enableColumnDragging: !App.device.is_mobile(),
				enableColumnWidthDragging: !App.device.is_mobile(),
				enableContainerSwipper: !App.device.is_mobile(),
			};
		},
		getObj: function() {
			if (!self.obj || !self.obj.length) return $('.dataTable');
			return self.obj;
		},
		getObjBody: function() {
			if (!self.obj_body || !self.obj_body.length) return $('.dataTable tbody');
			return self.obj_body;
		},
		getObjHead: function() {
			if (!self.obj_head || !self.obj_head.length) return $('.dataTable thead tr:not(.dataTable__head-hidden)');
			return self.obj_head;
		},
		// datatable init function
		init: function (config) {
			config ||= {};
			self.init_config_default();
			if ('disableColumnsSameGroup' in config) self.config.disableColumnsSameGroup = config.disableColumnsSameGroup;
			if ('disableColumnsAutoWidth' in config) self.config.disableColumnsAutoWidth = config.disableColumnsAutoWidth;
			if ('disableHalfColumnsLimitation' in config) self.config.disableHalfColumnsLimitation = config.disableHalfColumnsLimitation;
			if ('enableRowDragging' in config && !App.device.is_mobile()) self.config.enableRowDragging = config.enableRowDragging;
			if ('enableManualOrdering' in config && !App.device.is_mobile()) self.config.enableManualOrdering = config.enableManualOrdering;
			if ('enableColumnDragging' in config && !App.device.is_mobile()) self.config.enableColumnDragging = config.enableColumnDragging;
			if ('enableColumnWidthDragging' in config && !App.device.is_mobile()) self.config.enableColumnWidthDragging = config.enableColumnWidthDragging;
			if ('enableContainerSwipper' in config && !App.device.is_mobile()) self.config.enableContainerSwipper = config.enableContainerSwipper;
			if ('enableUseRealColumnWidthIfHasSpace' in config) self.config.enableUseRealColumnWidthIfHasSpace = config.enableUseRealColumnWidthIfHasSpace;

			self.rowsOrder = null;
			self.rowDragger.inited = false;
			self.obj = self.getObj();
			self.obj_body = self.getObjBody();
			if (!self.obj.length) return;
			self.wrapper = self.obj.find('.' + self.wrapperClass);
			self.tableObjData.obj = self.wrapper.find('table');
			self.tableObjData.paddingLeft = (self.obj.innerWidth() - self.wrapper.innerWidth()) + ($('#content').innerWidth() - self.obj.innerWidth());
			if (App.device.is_mobile()) self.tableObjData.paddingLeft /= 2;
			self.tableObjData.paddingTop = self.obj.innerHeight() - self.wrapper.innerHeight();
			self.calibrate_header();
			self.tableObjData.obj.show();
			self.scrollBar.init();
			self.columnDragger.init();
			self.widthDragger.init();
			self.containerSwipper.init();
			self.customize_menu.btn_init();
			self.customize_menu.init();
			self.init_th_menu();
			self.init_mass();
			self.interactive_cells.init();
			$('body').addClass('withDatatable');

			self.resizeObserver = new ResizeObserver(() => {
				self.isResize = true;
				self.onresize();
			});
			self.resizeObserver.observe(self.obj.get(0));
			self.onresize();

			$(window).bind('mouseup.page touchend.page', function(e) {
				if (self.scrollBar.started) self.scrollBar.started = false;
				if (self.config.enableColumnWidthDragging) self.widthDragger.end();
				if (self.config.enableColumnDragging) self.columnDragger.end(e);
				if (self.config.enableRowDragging) self.rowDragger.end(e);
				if (self.config.enableContainerSwipper) self.containerSwipper.end(e);
			}).bind('mousemove.page touchmove.page', function(e) {
				self.currentX = e.pageX;
				self.currentY = e.pageY;
				if (self.config.enableColumnWidthDragging) self.widthDragger.move(e);
				if (self.config.enableColumnDragging) self.columnDragger.move(e);
				if (self.config.enableRowDragging) self.rowDragger.move(e);
				if (self.config.enableContainerSwipper) self.containerSwipper.move(e);
			});
		},

		onresize: App.helper.debounce(function () {
			self.calibrate(true, true);
		}, 250, true),

		// calibrate all datatable header css-position-features
		calibrate_header: function() {
			self.obj_head = $('.dataTable thead tr:not(.dataTable__head-hidden)');
			let count = self.obj_head.find('th').length;
			self.obj_head.find('th').each(function(index) {
				$(this).css({'z-index': count - index});
				let width = +$(this).attr('data-width');
				if (width) $(this).css({
					minWidth: width,
					width: width
				});
			});
		},
		// calibrate all datatable body css-position-features (column pins, left/right shadows, scrolls) and calculate trcoords use by dragging
		calibrate: function(pinnedUpdate, mainColumnUpdate, headerUpdate) {
			if (!self.obj || !self.obj.length) return;
			let fakeItem = self.obj.find('tr.dataTable__item-fake');
			if (fakeItem && fakeItem.length) {
				if (mainColumnUpdate) self.adaptive_name.check();
				return;
			}
			self.obj_head = $('.dataTable thead tr:not(.dataTable__head-hidden)');
			if (pinnedUpdate || mainColumnUpdate) {
				self.tableObjData.innerHeight = self.obj.innerHeight();
				self.tableObjData.offsetTop = self.obj.offset().top;
				self.tableObjData.offsetLeft = self.obj.offset().left;
			}
			setTimeout(function() {
				if (!self.obj || !self.obj.length) return;
				let i = 1;
				let zIndex = self.obj.find('th[data-name]').length;
				self.obj_head.find('th[data-name]').each(function() {
					// if (!$(this).hasClass('main')) {
					// 	$(this).attr('data-order', i);
					// 	i++;
					// }
					$(this).css({'z-index': zIndex});
					zIndex--;
				});
				if (mainColumnUpdate) self.adaptive_name.check();
				if (headerUpdate) self.calibrate_header();

				self.rowDragger.groupDrag = self.customize_menu.obj.find('.dataTable__menu__row[data-settings-name=group_by]').attr('data-settings-value');
				let subgroupDrag = self.customize_menu.obj.find('.dataTable__menu__row[data-settings-name=subgroup_by]').attr('data-settings-value');
				if (self.rowDragger.groupDrag === self.order.none || subgroupDrag !== self.order.none) self.rowDragger.groupDrag = false;

				let left = parseInt(self.obj_head.find('th.pinned[data-name]:first').attr('data-width')) + (self.obj.find('.td_checkbox').outerWidth() ? self.obj.find('.td_checkbox').outerWidth() : 0);
				self.obj_head.find('th.pinned:not(.main)[data-name]').each(function() {
					self.obj_head.find('th.'+$(this).attr('data-name')+'.pinned').css({left});
					left += parseInt($(this).attr('data-width'));
				});
				if (pinnedUpdate || mainColumnUpdate) {
					let thWidths = {};
					self.trCoords = {};
					self.trCoordsById = {};
					self.emptyGrid.update();
					if (!self.massInited && !self.obj.find('tr td.td_checkbox').length && self.obj.find('thead th.th_checkbox').length) {
						self.massInited = true;
						self.obj.find('thead .th_checkbox').remove();
					}
					self.obj_head.find('th').each(function() {
						if ($(this).attr('data-name')) thWidths[$(this).attr('data-name')] = $(this).attr('data-width');
					});

					self.obj.find('tr').each(function() {
						let pinned = $(this).find('.pinned[data-name]').first();
						let left = self.obj.find('.td_checkbox').outerWidth() ? self.obj.find('.td_checkbox').outerWidth() : 0;

						self.obj.cssDelayed(pinned, {left});
						while (pinned.next().hasClass('pinned')) {
							left += parseInt(thWidths[pinned.attr('data-name')]);
							pinned = pinned.next();
							self.obj.cssDelayed(pinned, {left});
						}
						if (self.config.enableRowDragging) {
							if ($(this).hasClass('dataTable__item') && $(this).attr('data-id')) {
								let level = $(this).attr('class').match(/dataTable__item-realLevel(\d)/) ? parseInt($(this).attr('class').match(/dataTable__item-realLevel(\d)/)[1]) : 0;
								let id = $(this).attr('data-id');
								self.trCoordsById[id] = {
									id: id,
									startY: parseFloat($(this).offset().top) + self.get_scroll_offset_top(),
									endY: parseFloat($(this).offset().top) + self.get_scroll_offset_top() + parseFloat($(this).outerHeight())
								}
								self.trCoordsById[id].level = level;
								self.trCoordsById[id].hasChild = $(this).next().hasClass('dataTable__item-child') && $(this).next().hasClass('dataTable__item-realLevel' + (level+1));
								self.trCoords[(parseInt($(this).offset().top) + self.get_scroll_offset_top()).toString().slice(0, -1)] = self.trCoordsById[id];
								self.trCoordsById[id].obj = $(this);
							}
							if (self.rowDragger.groupDrag) {
								if ($(this).hasClass('dataTable__group') && $(this).attr('data-group-id')) {
									let id = 'group_' + $(this).attr('data-group-id');
									self.trCoordsById[id] = {
										id: id,
										startY: parseFloat($(this).offset().top) + self.get_scroll_offset_top() + 20,
										endY: parseFloat($(this).offset().top) + self.get_scroll_offset_top() + parseFloat($(this).outerHeight()),
										isGroup: true
									}
									self.trCoords[(parseInt($(this).offset().top) + self.get_scroll_offset_top() + 20).toString().slice(0, -1)] = self.trCoordsById[id];
									self.trCoordsById[id].obj = $(this);
								}
							}
						}
					});
					self.obj.applyCssDelayed(true);
					if (App.device.is_mobile()) {
						self.tableObjData.thWidths = [];
						let tmp = self.obj_head.find('th:not(.main)[data-name]');
						let sum = 0;
						tmp.each(function() {
							if ($(this).attr('data-name')) {
								sum += parseFloat($(this).outerWidth());
								self.tableObjData.thWidths.push(sum);
							}
						});
					}
					if (self.config.enableRowDragging) {
						if (self.rowDragger.started) self.rowDragger.objSlider.css({
							'top': self.trCoordsById[self.rowDragger.id].startY - self.get_scroll_offset_top()
						});
						self.rowDragger.init();
					}
					self.init_th_sorting();
				}
				self.scrollBar.obj.update();
				self.shadows_reload(true);
				self.interactive_cells.update();
			}, 0);
			self.scrollBar.calculateStartEndX();
		},
		// calculate auto-width of main column if adaptive_name feature enabled
		adaptive_name: {
			skip: false,
			check: function() {
				try {
					if (self.adaptive_name.skip) {
						self.adaptive_name.skip = false;
						return false;
					}
					let adaptiveObj = self.customize_menu.obj.find('#dataTable-groups-options div[data-settings-name=adaptive_name]');
					if (self.config.disableColumnsAutoWidth || (adaptiveObj.length && !parseInt(adaptiveObj.attr('data-settings-value')))) return false;
					self.adaptive_name.func();
				} finally {
					if (!self.isLoaded) {
						if (self.lastBaseUrl && self.lastScrollY && App.page.url.base === self.lastBaseUrl) {
							self.scrollBar.zone.scrollTo({top: parseInt(self.lastScrollY)});
						}
						setTimeout(function() {self.obj.removeClass('dataTable-none');}, 300);
						self.isLoaded = true;
					}
				}
			},
			func: function() {
				let tmpWidth = 0,
					tmpWidthMax = 0,
					columnWidth = 0,
					allColumnsWidth = 0,
					allPinnedColumnsWidth = 0,
					mainTh = self.obj_head.find('th.main'),
					tableWidth = self.tableObjData.obj.outerWidth(),
					wrapperWidth = self.wrapper.outerWidth(),
					halfWidth = Math.floor(self.config.disableHalfColumnsLimitation ? (wrapperWidth - 150) : wrapperWidth / 2),
					thCheckboxWidth = self.obj_head.find('th.th_checkbox').outerWidth() || 0,
					plusWidth = self.obj_head.find('th.plus').length ? self.columnPlusWidth : 0,
					isHorizontalScroll = Math.round(tableWidth) > Math.round(wrapperWidth);
				if (wrapperWidth > tableWidth) tableWidth = wrapperWidth;

				if (!App.device.is_mobile()) {
					allColumnsWidth += thCheckboxWidth;
					self.obj_head.find('th[data-name]').each(function() {
						allColumnsWidth += $(this).hasClass('collapsed') ? 32 : parseInt($(this).attr('data-width'));
						if (!$(this).hasClass('main') && $(this).hasClass('pinned')) allPinnedColumnsWidth += parseInt($(this).attr('data-width'));
					});
					if (isHorizontalScroll && mainTh.attr('data-width') <= halfWidth && !parseInt(mainTh.attr('data-width-real'))) {
						mainTh.attr('data-width-real', mainTh.attr('data-width'));
						tmpWidthMax = wrapperWidth - plusWidth - thCheckboxWidth - allPinnedColumnsWidth - 100;
						tmpWidthMax = halfWidth > tmpWidthMax ? tmpWidthMax : halfWidth;
						mainTh.attr('data-width-max', tmpWidthMax);
						return false;
					}
					if (self.config.enableUseRealColumnWidthIfHasSpace && parseInt(mainTh.attr('data-width-real')) && Math.floor(tableWidth - allColumnsWidth) > plusWidth) {
						tmpWidth = parseInt(mainTh.attr('data-width-real'))
					} else if (Math.floor(tableWidth - allColumnsWidth) > plusWidth) {
						tmpWidth = tableWidth - plusWidth - (allColumnsWidth - parseInt(mainTh.attr('data-width')));
						tmpWidth = tmpWidth > halfWidth ? halfWidth : tmpWidth;
					} else if (Math.floor(tableWidth - allColumnsWidth) <= plusWidth) {
						tmpWidth = wrapperWidth - plusWidth - (allColumnsWidth - parseInt(mainTh.attr('data-width')));
						tmpWidth = tmpWidth > halfWidth ? halfWidth : tmpWidth;
						if (!plusWidth) mainTh.attr('data-width-min', isHorizontalScroll ? Math.max(tmpWidth - (Math.round(tableWidth) - Math.round(wrapperWidth)), 200) : tmpWidth);
					} else if (mainTh.attr('data-width') > halfWidth) {
						tmpWidth = halfWidth;
					}
					if (tmpWidth <= Math.floor(wrapperWidth / 4)) tmpWidth = Math.floor(wrapperWidth / 4);
					if (tmpWidth <= mainTh.attr('data-width-min')) tmpWidth = mainTh.attr('data-width-min');
					if (plusWidth && tmpWidth <= mainTh.attr('data-width') && tmpWidth <= self.autoColumnMinWidth) tmpWidth = self.autoColumnMinWidth;
					if (mainTh.hasClass('manual-width') && (tableWidth - wrapperWidth === 0 && tableWidth - allColumnsWidth === 0 || plusWidth === self.columnPlusWidth)) {
						mainTh.attr('data-width-max', halfWidth);
						return false;
					}
				} else {
					halfWidth = tmpWidth = Math.floor(self.obj.innerWidth() * self.columnMainMobilePercent);
					columnWidth = Math.floor(self.obj.innerWidth() * self.columnMobilePercent);
					self.scrollBar.objShadowLineLeft.data('force-shadow', Boolean(
						App.device.is_mobile() && self.columnMainMobilePercent === self.columnMainMobilePercentMin
					));
				}
				if (tmpWidth) {
					if (!parseInt(mainTh.attr('data-width-real'))) mainTh.attr('data-width-real', mainTh.attr('data-width'));
					if (!plusWidth) mainTh.attr('data-width-min', isHorizontalScroll ? Math.max(tmpWidth - (Math.round(tableWidth) - Math.round(wrapperWidth)), 200) : tmpWidth);
					mainTh.one('transitionrun transitionstart', () => self.tableObjData.obj.data('hasTransition', true));
					mainTh.one('transitionend transitioncancel', () => {
						self.tableObjData.obj.data('hasTransition', false)
						self.shadows_reload(true);
					});
					mainTh.attr('data-width', tmpWidth).attr('data-width-max', halfWidth).css({
						'width': tmpWidth,
						'min-width': tmpWidth
					});
					if (!self.columnMobileLoaded && columnWidth) {
						self.columnMobileLoaded = true;
						self.obj_head.find('th:not(.main):not(.plus)[data-name]').each(function () {
							if (parseInt($(this).attr('data-width')) !== self.columnMinWidth) {
								$(this).attr('data-width', columnWidth).attr('data-width-max', columnWidth).css({
									'width': columnWidth,
									'min-width': columnWidth
								});
							}
						});
					}
				}
			}
		},
		// change table left-right shadows display/none state
		shadows_reload: function(isDraw) {
			let timeout = self.shadowsTimeoutMS ?? 0;
			let pinnedLast = self.obj_head.find('th.pinned[data-name]:last');
			let plus = self.obj_head.find('th.plus');
			setTimeout(function() {
				if (!self.obj || !self.obj.length) return;
				if (isDraw) self.shadows_pinned_draw();
				if (!self.widthDragger.started) {
					if (App.device.is_mobile() && App.swipe.components.mobile_datatable_horizontal.disable) return false;
					if (self.scrollBar.obj.scrollbarXWidth && (self.scrollBar.obj.scrollbarXLeft > 1 || self.scrollBar.objShadowLineLeft.data('force-shadow'))) {
						self.scrollBar.objShadowLineLeft.addClass('dataTable__shadowLine-active');
						pinnedLast.addClass('pinned-shadow pinned-shadow-left');
					} else if (self.scrollBar.obj.scrollbarXLeft <= 1 || !self.scrollBar.obj.scrollbarXWidth) {
						self.scrollBar.objShadowLineLeft.removeClass('dataTable__shadowLine-active');
						pinnedLast.removeClass('pinned-shadow pinned-shadow-left');
					}
					if (self.scrollBar.objShadowLineRight) {
						if (self.scrollBar.obj.scrollbarXWidth && self.scrollBar.scrollBarXRight() > 1) {
							self.scrollBar.objShadowLineRight.addClass('dataTable__shadowLine-active');
							plus.addClass('pinned-shadow pinned-shadow-right');
						} else if (self.scrollBar.scrollBarXRight() <= 1 || !self.scrollBar.obj.scrollbarXWidth) {
							self.scrollBar.objShadowLineRight.removeClass('dataTable__shadowLine-active');
							plus.removeClass('pinned-shadow pinned-shadow-right');
						}
					}
				}
			}, timeout ?? 0);
			self.shadowsTimeoutMS = 0;
		},
		shadows_remove: function() {
			self.scrollBar.objShadowLineLeft.removeClass('dataTable__shadowLine-active');
			if (self.scrollBar.objShadowLineRight) self.scrollBar.objShadowLineRight.removeClass('dataTable__shadowLine-active');
			self.obj_head.find('th.pinned[data-name]:last').removeClass('pinned-shadow pinned-shadow-left');
			self.obj_head.find('th.plus').removeClass('pinned-shadow pinned-shadow-right');
		},
		shadows_pinned_draw: function() {
			let left = self.obj_head.find('th.pinned[data-name]:first').outerWidth() + (self.obj.find('.td_checkbox').outerWidth() ? self.obj.find('.td_checkbox').outerWidth() : 0);
			self.obj_head.find('th.pinned:not(.main)[data-name]').each(function() {
				left += $(this).outerWidth();
			});
			let plus = self.obj_head.find('th.plus');
			let mainTh = self.obj_head.find('th.main');
			let shadowHeight = self.tableObjData.obj.innerHeight() < self.tableObjData.innerHeight ? self.tableObjData.obj.innerHeight() : self.tableObjData.innerHeight - self.tableObjData.paddingTop;

			self.scrollBar.objShadowLineLeft.css({
				marginTop: mainTh.outerHeight(),
				left: left + self.tableObjData.paddingLeft,
				height: shadowHeight - mainTh.outerHeight()
			});
			if (self.scrollBar.objShadowLineRight && plus.length) {
				self.scrollBar.objShadowLineRight.css({
					marginTop: mainTh.outerHeight(),
					right: plus.outerWidth(),
					height: shadowHeight - mainTh.outerHeight()
				});
			}
		},
		// expand column feature
		expand_th: function(el) {
			let data = {};
			let th = $(el).closest('th');
			let menu = $('#dataTable-column-'+th.attr('data-name')+'-menu');
			let menuItem = menu.find('.menu__item[data-collapse]');

			th.attr('data-collapsed', 0);
			menuItem.find('span.in').html(menuItem.attr('data-collapse-text'));
			menuItem.find('ws-icon').attr('name', menuItem.attr('data-collapse-icon'));
			self.obj_head.find('th.'+menu.attr('data-name')).add(self.obj.find('td.td_'+menu.attr('data-name'))).removeClass('collapsed');
			th.find('ws-icon[name="arrows/chevron_expand_sm-turn"]').remove();
			self.calibrate(false, true);

			data['column_name'] = menu.attr('data-name');
			data['column_collapsed'] = 0;
			self.customize_menu.btn_disable();
			self.customize_menu.save(data);
		},
		// datatable mass functions init
		init_mass: function() {
			// TODO: ref .act seems to be useless within items
			if ('init_mass' in App.page) return; // custom processing by active page

			self.obj.on('click ws_click', 'input.mass', function (e, e_original) {
				console.log('CLICK');
				if (e.type === 'ws_click') {
					this.checked = !this.checked;
				}
				e = e_original || e;
				if (App.mass.is_after_action()) {
					if (!e.shiftKey) {
						App.page.mass.update_menu(true);
						this.checked = true;
					}
					App.mass.clear_action();
				}
				e.stopPropagation();
				let item = $(this).closest('tr');
				if (!this.checked) {
					item.removeClass('dataTable__item-active');
					App.mass.range.start = 0;
				} else {
					if (e.shiftKey && App.mass.range.start) {
						App.mass.range.end = this.value;
						let in_range = false;
						let items_range = $('.dataTable__item').not('.dataTable__item-hidden');
						items_range.find('input.mass').each(function () {
							if (this.value === App.mass.range.start || this.value === App.mass.range.end) in_range = !in_range;
							if (in_range || this.value === App.mass.range.end) $(this).toggleChecked(true).closest('tr').addClass('dataTable__item-active');
						});
					} else {
						item.addClass('dataTable__item-active');
						// App.effects.fly_to_mass(item);
					}
					App.mass.range.start = this.value;
				}

				$('input.mass_all').trigger('child_click');
				if (e.shiftKey && App.mass.range.start) {
					$('.dataTable__group, .dataTable__subgroup').trigger('child_click');
				} else {
					item.prevAll('.dataTable__group').eq(0).trigger('child_click');
					item.prevAll('.dataTable__subgroup').eq(0).trigger('child_click');
				}
				App.page.mass.update_menu();
			});
			self.obj.on('click', 'input.mass_subgroup', function () {
				if (App.mass.is_after_action()) {
					App.page.mass.update_menu(true);
					App.mass.clear_action();
				}
				App.mass.range.start = 0;
				let subgroup = $(this).closest('tr');
				let items = subgroup.nextUntil(':not(.dataTable__item)').not('.dataTable__item-hidden');
				if (this.checked) {
					subgroup.addClass('dataTable__subgroup-active');
					items.addClass('dataTable__item-active').find('input.mass').toggleChecked(true);
				} else {
					subgroup.removeClass('dataTable__subgroup-active');
					items.removeClass('dataTable__item-active').find('input.mass').toggleChecked(false);
				}
				$('input.mass_all').trigger('child_click');
				subgroup.prevAll('.dataTable__group').eq(0).trigger('child_click');
				App.page.mass.update_menu();
			});
			self.obj.on('child_click', '.dataTable__subgroup', function () {
				let subgroup = $(this);
				let items = subgroup.nextUntil(':not(.dataTable__item)').not('.dataTable__item-hidden');
				let items_active = items.filter('.dataTable__item-active');
				if (items_active.length === 0) {
					subgroup.removeClass('dataTable__subgroup-active').find('input.mass_subgroup').toggleChecked(false);
				} else if (items_active.length === items.length) {
					subgroup.addClass('dataTable__subgroup-active').find('input.mass_subgroup').toggleChecked(true);
				} else {
					subgroup.removeClass('dataTable__subgroup-active').find('input.mass_subgroup').toggleChecked('indeterminate');
				}
			});
			self.obj.on('click ws_click', 'input.mass_group', function (e) {
				if (e.type === 'ws_click') {
					this.checked = !this.checked;
				}
				if (App.mass.is_after_action()) {
					App.page.mass.update_menu(true);
					App.mass.clear_action();
				}
				App.mass.range.start = 0;
				let group = $(this).closest('tr');
				let items = group.nextUntil('.dataTable__group').filter('.dataTable__item').not('.dataTable__item-hidden');
				let subgroups = group.nextUntil('.dataTable__group').filter('.dataTable__subgroup');
				if (this.checked) {
					group.addClass('dataTable__group-active');
					items.addClass('dataTable__item-active').find('input.mass').toggleChecked(true);
					subgroups.addClass('dataTable__subgroup-active').find('input.mass_subgroup').toggleChecked(true);
				} else {
					group.removeClass('dataTable__group-active');
					items.removeClass('dataTable__item-active').find('input.mass').toggleChecked(false);
					subgroups.removeClass('dataTable__subgroup-active').find('input.mass_subgroup').toggleChecked(false);
				}
				$('input.mass_all').trigger('child_click');
				App.page.mass.update_menu();
			});
			self.obj.on('child_click', '.dataTable__group', function () {
				let group = $(this);
				let items = group.nextUntil('.dataTable__group').filter('.dataTable__item').not('.dataTable__item-hidden');
				let items_active = items.filter('.dataTable__item-active');
				if (items_active.length === 0) {
					group.removeClass('dataTable__group-active').find('input.mass_group').toggleChecked(false);
				} else if (items_active.length === items.length) {
					group.addClass('dataTable__group-active').find('input.mass_group').toggleChecked(true);
				} else {
					group.removeClass('dataTable__group-active').find('input.mass_group').toggleChecked('indeterminate');
				}
			});
			self.obj.on('click ws_click', 'input.mass_all', function (e) {
				if (e.type === 'ws_click') {
					this.checked = !this.checked;
				}
				if (App.mass.is_after_action()) {
					App.page.mass.update_menu(true);
					App.mass.clear_action();
				}
				App.mass.range.start = 0;
				let items = $('.dataTable__item').not('.dataTable__item-hidden');
				let groups = $('.dataTable__group');
				let subgroups = $('.dataTable__subgroup');
				if (this.checked) {
					items.addClass('dataTable__item-active').find('input.mass').toggleChecked(true);
					groups.addClass('dataTable__group-active').find('input.mass_group').toggleChecked(true);
					subgroups.addClass('dataTable__subgroup-active').find('input.mass_subgroup').toggleChecked(true);
				} else {
					items.removeClass('dataTable__item-active').find('input.mass').toggleChecked(false);
					groups.removeClass('dataTable__group-active').find('input.mass_group').toggleChecked(false);
					subgroups.removeClass('dataTable__subgroup-active').find('input.mass_subgroup').toggleChecked(false);
					$(this).toggleChecked(false);
					$(this).parent().removeClass('act');
				}
				App.page.mass.update_menu();
			}).on('child_click', 'input.mass_all', function () {
				let items = $('.dataTable__item').not('.dataTable__item-hidden');
				let items_active = items.filter('.dataTable__item-active');
				if (items_active.length === 0) {
					$(this).toggleChecked(false).parent().removeClass('act');
				} else if (items_active.length === items.length) {
					$(this).toggleChecked(true).parent().addClass('act');
				} else {
					$(this).toggleChecked('indeterminate').parent().removeClass('act');
				}
			});
		},
		th_menu: function(event) {
			if (self.widthDragger.started || $(event.target).hasClass('widthDraggerSlider')) return false;

			let me = this;
			let widthDraggerDblclick = self.widthDragger.dblclick;
			self.clickCounter++;
			setTimeout(function() {self.clickCounter = 0}, 200);
			setTimeout(function() {
				if (event.type === 'click' && (self.clickCounter > 1 || $(me).outerWidth() !== self.columnMinWidth)
					&& !$(event.target).parents().addBack().is('.columnChevron') || widthDraggerDblclick) return false;
				let th = $(me).prop('tagName') === 'TH' ? $(me) : $(me).closest('th');
				if (self.customize_menu.reloading || parseInt(th.attr('data-collapsed'))) return false;
				let menuId = 'dataTable-column-' + th.attr('data-name') + '-menu';
				let menu = $('#' + menuId);
				let name = th.attr('data-name');
				let firstTh, lastTh;
				menu.find('.menu__item[data-route]').removeClass('menu__item-disabled');
				if (menu.find('a[data-route]').length) {
					if (th.hasClass('pinned')) {
						firstTh = self.obj_head.find('th.pinned:not(.main)[data-name]:first');
						lastTh = self.obj_head.find('th.pinned:not(.main)[data-name]:last');
					} else {
						firstTh = self.obj_head.find('th:not(.pinned)[data-name]:first');
						lastTh = self.obj_head.find('th:not(.pinned)[data-name]:last');
					}

					if (firstTh.length && lastTh.length) {
						if (name === firstTh.attr('data-name')) {
							menu.find('a[data-route=left]').addClass('menu__item-disabled');
							menu.find('a[data-route=start]').addClass('menu__item-disabled');
						}
						if (name === lastTh.attr('data-name')) {
							menu.find('a[data-route=right]').addClass('menu__item-disabled');
							menu.find('a[data-route=end]').addClass('menu__item-disabled');
						}
					}
				}
				App.menu.show({
					anchor: th.get(0),
					box: '#' + menuId
				});
			}, 100);

			return false;
		},
		init_th_menu: function() {
			self.obj_head.find('th:not(.main)[data-name] .columnChevron ws-btn').bind('click', self.th_menu);
			self.obj_head.find('th:not(.main)[data-name]').bind('click dblclick', self.th_menu);
			self.obj.find('[id*=dataTable-column-] .menu__item[data-hide]').bind('click', function() {
				if ($(this).hasClass('menu__item-disabled')) return false;
				let menu = $(this).closest('.menu');
				self.obj_head.find('th.'+menu.attr('data-name'))
					.add(self.obj.find('td.td_'+menu.attr('data-name'))).animate({opacity: 0.5}, 200);
				setTimeout(function() {
					self.api.remove_col(menu.attr('data-name'));
				}, 200);

				let data = {};
				data['column_name'] = menu.attr('data-name');
				data['column_pinned'] = 0;
				data['column_order'] = 0;
				self.customize_menu.btn_disable();
				self.customize_menu.save(data, true);
				App.menu.hide();
			});
			self.obj.find('[id*=dataTable-column-] .menu__item[data-collapse]').bind('click', function() {
				if ($(this).hasClass('menu__item-disabled')) return false;
				let data = {};
				let menu = $(this).closest('.menu');
				let th = self.obj_head.find('th[data-name='+menu.attr('data-name')+']');

				data['column_name'] = menu.attr('data-name');
				data['column_collapsed'] = (parseInt(th.attr('data-collapsed')) ? 0 : 1);
				self.customize_menu.btn_disable();
				self.customize_menu.save(data);

				if (parseInt(th.attr('data-collapsed'))) {
					th.attr('data-collapsed', 0);
					$(this).find('span.in').html($(this).attr('data-collapse-text'));
					$(this).find('ws-icon').attr('name', $(this).attr('data-collapse-icon'));
					self.obj_head.find('th.'+menu.attr('data-name'))
						.add(self.obj.find('td.td_'+menu.attr('data-name'))).removeClass('collapsed');
					th.find('ws-icon[name="arrows/chevron_expand_sm-turn"]').remove();
				} else {
					th.attr('data-collapsed', 1);
					$(this).find('span.in').html($(this).attr('data-expand-text'));
					$(this).find('ws-icon').attr('name', $(this).attr('data-expand-icon'));
					self.obj_head.find('th.'+menu.attr('data-name'))
						.add(self.obj.find('td.td_'+menu.attr('data-name'))).addClass('collapsed');
					$('<ws-icon name="arrows/chevron_expand_sm-turn" onclick="App.controls.datatable.expand_th(this);"></ws-icon>').appendTo(th);
				}
				self.calibrate(false, true);
				App.menu.hide();
			});
			self.obj.find('[id*=dataTable-column-] .menu__item[data-pin]').bind('click', function() {
				let menu = $(this).closest('.menu');
				let name = menu.attr('data-name');

				$.ajax({
					type: 'POST',
					url: App.helper.endpoint.ajax() + '?'
						+ App.actions.get('common_datatable:save_config_pinned')
						+ '&page=' + App.current_page.page
						+ '&column_name=' + name
						+ '&column_pinned=' + parseInt($(this).attr('data-pin')),
					success: function() {
						App.core.reload();
					}
				});
				App.menu.hide();
			});
			self.obj.find('[id*=dataTable-column-] .menu__item[data-route]').bind('click', function() {
				let orderNew, orderOld, firstTh, lastTh, nameOld, nameNew;
				let route = $(this).attr('data-route');
				let menu = $(this).closest('.menu[data-name]');
				let mainTh = self.obj_head.find('th[data-name=' + menu.attr('data-name') + ']');
				nameOld = menu.attr('data-name');
				orderOld = parseInt(mainTh.attr('data-order'));
				if (mainTh.hasClass('pinned')) {
					firstTh = self.obj_head.find('th.pinned:not(.main)[data-name]:first');
					lastTh = self.obj_head.find('th.pinned:not(.main)[data-name]:last');
				} else {
					firstTh = self.obj_head.find('th:not(.pinned)[data-name]:first');
					lastTh = self.obj_head.find('th:not(.pinned)[data-name]:last');
				}
				if (route === 'right') {
					orderNew = orderOld + 1;
					nameNew = mainTh.next().attr('data-name');
				} else if (route === 'left') {
					orderNew = orderOld - 1;
					nameNew = mainTh.prev().attr('data-name');
				} else if (route === 'start') {
					orderNew = firstTh.attr('data-order');
					nameNew = firstTh.attr('data-name');
				} else if (route === 'end') {
					orderNew = lastTh.attr('data-order');
					nameNew = lastTh.attr('data-name');
				}
				if (orderNew && orderOld) {
					setTimeout(function() {
						if (route === 'right' || route === 'left') {
							self.obj_head.find('th.'+nameOld).add(self.obj.find(`td[data-name="${nameOld}"]`)).each(function() {
								let row = $(this).closest('tr');
								let el = row.find(`th.${nameNew}, td[data-name="${nameNew}"]`);
								el.before($('<div class="dataTable-column-buffer"/>'));
								$(this).before(el);
								row.find('.dataTable-column-buffer').replaceWith($(this));
							});
						} else if (route === 'end' || route === 'start') {
							self.obj_head.find('th.'+nameOld).add(self.obj.find(`td[data-name="${nameOld}"]`)).each(function() {
								let row = $(this).closest('tr');
								let elTo = row.find(`th.${nameNew}, td[data-name="${nameNew}"]`)
								let elFrom = $(this);
								if (route === 'end') {
									elTo.after(elFrom);
								} else {
									elTo.before(elFrom);
								}
							});
						}
					}, 0);

					let data = {};
					data['column_name'] = nameOld;
					data['column_order_new'] = orderNew;
					data['column_order_old'] = orderOld;
					self.customize_menu.btn_disable();
					self.customize_menu.save(data, true);
					self.calibrate(mainTh.hasClass('pinned'));
				}
				App.menu.hide();
			});
		},
		init_th_sorting: function(withoutTh) {
			if (!withoutTh) {
				self.obj_head.find('th .in.sorted').each(function() {
					$(this).removeClass('sorted');
					$(this).find('.columnSorting').remove();
				});
			}
			self.customize_menu.obj.find('.dataTable__menu__columns ws-btn.sorted').removeAttr('right-icon').removeAttr('right-icon-box');
			if (self.rowsOrder) {
				if (!withoutTh) {
					let th = self.obj_head.find('th[data-name='+self.rowsOrder+']');
					if (th.length) {
						let tmp = $('<div class="columnSorting"><ws-icon name="arrows/arrow_circle_sm-up"></ws-icon><ws-icon name="arrows/arrow_circle_sm-down"></ws-icon></div>');
						tmp.addClass(App.filter.desc ? 'columnSorting-desc' : 'columnSorting-asc');
						th.find('.widthDraggerSlider').before(tmp);
						th.find('.in').addClass('sorted');
					}
				}
				let menuBtn = self.customize_menu.obj.find('.dataTable__menu__columns ws-btn[data-column-name='+ self.rowsOrder +']');
				if (menuBtn.length) {
					menuBtn.addClass('sorted');
					menuBtn.attr('right-icon', App.filter.desc ? 'arrows/arrow_circle_sm-up' : 'arrows/arrow_circle_sm-down');
					menuBtn.attr('right-icon-box', 'small');
				}
			}
		},
		helper_group_collapse: function(el) {
			$(el).toggleClass('space-expand-on');
			let is_on = $(el).hasClass('space-expand-on');
			let group = $(el).closest('.dataTable__subgroup, .dataTable__group');

			$.ajax({
				type: 'POST',
				url: App.helper.endpoint.ajax() + '?'
					+ App.actions.get('common_datatable:save_collapse')
					+ '&page=' + App.current_page.page
					+ '&is_on=' + (is_on ? 1 : 0)
					+ '&id_group=' + (group.hasClass('dataTable__subgroup') ? group.attr('data-group-id') + '_' + group.attr('data-group-sub-id') : group.attr('data-group-id'))
			});

			if (group.hasClass('dataTable__subgroup')) {
				group.nextUntil(':not(.dataTable__item)').toggleClass('dataTable__item-collapsedSub', !is_on);
			} else {
				group.nextUntil('.dataTable__group').filter('.dataTable__item').toggleClass('dataTable__item-collapsed', !is_on);
				group.nextUntil('.dataTable__group').filter('.dataTable__subgroup').toggleClass('dataTable__subgroup-collapsed', !is_on);
			}
		},
		get_scroll_offset_left: function() {
			return Math.round(self.tableObjData.offsetLeft + self.tableObjData.paddingLeft - self.tableObjData.obj.offset().left);
		},
		get_scroll_offset_top: function() {
			return Math.round(self.tableObjData.offsetTop - self.tableObjData.obj.offset().top);
		},
		// main datatable customize menu implementation
		customize_menu: {
			obj: null,
			opened: false,
			reloading: false,
			switchers: ['hierarchy', 'empty_groups', 'adaptive_name', 'split_labels'],
			order_to_column_map: {},
			update_split_labels_visibility() {
				let groupsOptionsObj = self.customize_menu.obj.find('#dataTable-groups-options');
				let switcher = groupsOptionsObj.find('div[data-settings-name=split_labels]');
				if (!switcher.length) return;

				let labelsBtn = self.customize_menu.obj.find('.dataTable__menu__columns ws-btn[data-column-name=labels]');
				let labelsEnabled = labelsBtn.length ? !!parseInt(labelsBtn.attr('data-column-enabled')) : false;
				let splitOn = !!parseInt(switcher.attr('data-settings-value'));

				switcher.toggleClass('none', !labelsEnabled && !splitOn);

				let counter = 0;
				self.customize_menu.switchers.forEach(function(val) {
					if (groupsOptionsObj.find('div[data-settings-name=' + val + '].none').length) counter++;
				});

				groupsOptionsObj.toggleClass('menu__group-hidden', counter === self.customize_menu.switchers.length);

			},
			init: function() {
				self.customize_menu.obj = self.customize_menu.get_obj();
				if (self.customize_menu.obj.length) {
					self.customize_menu.obj.find('.dataTable__menu__row .menu__submenuWrapper-click .menu__item').bind('click', function() {
						if ($(this).hasClass('menu__item-disabled')) return false;
						let row = $(this).closest('.dataTable__menu__row');
						let rowNext = row.next();
						let rowType = row.attr('data-settings-name');
						let tmpGroup, tmpNext;
						let oldGroupID = row.parent().find('.dataTable__menu__row[data-settings-name=group_by]').attr('data-settings-value');
						let oldSubgroupID = row.parent().find('.dataTable__menu__row[data-settings-name=subgroup_by]').attr('data-settings-value');
						$(this).closest('.menu__submenuWrapper-click').find('button span').html($(this).find('span').html());
						self.customize_menu.toggle_edited(row, 1);
						row.attr('data-settings-value', $(this).attr('data-value'));
						let groupID = row.parent().find('.dataTable__menu__row[data-settings-name=group_by]').attr('data-settings-value');
						let subgroupID = row.parent().find('.dataTable__menu__row[data-settings-name=subgroup_by]').attr('data-settings-value');

						if (rowType === 'group_by') {
							tmpNext = row.next();
							if (tmpNext.attr('data-settings-name') === 'group_by_order') {
								tmpNext.find('.menu__group').addClass('menu__group-hidden');
								tmpGroup = tmpNext.find('.menu__group[data-group-id="'+groupID+'"]');
								tmpGroup.removeClass('menu__group-hidden');
								if (!tmpGroup.find('.menu__item-active').length) tmpGroup.find('.menu__item').first().addClass('menu__item-active');
								tmpNext.find('ws-btn span').html(tmpNext.find('.menu__group:not(.menu__group-hidden) .menu__item-active span').html());
								tmpNext.attr('data-settings-value', tmpNext.find('.menu__group:not(.menu__group-hidden) .menu__item-active').attr('data-value'));
								tmpNext = tmpNext.next();
							}
							if (tmpNext.attr('data-settings-name') === 'subgroup_by') {
								tmpNext.find('.menu__group').addClass('menu__group-hidden');
								tmpGroup = tmpNext.find('.menu__group[data-group-id="'+groupID+'"]');
								tmpGroup.removeClass('menu__group-hidden');
								if (!tmpNext.next().hasClass('dataTable__menu__row-none') && tmpGroup.find('.menu__item-active').attr('data-value') === self.order.none) tmpGroup.find('.menu__item').removeClass('menu__item-active');
								if (!tmpGroup.find('.menu__item-active').length) tmpGroup.find('.menu__item').first().addClass('menu__item-active');
								subgroupID = tmpNext.find('.menu__group:not(.menu__group-hidden) .menu__item-active').attr('data-value');
								tmpNext.find('ws-btn span').html(tmpNext.find('.menu__group:not(.menu__group-hidden) .menu__item-active span').html());
								tmpNext.attr('data-settings-value', subgroupID);
								const groupItems = tmpNext.find('.menu__group:not(.menu__group-hidden) .menu__item');
								if (groupItems.length === 1 && groupItems.attr('data-type') == self.order.none) {
									tmpNext.hide();
								} else {
									tmpNext.css('display', '');
								}
								tmpNext = tmpNext.next();
								if (tmpNext.attr('data-settings-name') === 'subgroup_by_order') {
									tmpNext.find('.menu__group').addClass('menu__group-hidden');
									tmpGroup = tmpNext.find('.menu__group[data-group-id="'+(groupID + ':' + subgroupID)+'"]');
									tmpGroup.removeClass('menu__group-hidden');
									if (!tmpGroup.find('.menu__item-active').length) tmpGroup.find('.menu__item').first().addClass('menu__item-active');
									tmpNext.find('ws-btn span').html(tmpNext.find('.menu__group:not(.menu__group-hidden) .menu__item-active span').html());
									tmpNext.attr('data-settings-value', tmpNext.find('.menu__group:not(.menu__group-hidden) .menu__item-active').attr('data-value'));
								}
							}
						} else if (rowType === 'subgroup_by') {
							if ($(this).attr('data-value') === self.order.none) {
								row.find('.menu__group-hidden .menu__item').removeClass('menu__item-active');
								row.find('.menu__group-hidden .menu__item[data-value="'+self.order.none+'"]').addClass('menu__item-active');
							}
							tmpNext = row.next();
							if (tmpNext.attr('data-settings-name') === 'subgroup_by_order') {
								tmpNext.find('.menu__group').addClass('menu__group-hidden');
								tmpGroup = tmpNext.find('.menu__group[data-group-id="'+(groupID + ':' + subgroupID)+'"]');
								tmpGroup.removeClass('menu__group-hidden');
								if (!tmpGroup.find('.menu__item-active').length) tmpGroup.find('.menu__item').first().addClass('menu__item-active');
								tmpNext.find('ws-btn span').html(tmpNext.find('.menu__group:not(.menu__group-hidden) .menu__item-active span').html());
								tmpNext.attr('data-settings-value', tmpNext.find('.menu__group:not(.menu__group-hidden) .menu__item-active').attr('data-value'));
							}
						}
						$(this).closest('.menu__group').find('.menu__item').removeClass('menu__item-active');
						$(this).addClass('menu__item-active');
						row.find('ws-btn span').html(row.find('.menu__group:not(.menu__group-hidden) .menu__item-active span').html());
						row.attr('data-settings-value', row.find('.menu__group:not(.menu__group-hidden) .menu__item-active').attr('data-value'));

						if (row.attr('data-hidder')) {
							if ($(this).attr('data-value') === self.order.none) {
								row.find('.menu__submenuWrapper-click ws-btn .btn-left-icon').hide();
								while (rowNext.hasClass('dataTable__menu__row')) {
									rowNext.addClass('dataTable__menu__row-none');
									if (rowNext.attr('data-hidder')) {
										rowNext.find('.menu__item[data-value="'+self.order.none+'"]').trigger('click');
									}
									rowNext = rowNext.next();
								}
							} else if (rowType === 'group_by' && rowNext.next().attr('data-settings-value') === self.order.none
								&& !rowNext.next().next().hasClass('dataTable__menu__row-none')) {
								rowNext.next().find('.menu__item[data-value="'+self.order.none+'"]').trigger('click');
							} else {
								row.find('.menu__submenuWrapper-click ws-btn .btn-left-icon').show();
								while (rowNext.hasClass('dataTable__menu__row')) {
									rowNext.removeClass('dataTable__menu__row-none');
									if (rowNext.attr('data-hidder') && rowNext.attr('data-settings-value') === self.order.none) break;
									rowNext = rowNext.next();
								}
							}
						}
						if (row.parent().find('.dataTable__menu__row[data-settings-name=group_by]').attr('data-settings-value') === self.order.none) {
							self.customize_menu.obj.find('.dataTable__menu__columns ws-btn[data-column-name='+oldGroupID+']').addClass('setting-before-none');
							self.customize_menu.obj.find('.dataTable__menu__columns ws-btn[data-column-name='+oldSubgroupID+']').addClass('setting-before-none');
						} else if (row.parent().find('.dataTable__menu__row[data-settings-name=subgroup_by]').attr('data-settings-value') === self.order.none) {
							self.customize_menu.obj.find('.dataTable__menu__columns ws-btn[data-column-name='+oldSubgroupID+']').addClass('setting-before-none');
						}


						if (App.menu.obj_window && App.menu.obj_window.attr('class').indexOf('menu-secondary') !== -1) App.menu.hide();
						self.customize_menu.configure(true);
					});
					self.customize_menu.obj.find('.dataTable__menu__columns ws-btn').bind('click', function() {
						if ($(this).attr('name').indexOf('btn-disabled') !== -1) return false;
						let enabled = $(this).attr('data-column-enabled');
						let name = $(this).attr('name');

						if ($(this).attr('data-feature-reason')) return false;

						if (name.indexOf('btn-add-column') !== -1) {
							const id_project = $(this).attr('data-id-project').toInt(),
								id_inst = $(this).attr('data-id-inst').toInt();

							App.controls.custom_fields.show_add_menu(this, id_project, id_inst, {
								backup: true,
								callback: function(id_field) {
									if (!id_field) return;

									self.customize_menu.save_button_click(false, true, {
										columns: { ['custom_field__' + id_field]: '1' }
									});
								}
							});
							return false;
						}
						self.customize_menu.toggle_edited(this);

						if (parseInt(enabled)) {
							$(this).attr('data-column-enabled', 0);
							name = name.replace('btn-b', 'btn-g');
							name = name.replace('btn-fill', 'btn-skeleton');
						} else {
							$(this).attr('data-column-enabled', 1);
							name = name.replace('btn-g', 'btn-b');
							name = name.replace('btn-skeleton', 'btn-fill');
						}
						$(this).attr('name', name);
						self.customize_menu.toggle_btn_ok_visibility();
						if ($(this).attr('data-column-name') === 'labels') {
							self.customize_menu.update_split_labels_visibility();
						}
					});
					self.customize_menu.bind_switchers_clicks(self.customize_menu.obj.find('.dataTable__menu__row-switchers div'));
					self.customize_menu.bind_save_button_click(self.customize_menu.obj.find('#dataTable__menu-ok'));
					const customizeMenuReal = self.customize_menu.obj.get(0);
					customizeMenuReal.addEventListener('update:selectedTemplate', ({detail}) => {
						self.customize_menu.toggle_btn_ok_visibility()
					});
					// self.customize_menu.obj.find('#dataTable__menu-reset').bind('click', function() {
					// 	App.controls.confirm.menu(this, {
					// 		message: $(this).attr('data-confirm-text'),
					// 		backup: true,
					// 		on_confirm: function() {
					// 			self.customize_menu.obj.find('[data-edited=1]').removeAttr('data-edited');
					// 			App.menu.hide();
					// 			$.ajax({
					// 				type: 'POST',
					// 				url: App.helper.endpoint.ajax() + '?' + App.actions.get('common_datatable:reset_config') + '&page=' + App.current_page.page,
					// 				success: function() {
					// 					App.core.reload();
					// 				}
					// 			});
					// 		}
					// 	});
					// });
					self.customize_menu.configure();
					self.customize_menu.update_split_labels_visibility();
					self.customize_menu.btn_enable();
				}
			},
			toggle_btn_ok_visibility() {
				const btnOk = self.customize_menu.obj.find('#dataTable__menu-ok');
				if (self.customize_menu.is_dirty()) {
					btnOk.attr('name', btnOk.attr('name').replace(' btn-hide', ''));
				} else if (btnOk.attr('name').indexOf('btn-hide') === -1) {
					btnOk.attr('name', btnOk.attr('name') + ' btn-hide');
				}
			},
			is_dirty() {
				return self.customize_menu.get_obj().find('[data-edited=1]:visible').length > 0 ||  self.customize_menu.get_obj().find('input[name="template_id"]').length > 0
			},
			toggle_edited(obj, force) {
				if (force === undefined) {
					$(obj).attr('data-edited', Number.parseInt($(obj).attr('data-edited')) ? 0 : 1);
				} else {
					$(obj).attr('data-edited', Number(force));
				}
				self.customize_menu.obj.get(0).emitEvent('change');
			},
			bind_save_button_click(btn) {
				$(btn).bind('click', function() {
					self.customize_menu.save_button_click(false);
				});
			},
			save_button_click(menu_reload = true, core_reload = true, extend_data) {
				if (self.customize_menu.is_dirty()  || extend_data !== null) {
					self.customize_menu.obj.find('[data-edited=1]').removeAttr('data-edited');
					setTimeout(function() {
						let data = {
							settings: {},
							columns: {}
						}
						self.customize_menu.obj.find('[data-settings-name]').each(function() {
							let name = $(this).attr('data-settings-name');
							data['settings'][name] = $(this).attr('data-settings-value');
						});
						self.customize_menu.obj.find('[data-column-name]').each(function() {
							let name = $(this).attr('data-column-name');
							data['columns'][name] = $(this).attr('data-column-enabled');
						});

						if (extend_data?.columns) data.columns = {...data.columns, ...extend_data.columns};
						if (extend_data?.settings) data.settings = {...data.settings, ...extend_data.settings};
						const selectedTemplate = self.customize_menu.obj.get(0).querySelector('input[name="template_id"]');
						if (selectedTemplate) {
							data['template_id'] = selectedTemplate.value;
							menu_reload = true;
						}

						self.customize_menu.save(data, menu_reload, core_reload);
						const groupID = self.customize_menu.obj.find('.dataTable__menu__row[data-settings-name=group_by]').attr('data-settings-value');
						const subgroupID = self.customize_menu.obj.find('.dataTable__menu__row[data-settings-name=subgroup_by]').attr('data-settings-value');
						const activeSort = $('.menu__item.sort__item.menu__item-active');
						if (activeSort.attr('data-order-name') == groupID || activeSort.attr('data-order-name') == subgroupID) {
							$('.menu__item.sort__item').removeClass('menu__item-disabled')
							activeSort.removeClass('menu__item-active');
							activeSort.addClass('menu__item-disabled');
							$('.menu__item.sort__item:first').trigger('click');
						}
						App.menu.invalidate_cache_by_trigger(App.controls.user_template.construct_menu_cache_trigger())

					}, 0);
				}
				App.menu.hide();
			},
			bind_switchers_clicks(switchers) {
				$(switchers).bind('click', this.process_switcher_click);
			},
			process_switcher_click(e, triggerEvent = true) {
				if ($(e.target).closest('ws-icon[name="hint"]').length) return false;
				let name = $(this).attr('data-settings-name');
				let value = $(this).attr('data-settings-value');
				if (!$(e.target).parents().is('ws-btn')) {
					if ($(this).hasClass('menu__item-checkbox')) {
						$(this).toggleClass('menu__item-active');
					} else {
						$(this).find('span:last-child').toggleClass('sw_act');
					}
				}
				$(this).attr('data-settings-value', parseInt(value) ? 0 : 1);
				self.customize_menu.toggle_edited(this);
				self.customize_menu.toggle_btn_ok_visibility();

				if (name === 'split_labels') {
					let labels = self.customize_menu.obj.find('.dataTable__menu__columns ws-btn[data-column-name=labels]');
					let splitLabels = self.customize_menu.obj.find('.dataTable__menu__columns ws-btn[data-column-name^=labels__]');
					if (parseInt($(this).attr('data-settings-value'))) {
						labels.addClass('ws-utility-hidden');
						splitLabels.removeClass('ws-utility-hidden');
						if (parseInt(labels.attr('data-column-enabled'))) {
							splitLabels.each(function() {
								if (!parseInt($(this).attr('data-column-enabled'))) $(this).trigger('click');
							});
							labels.trigger('click');
						}
					} else {
						let splitLabelsEnabledCount = 0;
						splitLabels.each(function() {
							if (parseInt($(this).attr('data-column-enabled'))) {
								splitLabelsEnabledCount++;
								$(this).trigger('click');
							}
						});
						splitLabels.addClass('ws-utility-hidden');
						labels.removeClass('ws-utility-hidden');
						if (splitLabelsEnabledCount === splitLabels.length) labels.trigger('click');
					}
					self.customize_menu.update_split_labels_visibility();
				}
				self.customize_menu.obj.find('[data-settings-name='+name+']').not(this).each(function() {
					self.customize_menu.process_switcher_click.call(this, e);
				});

				triggerEvent && this.dispatchEvent(new Event('change'));
			},
			configure: function(clicked) {
				let obj;
				let groupsOptionsObj = self.customize_menu.obj.find('#dataTable-groups-options');
				let groupByRow = self.customize_menu.obj.find('.dataTable__menu__row[data-settings-name=group_by]');
				let subgroupByRow = self.customize_menu.obj.find('.dataTable__menu__row[data-settings-name=subgroup_by]');
				let realGroupType = groupByRow.find('.menu__item-active').attr('data-type');
				let realSubgroupType = subgroupByRow.find('.menu__group:not(.menu__group-hidden) .menu__item-active').attr('data-type');
				let hideGroupsOptionsCounter = 0;

				self.customize_menu.switchers.forEach(function(val) {
					let objSwitch = groupsOptionsObj.find('div[data-settings-name='+val+']');
					if (subgroupByRow.find('.menu__group:not(.menu__group-hidden) .menu__item-active').attr('data-' + val.replace('_', '-'))) {
						objSwitch.removeClass('none');
						if (clicked && val === 'hierarchy' && !parseInt(objSwitch.attr('data-settings-value'))) groupsOptionsObj.find('div[data-settings-name='+val+']').trigger('click');
					} else {
						if (parseInt(objSwitch.attr('data-settings-value'))) self.customize_menu.obj.find('.dataTable__menu__row-switchers div[data-settings-name='+val+']').trigger('click');
						hideGroupsOptionsCounter++;
						objSwitch.addClass('none');
					}

				});
				if (hideGroupsOptionsCounter === self.customize_menu.switchers.length) {
					groupsOptionsObj.addClass('menu__group-hidden');
				} else if (groupsOptionsObj.hasClass('menu__group-hidden')) {
					groupsOptionsObj.removeClass('menu__group-hidden');
				}
				if (!self.config.disableColumnsSameGroup) {
					groupByRow.find('.menu__item-active').each(function () {
						let groupType = $(this).attr('data-type');
						obj = self.customize_menu.obj.find('.dataTable__menu__columns ws-btn[data-column-name=' + groupType + ']');
						if (obj.length) {
							//obj.attr('data-column-enabled', 0);
							// let name = obj.attr('name');
							// name = name.replace('btn-b', 'btn-g');
							// name = name.replace('btn-fill', 'btn-skeleton');// + (name.indexOf('btn-disabled') === -1 ? ' btn-disabled' : '');
							// obj.attr('name', name);
							obj.attr('data-title', '#hint-column-grouped');
						}
					});
					groupByRow.find('.menu__item:not(.menu__item-active):not(.menu__item-disabled)').each(function () {
						if ($(this).attr('data-type') !== realGroupType && $(this).attr('data-type') !== realSubgroupType) {
							let tmp = self.customize_menu.obj.find('.dataTable__menu__columns ws-btn[data-column-name=' + $(this).attr('data-type') + ']');
							if (tmp.length) {
								//tmp.attr('name', tmp.attr('name').replace(' btn-disabled', ''));
								tmp.removeAttr('data-title');
							}
						}
					});
					subgroupByRow.find('.menu__item-active').each(function () {
						let subgroupType = $(this).attr('data-type');
						obj = self.customize_menu.obj.find('.dataTable__menu__columns ws-btn[data-column-name=' + subgroupType + ']');
						if (obj.length) {
							// obj.attr('data-column-enabled', 0);
							// let name = obj.attr('name');
							// name = name.replace('btn-b', 'btn-g');
							// name = name.replace('btn-fill', 'btn-skeleton') + (name.indexOf('btn-disabled') === -1 ? ' btn-disabled' : '');
							// obj.attr('name', name);
							obj.attr('data-title', '#hint-column-grouped');
						}
					});
					subgroupByRow.find('.menu__item:not(.menu__item-active):not(.menu__item-disabled)').each(function () {
						if ($(this).attr('data-type') !== realGroupType && $(this).attr('data-type') !== realSubgroupType) {
							let tmp = self.customize_menu.obj.find('.dataTable__menu__columns ws-btn[data-column-name=' + $(this).attr('data-type') + ']');
							if (tmp.length) {
								// tmp.attr('name', tmp.attr('name').replace(' btn-disabled', ''));
								tmp.removeAttr('data-title');
							}
						}
					});
					if (realSubgroupType !== self.order.none) {
						self.customize_menu.obj.find('.dataTable__menu__columns ws-btn[name$=main]')
							.after(self.customize_menu.obj.find('.dataTable__menu__columns ws-btn[data-column-name='+realSubgroupType+']'));
					}
					if (realGroupType !== self.order.none) {
						self.customize_menu.obj.find('.dataTable__menu__columns ws-btn[name$=main]')
							.after(self.customize_menu.obj.find('.dataTable__menu__columns ws-btn[data-column-name='+realGroupType+']'));
					}
				}
				if (realGroupType === self.order.none && realSubgroupType === self.order.none) {
					groupByRow.find('.menu__item').each(function() {
						let tmp = self.customize_menu.obj.find('.dataTable__menu__columns ws-btn[data-column-name='+$(this).attr('data-type')+']');
						if (tmp.length) tmp.attr('name', tmp.attr('name').replace(' btn-disabled', ''));
					});
					subgroupByRow.find('.menu__item').each(function() {
						let tmp = self.customize_menu.obj.find('.dataTable__menu__columns ws-btn[data-column-name='+$(this).attr('data-type')+']');
						if (tmp.length) tmp.attr('name', tmp.attr('name').replace(' btn-disabled', ''));
					});
				}
				if (realGroupType === self.order.none || realSubgroupType === self.order.none) {
					self.customize_menu.obj.find('.dataTable__menu__columns ws-btn.setting-before-none').each(function() {
						$(this).removeClass('setting-before-none');
						$(this).attr('data-column-enabled', 1);
						let name = $(this).attr('name');
						name = name.replace('btn-g', 'btn-b');
						name = name.replace('btn-skeleton', 'btn-fill');
						$(this).attr('name', name);
					});
				}
				self.customize_menu.toggle_btn_ok_visibility();
			},
			save: function(data, menuReload, coreReload) {
				let url = App.helper.endpoint.ajax() + '?' + App.actions.get('common_datatable:save_config');
				data.page = App.current_page.page;

				$.ajax({
					type: 'POST',
					url: url,
					data: data,
					success: function(response = {}) {
						const {new_orders} = response;
						new_orders && self.sync_orders(new_orders)
						self.customize_menu.btn_enable();
						if (menuReload) self.customize_menu.reload();
						if (coreReload) App.core.reload();
					}
				});
			},
			reload: function(callback) {
				App.core.async_task.ajax({
					type: 'POST',
					url: App.helper.endpoint.ajax() + '?' + App.actions.get('common_datatable:customize_menu') + '&page=' + App.current_page.page,
					success: function(html) {
						$('#dataTable__menu').replaceWith($(html));
						self.customize_menu.init();
						self.init_th_sorting(true);
						if (callback) callback();
					}
				});
			},
			btn_disable: function() {
				let settings = $('#dataTable-settings');
				if (settings.length) {
					settings.attr('name', settings.attr('name') + ' btn-disabled');
					self.customize_menu.reloading = true;
				}
			},
			btn_enable: function() {
				let settings = $('#dataTable-settings');
				if (settings.length) {
					settings.attr('name', settings.attr('name').replace(' btn-disabled', ''));
					self.customize_menu.reloading = false;
				}
			},
			btn_init: function() {
				$('#dataTable-settings, .dataTable th.plus ws-btn').bind('click', function() {
					if ($(this).attr('name') && $(this).attr('name').indexOf('btn-disabled') !== -1) return false;
					let menuID = $(this).attr('data-menu-id');
					if ($(this).parents().filter('th.plus').length) {
						$('#' + menuID).find('#dataTable-groups, #dataTable-groups-options').each(function() {
							if (!$(this).hasClass('menu__group-hidden')) $(this).addClass('menu__group-hidden menu__group-hiddenTh');
						});
					} else {
						$('#' + menuID).find('#dataTable-groups, #dataTable-groups-options').each(function() {
							if ($(this).hasClass('menu__group-hidden menu__group-hiddenTh')) $(this).removeClass('menu__group-hiddenTh').removeClass('menu__group-hidden');
						});
					}
					App.menu.show({
						anchor: this,
						box: '#' + menuID,
						onhide: function() {
							if (self.customize_menu.is_dirty()) self.customize_menu.reload();
						},
						onshow: function() {
							let award_btns = $(this).find('.dataTable__menu__columns__body ws-btn[name*=disabled][right-icon*=award]');
							let toggle_award = $(this).find('.dataTable__menu__columns__body ws-btn[name*=toggle_award]');

							if (toggle_award.length === 0) {
								toggle_award = $('<ws-btn name="btn btn-28 btn-g btn-skeleton btn-toggle_award"></ws-btn>');
								toggle_award.attr('text', App.i18n.t('flt_more'));
								toggle_award.on('click', function() {
									toggle_award.addClass('hiddenBlock');
									award_btns.removeClass('hiddenBlock');
								});
								$(this).find('.dataTable__menu__columns__body').append(toggle_award);
							}

							toggle_award.toggleClass('hiddenBlock', award_btns.length === 0);
							award_btns.addClass('hiddenBlock');
						}
					});
				});
			},
			onshow_ordermenu: function() {

				if (!$('#dataTable').length) return;

				const menu = $(this);
				const items = menu.find('.menu__item[data-order-name]');
				const columns = $('#dataTable th[data-name]');

				if (self.debug) console.log('order_to_column_map', App.controls.datatable.customize_menu.order_to_column_map);
				if (self.debug) {
					const s = new Set();
					columns.each((_, th) => { s.add(th.dataset.name); });
					console.log('columns', s);
				}
				items.each((index, item) => {
					const order_name = $(item).data('order-name');
					let column_name_list = App.controls.datatable.customize_menu.order_to_column_map[order_name] ?? order_name;
					column_name_list = Array.isArray(column_name_list) ? column_name_list : [column_name_list];
					const is_enabled = column_name_list.some(
						column_name => columns.filter('[data-name="'+column_name+'"]').length > 0
					);
					if (self.debug) console.log({ order_name, column_name_list, is_enabled });

					const is_estimate_option = ['cnt4', 'cnt5', 'cnt6'].includes(order_name);
					const should_hide_icon = is_estimate_option && !is_enabled;

					const icon = $(item).find('.column_hidden');
					if (is_enabled) {
						icon.remove();
					} else if (!icon.length && !should_hide_icon) {
						$(item).append(`<ws-icon name="${$(item).attr('data-hidden-icon') || 'eye-close'}" class="column_hidden" data-title="${$(item).attr('data-hidden-hint') || App.object_state.locale.hint_column_hidden}"></ws-icon>`);
					}
				});
			},
			get_obj() {
				return $('#dataTable__menu');
			}
		},
		// datatable scrollbar object
		scrollBar: {
			startX: 0,
			endX: 0,
			started: false,
			obj: null,
			objShadowLine: null,
			zone: null,
			init: function() {
				self.scrollBar.started = false;
				self.scrollBar.startX = self.scrollBar.endX = 0;
				self.scrollBar.zone = self.obj.find('.scrollZone').get(0);
				self.scrollBar.obj = App.controls.js_scrollbars.init(self.scrollBar.zone, {
					scrollWidthShift: self.wrapper.width() - self.wrapper.innerWidth(),
					scrollHeightShift: self.wrapper.height() - self.wrapper.innerHeight(),
					hoverZone: false,
					railToParent: true,
				});
				self.scrollBar.zone.addEventListener('ps-scroll-x', function () {
					self.scrollBar.started = true;
					self.shadows_reload();
				});
				self.scrollBar.objShadowLineLeft = $('<div></div>').addClass('dataTable__shadowLine dataTable__shadowLine-left');
				if (!App.device.is_mobile()) self.scrollBar.objShadowLineRight = $('<div></div>').addClass('dataTable__shadowLine dataTable__shadowLine-right');
				self.obj.before(self.scrollBar.objShadowLineLeft);
				if (self.scrollBar.objShadowLineRight) self.obj.before(self.scrollBar.objShadowLineRight);
				self.scrollBar.calculateStartEndX();
			},
			calculateStartEndX: App.helper.debounce(function() {
				if (self.scrollBar?.obj.scrollbarXWidth) {
					self.scrollBar.startX = self.obj_head.find('th.pinned:not(.plus)').last().offset().left + self.obj_head.find('th.pinned:not(.plus)').last().outerWidth();
					let plus = self.obj_head.find('th.plus');
					if (plus.length) {
						self.scrollBar.endX = plus.offset().left;
					} else {
						self.scrollBar.endX = self.obj_head.width();
					}
				}
			}, 50, true),
			scrollBarXRight: function() {
				return self.scrollBar.obj.railXWidth - self.scrollBar.obj.scrollbarXLeft - self.scrollBar.obj.scrollbarXWidth;
			}
		},
		// column width-size change feature
		widthDragger: {
			obj: null,
			objSlider: null,
			objLine: null,
			timeout: null,
			started: false,
			dblclick: false,
			defaultWidth: 0,
			defaultLeft: 0,
			defaultPinnedLeft: 0,
			touchStartX: 0,
			touchEndW: 0,
			widthEnd: 0,
			moveEnd: 0,
			breakMinWidth: null,
			plusCalibrate: false,
			plusCalibrateOffset: 0,
			init: function() {
				if (!self.config.enableColumnWidthDragging) return false;
				self.widthDragger.defaultWidth = self.widthDragger.defaultLeft = self.widthDragger.defaultPinnedLeft = self.widthDragger.touchStartX = self.widthDragger.touchEndW = 0;
				let clicks = 0;

				self.obj.on('mousedown.page touchstart.page', 'th .widthDraggerSlider', function(e) {
				    if (App.mass.is_shown() || App.task_view.is_shown() || App.modal.is_shown() || App.mymenu.is_shown() || App.menu.is_shown()) return false;
					let me = this;
					e.preventDefault();
					clicks++;
					setTimeout(function() {clicks = 0;}, 200);
					self.widthDragger.widthEnd = self.widthDragger.moveEnd = 0;
					self.widthDragger.obj = $(this).closest('th');
					self.widthDragger.defaultPinnedLeft = self.widthDragger.obj.hasClass('pinned') && self.widthDragger.obj.next().hasClass('pinned') ? self.widthDragger.obj.next().position().left - self.get_scroll_offset_left() : 0;
					if (clicks === 2) {
						self.widthDragger.dblclick = true;
						let data = {};
						let width;
						let tmp  = self.obj.find('td.td_' + self.widthDragger.obj.attr('data-name'));
						clicks = 0;
						self.widthDragger.obj.attr('data-width', self.widthDragger.obj.attr('data-width-min'));
						let minWidth = +self.widthDragger.obj.attr('data-width-min');
						self.widthDragger.obj.css({
							width: minWidth,
							minWidth: minWidth
						});
						width = tmp.addClass('auto-width').outerWidth();
						width = Math.ceil(width);
						tmp.removeClass('auto-width');
						if (width >= self.widthDragger.obj.attr('data-width-max')) {
							width = self.widthDragger.obj.attr('data-width-max');
						} else if (width <= self.widthDragger.obj.attr('data-width-min')) {
							width = self.widthDragger.obj.attr('data-width-min');
						}
						self.widthDragger.obj.attr('data-width', width);
						self.widthDragger.obj.css({
							width: width,
							minWidth: width
						});
						self.calibrate(true);
						self.widthDragger.breakMinWidth = false;
						data['column_name'] = self.widthDragger.obj.attr('data-name')
						data['column_width'] = width;
						self.customize_menu.save(data);
						setTimeout(function() {
							self.widthDragger.dblclick = false;
						}, 100);
						return false;
					} else {
						self.widthDragger.started = true;
						self.widthDragger.timeout = setTimeout(function() {
							if (clicks === 1) {
								self.widthDragger.objLine = self.obj.find('.widthDraggerLine');
								self.shadows_remove();
								self.widthDragger.objLine.show();
								self.widthDragger.objLine.css({
									left: ($(me).position().left + self.widthDragger.obj.position().left) + $(me).width() / 2 ,
									top: self.get_scroll_offset_top()
								});
								$('body').addClass('col-resize');
								self.obj.addClass('columnWidthDraggerStarted');
								self.widthDragger.defaultWidth = self.widthDragger.obj.outerWidth();
								self.widthDragger.defaultLeft = self.widthDragger.objLine.position().left + self.get_scroll_offset_left();
								if (e.type !== 'touchstart' && e.which !== 1) return true;
								if (e.type === 'touchstart') e = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e;
								self.widthDragger.touchStartX = e.pageX;
							}
						}, 100);
					}
				});
			},
			move: App.helper.debounce(function(e) {
				if (!self.config.enableColumnWidthDragging) return false;
				if (self.widthDragger.started && self.widthDragger.touchStartX && $(window).width() > 600) {
					let touch = e;
					let maxWidth = (self.widthDragger.obj.attr('data-width-max') ?? 500) - self.widthDragger.defaultWidth;
					let minWidth = (self.widthDragger.obj.attr('data-width-min') ?? 100) - self.widthDragger.defaultWidth;
					if (e.type === 'touchmove') touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e;
					let this_w = touch.pageX - self.widthDragger.touchStartX;
					if (this_w > maxWidth) this_w = maxWidth;
					if (this_w < minWidth) this_w = minWidth;
					let width = this_w < 0 ? self.widthDragger.defaultWidth - Math.abs(this_w) : self.widthDragger.defaultWidth + Math.abs(this_w);

					if ((self.widthDragger.defaultWidth === self.columnMinWidth || self.widthDragger.breakMinWidth) && width > self.columnMinWidth) {
						width = 80;
						self.widthDragger.defaultWidth += self.columnMinWidth;
						self.widthDragger.touchEndW += self.columnMinWidth;
						self.widthDragger.breakMinWidth = false;
					} else if (width > self.columnMinWidth && width < 80) {
						width = self.columnMinWidth;
						self.widthDragger.defaultWidth -= self.columnMinWidth;
						self.widthDragger.touchEndW -= self.columnMinWidth;
						self.widthDragger.breakMinWidth = true;
					}

					maxWidth = (self.widthDragger.obj.attr('data-width-max') ?? 500) - self.widthDragger.defaultWidth;
					minWidth = (self.widthDragger.obj.attr('data-width-min') ?? 100) - self.widthDragger.defaultWidth;
					if (this_w > maxWidth) this_w = maxWidth;
					if (this_w < minWidth) this_w = minWidth;

					self.widthDragger.widthEnd = width;
					self.widthDragger.moveEnd = this_w;
					self.widthDragger.objLine.css({left: self.widthDragger.defaultLeft + self.widthDragger.touchEndW + this_w});
					if (!self.widthDragger.defaultPinnedLeft) {
						self.widthDragger.obj.css({
							width: self.widthDragger.widthEnd,
							minWidth: self.widthDragger.widthEnd
						});
						self.widthDragger.obj.attr('data-width', self.widthDragger.widthEnd);
						if (self.scrollBar.obj.scrollbarXWidth && this_w < 0) {
							if (Math.abs(this_w) >= self.scrollBar.scrollBarXRight()) {
								if (!self.widthDragger.plusCalibrate) self.widthDragger.plusCalibrateOffset = Math.abs(this_w) - 1;
								self.widthDragger.plusCalibrate = true;
								self.obj_head.find('th.plus').css({minWidth: self.columnPlusWidth + Math.abs(this_w) - self.widthDragger.plusCalibrateOffset});
							}
						}
					}
				}
			}, 30, true),
			end: function () {
				if (!self.config.enableColumnWidthDragging) return false;
				if (self.widthDragger.objLine && self.widthDragger.objLine.length) {
					self.widthDragger.objLine.css({'left': '', 'top': ''});
					self.widthDragger.objLine.hide();
					self.widthDragger.objLine = null;
					self.scrollBar.obj.update();
				}
				if (self.widthDragger.started) {
					if (self.widthDragger.timeout) clearTimeout(self.widthDragger.timeout);
					self.widthDragger.started = self.widthDragger.breakMinWidth = false;
					if (self.widthDragger.defaultPinnedLeft && self.widthDragger.widthEnd && $(window).width() > 600) {
						setTimeout(function () {
							self.widthDragger.obj.css({
								width: self.widthDragger.widthEnd,
								minWidth: self.widthDragger.widthEnd
							});
							self.widthDragger.obj.attr('data-width', self.widthDragger.widthEnd);
							if (self.widthDragger.obj.attr('data-width-real')) self.widthDragger.obj.attr('data-width-real', self.widthDragger.widthEnd);
							if (self.scrollBar.obj.scrollbarXWidth && self.widthDragger.moveEnd < 0) {
								if (Math.abs(self.widthDragger.moveEnd) >= self.scrollBar.scrollBarXRight()) {
									if (!self.widthDragger.plusCalibrate) self.widthDragger.plusCalibrateOffset = Math.abs(self.widthDragger.moveEnd) - 1;
									self.widthDragger.plusCalibrate = true;
									self.obj_head.find('th.plus').css({minWidth: self.columnPlusWidth + Math.abs(self.widthDragger.moveEnd) - self.widthDragger.plusCalibrateOffset});
								}
							}
						}, 0);
					}
					self.calibrate(true, !self.widthDragger.obj.hasClass('main'));
					setTimeout(function() {
						$('body').removeClass('col-resize');
						self.obj.removeClass('columnWidthDraggerStarted');
						if ($(window).width() > 600 && self.widthDragger.touchStartX) {
							self.widthDragger.touchStartX = 0;
							self.widthDragger.touchEndW = 0;
							if (self.widthDragger.defaultWidth !== self.widthDragger.obj.outerWidth()) {
								let data = {};
								data['column_name'] = self.widthDragger.obj.attr('data-name')
								data['column_width'] = self.widthDragger.obj.outerWidth();
								self.customize_menu.save(data);
							}
						}
						if (self.widthDragger.plusCalibrate) {
							self.widthDragger.plusCalibrate = false;
							self.obj_head.find('th.plus').css({'min-width': ''});
						}
						self.scrollBar.obj.update();
						self.scrollBar.calculateStartEndX();
						self.widthDragger.obj.addClass('manual-width');
					}, 0);
				}
			},
		},
		// columnn moving, position change feature (press and move)
		columnDragger: {
			obj: null,
			started: false,
			isPinned: false,
			leftPosition: 0,
			startX: 0,
			startY: 0,
			touchOffsetLeftX: 0,
			touchOffsetRightX: 0,
			columnPositionOffsetX: 0,
			hoveredColumnName: null,
			overScrollTimeout: null,
			overScrollOffsetX: 0,
			overScrollIsLeft: false,
			timeout: null,
			thObjs: null,
			thCoords: {},
			init: function() {
				if (!self.config.enableColumnDragging) return false;
				self.columnDragger.timeout = self.columnDragger.thObjs = null;
				self.columnDragger.started = self.columnDragger.isPinned = false;
				self.columnDragger.leftPosition = self.columnDragger.columnPositionOffsetX = self.columnDragger.startX = self.columnDragger.startY = 0;
				self.columnDragger.touchOffsetRightX = self.columnDragger.touchOffsetLeftX = 0;

				self.obj.on('mousedown.page touchstart.page', 'th:not(.main, .plus)[data-name]', function(e) {
					if (App.mass.is_shown() || App.task_view.is_shown() || App.modal.is_shown() || App.mymenu.is_shown() || App.menu.is_shown()) return false;
					let me = $(this);
					if ($(e.target).parents().addBack().is('.columnChevron') || $(e.target).parents().addBack().is('.widthDraggerSlider') || e.button !== 0) return false;
					self.columnDragger.obj = me.clone();
					self.columnDragger.columnPositionOffsetX = me.offset().left - self.obj.offset().left - self.tableObjData.paddingLeft + self.get_scroll_offset_left();
					self.columnDragger.startX = e.pageX;
					self.columnDragger.startY = e.pageY;
					self.columnDragger.isPinned = $(this).hasClass('pinned');
					self.columnDragger.lastColumnObj = self.obj_head.find('th[data-name]').last();
					let plus = self.obj_head.find('th.plus');
					if (plus.length) {
						self.columnDragger.thPlusLeftX = plus.offset().left;
					} else {
						self.columnDragger.thPlusLeftX = self.obj_head.width();
					}

					if (self.columnDragger.timeout) clearTimeout(self.columnDragger.timeout);
					self.columnDragger.timeout = setTimeout(function() {
						if (self.columnDragger.obj
							&& Math.abs(self.columnDragger.startX - self.currentX) < 20
							&& Math.abs(self.columnDragger.startY - self.currentY) < 20 && !App.menu.is_shown()) {
							self.columnDragger.started = true;
							if (me.outerWidth() === self.columnMinWidth) {
								self.columnDragger.obj.find('.columnValue').remove();
								self.columnDragger.obj.find('.columnPin').remove();
							}
							self.columnDragger.obj.find('.columnChevron').remove();
							self.columnDragger.obj.addClass('columnDragger');
							self.columnDragger.obj.find('.in').prepend(('<div class="columnDragIco"><ws-icon name="drag_indicator"></ws-icon></div>'));
							self.columnDragger.obj.css({'position': 'absolute', 'transition': 'none', 'z-index': 99999});
							self.columnDragger.move(e);
							me.addClass('columnDraggerFrom');
							me.parent().before(self.columnDragger.obj);
							self.columnDragger.thObjs = self.obj_head.find(self.columnDragger.isPinned ? 'th.pinned:not(.main, .plus, .columnDragger)[data-name]': 'th:not(.pinned, .columnDragger)[data-name]');
							self.columnDragger.thObjs.each(function() {
								if ($(this).attr('data-name')) {
									self.columnDragger.thCoords[$(this).attr('data-name')] = {
										obj: $(this),
										startX: parseFloat($(this).offset().left),
										endX: parseFloat($(this).offset().left) + parseFloat($(this).outerWidth())
									};
								}
							});
							self.columnDragger.touchOffsetLeftX = e.pageX - self.columnDragger.thCoords[me.attr('data-name')].startX;
							self.columnDragger.touchOffsetRightX = self.columnDragger.thCoords[me.attr('data-name')].endX - e.pageX;
						}
					}, 300);
				});
				$(document).bind('keydown', self.columnDragger.onkeydown);
			},
			move: function(e) {
				if (!self.config.enableColumnDragging) return false;
				if (self.columnDragger.started && self.columnDragger.obj) {
					self.columnDragger.obj.css({
						left: e.pageX + self.columnDragger.columnPositionOffsetX - self.columnDragger.startX,
						top: e.pageY - self.columnDragger.startY
					});
					let lastRightHoveredColumnName;
					for (let columnName in self.columnDragger.thCoords) {
						if (e.pageX < self.columnDragger.startX && (e.pageX - self.columnDragger.touchOffsetLeftX + self.columnDragger.overScrollOffsetX) <= self.columnDragger.thCoords[columnName].startX) {
							if (self.columnDragger.thCoords[columnName].obj.hasClass('columnDraggerHover')) break;
							if (self.columnDragger.hoveredColumnName !== columnName) {
								self.columnDragger.hoveredColumnName = columnName;
								self.columnDragger.thObjs.removeClass('columnDraggerHover');
								if (!self.columnDragger.thCoords[columnName].obj.hasClass('columnDraggerFrom')) {
									self.columnDragger.thCoords[columnName].obj.addClass('columnDraggerHover');
								}
								break;
							}
							if (self.columnDragger.thCoords[columnName].obj.hasClass('columnDraggerFrom')) break;
						} else if (e.pageX + self.columnDragger.overScrollOffsetX >= self.columnDragger.thCoords[columnName].startX
							&& self.columnDragger.thCoords[columnName].startX >= (self.columnDragger.startX - self.columnDragger.touchOffsetLeftX + self.columnDragger.overScrollOffsetX)
							&& (e.pageX + self.columnDragger.touchOffsetRightX + self.columnDragger.overScrollOffsetX) >= self.columnDragger.thCoords[columnName].endX) {
							lastRightHoveredColumnName = columnName;
						}

					}
					if (lastRightHoveredColumnName && self.columnDragger.hoveredColumnName !== lastRightHoveredColumnName) {
						self.columnDragger.hoveredColumnName = lastRightHoveredColumnName;
						self.columnDragger.thObjs.removeClass('columnDraggerHover');
						if (!self.columnDragger.thCoords[lastRightHoveredColumnName].obj.hasClass('columnDraggerFrom')) {
							self.columnDragger.thCoords[lastRightHoveredColumnName].obj.addClass('columnDraggerHover');
						}
					}
					if (!self.columnDragger.obj.hasClass('pinned') && self.columnDragger.thObjs
						&& self.scrollBar.obj.scrollbarXWidth && self.scrollBar.startX && self.scrollBar.endX) {
						setTimeout(() => {
							let diffLeft = self.scrollBar.startX - (e.pageX - self.columnDragger.touchOffsetLeftX);
							let diffRight = e.pageX + self.columnDragger.touchOffsetRightX - self.scrollBar.endX;
							if (self.scrollBar.obj.scrollbarXLeft && diffLeft > 0 || self.scrollBar.scrollBarXRight() && diffRight > 0) {
								if (!self.columnDragger.overScrollTimeout) {
									self.columnDragger.overScrollIsLeft = diffLeft > 0;
									self.columnDragger.overScrollTimeout = setTimeout(self.columnDragger.overScrollFunction, 0);
								}
							} else {
								self.columnDragger.overScrollTimeout = null;
							}
						}, 0);
					}
				}
			},
			overScrollFunction: function() {
				let offset;
				if (!self.config.enableColumnDragging) return false;
				if (self.columnDragger.overScrollIsLeft) {
					offset = -4;
					if (!self.scrollBar.obj.scrollbarXLeft) {
						self.columnDragger.overScrollTimeout = null;
						self.scrollBar.obj.update();
					}
				} else {
					offset = 4;
					if (!self.scrollBar.scrollBarXRight() || self.columnDragger.lastColumnObj.offset().left + self.columnDragger.lastColumnObj.outerWidth() < self.columnDragger.thPlusLeftX + 1) {
						self.columnDragger.overScrollTimeout = null;
						self.scrollBar.obj.update();
					}
				}
				if (self.columnDragger.obj && self.columnDragger.overScrollTimeout) {
					self.columnDragger.overScrollOffsetX += offset;
					self.columnDragger.leftPosition = parseInt(self.columnDragger.obj.css('left').replace(/px/, '')) + offset;
					self.columnDragger.columnPositionOffsetX += offset;
					self.scrollBar.zone.scrollTo({left: self.scrollBar.zone.scrollLeft + offset});
					self.columnDragger.obj.css({left: self.columnDragger.leftPosition});
					self.columnDragger.overScrollTimeout = setTimeout(self.columnDragger.overScrollFunction, 10);
				}
			},
			end: function(e, escape) {
				if (!self.config.enableColumnDragging) return false;
				if (self.columnDragger.obj && self.columnDragger.started) {
					let from = parseInt(self.obj_head.find('th.columnDraggerFrom').attr('data-order')),
						fromName = self.obj_head.find('th.columnDraggerFrom').attr('data-name'),
						to = parseInt(self.obj_head.find('th.columnDraggerHover').attr('data-order')),
						toName = self.obj_head.find('th.columnDraggerHover').attr('data-name'),
						columnName = self.obj_head.find('th.columnDraggerFrom').attr('data-name');

					setTimeout(function() {
						self.obj_head.find('th.'+fromName).add(self.obj.find(`td[data-name="${fromName}"]`)).each(function() {
							if (!$(this).hasClass('columnDragger')) {
								let row = $(this).closest('tr');
								let el = row.find(`th.${toName}, td[data-name="${toName}"]`);
								if (to < from) {
									el.before($(this));
								} else {
									el.after($(this));
								}
							}
						});
					}, 0);
					self.obj_head.find('th.columnDraggerFrom').removeClass('columnDraggerFrom');
					self.columnDragger.thObjs.removeClass('columnDraggerHover');
					self.columnDragger.obj.remove();
					self.columnDragger.thCoords = {};
					if (from && to && from !== to) {
						let data = {};
						data['column_name'] = columnName;
						data['column_order_new'] = to;
						data['column_order_old'] = from;
						self.customize_menu.btn_disable();
						self.customize_menu.save(data, true);
						self.calibrate(self.obj_head.find('th.'+fromName).hasClass('pinned'));
						if (typeof App.page.onColumnsDrag === 'function') App.page.onColumnsDrag(from, to);
						$(document).trigger('datatable.columnsDrag', [from, to]);
					}
					e.preventDefault();
					e.stopPropagation();
				}

				self.columnDragger.overScrollOffsetX = 0;
				self.columnDragger.started = false;
				self.columnDragger.obj = null;
				self.columnDragger.thObjs = null;
				self.columnDragger.hoveredColumnName = null;
			},
			onkeydown: function(e) {
				if (self.config.enableColumnDragging && self.columnDragger.started && e.keyCode === App.keycode.Escape) self.columnDragger.end(e, true);
			},
		},
		// row moving, position change feature (press and move)
		rowDragger: {
			id: 0,
			obj: null,
			objData: {},
			objHovered: null,
			objLine: null,
			objBox: null,
			objSubBox: null,
			objSlider: null,
			objSliderVisible: false,
			objChilds: null,
			objChildsLevel: 0,
			moveData: {},
			timeout: null,
			groupDrag: false,
			inited: false,
			started: false,
			startX: 0,
			startY: 0,
			data: {},
			condition: '',
			maxOfItems: 500,
			mass: false,
			conditionTypes: {
				inside: 'inside',
				bottom: 'bottom',
				top: 'top',
				insideChilds: 'inside-childs',
				bottomChilds: 'bottom-childs',
				groupInside: 'group-inside'
			},
			is_enableRowDragging: function() {
				return self.config.enableRowDragging && self.rowDragger.inited && !self.columnDragger.started && !self.containerSwipper.started && !self.widthDragger.started
					&& !App.task_view.is_shown() && !App.modal.is_shown() && !App.mymenu.is_shown() && !App.menu.is_shown();
			},
			init: function() {
				self.config.enableRowDragging = !(!App.page || !(App.page.hierarchy || self.config.enableManualOrdering || self.rowDragger.groupDrag) || App.current_page.archive) && self.obj.find('tr.dataTable__item').length <= self.rowDragger.maxOfItems;
				if (!self.config.enableRowDragging || self.rowDragger.inited) return false;
				if (!self.wrapper.find('> .rowDragger').length) {
					self.rowDragger.objSlider = $('<div><ws-icon name="drag_indicator"></ws-icon></div>').addClass('rowDragger');
					self.wrapper.parent().prepend(self.rowDragger.objSlider);
				}
				self.rowDragger.inited = true;
				self.tableObjData.innerHeight = self.obj.innerHeight();
				self.tableObjData.offsetTop = self.obj.offset().top;
				self.tableObjData.offsetLeft = self.obj.offset().left;
				self.obj.on('mousedown.page touchstart.page', '.rowDragger', function(e) {
					if (App.task_view.is_shown() || App.modal.is_shown() || App.mymenu.is_shown() || App.menu.is_shown()) return false;
					self.rowDragger.reset();
					self.rowDragger.obj = self.obj.find('tr[data-id='+self.rowDragger.id+']');
					self.rowDragger.objData = {
						childsLevel: self.rowDragger.getChildsLevel(self.rowDragger.obj, self.rowDragger.id),
						checkboxWidth: self.rowDragger.obj.find('td.td_checkbox').outerWidth(),
						spanSpaceWidth: self.rowDragger.obj.find('span.space').outerWidth(),
						nameWidth: self.rowDragger.obj.find('td.td_name').outerWidth()
					}
					self.rowDragger.startX = e.pageX;
					self.rowDragger.startY = e.pageY;
					if (self.rowDragger.timeout) clearTimeout(self.rowDragger.timeout);
					self.rowDragger.timeout = setTimeout(function() {
						if (Math.abs(self.rowDragger.startX - self.currentX) < 10 && Math.abs(self.rowDragger.startY - self.currentY) < 10) {
							self.rowDragger.started = true;
							$('body').addClass('grabbing');
							self.obj.addClass('rowDraggerStarted');
							self.trFirstID = self.obj.find('.dataTable__item:first').not('.dataTable__item-hidden').attr('data-id');
							if (App.mass.is_shown()) {
								self.rowDragger.mass = true;
								self.obj.find('tr.dataTable__item-active').addClass('rowDraggerFrom');
							} else {
								self.rowDragger.obj.addClass('rowDraggerFrom');
								self.rowDragger.objChilds.addClass('rowDraggerFromChild');
							}
							self.rowDragger.objLine = $('<div></div>').addClass('rowDraggerLine');
							self.wrapper.prepend(self.rowDragger.objLine);
							self.rowDragger.objBox = $('<div></div>').addClass('rowDraggerBox');
							self.rowDragger.objSubBox = $('<div></div>').addClass('rowDraggerBox');
							self.wrapper.prepend(self.rowDragger.objBox);
							self.wrapper.prepend(self.rowDragger.objSubBox);
							self.rowDragger.move(e);
						}
					}, 50);
				});
				self.scrollBar.zone.addEventListener('ps-scroll-y', function () {
					if (self.rowDragger.objSliderVisible) {
						self.rowDragger.objSlider.removeClass('rowDragger-visible');
						self.rowDragger.objSliderVisible = false;
					}
				});
				$(document).bind('keydown', self.rowDragger.onkeydown);
			},
			move: function(e) {
				if (!self.rowDragger.started && self.rowDragger.objSliderVisible
					&& (self.containerSwipper.started || self.columnDragger.started || self.widthDragger.started
						|| App.task_view.is_shown() || App.modal.is_shown() || App.mymenu.is_shown() || App.menu.is_shown())) {
					self.rowDragger.objSlider.removeClass('rowDragger-visible');
					self.rowDragger.objSliderVisible = false;
				}
				if (!self.rowDragger.is_enableRowDragging()) return false;
				if (e.pageY >= self.tableObjData.offsetTop + (self.rowDragger.started ? 0 : 30) && e.pageY <= self.tableObjData.offsetTop + self.tableObjData.innerHeight - 10) {
					if (self.rowDragger.started) {
						let dragZone, data, finded, dataID,
							pageY = e.pageY + self.get_scroll_offset_top(),
							tmp = (pageY - self.columnHeight).toString().slice(0, -1);

						for (let i = tmp; i <= parseInt(tmp) + 8; i++) {
							if (self.trCoords[i]) {
								data = self.trCoords[i];
								dataID = data.id;
								data.obj = self.trCoordsById[dataID].obj;
								dragZone = {
									topStart: data.startY - 4 - (dataID === self.trFirstID ? 32 : 0),
									topEnd: data.startY + 4,
									bottomStart: data.endY - 4,
									bottomEnd: data.endY + 4,
									insideStart: data.startY + 5,
									insideEnd: data.endY - 5
								}

								if (dataID === self.trFirstID && pageY >= dragZone.topStart && pageY <= dragZone.topEnd) {
									finded = true;
									if (!Object.keys(self.rowDragger.data).length || self.rowDragger.condition !== self.rowDragger.conditionTypes.top) {
										self.rowDragger.condition = self.rowDragger.conditionTypes.top;
										self.rowDragger.drawTop(data);
										self.rowDragger.action(data);
										break;
									}
								} else if (pageY >= dragZone.insideStart && pageY <= dragZone.insideEnd) {
									if (dataID === self.rowDragger.id) self.rowDragger.resetDraw();
									if (self.rowDragger.groupDrag && data.isGroup) {
										finded = true;
										if (!Object.keys(self.rowDragger.data).length || self.rowDragger.condition !== self.rowDragger.conditionTypes.groupInside) {
											self.rowDragger.condition = self.rowDragger.conditionTypes.groupInside;
											self.rowDragger.drawBottom(data);
											self.rowDragger.action(data);
											break;
										}
									}
									if (!self.rowDragger.isAccess(data) || dataID === self.rowDragger.id || self.rowDragger.groupDrag) continue;
									finded = true;
									if (!data.hasChild) {
										if (!Object.keys(self.rowDragger.data).length || self.rowDragger.data.id !== data.id || self.rowDragger.condition !== self.rowDragger.conditionTypes.inside) {
											self.rowDragger.condition = self.rowDragger.conditionTypes.inside;
											if (data.level === 0) {
												if (App.page.hierarchy) self.rowDragger.drawSelected(data);
												else self.rowDragger.drawBottom(data);
											} else {
												self.rowDragger.drawSelected(data);
												self.rowDragger.drawParentSelected(data, true);
											}
											self.rowDragger.action(data);
											break;
										}
									} else {
										if (!Object.keys(self.rowDragger.data).length || self.rowDragger.data.id !== data.id || self.rowDragger.condition !== self.rowDragger.conditionTypes.insideChilds) {
											self.rowDragger.condition = self.rowDragger.conditionTypes.insideChilds;
											self.rowDragger.drawBottom(data);
											self.rowDragger.drawParentSelected(data);
											self.rowDragger.drawSubParentSelected(data);
											self.rowDragger.action(data);
											break;
										}
									}
								} else if (pageY >= dragZone.bottomStart && pageY <= dragZone.bottomEnd) {
									if (!self.rowDragger.isAccess(data) || data.endY === self.trCoordsById[self.rowDragger.id].startY
										&& data.level === self.trCoordsById[self.rowDragger.id].level || dataID === self.rowDragger.id) continue;
									finded = true;
									if (!data.hasChild || self.rowDragger.groupDrag) {
										if (!Object.keys(self.rowDragger.data).length || self.rowDragger.data.id !== data.id || self.rowDragger.condition !== self.rowDragger.conditionTypes.bottom) {
											self.rowDragger.condition = self.rowDragger.conditionTypes.bottom;
											if (data.level === 0 || self.rowDragger.groupDrag) {
												self.rowDragger.drawBottom(data);
											} else if (data.level === 2) {
												self.rowDragger.drawBottom(data);
												self.rowDragger.drawParentSelected(data);
												self.rowDragger.drawSubParentSelected(data);
											} else {
												self.rowDragger.drawBottom(data);
												self.rowDragger.drawParentSelected(data);
											}
											self.rowDragger.action(data);
											break;
										}
									} else {
										if (!Object.keys(self.rowDragger.data).length || self.rowDragger.data.id !== data.id || self.rowDragger.condition !== self.rowDragger.conditionTypes.bottomChilds) {
											self.rowDragger.condition = self.rowDragger.conditionTypes.bottomChilds;
											self.rowDragger.drawBottom(data);
											self.rowDragger.drawParentSelected(data);
											self.rowDragger.drawSubParentSelected(data);
											self.rowDragger.action(data);
											break;
										}
									}
								}
							}
						}

						if (!finded) {
							self.rowDragger.condition = '';
						}
					} else {
						// move rowdragger slider
						if (e.pageY >= self.tableObjData.offsetTop && e.pageY <= self.tableObjData.offsetTop + self.tableObjData.innerHeight - self.tableObjData.paddingTop) {
							if (e.pageX >= self.tableObjData.offsetLeft) {
								let tmp = (e.pageY + self.get_scroll_offset_top() - self.columnHeight).toString().slice(0, -1);
								for (let i = tmp; i <= parseInt(tmp) + 8; i++) {
									if (self.trCoords[i]) {
										let data = self.trCoords[i];
										let dataID = data.id;
										data.obj = self.trCoordsById[dataID].obj;
										if (dataID !== self.rowDragger.id
											&& e.pageY + self.get_scroll_offset_top() >= data.startY
											&& e.pageY + self.get_scroll_offset_top() < data.endY) {
											self.rowDragger.id = dataID;
											if (self.rowDragger.groupDrag && dataID.indexOf('group_') !== -1
												|| data.endY >self.tableObjData.offsetTop + self.get_scroll_offset_top() + self.tableObjData.innerHeight
												|| App.mass.is_shown() && App.mass.ids['act'] && !App.mass.ids['act'].includes(self.rowDragger.id + ',')) {
												self.rowDragger.objSlider.removeClass('rowDragger-visible');
												self.rowDragger.objSliderVisible = false;
												continue;
											}

											self.rowDragger.objSliderVisible = true;
											self.rowDragger.objSlider.addClass('rowDragger-visible').css({
												left: parseInt(self.tableObjData.offsetLeft) + self.tableObjData.paddingLeft / 2 - 10,
												top: data.startY - self.get_scroll_offset_top()
											});
											break;
										}
									}
								}
							} else if (self.rowDragger.objSliderVisible) {
								self.rowDragger.objSlider.removeClass('rowDragger-visible');
								self.rowDragger.objSliderVisible = false;
							}
						}
					}
					if ($(e.target).parent().hasClass('dataTable__item-empty')) {
						self.rowDragger.objSlider.removeClass('rowDragger-visible');
						self.rowDragger.objSliderVisible = false;
					} else if (self.rowDragger.objSliderVisible) {
						self.rowDragger.objSlider.addClass('rowDragger-visible');
					}
				} else {
					self.rowDragger.condition = '';
					if (!self.rowDragger.started) self.rowDragger.id = 0;
					if (self.rowDragger.objSliderVisible) {
						self.rowDragger.objSlider.removeClass('rowDragger-visible');
						self.rowDragger.objSliderVisible = false;
					}
					if (self.rowDragger.started && !self.rowDragger.overScrollTimeout) {
						self.rowDragger.overScrollTimeout = setTimeout(self.rowDragger.overScrollFunction, 0);
						self.rowDragger.resetDraw();
					}
				}
			},
			overScrollFunction: function() {
				if (!self.rowDragger.is_enableRowDragging()) return false;
				if (self.rowDragger.overScrollTimeout) {
					let next = false;
					if (self.currentY < self.tableObjData.offsetTop + 30) {
						self.scrollBar.zone.scrollTo({top: self.get_scroll_offset_top() - 4});
						next = true;
					} else if (self.currentY > self.tableObjData.offsetTop + self.tableObjData.innerHeight - 30) {
						self.scrollBar.zone.scrollTo({top: self.get_scroll_offset_top() + 4});
						next = true;
					}
					if (next) self.rowDragger.overScrollTimeout = setTimeout(self.rowDragger.overScrollFunction, 10);
				}
			},
			end: function(e, escape) {
				if (!self.rowDragger.is_enableRowDragging()) return false;
				if (self.rowDragger.started) {
					if (!escape && typeof App.page.onRowDrag === 'function') App.page.onRowDrag();
					if (self.rowDragger.mass) {
						self.obj.find('tr.rowDraggerFrom').removeClass('rowDraggerFrom');
						self.rowDragger.mass = false;
					} else {
						self.rowDragger.obj.removeClass('rowDraggerFrom');
						self.rowDragger.objChilds.removeClass('rowDraggerFromChild');
					}
					$('body').removeClass('grabbing');
					self.obj.removeClass('rowDraggerStarted');
					self.rowDragger.reset();
					e.preventDefault();
					e.stopPropagation();
				}
			},
			onkeydown: function(e) {
				if (self.rowDragger.is_enableRowDragging() && self.rowDragger.started && e.keyCode === App.keycode.Escape) self.rowDragger.end(e, true);
			},
			reset: function() {
				self.rowDragger.resetDraw();
				self.rowDragger.started = false;
				if (self.rowDragger.objLine) self.rowDragger.objLine.remove();
				if (self.rowDragger.objBox) self.rowDragger.objBox.remove();
				if (self.rowDragger.objSubBox) self.rowDragger.objSubBox.remove();
				self.rowDragger.startX = self.rowDragger.startY = 0;
				self.rowDragger.obj = null;
				self.rowDragger.objLine = null;
				self.rowDragger.objBox = null;
				self.rowDragger.objSubBox = null;
				self.rowDragger.objData = {};
				self.rowDragger.overScrollTimeout = null;
				self.rowDragger.data = {};
				self.rowDragger.condition = '';
			},
			resetDraw: function() {
				self.rowDragger.moveData = {}
				if (self.rowDragger.objLine) {
					self.rowDragger.objLine.css({width: 0});
					self.rowDragger.objLine.removeClass('rowDraggerLine-error');
				}
				if (self.rowDragger.objBox) {
					self.rowDragger.objBox.css({width: 0});
					self.rowDragger.objBox.removeClass('rowDraggerBox-selected').removeClass('rowDraggerBox-error');
				}
				if (self.rowDragger.objSubBox) {
					self.rowDragger.objSubBox.css({width: 0});
					self.rowDragger.objSubBox.removeClass('rowDraggerBox-selected').removeClass('rowDraggerBox-error');
				}
			},
			isAccess: function(data) {
				let level = self.trCoordsById[self.rowDragger.id].level;

				if (data.startY < (self.tableObjData.offsetTop + self.get_scroll_offset_top() + 30)
				   || App.mass.is_shown() && App.mass.ids['act'].includes(data.id + ',')) return false;

				return !(self.trCoordsById[self.rowDragger.id].hasChild && data.level !== 0 && data.level > level
						&& (self.rowDragger.id === data.obj.attr('data-id-parent') || self.rowDragger.id === data.obj.attr('data-id-parent-top')))
					&& !(level > 0 && self.rowDragger.obj.attr('data-id-parent') === data.id && data.obj.next().attr('data-id') === self.rowDragger.id);
			},
			drawSelected: function(data) {
				let offset = 0;
				self.rowDragger.resetDraw();
				self.rowDragger.data = data;

				if (data.level === 0) offset = self.rowDragger.objData.checkboxWidth + self.rowDragger.objData.spanSpaceWidth + 20;
				if (data.level === 1) offset = self.rowDragger.objData.checkboxWidth + self.rowDragger.objData.spanSpaceWidth * 2 + 30;
				if (data.level === 2) offset = self.rowDragger.objData.checkboxWidth + self.rowDragger.objData.spanSpaceWidth * 2 + 30;

				self.rowDragger.objLine.css({
					width: self.rowDragger.objData.checkboxWidth + self.rowDragger.objData.nameWidth - offset,
					top: data.endY - parseInt(self.tableObjData.offsetTop) - 2,
					left: self.get_scroll_offset_left() + offset
				});
				self.rowDragger.objBox.css({
					width: self.rowDragger.objData.nameWidth + (data.level ? 0 : self.rowDragger.objData.checkboxWidth),
					top: data.endY - parseInt(self.tableObjData.offsetTop) - self.rowDragger.objBox.outerHeight(),
					left: self.get_scroll_offset_left() + (data.level ? self.rowDragger.objData.checkboxWidth : 0)
				});
				if ((data.level + 1) + self.rowDragger.objData.childsLevel > 3) {
					self.rowDragger.objBox.addClass('rowDraggerBox-error');
					self.rowDragger.objLine.addClass('rowDraggerLine-error');
				} else {
					self.rowDragger.objBox.addClass('rowDraggerBox-selected');
				}
			},
			drawParentSelected: function(data, objSubBox) {
				if (self.trCoordsById[data.obj.attr('data-id-parent-top')]
					&& self.trCoordsById[data.obj.attr('data-id-parent-top')].startY <
					(self.tableObjData.offsetTop + self.get_scroll_offset_top() + 30)) return false;

				self.rowDragger.data = data;
				let objBox = objSubBox ? 'objSubBox' : 'objBox';
				let offset = self.rowDragger.condition === self.rowDragger.conditionTypes.bottom ? 1 : 0;
				let width, top, left, cls;
				if ((data.level + 1) + self.rowDragger.objData.childsLevel > 3 + offset) {
					cls = 'rowDraggerBox-error';
					if (data.level === 0) {
						width = self.rowDragger.objData.checkboxWidth + self.rowDragger.objData.nameWidth;
						top = data.endY - parseInt(self.tableObjData.offsetTop) - self.rowDragger[objBox].outerHeight();
						left = 0;
					} else {
						width = self.rowDragger.objData.nameWidth + (self.trCoordsById[data.obj.attr('data-id-parent-top')].level ? 0 : self.rowDragger.objData.checkboxWidth);
						top = self.trCoordsById[data.obj.attr('data-id-parent-top')].endY - parseInt(self.tableObjData.offsetTop) - self.rowDragger[objBox].outerHeight();
						left = (self.trCoordsById[data.obj.attr('data-id-parent-top')].level ? self.rowDragger.objData.checkboxWidth : 0);
					}
				} else {
					cls = 'rowDraggerBox-selected';
					if (data.level === 0) {
						width = self.rowDragger.objData.checkboxWidth + self.rowDragger.objData.nameWidth;
						top = data.endY - parseInt(self.tableObjData.offsetTop) - self.rowDragger[objBox].outerHeight();
						left = 0;
					} else {
						width = self.rowDragger.objData.nameWidth + (self.trCoordsById[data.obj.attr('data-id-parent-top')].level ? 0 : self.rowDragger.objData.checkboxWidth);
						top = self.trCoordsById[data.obj.attr('data-id-parent-top')].endY - parseInt(self.tableObjData.offsetTop) - self.rowDragger[objBox].outerHeight();
						left = (self.trCoordsById[data.obj.attr('data-id-parent-top')].level ? self.rowDragger.objData.checkboxWidth : 0);
					}
				}
				left += self.get_scroll_offset_left();
				self.rowDragger[objBox].css({
					width: width,
					top: top,
					left: left
				}).addClass(cls);
			},
			drawSubParentSelected: function(data) {
				if (self.trCoordsById[data.obj.attr('data-id-parent')] &&
					self.trCoordsById[data.obj.attr('data-id-parent')].startY <
					(self.tableObjData.offsetTop + self.get_scroll_offset_top() + 30)) return false;

				let offset = self.rowDragger.condition === self.rowDragger.conditionTypes.bottom ? 1 : 0;
				let width, top, left, cls;
				if ((data.level + 1) + self.rowDragger.objData.childsLevel > 3 + offset) {
					width = self.rowDragger.objData.nameWidth;
					left = self.rowDragger.objData.checkboxWidth;
					cls = 'rowDraggerBox-error';
					if (data.level === 1) {
						top = data.endY - parseInt(self.tableObjData.offsetTop) - self.rowDragger.objSubBox.outerHeight();
					} else if (data.level === 2) {
						top = self.trCoordsById[data.obj.attr('data-id-parent')].endY - parseInt(self.tableObjData.offsetTop) - self.rowDragger.objSubBox.outerHeight();
					}
				} else {
					width = self.rowDragger.objData.nameWidth;
					left = self.rowDragger.objData.checkboxWidth;
					cls = 'rowDraggerBox-selected';
					if (data.level === 1) {
						top = data.endY - parseInt(self.tableObjData.offsetTop) - self.rowDragger.objSubBox.outerHeight();
					} else if (data.level === 2) {
						top = self.trCoordsById[data.obj.attr('data-id-parent')].endY - parseInt(self.tableObjData.offsetTop) - self.rowDragger.objSubBox.outerHeight();
					}
				}
				left += self.get_scroll_offset_left();
				if (data.level) {
					self.rowDragger.objSubBox.css({
						width: width,
						top: top,
						left: left
					}).addClass(cls);
				}
			},
			drawBottom: function(data) {
				self.rowDragger.resetDraw();
				self.rowDragger.data = data;
				let offset = 0;
				if (self.rowDragger.groupDrag) {
					offset = 0;
				} else if (self.rowDragger.condition === self.rowDragger.conditionTypes.bottomChilds) {
					if (data.level === 0) offset = self.rowDragger.objData.checkboxWidth + self.rowDragger.objData.spanSpaceWidth + 20;
					if (data.level === 1) offset = self.rowDragger.objData.checkboxWidth + self.rowDragger.objData.spanSpaceWidth * 2 + 30;
					if (data.level === 2) offset =self.rowDragger.objData.checkboxWidth + self.rowDragger.objData.spanSpaceWidth * 2 + 30;
				} else if (self.rowDragger.condition === self.rowDragger.conditionTypes.insideChilds) {
					if (data.level === 0) offset = self.rowDragger.objData.checkboxWidth + self.rowDragger.objData.spanSpaceWidth + 20;
					if (data.level === 1) offset = self.rowDragger.objData.checkboxWidth + self.rowDragger.objData.spanSpaceWidth * 2 + 30;
					if (data.level === 2) offset = self.rowDragger.objData.checkboxWidth + self.rowDragger.objData.spanSpaceWidth * 2 + 30;
				} else {
					if (data.level === 1) offset = self.rowDragger.objData.checkboxWidth + self.rowDragger.objData.spanSpaceWidth + 20;
					if (data.level === 2) offset = self.rowDragger.objData.checkboxWidth + self.rowDragger.objData.spanSpaceWidth * 2 + 30;
				}
				self.rowDragger.objLine.css({
					width: self.rowDragger.objData.checkboxWidth + self.rowDragger.objData.nameWidth - offset,
					top: data.endY - parseInt(self.tableObjData.offsetTop) - 2,
					left: self.get_scroll_offset_left() + offset
				});
				offset = self.rowDragger.condition === self.rowDragger.conditionTypes.bottom ? 1 : 0;
				if ((data.level + 1) + self.rowDragger.objData.childsLevel > 3 + offset) {
					self.rowDragger.objLine.addClass('rowDraggerLine-error');
				}
			},
			drawTop: function(data) {
				let offset = 0;
				self.rowDragger.resetDraw();
				self.rowDragger.data = data;
				self.rowDragger.objLine.css({
					width: self.rowDragger.objData.checkboxWidth + self.rowDragger.objData.nameWidth - offset,
					top: data.startY - parseInt(self.tableObjData.offsetTop) - 2,
					left: self.get_scroll_offset_left() + offset
				});
			},
			getChilds: function(obj) {
				let level = self.trCoordsById[obj.attr('data-id')].level;
				return self.trCoordsById[obj.attr('data-id')].hasChild ? self.obj.find('tr[data-id='+obj.attr('data-id')+']').nextUntil('.dataTable__item-level' + level).not('.dataTable__item-level0') : $();
			},
			getChildsLevel: function(obj, id) {
				let tmp = {},
					level = self.trCoordsById[id].level;
				self.rowDragger.objChilds = self.rowDragger.getChilds(obj);
				tmp[level] = 1;
				self.rowDragger.objChilds.each(function() {
					tmp[self.trCoordsById[$(this).attr('data-id')].level + 1] = 1;
				});
				return Object.keys(tmp).length;
			},
			action: function(data) {
				let moveData = {};
				self.rowDragger.overScrollTimeout = null;
				self.rowDragger.actionTimeout = null;
				if (self.rowDragger.condition === self.rowDragger.conditionTypes.inside && data.obj.find('.space-expand-shown').not('.space-expand-on').length) {
					self.rowDragger.actionTimeout = setTimeout(function() {
						if (self.rowDragger.data.id === data.id) {
							App.page.helper_child_collapse(data.obj.find('span.space-expand'), data.id);
						}
					}, 700);
				}
				moveData.idFrom = +self.rowDragger.id;
				moveData.idTo = data.id; // not INT for groups
				moveData.isBefore = self.rowDragger.condition === self.rowDragger.conditionTypes.top;
				moveData.isInside = self.rowDragger.condition !== self.rowDragger.conditionTypes.bottom && !moveData.isBefore;
				self.rowDragger.moveData = moveData;
			}
		},
		// datatable horizontal scroll by press on content, horizontal swipper
		containerSwipper: {
			x: -1,
			y: -1,
			type: -1,
			started: false,
			init: function () {
				if (!self.config.enableContainerSwipper) return false;
				self.containerSwipper.type = self.containerSwipper.x = self.containerSwipper.y = -1;
				self.obj.bind('mousedown.page touchstart.page', function (e) {
					let touch = e;
					if (e.type === 'touchstart') touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e;
					if (App.mass.is_shown() || App.task_view.is_shown() || App.modal.is_shown() || App.mymenu.is_shown() || App.menu.is_shown() || !self.scrollBar.obj.scrollbarXWidth) return true;
					if (e.type !== 'touchstart' && e.which !== 1) return true;
					//if (touch.pageX < self.scrollBar.startX || touch.pageX > self.scrollBar.endX) return true;
					if ($(e.target).parents().addBack().filter('th').length || $(e.target).parents().is('.rowDragger')) return true;
					if ($(e.target).parents('.editable-value.editing').length) return true;
					if ($(e.target).is('input')) return true;

					self.containerSwipper.x = touch.pageX;
					self.containerSwipper.y = touch.pageY;
					self.containerSwipper.type = 1;
					self.containerSwipper.started = true;
				});
			},
			move: function(e) {
				if (!self.config.enableContainerSwipper) return false;
				if (self.containerSwipper.started) {
					if (App.modal.is_shown()) return true;
					if (self.containerSwipper.type === -1) return;
					let touch = e;
					if (e.type === 'touchmove') touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e;
					if (Math.abs(self.containerSwipper.x - touch.pageX) < 10) return true;
					self.scrollBar.zone.scrollTo({left: self.scrollBar.zone.scrollLeft + (self.containerSwipper.x - touch.pageX)});
					self.containerSwipper.x = touch.pageX;
					self.containerSwipper.y = touch.pageY;
					App.helper.selection.clear();
					$('body').addClass('grabbing');
					self.obj.addClass('containerSwipperStarted');
				}
			},
			end: function (e) {
				if (!self.config.enableContainerSwipper) return false;
				if (self.containerSwipper.started) {
					$('body').removeClass('grabbing');
					self.containerSwipper.started = false;
					if (App.modal.is_shown() || self.containerSwipper.type === -1) return true;
					self.containerSwipper.x = -1;
					self.containerSwipper.y = -1;
					self.containerSwipper.type = -1;
					self.obj.removeClass('containerSwipperStarted');
					e.preventDefault();
					e.stopPropagation();
				}
			}
		},
		emptyGrid: {
			addClicked: false,
			bind_events: function () {
				const bodyObj = self.getObjBody();
				bodyObj.on('click', 'tr.dataTable__item-empty', function() {
					self.emptyGrid.addClicked = true;
					App.task_grid_create.show($(this));
					setTimeout(function() {
						self.emptyGrid.addClicked = false;
					}, 100);
				});
			},

			update: function(rebuild) {
				if (!self.obj) return;
				const bodyObj = self.getObjBody();

				let remain_height = self.obj.height() - self.getObjHead().outerHeight();
				self.obj.find('.dataTable__item, .dataTable__group, dataTable__subgroup').filter(':visible').not('.dataTable__item-emptyFoot').each(function() {
					remain_height -= $(this).outerHeight();
				})
				let count = Math.floor(remain_height / self.columnHeight);
				if (rebuild) self.obj.find('.dataTable__item-emptyFoot').remove();
				else self.obj.find('.dataTable__item-emptyFoot').each(function() {
					if (count <= 0) $(this).remove();
					count--;
				});
				if (count > 0) {
					for (let i = 0; i < count; i++) {
						bodyObj.append(self.emptyGrid.getItem());
					}
				}
			},
			getItem: function(need) {
				if (App.task_grid_create.obj?.length) {
					const className = 'dataTable__item dataTable__item-empty dataTable__item-level0' + (App.page.allow_add_task ? '  dataTable__item-instead' : '') + (need ? '' : ' dataTable__item-emptyFoot');
					let item = App.task_grid_create.obj.clone().attr('class', className);
					item.find('td').html('');
					return item.show();
				}

				let head = self.getObjHead();
				let item = $('<tr></tr>').attr('class', 'dataTable__item dataTable__item-empty dataTable__item-level0' + (need ? '' : ' dataTable__item-emptyFoot'));
				let html = '';
				head.find('th').each(function() {
					let classes = [];
					['pinned', 'plus', 'side-shadow'].forEach(className => {
						if ($(this).hasClass(className)) classes.push(className);
					});
					const classMap = {
						'th_checkbox': 'td_checkbox',
						'report_time': 'td_report_time',
						'report_money': 'td_report_money'
					};
					for (let key in classMap) {
						if ($(this).hasClass(key)) classes.push(classMap[key]);
					}
					html += '<td'
						+ (classes.length ? ' class="' + classes.join(' ') + '"' : '')
						+ ($(this).attr('data-name') ? ' data-name="'+$(this).attr('data-name')+'"' : '')
						+ '></td>';
				});
				return item.html(html);
			},
			destructor: function() {
				self.emptyGrid.initedCount = 0;
				self.emptyGrid.addClicked = false;
				//self.getObjBody().find('.dataTable__item-empty').remove();
			}
		},
		//TODO: move to separate pages
		interactive_cells: {
			init() {
				self.interactive_cells.editable.init();
				self.interactive_cells.checkboxed.init();
				self.interactive_cells.groups.init();
				self.interactive_cells.cells.init();
			},
			update() {
				self.interactive_cells.checkboxed.update();
				self.interactive_cells.groups.update();
				self.interactive_cells.cells.update();
			},
			editable: {
				init() {
					const objReal = self.obj.get(0);
					objReal.addDelegatedMultipleEventListener(['apply', 'cancel', 'input-ready'], 'ws-editable', function(e, obj) {
						obj.closest('.dataTable__item').toggleClass('dataTable__item--editing', e.type === 'input-ready');
					});
					objReal.addDelegatedEventListener('change-state', 'custom-field', function(e, obj) {
						obj.closest('.dataTable__item').toggleClass('dataTable__item--editing', e.detail.state === 'edit');
					});
				},
			},
			checkboxed: {
				init() {
					self.interactive_cells.checkboxed.update();
				},
				update() {
					const objReal = self.obj.get(0);
					objReal.querySelectorAll('th:has(.inputCheckbox)').toggleClass('th--checkbox', true);
					objReal.querySelectorAll('td:has(.inputCheckbox)').toggleClass('td--checkbox', true);
					objReal.querySelectorAll('.dataTable__group, .dataTable__subgroup').forEach(el => {
						if (el.previousElementSibling && !el.previousElementSibling.matches('.dataTable__group, .dataTable__subgroup')) {
							el.previousElementSibling.toggleClass('dataTable__item--before-group', true);
						}
					});
				}
			},
			cells: {
				init() {
					self.interactive_cells.cells.update();
				},
				update() {
					const objReal = self.obj.get(0);
					objReal.querySelectorAll('th:has(ws-icon[name="subtask"])').addClass('th--subtask');
					objReal.querySelectorAll(
						'td:has(.data-costs-progress-money .over, .data-costs-progress-time .over, .data-tasks-progress-done .over)'
					).addClass('td--over');
					objReal.querySelectorAll('.td_terms').forEach(td => {
						td.toggleClass('td_terms--hot', !!td.querySelector('.hot'));
						td.toggleClass('td_terms--warm', !!td.querySelector('.warm'));
						td.toggleClass('td_terms--today', !!td.querySelector('.today'));
					});
					objReal.querySelectorAll('td:not(.td_name) > div.in[onclick], td:not(.td_name) > a.in').forEach(el => {
						el.addClass('in--hoverable');
					});
					objReal.querySelectorAll('.td_onclick').forEach(el => {
						el.closest('div.in')?.addClass('in--hoverable');
					});
				}
			},
			groups: {
				init() {
					self.interactive_cells.groups.update();

				},
				update() {
					const objReal = self.obj.get(0);
					const getNextSiblings = el => {
						const result = [];
						let next = el.nextElementSibling;
						while (next) { result.push(next); next = next.nextElementSibling; }
						return result;
					};
					objReal.querySelectorAll('.dataTable__group, .dataTable__subgroup').forEach(el => {
						if (el.previousElementSibling && !el.previousElementSibling.matches('.dataTable__group, .dataTable__subgroup')) {
							el.previousElementSibling.toggleClass('dataTable__item--before-group', true);
						}
					});
					objReal.querySelectorAll('.dataTable__group').forEach(group => {
						const siblings = getNextSiblings(group);
						const hasNextGroup = siblings.some(el => el.matches('.dataTable__group'));
						const hasVisibleSubgroup = siblings.some(el => el.matches('.dataTable__subgroup:not(.dataTable__subgroup-collapsed)'));
						group.toggleClass('dataTable__group--last', !hasNextGroup && !hasVisibleSubgroup);
					});

					objReal.querySelectorAll('.dataTable__subgroup').forEach(subgroup => {
						const siblings = getNextSiblings(subgroup);
						const hasNextSubgroup = siblings.some(el => el.matches('.dataTable__subgroup'));
						subgroup.toggleClass('dataTable__subgroup--last', !hasNextSubgroup);

						const next = subgroup.nextElementSibling;
						const hasVisibleItem = !!next?.matches('.dataTable__item:not(.dataTable__item-collapsedSub)');
						subgroup.toggleClass('dataTable__subgroup--before-items', hasVisibleItem);
					});
				}
			}
		},
		onInitPage: function(params) {
			self.customize_menu.order_to_column_map = params?.order_to_column_map ?? {};

			App.bus.state.on('custom_field_projects', function(payload, ctx) {
				let remove_projects = payload.data.remove || [];

				if (App.current_page.page === 'tasks_grid' && remove_projects.includes(App.current_page.project)) {
					self.api.remove_col(`custom_field__${payload.id}`);
				}

				if (['tasks_grid', 'projects_grid'].includes(App.current_page.page)) {
					self.customize_menu.reload();
				}
			}).on('custom_field_add', function (payload, ctx) {
				if (ctx.active_tab) return;

				if (['tasks_grid', 'projects_grid'].includes(App.current_page.page)) {
					self.customize_menu.reload();
				}
			}).on('custom_field_update', function (payload) {
				self.api.update_col_name(`custom_field__${payload.id}`, payload.data.name, payload.data.descr);
			}).on('custom_field_delete', function (payload) {
				self.api.remove_col(`custom_field__${payload.id}`);
			});
		},

		onUnloadPage: function () {
			if (self.obj == null) return;

			self.lastBaseUrl = App.page.url.base;
			if (self.scrollBar.obj) self.lastScrollY = self.scrollBar.obj.lastScrollTop;
			if (self.resizeObserver) self.resizeObserver.disconnect();
			$('body').removeClass('withDatatable');
			if (self.customize_menu.obj && self.customize_menu.obj.length) self.customize_menu.obj.remove();
			self.widthDragger.move.clear();
			self.scrollBar.calculateStartEndX.clear();
			self.onresize.clear();
			self.obj = null;
			self.obj_head = null;
			self.obj_body = null;
			self.wrapper = null;
			self.resizeObserver = null;
			self.customize_menu.obj = null;
			self.isLoaded = false;
			self.trCoords = {};
			self.trCoordsById = {};
			self.config = {};
		},
		collapseAll() {
			App.page.helper_collapse_all?.();
		},
		expandAll() {
			App.page.helper_expand_all?.();
		},
		sync_orders(orders) {
			Object.entries(orders).forEach(([column, order]) => {
				const columnObj = self.obj_head.find(`th[data-name="${column}"]`);
				columnObj?.attr('data-order', order);
			});
		},
		mass_helper: {
			toggle_group: function(groupID) {
				$(`#obj-group${groupID} .td_checkbox input.mass_group`).trigger('ws_click');
			},
			toggle_subgroup: function(groupID, subgroupID) {
				$(`#obj-subgroup${groupID}-${subgroupID} .td_checkbox input.mass_subgroup`).trigger('click');
			}
		},
		api: {
			remove_col(name) {
				if (!self.customize_menu?.obj || !self.obj_head) return;

				self.customize_menu.obj.find('.dataTable__menu__columns ws-btn[data-column-name="'+name+'"]').remove();
				self.obj_head.find(`th.${name}`).add(self.obj.find(`td.td_${name}`)).remove();
				self.calibrate(false, true);
			},
			update_col_name(col, name, descr) {
				if (!self.customize_menu?.obj || !self.obj_head) return;

				self.customize_menu.obj.find('.dataTable__menu__columns ws-btn[data-column-name="'+col+'"]').attr('text', App.helper.html.encode(name));
				self.obj_head.find(`th.${col} .in .columnValue`).text(name);
				if (descr) {
					let el = self.obj_head.find(`th.${col} .in .columnHint`);
					if (el.length === 0) {
						el = $('<div class="columnHint"><ws-icon name="hint" data-title=""></ws-icon></div>');
					}

					el.find('ws-icon').attr('data-title', App.helper.html.encode(`%H${name}H%%NL%${descr}`));
					self.obj_head.find(`th.${col} .in .columnValue`).after(el);

				} else self.obj_head.find(`th.${col} .in .columnHint`).remove();
			}
		}
	}
})();

;(function() {
	let self = App.controls.datepicker = {
		locale: {}, // from template
		config: {
			holidays : {},
			extraday : {},
			index_holidays: {},
			index_extraday: {},
			user_config: {},
			user_datestart: '',
			user_dateend: '',
			saturday_work: false,
			disable_holidays: 0,
			user_avatar: '',
			firstDay: 0,
			user_id: 0,
		}, // from template
		last_user: {
			id: null,
			user_config: {},
		},

		menu: function (params) {
			params ||= {}
			let box = '#datepickerMenu';

			$(box).find('.menu__text').toggleClass('hiddenBlock', params.title == null).text(params.title || '');

			App.menu.show({
				anchor: params.anchor,
				box: box,
				type: params.type,
				backup: params.backup,
				offset: params.offset,
				width: 'auto',
				onshow: function () {
					let config = params.datepicker || {};
					config.inline = true;
					let container = $(this).find('[data-container=calendar]');

					container.datepicker('destroy').datepicker(config);

					if (params.onshow) params.onshow.apply(this, [container]);
				}
			});
		},

		helper_disable_holidays: function(date) {
			let date_str = App.helper.date.to_input(date);
			let is_weekend = date.getDay() === 0 || (!self.config.saturday_work && date.getDay() === 6);
			if (date_str in self.config.extraday && !is_weekend) delete self.config.extraday[date_str];
			if (self.config.holidays && date_str in self.config.holidays) return [false, 'ui-datepicker-holiday', typeof self.locale == 'object' ? self.locale['holiday'] : ''];
			if (self.config.extraday && date_str in self.config.extraday) return [true, 'ui-datepicker-extraday', typeof self.locale == 'object' ? self.locale['extraday'] : ''];
			if (self.config.saturday_work) return [date.getDay() > 0, ''];
			return [(date.getDay() > 0 && date.getDay() < 6), ''];
		},

		helper_draw_holidays: function(date) {
			let date_str = App.helper.date.to_input(date);
			let is_weekend = date.getDay() === 0 || (!self.config.saturday_work && date.getDay() === 6);
			if (date_str in self.config.extraday && !is_weekend) delete self.config.extraday[date_str];
			if (self.config.holidays && date_str in self.config.holidays) return [true, 'ui-datepicker-holiday', typeof self.locale == 'object' ? self.locale['holiday'] : ''];
			if (self.config.extraday && date_str in self.config.extraday) return [true, 'ui-datepicker-extraday', typeof self.locale == 'object' ? self.locale['extraday'] : ''];
			if (self.config.saturday_work) return [date.getDay() > 0, ''];
			return [true, ''];
		},

		helper_calc_ranges: function(key) {
			let parseDate = (str) => {
				const [day, month, year] = str.split('.');
				return new Date(year, month - 1, day);
			}

			return self.config.user_config[key] ? App.helper.dates_into_ranges(Object.keys(self.config.user_config[key]).map(parseDate)) : [];
		},

		helper_pick_range: function(key, date) {
			let range_key = 'user_config_range_' + key;

			if (self.config[range_key] == null) {
				self.config[range_key] = self.helper_calc_ranges(key);
			}

			return self.config[range_key].find(i => i.start <= date && date <= i.end);
		},

		helper_user_holidays: function (date) {
			let override_weekend = '';
			let override_class = '';
			let override_title = '';
			let is_weekend = date.getDay() === 0 || (!self.config.saturday_work && date.getDay() === 6);
			let override_clickable = !is_weekend;
			let match = !self.config.user_datestart || date >= App.helper.date.from_input(self.config.user_datestart);
			if (match && self.config.user_dateend && date > App.helper.date.from_input(self.config.user_dateend)) match = false;
			let date_str = App.helper.date.to_input(date);
			if (self.config.extraday && date_str in self.config.extraday && !is_weekend) delete self.config.extraday[date_str];
			if (self.config.user_config[WORKDAY] && date_str in self.config.user_config[WORKDAY] && !(is_weekend || date_str in self.config.holidays)) delete self.config.user_config[WORKDAY][date_str];
			if (self.config.holidays && (date_str in self.config.holidays)) {
				override_clickable = false;
				override_weekend = 'holiday';
				override_class = 'ui-datepicker-holiday ';
				override_title = self.locale['holiday'];
			} else if (self.config.extraday && (date_str in self.config.extraday) && is_weekend) {
				override_class += ' ui-datepicker-extraday';
				override_title = self.locale['workday'];
				override_clickable = true;
			}
			if (match) {
				let found = false;
				for (let type of App.holidays.holiday_types) {
					if (self.config.user_config[type] && (date_str in self.config.user_config[type])) {
						override_class += ' ui-datepicker-us-' + App.holidays.type_index[type];
						override_title = self.locale['user_' + App.holidays.type_index[type]];
						override_clickable = false;
						if (override_title) {
							let range = App.format.terms_from_range(self.helper_pick_range(type, date));
							override_title = override_title.replace(/\{RANGE\}/gm, (range ? ': ' + range : ''));
						}
						found = true;
						break;
					}
				}
				if (!found && self.config.user_config[WORKDAY] && (date_str in self.config.user_config[WORKDAY])) {
					override_class += ' ui-datepicker-us-' + App.holidays.type_index[WORKDAY];
					override_title = self.locale['user_' + App.holidays.type_index[WORKDAY]];
					if (override_title) {
						let formatted_date = App.format.date(date, DATE_DEFAULT);
						override_title = override_title.replace(/\{DATE\}/gm, (formatted_date ? ': ' + formatted_date : ''));
					}
					override_clickable = true;
				}
			}
			if (date_str === self.config.user_datestart) {
				override_class += ' ui-datepicker-us-firstday';
				override_title = self.locale['user_datestart'];
			}
			if (date_str === self.config.user_dateend) {
				override_class += ' ui-datepicker-us-lastday';
				override_title = self.locale['user_dateend'];
			}

			let allowed = self.config.disable_holidays ? override_clickable : true;

			if (!allowed && is_weekend && self.locale['disabled_weekend']) {
				override_title = self.locale['disabled_weekend'];
			}

			return [self.config.disable_holidays ? override_clickable : true, override_class, override_title, override_weekend];
		},

		helper_first_last_weekends: function(date) {
			const year = date.getFullYear();
			const month = date.getMonth();

			// Get the first day of the month
			const firstDayOfMonth = new Date(year, month, 1);
			// Find the first Sunday and first Saturday
			const firstSunday = new Date(firstDayOfMonth);
			firstSunday.setDate(firstDayOfMonth.getDate() + (7 - firstDayOfMonth.getDay()) % 7);
			const firstSaturday = new Date(firstSunday);
			firstSaturday.setDate(firstSunday.getDate() - 1);

			if (firstSaturday.getMonth() !== month) {
				firstSaturday.setDate(firstSaturday.getDate() + 7);
			}
			if (firstSunday.getMonth() !== month) {
				firstSunday.setDate(firstSunday.getDate() + 7);
			}

			// Get the last day of the month
			const lastDayOfMonth = new Date(year, month + 1, 0);
			// Find the last Sunday
			const lastSunday = new Date(lastDayOfMonth);
			lastSunday.setDate(lastDayOfMonth.getDate() - (lastDayOfMonth.getDay() || 7) + 7);  // "|| 7" для того, щоб коректно обрахувати день, якщо lastDayOfMonth - це неділя
			// Find the last Saturday
			const lastSaturday = new Date(lastSunday);
			lastSaturday.setDate(lastSunday.getDate() - 1);

			if (lastSaturday.getMonth() !== month) {
				lastSaturday.setDate(lastSaturday.getDate() - 7);
			}
			if (lastSunday.getMonth() !== month) {
				lastSunday.setDate(lastSunday.getDate() - 7);
			}

			return {
				first: [App.helper.date.to_input(firstSaturday), App.helper.date.to_input(firstSunday)],
				last: [App.helper.date.to_input(lastSaturday), App.helper.date.to_input(lastSunday)]
			};
		},
		closest_workday: function (dt) {
		if (self.helper_user_holidays(dt)[0]) return dt;
		let currentDate = new Date(dt);
		currentDate.setHours(0, 0, 0, 0);
		let maxDaysToCheck = 30;
		for (let i = 1; i <= maxDaysToCheck; i++) {
			let nextDay = new Date(currentDate);
			nextDay.setDate(currentDate.getDate() + i);

			let prevDay = new Date(currentDate);
			prevDay.setDate(currentDate.getDate() - i);

			let nextDayResult = self.helper_user_holidays(nextDay);
			let prevDayResult = self.helper_user_holidays(prevDay);

			if (nextDayResult[0] === true) {
				return nextDay;
			}
			if (prevDayResult[0] === true) {
				return prevDay;
			}
		}

		// Якщо допустима дата не знайдена
		return null;
	},
	}
})();

;(function() {
	let self = App.controls.delay_menu = {
		time_conf: {}, // from template
		locale: {}, // from template
		config: {
			today: '',
			today_work: 0,
			workday: '',
			time_start: '',
			time_end: '',
		},

		apply: function() {
			let id = $('#delayedPubMenu').attr('data-id');
			let obj = '#drop' + ($('#delayedPubMenu').attr('data-type') === 'task' ? 'wait' : 'cwait') + id;
			if (id) {
				$.getScript($(obj).attr('data-prolong-url') + '&pub_dd=' + $('#delay_select input[name=date]').val() + '&pub_dt=' + $('#delay_select input[name=time]').val());
			} else {
				let frm = $('#delayedPubMenu').attr('data-type') === 'task' ? App.task_create.obj_window.get(0) : App.comment_form.form;
				frm.is_wait_pub.value = '1';
				frm.pub_dd.value = $('#delay_select input[name=date]').val();
				frm.pub_dt.value = $('#delay_select input[name=time]').val();
				if ($('#delayedPubMenu').attr('data-type') === 'task') {
					App.task_create.form_on_submit();
				} else {
					App.comment_form.submit();
				}
				frm.is_wait_pub.value = frm.pub_dd.value = frm.pub_dt.value = '';
			}
			App.menu.hide_all();
		},

		date_to_string: function(date) {
			let date_check = new Date();
			if (App.helper.date.to_format(date, 'ymd') === App.helper.date.to_format(date_check, 'ymd')) return self.locale['today'];
			date_check.setDate(date_check.getDate() + 1);
			if (App.helper.date.to_format(date, 'ymd') === App.helper.date.to_format(date_check, 'ymd')) return self.locale['tomorrow'];
			return $.datepicker.formatDate('d L', date);
		},

		preset: function() {
			let id = $('#delayedPubMenu').attr('data-id');
			let obj = '#drop' + ($('#delayedPubMenu').attr('data-type') === 'task' ? 'wait' : 'cwait') + id;
			if (id && $(obj).attr('data-date')) {
				let a = $(obj).attr('data-date').split(' ');
				// let b = $(obj).attr('data-date-txt').split(' ');
				// $('#delay_select input[name=date]').val(a[0]).next().html(b[0]);
				const date_txt = App.controls.delay_menu.date_to_string(App.helper.date.from_input(a[0]))
				$('#delay_select input[name=date]').val(a[0]).next().html(date_txt);
				$('#delay_select input[name=time]').val(a[1]);
				$('#delayedPubMenu .save').html($('#delayedPubMenu .save').attr('data-txt2'));
			} else {
				let date = new Date();
				date.setMinutes(date.getMinutes() + 10);

				let is_today = App.helper.date.to_format(date, 'ymd') === self.config.today;
				let this_time = App.helper.date.to_format(date, self.time_conf.timeFormat);

				if (is_today && self.config.today_work && this_time >= self.config.time_start && this_time < self.config.time_end) {
				} // this workday is not end
				else if (App.helper.date.to_format(date, 'ymd') >= self.config.workday && this_time >= self.config.time_start) {
				} // next workday is began
				else {
					while (App.helper.date.to_format(date, 'ymd') < self.config.workday) date.setDate(date.getDate() + 1);
					let t = self.config.time_start.split(':');
					date.setHours(parseInt(t[0]));
					date.setMinutes(parseInt(t[1]));
				}
				$('#delay_select input[name=date]').val(App.helper.date.to_input(date)).next().html(self.date_to_string(date));
				$('#delay_select input[name=time]').val(self.time2step(App.helper.date.to_format(date, self.time_conf.timeFormat)));
				$('#delayedPubMenu .save').html($('#delayedPubMenu .save').attr('data-txt1'));
			}
		},

		onShowTimepicker: function () {
			let date = new Date();
			let [day, month, year] = $('#delay_select input[name=date]').val().split('.').map(Number);
			let dateObj = new Date(year, month - 1, day);
			let is_today = App.helper.date.to_format(dateObj, 'ymd') === self.config.today;
			let this_time = App.helper.date.to_format(date, self.time_conf.timeFormat);
			const timepicker_list = $('#delay_select input[name=time]').data('timepickerList');
			timepicker_list && timepicker_list.find('.ui-timepicker-disabled').toggleClass('ui-timepicker-disabled ui-timepicker-disabled-fake');
			if (is_today) {
				timepicker_list.find('li .in').each(function () {
					let list_time = $(this).html();
					if (self.toMinutes(list_time) < self.toMinutes(this_time)) {
						$(this).parent().removeClass('ui-timepicker-disabled-fake').addClass('ui-timepicker-disabled ui-timepicker-disabled-late');
					}
				});
			} else {
				timepicker_list.find('.ui-timepicker-disabled-late').removeClass('ui-timepicker-disabled ui-timepicker-disabled-late').addClass('ui-timepicker-disabled-fake');
				timepicker_list.find('li .in').each(function () {
					let list_time = $(this).html();
					if (self.toMinutes(list_time) >= self.toMinutes(self.time_conf.minWorkTime) && self.toMinutes(list_time)<=self.toMinutes(self.time_conf.maxWorkTime)) $(this).parent().removeClass('ui-timepicker-disabled-fake');
				});
			}
		},

		onhideTimepicker: function() {
			window.ignore_drophide = true;
			setTimeout(function() {window.ignore_drophide = false;}, 300);
			let date_check = new Date();
			if (App.helper.date.to_input(date_check) === $('#delay_select input[name=date]').val() && this.value < App.helper.date.to_format(date_check, self.time_conf.timeFormat)) {
				date = new Date();
				date.setMinutes(date.getMinutes() + 10);
				$('#delay_select input[name=date]').val(App.helper.date.to_input(date)).next().html(self.date_to_string(date));
				$('#delay_select input[name=time]').val(self.time2step(App.helper.date.to_format(date, self.time_conf.timeFormat)));
			}
		},

		init: function() {
			$('#delay_select input[name=time]').timepicker(self.time_conf)
				.bind('hideTimepicker', function () {
					self.onhideTimepicker.call(this);
				}).bind('showTimepicker', function () {
					self.onShowTimepicker.call(this);
				})
				.on('change', function () {
					if ($(this).val().trim() == '' && $(this).attr('data-defaultTime')) {
						$(this).val($(this).attr('data-defaultTime'));
					}
				});

			$('#delay_select input[name=date]').datepicker({
				rangeSelect: false,
				minDate: new Date(self.locale['today_mdy']),
				minDate_: new Date(self.locale['today_mdy']),
				maxDate: new Date(self.locale['month_mdy']),
				maxDate_: new Date(self.locale['month_mdy']),
				numberOfMonths: 1,
				monthPicker: true,
				hideUnselectableDays: true,
				firstDay: App.datepicker_firstDay,
				onSelect: function (date_str) {
					let date = App.helper.date.from_input(date_str);
					let date_check = new Date();
					if (App.helper.date.to_format(date, 'ymd') === App.helper.date.to_format(date_check, 'ymd')) {
						date = new Date();
						date.setMinutes(date.getMinutes() + 10);
					} else {
						let t = self.config.time_start.split(':');
						date.setHours(parseInt(t[0]));
						date.setMinutes(parseInt(t[1]));
					}
					$('#delay_select input[name=date]').val(date_str).next().html(self.date_to_string(date));
					$('#delay_select input[name=time]').val(self.time2step(App.helper.date.to_format(date, self.time_conf.timeFormat)));
				},
				onClose: function() {
					window.ignore_drophide = true;
					setTimeout(function() {window.ignore_drophide = false;}, 300);
				},
				beforeShowDay: function (date) {
					let override_class = '';
					let override_title = '';
					let override_weekend = '';
					let date_str = App.helper.date.to_input(date);
					if (App.controls.datepicker.config.holidays && (date_str in App.controls.datepicker.config.holidays)) {
						override_weekend = 'holiday';
						override_class = 'ui-datepicker-holiday ';
						override_title = self.locale['holiday']
					}
					return [true, override_class, override_title, override_weekend];
				}
			});
		},
		time2step: function (time) {

			const hasMeridiem = /\b(am|pm)\b/i.test(time);
			const isPM = /\bpm\b/i.test(time);
			const isAM = /\bam\b/i.test(time);

			let clean = time.replace(/\s*(am|pm)\b/i, '');

			let [h, m] = clean.split(':').map(Number);
			if (hasMeridiem) {
				if (isPM && h < 12) h += 12;
				if (isAM && h === 12) h = 0;
			}

			m = Math.ceil(m / self.time_conf.step) * self.time_conf.step;
			if (m >= 60) {
				m = 0;
				h = (h + 1) % 24;
			}

			let suffix = '';
			if (hasMeridiem) {
				suffix = h >= 12 ? ' pm' : ' am';
				h = h % 12;
				if (h === 0) h = 12;
			}

			return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}${suffix}`;
		},
		toMinutes: function (timeStr) {
			let [h, m] = timeStr.split(':').map(Number);
			return h * 60 + m;
		},

		onBoot: function () {
			// instead of really_ready in /date/picker.js
			$(document.body).append($.datepicker.dpDiv).
				mousedown($.datepicker._checkExternalClick);
		}
	}
})();

;(function() {
	let self = App.controls.demo_modal = {
		start_time: null,
		timer: null,
		visibility_handler: null,

		init: function() {
			self.visibility_handler = function() {
				if (document.visibilityState === 'hidden') {
					self.start_time = Date.now();
					self.timer = setInterval(() => {
						const elapsed = Math.floor((Date.now() - self.start_time) / 1000);
						if (elapsed >= 120) {
							App.modal.show({
								url: App.helper.endpoint.primary() + '?' + App.actions.get('demo_modal:show'),
								group: 'nohead',
								onhide: function() {
									$.getScript(App.helper.endpoint.primary() + '?' + App.actions.get('demo_modal:delay'))
								}
							});
							self.destroy();
						}
					}, 5000);
				} else {
					clearInterval(self.timer);
					self.timer = null;
					self.start_time = null;
				}
			};
		},

		destroy: function() {
			clearInterval(self.timer);
			self.timer = null;
			self.start_time = null;
			self.visibility_handler = null;
		},

		onLogin: function () {
			App.core.context.when('show_demo_modal', () => {
				self.init()
			});
			App.bus.window.on('active inactive', function () {
				if (self.visibility_handler) self.visibility_handler();
			});
		}
	};
})();

;(function () {
	let self = App.controls.edit_field_menu = {
		/**
		 * @param {Pick<MenuShowData, 'anchor'|'backup'>} menuParams
		 * @param {{
		 *     onSubmit: (value:string) => void
		 * }} callbacks
		 * @param {Partial<Pick<HTMLInputElement, 'maxLength'|'placeholder'|'value'|'required'>>} inputAttributes
		 */
		show({anchor, backup}, {onSubmit}, {maxLength, placeholder, value, required}) {
			App.menu.show({
				anchor,
				backup,
				box: '#inlineEditMenu',
				onshow: (menu) => {
					const input = menu.querySelector('input');
					const submitBtn = menu.querySelector('button');

					const toggleDisabledBtn = () => {
						submitBtn.disabled = required ? input.value.length > 0 : false;
					}
					const submit = () => {
						onSubmit(input.value);
						App.menu.hide();
					}

					const {unbind: unbindInput} = input.addEventListenerWs('input', () => toggleDisabledBtn())
					const {unbind: unbindInputEnter} = input.addEventListenerWs('keydown', (e) => {
						if (e.keyCode === App.keycode.Enter) {
							submitBtn.click();
						}
					});
					const {unbind: unbindBtn} = submitBtn.addEventListenerWs('click', () => submit());


					Object.entries({maxLength, placeholder, value}).forEach(([key, value]) => {
						if (value) {
							input[key] = value;
						}
					})
					input.focusWithSelection();


					menu.unbind = () => {
						unbindInput();
						unbindBtn();
						unbindInputEnter();
					}
				},
				onhide: (menu) => {
					menu.unbind?.();
				}
			});
		}
	}
})();
;(function() {
	let self = App.controls.editblock = {
		_handlers: {},
		init: function (instance) {
			instance ||= {};
			instance.obj ||=  App.modal.obj_window;
			instance.updated_state = false;
			instance.btn_ok_selector ??= '.btn-ok';
			instance.btn_cancel_selector ??= '.btn-cancel';
			instance.allow_close_alert ??= true;
			instance.closeBlockInit ??= false;
			instance.variant ??= 'leave';
			instance.onsubmit ??= null; // (this === .btn)
			instance.onsuccess ??= null;
			instance.onerror ??= null; // (xhr, xhr.responseText)
			App.modal.obj_window.get(0).editBlock = instance;

			let input = instance.obj.find('.editBlock__input input');
			let textarea = instance.obj.find('.editBlock__textarea textarea');

			const pickers = instance.obj.find('.editBlock__picker[data-editblock-validator], .editBlock__picker.required');
			const validate_pickers = () => {
				let has_error = false;
				pickers.each(function () {
					picker = $(this);
					const input = instance.obj.find('input[name="'+picker.attr('data-input')+'"]');

					validator = picker.hasClass('required') ? (input) => {
						if (input.val().trim() !== '') return;
						return picker.attr('data-required-error-text') || App.object_state.locale.required_input;
					} : new Function('input', 'return '+picker.attr('data-editblock-validator')+'(input)');

					if (error_text = validator(input)) {
						has_error = true;

						picker
							.find('.editBlock__picker__header .label')
							.replaceWith(App.helper.template.fill('editBlock_picker_label_error', {
								label: error_text+':'
							}));
						picker.animate_css('head-shake');

						return false;
					}
				});
				return has_error;
			};

			input.bind('keydown', function(e) {
				let key = e.keyCode ? e.keyCode : e.charCode;
				if (key === App.keycode.Enter) e.preventDefault();
				input.closest('.editBlock__input').removeClass('editBlock__input-has-error');
				input.closest('.editBlock__inputGroup').find('.editBlock__inputError').addClass('editBlock__inputError--empty').text('');
			});
			if (instance.allow_close_alert) {
				instance.obj.find('input, textarea').bind('input', function() {
					self.set_updated_state();
				});
			}
			instance.obj.find(instance.btn_cancel_selector).bind('click', function() {
				App.modal.hide({ force: true });
			});
			instance.obj.find(instance.btn_ok_selector).bind('click', function() {
				if (input.hasClass('required') && !input.val().toString().trim().length) {
					input.closest('.editBlock__input').addClass('editBlock__input-has-error')
						.animate_css('head-shake');
					input.focus();
				} else if (textarea.hasClass('required') && !textarea.val().toString().trim().length) {
					textarea.closest('.editBlock__textarea').shortblink();
				} else if (validate_pickers()) {
					// error shown by validator
				} else if (!$(this).hasClass('btn-disabled')) {
					if ($(this).attr('onclick')) {
						// will fire itself
					} else if ($(this).attr('data-onclick')) {
						eval($(this).attr('data-onclick'));
					} else if (instance.submit) {
						instance.submit();
					} else {
						if (typeof instance.onsubmit === 'function') {
							if (instance.onsubmit(this) === false) return;
						}
						App.core.form_submit(this.form, instance.onsuccess, instance.onerror);
					}
				}
			});

			// COUNTERS INIT
			instance.obj.find('.editBlock__input-counter').each(function() {
				let counter = $(this).find('input').attr('data-maxlength') - $(this).find('input').val().length;
				$(this).append('<span class="editBlock__input__counter">' + counter + '</span>');
			});
			input.filter('[data-maxlength]').bind('input', function() {
				let counter = $(this).attr('data-maxlength') - $(this).val().length;
				instance.obj.find('.editBlock__input__counter').html(counter);
				if (counter < 0) {
					instance.obj.find('.editBlock').addClass('editBlock-error');
					instance.obj.find(instance.btn_ok_selector).addClass('btn-disabled');
				} else {
					instance.obj.find('.editBlock').removeClass('editBlock-error');
					instance.obj.find(instance.btn_ok_selector).removeClass('btn-disabled');
				}
			});
			instance.obj.find('.editBlock__textarea-counter').each(function() {
				let counter = $(this).find('textarea').attr('data-maxlength') - $(this).find('textarea').val().replace(/\n/g, "\r\n").length;
				$(this).append('<span class="editBlock__textarea__counter">' + counter + '</span>');
			});
			textarea.filter('[data-maxlength]').bind('input', function() {
				let counter = $(this).attr('data-maxlength') - $(this).val().replace(/\n/g, "\r\n").length;
				instance.obj.find('.editBlock__textarea__counter').html(counter);
				if (counter < 0) {
					instance.obj.find('.editBlock').addClass('editBlock-error');
					instance.obj.find(instance.btn_ok_selector).addClass('btn-disabled');
				} else {
					instance.obj.find('.editBlock').removeClass('editBlock-error');
					instance.obj.find(instance.btn_ok_selector).removeClass('btn-disabled');
				}
			});
			// COUNTERS INIT

			input.bind('focus', function() {
				$(this).closest('.editBlock__input').addClass('editBlock-focused');
			});
			input.bind('focusout', function() {
				$(this).closest('.editBlock__input').removeClass('editBlock-focused');
			});
		},
		show_close_alert: function (variant) {
			let instance = self.get_current_instance();
			if (instance && instance.allow_close_alert && instance.updated_state && !instance.is_close_alert_shown) {
				instance.is_close_alert_shown = true;
				const show_variant = variant || instance.variant;
				App.modal.obj_window.find('.modal__header').addClass('modal__header-disable');
				instance.obj.addClass('editBlock-initClose');
				instance.obj.prepend(
					App.helper.template.fill(show_variant === 'save' ? 'editBlock_saveAlert' : 'editBlock_closeAlert')
				);
				instance.obj.prepend('<div class="editBlock-backdrop"></div>')

				instance.obj.find('.editBlock-close-buttons ' + instance.btn_cancel_selector).bind('click', function(e) {
					let hide_modal = self._handlers.cancel == null;

					if (typeof self._handlers.cancel === 'function') self._handlers.cancel(e);

					self.set_updated_state(false);
					self.hide_close_alert();

					if (hide_modal) App.modal.hide();
				});
				instance.obj.find('.editBlock-close-buttons ' + instance.btn_ok_selector).focus().bind('click', function(e) {
					if (typeof self._handlers.ok === 'function') self._handlers.ok(e);

					self.hide_close_alert();
				})
				instance.obj.find('.editBlock-backdrop').bind('click', function() {
					self.hide_close_alert();
				})

				$(document).unbind('keydown', self.onkeydown);
				$(document).bind('keydown', self.onkeydown);
			}
		},
		onkeydown: function (e) {
			let instance = self.get_current_instance();

			if (instance == null || !instance.is_close_alert_shown) return;

			if (e.keyCode === App.keycode.Escape) {
				self.hide_close_alert();
			} else if(e.keyCode === App.keycode.Tab) {
				e.preventDefault();

				const btn_cancel = instance.obj.find('.editBlock-close-buttons ' + instance.btn_cancel_selector);
				const btn_ok = instance.obj.find('.editBlock-close-buttons ' + instance.btn_ok_selector);

				if (btn_ok.is(":focus")) {
					setTimeout(() => btn_cancel.focus(), 1)
				} else {
					setTimeout(() => btn_ok.focus(), 1)
				}
			}
		},
		on(type, handler) {
			if (['ok','cancel'].includes(type) && typeof handler === 'function') {
				self._handlers[type] = handler
			}
			return self;
		},
		hide_close_alert: function() {
			self._handlers = {};
			let instance = self.get_current_instance();
			if (instance) {
				$(document).unbind('keydown', self.onkeydown);
				App.modal.obj_window.find('.modal__header').removeClass('modal__header-disable');
				instance.obj.removeClass('editBlock-initClose');
				instance.obj.find('.editBlock-close').remove();
				instance.obj.find('.editBlock-backdrop').remove();
				instance.is_close_alert_shown = false;
			}
		},
		has_unsaved_updates: function() {
			let instance = self.get_current_instance();
			return instance && instance.updated_state;
		},
		set_updated_state: function(state= true) {
			let instance = self.get_current_instance();
			if (instance) instance.updated_state = state;
		},
		get_current_instance: function() {
			return App.modal.is_shown() && App.modal.obj_window.get(0).editBlock;
		},

		apply: function () {
			const instance = App.modal.obj_window.get(0).editBlock;

			instance.obj.find(instance.btn_ok_selector).filter(':visible').first().trigger('click');
		},

		process_input_error: function (input_name, error_text = '') {
			const instance = App.modal.obj_window.get(0).editBlock;

			// TODO process textarea etc if needed
			const input = instance.obj.find(`.editBlock__input input[name="${input_name}"]`);

			if (input) {
				input.closest('.editBlock__input').addClass('editBlock__input-has-error').focus().animate_css('head-shake');
				input.closest('.editBlock__inputGroup').find('.editBlock__inputError').removeClass('editBlock__inputError--empty').text(error_text);
				return true;
			}
		},
		process_form_error: function (error_text = '') {
			const instance = App.modal.obj_window.get(0).editBlock;

			// TODO process error_text
			instance.obj.find(instance.btn_ok_selector).animate_css('head-shake');
			return true;
		},
	}
})();

;(function() {
	let self = App.controls.editBlock_picker = {
		init: function (menu, pickerFake, callback, params) {
			params ||= {}
			params.templates ||= {
				spec: 'editBlock_picker_spec',
				item: 'editBlock_picker_item',
				group_all: 'editBlock_picker_group_all',
				group: 'editBlock_picker_group',
				group_client: 'editBlock_picker_group_client',
				group_sub: 'editBlock_picker_group_sub',
				group_sub_client: 'editBlock_picker_group_sub_client',
			}
			params.search_selector ||= '.menu__item[data-id]';

			const onload = params.on_menu_load  || self.on_menu_load;

			let is_menu_loading = false;
			pickerFake.bind('click', function(e) {
				if (is_menu_loading) return;
				is_menu_loading = true;
				App.menu.show({
					anchor: pickerFake.get(0),
					box: menu,
					type: 'picker',
					// з анімаціями гидко смикається picker__body при автоскролі до input
					no_anim: true,
					onload: () => onload(menu, pickerFake, callback, params),
					onshow: () => {
						is_menu_loading = false;
					}
				});
			});
		},

		init_bigSwitch: function (pickerFake, bigSwitch, options = {}) {

			const input = options.input;
			const on_toggle = options.on_toggle;

			if (input.attr('data-ids-min') === input.attr('data-ids-max') && input.attr('data-ids-max') === input.val()) {
				pickerFake.addClass('editBlock__picker-no-pickable');
			}

			// ? якщо ці атрибути відсутні, то і в свічі нема сенсу ?
			// input.attr('data-ids-min')
			// input.attr('data-ids-max')

			bigSwitch.on('click', function (e) {
				e.preventDefault();
				e.stopPropagation();

				pickerFake.show();
				bigSwitch.hide();

				if (input && input.attr('data-ids-min')) {
					input.val(input.attr('data-ids-min'));
				}

				on_toggle && on_toggle(false);
			});
			pickerFake.find('.select-all').on('click', function (e) {
				e.preventDefault();
				e.stopPropagation();

				pickerFake.hide();
				bigSwitch.show();

				if (input) {
					input.attr('data-ids-min', input.val());
					if (input.attr('data-ids-max')) {
						input.val(input.attr('data-ids-max'));
					}
				}

				on_toggle && on_toggle(true);
			});
		},

		on_menu_load: function(menu, pickerFake, callback, params) {

			menu.on('before_hide', function () {
				pickerFake.find('.editBlock__picker__add').scrollIntoView({ block: 'start' });
			});

			let picker = menu.find('.editBlock__picker');
			let menu_keyboardZone = menu.find('.keyboardZone').filter(function () {
				return $(this).closest('.editBlock__picker').length == 0;
			});
			let picker_keyboardZone = picker.find('.editBlock__picker__body');
			let run_search = function(options_overwrite) {
				const default_options = {
					skip_selection: picker_keyboardZone.hasClass('keyboardZone-active')
				};
				const options = $.extend({}, default_options, options_overwrite, {
					item: params.search_selector + ':not(.menu__item-picked)',
				});
				App.context_search.menu.apply(this, menu, options);
			}

			/** Initial content set **/

			picker.find('.editBlock__picker__search').before(pickerFake.find('.editBlock__picker__item').clone());
			picker.find('.editBlock__picker__counter').text(pickerFake.find('.editBlock__picker__counter').text());

			picker.find('.editBlock__picker__item').each(function() {

				if ($(this).attr('data-id')) {

					/** User pseudo-click */
					menu.find('.menu__item[data-id='+$(this).attr('data-id')+']').addClass('menu__item-picked');

				} else if ($(this).attr('data-group-sub')) {

					/** Department pseudo-click */
					menu.find('.menu__item[data-group='+$(this).attr('data-group')+'][data-group-sub='+$(this).attr('data-group-sub')+']').addClass('menu__item-picked');
					menu.find('.menu__group[data-group='+$(this).attr('data-group')+'] .menu__group__subset[data-group-sub='+$(this).attr('data-group-sub')+'] .menu__item[data-id]').addClass('menu__item-picked');

				} else if ($(this).attr('data-group')) {

					/** Team pseudo-click */
					menu.find('.menu__item[data-group='+$(this).attr('data-group')+']').addClass('menu__item-picked');
					menu.find('.menu__group[data-group='+$(this).attr('data-group')+'] .menu__item[data-id]').addClass('menu__item-picked');

				} else if ($(this).attr('data-groups')) {
					/** All Team pseudo-click */
					const id_groups = $(this).attr('data-groups').split(',');
					menu.find('.menu__item[data-groups="'+$(this).attr('data-groups')+'"]').addClass('menu__item-picked');
					for (let id_group of id_groups) {
						/** like Team pseudo-click */
						menu.find('.menu__group[data-group='+id_group+'] .menu__item[data-id]').addClass('menu__item-picked');
						menu.find('.menu__item[data-group='+id_group+']').addClass('menu__item-picked');
					}
				}

			});

			setTimeout(function() {
				/** this will hide empty groups and reset keyboard selection */
				picker.find('.editBlock__picker__search input').focus_desktop().each(run_search);
			})

			/** Events **/

			menu.on('click preset', '.menu__group-searchable .menu__item', function() {

				picker_keyboardZone.removeClass('keyboardZone-active').find('.selected').toggleSelected(false);
				menu_keyboardZone.addClass('keyboardZone-active');

				let item, ids = [];
				let name = $(this).attr('data-picker-text') || $(this).find('.in').text();
				let ico = $(this).find('.space:first-child').html();
				if ($(this).attr('data-id')) {
					/** User click */
					if (ico.match(/av_s /)) ico = $(ico).ava_recalc_bg(28).prop('outerHTML');
					$(this).addClass('menu__item-picked');
					item = App.helper.template.fill($(this).attr('data-picker-spec') ? params.templates.spec : params.templates.item, {
						id: $(this).attr('data-id'),
						id_group: $(this).closest('.menu__group').attr('data-group'),
						id_group_sub: $(this).closest('.menu__group__subset').attr('data-group-sub') || 0,
						ico,
						name: name,
						default: $(this).hasClass('menu__item-default'),
						client: $(this).closest('.menu__group').hasClass('menu__group-clients'),
					});
				} else if ($(this).attr('data-group-sub')) {
					/** Department click */
					let parentTeamType = $(this).parent().parent().find('ws-icon[name="office"]').length;
					menu.find('.menu__group[data-group='+$(this).attr('data-group')+'] .menu__group__subset[data-group-sub='+$(this).attr('data-group-sub')+'] .menu__item[data-id]').each(function() {
						ids.push($(this).attr('data-id'));
					}).addClass('menu__item-picked');
					pickerFake.find('.editBlock__picker__item[data-group='+$(this).attr('data-group')+'][data-group-sub='+$(this).attr('data-group-sub')+']').remove();
					picker.find('.editBlock__picker__item[data-group='+$(this).attr('data-group')+'][data-group-sub='+$(this).attr('data-group-sub')+']').remove();
					menu.find('.menu__item[data-group='+$(this).attr('data-group')+'][data-group-sub='+$(this).attr('data-group-sub')+']').addClass('menu__item-picked');
					item = App.helper.template.fill(parentTeamType ? params.templates.group_sub : params.templates.group_sub_client, {
						id_group: $(this).attr('data-group'),
						id_group_sub: $(this).attr('data-group-sub'),
						name: name,
						ids: ids.join(','),
						cnt: ids.length
					});

				} else if ($(this).attr('data-group')) {
					/** Team click */
					menu.find('.menu__group[data-group='+$(this).attr('data-group')+'] .menu__item[data-id]').each(function() {
						ids.push($(this).attr('data-id'));
					}).addClass('menu__item-picked');
					pickerFake.find('.editBlock__picker__item[data-group='+$(this).attr('data-group')+']').remove();
					picker.find('.editBlock__picker__item[data-group='+$(this).attr('data-group')+']').remove();
					menu.find('.menu__item[data-group='+$(this).attr('data-group')+']').addClass('menu__item-picked');
					item = App.helper.template.fill(ico.match(/shop/) ? params.templates.group_client : params.templates.group, {
						id_group: $(this).attr('data-group'),
						ico: ico,
						name: name,
						ids: ids.join(','),
						cnt: ids.length
					});
				} else if ($(this).attr('data-groups')) {
					/** All Team click */
					const id_groups = $(this).attr('data-groups').split(',');
					$(this).addClass('menu__item-picked');
					for (let id_group of id_groups) {
						/** like Team click */
						menu.find('.menu__group[data-group='+id_group+'] .menu__item[data-id]').each(function() {
							ids.push($(this).attr('data-id'));
						}).addClass('menu__item-picked');
						pickerFake.find('.editBlock__picker__item[data-group='+id_group+']').remove();
						picker.find('.editBlock__picker__item[data-group='+id_group+']').remove();
						menu.find('.menu__item[data-group='+id_group+']').addClass('menu__item-picked');
						item = App.helper.template.fill(params.templates.group_all, {
							id_groups: id_groups.join(','),
							ico: ico,
							name: name,
							ids: ids.join(','),
							cnt: ids.length
						});
					}
				}

				pickerFake.find('.editBlock__picker__add').before(item);
				picker.find('.editBlock__picker__search').before(item);

				if (params.before_group_processing_callback) {
					self.run_callbacks(pickerFake, params.before_group_processing_callback);
				}

				/** this will hide empty groups and reset keyboard selection */
				App.keyboard_selection.move_to_closest(menu_keyboardZone);
				picker.find('.editBlock__picker__search input').val('').focus_desktop().each(function () {
					run_search.call(this, { skip_selection: true });
				});
				// при додаванні група "поглинає" обрані елементи, котрі в неї входять
				// тому треба оновити висоту скролзони
				picker_keyboardZone.closest('.scrollZone').scrollUpdate();
				// на мобілі без автофокуса в поле вводу,
				// тому вручну скролимо до низу, щоб бачити, що елемент додався
				if (App.device.is_mobile()) {
					picker_keyboardZone.closest('.scrollZone').scrollBottom();
				}

				self.run_callbacks(pickerFake, callback);

				self.update_blocks_visibility(menu, pickerFake);
			});

			picker.on('click', '.editBlock__picker__item', function(e, data) {
				picker_keyboardZone.addClass('keyboardZone-active');
				menu_keyboardZone.removeClass('keyboardZone-active').find('.selected').toggleSelected(false);

				data ||= {};

				const is_mobile_delete = App.device.is_mobile() && $(this).hasClass('selected'); // на мобілці видаляється при дабл тапі (якщо не в хрестик)
				const is_button_delete = $(e.target).closest('.delete').length > 0;
				if (!data.delete && !data.enter && !is_button_delete && !is_mobile_delete) {
					if ($(this).hasClass('selected')) $(this).toggleSelected(false);
					else {
						// треба щоб фокус ставився в поле, але не скролило до нього
						picker.find('.editBlock__picker__search input').focus_enhanced({
							desktop_only: true,
							restore_scroll: true,
							callback: () => {
								picker_keyboardZone.find('.selected').toggleSelected(false);
								$(this).toggleSelected(true);
							}
						});
					}
					return false;
				}

				// обирати щось взамін, тільки якщо це дія з клавіатури
				let closest_sibling_item;
				if (data.delete || data.enter) {
					closest_sibling_item = App.keyboard_selection.find_closest_sibling(picker_keyboardZone, data.backward || false);
				}

				if ($(this).attr('data-id')) {

					/** User click */
					if (menu.find('.menu__item[data-id='+$(this).attr('data-id')+']').hasClass('menu__item-default')) return false;
					menu.find('.menu__item[data-id='+$(this).attr('data-id')+']').removeClass('menu__item-picked');
					pickerFake.find('.editBlock__picker__item[data-id='+$(this).attr('data-id')+']').remove();

				} else if ($(this).attr('data-group-sub')) {

					/** Department click */
					menu.find('.menu__item[data-group='+$(this).attr('data-group')+'][data-group-sub='+$(this).attr('data-group-sub')+']').removeClass('menu__item-picked');
					menu.find('.menu__group[data-group='+$(this).attr('data-group')+'] .menu__group__subset[data-group-sub='+$(this).attr('data-group-sub')+'] .menu__item[data-id]').removeClass('menu__item-picked');
					pickerFake.find('.editBlock__picker__item[data-group='+$(this).attr('data-group')+'][data-group-sub='+$(this).attr('data-group-sub')+']').remove();

				} else if ($(this).attr('data-group')) {

					/** Team click */
					menu.find('.menu__item[data-group='+$(this).attr('data-group')+']').removeClass('menu__item-picked');
					menu.find('.menu__group[data-group='+$(this).attr('data-group')+'] .menu__item[data-id]').removeClass('menu__item-picked');
					pickerFake.find('.editBlock__picker__item[data-group='+$(this).attr('data-group')+']').remove();

				} else if ($(this).attr('data-groups')) {
					/** All Team click */
					menu.find('.menu__item[data-groups="'+$(this).attr('data-groups')+'"]').removeClass('menu__item-picked');
					menu.find('.menu__group[data-groups="'+$(this).attr('data-groups')+'"] .menu__item[data-id]').removeClass('menu__item-picked');
					pickerFake.find('.editBlock__picker__item[data-groups="'+$(this).attr('data-groups')+'"]').remove();

					const id_groups = $(this).attr('data-groups').split(',');
					for (let id_group of id_groups) {
						/** like Team click */
						menu.find('.menu__item[data-group='+id_group+']').removeClass('menu__item-picked');
						menu.find('.menu__group[data-group='+id_group+'] .menu__item[data-id]').removeClass('menu__item-picked');
						pickerFake.find('.editBlock__picker__item[data-group='+id_group+']').remove();
					}
				} else {
					throw new Error("Unknown item type");
				}
				$(this).remove();

				if (params.before_group_processing_callback) {
					self.run_callbacks(pickerFake, params.before_group_processing_callback);
				}

				if (closest_sibling_item && closest_sibling_item.length) {
					closest_sibling_item.toggleSelected(true);
				}

				/** this will hide empty groups and reset keyboard selection */
				picker.find('.editBlock__picker__search input').focus_enhanced({
					desktop_only: true,
					restore_scroll: true
				}).each(run_search);

				picker_keyboardZone.closest('.scrollZone').scrollUpdate();

				self.run_callbacks(pickerFake, callback);

				menu.find('.menu__item-default').not('.menu__item-picked').click();

				self.update_blocks_visibility(menu, pickerFake);

				// щоб не прокидувалась подія далі (де ставиться фокус в поле, що заважає на мобілці)
				return false;
			});

			picker.bind('click', function(e) {
				if ($(e.target).closest('.ps__rail-y, .ps__rail-x').length) return true;
				if ($(e.target).closest('ws-btn[onclick]').attr('onclick')?.startsWith('App.menu.hide')) return true;
				if (!$(e.target).parents().addBack().filter('.editBlock__picker__item').length && picker.find('.selected').length) {
					picker.find('.selected').toggleSelected(false);
					picker_keyboardZone.removeClass('keyboardZone-active');
					menu_keyboardZone.addClass('keyboardZone-active');
				}
				picker.find('.editBlock__picker__search input').focus();
			});

			picker.find('.editBlock__picker__search input').bind('keydown', function(e) {
				let keyCode = e.which || e.keyCode || e.charCode;
				if (keyCode === App.keycode.Escape) {
					if (this.value) {
						this.value = '';
						menu.find('.selected').toggleSelected(false);
						run_search.call(this);
						return false;
					} else if (picker_keyboardZone.hasClass('keyboardZone-active')) {
						picker_keyboardZone.removeClass('keyboardZone-active').find('.selected').toggleSelected(false);
						menu_keyboardZone.addClass('keyboardZone-active');
						return false;
					}
				}
				if (keyCode === App.keycode.Tab && !picker_keyboardZone.hasClass('keyboardZone')) {
					if (picker_keyboardZone.hasClass('keyboardZone-active')) {
						picker_keyboardZone.removeClass('keyboardZone-active').find('.selected').toggleSelected(false);
						App.keyboard_selection.init_container(menu_keyboardZone.addClass('keyboardZone-active'));
					} else if (picker.find('.editBlock__picker__item').length) {
						menu_keyboardZone.removeClass('keyboardZone-active').find('.selected').toggleSelected(false);
						App.keyboard_selection.init_container(picker_keyboardZone.addClass('keyboardZone-active'));
					}
					return false;
				}

				// уникаємо авто-проскрола до поля вводу
				if (
					picker_keyboardZone.hasClass('keyboardZone-active')
					&& picker_keyboardZone.find('.selected').length
					&& (keyCode === App.keycode.Backspace || keyCode === App.keycode.Delete)
				) return false;
			});

			picker.find('.editBlock__picker__search input').bind('keyup', function(e) {
				let keyCode = e.which || e.keyCode || e.charCode;

				// це не введення, а навігація між зонами
				if (keyCode === App.keycode.Tab) return false;

				if (this.value || $(this).closest('.search_started').length) {

					// це навігація курсора по написаному
					if (keyCode === App.keycode.ArrowLeft || keyCode === App.keycode.ArrowRight) return false;
					if (keyCode === App.keycode.ArrowUp || keyCode === App.keycode.ArrowDown) return false;

					if (picker_keyboardZone.hasClass('keyboardZone-active')) {
						picker_keyboardZone.removeClass('keyboardZone-active').find('.selected').toggleSelected(false);
					}
					menu_keyboardZone.addClass('keyboardZone-active');
					run_search.call(this);

				} else {
					if (
						picker_keyboardZone.hasClass('keyboardZone-active')
						&& picker_keyboardZone.find('.selected').length
						&& (keyCode === App.keycode.Backspace || keyCode === App.keycode.Delete)
					) {
						picker_keyboardZone.find('.selected').trigger('click', [{delete: true, backward: keyCode === App.keycode.Backspace}]);
						if (!picker.find('.editBlock__picker__item').length) {
							picker_keyboardZone.removeClass('keyboardZone-active')
							menu_keyboardZone.addClass('keyboardZone-active');
						}
						return false;
					}
					if (!menu.find('.selected').length && (keyCode === App.keycode.ArrowLeft || keyCode === App.keycode.ArrowUp) || keyCode === App.keycode.Backspace) {
						menu_keyboardZone.removeClass('keyboardZone-active').find('.selected').toggleSelected(false);
						App.keyboard_selection.init_container(picker_keyboardZone.addClass('keyboardZone-active'), true);
					}

				}
			});

			picker.on('onselect', '.editBlock__picker__item', function () {

				// з клавіатури там своя система
				if (!App.keyboard_selection.is_mouse_moved) return true;

				$(this).scrollIntoViewIfNeeded({
					offset_top: 8 + (parseFloat(picker_keyboardZone.css('padding-top')) || 0),
					offset_bottom: parseFloat(picker_keyboardZone.css('padding-bottom')) || 0,
				});
			});
		},

		run_callbacks: function(pickerFake, callback) {
			let ids = [];
			pickerFake.find('.editBlock__picker__item').each(function() {
				if ($(this).attr('data-ids')) {
					$(this).attr('data-ids').split(',').forEach((id) => ids.push(id));
				} else {
					ids.push($(this).attr('data-id'))
				}
			});

			pickerFake.find('.editBlock__picker__counter').html('(' + ids.length + ')');
			if (callback) callback.call(pickerFake.get(0), ids);
		},

		update_blocks_visibility: function(menu, pickerFake) {

			const has_pickable = menu.find('.menu__group-searchable').find('.menu__item').not('.menu__item-picked').not('.menu__item-notPossible').not('.menu__item-group').length > 0;

			menu.toggleClass('menu-no-pickable', !has_pickable);
			menu.find('.editBlock__picker').add(pickerFake).toggleClass('editBlock__picker-no-pickable', !has_pickable);
		},
	}
})();

;(function() {
	let self = App.controls.emoji = {
		picker: null,
		pickerOptions: {},
		type: 'apple', // native, apple, facebook, google, twitter
		script: '/assets/js/vendor/emoji/',
		source: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple@14.0.0/img/apple/64/',
		localSource: '/assets/img/emoji/apple/',
		defaultIco: {
			'project' : 'project',
			'chat' : 'chat_bubble',
			'bookmark' : 'bookmark-solid'
		},
		onBoot: function () {
			if (Object.keys(self.pickerOptions).length === 0) {
				self.pickerOptions = {
					set: self.type,
					data: self.getEmojiUrl('json', self.type),
					getSpritesheetURL: self.getEmojiUrl('png', self.type),
					categories: ['frequent', 'people', 'nature', 'foods', 'activity', 'places', 'objects', 'symbols', 'flags'],
					locale: App.locale ?? 'en',
					theme: 'light',
					autoFocus: true,
					maxFrequentRows: 1,
					emojiButtonColors: 'red',
					emojiSize: 22,
					emojiButtonSize: 32,
					emojiButtonRadius: '8px'
				}
				if (typeof EmojiMart != 'undefined') EmojiMart.init(self.pickerOptions);
			}
		},

		inline_menu: {

			_emoji_ready: false,
			_last_menu_params: null,

			get_container: function () {
				const menu = $('#inlineEmojiMenu');
				const container = menu.find('[data-container=emoji]');
				return container;
			},

			is_shown: function () {
				return App.menu.is_shown() && App.menu.obj_window.is('#inlineEmojiMenu');
			},

			show: function (params) {
				params ||= {};

				self._last_menu_params = params;

				const container = self.inline_menu.get_container();

				App.menu.show({
					anchor: params.anchor,
					text_position: params.text_position,
					box: '#inlineEmojiMenu',
					type: params.type ?? (params.text_position ? 'text' : null),
					backup: params.backup,
					force_dropdown: true,
					onload: function () {
						const menu = $(this);
						menu.horizontalWheelScroll({
							container: '.flex_row-forceScrollable'
						});
					},
					onshow: function () {
						const menu = $(this);
						menu.off('click.app.controls.emoji').on('click.app.controls.emoji', '.menu__item', function() {
							EmojiMart.FrequentlyUsed.add($(this).attr('data-id'));
							params?.onEmojiSelect($(this).data('EmojiMartData'));
						});
						if (params.focus) {
							self.inline_menu.focus();
						}
					},
					onhide: function () {
						container.empty();
					}
				});
				if (params.inline_emoji_select) App.menu.inline_emoji_select = true;
				if (params.in_editor) App.menu.in_editor = true;
			},

			create_item: (emoji, emoji_html) => App.controls.menu.create_item({ left_icon: () => emoji_html, dataset: { id: emoji.id } }).data('EmojiMartData', emoji),

			focus: function () {
				const keyboard_container = App.menu.get_keyboard_zone();
				App.keyboard_selection.init_container_with_preselected_item(keyboard_container);
			},

			search_show: async function (search_query, menu_params) {

				if (!self.inline_menu._emoji_ready) {
					await EmojiMart.init({ data: self.getEmojiUrl('json', self.type) });
					self.inline_menu._emoji_ready = true;
				}

				const container = self.inline_menu.get_container();

				const get_frequent = () => {
					const frequent = EmojiMart.FrequentlyUsed
						.get({ maxFrequentRows: 1, perLine: 9 });

					let last = localStorage.getItem('emoji-mart.last');
					if (last) last = JSON.parse(last);

					if (!last) {
						return frequent.map(key => EmojiMart.Data.emojis[key]);
					}

					const reordered = [
						last,
						...frequent.filter(key => key !== last)
					];

					return reordered
						.slice(0, 9)
						.map(key => EmojiMart.Data.emojis[key]);
				};

				const get_search = async (search_query) => {
					const res = await EmojiMart.SearchIndex.search(search_query);
					return res.slice(0, 36);
				};

				const data = !search_query
					? get_frequent()
					: await get_search(search_query);

				if (!data.length) {
					if (self.inline_menu.is_shown()) App.menu.hide();
					return;
				}

				container.empty().append(
					data.filter(e => e?.skins?.length > 0)
						.map(e => ({ id: e.id, ...e.skins[0] }))
						.map(e => self.inline_menu.create_item(e, '<ws-emoji id="'+e.id+':'+e.unified+'" native="'+e.native+'"></ws-emoji>'))
				);

				if (!self.inline_menu.is_shown()) {
					self.inline_menu.show(menu_params);
				} else if (menu_params.focus) {
					self.inline_menu.focus();
				}
			},

			handleNav: function (dx, dy) {
				if (dx === -1) {
					const keyboard_container = App.menu.get_keyboard_zone();
					const BACKWARD = true;
					if (!keyboard_container.find('.selected').length) {
						if (self.inline_menu.is_shown()) App.menu.hide();
						return true;
					}
					App.keyboard_selection.move_to_next_item(keyboard_container, BACKWARD);
					return true;
				}
				if (dx && App.keyboard_selection.go_within_container(dx, false)) return true;
				if (dy) return true; // а це перехвачено для роботи меншн меню в App.keyboard_selection... було б добре рефакторнути це все
				return false;
			},

			handleSelect: function () {
				self.inline_menu.get_container().find('.menu__item.selected').first().trigger('click');
			},

			handleSearch: function (search_query) {
				self.inline_menu.search_show(search_query ?? '', self._last_menu_params);
			},
		},

		getEmojiUrl: function(type, set) {
			if (type === 'json') {
				return async () => {
					const response = await fetch(
						(App.hybrid_app ? App.api.get_account_domen() + '/cors/?file=' : '') + self.script + set + '.' + type,
					)
					return response.json()
				}
			}
			if (type === 'png') {
				return () => self.script + set + '.' + type;
			}
		},
		getPicker: function (onEmojiSelect, onClickOutside, autoFocus) {
			let pickerOptions = { ...self.pickerOptions };
			pickerOptions.onEmojiSelect = onEmojiSelect;
			if (onClickOutside) pickerOptions.onClickOutside = onClickOutside;

			pickerOptions.autoFocus = autoFocus ?? true;
			pickerOptions.theme = $('body').attr('data-color') === 'color' ? 'dark' : 'light';

			return new EmojiMart.Picker(pickerOptions);
		},
		getEmoji: function (id) {
			return '<ws-emoji id="' + id + '"></ws-emoji>';
		},
		resolveComponent: function (el) {
			el = $(el).is('em-emoji-picker') ? $(el).get(0) : $(el).find('em-emoji-picker').get(0);
			return el?.component || null;
		},
		triggerSearch: function (el, query) {
			let component = this.resolveComponent(el);
			if (!component) return;

			component.refs.searchInput.current.value = query.trim();
			component.handleSearchInput()
		},
		handleSelect: function (el) {
			let component = this.resolveComponent(el);
			if (!component) return;

			$(component.base).find('.scroll button[aria-selected=true]').first().trigger('click')
		},
		handleNav: function (el, dx, dy) {
			let component = this.resolveComponent(el);
			if (!component) return;

			let area = $(component.base).find('.scroll');
			if (area.length === 0) return;
			let btns = area.find('button').get().slice(0, 99);
			if (btns.length === 0) return;

			let active_index = btns.findIndex(i => i.getAttribute('aria-selected') != null);
			if (active_index < 0) active_index = 0;

			$(btns[active_index]).attr('aria-selected', null);

			active_index += dx;
			active_index += dy * 9;

			let new_target = $(btns[active_index] != null ? btns[active_index] : btns[0]);

			new_target.attr('aria-selected', 'true');

			if (active_index < 18) {
				area.scrollTop(0);
			} else {
				new_target.scrollIntoView({behavior: 'smooth', block: 'nearest'});
			}
		},

		onLogin: function () {
			if (Object.keys(self.pickerOptions).length !== 0) {
				self.pickerOptions.locale = App.locale;
			}
		},
		onLogout: function () {
			if (Object.keys(self.pickerOptions).length !== 0) {
				self.pickerOptions.locale = 'en';
			}
		},
	}
})();

;(function() {
	let self = App.controls.export_with_options = {
		url: '',
		onclick: function() {
			$('.export_btn').html(App.config.loader_html);
			App.core.download_file(self.url, $(document.modfrm).serialize(), function() {
				App.modal.hide();
			});
			return false;
		},
		init: function (url) {
			self.url = url;
			$('.export input:checkbox').on('change', function () {
				if (!$('.export input:checkbox:checked').length) {
					$('.export .button').toggleDisabled('disabled');
				} else {
					$('.export .button').removeAttr('disabled');
				}
			});
			$('.export .title').on('click', function () {
				let target = $(this).attr('data-target'),
					input = $(target).find('input[type="checkbox"]:not(:disabled)');
				if ($(this).hasClass('checked')) {
					input.prop('checked', false);
					input.parent().removeClass('act');
					$(this).removeClass('checked');
				} else {
					input.prop('checked', true);
					input.parent().addClass('act');
					$(this).addClass('checked');
				}
			});
			$('.export .export_btn ws-btn').on('click', self.onclick);
		}
	}
})();

;(function () {
	let self = App.controls.ext_link_quick_menu = {

		box: '#quickExternalLinkMenu',

		show: function (anchor, url, params) {
			params ||= {}

			let final_url = url;
			if (App.helper.validate.is_relative_url(final_url)) {
				final_url = App.config.account_url + final_url;
			}

			const menu = $(self.box);
			const open = menu.find('.menu__item[data-key=open]');
			const more = menu.find(`.menu__item[data-key=more]`);

			menu.find('.menu__item[data-key=link]').attr('data-copy-val', final_url);

			open.attr('data-url', final_url);

			if (App.helper.validate.match_account_url(url, App.helper.validate.task_url_any)) {
				open.prepend(open.children('ws-icon'));
				more
					.removeClass('menu__item-hidden')
					.attr('data-type', 'task')
					.attr('data-endpoint', App.helper.url.task(App.helper.validate.match_account_url(url, App.helper.validate.task_url_any)));
			} else if (App.helper.validate.match_account_url(url, App.helper.validate.project_url)) {
				open.prepend(open.children('ws-icon'));
				more
					.removeClass('menu__item-hidden')
					.attr('data-type', 'project')
					.attr('data-endpoint', App.helper.endpoint.ajax(App.helper.validate.match_account_url(url, App.helper.validate.project_url)));
			} else {
				more.addClass('menu__item-hidden');
				open.append(open.children('ws-icon'));
			}

			App.menu.show({
				anchor: anchor,
				type: params.type || 'left',
				replace: params.replace || false,
				backup: params.backup || false,
				box: self.box,
				force_dropdown: true,
				width: 'auto'
			});
		},

		onLogin: function () {
			$(self.box).on('click','[data-key]', function() {
				switch ($(this).attr('data-key')) {
					case 'open':
						App.menu.hide();
						App.core.new_window($(this).attr('data-url'));
						break;
					case 'link':
						const val = $(this).attr('data-copy-val');
						if (val == null || val.trim() === '') {
							$(this).animate_css('head-shake');
							return;
						}
						App.core.clipboard_from_menu(this, val);
						break;
					case 'more':
						let type = $(this).attr('data-type'), url = $(this).attr('data-endpoint');
						if (type === 'task') {
							App.controls.task_menu.show(this, url, { backup: true });
						} else if (type === 'project') {
							App.controls.project_menu.show(this, url, {context_menu: true, backup: true});
						}
						break;
				}
			});
		}
	};
})();

;var App = App || {};

(function () {
	let self = App.fatforms = {
		init: function(instance) {
			instance ||= {};
			instance.obj ||=  App.modal.obj_window.find('.inputBlock__label');
			instance.btn_ok_selector ??= '.btn-ok';

			let textarea = instance.obj.find('textarea[data-maxlength]');

			textarea.each(function() {
				self.init_input(this, instance);
			});

			let inputs = instance.obj.find('input[type=text][data-maxlength]');
			inputs.each(function() {
				self.init_input(this, instance);
			});
		},

		init_input: function (el, config) {
			let $el = $(el), len = $el.val().replace(/\n/g, "\r\n").length, block = $el.parent();
			let counter = parseInt($el.attr('data-maxlength'), 10) - len;

			if (counter < 0) $el.addClass('input_error');

			if (block.find('.inputBlock__label-counter').length === 0)
				block.append('<span class="inputBlock__label-counter"></span>');

			block.find('.inputBlock__label-counter').toggleClass('hiddenBlock', len === 0).text(counter);

			$el.bind('input', function() {
				let len = $el.val().replace(/\n/g, "\r\n").length,
					counter = $(this).attr('data-maxlength') - len;

				block.find('.inputBlock__label-counter').toggleClass('hiddenBlock', len === 0).text(counter);

				if (counter < 0) {
					$el.addClass('input_error').parent().find('.label-icons-top').hide();
					config.obj.find(config.btn_ok_selector).addClass('btn-disabled').toggleDisabled(true);
				} else {
					$el.removeClass('input_error').parent().find('.label-icons-top').show();
					config.obj.find(config.btn_ok_selector).removeClass('btn-disabled').toggleDisabled(false);
				}
			});
		},
	}
})();

;(function() {
	let self = App.controls.file = {

		download: function (options) {
			if (typeof options === 'string') options = { file_link: options };

			if (options.all_link == null) return self.start_download(options.file_link, options.is_ftp);

			App.menu.show({
				anchor: options.anchor,
				box: '#fileDownloadMenu',
				type: options.menu_type || 'left',
				backup: options.backup || options.menu_type === 'submenu',
				width: options.width || 256,
				onshow: function () {
					const menu = $(this);

					menu.find('[data-key=all] .cnt').toggleClass('hiddenBlock', !(options.all_count > 0)).text(options.all_count);

					menu.find('[data-key=file]').toggleClass('menu__item-hidden', options.file_link == null).off('click').on('click', function () {
						self.start_download(options.file_link, options.is_ftp);
						App.menu.hide();
					});
					menu.find('[data-key=all]').toggleClass('menu__item-hidden', options.all_link == null).off('click').on('click', function () {
						self.start_download(options.all_link);
						App.menu.hide();
					});
				}
			});
		},

		start_download: function (url, blank) {
			if (blank) {
				App.core.new_window(url);
			} else {
				App.core.download_file(url);
			}
		}
	}
})();

;(function () {
	const self = App.controls.files_grid = {
		openEditLabelsModal: function (file_id) {
			App.modal.show({
				url: App.helper.url.add_query(App.mass.action_url('labels'), 'ids=' + file_id),
				width: 500,
				group: 'labels'
			});
		},
		openTaskSelectFilter: function (anchor, endpoint) {
			App.controls.task_select_and_go.show_context(anchor, endpoint, {
				request: {
					type: 'files'
				},
				load_always: true,
				backup: true,
				onload: function() {
					let menu = $(this);
					menu.on('click', '.menu__item[data-id]', function() {
						App.page.filter_update({'task': $(this).attr('data-id')});
					});
				},

			});
		}
	}
})();
;(function() {
	let self = App.controls.float_edit = {

		apply: function(name) {
			$(self.current_el).text(name);
			self.delete();
		},

		/**
		 * @deprecated onsubmit event
		 */
		init: function () {
			$('form.ajax_form_replace').not('.ws_init').addClass('ws_init').bind('submit', function () {
				App.core.form_submit(this);
				return false;
			}).find('.input, .js_focus').focus_to_end();
			App.forms.init_setup_forms();
		},

		show: function (el) {
			$('#float_edit_inline').remove();
			$('.floatEditAppended').removeClass('floatEditAppended');
			if (!$(el).attr('data-dock')) $(el).parent().addClass('floatEditAppended');
			if ($(el).attr('data-html')) $('<div></div>').attr('id', 'float_edit_inline').appendTo($(el).attr('data-dock') ? $(el).attr('data-dock') : '.taskView__name').html($($(el).attr('data-html')).html()).show().find('.inputmain').focus_to_end();
			else $('<div></div>').attr('id', 'float_edit_inline').appendTo($(el).attr('data-dock') ? $(el).attr('data-dock') : '.taskView__name').load(App.helper.url.add_query($(el).attr('data-edit')), function () {
				$(this).show().find('.inputmain').focus_to_end();
			});
		},

		current_el: null,
		create: function (el, url, el_position, addition_class_wrapper = '') {
			self.current_el = el;
			let o = $(el_position ? el_position : el);
			$('#fixed_container').append($('<span class="frm_inside'+ (addition_class_wrapper ? ' ' + addition_class_wrapper : '') +'" id="form_edit_inline"></span>').css({
				left: o.offset().left + 0.5 * o.outerHeight(),
				top: o.offset().top,
			}).load(url, function () {
				self.init();
				App.forms.init_itm_inputs();
			}));
		},

		delete: function () {
			$('#form_edit_inline').parent().removeClass('frm_inline');
			$('#form_edit_inline').remove();
		},
	}
})();

;(function() {
	let self = App.controls.form_autosave = {
		state_saved: {},
		state_noticed: {},
		saveTimers: {},

		request_save: function (params, onsuccess, onerror) {
			$.ajax({
				url: App.helper.url.add_query(params.endpoint),
				type: 'POST',
				dataType: 'script',
				data: params.data,
				timeout: App.env === 'local' ? 60000 : 10000,
				error: App.core.create_jq_ajax_error(onerror),
				success: function () {
					if (onsuccess) onsuccess();
					$('.form_autoSave[data-frm-id='+params.frm_id+']').removeClass('form_autoSave-changed');
					if (self.state_saved) self.state_saved[params.frm_id] = params.data;
				}
			});
		},

		init: function () {
			$('.form_autoSave').each(function () {
				let frm_id = Math.floor(1000 + Math.random()*8999);
				$(this).attr('data-frm-id', frm_id);
				self.state_saved[frm_id] = self.state_noticed[frm_id] = $(this).serialize();
			}).bind('change keyup', function() {
				let frm_id = $(this).attr('data-frm-id');
				let this_state = $(this).serialize();

				if (self.state_saved[frm_id] !== this_state) {
					$(this).addClass('form_autoSave-changed');
					$(this).find('.ws-btn-reset').toggle(!App.forms.check_defaults(this));

					if (self.saveTimers[frm_id]) {
						clearTimeout(self.saveTimers[frm_id]);
					}

					self.saveTimers[frm_id] = setTimeout(function() {
						self.request_save({
							frm_id: frm_id,
							endpoint: $(this).attr('action'),
							data: this_state,
						});
						delete self.saveTimers[frm_id];
					}.bind(this), 1000);

					self.state_noticed[frm_id] = this_state;
				} else {
					if (self.saveTimers[frm_id]) {
						clearTimeout(self.saveTimers[frm_id]);
						delete self.saveTimers[frm_id];
					}
					$(this).removeClass('form_autoSave-changed');
				}
			});
		},

		onLoadPage: function () {
			self.init();
		}
	}
})();

;(function() {
	let self = App.controls.header = {
		obj_window: null,
		obj_search_input: null,

		show_menu: function (menu_anchor) {
			if (self.is_without_tabs() && self.is_view_updated()) {
				App.controls.view_list.show_menu(App.controls.view_list.get_active_item(), {
					menu_anchor,
				});
				return;
			}

			if (App.device.is_mobile()) {
				const url = App.helper.url.add_query(
					App.helper.endpoint.primary(),
					App.actions.get('header_sections_menu:show'),
				);
				App.menu.show({
					anchor: menu_anchor,
					url,
					onshow: function () {

						const { page, subpage } = App.current_page;

						const menu = $(this);
						const items = App.controls.menu.get_items(menu);
						const item = items.filter(function () {
							const this_page = $(this).attr('data-page');
							const this_subpage = $(this).attr('data-subpage');
							return this_page == page && this_subpage == subpage;
						});

						App.controls.menu.item_set_active(item);
					}
				});
			}
		},

		show_home_menu: function (anchor) {
			App.menu.show({
				anchor,
				box: '#sidebarAccMenu',
				type: 'bottom right',
				onshow: function () {
					const menu = $(this);
					menu.find('.menu__group-account').addClass('menu__group-hidden');
				},
				onhide: function () {
					const menu = $(this);
					menu.find('.menu__group-account').removeClass('menu__group-hidden');
				},
			});
		},

		is_without_tabs: function() {
			return Boolean(self.obj_window.find('.viewsList_hidden').length);
		},

		is_view_updated: function() {
			return Boolean(self.obj_window.find('.viewsList__item-active.viewsList__item-updated').length);
		},

		onLoadPage: function () {
			self.obj_window = $('#headerGeneral');

			self.obj_window.find('.but_search').bind('click', function() {
				self.obj_window.toggleClass('headerGeneral-withSearch');
				App.controls.view_list.onresize();
				return false;
			});
			self.obj_window.find('.but_expand').bind('click', function() {
				self.obj_window.toggleClass('headerGeneral-collapsed');
				$.ajax({
					type: 'POST',
					url: App.helper.url.add_query(
						App.helper.endpoint.ajax(),
						App.actions.get('common_user_config_save:apply'),
						// {debug: 1}
					),
					data: {
						name: 'prj_header_collapsed',
						value: self.obj_window.hasClass('headerGeneral-collapsed')
					}
				});
				App.controls.view_list.onresize();
				self._init_but_expand_hint();
				return false;
			});

			self._init_but_expand_hint();
		},

		_init_but_expand_hint: () => {
			let title = App.object_state.locale?.header?.collapse;
			if (self.obj_window.hasClass('headerGeneral-collapsed')) {
				title = App.object_state.locale?.header?.expand;
			}

			self.obj_window.find('.but_expand').attr('data-title', title);
		},


		destructor: function () {
			self.obj_window = null;
			self.obj_search_input = null;
		},

		onLogout: () => self.destructor(),
	}
})();

;(function() {
	let self = App.controls.import_preview = {
		error_count: 0,
		locale: {}, // from template
		endpoint: '',

		update_error: function(me, type) {
			let ico = me.find('span.ico_alert_sm'),
				icoClass = (type === 'info' ? 'ico_info' : 'ico_yes'),
				value = me.find('span.value'),
				itemRow = me.parent(),
				fix = $('.import_btn #fix_errors');
			if (ico.length) {
				ico.toggleClass('ico_alert_sm ' + icoClass).removeAttr('data-title');
				value.removeAttr('data-title');
				me.removeAttr('data-error');
				self.error_count--;
				if (!fix.hasClass('fixed')) fix.find('span').html(self.locale['fix_errors'] + ' (' + self.error_count + ')');
				if (!self.error_count) fix.remove();
			}
			if (!itemRow.find('.import_field[data-error]').length) {
				itemRow.removeClass('item_error');
			}
		},

		update_title: function(me) {
			let parent = $(me).parent(),
				a = parent.find('a.onch');

			if (!$(me).val()) {
				$(me).blink();
			} else {
				$(me).attr('value', $(me).val());
				$(me).addClass('hide');
				a.html($(me).val());
				a.attr('data-title', $(me).val());
				a.removeClass('hide');
				parent.find('._tags').removeClass('hide');
			}
			return false;
		},

		remove_date: function(me) {
			let itemRow = me.parent(),
				lastClass = me.attr('class').split(' ').pop(),
				id = itemRow.attr('data-id'),
				startdate = (lastClass === 'import_start_date');
			me.find('a').html(me.attr('data-default'));
			me.find('input').attr('name', (startdate ? 'datestart[' : 'dateend[') + id + ']')
			me.find('input').attr('value', 0);
			me.find('.ico_remove').addClass('hide');

			self.update_error(itemRow.find('.import_end_date'));
			self.check_date_error(me);
		},

		check_date_error: function(me) {
			let itemRow = me.parent(),
				enddate = itemRow.find('.import_end_date'),
				startdate = itemRow.find('.import_start_date'),
				fix = $('.import_btn #fix_errors');

			if (startdate.find('a.onch').html() !== startdate.attr('data-default') && enddate.find('a.onch').html() === enddate.attr('data-default')) {
				enddate.find('span.ico_yes').remove();
				enddate.find('a.onch').parent().prepend($('<ws-icon name="exclam_triangle-solid"></ws-icon>').attr('data-title', self.locale['need_dateend']));
				itemRow.addClass('item_error');
				enddate.attr('data-error', self.locale['need_dateend'])
				self.error_count++;
				fix.find('span').html(self.locale['fix_errors'] + ' (' + self.error_count + ')');
				if (fix.hasClass('fixed')) fix.remove();
			}
		},

		init: function() {
			$('.import_field .ico_remove').on('click', function () {
				self.remove_date($(this).parent().parent());
			});
			$('.import_user_from span.value a.onch').on('click', function () {
				App.menu.show({anchor: this, box: '#dropcopyusermenu-author', type: '', title: self.locale['author']});
				return false;
			});
			$('.import_user_to span.value a.onch').on('click', function () {
				App.menu.show({anchor: this, box: '#dropcopyusermenu-assignee', type: '', title: self.locale['assignee']});
				return false;
			});
			$('.import_start_date a, .import_end_date a').on('click', function () {
				let input = $(this).prev();
				input.datepicker({
					rangeSelect: false,
					numberOfMonths: 2,
					onSelect: function (dateText) {
						let parent = $(this).parent().parent(),
							id = parent.parent().attr('data-id'),
							lastClass = parent.attr('class').split(' ').pop();
						$(this).attr('name', (lastClass === 'import_start_date' ? 'datestart[' : 'dateend[') + id + ']');
						$(this).val(dateText);
						parent.find('a').html(dateText);
						parent.find('.ico_remove').removeClass('hide');
						self.update_error(parent);
						self.check_date_error(parent);
					},
					beforeShowDay: App.controls.datepicker.helper_draw_holidays
				});
				input.datepicker('show');
				return false;
			});

			$('.import_title a.onch').on('click', function () {
				let parent = $(this).parent(),
					id = parent.parent().attr('data-id'),
					input = parent.find('input');
				if ($('.import_title input[value=""]').length) return false;
				$(this).addClass('hide');
				parent.find('._tags').addClass('hide');
				if (input.length) {
					input.removeClass('hide');
				} else {
					parent.append($('<input/>').addClass('input2 wide2').attr('name', 'name[' + id + ']').attr('value', $(this).html()));
					input = parent.find('input.input2');
					input.on('keydown', function (e) {
						if (e.keyCode === App.keycode.Enter) {
							self.update_title(this);
							return false
						}
					});
					input.on('focusout', function () {
						self.update_title(this)
					});
				}
				input.focus();
			});
			$('.import_priority span').on('click', function () {
				App.controls.priority.open(this);
				return false;
			});
			$('#prioritySelectMenu span').on('click', function () {
				let span = $('.import_priority span.menu_open'),
					val = $(this).parent().attr('data-txt'),
					parent = span.parent(),
					id = parent.parent().attr('data-id'),
					input = parent.find('input');
				span.html(val);
				if (input.length) {
					input.val(val);
				} else {
					parent.append($('<input/>').attr('type', 'hidden').attr('name', 'important[' + id + ']').val(val));
				}
				span.attr('class', 'priorb ' + $(this).parent().find('span:first-child').attr('class'));
				App.menu.hide();
			});
			$('#dropcopyusermenu-author a, #dropcopyusermenu-assignee a').bind('click', function () {
				let parent = $(App.menu.active_anchor).parent().parent();
				console.log(App.menu.active_anchor);
				parent.removeAttr('data-can-add');
				parent.removeClass('add_users');
				let id = parent.parent().attr('data-id'),
					parClass = parent.attr('class'),
					lastClass = parClass.split(' ').pop(),
					value;
				parent.find('input').attr('name', (lastClass === 'import_user_from' ? 'id_user_from[' : 'id_user_to[') + id + ']');
				value = $(this).attr('rel');
				if ($(this).html().indexOf(self.locale['anyone']) !== -1) value = 'ANY';
				if ($(this).html().indexOf(self.locale['no_assignee']) !== -1) value = 'NOONE';
				parent.find('input').val(value);
				self.update_error(parent);
			});

			$('.import_btn #btn-import').on('click', function () {
				let errors = $('.preview_import.item_error'),
					fields = {};

				$('#modfrm').find(':input[name]').each(function () {
					fields[this.name] = $(this).val();
				});

				if (errors.length) {
					$(this).shake(3, 5, 300);
				} else {
					$('.import_btn #fix_errors').hide();
					$(this).parent().html(App.config.loader_html);
					$.ajax({
						type: "POST",
						url: self.endpoint,
						data: fields,
						success: function (response) {
							document.location.href = response;
						}
					});
				}
				return false;
			});
			$('.import_btn #fix_errors').on('click', function () {
				this.blur();
				if ($(this).hasClass('fix')) {
					$('.preview_import.item_error').each(function () {
						let author = $(this).find('.import_user_from'),
							author_value = author.find('.value'),
							author_ico = author.find('ws-icon'),
							assignee = $(this).find('.import_user_to'),
							assignee_value = assignee.find('.value'),
							assignee_ico = assignee.find('ws-icon'),
							startdate = $(this).find('.import_start_date'),
							startdate_value = startdate.find('a.onch'),
							enddate = $(this).find('.import_end_date'),
							enddate_value = enddate.find('a.onch'),
							enddate_ico = enddate.find('ws-icon'),
							id = $(this).attr('data-id');

						if (author.length && author.attr('data-error')) {
							if (author.attr('data-can-add')) {
								$('.import_btn #add_users').click();
							} else {
								author.find('a.onch').html(self.locale['import_name']);
								author.attr('data-error-old', author.attr('data-error'));
								author.removeAttr('data-error');
								author_value.attr('data-title-old', author_value.attr('data-title'));
								author_value.removeAttr('data-title');
								author_ico.attr('name', 'check_alt');
								author_ico.attr('data-title-old', author_ico.attr('data-title'));
								author_ico.removeAttr('data-title');
								author.find('input').attr('name', 'id_user_from[' + id + ']').attr('value', self.locale['me_id']);
							}
						}
						if (assignee.length && assignee.attr('data-error')) {
							assignee.find('a.onch').html(self.locale['no_assignee']);
							assignee.attr('data-error-old', assignee.attr('data-error'));
							assignee.removeAttr('data-error');
							assignee_value.attr('data-title-old', assignee_value.attr('data-title'));
							assignee_value.removeAttr('data-title');
							assignee_ico.attr('name', 'check_alt');
							assignee_ico.attr('data-title-old', assignee_ico.attr('data-title'));
							assignee_ico.removeAttr('data-title');
							assignee.find('input').attr('name', 'id_user_to[' + id + ']').attr('value', 'NOONE');
						}
						if (enddate.length && enddate.attr('data-error')) {
							enddate_value.html(startdate_value.html());
							enddate.find('input').attr('name', 'dateend[' + id + ']').attr('value', startdate_value.html());
							enddate_ico.attr('name', 'check_alt');
							enddate_ico.attr('data-title-old', enddate_ico.attr('data-title'));
							enddate_ico.removeAttr('data-title');
							startdate_value.attr('data-html-old', startdate_value.html());
							startdate_value.html(startdate.attr('data-default'));
							startdate.find('input').attr('name', '').attr('value', '');
							enddate.find('.ico_remove').removeClass('hide'); // show delete-date button
							startdate.find('.ico_remove').addClass('hide');  // hide delete-date button
						}
						$(this).removeClass('item_error');
						$(this).addClass('item_error_fixed');
					});
					$(this).find('span').html(self.locale['back']);
					$(this).removeClass('fix').addClass('fixed');
				} else {
					$(this).find('span').html(self.locale['fix_errors'] + ' (' + self.error_count + ')');
					$('.preview_import.item_error_fixed').each(function () {
						let author = $(this).find('.import_user_from'),
							author_value = author.find('.value'),
							author_ico = author.find('ws-icon'),
							assignee = $(this).find('.import_user_to'),
							assignee_value = assignee.find('.value'),
							assignee_ico = assignee.find('ws-icon'),
							startdate = $(this).find('.import_start_date'),
							startdate_value = startdate.find('a.onch'),
							enddate = $(this).find('.import_end_date'),
							enddate_value = enddate.find('a.onch'),
							enddate_ico = enddate.find('ws-icon'),
							id = $(this).attr('data-id');

						if (author.length && author.attr('data-error-old') && !author.hasClass('add_users')) {
							author.find('a.onch').html(author_value.attr('data-title-old'));
							author.attr('data-error', author.attr('data-error-old'));
							author.removeAttr('data-error-old');
							author_value.attr('data-title', author_value.attr('data-title-old'));
							author_value.removeAttr('data-title-old');
							author_ico.attr('name', 'exclam_triangle-solid');
							author_ico.attr('data-title', author_ico.attr('data-title-old'));
							author_ico.removeAttr('data-title-old');
							author.find('input').removeAttr('name').attr('value', author.attr('data-can-add') ? author.attr('data-can-add') : '');
						}
						if (assignee.length && assignee.attr('data-error-old') && !assignee.hasClass('add_users')) {
							assignee.find('a.onch').html(assignee_value.attr('data-title-old'));
							assignee.attr('data-error', assignee.attr('data-error-old'));
							assignee.removeAttr('data-error-old');
							assignee_value.attr('data-title', assignee_value.attr('data-title-old'));
							assignee_value.removeAttr('data-title-old');
							assignee_ico.attr('name', 'exclam_triangle-solid');
							assignee_ico.attr('data-title', assignee_ico.attr('data-title-old'));
							assignee_ico.removeAttr('data-title-old');
							assignee.find('input').removeAttr('name').attr('value', assignee.attr('data-can-add') ? assignee.attr('data-can-add') : '');
						}
						if (enddate.length && enddate.attr('data-error')) {
							startdate_value.html(startdate_value.attr('data-html-old'));
							startdate.find('input').attr('name', 'datestart[' + id + ']').attr('value', startdate_value.attr('data-html-old'));
							startdate_value.removeAttr('data-html-old');
							enddate_ico.attr('name', 'exclam_triangle-solid');
							enddate_ico.attr('data-title', enddate_ico.attr('data-title-old'));
							enddate_ico.removeAttr('data-title-old');
							enddate_value.html(enddate.attr('data-default'));
							enddate.find('input').attr('name', '').attr('value', '');
							startdate.find('.ico_remove').removeClass('hide'); // show delete-date button
							enddate.find('.ico_remove').addClass('hide');  // hide delete-date button
						}
						$(this).removeClass('item_error_fixed');
						$(this).addClass('item_error');
					});
					$(this).removeClass('fixed').addClass('fix');
				}
			});
			$('.import_btn #add_users').on('change', function () {
				let fix = $('.import_btn #fix_errors'),
					fields = ['author', 'assignee'];

				if (this.checked) {
					$(this).attr('name', 'add_users');
					$('.preview_import.item_error').each(function () {
						let author = $(this).find('.import_user_from'),
							author_value = author.find('.value'),
							author_ico = author.find('ws-icon'),
							assignee = $(this).find('.import_user_to'),
							assignee_value = assignee.find('.value'),
							assignee_ico = assignee.find('ws-icon'),
							me = $(this),
							id = me.attr('data-id');

						fields.forEach(function (item) {
							if (eval(item).attr('data-can-add')) {
								eval(item).attr('data-error-old', eval(item).attr('data-error'));
								eval(item).find('input').attr('name', (item === 'author' ? 'id_user_from' : 'id_user_to') + '[' + id + ']');
								eval(item + '_value').attr('data-title-old', eval(item + '_value').attr('data-title'));
								eval(item + '_ico').attr('data-title-old', eval(item + '_ico').attr('data-title'));
								me.addClass('add_users');
								eval(item).addClass('add_users');
								self.update_error(eval(item), 'info');
								eval(item + '_ico').attr('data-title', self.locale['user_will_be_added']);
							}
						});
					});
				} else {
					$(this).removeAttr('name');
					$('.preview_import.add_users').each(function () {
						let author = $(this).find('.import_user_from'),
							author_value = author.find('.value'),
							author_ico = author.find('ws-icon'),
							assignee = $(this).find('.import_user_to'),
							assignee_value = assignee.find('.value'),
							assignee_ico = assignee.find('ws-icon'),
							me = $(this);

						fields.forEach(function (item) {
							if (eval(item).attr('data-can-add')) {
								eval(item).attr('data-error', eval(item).attr('data-error-old'));
								eval(item).removeAttr('data-error-old');
								eval(item).find('input').removeAttr('name');
								eval(item + '_value').attr('data-title', eval(item + '_value').attr('data-title-old'));
								eval(item + '_value').removeAttr('data-title-old');
								eval(item + '_ico').attr('data-title', eval(item + '_ico').attr('data-title-old'));
								eval(item + '_ico').removeAttr('data-title-old');
								eval(item + '_ico').removeClass('ico_info').addClass('ico_alert_sm');
								eval(item).removeClass('add_users');
								me.removeClass('add_users');
								me.addClass('item_error');
								self.error_count++;
								if (!fix.hasClass('fixed')) fix.find('span').html(self.locale['fix_errors'] + ' (' + self.error_count + ')');
							}
						});
					});
				}
			});
		},
	}
})();

;(function() {
	let self = App.controls.inline_delete = {
		active: false,
		timeout: null,
		show: function (o, save) {
			if (self.active) $('.pre_delete, .pre_save').removeClass('pre_delete pre_save'); else self.active = true;
			if (save) o.addClass('pre_save'); else o.addClass('pre_delete');
			if (self.timeout) clearTimeout(self.timeout);
			self.timeout = setTimeout(function () {
				$('.pre_delete').removeClass('pre_delete');
				$('.pre_save').removeClass('pre_save');
				self.active = false;
				self.timeout = null;
			}, 3000);
		},
		cancel: function () {
			$('.pre_delete, .pre_save').removeClass('pre_delete pre_save');
			if (self.timeout) clearTimeout(self.timeout);
			self.active = false;
			self.timeout = null;
		}
	}
})();

;(function() {
	let self = App.controls.inline_edit = {
		id: 0,
		obj: null,
		parent: null,
		position: null,
		content: null,
		endpoint: '',
		start: function(el, endpoint, id) {
			App.menu.hide();
			if (self.obj) self.end();
			self.id = id;
			self.obj = $(el);
			self.parent = self.obj.parent();
			self.position = self.obj.next();
			if (!self.obj.length) {
				self.obj = null;
				return false;
			}
			self.endpoint = endpoint;
			self.content = self.obj.detach();
			self.parent.addClass('inline-edit');

			let text_target = self.content.find('*[data-inline-edit-text]');
			let txt = '';

			if (text_target.length === 1) {
				txt = text_target.text();
			} else {
				let txt_nodes = self.content.contents().filter((i, n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim() !== '');
				if (txt_nodes.length > 0) {
					txt = txt_nodes[0].textContent.trim();
				}
			}


			let obj = self.position.length ? $('<input type="text" />').val(txt).insertBefore(self.position) : $('<input type="text" />').val(txt).appendTo(self.parent);
			obj.focus().bind('keydown', function(e) {
				let key = e.keyCode || e.charCode;
				e.stopPropagation();
				if (key === App.keycode.Enter) {
					if (this.value) self.save(this.value); else self.end();
					return false;
				} else if (key === App.keycode.Escape) {
					self.end();
					return false;
				}
			}).bind('blur', () => self.end());
		},
		save: function(value) {
			$.ajax({
				url: self.endpoint + '&id=' + self.id + '&name=' + encodeURIComponent(value),
				success: function () {
					self.content.text(value);
					self.end();
				}
			});
		},
		end: function() {
			self.parent.removeClass('inline-edit');
			self.parent.find('input').remove();
			if (self.position.length) {
				self.content.insertBefore(self.position);
			} else {
				self.parent.append(self.content);
			}
			self.obj = null;
			self.content = null;
		}
	}
})();

;(function() {
	let self = App.controls.js_scrollbars = {
		ps: null,
		exclude_pages: ['tasks_grid', 'kanban', 'kanban_days', 'users_tasks', 'projects_kanban'],
		onLoadPage: function() {
			if (self.exclude_pages.includes(App.page.where())) {
				self.destroy(self.ps);
				self.ps = null;
			} else {
				self.ps = self.init('#content');
			}
		},
		onUnloadPage: function() {
			self.destroy(self.ps);
			self.ps = null;
		},

		init: function(scrollZone, config) {
			config ||= {}
			config.handlers = ['click-rail', 'drag-thumb'];
			if (typeof scrollZone == 'string') scrollZone = document.querySelector(scrollZone);
			if (!scrollZone) return null;
			let ps = new PerfectScrollbar(scrollZone, config);
			ps.scrollTarget = scrollZone;
			if (App.modal.is_shown()) {
				if ("IntersectionObserver" in window) {
					const observer = new IntersectionObserver((entries) => {
						entries.forEach(entry => {
							if (entry.isIntersecting) {
								entry.target.classList.add('scrollZone--in-view');
								entry.target.classList.remove('scrollZone--out-of-view');
							} else {
								entry.target.classList.remove('scrollZone--in-view');
								entry.target.classList.add('scrollZone--out-of-view');
							}
						});
					}, {
						root: scrollZone.parentElement?.closest('.scrollZone') || null,
						threshold: 0.4
					});
					observer.observe(scrollZone);
					ps.intersectionObserver = observer;
				}
			}
			if ("ResizeObserver" in window) {
				ps.resizeObserver = new ResizeObserver(function() {
					if (ps.tm) clearTimeout(ps.tm);
					ps.tm = setTimeout(() => ps.update(), 50)
				});
				ps.resizeObserver.observe(scrollZone);
			}
			if ("MutationObserver" in window) {
				ps.mutationObserver = new MutationObserver(mutationRecords => {
					for (let i in mutationRecords) {
						if (mutationRecords[i].target.classList == null) return false
						if (mutationRecords[i].target.classList.contains('ps')) return false
						if (mutationRecords[i].type !== 'attributes' ||
							(mutationRecords[i].attributeName === 'class' && (mutationRecords[i].oldValue?.includes('hidden') || mutationRecords[i].target.className.includes('hidden')))
						   ) {
							if (ps.tm) clearTimeout(ps.tm);
							ps.tm = setTimeout(() => ps.update(), 50);
							return;
						}
					}
				});
				ps.mutationObserver.observe(scrollZone, {
					attributes: true,
					attributeOldValue: true,
					childList: true,
					subtree: true,
					characterData: config.watchText || false
				});
			}
			return ps;
		},

		destroy: function(ps) {
			if (!ps) return;
			if (ps.resizeObserver) {
				ps.resizeObserver.unobserve(ps.scrollTarget);
				ps.resizeObserver = null;
			}
			if (ps.mutationObserver) {
				ps.mutationObserver.disconnect();
				ps.mutationObserver = null;
			}
			if (ps.intersectionObserver) {
				ps.intersectionObserver.unobserve(ps.scrollTarget);
				ps.intersectionObserver.disconnect();
				ps.intersectionObserver = null;
			}
			ps.destroy();
		},

		waitSmoothScrolling: function(ps) {
			ps.isAlive = false;
			App.helper.scroll.waitSmoothScrolling(ps.scrollTarget, function() {
				ps.isAlive = true;
				ps.scrollTarget.dispatchEvent(new Event("scroll"));
				App.scroll_listener.onDivScroll.call(ps.scrollTarget);
			});
		}
	}
})();

;(function() {
	let self = App.controls.keyboard_detect = {

		initialWindowHeight: window.innerHeight, // support `interactive-widget=resizes-content`

		is_shown: function () {
			return $('body').hasClass('w_keyboard');
		},

		// onresize: function () {
		// 	if (self.previous_screen_height) {
		// 		if (100 + self.previous_screen_height < $(window).height() && $(window).width() === self.previous_screen_width && $('body').hasClass('mobile')) {
		// 			$('body').removeClass('w_keyboard');
		// 		}
		// 		if (self.previous_screen_height && (self.previous_screen_height - 100 > $(window).height()) && $(window).width() === self.previous_screen_width && $('body').hasClass('mobile')) {
		// 			$('body').addClass('w_keyboard');
		// 			if ($('.editor .data').length && document.activeElement && $(document.activeElement).is('.data')) {
		// 				$(window).scrollTop($('.editor').offset().top - 50);
		// 			}
		// 		}
		// 	}
		// 	self.previous_screen_height = $(window).height();
		// 	self.previous_screen_width = $(window).width();
		// },

		last_state: false,
		onresize_viewport: function() {

			let keyboard_state = window.innerHeight - 200 > window.visualViewport.height;

			// console.log('keyboard_state1: ', keyboard_state); // 4 debug
			// support `interactive-widget=resizes-content`
			if (Math.abs(window.innerHeight - window.visualViewport.height) < 5) {
				keyboard_state = self.initialWindowHeight - 200 > window.innerHeight;
				// console.log('keyboard_state2: ', keyboard_state); // 4 debug
			}

			$(':root').css('--keyboard-height', App.helper.viewport.keyboard_height()+'px');
			if (keyboard_state !== self.last_state) {
				self.last_state = keyboard_state;
				$('body').toggleClass('w_keyboard', keyboard_state);
				App.bus.window.emit(keyboard_state ? 'keyboard_show' : 'keyboard_hide');
			}
		},

		debounce: function(o, retry) {
			retry ||= 0;
			let pos = o.css('margin-top', '').get(0).getBoundingClientRect().top;
			if (pos < -1) {
				o.css('margin-top', -pos);
			} else {
				if (retry > 0) setTimeout(() => self.debounce(o, retry - 1), 100);
			}
		},

		toggleFakeKeyboard: function() {
			console.warn('For debug purposes only!');
			$('body').toggleClass('w_keyboard');
			$(':root').css('--keyboard-height', self.is_shown() ? '340px' : '0px');
			if (self.is_shown()) $('body').append($('<div>', { id: 'fakeKeyboard' }));
			else $('#fakeKeyboard').remove();
			App.bus.window.emit(self.is_shown() ? 'keyboard_show' : 'keyboard_hide');
		},

		onBoot: function () {
			if (App.hybrid_app) return;

			// App.bus.window.on('resize', App.helper.throttle(self.onresize))
			App.bus.window.on('resize_viewport', App.helper.just_throttle(self.onresize_viewport));
			App.bus.window.on('keyboard_show', App.helper.debounce((payload, context) => {
				$(document.activeElement).scrollIntoViewIfNeeded({ offset_block: 20 });
			}, 300));
			App.bus.window.on('scroll_viewport', App.helper.just_throttle(() => {
				$(':root').css('--visualViewport-offsetTop', visualViewport.offsetTop+'px');
			}));

			let heightUpdateTimeout;
			// це має пофіксити на IOS проскролл вьюпорта
			document.addEventListener('focus', (event) => {
				if (!App.device.is_mobile()) return; // можливо ще чекнути андройд
				const is_editable = event.target.isContentEditable
					|| event.target.tagName === 'INPUT'
					|| event.target.tagName === 'TEXTAREA';
				if (!is_editable) return; // можливо ще чекнути що лежить всередині фіксованого елемента
				clearTimeout(heightUpdateTimeout, 10);
				heightUpdateTimeout = setTimeout(() => {
					$(':root').css('--keyboard-height', App.helper.viewport.keyboard_height()+'px');
				});
				event.target.style.opacity = 0;
				setTimeout(() => event.target.style.opacity = 1, 100);
			}, true);
			document.addEventListener('blur', (event) => {
				if (!App.device.is_mobile()) return; // можливо ще чекнути андройд
				const is_editable = event.target.isContentEditable
					|| event.target.tagName === 'INPUT'
					|| event.target.tagName === 'TEXTAREA';
				if (!is_editable) return; // можливо ще чекнути що лежить всередині фіксованого елемента
				clearTimeout(heightUpdateTimeout, 10);
				heightUpdateTimeout = setTimeout(() => {
					$(':root').css('--keyboard-height', '0px');
				});
			}, true);
		}
	}
})();

;(function() {
	let self = App.controls.loader = {

		debug: false,

		replace_this: function (o) {
			o.hide().after('<span class="loader_sm"></span>');
			window.loader_tm = setTimeout(function () {
				App.menu.hide();
			}, 5000)
		},

		start: function () {
			$('body').addClass('loading').eachDelayed(function() {
				$(this).one('transitionend', () => App.controls.swipe_reload.stop());
				$(this).addClass('loading_start');
			}, 1);
		},

		stop: function() {
			$('body').removeClass('loading').eachDelayed(function() {
				$(this).removeClass('loading_start')
			}, 10);
		},

		overlay: {
			start: function(elements, options) {
				options ||= {};
				const { overlayTheme, loaderStyle, loaderSize } = options;
				self.overlay._each(elements, (el, is_loading) => {
					if (is_loading) {
						if (self.debug) console.warn('already loading');
						return;
					}
					el.attr('data-loading', true);
					if (overlayTheme || loaderStyle || loaderSize) {
						$('<div />')
							.addClass([
								'loading-overlay',
								'loading-overlay--'+(overlayTheme ?? 'default'),
							])
							.append(
								$('<div />')
									.addClass([
										'loader',
										loaderStyle ? 'loader--'+loaderStyle : 'loader--curling',
										loaderSize ? 'loader--'+loaderSize : 'loader--md',
									])
							).appendTo(el);
					} else {
						self.overlay._get_loader().clone().appendTo(el);
					}
				});
			},
			stop: function (elements) {
				self.overlay._each(elements, (el, is_loading) => {
					if (!is_loading) {
						if (self.debug) console.warn('not loading');
						return;
					}
					el.removeAttr('data-loading');
					el.children('.loading-overlay').remove();
				});
			},
			_loader: null,
			_get_loader: function () {
				if (!self.overlay._loader) {
					const loader = $('#loadingOverlay').clone();
					loader.removeAttr('id');
					loader.addClass('loading-overlay');
					self.overlay._loader = loader;
				}
				return self.overlay._loader;
			},
			_each: function (elements, callback) {
				$(elements).each(function () {
					const el = $(this);
					const is_loading = el.attr('data-loading') === 'true';

					callback(el, is_loading);
				});
			}
		},

		ask_reload: {
			show: function(elements, options) {
				options = {
					overlayTheme: 'light',
					overlayBlur: true,
					onclick: () => { console.warn('Pass your own callback'); },
					...options,
				};
				const { overlayTheme, overlayBlur, onclick } = options;
				self.ask_reload._each(elements, (el, is_shown) => {
					if (is_shown) {
						el.children('.askReloadOverlay').remove();
						// if (self.debug) console.warn('ask_reload', 'already shown');
						// return;
					}
					el.attr('data-ask-reload', true);
					if (overlayTheme) {
						const content = '<ws-icon name="news/reload"></ws-icon>';
						$('<div />')
							.addClass([
								'askReloadOverlay',
								!overlayTheme ? '' : 'askReloadOverlay--theme-'+overlayTheme,
								!overlayBlur ? '' : 'askReloadOverlay--blur',
							])
							.on('click', () => {
								el.removeAttr('data-ask-reload');
								el.children('.askReloadOverlay').remove();
								onclick?.call();
							})
							.append(content)
							.appendTo(el);
					}
				});
			},
			exec: function(elements) {
				self.ask_reload._each(elements, (el, is_shown) => {
					if (!is_shown) {
						if (self.debug) console.warn('ask_reload', 'not shown');
						return;
					}
					el.children('.askReloadOverlay').first().trigger('click');
				});
			},
			hide: function (elements) {
				self.ask_reload._each(elements, (el, is_shown) => {
					if (!is_shown) {
						if (self.debug) console.warn('ask_reload', 'not shown');
						return;
					}
					el.removeAttr('data-ask-reload');
					el.children('.askReloadOverlay').remove();
				});
			},
			_each: function (elements, callback) {
				elements.each(function () {
					const el = $(this);
					const is_shown = el.attr('data-ask-reload') === 'true';

					callback(el, is_shown);
				});
			}
		},
	}
})();

;(function() {
	let self = App.controls.main_plus = {

		add_task: function () {
			if (typeof $('.quick_ta:first').attr('href') == 'undefined') $('.quick_ta:first').trigger('click'); else App.core.goto($('.quick_ta:first').attr('href'));
		},

		onLoadPage: function () {
			$('#primaryMenu .primaryMenu__item-plus, #headerGeneral .headerGeneral__buttons .but_plus').once_by_criteria('plus_click').not('.alt').bind('mousedown', function (e) {
				if (e.which === 2) {
					$('#sidebarAddMenu .quick_ta:first').each(function () {
						App.core.new_window(this.href);
					});
					return false;
				}
			}).bind('click dblclick', function (e) {
				if (App.click_listener.is_moved(e)) return false;
				let a = $('#sidebarAddMenu a');
				if (a.length == 1) {
					if (typeof a.attr('href') == 'undefined') a.trigger('click'); else App.core.goto(a.attr('href'));
					return false;
				}
				if (App.device.is_mobile()) {
					App.menu.show({anchor: this, box: '', type: '', title: ' '});
					return false;
				}
				if (e.shiftKey) {
					a.filter('.quick_ta:first').each(function () {
						App.core.goto(this.href);
					});
					return false;
				}
				if (e.metaKey || e.ctrlKey) {
					a.filter('.quick_ta:first').each(function () {
						App.core.new_window(this.href);
					});
					return false;
				}
				if (e.type == 'dblclick') {
					App.click_listener.longclick.stop(e);
					$(this).removeClass('clicked clicked2');
					a = a.filter('.quick_ta:first');
					if (typeof a.attr('href') == 'undefined') a.trigger('click'); else App.core.goto(a.attr('href'));
					return false;
				} else {
					App.click_listener.longclick.call(function (el) {
						App.menu.show({anchor: el, box: '', type: 'fixed', title: ' '});
					}, this);
				}
				return false;
			});
		}
	}
})();

;(function () {

	let self = App.controls.me = {

		endpoint: function() {
			return App.helper.endpoint.user(App.me.id);
		},

		notify: {
			request: null,

			set_mute_until: App.helper.debounce(function (mute_until) {
				self.notify.request.ajax(self.endpoint() + '?' + App.actions.get('user_profile_notifications:mute') + '&mute_until=' + mute_until);
			}, 999),

			set_sound: App.helper.debounce(function (sound_on) {
				self.notify.request.ajax(self.endpoint() + '?' + App.actions.get('user_profile_notifications:mute') + '&sound_on=' + (sound_on ? 1 : 0));
			}, 999),

			destructor: function () {
				self.notify.request.abort();
			},
		},

		menu: {
			obj: null,
			request: null,
			tmp_html: null,

			is_shown: function() {
				return self.menu.obj && self.menu.obj.hasClass('menu-active');
			},

			reload: function() {
				if (!self.menu.obj) return;
				self.menu.request.ajax({
					url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('primary_menu:profile_menu_show')),
				}).then(html => {
					if (self.menu.is_shown()) {
						self.menu.tmp_html = html;
					} else {
						self.menu.obj.replaceWith(html);
						self.menu.init();
					}
				});
			},

			init: function() {
				self.menu.obj = $('#sidebarProfileMenu');

				self.menu.obj.on('click', 'a.menu__item-notify', function (e) {
					let sw = $(this).find('.sw_pre');

					if ($(e.target).closest('.sw_pre').length) {
						self.notify.set_mute_until(App.me.notify.mute_until = sw.hasClass('sw_act') ? App.helper.time.now() + 365*86400 : 0);
						self.menu.update_notify_menu_item();
						return;
					}

					if (sw.hasClass('sw_act')) {
						let wrapper = $(this).closest('.menu__submenuWrapper');
						App.menu.show({
							anchor: wrapper,
							box: wrapper.children('.menu').get(0),
							backup: true,
							type: wrapper.attr('data-direction') || 'submenu',
							width: 250
						});
					} else {
						self.notify.set_mute_until(App.me.notify.mute_until = 0);
						self.menu.update_notify_menu_item();
					}
				});

				self.menu.obj.on('click', '.menu-notify .menu__item[data-option]', function () {
					let add;

					switch ($(this).attr('data-option')) {
						case '1h': add = 3600; break;
						case '2h': add = 2*3600; break;
						case 'tomorrow': add = App.helper.customDate.get('tomorrow') - App.helper.time.now(); break;
						case '7d': add = (App.helper.customDate.get('tomorrow') - App.helper.time.now()) + 7*24*3600; break;
					}

					if (add == null) return;

					App.menu.hide();
					self.notify.set_mute_until(App.me.notify.mute_until = App.helper.time.now() + add);
					self.menu.update_notify_menu_item();
				});

				self.menu.obj.on('click', 'a.menu__item-sound', function () {
					self.notify.set_sound(App.me.notify.sound_on = !$(this).find('span:last-child').hasClass('sw_act'));
					self.menu.update_sound_menu_item();
				});

				self.menu.update_notify_menu_item();
				self.menu.update_sound_menu_item();
			},

			update_notify_menu_item: function() {
				if (!self.menu.obj) return;

				let mute_until = App.me.notify.mute_until;
				let el = self.menu.obj.find('a.menu__item-notify'), is_on = true;

				if (mute_until === -1 || mute_until > App.helper.time.now()) {
					is_on = false;
				}

				el.find('.sw_pre').toggleClass('sw_act', is_on);

				if (is_on) {
					$(el).find('ws-icon').attr('name', 'notifications_alt');
					$(el).find('span.flex_content').text($(el).attr('data-base-label'));
					el.find('.sw_pre').show();
				} else {
					$(el).find('ws-icon').attr('name', 'notifications_off');
					$(el).find('span.flex_content').text($(el).attr('data-unmute-label'));
					el.find('.sw_pre').hide();
				}

				self.menu.update_notify_menu_item_countdown();
			},
			update_notify_menu_item_countdown: function() {
				let mute_until = App.me.notify.mute_until, el = self.menu.obj.find('a.menu__item-notify .cnt'),
					time_left = mute_until - App.helper.time.now();

				if (time_left > 1 && time_left < 30*24*3600) {
					if (time_left < 24*3600) {
						el.text(App.format.time_to_HHMMSS(time_left));
					} else {
						el.text(App.format.time_diff(time_left));
					}
					el.show();
				} else {
					el.text('');
					el.hide();
				}
			},
			update_sound_menu_item: function() {
				let is_on = App.me.notify.sound_on;
				let el = self.menu.obj.find('a.menu__item-sound');
				$(el).find('span:last-child').toggleClass('sw_act', is_on);

				if (is_on) {
					$(el).find('ws-icon').attr('name', 'sound_on');
					$(el).find('span.flex_content').text($(el).attr('data-on-label'));
				} else {
					$(el).find('ws-icon').attr('name', 'sound_off');
					$(el).find('span.flex_content').text($(el).attr('data-off-label'));
				}
			},

			onshow: function () {
				self.menu.update_notify_menu_item();
				self.menu.update_sound_menu_item();
				App.helper.cron.add('update_notify_menu_item_countdown', self.menu.update_notify_menu_item_countdown, 1);
				App.sidebar.custom_menu_handler.call(self.menu.obj.get(0), self.menu.obj.get(0));
			},

			onhide: function () {
				App.helper.cron.remove('update_notify_menu_item_countdown');
				if (self.menu.tmp_html) {
					self.menu.obj.replaceWith(self.menu.tmp_html);
					self.menu.tmp_html = null;
					self.menu.init();
				}
			},

			destructor: function () {
				self.menu.obj = null;
				self.menu.tmp_html = null;
				self.menu.request.abort();
			},
		},

		destructor: function () {
			self.menu.destructor();
			self.notify.destructor();
		},

		onBoot: function () {
			self.notify.request = App.core.async_task.context('set_notify');
			self.menu.request = App.core.async_task.context('app_controls_me_menu_load');

			App.bus.state.on('user', function (user, ctx) {
				let should_update = App.me.id === user.id && user.data.notify && !ctx.active_tab;
				if (!should_update) return;

				App.me.notify.mute_until = user.data.notify.mute_until ?? App.me.notify.mute_until;
				App.me.notify.sound_on = user.data.notify.sound_on ?? App.me.notify.sound_on;

				self.menu.update_notify_menu_item();
				self.menu.update_sound_menu_item();
			});
		},
		onLogin: function () {
			App.helper.cron.add('update_notify_menu_item', self.menu.update_notify_menu_item);
			App.bus.app.on('menu_show', function (el) {
				if (self.menu.obj && self.menu.obj.is(el)) self.menu.onshow();
			}).on('menu_hide', function (el) {
				if (self.menu.obj && self.menu.obj.is(el)) self.menu.onhide();
			});
			App.bus.state.on('account_update', function () {
				self.menu.reload();
			});
		},
		onLogout: function () {
			App.helper.cron.remove('update_notify_menu_item');
			App.helper.cron.remove('update_notify_menu_item_countdown');
			self.destructor();
		}
	};

})();

;(function () {
	let self = App.controls.menu = {
		init: function (obj) {
			let menu = $(obj || App.menu.obj_window);
			menu.on('click', '.menu__group-collapsed', function (e) {
				$(this).removeClass('menu__group-collapsed');
			});


			// EXPANDABLE - схоже на menu__group-collapsed, але можна й з клавіатури робити
			menu.find('.menu__item-groupExpand').each(function () {
				$(this).removeClass('menu__itemFake').addClass('menu__item');
			});
			menu.on('click', '.menu__item-groupExpand', function (e) {
				e.preventDefault();
				e.stopImmediatePropagation();
				const group = $(this).closest('.menu__group');
				group.removeClass('menu__group-expandable');
				$(this).addClass('menu__itemFake').removeClass('menu__item').removeClass('menu__item-groupExpand');
				return false;
			});

			// MENU BUTTON `TOGGLE SEARCH CHOSEN`
			self.init_toggle_search_chosen(menu);

			// MENU BUTTON `TOGGLE SEARCH BOOKMARKS`
			self.init_toggle_search_bookmarks(menu);

			// MENU RADIO
			if (menu.find('.menu__group-radio').length) {
				menu.on('click', '.menu__group-radio .menu__item', function () {
					let groupRadio = $(this).closest('.menu__group-radio');
					groupRadio.find('.menu__item').removeClass('menu__item-active');
					$(this).addClass('menu__item-active');
				});
				menu.find('.menu__group-search input').bind('keyup', function () {
					App.context_search.menu.apply(this, menu);
				});
			}

			// MENU CHECKBOX
			if (menu.find('.menu__group-checkbox').length) {
				let lastClickedItem = null;
				menu.on('click', '.menu__group-checkbox .menu__item[data-id]', function (e) {
					let menuCheckbox = $(this).closest('.menu__group-checkbox');
					let menuGroupSubset = $(this).closest('.menu__group__subset');
					let menuGroupTitle = menuCheckbox.find('.menu__item-group');

					if (e.shiftKey && lastClickedItem && lastClickedItem.length && lastClickedItem.is(':visible')) {
						let items = menu.find('.menu__group-checkbox').find('.menu__item[data-id]:visible');
						let start = items.index(lastClickedItem);
						let end = items.index($(this));

						if (start > end) [start, end] = [end, start];

						let shouldActivate = lastClickedItem.hasClass('menu__item-active');

						items.slice(start, end + 1).each(function () {
							if ($(this).hasClass('menu__item-active') !== shouldActivate) {
								$(this).trigger('click'); // так врахується disabled etc
							}
						});

						lastClickedItem = $(this);
						return;
					}

					if ($(this).hasClass('menu__item-active')) {
						$(this).removeClass('menu__item-active');
						menu.find('.menu__item-active[data-id="' + $(this).attr('data-id') + '"]').trigger('click');
						menu.trigger('after_interaction');
						menuGroupSubset.find('.sw_pre').removeClass('sw_act');
						menuGroupTitle.filter('.sw_pre').removeClass('sw_act');
					} else {
						$(this).addClass('menu__item-active');
						menu.find('.menu__item[data-id="' + $(this).attr('data-id') + '"]:not(.menu__item-active)').trigger('click');
						menu.trigger('after_interaction');
						if (!menuGroupSubset.find('.menu__item:not(.menu__item-active').length) menuGroupSubset.find('.sw_pre').addClass('sw_act');
						if (!menuCheckbox.find('.menu__item:not(.menu__item-active').length) menuGroupTitle.filter('.sw_pre').addClass('sw_act');
					}

					lastClickedItem = $(this);
				});
				menu.on('click', '.menu__group-checkbox .sw_pre', function () {
					let menuCheckbox = $(this).closest('.menu__group-checkbox');
					let menuGroupSubset = $(this).closest('.menu__group__subset');
					let menuGroupTitle = menuCheckbox.find('.menu__item-group');

					if ($(this).hasClass('sw_act')) {
						$(this).removeClass('sw_act');
						if (menuGroupSubset.length) menuGroupSubset.find('.menu__item[data-id]').each(function () {
							$(this).removeClass('menu__item-active');
							menu.trigger('after_interaction');
						});
						menuGroupTitle.filter('.sw_pre').removeClass('sw_act');
						if ($(this).closest('.menu__item-group').length) {
							menuCheckbox.find('.menu__group__subset .sw_pre').removeClass('sw_act');
							menuCheckbox.find('.menu__item[data-id]').each(function () {
								$(this).removeClass('menu__item-active');
								menu.trigger('after_interaction');
							});
						}
					} else {
						$(this).addClass('sw_act');
						if (menuGroupSubset.length) menuGroupSubset.find('.menu__item[data-id]').each(function () {
							$(this).addClass('menu__item-active');
							menu.trigger('after_interaction');
						});
						if (!menuCheckbox.find('.menu__item:not(.menu__item-active').length) menuGroupTitle.filter('.sw_pre').addClass('sw_act');
						if ($(this).closest('.menu__item-group').length) {
							menuCheckbox.find('.menu__group__subset .sw_pre').addClass('sw_act');
							menuCheckbox.find('.menu__item[data-id]').each(function () {
								$(this).addClass('menu__item-active');
								menu.trigger('after_interaction');
							});
						}
					}
				});
				menu.bind('after_interaction', App.helper.just_throttle(function () {
					menu.find('.menu__item-withInput').each(function () {
						$(this).find('input[type=hidden]').val($(this).hasClass('menu__item-active') ? '1' : '0');
					})
					let overhead = menu.find('.menu__group-head');
					let defaultText = overhead.attr('data-default-text');
					let changeText = overhead.attr('data-change-text');
					let allowEmpty = overhead.attr('data-allow-empty') === 'yes';
					let cnt = menu.find('.menu__item-active').length;
					console.log('cnt', cnt);
					if (cnt) {
						if (defaultText && changeText) {
							let tmpTxt = App.format.quantity(cnt, changeText);
							menu.find('.checkboxCount').html('<b>' + cnt + '</b> ' + tmpTxt.charAt(0).toUpperCase() + tmpTxt.slice(1));
						} else menu.find('.checkboxCount .cnt').html(cnt);
						overhead.addClass('active');
						overhead.find('ws-btn').toggleDisabled(false);
					} else {
						if (defaultText && changeText) menu.find('.checkboxCount').html(defaultText);
						else menu.find('.checkboxCount .cnt').html('');
						overhead.toggleClass('active', allowEmpty);
						overhead.find('ws-btn').toggleDisabled(!allowEmpty);
					}
				}, 1)).trigger('after_interaction', {onload: true});
			}
			// не зрозуміло нафіга цей код, нічого не робить, лише дарма перечитує layout... поки коментую
			// menu.bind('onselect', function () {
			// 	let searchable = $(this).find('.scrollZone');
			// 	let height = $(this).find('.menu__group-search').height();
			// 	let item = $(this).find('.selected');
			// 	let itemTop = item.position().top;

			// 	if (item.closest('.menu__item-group').length) {
			// 		itemTop += item.closest('.menu__item-group').position().top;
			// 	}
			// 	if (item.closest('.menu__group__subset').length) {
			// 		itemTop += item.closest('.menu__group__subset').position().top;
			// 	}

			// 	/*
			// 	if (itemTop < 0) searchable.scrollTop(0);
			// 	else if (itemTop > 0 && itemTop < height + 20) searchable.scrollTop(searchable.scrollTop() - 33);
			// 	else if (itemTop > height + 180 && itemTop < height + 220) searchable.scrollTop(searchable.scrollTop() + 33);
			// 	else if (itemTop > height + 290) searchable.scrollTop(itemTop);
			// 	else if (itemTop >= height + 220 && itemTop <= height + 290) menu.find('.menu__item.selected').removeClass('selected');
			// 	 */
			// });

			menu.addClass('menu--inited');
		},

		init_toggle_search_chosen: function (menu) {

			const control = menu.find('.menu__toggle-search-chosen');
			if (!control.length) return;
			if (!control.hasClass('menu__toggle-search-chosen-not-inited')) return console.warn('Already inited');

			const state_key = 'toggle_search_chosen:'+control.attr('data-state-key');
			const searchable_item_group = $(menu).find('.menu__group-searchable');
			const search_input = menu.find('.menu__group-search input');
			const original_placeholder = search_input.attr('placeholder');
			const activate = () => {

				const active_items = self.get_active_item(menu);
				const active_groups = active_items.closest('.menu__group');
				active_groups.first().addClass('menu__group-flat-first-visible');
				active_groups.last().addClass('menu__group-flat-last-visible');
				menu.addClass('menu-flat-groups');

				control.addClass('menu__toggle-search-chosen-active');
				search_input.attr('placeholder', control.attr('data-placeholder'));
				if (!state_key) {
					menu.on('before_hide.toggle_search_chosen', function () {
						deactivate();
					});
				}
				searchable_item_group.find('.menu__item[data-id]').not('.menu__item-active').addClass('menu__item-notPossible');
				searchable_item_group.find('.menu__item-group').addClass('menu__item-notPossible');
				searchable_item_group.find('.menu__item-subset').addClass('menu__item-notPossible');
			};
			const deactivate = () => {
				control.removeClass('menu__toggle-search-chosen-active');
				menu.removeClass('menu-flat-groups');
				menu.find('.menu__group-flat-first-visible, .menu__group-flat-last-visible')
					.removeClass('menu__group-flat-first-visible menu__group-flat-last-visible');
				search_input.attr('placeholder', original_placeholder);
				menu.off('before_hide.toggle_search_chosen');
				searchable_item_group.find('.menu__item[data-id]').removeClass('menu__item-notPossible');
				searchable_item_group.find('.menu__item-group').removeClass('menu__item-notPossible');
				searchable_item_group.find('.menu__item-subset').removeClass('menu__item-notPossible');
			};

			control.on('click', function () {
				if (control.hasClass('menu__toggle-search-chosen-active')) {
					deactivate();
					if (state_key) localStorage.setItem(state_key, false);
				} else {
					activate();
					if (state_key) localStorage.setItem(state_key, true);
				}
				// по хорошому кожне меню має якось визначати ці параметри (як, конфіг?)
				// + вони скоріше за все мають бути спільні для search.js
				const options = {item: '.menu__item:not(.menu__item-group)'};
				self.process_groups_visibility(menu.get(0), options);
				menu.trigger('after_toggle_search_chosen');
			});

			control.removeClass('menu__toggle-search-chosen-not-inited');
			menu.bind('after_interaction after_toggle_search_chosen', function (event, data) {
				if (!control.hasClass('menu__toggle-search-chosen-active')) {
					const has_checked_items = menu.find('.menu__item-active').length > 0;
					if (has_checked_items) {
						control.find('ws-btn').removeAttr('disabled');
					} else {
						control.find('ws-btn').attr('disabled', true);
					}
				}
			});

			if (state_key) {
				menu.on('onshow.toggle_search_chosen', function () {
					// after items inited, or listen to after_interaction?
					App.helper.nextTick(() => {
						const current_state = control.hasClass('menu__toggle-search-chosen-active');
						const saved_state = App.helper.parseBoolean(localStorage.getItem(state_key) ?? true);
						if (current_state === saved_state) return;
						if (saved_state) {
							const has_checked_items = menu.find('.menu__item-active').length > 0;
							if (has_checked_items) {
								activate();
							}
						} else {
							deactivate();
						}
					});
				});
			}
		},

		init_toggle_search_bookmarks: function (menu, options) {

			options = {
				obj_input: null,
				obj_control: null,
				context_search_callback: null,
				...options
			};

			const control = options.obj_control ?? menu.find('.menu__toggle-search-bookmarks');
			if (!control.length) return;
			if (!control.hasClass('menu__toggle-search-bookmarks-not-inited')) return console.warn('Already inited');

			const state_key = 'toggle_search_bookmarks:'+control.attr('data-state-key');

			const search_input = options.obj_input ?? menu.find('.menu__group-search input');
			const original_placeholder = search_input.attr('placeholder');
			const activate = () => {

				const all_items = self.get_items(menu);
				const active_items = all_items.filter('[data-fav=true]');
				const active_groups = active_items.closest('.menu__group');
				active_groups.first().addClass('menu__group-flat-first-visible');
				active_groups.last().addClass('menu__group-flat-last-visible');
				menu.addClass('menu-flat-groups');

				control.addClass('menu__toggle-search-bookmarks-active');
				search_input.attr('placeholder', control.attr('data-placeholder'));

				if (!state_key) {
					menu.on('before_hide.toggle_search_bookmarks', function () {
						deactivate();
					});
				}

				all_items.not(active_items).addClass('menu__item-notPossible');
			};
			const deactivate = () => {

				const all_items = self.get_items(menu);

				control.removeClass('menu__toggle-search-bookmarks-active');
				menu.removeClass('menu-flat-groups');
				menu.find('.menu__group-flat-first-visible, .menu__group-flat-last-visible')
					.removeClass('menu__group-flat-first-visible menu__group-flat-last-visible');
				search_input.attr('placeholder', original_placeholder);
				menu.off('before_hide.toggle_search_bookmarks');

				all_items.removeClass('menu__item-notPossible');
			};

			control.on('click', function () {
				if (control.hasClass('menu__toggle-search-bookmarks-active')) {
					deactivate();
					if (state_key) {
						localStorage.setItem(state_key, false);
					}
				} else {
					activate();
					if (state_key) {
						localStorage.setItem(state_key, true);
					}
				}
				// по хорошому кожне меню має якось визначати ці параметри (як, конфіг?)
				// + вони скоріше за все мають бути спільні для search.js
				const process_groups_visibility_options = {item: '.menu__item:not(.menu__item-group)'};
				const has_results = self.process_groups_visibility(menu.get(0), process_groups_visibility_options);
				if (options.context_search_callback) options.context_search_callback(has_results);
			});

			const active_items = self.get_items(menu).filter('[data-fav=true]');
			if (!active_items.length) {
				control.addClass('menu__toggle-search-bookmarks-disabled');
			}
			control.removeClass('menu__toggle-search-bookmarks-not-inited');

			if (state_key) {
				menu.on('onshow.toggle_search_bookmarks', function () {

					App.helper.nextTick(() => {

						const has_bookmarks = self.get_items(menu).filter('[data-fav=true]').length > 0;

						if (!has_bookmarks) return;

						const current_state = control.hasClass('menu__toggle-search-bookmarks-active');

						const saved_state = App.helper.parseBoolean(
							localStorage.getItem(state_key) ?? false
						);

						if (current_state === saved_state) return;

						if (saved_state) {
							activate();
						} else {
							deactivate();
						}

						const process_groups_visibility_options = {
							item: '.menu__item:not(.menu__item-group)'
						};

						const has_results = self.process_groups_visibility(
							menu.get(0),
							process_groups_visibility_options
						);

						if (options.context_search_callback) {
							options.context_search_callback(has_results);
						}
					});
				});
			}
		},

		item_set_active: function (el) {
			self.get_active_item($(el).closest('.menu, .menuFake')).removeClass([
				'menu__item-active',
				'menu__item-picked',
			]);
			$(el).addClass('menu__item-active');
			if ($(el).hasClass('menu__item-pickable')) {
				$(el).addClass('menu__item-picked');
			}
		},
		item_set_active_by_id: function (menu, data_id) {
			const searchable_item_group = $(menu).find('.menu__group-searchable');
			let items;
			if (searchable_item_group.length) items = searchable_item_group.find('.menu__item[data-id=' + data_id + ']');
			else items = $(menu).find('.menu__group:not(.menu__group-select-box)').find('.menu__item[data-id=' + data_id + ']');
			self.item_set_active(items);
		},
		get_active_item: function (menu) {
			const searchable_item_group = $(menu).find('.menu__group-searchable');
			if (searchable_item_group.length) return searchable_item_group.find('.menu__item-active');
			return $(menu).find('.menu__group:not(.menu__group-select-box) .menu__item-active');
		},
		get_picked_item: function (menu) {
			const searchable_item_group = $(menu).find('.menu__group-searchable');
			if (searchable_item_group.length) return searchable_item_group.find('.menu__item-picked');
			return $(menu).find('.menu__item-picked');
		},
		get_items: function (menu) {
			const searchable_item_group = $(menu).find('.menu__group-searchable');
			if (searchable_item_group.length) return searchable_item_group.find('.menu__item');
			return $(menu).find('.menu__group:not(.menu__group-select-box) .menu__item');
		},
		// todo можна було б обережно явно обізвати _selector / _class
		// todo додати .menu__item-notPossible,
		//      а також врахувати його в self.process_groups_visibility() та, search.js
		default_options: {
			item: '.menu__item',
			title: '.flex_content',
			group: '.menu__group-searchable', // todo replace with group_searchable ? ! see search.js
			subset: '.menu__group__subset',
			empty: '.menu__group-empty',

			tip_selector: '.menu__tip',

			hide_on_search_empty_selector: '[data-hide-on-search-empty="true"]',

			// old style
			item_hidden: 'menu__item-hidden',
			item_picked: 'menu__item-picked',
			group_hidden: 'menu__group-hidden',
			subset_hidden: 'menu__group__subset-hidden',

			// new style
			select_box_class: 'menu__group-select-box',
			item_removable_class: 'menu__item-removable',
			item_active_class: 'menu__item-active',
			item_not_possible_class: 'menu__item-notPossible',
		},
		// TODO flymod - mb move to self.init ?
		init_select_box: function (menu, options) {
			options = $.extend({}, self.default_options, {
				animate_selectbox: true,
				on_remove: (menu, select_box, placeholder) => {
					console.warn('You may implement it yourself to clear <input> values properly');
				},
			}, options);

			const select_box = menu.find('.' + options.select_box_class);
			select_box.off().on('click', options.item + ' [data-action="remove"]', function (event, this_options) {
				event.preventDefault();
				this_options = $.extend({}, options, this_options);
				const placeholder = select_box.find('.menu__item__wrapper[data-role="placeholder"]');
				const id_default = placeholder.find('.menu__item[data-id]').attr('data-id');
				const active_item = App.controls.menu.get_active_item(menu);
				$(this).closest('.menu__item__wrapper').remove();
				if (id_default != active_item.attr('data-id')) {
					active_item.removeClass([this_options.item_active_class, this_options.item_picked])
						.closest('.menu__group').removeClass(this_options.group_hidden);
					self.item_set_active_by_id(menu, id_default);
				}
				if (this_options.animate_selectbox) select_box.find('.menu__item__wrapper').first().shortblink();
				App.controls.menu.process_groups_visibility(menu, options);
				this_options.on_remove.call(this, menu, select_box, placeholder);
			});
		},
		process_select_box: function (menu, options) {
			options = $.extend({}, self.default_options, {
				animate_selectbox: true,
				item_renderer: (menu, select_box, active_item) => {
					const title_el = active_item.find(options.title);
					const select_box_item = App.controls.menu.create_item({
						avatar: title_el.prev('.av_sm').length
							? title_el.prev('.av_sm').clone().removeClass('av_svg')
							: title_el.prev('.space-ava').find('.av_sm').length
								? title_el.prev('.space-ava').find('.av_sm').clone().removeClass('av_svg')
								: '',
						left_icon: title_el.prev('ws-icon').length
							? () => title_el.prev('ws-icon').clone()
							: '',
						title: App.helper.html.encode(title_el.text()),
						right_icon: 'input-box-solid-cancel',
						active: true
					}).addClass('flex_content');
					select_box_item.find('[data-role="right_icon"]').attr('data-action', 'remove').removeClass('space-20');

					// copy data-*
					for (const key in active_item[0].dataset) {
						select_box_item[0].dataset[key] = active_item[0].dataset[key];
					}

					const wrapper = $('<div>').addClass('menu__item__wrapper flex_row');
					wrapper.append(select_box_item);

					if (active_item.closest('.menu__group').hasClass('menu__group-users') && active_item.attr('data-id') >= App.config.real_user_id) {
						const user_menu_btn = App.controls.menu.create_item({
							left_icon: 'contacts',
						}).addClass('btn-user-menu').attr('onclick', "App.controls.user_menu.show(this, " + active_item.attr('data-id') + ", 'parent fixed left', 0, {backup: true});");
						wrapper.prepend(user_menu_btn);
					}

					select_box.find('.menu__item__wrapper:not([data-role="placeholder"])').remove();
					select_box.append(wrapper);

					if (options.animate_selectbox) wrapper.shortblink();
				},
			}, options);

			const select_box = menu.find('.' + options.select_box_class);
			if (!select_box.length) return;

			const active_item = self.get_active_item(menu)
				.sort(function (a, b) {
					const a_is_extra = $(a).closest('.menu__group').hasClass('menu__group-extra');
					const b_is_extra = $(b).closest('.menu__group').hasClass('menu__group-extra');
					return a_is_extra - b_is_extra;
				})
				.first();
			if (!active_item.length) {
				select_box.find(options.item).find('[data-action="remove"]').trigger('click', {animate_selectbox: options.animate_selectbox});
				return;
			}

			// move to options as default checker? or redraw always?
			if (select_box.find('.menu__item[data-id]:visible').attr('data-id') == active_item.attr('data-id')) return;
			if (select_box.find('[data-role="placeholder"]').find('.menu__item[data-id]').attr('data-id') == active_item.attr('data-id')) {
				select_box.find(options.item).find('[data-action="remove"]').trigger('click');
				return;
			}

			options.item_renderer.call(this, menu, select_box, active_item);
			App.controls.menu.process_groups_visibility(menu, options);
		},
		process_groups_visibility: function (list, options) {
			options = $.extend({}, self.default_options, options);
			let o = $(list).find(options.group).find(options.item)
				.not('.' + options.item_hidden).not('.' + options.item_picked).not('.' + options.item_not_possible_class);
			$(list).find(options.group).addClass(options.group_hidden);
			$(list).find(options.subset).addClass(options.subset_hidden);
			o.parents(options.group).removeClass(options.group_hidden);
			o.parents(options.subset).removeClass(options.subset_hidden);
			let has_results;
			if (o.length) {
				$(list).find(options.empty).hide();
				$(list).find(options.hide_on_search_empty_selector).each(function () {
					if ($(this).hasClass('menu__group')) {
						$(this).removeClass('menu__group-hidden')
					} else if ($(this).hasClass('menu__item')) {
						$(this).removeClass('menu__item-hidden')
					} else {
						$(this).show();
					}
				});
				has_results = true;
			} else {
				$(list).find(options.empty).show();
				$(list).find(options.hide_on_search_empty_selector).each(function () {
					if ($(this).hasClass('menu__group')) {
						$(this).addClass('menu__group-hidden')
					} else if ($(this).hasClass('menu__item')) {
						$(this).addClass('menu__item-hidden')
					} else {
						$(this).hide();
					}
				});
				has_results = false;
			}

			$(list).find(options.tip_selector).toggleClass('ws-utility-hidden', !has_results);

			return has_results;
		},

		onkeyup_required: function (input) {
			$(input).closest('.menu__group-search').find('ws-btn').prop('disabled', $(input).val().trim() == '');
		},

		load_items: function (anchor, config) {

			config ||= {};

			const selector = config.selector;
			const url = config.url;
			const callback = config.callback;

			if (!selector || !url) throw new Error("Wrong config", config);

			const menu = $(anchor).closest('.menu');

			// to show loading icon
			menu.addClass('menu-unloading');

			// для десктопа будемо міняти висоту скроллЗони
			// робимо саме resize, а не reposition, щоб меню не смикати
			// поки простий випадок, коли скроллЗона одна.. а якщо 0 то висоту чого міняти?
			const scrollZone = menu.find('.scrollZone');
			if (scrollZone.length != 1) throw new Error("Wrong config");
			const scrollZone_height = scrollZone.height();

			menu.find(selector).load(url, function () {
				menu.removeClass('menu-unloading');
				if (callback) callback();

				if (App.device.is_mobile()) return;

				if (menu.hasClass('menu--fixedHeight')) {
					// для меню відкритих "вверх" зафіксуємо висоту скроллЗони на поточному значенні
					scrollZone.css({
						maxHeight: scrollZone_height,
					});
				} else {
					const diff = $(window).height() - (menu.offset().top + menu.height() + 9);

					if (diff < 0) {
						scrollZone.css({
							maxHeight: scrollZone.height() + diff,
						});
					}
				}

				// при закритті підчистимо
				menu.one('before_hide', () => {
					scrollZone.css({
						maxHeight: '',
					})
				});
			});
		},

		/**
		 * @param {{items: (string|HTMLElement|jQuery|object)[], fill: boolean, classes: string[], search: boolean, checkbox: boolean, select: boolean}} data
		 * @returns {jQuery}
		 */
		create_group: function (data) {
			let el = $('<div/>');

			const class_list = {
				fill: 'menu__group-fill',
				bottom: 'menu__group-bottom',
			};

			el.addClass([
				'menu__group',
				data.fill ? class_list.fill : '',
				data.bottom ? class_list.bottom : '',
				...(data.classes ? data.classes : []),
				data.search ? 'menu__group-searchable' : '',
				data.checkbox === true ? 'menu__group-checkbox' : '',
				data.select === true ? 'menu__group-select' : '',
			]);


			if (Array.isArray(data.items)) {
				data.items.forEach(function (item) {

					if (typeof item === 'string'
						|| item instanceof HTMLElement
						|| item instanceof jQuery
					) {
						return el.append(item);
					}

					el.append(self.create_item(item))
				});
			}

			return el;
		},

		/**
		 * @param {{avatar: (string|function(): string|HTMLElement|jQuery), left_icon: (string|function(): string|HTMLElement|jQuery), right_icon: (string|function(): string|HTMLElement|jQuery), title: (string|function(): string|HTMLElement|jQuery), dataset: object, active: boolean, disabled: boolean, hidden: boolean, picked: boolean, unselectable: boolean, delete: boolean}} data
		 * @param props
		 */
		create_item: function (data, props) {
			data = {
				avatar: '',
				left_icon: '',
				right_icon: '',
				title: '',
				dataset: {},
				active: false,
				disabled: false,
				hidden: false,
				picked: false,
				unselectable: false,
				delete: false,
				style: {},
				checkbox: false,
				...data,
				...(props || {}),
			};

			const class_list = {
				item: {
					base: 'menu__item flex_row',
					active: 'menu__item-active',
					disabled: 'menu__item-disabled',
					picked: 'menu__item-picked',
					hidden: 'menu__item-hidden',
					delete: 'menu__item-delete',
				},
				title: 'in flex_content',
				avatar: 'space space-ava',
				left_icon: 'space',
				right_icon: 'space space-20',
			};

			const item = $('<div>').addClass([
				class_list.item.base,
				data.active ? class_list.item.active : '',
				data.disabled ? class_list.item.disabled : '',
				data.picked ? class_list.item.picked : '',
				data.hidden ? class_list.item.hidden : '',
				data.delete ? class_list.item.delete : '',
				data.unselectable ? 'todo' : '',
				...(data.classes || []),
			]);
			Object.entries(data.style).forEach(([key, value]) => {
				item.css(key, value);
			});
			const avatar = !data.avatar ? '' : $('<span>').addClass(class_list.avatar)
				.attr('data-role', 'avatar')
				.html(typeof data.avatar === 'function' ? data.avatar.call() : data.avatar);
			const left_icon = !data.left_icon ? '' : $('<span>').addClass(class_list.left_icon)
				.attr('data-role', 'left_icon')
				.html(typeof data.left_icon === 'function' ? data.left_icon.call() : '<ws-icon name="' + data.left_icon + '"></ws-icon>');
			const title = !data.title ? '' : $('<span>').addClass(class_list.title)
				.attr('data-role', 'title')
				.html(typeof data.title === 'function' ? data.title.call() : data.title);
			const right_icon = !data.right_icon ? '' : $('<span>').addClass(class_list.right_icon)
				.attr('data-role', 'right_icon')
				.html(typeof data.right_icon === 'function' ? data.right_icon.call() : '<ws-icon name="' + data.right_icon + '"></ws-icon>');
			const checkbox = data.checkbox ? $('<span class="sw_pre sw_blue" style="display: inline-block"><ws-icon name="checkbox"></ws-icon></span>') : '';
			Object.keys(data.dataset).forEach((key) => {
				item.attr('data-' + key, data.dataset[key]);
			});

			return item.append(checkbox, avatar, left_icon, title, right_icon);
		},

		/**
		 * @param {{id: string, groups: (string|HTMLElement|jQuery|object)[], search: boolean, button: boolean, button_text: String}} params
		 * @return {{id: string, el: (*|jQuery), show(*): void}}
		 */
		create_menu: function (params) {
			let id = params.id ?? 'tmp-menu-' + Date.now();
			const html = App.helper.dom.builder();

			let menu = $('<div/>').attr('id', id).addClass('menu menu-primary');
			let group_wrapper = $('<div/>').addClass('menu__group__wrapper');

			params.groups.forEach(function (group) {
				group_wrapper.append(self.create_group({
					...(typeof group === 'object' && !Array.isArray(group) ? group : {items: group}),
				}));
			});

			if (params.search) {
				const search_group = self.create_group({
					classes: ['menu__group-search', 'flex_row'],
					items: [
						html['ws-icon']({name: 'search_sm'}),
						html.span({class: 'in flex_content'},
							html.input({
								type: 'text',
								placeholder: App.object_state.locale.search.placeholder,
								onkeyup: 'App.context_search.menu.apply(this, App.menu.obj_window)',
							})
						),
						html.a({
								onclick: "$(this).closest('.menu__group-search').find('input').val('').trigger('keyup');",
								class: "delete svg_hover"
							},
							html['ws-icon']({name: 'cancel_sm:cancel_sm-solid'})
						),
						...(params.button ? [html['ws-btn']({
							text: params.button_text || "OK",
							name: "btn btn-28 btn-a btn-solid",
							'right-icon': params.button_icon,
						})] : []),
					]
				});
				group_wrapper.prepend(search_group);
			}
			menu.append(group_wrapper);

			return {
				id,
				el: menu,
				show(data) {
					App.menu.show({
						...data,
						box: menu,
					});
				},
				destroy() {
					menu.remove();
				}
			};
		}
	}
})();

;(function() {
	let self = App.controls.menu_datepicker = {
		locale: {}, // from template
		config: {}, // from template

		show: function (anchor, endpoint, params) {
			params ||= {};
			endpoint ||= $(anchor).attr('data-url');
			App.menu.show({
				anchor,
				type: params.type || '',
				width: params.width || 284,
				url: endpoint,
				onload: function() {
					let menu = $(this);
					menu.find('ws-btn[name*=primary]').on('click', function(event) {
						App.core.form_submit(menu.find('form'), function () {
							if (params.onsuccess) params.onsuccess.call(menu);
							App.menu.hide();
						});
					});
				},
				onshow: function() {
					self.onshow(this);
				}
			});
		},
		onshow(menu, params = {}) {
			/**
			 * This function awaits for self.config to load, so it can't be called from onload ((
			 */
			menu = $(menu);
			menu.once_by_criteria('menu_load').find(".modal_picker").datepicker({
				rangeSelect: false,
				numberOfMonths: 1,
				monthPicker: true,
				monthNames: App.object_state.locale.month.long,
				firstDay: App.datepicker_firstDay || 0,
				minDate_: self.config['min_date_js'] ? new Date(self.config['min_date_js']) : null,
				minDate: self.config['min_date_real_js'] ? new Date(self.config['min_date_real_js']) : null,
				maxDate_: self.config['max_date_js'] ? new Date(self.config['max_date_js']) : null,
				maxDate: new Date(),
				defaultDate: new Date(self.config['def_date_js']),
				altField: menu.find('input[name='+self.config['variable']+'_]'),
				altFormat: 'DD.d.LL.yy.D.L.w',
				unSelReplace: '&bull;',
				hideIfNoPrevNext: true,
				onSelect: function(date) {
					menu.find('input[name='+self.config['variable']+']').val(date);
				},
				beforeShowDay: self.helper_draw_all,
				...params,
			});
		},
		helper_draw_all: function (date) {
			let date_str = App.helper.date.to_input(date);
			let is_weekend = date.getDay() === 0 || (!self.config.saturday_work && date.getDay() === 6);
			let override_class = '';
			let override_title = '';
			let override_weekend = '';

			if (date_str in self.config.extraday) {
				override_class += ' ui-datepicker-extraday';
				override_title = self.locale['workday'];
			}

			if (date_str in self.config.holidays) {
				override_class = 'ui-datepicker-holiday ' + (is_weekend ? 'ui-datepicker-force-weekend ' : '') + $.datepicker._unselectableClass;
				override_title = self.locale['holiday'];
				if (self.config.is_set && App.holidays.holiday_types.includes(self.config.is_set)) {
					override_title += '\n' + self.locale['as_' + App.holidays.type_index[self.config.is_set]];
				}
				override_weekend = 'holiday';
			}

			for (let type of App.holidays.types) {
				if (date_str in self.config.user_config[type]) {
					override_class += ' ui-datepicker-us-' + App.holidays.type_index[type];
					override_title = self.locale['user_' + App.holidays.type_index[type]];
					break;
				}
			}
			if (self.config.is_set && App.holidays.holiday_types.includes(self.config.is_set))
			{
				let found_other_type = false;
				for (let type of App.holidays.holiday_types) {
					if (type !== self.config.is_set && override_class.includes('ui-datepicker-us-' + App.holidays.type_index[type])) found_other_type = true;
				}
				if (found_other_type) override_class += ' '+$.datepicker._unselectableClass;
			}

			if (
				is_weekend
				&& (!override_class.includes('ui-datepicker-us-' + App.holidays.type_index[WORKDAY]) && !override_class.includes('ui-datepicker-extraday'))
			) {
				override_class += ' ' + $.datepicker._unselectableClass;
			}

			return [true, override_class.trim(), override_title, override_weekend];
		},
	}
})();

;(function() {
	let self = App.controls.more_dots = {
		timeout: false,
		allow_load: false,
		onscroll: function (onload) {
			if ($('#more_auto').length && self.allow_load && $('#more_auto').is(':visible')) {
				if (($('#more_auto').offset().top + $('#more_auto').height() <= $(window).scrollTop() + $(window).height()) && ($('#more_auto').offset().top >= $(window).scrollTop())) {
					if (onload || $('#more_auto').parent().is('h4')) {
						$('#more_auto').trigger('click');
					} else {
						if (self.timeout) {
							clearTimeout(self.timeout);
							$('#more_auto').parent().parent().prev().stop().css({left: 0});
						}
						self.timeout = setTimeout(function () {
							$('#more_auto').parent().parent().prev().animate({left: $('#more_auto').parent().parent().parent().width()}, 1000);
							self.timeout = setTimeout(function () {
								$('#more_auto').trigger('click');
							}, 900);
						}, 500);
					}
				}
			}
		},
		onLoadPage: function () {
			App.bus.window.on('scroll', self.onscroll);
			self.onscroll(true);
			setTimeout(function () {
				self.allow_load = true;
			}, 1000);
		}
	}
})();

;(function() {
	let self = App.controls.mouse = {
		pageX: 0,
		pageY: 0,
		onBoot: function () {
			let lastMove = 0;
			$(document).off('mousemove.mousetrack').on('mousemove.mousetrack', function (e) {
				let now = Date.now();
				if (now - lastMove > 50) {
					self.pageX = e.pageX;
					self.pageY = e.pageY;
					lastMove = now;
				}
			});
		},
	}
})();

;(function() {
	let self = App.controls.mouse_help = {
		onLoadPage: function () {
			if ($('#mouse_help').length) {
				setTimeout(function () {
					$('#mouse_help').addClass('help_shown');
					if (!$('#mouse_help').hasClass('help_hidden')) $('#mouse_help a.shown').trigger('click');
				}, 2000);
			}
		}
	}
})();

;(function() {
	let self = App.controls.notify = {
		toggle: function(val) {
			if (typeof val == 'undefined') val = 1 - App.config.notify_action; else val = val ? 1 : 0;
			App.config.notify_action = val;
			$.ajax({url: '/ajax/?' + App.actions.get('process:save_notify') + '&is_notify=' + val});
			val = !!val;
			$('.notify_block, .notify_btn').each(function() {
				$(this).filter('.notify_block').toggleClass('notify_block_act', val);
				$(this).filter('.notify_btn').toggleClass('notify_btn_act', val);
				$(this).filter('.sw_pre').toggleClass('sw_act');
				$(this).find('input[name=skip_notify]').val(val ? '' : '1');
				$(this).find('[data-txt-on]').html($(this).attr(val ? 'data-txt-on' : 'data-txt-off'));
				$(this).attr('data-title', $(this).attr(val ? 'data-title-on' : 'data-title-off'));
				$(this).find('[data-title-on]').attr('data-title', $(this).attr(val ? 'data-title-on' : 'data-title-off'));
			});
			$('#notificationMenu .menu__item:first-child').toggleClass('menu__item-active', val);
			$('#notificationMenu .menu__item:last-child').toggleClass('menu__item-active', !val);
			return false
		},

		asked: new Map(),

		notify_params: function(action) {
			let answer = self.asked.get(action);

			return answer && answer.expire > Date.now()
				? { skip_notify: answer.skip, notify_action: action }
				: { skip_notify: 1, notify_action: action };
		},

		process_action: function(action, id_event) {
			let answer = self.asked.get(action);
			if (answer?.expire > Date.now()) return;

			App.core.async_task.ajax('/ajax/?' + App.actions.get('log_notify:ask') + '&id=' + id_event + '&type=' + action)
				.then(function(data) {
					if (data.cnt_users === 0) return;

					let msgId = 'msg-ask-notify-type-' + action;
					let msg = App.message.find_by_id(msgId);

					if (msg == null) {
						msg = App.message.info(data.message, {
							id: msgId,
							actions: [
								{
									name: 'btn-a btn-solid btn-notify',
									left_icon: 'notifications_alt',
									text: App.i18n.t('notify_subscribers_send'),
									onclick: function () {
										let ids = App.message.find_by_id(msgId)?.attr('data-ids');
										if (ids) {
											App.core.async_task.ajax(
												App.helper.endpoint.primary() + '?' + App.actions.get('log_notify:do') + '&id=' + ids
											);
										}
									}
								},
								{
									name: 'btn-a btn-outline',
									text: '15 ' + App.i18n.t('time_diff.min_xs'),
									left_icon: 'notifications_off',
									title: App.i18n.t('notify_subscribers_decline'),
									onclick: function () {
										self.asked.set(action, { skip: 1, expire: Date.now() + 900*1000 });
									}
								}
							]
						});
					} else {
						App.message.reset_timer_by_id(msgId);
					}

					let ids_event = (msg.attr('data-ids') || '').split(',').filter(id => !!id);

					ids_event.push(id_event);
					msg.attr('data-ids', ids_event.join(','));

					if (ids_event.length > 1) {
						let cnt = msg.find('.text .cnt');
						if (cnt.length === 0) cnt = $('<span class="cnt"></span>');
						cnt.text(' (' + (ids_event.length) + ')');
						msg.find('.text').append(cnt);
					}
				});
		},
	}
})();

;(function () {
	let self = App.controls.page_reloader = {
		ids_updated: [],
		ids_created: [],
		timer: null,
		time_left: 0,
		is_shown: function () {
			return $('.page-reloader').length > 0;
		},
		wait_force_reload: function () { return self.is_shown() && $('.page-reloader').hasClass('forceReload'); },
		do_reload: function() {
			App.core.reload(self.wait_force_reload());
			self.remove();
		},
		add: function (id, is_new) {
			if (self.wait_force_reload()) return;
			self.remove();

			is_new ||= false;
			let selector = $('.page-reloader');
			if (is_new) {
				if (!self.ids_created.includes(id)) self.ids_created.push(id);
			} else {
				if (!self.ids_updated.includes(id) && !self.ids_created.includes(id)) self.ids_updated.push(id);
			}
			if (!selector.length) {
				let o = $('<div />').addClass('page-reloader flex_row').attr('data-count', String(id)).html(
					'<span></span>' +
					'<ws-btn name="btn btn-24 btn-g btn-solid btn-rounded btn-reload" text="'+App.object_state.locale['reload_page']+'"></ws-btn>'
				).appendTo('#fixed_container');
				o.find('[name*=reload]').on('click', self.do_reload);
				selector = $('.page-reloader');
			}
			let html = '';
			if (self.ids_created.length) {
				html = '<b>'+self.ids_created.length+'</b> <span class="txt">'+App.format.quantity(self.ids_created.length, App.object_state.locale['tasks_created'])+'</span>';
				if (self.ids_updated.length) {
					html += ' / <b>' + self.ids_updated.length + '</b> <span class="txt">' + App.format.quantity(self.ids_updated.length, App.object_state.locale['tasks_updated_short']) + '</span>';
				}
			} else {
				html = '<b>'+self.ids_updated.length+'</b> <span class="txt">'+App.format.quantity(self.ids_updated.length, App.object_state.locale['tasks_updated'])+'</span>';
			}
			selector.find('> span').html(html);
			selector.css({
				top: $('.headerGeneral').height() ?? '10vh',
				left: 'calc(50% - ' + (selector.width() - 130) + 'px/2)'
			});
		},
		permissions_changed: function () {
			self.ask_reload({ text: App.object_state.locale['reload_page_permissions'] });
		},
		account_changed: function (force) {
			self.ask_reload({
				text: App.object_state.locale['reload_page_settings'],
				ttl: 60,
				force: force === true,
			});
		},
		state_changed: function () {
			self.ask_reload({
				text: App.object_state.locale['reload_account_state'],
				ttl: 15,
				force: true,
			});
		},
		users_changed: function () {
			self.ask_reload({
				ttl: 60
			});
		},
		app_version_changed: function () {
			if (self.wait_force_reload()) return;

			self.ask_reload({
				text: App.object_state.locale['reload_new_version'],
				force: true,
			});
		},
		ask_reload: App.helper.debounce(function (params) {
			params ||= {};
			let text = params.text || App.object_state.locale['reload_page_text'], ttl = params.ttl || 0, force = params.force || false;

			if (self.wait_force_reload() && !force) return;
			self.remove();

			let html = `<span>${text}</span>`;
			if (App.device.is_mobile()) {
				html = `<span><ws-marquee>${text}</ws-marquee></span>`;
			}

			let o = $('<div />').addClass('page-reloader flex_row').toggleClass('hasTimer', ttl > 0).toggleClass('forceReload', force).html(
				html +
				'<ws-btn name="btn btn-24 btn-g btn-solid btn-rounded btn-reload" text="'+(App.object_state.locale['reload_page'] || 'Reload')+'"></ws-btn>'
			).appendTo('#fixed_container');

			o.css({
				top: '6vh',
				left: 'calc(50% - ' + o.width() + 'px/2)'
			});

			o.find('[name*=reload]').on('click', self.do_reload);

			if (ttl > 0) self.start_timer(ttl);
		}, 1000),
		start_timer: function (seconds) {
			if (seconds <= 1) return;

			let txt = $('.page-reloader > span').text();
			$('.page-reloader > span').html(txt + ' (<i class="timeleft">' + seconds + '</i>)');

			self.time_left = seconds;
			self.check_timer();
		},
		check_timer: function () {
			if (!self.is_shown()) return self.clear_timer();
			if (App.offline_mode.active) return self.stop_timer();

			if (self.time_left <= 0) {
				$('.page-reloader .timeleft').remove();
				return self.clear_timer();
			}

			$('.page-reloader .timeleft').text(self.time_left);

			clearTimeout(self.timer);
			self.timer = setTimeout(function () {
				if (!self.wait_force_reload() && App.task_view.is_shown()) return self.check_timer();

				self.time_left--;
				if (self.time_left > 0) self.check_timer();
				else self.do_reload();
			}, 1000);
		},
		clear_timer: function () {
			clearTimeout(self.timer);
			self.time_left = 0;
			self.timer = null;
		},
		stop_timer: function () {
			clearTimeout(self.timer);
			self.timer = null;
		},
		too_many: function () {
			self.ask_reload();
		},
		remove: function () {
			self.clear_timer();
			$('.page-reloader').remove();
		},
		handle_resize: function () {
			if ($(window).width() <= APP_SCREEN_THRESHOLD) {
				if (!$('body').hasClass('mobile')) {
					if (self.wait_force_reload()) return;
					self.ask_reload({ force: true, text: App.object_state.locale['reload_page_resize'] });
				} else {
					self.remove();
				}
			} else if (!$('body').hasClass('desktop')) {
				if (self.wait_force_reload()) return;
				self.ask_reload({ force: true, text: App.object_state.locale['reload_page_resize'] });
			} else {
				self.remove();
			}
		},
		onBoot: function () {
			App.bus.window.on('active', function () {
				self.check_timer();
			}).on('inactive', function () {
				self.stop_timer();
			});

			App.bus.app.on('offline_mode', function (is_offline) {
				if (is_offline) {
					self.stop_timer();
				} else {
					self.check_timer();
				}
			});

			if (!App.hybrid_app) App.bus.window.on('resize', App.helper.debounce(self.handle_resize));
		}
	};
})();

;(function() {
	let self = App.controls.plan_usage_indicator = {

		update: function (el, type) {
			let o = $(el).parent().parent().find('.progress_pre');
			if (o.length) {
				this_val = 1 * el.value;
				cur_val = 1 * o.attr('data-used') + this_val - 1 * o.attr('data-this');
				if ($('#dataadd_group').length) {
					if (el.name == 'max_time') $('.todo').not('.todo_act').find('input[name^=arr_max_time]').each(function () {
						cur_val += 1 * $(this).val();
					});
					if (el.name == 'max_money') $('.todo').not('.todo_act').find('input[name^=arr_max_money]').each(function () {
						cur_val += 1 * $(this).val();
					});
				}
				max_val = 1 * o.attr('data-plan');
				o.attr('data-title', o.attr('data-trans').replace('%2$s', Math.ceil(cur_val)).replace('%1$s', Math.ceil(max_val)));
				if (this_val) o.find('.progress2').removeClass('progress2_nofill'); else o.find('.progress2').addClass('progress2_nofill');
				if (cur_val <= max_val) {
					o.find('.progress2').removeClass('progress2_over2').removeClass('progress2_over');
					o.find('.p1').css({width: (0.01 * Math.floor(100 * 100 * (cur_val - this_val) / max_val)) + '%'});
					o.find('.p2').css({width: (0.01 * Math.floor(100 * 100 * this_val / max_val)) + '%'});
				} else if (cur_val - this_val > max_val) {
					o.find('.progress2').removeClass('progress2_over2').addClass('progress2_over');
					o.find('.p1').css({width: (cur_val ? 0.01 * Math.floor(100 * 100 * (cur_val - max_val - this_val) / cur_val) : 0) + '%'});
					o.find('.p2').css({width: (cur_val ? 0.01 * Math.floor(100 * 100 * this_val / cur_val) : 0) + '%'});
				} else {
					o.find('.progress2').addClass('progress2_over2').removeClass('progress2_over');
					o.find('.p1').css({width: (cur_val ? 0.01 * Math.floor(100 * 100 * (cur_val - max_val) / cur_val) : 0) + '%'});
					o.find('.p2').css({width: (cur_val ? 0.01 * Math.floor(100 * 100 * (this_val - cur_val + max_val) / cur_val) : 0) + '%'});
				}
			}
		}
	}
})();

;(function() {
	let self = App.controls.priority = {
		obj: '',
		onApply: null,
		callback: null,
		open: function (el, params, callback) {
			params ||= {}
			if (App.mass.is_shown()) return false;
			self.callback = callback || null;
			self.onApply = params.onApply || null;
			self.obj = $(el);
			$('#prioritySelectMenu a.pra').removeClass('menu__item-active');
			let prior = params.current || 1;
			$(el).children().addBack().each(function() {
				if (/prior(\d+)/.test($(this).attr('class'))) prior = RegExp.$1;
			});
			$('#prioritySelectMenu a.pra' + prior).addClass('menu__item-active');
			App.menu.show({
				anchor: params.anchor || el,
				box: $('#prioritySelectMenu').get(0),
				backup: params.backup || false,
				replace: params.replace || false,
				type: params.type || '',
			});
		},
		apply: function () {
			if (self.callback) {
				self.callback.call(this);
			} else if (self.obj) {
				if (self.obj.attr('data-obj')) {
					$(self.obj.attr('data-obj')).val($(this).attr('data-id'));
					$(self.obj.attr('data-obj'))[0].dispatchEvent(new Event('change', {bubbles: true}));
				}
				self.obj.val($(this).attr('data-id'));
				self.obj.attr('class', self.obj.attr('class').replace(/ prior\d+/, '') + ' prior' + $(this).attr('data-id')).html($(this).attr('data-id') == 0 ? PRIOR0_HTML : $(this).attr('data-txt'));
			}
			App.menu.hide();
			if (self.onApply) {
				self.onApply($(this).attr('data-id'));
			}
			return false;
		},
		onLogin: function () {
			$('#prioritySelectMenu a.pra').bind('click', self.apply);
		},
	}
})();

;(function() {
	let self = App.controls.quick_nav = {
		onresize: function () {
			if ($(document).height() - $(window).height() > 100) $('body').addClass('quick_nav'); else $('body').removeClass('quick_nav');
		},
		onLoadPage: function () {
			App.bus.window.on('resize', App.helper.throttle(self.onresize));
			self.onresize();
		}
	}
})();

;(function() {
	let self = App.controls.rate = {
		sanitize_input: function (input) {
			input.value = App.helper.number.normalize_unsigned_decimal_input(input.value);
		},
		sanitize_change: function (input) {
			input.value = App.helper.number.normalize_unsigned_decimal_input(input.value);
			if (input.value !== '') {
				input.value = +(+input.value).toFixed(2); // .5 -> 0.5
			}
		},
		time_to_money: function (no_init) {
			if (!no_init) {
				$('.inputBlock__costs-spendAdd').show();
			}
			if ($('#tm_rate').length && $('#tm_rate').val() == '1') {
				let tk = $('#tm_time').val().replace(/ /g, '').replace(/,/g, '.');
				if (App.helper.validate.time_readable.test(tk)) {
					tk = 1 * RegExp.$1 + RegExp.$2 / 60;
				} else if (App.helper.validate.time_int.test(tk)) {
					tk = 1 * tk;
				} else {
					tk = 0;
				}
				tk = Math.round(tk * 60) / 60;
				tk_r = 1 * $('#tm_rate').parent().find('input[name=rate]').val().replace(/ /g, '').replace(/,/g, '.');
				tk_r2 = 1 * $('#tm_rate').parent().find('input[name=rate]').attr('rel');
				tk = Math.round(tk * tk_r * Math.pow(10, tk_r2)) / Math.pow(10, tk_r2);
				if (tk) {
					$('#tm_money').val(tk).trigger('change');
				} else {
					$('#tm_money').val('').trigger('change');
				}
			}
		},
		money_to_time: function () {
			$('.inputBlock__costs-spendAdd').show();
			$('.inputBlock-hideByTimeList').show();
			if ($('#tm_rate')) $('#tm_rate').val(0).parent().find('.sw_pre').removeClass('sw_act').parent().prev().prev().toggleDisabled(true);
			App.costs_list.update_total();
		},
	}
})();

;/**
 * use this for documentation build
 */
App.controls.reflect = {
	onLoadPage: function() {

		return false;

		$('body').css('user-select', 'auto');
		let div = $('<div />').appendTo('body'), ul, li, ul2, li2_cnt;

		for (let i in App) {
			if (i == 'page') continue;
			$('<div />').html('App.' + i).appendTo(div);
			for (let j in App[i]) {
				$('<div />').html('App.' + i + '.' + j).appendTo(div);
				if (typeof App[i][j] === 'object' && App[i][j] != null) {
					for (let k in App[i][j]) {
						$('<div />').html('App.' + i + '.' + j + '.' + k).appendTo(div);
						if (typeof App[i][j][k] === 'object' && App[i][j][k] != null) {
							for (let l in App[i][j][k]) {
								$('<div />').html('App.' + i + '.' + j + '.' + k + '.' + l).appendTo(div);
								if (typeof App[i][j][k][l] === 'object' && App[i][j][k][l] != null) {
									for (let m in App[i][j][k][l]) {
										$('<div />').html('App.' + i + '.' + j + '.' + k + '.' + l + '.' + m).appendTo(div);
									}
								}
							}
						}
					}
				}
			}
		}
		return false;

		for (let i in App) {
			$('<h2 />').html(i).appendTo(div);
			$('<p />').html('Описание ' + i).appendTo(div);
			$('<img src="https://planetwings.com/wp-content/uploads/2016/05/sample-img-300x168.jpg" width="200">').appendTo(div);
			$('<br />').appendTo(div);
			$('<br />').appendTo(div);
			ul = $('<ol />').appendTo(div);
			for (let j in App[i]) {
				li = $('<li />');
				if (typeof App[i][j] === 'object' && App[i][j] != null) {
					ul2 = $('<ol />');
					li2_cnt = 0;
					for (let k in App[i][j]) {
						if (typeof App[i][j][k] === 'function') {
							li2_cnt++;
							$('<li />').html(k).appendTo(ul2).css('list-style', 'initial');
						}
					}
					if (li2_cnt) {
						li.html('<b>' + j + '</b>').appendTo(ul).css('list-style', 'initial');
						ul2.appendTo(li);
					} else {
						ul2.remove();
					}
				} else if (typeof App[i][j] === 'function') li.html(j).appendTo(ul).css('list-style', 'initial');
			}
			$('<hr />').appendTo(div);
			$('<br />').appendTo(div);
			$('<br />').appendTo(div);
		}
	}
}

;(function () {
	let self = App.controls.ripple = {

		maxRipples: 5, // максимум одночасних ripple на хості

		ensureHost: function (el) {

			// Якщо задано кастомний контейнер — шукаємо в ньому або додаємо в нього
			const customSelector = el.getAttribute('data-ripple-container');
			let container = el;

			if (customSelector) {
				const found = el.querySelector(customSelector);
				if (found) {
					container = found;
					container.classList.add('ripple-container');
				}
			}

			let host = container.querySelector(':scope > .ripple-host');
			if (host) return host;

			const hostNew = document.createElement('span');
			hostNew.className = 'ripple-host';

			container.insertBefore(hostNew, container.firstChild);
			return hostNew;
		},

		spawn: function (el, pageX, pageY) {
			const host = self.ensureHost(el);
			const hostRect = host.getBoundingClientRect();

			const scrollX = window.scrollX || window.pageXOffset;
			const scrollY = window.scrollY || window.pageYOffset;

			const x = pageX - (hostRect.left + scrollX);
			const y = pageY - (hostRect.top + scrollY);

			const dx = Math.max(x, hostRect.width - x);
			const dy = Math.max(y, hostRect.height - y);
			const radius = Math.sqrt(dx * dx + dy * dy);
			const duration = 225;

			// Лімітуємо кількість ripple на хості
			while (host.children.length >= self.maxRipples) {
				host.children[0].remove();
			}

			const circle = document.createElement('div');
			circle.className = 'ripple-circle';
			circle.style.width = `${radius * 2}px`;
			circle.style.height = `${radius * 2}px`;
			circle.style.left = `${x - radius}px`;
			circle.style.top = `${y - radius}px`;
			circle.style.setProperty('--ripple-duration', `${duration}ms`);

			host.appendChild(circle);

			requestAnimationFrame(() => {
				circle.style.transform = 'scale(1)';
			});

			// Зберігаємо тривалість для видалення
			circle._rippleDuration = duration;

			return circle;
		},

		onBoot: function () {

			// O Lushyk
			// а там будем далі пробувать, на кнопки хочеться, на чіпси також чому ні
			// але може не на всі стилі кнопок воно буде доречно
			// тому все потрошку будем додавать ))
			const selector = '.btn:not(.btn-noripple), .withRipple, .modal__header__tabs a';

			// для легкого дебага на сторінці хелперів доступно включено на десктопі
			if (!App.device.is_mobile() && !window.RIPPLE_DESKTOP_ENABLED) return;

			let activeRippleElement = null;

			document.addEventListener('pointerdown', (e) => {
				const el = e.target.closest(selector);
				if (!el) return;

				const triggerSelector = el.getAttribute('data-ripple-trigger');

				if (triggerSelector) {
					const trigger = e.target.closest(triggerSelector);
					if (!trigger || !el.contains(trigger)) return;
				}

				activeRippleElement = el;
				self.spawn(el, e.pageX, e.pageY);
			}, { passive: true });

			const handleRelease = (e) => {
				if (!activeRippleElement) return;

				const circles = activeRippleElement.querySelectorAll('.ripple-circle');
				for (const circle of circles) {
					if (!circle._rippleDuration) continue;

					// Ставимо opacity: 0 щоб запустити зникнення
					circle.style.opacity = '0';

					// Видаляємо після завершення transition
					const duration = circle._rippleDuration;
					setTimeout(() => {
						if (circle.parentNode) circle.remove();
					}, duration + 50);

					// Скидаємо, щоб не повторити
					delete circle._rippleDuration;
				}

				activeRippleElement = null;
			};

			document.addEventListener('pointerup', handleRelease);
			document.addEventListener('pointercancel', handleRelease);
		},
	};
})();

;(function() {
	let self = App.controls.slider = {

		init: function () {
			$('.eye_init:visible').removeClass('eye_init').find('a.act').each(function () {
				$(this).parent().find('i').show().css({
					width: $(this).outerWidth() + 4,
					left: $(this).position().left - 3,
					top: $(this).position().top - 7
				});
			});
			$('.eye_line a').not('.wsinit').addClass('wsinit').bind('click', function () {
				$(this).parent().find('a').removeClass('act');
				$(this).addClass('act');
				$(this).parent().parent().find('input').val($(this).attr('rel'));
				$(this).parent().find('i').show().css({
					width: $(this).outerWidth() + 4,
					left: $(this).position().left - 3,
					top: $(this).position().top - 7
				}).addClass('ani');
				let o = $(this).parent();
				while (o.length && !o.hasClass('eye_conf')) o = o.parent();
				o.find('.button').removeClass('button_dis2');
				if (o.parent().find('a.def').not('.act').length) o.parent().find('.reset').show(); else o.parent().find('.reset').hide();
				if (App.modal.is_shown()) {
					if (App.modal.obj_window.find('.modal__content .eye_conf a.def').not('.act').length) App.modal.obj_window.find('.modal__content .eye_conf .ws-btn-reset').show(); else App.modal.obj_window.find('.modal__content .eye_conf .ws-btn-reset').hide();
				}
				$(this).trigger('blur');
				return false;
			});
			$('.eye_conf .reset').not('.wsinit').addClass('wsinit').bind('click', function () {
				$(this).parent().find('a.def').not('.act').trigger('click');
				return false;
			});
			if (App.modal.is_shown()) {
				if (App.modal.obj_window.find('.modal__content .eye_conf a.def').not('.act').length) App.modal.obj_window.find('.modal__content .eye_conf .ws-btn-reset').show(); else App.modal.obj_window.find('.modal__content .eye_conf .ws-btn-reset').hide();
				App.modal.obj_window.find('.modal__content .eye_conf .ws-btn-reset').not('.wsinit').addClass('wsinit').bind('click', function () {
					App.modal.obj_window.find('.modal__content .eye_conf a.def').not('.act').trigger('click');
					return false;
				});
			}
		},

		init_for_sidebar(o) {
			o.find('.eye_init:visible').removeClass('eye_init').find('a.act').each(function () {
				$(this).parent().find('i').show().css({
					width: $(this).outerWidth() + 4,
					left: $(this).position().left - 3,
					top: $(this).position().top - 5
				});
			});
			o.find('.eye_line a').bind('click', function () {
				$(this).parent().find('a').removeClass('act');
				$(this).addClass('act');
				$(this).parent().find('i').show().css({
					width: $(this).outerWidth() + 4,
					left: $(this).position().left - 3,
					top: $(this).position().top - 5
				}).addClass('ani');
				let o = $(this).parent();
				while (o.length && !o.hasClass('eye_conf')) o = o.parent();
				$(this).trigger('blur');
				return false;
			});
		},

		reinit: function () {
			$('.eye_line:visible').find('a.act').each(function () {
				$(this).parent().find('i').show().css({
					width: $(this).outerWidth() + 4,
					left: $(this).position().left - 3,
					top: $(this).position().top - 7
				});
			});
		},

		onLoadPage: function () {
			self.init();
		}
	}
})();

;(function() {
	let self = App.controls.stage_tag_select_and_go = {
		callback: null,
		show_context: function(menu_anchor, endpoint, params) {
			params ||= {};
			params['request'] ||= {};
			params['request']['template'] = 'menu';
			endpoint ||= $(menu_anchor).attr('data-url');
			App.menu.show({
				anchor: menu_anchor,
				url: App.helper.url.add_query(endpoint, $.param(params['request'])),
				onload: params.onload || null,
				onshow: params.onshow || null,

				replace: params.replace || false,
				backup: params.backup || false,
				type: params.type || '',
				cache_trigger: params.cache_trigger || 'tags,tag_group',
				width: params.width || 232,
			});
		}
	}
})();
;(function() {
	let self = App.controls.swipe_reload = {

		obj_window: null,

		is_started: false,

		start: function (callback) {

			if (!self.obj_window) return;

			self.is_started = true;

			if (!callback) {
				callback = () => App.core.reload_everything();
			}

			$('body').addClass('withSwipeReloadTransition');
			$('#load_overlay').show(); // це потрібно чи вже legacy?
			self.obj_window.css({
				"--swipeReload-top": '48px', // height(40px) + margin-top(8px)
				"--swipeReload-opacity": 1,
			}).addClass('swipeReload-state2');
			$('#content').css({
				"--swipeReload-top": '48px',
				pointerEvents: '',
			});

			setTimeout(() => self.obj_window.addClass('swipeReload-state3'), 50);
			setTimeout(callback, 900);
		},

		stop: function (immediate) {

			self.is_started = false;

			if (!self.obj_window) return;

			self.obj_window.css({
				"--swipeReload-top": '',
				"--swipeReload-add-top": '',
				"--swipeReload-opacity": '',
				"--swipeReload-rotate": '',
				"--swipeReload-headerHeight": '',
			})
			.removeClass('swipeReload-state swipeReload-state2 swipeReload-state3 swipeReload-hiding swipeReload--shown swipeReload--addTop');
			$('#content').css({
				"--swipeReload-top": '',
				"--swipeReload-add-top": '',
				pointerEvents: '',
			});
		},

		onUnloadPage: function () {
			self.stop();
		},

		onBoot: function () {
			self.obj_window = $('#swipeReload');
			App.bus.app.on('task_view_ready', function () {
				self.stop();
			});
		},
	}
})();

;(function() {
	let self = App.controls.switch = {
		toggle: function (el, state) {

			if (typeof state !== 'undefined') {
				const isActive = state === true || state === 1;

				if (isActive) {
					$(el).addClass('sw_act');
				} else {
					$(el).removeClass('sw_act');
				}
			} else {
				if ($(el).attr('data-id')) {
					$('.menu').find('a[data-id=' + $(el).attr('data-id') + ']').toggleClass('sw_act');
				} else {
					$(el).toggleClass('sw_act');
				}
			}

			if ($(el).hasClass('sw_withHint')) {
				$('.sw_status').remove();
				$(el).prepend('<span class="sw_status">' + ($(el).hasClass('sw_act') ? 'on' : 'off') + '</span>');
				setTimeout(function () {
					$('.sw_status').remove();
					App.menu.hide(true);
				}, 500);
				if (el.href) setTimeout('App.core.goto(\'' + el.href + '\')', 500);
			}
		},

		onLoadPage: function () {
			if (!$('body').hasClass('mobile')) $('.sw_pre a').hover(function () {
				$(this).parent().addClass('sw_hover');
			}, function () {
				$(this).parent().removeClass('sw_hover');
			});
		}
	}
})();

;(function() {
	let self = App.controls.sortable = {
		init: function() {
			$('.sortable').each(function() {
				let sortcount = 0, asc = $(this).attr('data-asc') || '0';

				this.asc = asc === '1';

				$(this).find('span').each(function(){
					$(this).css('cursor', 'pointer').css('min-width', $(this).width() + 20);
					//$(this).append('<ws-icon name="arrows/arrow_circle_sm-up" style="display: none"></ws-icon>');
					$(this).append('<ws-icon name="arrows/arrow_circle_sm-down" style="display: none"></ws-icon>');
					$(this).bind('click', function() {
						self.sort($(this).parent().get(0), $(this).attr('data-sortby') || '0');
					});

					$(this).hover(function() {
						if (!$(this).hasClass('sorted')) {
							if (!$(this).parent().get(0).asc) {
								$(this).find('ws-icon[name="arrows/arrow_circle_sm-down"]').show().css('opacity', 0.5);
							} else {
								//$(this).find('ws-icon[name="arrows/arrow_circle_sm-up"]').show().css('opacity', 0.5);
								$(this).find('ws-icon[name="arrows/arrow_circle_sm-down"]').addClass('rotated_up').show().css('opacity', 0.5);
							}
						}
					}, function() {
						if (!$(this).hasClass('sorted')) {
							//$(this).find('ws-icon[name^="arrows/arrow_circle_sm"]').hide().css('opacity', 1);
							$(this).find('ws-icon[name="arrows/arrow_circle_sm-down"]').removeClass('rotated_up').hide().css('opacity', 1);
						}
					});
					sortcount++;
				});

				if (sortcount === 1 && $(this).find('span').length === 1) $(this).find('span').attr('data-sortby', '0');

				if ($(this).hasClass('sortable-default')) {
					self.sort(this, '0');
				}
			});
		},

		sort: function(column, sortby) {
			let table = $(column).closest("table").eq(0);
			let tbody = table.find('tbody');
			let rows = tbody.find("tr").toArray().sort(this.comparer($(column).index(), sortby));
			column.asc = column.asc != null ? !column.asc : true;
			$(table).find('th ws-icon[name^="arrows/arrow_circle_sm"]').removeClass('rotated_up').hide().css('opacity', 1);
			if (column.asc) {
				rows = rows.reverse();
				$(column).find('span[data-sortby="'+sortby+'"] ws-icon[name="arrows/arrow_circle_sm-down"]').show().css('opacity', 1);
			} else {
				$(column).find('span[data-sortby="'+sortby+'"] ws-icon[name="arrows/arrow_circle_sm-down"]').addClass('rotated_up').show().css('opacity', 1);
				//$(column).find('span[data-sortby="'+sortby+'"] ws-icon[name="arrows/arrow_circle_sm-up"]').show().css('opacity', 1);
			}
			for (let i = 0; i < rows.length; i++) {
				tbody.append(rows[i]);
			}
			$(table).find('.sortable span').removeClass('sorted');
			$(column).find('span[data-sortby="'+sortby+'"]').addClass('sorted');
		},

		comparer: function(index, sortby) {
			return function(a, b) {
				let valA = self.getCellValue(a, index, sortby);
				let valB = self.getCellValue(b, index, sortby);
				return $.isNumeric(valA) && $.isNumeric(valB) ? valA - valB : String(valA).localeCompare(String(valB));
			};
		},
		getCellValue: function(row, index, sortby) {
			let sortData = '';
			if (sortby === '0') {
				sortData = $(row).children("td").eq(index).data('sort-value-' + sortby) || $(row).children("td").eq(index).data('sort-value');
			} else {
				sortData = $(row).children("td").eq(index).data('sort-value-' + sortby);
			}
			let result = sortData ? sortData : $(row).children("td").eq(index).text();
			return $.isNumeric(result) ? parseInt(result) : result;
		},

		onLoadPage: function () {
			this.init();
			App.bus.window.on('resize', App.helper.throttle(self.onresize));
		},

		onresize: function () {
			$('.sortable').each(function() {
				$(this).css('min-width', '').css('min-width', $(this).width() + 20);
			});
		}
	};

})();

;(function() {
	const RETURN_ASSIGNEE = 9;

	let self = App.controls.tag_edit = {
		callback: null,
		show: function(menu_anchor, endpoint, params) {
			params ||= {}
			endpoint ||= $(menu_anchor).attr('data-url');
			if (params.from) {
				endpoint = App.helper.url.add_query(endpoint, 'is_ajax=callback');
				params.backup = true;
			}
			self.callback = function(id) {
				if (params.from === 'menu')	{
					// спочатку треба сховати меню з формою create/update
					App.menu.hide();

					const ids_picked = [];
					App.controls.menu.get_picked_item(App.menu.obj_window).each(function () {
						ids_picked.push(this.dataset.id);
					});

					// лише потім перезавантажити меню зі списками міток
					App.menu.reload(function () {
						// onreload виконується ДО onshow
						// а нам треба, щоб вже були всі бінди, котрі додаються в onshow
						setTimeout(() => {
							// Lysh давай не призначати іі а просто створювати
							// $(this).find('.menu__item[data-id=' + id + ']').click();
							// а от обрані треба відновити
							ids_picked.forEach(id => {
								App.menu.obj_window.find('.menu__item[data-id="'+id+'"]').click();
							});
						});
					});
				} else if (params.from === 'modal') {
					App.modal.reload(function () {
						App.modal.obj_window.find('.menu__item[data-id=' + id + ']').click();
					});
				} else if (params.from === 'modal_workflow') {
					let menu_anchor = App.modal.obj_window.find('.menu_open');
					let menu_id_type = menu_anchor.attr('data-id-type');
					let menu_id_workflow = menu_anchor.attr('data-workflow');
					App.menu.hide_all();
					setTimeout(() => {
						const tags = (App && App.tags) ? Object.values(App.tags) : [];
						let cnt = 0;
						let result;
						for (const t of tags) {
							if (t && +t.id_type === 6 && +t.id_group === 55) {
								cnt++;
								if (cnt >= 2) break;
							}
						}
						if (result === undefined) result = cnt;
						App.modal.obj_window.find('a.drop_select[data-id-type=' + menu_id_type + ']').each(function () {
							$(this).attr('data-action', result<2 ? 'add' : 'select');
						});
						menu_anchor.prev('ws-icon').attr('name', App.tags_type_icon[0][menu_anchor.attr('data-id-type')]).attr('class', 'tag tag'+App.tags[id]['color']).removeClass('border_dashed');
						if (App.tags[id]['percent_style'] !== undefined) {
							let styleValue = App.tags[id]['percent_style'].match(/style="([^"]*)"/);
							if (styleValue && styleValue[1]) menu_anchor.prev('ws-icon').attr('style', styleValue[1]);
						}
						menu_anchor.find('.in').text(App.tags[id]['name']).next('ws-icon').attr('name', 'arrows/chevron-down');
						App.modal.obj_window.find('span.drop_select[data-id-type=' + menu_id_type + ']').each(function () {
							$(this).replaceWith(menu_anchor.clone());
						});
						menu_anchor.next('input[type=hidden]').val(id);
						App.modal.obj_window.find('.drop_select[data-id-type=' + menu_id_type + ']').each(function () {
							let icon = $(this).prev('ws-icon');
							let icon_id = icon.attr('data-tag');
							if (App.tags?.[icon_id]?.['percent_style'] !== undefined) {
								let styleValue = App.tags[icon_id]['percent_style'].match(/style="([^"]*)"/);
								if (styleValue && styleValue[1]) icon.attr('style', styleValue[1]);
							}
						});
						let matched = true;
						App.modal.obj_window.find('input[name^=tag_replace]').each(function () {
							if ($(this).val() === '-1') matched = false;
						});
						if (!matched) {
							App.modal.obj_window.find('.buttons ws-btn').attr('disabled', true);
						} else {
							App.modal.obj_window.find('.buttons ws-btn').removeAttr('disabled');
						}
					}, 400);
				} else if (params.from === 'project_modal') {
					App.menu.hide_all();
					//App.project_view.tab_reload("settings");
				}
			}
			App.menu.show({
				anchor: menu_anchor,
				url: endpoint,
				width: 320,
				onshow: function() {
					let menu = $(this);

					let inst = menu.find('input[name=inst]').val();//.toInt();

					if ('id_type' in params) {
						menu.find('.menu__item[data-container="tag_type"]').find('.in strong').html(App.tags_type[inst][params['id_type']]);
						menu.find('.editBlock__input .space').html('<ws-icon name="' + App.tags_type_icon[inst][params['id_type']] + '" class="tag tag' + menu.find('input[name=id_color]').val() + '"></ws-icon>');
						menu.find('input[name=id_type]').val(params['id_type']);
						menu.find('input[name=is_hid]').val(params['is_hid']);
						menu.find('.tagColors__item.tag' + App.tags_type_def_color[inst][params['id_type']]).click();
						if (!('preserve_name' in params)) menu.find('.editBlock__input input').val('');
					} else if ('is_hid' in params) {
						menu.find('.menu__item[data-container="tag_group"]').find('.in span').html(App.tags_group[params['is_hid']].name);
						menu.find('.menu__item[data-container="tag_group"]').find('.in ws-icon').toggle(App.tags_group[params['is_hid']].hidden);
						menu.find('input[name=is_hid]').val(params['is_hid']);
						menu.find('.tagColors__item.tag50').click();
						if (!('preserve_name' in params)) menu.find('.editBlock__input input').val('');
					} else if (menu.find('input[name=id_color]').val()) {
						menu.find('.tagColors__item.tag'+menu.find('input[name=id_color]').val()).addClass('tagColors__item-active');
					}
				},
				onload: function () {
					let menu = $(this);

					let input = menu.find('.editBlock__input input');

					menu.on('click', '.menu__item[data-container=tag_group]', function() {
						App.controls.tag_group_select_and_go.show_context(this, null, {
							type: 'submenu',
							backup: true,
							onload: function() {
								$(this).off().on('click', '.menu__item[data-id]', function() {
									App.menu.hide();
									menu.find('.menu__item[data-container="tag_group"]').find('.in span').html($(this).find('.in span').html());
									menu.find('.menu__item[data-container="tag_group"]').find('.in ws-icon').toggle(!!$(this).find('.in ws-icon').length);
									menu.find('input[name=is_hid]').val($(this).attr('data-id'));
									input.trigger('input');
								});
							}
						});
						return false;
					});
					menu.on('click', '.menu__item[data-container=tag_type]', function() {
						let inst = menu.find('input[name=inst]').val();
						App.controls.tag_type_select_and_go.show_context(this, null, {
							type: 'submenu',
							backup: true,
							width: 220,
							onshow: function() {
								$(this).off().on('click', '.menu__item[data-id]', function() {
									App.menu.hide();
									menu.find('.menu__item[data-container="tag_type"]').find('.in strong').text($(this).find('.in').text());
									menu.find('.editBlock__input .space').html($(this).find('.space').html());
									menu.find('.editBlock__input .space ws-icon').attr('class', 'tag tag' + menu.find('input[name=id_color]').val());
									menu.find('input[name=id_type]').val($(this).attr('data-id'));
									menu.find('.tagColors__item.tag' + App.tags_type_def_color[inst][$(this).attr('data-id')]).click();
									input.trigger('input');
								});
							}
						});
						return false;
					});
					menu.on('click', '.tagColors__item', function() {
						$(this).parent().find('.tagColors__item').removeClass('tagColors__item-active').end().prev().find('font').html($(this).attr('data-title'));
						$(this).addClass('tagColors__item-active');
						menu.find('.tag_color').attr('class', 'tag_color tag' + $(this).attr('data-color'));
						menu.find('.editBlock__input .tag').attr('class', 'tag tag' + $(this).attr('data-color'));
						menu.find('input[name=id_color]').val($(this).attr('data-color'));
						input.trigger('input');
						return false
					});

					input.bind('keydown', function (e) {
						let key = e.keyCode ? e.keyCode : e.charCode;
						if (key === App.keycode.Enter) {
							menu.find('.menu__title ws-btn[name*=primary]').trigger('click');
							e.preventDefault();
						}
					});

					menu.find('.menu__title ws-btn[name*=primary]').bind('click', function () {
						if (input.hasClass('required') && !input.val()) {
							input.closest('.editBlock__input').shortblink();
						} else {
							if ($(this).attr('data-onclick')) {
								eval($(this).attr('data-onclick'));
							} else {
								App.core.form_submit($(this).parents('form'));
							}
						}
					});

					// COUNTERS INIT
					menu.find('.editBlock__input-counter').each(function () {
						let counter = $(this).find('input').attr('data-maxlength') - $(this).find('input').val().length;
						$(this).append('<span class="editBlock__input__counter">' + counter + '</span>');
					});
					input.bind('input', function () {
						let counter = $(this).attr('data-maxlength') - $(this).val().length;
						let counter_container = menu.find('.editBlock__input__counter');
						counter_container.html(counter);
						if (counter < 0 || !$(this).val().length) {
							menu.find('.menu__title ws-btn[name*=primary]').hide();
						} else {
							menu.find('.menu__title ws-btn[name*=primary]').show();
						}
						counter_container.toggleClass('editBlock__input__counter-error', counter<0);
					});
					// COUNTERS INIT

					input.bind('focus', function () {
						$(this).closest('.editBlock__input').addClass('editBlock-focused');
					});
					input.bind('focusout', function () {
						$(this).closest('.editBlock__input').removeClass('editBlock-focused');
					});
				},
				type: params.type || '',
				backup: params.backup || false,
				replace: params.replace || false,
			});
		},

		add_tag_helper: function(menu_anchor, endpoint, params) {
			endpoint ||= $(menu_anchor).attr('data-url');

			if (endpoint.indexOf('status=1') > 0 && !('id_type' in params)) {
				App.controls.tag_type_select_and_go.show_context(menu_anchor, $(menu_anchor).attr('data-url-secondary'), {
					type: 'submenu',
					backup: true,
					onshow: function() {
						$(this).off();
						$(this).on('click', '.menu__item[data-id]', function() {
							params['replace'] = true;
							params['id_type'] = $(this).attr('data-id').toInt();
							self.add_tag_helper(this, $(menu_anchor).attr('data-url'), params);
						});
					}
				});
				return false;
			} else self.show(menu_anchor, endpoint, params);
		},
		user: function(menu_anchor, endpoint, params) {
			params ||= {}
			endpoint ||= $(menu_anchor).attr('data-url');

			const dropdown_stages = (el, parent_menu, type = '') => {
				const url = App.helper.url.add_query(
					$(el).closest('form').attr('action'),
					App.actions.get('tag_return_assignee_stage:show')
				);
				App.controls.tag_edit.user_return_assignee_stage(el, url, {
					type,
					parent_menu,
					backup: true,
					id: parent_menu.find('input[name=id_tag]').val(),
					id_from: parent_menu.find('input[name=id_tag_from]').val(),
					submit: (menu) => {
						const active_item = App.controls.menu.get_active_item(menu);

						parent_menu.find('input[name=id_tag_from]').val(menu.find('input[name=id_tag_from]').val());

						if (type == 'submenu') {
							App.controls.menu.item_set_active(el);
							parent_menu.find('input[name=id_user_to]').val($(el).attr('data-id'));
							process_select_box(parent_menu);
						}

						const stage_icon = active_item.find('ws-icon.tag').clone();
						const stage_title = active_item.find('.flex_content').text();

						const dropdown_item = parent_menu.find('.menu__group-select-box .menu__item-dropdown');
						dropdown_item.find('[data-role="title"]').text(stage_title)
						dropdown_item.find('[data-role="left_icon"]').html(stage_icon);

						App.menu.hide();
					},
				});
			};
			const process_select_box = (menu, options) => {

				options = $.extend({}, {
					animate_selectbox: true,
				}, options);

				const select_box = menu.find('.menu__group-select-box');
				if (!select_box.length) return;

				const active_item = App.controls.menu.get_active_item(menu);
				if (!active_item.length) return;

				if (select_box.find('.menu__item[data-id]:visible').attr('data-id') == active_item.attr('data-id')) return;

				const is_extra_group = active_item.closest('.menu__group-extra').length > 0;
				const select_box_item = App.controls.menu.create_item({
					avatar: active_item.find('.av_sm').clone().removeClass('av_svg'),
					title: App.helper.html.encode(active_item.find('.in').text()),
					right_icon: 'input-box-solid-cancel',
					active: true
				})
					.addClass('flex_content')
					.attr({
						'data-id': active_item.attr('data-id'),
						'data-type': 'stage',
					});
				select_box_item.find('[data-role="right_icon"]').attr('data-action', 'remove').removeClass('space-20');

				const html = $('<div>').addClass('menu__item__wrapper flex_row');
				html.append(select_box_item);

				select_box.find('.menu__item__wrapper:not([data-role="placeholder"])').remove();
				select_box.append(html);
				if (options.animate_selectbox) html.shortblink();

				// Add extra items to the select box
				if (!is_extra_group) {
					const user_menu_btn = App.controls.menu.create_item({
						left_icon: 'contacts',
					}).addClass('btn-user-menu');
					html.prepend(user_menu_btn)
					return;
				}

				if (select_box_item.attr('data-id') == RETURN_ASSIGNEE) {
					let left_icon = () => '';
					let title = 'Unknown';
					if (menu.find('form').attr('data-tag-from-options')) {
						const tag_from_options = JSON.parse(menu.find('form').attr('data-tag-from-options'));
						if (tag_from_options.icon) left_icon = () => tag_from_options.icon;
						if (tag_from_options.title) title = tag_from_options.title;
						menu.find('form').removeAttr('data-tag-from-options')
					}
					const dropdown = App.controls.menu.create_item({
						left_icon,
						title,
						right_icon: 'arrows/chevron-down',
						active: true
					}).addClass('menu__item-dropdown').attr({
						'data-title-config': 'white bottom_right',
					});
					select_box_item.attr({
						'data-title-config': 'white bottom_right',
					});
					html.prepend(dropdown);
					dropdown.on('click', function(event) {
						event.preventDefault();
						dropdown_stages(this, menu);
					});
					return;
				}
			};

			App.controls.user_select_and_go.show_context(menu_anchor, endpoint, {
				type: params.type || '',
				backup: params.backup || false,
				replace: params.replace || false,
				onload: function() {
					let menu = $(this);
					menu.find('.menu__group-head ws-btn, .menu__group-search ws-btn').click(function() {
						App.core.form_submit(menu.find('form'));
					});
					menu.find('.menu__group-searchable .menu__item[data-id]').click(function() {
						if ($(this).attr('data-id') == RETURN_ASSIGNEE) {
							dropdown_stages(this, menu, 'submenu');
							return;
						}
						App.controls.menu.item_set_active(this);
						menu.find('input[name=id_user_to]').val($(this).attr('data-id'));
						menu.find('input[name=id_tag_from]')?.val(0);
						process_select_box(menu);
					});
					menu.find('.menu__group-select-box').on('click', '.menu__item[data-id] [data-action="remove"]', function(event) {
						const select_box = $(event.delegateTarget);
						const new_id = select_box.find('.menu__item__wrapper[data-role="placeholder"]').find('.menu__item[data-id]').attr('data-id') || 0;
						$(this).closest('.menu__item__wrapper').remove();
						menu.find('input[name=id_user_to]')?.val(new_id);
						menu.find('input[name=id_tag_from]')?.val(0);
						App.controls.menu.get_active_item(menu).removeClass(['menu__item-active', 'menu__item-picked'])
							.closest('.menu__group').removeClass('menu__group-hidden');
						select_box.find('.menu__item__wrapper').first().shortblink();
						App.controls.menu.process_groups_visibility(menu);
					});
					menu.find('.menu__group-select-box').on('click', '.btn-user-menu', function(event) {
						event.preventDefault();
						const id_user = $(this).closest('.menu__item__wrapper').find('.menu__item[data-id]').attr('data-id');
						App.controls.user_menu.show(this, id_user, 'parent fixed left', 0, {backup: true});
					});
				},
				onshow: function() {
					let menu = $(this);
					menu.find('ws-btn input[name=skip_notify]').val('');
					let id = menu.find('input[name=id_user_to]').length ? menu.find('input[name=id_user_to]').val() : 0;
					menu.find('.menu__group-searchable .menu__item').each(function() {
						$(this).toggleClass('menu__item-active', $(this).attr('data-id') == id)
					});
					process_select_box(menu, { animate_selectbox: false });
				}
			});
		},
		user_return_assignee_stage: function(menu_anchor, endpoint, params) {
			params ||= {}
			endpoint ||= $(menu_anchor).attr('data-url');
			const submit = params.submit || ((menu) => {
				App.message.info('in development');
				// App.core.form_submit(menu.find('form'));
			});
			App.controls.project_task_stage_and_go.show_context(menu_anchor, endpoint, {
				type: params.type || '',
				backup: params.backup || false,
				replace: params.replace || false,
				onshow: function() {
					let menu = $(this);
					menu.find('.menu__item[data-id]').off().on('click', function() {
						App.controls.menu.item_set_active(this);
						menu.find('input[name=id_tag_from]').val($(this).attr('data-id'));
						submit(menu);
					});
					menu.find('[name=id_tag]').val(params['id']);
					menu.find('[name=id_tag_from]').val(params['id_from']);
					menu.find('.menu__item').each(function() {
						$(this).toggleClass('menu__item-active', $(this).attr('data-id') == params['id_from']);
						$(this).toggleClass('menu__item-disabled', $(this).attr('data-id') == params['id']);
					});
				}
			})
		},
		next_stage: function(menu_anchor, endpoint, params) {
			params ||= {}
			endpoint ||= $(menu_anchor).attr('data-url');

			if (params.id_to == null) params.id_to = $(params.from_kanabn ? '#obj-card'+params.id : '#obj-tag'+params.id).attr('data-next-stage')
			delete params.from_kanabn;

			App.controls.project_task_stage_and_go.show_context(menu_anchor, endpoint, {
				type: params.type || '',
				backup: params.backup || false,
				replace: params.replace || false,
				onload: function() {
					let menu = $(this);
					menu.find('.menu__group-head ws-btn, .menu__group-search ws-btn').click(function() {
						App.core.form_submit(menu.find('form'));
					});
					menu.find('.menu__item[data-id]').click(function() {
						App.controls.menu.item_set_active(this);
						App.controls.menu.process_select_box(menu);
						menu.find('input[name=id_tag_to]').val($(this).attr('data-id'));
					});
					App.controls.menu.init_select_box(menu, {
						on_remove: (menu, select_box, placeholder) => {
							const placeholder_item = placeholder.find('.menu__item[data-id]');
							menu.find('input[name=id_tag_to]').val(placeholder_item.attr('data-id'));
						}
					});
				},
				onshow: function() {
					let menu = $(this);
					menu.find('[name=id_tag]').val(params['id']);
					menu.find('[name=id_tag_to]').val(params['id_to']);
					menu.find('.menu__group-searchable .menu__item').each(function() {
						$(this).toggleClass('menu__item-active', $(this).attr('data-id') == params['id_to']);
						$(this).toggleClass('menu__item-disabled', $(this).attr('data-id') == params['id']);
					});
					App.controls.menu.process_select_box(menu, { animate_selectbox: false });
				}
			})
		},
		terms: function(menu_anchor, endpoint, params) {
			params ||= {}
			endpoint ||= $(menu_anchor).attr('data-url');
			const change_modal_options  = (menu, id) => {
				const roles = { 1: 'trm_set', 2: 'trm_plus' };
				const role = roles[id] || 'trm_default';
				menu.find('[data-role^=trm_]').addClass('ws-utility-hidden');
				menu.find('[data-role='+role+']').removeClass('ws-utility-hidden');
			};
			App.controls.task_terms_select_and_go.show_context(menu_anchor, endpoint, {
				type: params.type || '',
				backup: params.backup || false,
				replace: params.replace || false,
				onload: function() {
					let menu = $(this);
					menu.find('.menu__group-head ws-btn, .menu__group-search ws-btn').click(function() {
						App.core.form_submit(menu.find('form'));
					});
					menu.find('.menu__item[data-id]').click(function() {
						App.controls.menu.item_set_active(this);
						App.controls.menu.process_select_box(menu);
						menu.find('input[name=is_day_shift]').val($(this).attr('data-id'));
						change_modal_options(menu, $(this).attr('data-id'));

						menu.find('input[data-focus="focus-select"]:visible').focus_select_desktop();
					});
					App.controls.menu.init_select_box(menu, {
						on_remove: (menu, select_box, placeholder) => {
							const placeholder_item = placeholder.find('.menu__item[data-id]');
							menu.find('input[name=is_day_shift]').val(placeholder_item.attr('data-id'));
							change_modal_options(menu, placeholder_item.attr('data-id'));
						}
					});
					menu.find('[data-role^=trm_] input')
						.on('input', function() {
							let val = $(this).val().replace(/[^0-9]+/g, '');
							const min = +$(this).attr('data-min');
							if (val && +val < min) {
								val = min;
								$(this).animate_css('head-shake');
							}
							$(this).val(val);
						})
						.on('blur', function() {
							if ($(this).val() === '') $(this).val($(this).attr('data-min'));
						});
				},
				onshow: function() {
					let menu = $(this);
					const id = menu.find('input[name=is_day_shift]').val() || 0;
					App.controls.menu.item_set_active_by_id(menu, id);
					App.controls.menu.process_select_box(menu, { animate_selectbox: false });
				}
			})
		},
		stage_menu: function(menu_anchor, endpoint, params) {
			params ||= {}
			endpoint ||= $(menu_anchor).attr('data-url');
			let is_off, is_collapsed = false;
			if (params.from === 'kanban' || params.from === 'projects_kanban') {
				is_off = $('#obj-card' + params.id).hasClass('listing__card-prohibited');
				is_collapsed = $('#obj-card' + params.id).hasClass('listing__card-collapsed');
			} else { // project_modal
				is_off = $('#obj-tag' + params.id).hasClass('projectSettings__item-off');
			}
			endpoint = App.helper.url.add_query(endpoint, $.param({
				id_tag: params.id,
				from: params.from || ''
			}));
			App.menu.show({
				anchor: menu_anchor,
				url: endpoint,
				type: params.type || '',
				backup: params.backup || false,
				replace: params.replace || false,
				width: 264,
				onshow: function() {
					let menu = $(this);
					menu.find('.menu__item[data-off=yes]').toggle(!is_off);
					menu.find('.menu__item[data-off=no]').toggle(is_off);
					menu.find('.menu__item[data-collapse=yes]').toggle(!is_collapsed);
					menu.find('.menu__item[data-collapse=no]').toggle(is_collapsed);
					if (params.from === 'projects_kanban') {
						let card = $(menu_anchor).closest('.listing__card');
						let group = menu.find('.menu__item[data-direction]').first().parent();
						let card_prev = card.prevAll('.listing__card').first();
						let card_next = card.nextAll('.listing__card').first();
						if (card_prev.attr('data-group') !== card.attr('data-group')) menu.find('.menu__item[data-direction="prev"]').addClass('menu__item-disabled');
						if (card_next.attr('data-group') !== card.attr('data-group')) menu.find('.menu__item[data-direction="next"]').addClass('menu__item-disabled');
						if (group.find('.menu__item:not(.menu__item-disabled)').length === 0) group.addClass('menu__group-hidden');
					}
				}
			})
		},
		move_label_helper: function (menu_anchor, endpoint, params) {
			endpoint ||= $(menu_anchor).attr('data-url');
			let menu_endpoint = params.menu_endpoint || $(menu_anchor).attr('data-menu-url');

			if (params.project) menu_endpoint = App.helper.url.add_query(menu_endpoint, 'id_project='+params.project);

			App.controls.tag_group_select_and_go.show_context(menu_anchor, menu_endpoint, {
				type: 'submenu',
				backup: true,
				onshow: function() {
					$(this).find('.menu__item[data-id]').off('click').on('click', function() {
						$.getScript(App.helper.url.add_query(endpoint, 'is_hid='+$(this).attr('data-id')));
					});
				}
			});
		},
		delete_label_helper: function (menu_anchor, endpoint, params) {
			params ||= {};
			params.confirm ||= {};

			const params_confirm = {
				...params.confirm,
			};

			const show_confirm = () => {
				endpoint ||= $(menu_anchor).attr('data-url');
				let id_replace_to = 0;

				App.controls.confirm.menu(menu_anchor, {
					...params_confirm,
					width: $('#obj-tag' + params.id_tag).hasClass('tagsAdmListing__item-empty') ? 320 : 400,
					on_confirm: function () {
						$.getScript(App.helper.url.add_query(endpoint, 'id_replace_to='+id_replace_to));
					},
					onshow: function () {
						let confirm_menu = $(this);
						confirm_menu.find('.menu__group-head .in').addClass('flex_overflow').find('span').addClass('flex_overflow');
						confirm_menu.find('.replace_to a').on('click', function () {
							App.menu.show({
								anchor: this,
								backup: true,
								type: 'parent',
								url: $(this).attr('data-url'),
								onshow: function () {
									$(this).find('.menu__item[data-id]').removeClass('menu__item-active')
									$(this).find('.menu__item[data-id='+id_replace_to+']').addClass('menu__item-active')
									$(this).find('.menu__item[data-id]').off('click').on('click', function() {
										id_replace_to = $(this).attr('data-id');
										confirm_menu.find('.replace_to a .in').text($(this).find('.in').text());
										App.menu.hide();
									});
								}
							})
						})
					}
				});
			};

			if (params.confirm_message_url) {
				$.ajax({
					type: 'GET',
					url: params.confirm_message_url,
					dataType: 'html',
					success: function (html) {
						params_confirm.message = html;
						show_confirm();
					}
				});
			} else {
				show_confirm();
			}
		},
	}

})();

;(function() {
	let self = App.controls.tag_group = {
		show: function(menu_anchor, endpoint, params) {
			params = params || {};

			App.menu.show({
				anchor: menu_anchor,
				url: endpoint,
				width: 260,
				backup: 1,
				type: params.type ?? 'submenu',
				cache_trigger: 'tag_group',
				onload: function() {
					let menu = $(this);
					App.controls.menu.init(menu);

					menu.find('.menu__item[data-id]').each(function(index) {
						$(this).attr('data-order', index);
					});

					menu.find('#menuCreateWorkflow ws-btn').bind('click', function() {
						let name = $(this).closest('.menu').find('input').val().trim();
						App.menu.hide();
						let i = 0;
						App.menu.obj_window.find('.menu__item[data-id]').each(function() {
							if ($(this).attr('data-id').toInt() < i) i = $(this).attr('data-id');
						});
						i--;
						if (name) {
							menu.find('.menu__group-checkbox').append(App.helper.template.fill('menu_group_new', {
								name: name,
								i
							}));
							self.updateCounter.call(menu);
						}
					});

					menu.on('click', '.menu__item[data-id]', function() {
						self.updateCounter.call(menu);
					});

					menu.find('.menu__group-search ws-btn').bind('click', function() {
						if (!$(this).closest('.menu__submenuWrapper').length) {
							menu.invalidateMenu();
							App.core.form_submit($(this).closest('form'));
						} // submenu have button also
					});

					menu.find('input[name=id_tag_group]').attr('data-initial-value', menu.find('input[name=id_tag_group]').val());
				},
				onshow: function() {
					let input = $(this).find('input[name=id_tag_group]');

					input.val(input.attr('data-initial-value'));

					let ids = input.length && input.val().length ? input.val().split(',').map(Number) : [];

					$(this).find('.menu__item[data-id]').each(function() {
						$(this).toggleClass('menu__item-active', ids.includes($(this).attr('data-id').toInt()));
					});

					self.orderSelected($(this));
					self.updateCounter.call($(this));
				}
			});
		},

		orderSelected: function(menu) {
			let sorted_group = menu.find('.menu__group-sortactive');
			if (sorted_group.length) {
				sorted_group.find('.menu__item').each(function() {
					let from_group_index = $(this).attr('data-group-from');
					let parent_group = menu.find('.menu__group[data-group-id=' + from_group_index + ']');
					if (!parent_group.length) {
						parent_group = $('<div>', {
							'class': sorted_group.attr('class'),
							'data-group-id': from_group_index
						});
						parent_group.removeClass('menu__group-sortactive');
						sorted_group.after(parent_group);
					}
					$(this).detach().appendTo(parent_group);
				});

				sorted_group.remove();
			}

			let first_group = menu.find('.menu__item:first').parent();
			let group_type_class = first_group.hasClass('menu__group-checkbox') ? ' menu__group-checkbox' : ' menu__group-select';
			let active_items = menu.find('.menu__item-active');
			let has_active = active_items.length;
			let all_groups = menu.find('.menu__group').not('.menu__group-sortactive').filter(function() {
				return $(this).hasClass('menu__group-checkbox') || $(this).hasClass('menu__group-select');
			});
			all_groups.each(function(i, group) {
				if (!this.hasAttribute('data-group-id')) $(this).attr('data-group-id', i);
			});

			if (has_active) {
				let sel_group = $('<div>', {
					class: 'menu__group menu__group-sortactive menu__group-searchable' + group_type_class,
				});

				first_group.before(sel_group);
				active_items.each(function() {
					if ($(this).not('[data-group-from]')) $(this).attr('data-group-from', $(this).parent().attr('data-group-id'));
					$(this).detach().appendTo(sel_group);
				});
			}

			all_groups.each(function(i, group) {
				$(this).toggle($(this).find('.menu__item').length !== 0);
			});

			const sortGroups = function() {
				const groupsWithId = menu.find('.menu__group[data-group-id]');

				const sortedGroups = groupsWithId.sort(function(a, b) {
					const idA = parseInt($(a).attr('data-group-id')) || 0;
					const idB = parseInt($(b).attr('data-group-id')) || 0;
					return idA - idB;
				});

				const container = groupsWithId.first().parent();
				sortedGroups.detach().appendTo(container);
			};

			const sortItemsInGroups = function() {
				menu.find('.menu__group').each(function() {
					const group = $(this);
					const items = group.find('.menu__item');

					const sortedItems = items.sort(function(a, b) {
						const groupFromA = parseInt($(a).attr('data-group-from')) || 0;
						const groupFromB = parseInt($(b).attr('data-group-from')) || 0;

						if (groupFromA !== groupFromB) {
							return groupFromA - groupFromB;
						}

						const orderA = parseInt($(a).attr('data-order')) || 0;
						const orderB = parseInt($(b).attr('data-order')) || 0;
						return orderA - orderB;
					});

					sortedItems.detach().appendTo(group);
				});
			};

			sortGroups();
			sortItemsInGroups();
			const lastGroup = menu.find('.menu__group[data-group-id]').sort((a, b) => {
				return parseInt($(a).attr('data-group-id')) - parseInt($(b).attr('data-group-id'));
			}).last();

			menu.find('.menu__group-empty').detach().insertAfter(lastGroup);
		},

		updateCounter: function() { // this = menu
			let ids = [];
			$(this).find('.menu__item-active[data-id]').each(function() {
				ids.push($(this).attr('data-id'));
			});
			$(this).find('input[name=id_tag_group]').val(ids.join(','));
			self.orderSelected($(this));

			if (ids.length === 0) {
				$(this).find('.menu__group-search ws-btn').attr('disabled', 'true').attr('data-title', $(this).find('form[data-required-hint]').attr('data-required-hint'));
			} else {
				$(this).find('.menu__group-search ws-btn').attr('disabled', null).attr('data-title', null);
			}
		},

		updateProjects: function() { // this = menu
			let menu = $(this);
			let ids = [];
			menu.find('.menu__item-active').each(function() {
				ids.push($(this).attr('data-id'));
			});
			menu.find('input[name=ids_project]').val(ids.join(','));
		},

		updateTitleLayout: function() {
			if (!App.device.is_mobile()) return;
			let id_group = $(this).closest('tags-group-toggle').attr('data-tags-group');
			let group = $('#obj-group' + id_group);
			let title = group.find('.tagsAdmListing__group__title');
			let wrapped = $('#obj-group' + id_group + 'menu').find('.menu__item.sw_act').length > 0;
			title.toggleClass('tagsAdmListing__group__title--wrapped', wrapped);
		},
	}
})();

;(function () {
	let self = App.controls.tag_group_drag = {
		url: '/account/labels/',
		options: {},
		init: function () {
			if (App.device.is_mobile() || $(window).width() <= 480) return;

			let options = {
				clone: true,
				opacity: 0.8,
				target: '.tagsAdmListing__dropPlace',
				tolerance: 'none',
				minibar: $('#content'),
				start: self.onstart,
				end: self.onend,
				drop: self.ondrop,
				move: self.find_nearest_target,
				renewTarget: true,
			}

			$(".st_highlight").removeClass('st_highlight').shortblink();
			if (self.stages) {
				$('.tagsAdmListing__group').each(function () {
					options.target = '#' + $(this).attr('id') + ' .tagsAdmListing__dropPlace';
					$(this).find('.tagsAdmListing__item-draggable').not('.tagsAdmListing__item-dragInit').addClass('tagsAdmListing__item-dragInit').dragable(options);

				});
			} else {
				options.target = '.tagsAdmListing__group-label .tagsAdmListing__dropPlace';
				$('.tagsAdmListing__group-label .tagsAdmListing__item-draggable').not('.tagsAdmListing__item-dragInit').addClass('tagsAdmListing__item-dragInit').dragable(options);
			}
		},
		onstart: function (o, event) {
			o.originalElem.addClass('drag_this');
			o.prepareTargetMatrix();
			self.find_nearest_target(o, event);
			$('body').addClass('body-dragInProgress');
			o.elem.addClass('drag_clone');
		},
		onend: function (o, event) {
			o.elem.removeClass('drag_this');
			App.state.drag.stop();
			o.target.removeClass('tagsAdmListing__dropPlace-hover');
			$('body').removeClass('body-dragInProgress');
			o.elem.removeClass('drag_clone');
		},
		ondrop: function (o, target) {
			o.elem.removeClass('drag_clone');
			$('body').removeClass('body-dragInProgress');
			App.state.drag.stop();
			$('.tagsAdmListing__group').trigger('click');
			o.elem.removeClass('drag_this');
			try {
				if (o.elem.parent().find('.tagsAdmListing__item').length === 1) {
					o.elem.parents('.tagsAdmListing__group').addClass('tagsAdmListing__group-empty').find('.labels_empty').show().prev().show().prev().hide();
				}
				let a = target.attr('data-target').split('_');
				let b = o.elem.prev().attr('data-target').split('_');
				target.parents('.tagsAdmListing__group').removeClass('tagsAdmListing__group-empty');
				o.elem.prev().attr('data-target', a[0] + '_' + a[1] + '_' + b[2])
				o.elem.prev().filter('.tagsAdmListing__dropPlace').insertBefore(target);
				o.elem.insertBefore(target);
				$.getScript(App.helper.url.add_query(self.url, App.actions.get('account_tag_drag:do') + '&object=' + o.elem.attr('id') + '&target=' + target.attr('data-target') + '&id_in=' + (1 * a[0])) + '&id_type=' + (1 * a[1]));
				self.init_delete_buttons();
			} catch (e) {
			}
		},
		find_nearest_target: function (o, event) {
			App.state.drag.start();
			let j = 10000;
			let i_min = -1;
			o.target.removeClass('tagsAdmListing__dropPlace-hover');
			if (self.stages) {
				let dif = 0;
				for (let i = 0; i < o.targetMatrix.length; i++) if (!$(o.targetMatrix[i].t).hasClass('tagsAdmListing__dropPlace-disabled')) {
					if (j > Math.abs(o.top + dif - o.targetMatrix[i].y1 - 0.001 * i)
						&& o.top > o.targetMatrix[i].y1 - 100 && o.top < o.targetMatrix[i].y1 + 100
						&& o.left > o.targetMatrix[i].x1 - 100 && o.left < o.targetMatrix[i].x2 + 100
					) {
						j = Math.abs(o.top + dif - o.targetMatrix[i].y1 - 0.001 * i);
						i_min = i;
					}
				}
			} else {
				if (i_min === -1) for (let i = 0; i < o.targetMatrix.length; i++) if (!$(o.targetMatrix[i].t).hasClass('tagsAdmListing__dropPlace-disabled')) {
					if (o.top >= o.targetMatrix[i].y1 - 10 && o.top <= o.targetMatrix[i].y1 + 40
						&& o.left >= o.targetMatrix[i].x1 - (o.targetMatrix[i].x2 - o.targetMatrix[i].x1 + 10) && o.left <= o.targetMatrix[i].x2
					) {
						j = Math.abs(o.top - 0.5 * (o.targetMatrix[i].y1 + o.targetMatrix[i].y2) - 0.001 * i) + Math.abs(o.left - 0.5 * (o.targetMatrix[i].x1 + o.targetMatrix[i].x2) - 0.001 * i);
						i_min = i;
					}
				}
			}
			if (i_min !== -1) {
				o.currentTarget = $(o.targetMatrix[i_min].t);
				o.currentTarget.addClass('tagsAdmListing__dropPlace-hover');
			} else {
				o.currentTarget = null;
			}
		}
	};
})();

;(function() {
	let self = App.controls.tag_group_select_and_go = {
		callback: null,
		show_context: function(menu_anchor, endpoint, params) {
			params ||= {};
			params['request'] ||= {};
			params['request']['template'] = 'menu';
			endpoint ||= $(menu_anchor).attr('data-url');
			App.menu.show({
				anchor: menu_anchor,
				url: App.helper.url.add_query(endpoint, $.param(params['request'])),
				onload: params.onload || null,
				onshow: params.onshow || null,
				replace: params.replace || false,
				backup: params.backup || false,
				type: params.type || '',
				width: params.width || 324,
			});
		}
	}
})();

;(function() {
	let self = App.controls.tag_type_select_and_go = {
		callback: null,
		show_context: function(menu_anchor, endpoint, params) {
			params ||= {};
			params['request'] ||= {};
			params['request']['template'] = 'menu';
			endpoint ||= $(menu_anchor).attr('data-url');
			App.menu.show({
				anchor: menu_anchor,
				url: App.helper.url.add_query(endpoint, $.param(params['request'])),
				onload: params.onload || null,
				onshow: params.onshow || null,
				replace: params.replace || false,
				backup: params.backup || false,
				type: params.type || '',
				cache_trigger: params.cache_trigger || 'tag_group',
				width: params.width || 232,
			});
		}
	}
})();

;(function () {

	const DB_NAME = 'worksection';
	const DB_HASH_KEY = 'db_workspace';
	const DB_VERSION = 4;
	const PROJECTS_SYNC_STORE = 'projects_sync';
	const TASKS_STORE = 'tasks';

	const MAX_BATCH_SIZE = 1000;
	const MAX_BATCH_COUNT = 4;

	const TASK_FIELDS = [
		"id_parent", "id_parent_top", "id_user_to", "class", "dateact",
		"dateadd", "dateclose", "dateend", "datestart", "id_stage",
		"id_user_from", "important", "is_related", "is_repeat", "manual_order",
		"max_money", "max_time", "name", "status", "timeend", "timestart", "custom_fields"
	];

	let self = App.task_db = {
		allowed: false,
		in_progress: null,
		dbPromise: null,
		db: null,

		init: function () {
			if (!self.allowed) return;
			if (window.Dexie == null) return self.allowed = false;

			self.db = new Dexie(DB_NAME);

			self.db.version(DB_VERSION).stores({
				[PROJECTS_SYNC_STORE]: 'id',
				[TASKS_STORE]: 't, p'
			});
		},

		check_workspace: async function () {
			const currentDBhash = App.me.db_hash;
			const storedDBhash = localStorage.getItem(DB_HASH_KEY) || '';
			if (storedDBhash !== currentDBhash) {
				if (storedDBhash) await self.clear_all();
				localStorage.setItem(DB_HASH_KEY, currentDBhash);
			}
		},

		update_workspace: async function (db_hash) {
			const currentDBhash = App.me.db_hash = db_hash;
			const storedDBhash = localStorage.getItem(DB_HASH_KEY) || '';
			if (storedDBhash !== currentDBhash) {
				if (storedDBhash) await self.clear_all();
				localStorage.setItem(DB_HASH_KEY, currentDBhash);
				if (self.allowed) {
					self.openDB();
				}
			}
		},

		openDB: async function() {
			if (!self.dbPromise && self.allowed) {
				await self.check_workspace();
				self.dbPromise = self.db.open().catch(err => {
					App.core.warn('task_db.openDB', err);
					self.allowed = false;
					return null;
				});
			}
			return self.dbPromise;
		},

		clear_all: async function () {

			self.queue.await();
			self.queue.clear_all();

			await Dexie.delete(DB_NAME).catch(err => App.core.error('task_db.clear_all', err));
			self.dbPromise = null;

			localStorage.removeItem(DB_HASH_KEY);
		},

		invalidate: function () {
			if (!self.allowed) return;

			self.clear_all();
		},

		store: {
			tasks: () => self.db[TASKS_STORE],
			projects_sync: () => self.db[PROJECTS_SYNC_STORE],
		},

		toggle_allowed: function (allowed) {
			if (allowed !== self.allowed) {
				self.allowed = allowed;
				if (!allowed) { // delete db
					self.clear_all();
				} else {
					self.openDB();
				}
			}
		},

		/**
		 * @param {Array<number>} ids_project - List of project IDs to show.
		 * @param {Array<number>} ids_project_load - List of project IDs to load.
		 * @param {Object.<number, number>} project_local_dates - Object with project local timestamps
		 * @param {Object.<number, number>} project_sizes - Object with project approximate size
		 * @param callback_tasks
		 * @param {Function} callback - Callback function to handle the loaded tasks.
		 */
		load_projects_tasks: async function(ids_project, ids_project_load, project_local_dates, project_sizes, callback_tasks, callback) {
			const endpoint = App.helper.endpoint.primary() + '?' + App.actions.get('batch_load:show');
			const ids_project_batches = self.split_projects_to_batches(ids_project_load, project_sizes);
			callback_tasks ||= {};
			const jobs = [];
			for (const ids_project_batch of ids_project_batches) {
				jobs.push(((index, resolve, reject) => {
					App.core.async_task.ajax({
						id: 'index_db_load_projects_tasks_' + index,
						url: endpoint,
						type: 'POST',
						data: {
							updates: JSON.stringify(project_local_dates),
							ids_project: ids_project_batch.join(',')
						},
						dataType: 'json',
						timeout: App.env === 'local' ? 60000 : 30000,
						success: async function (response) {
							const {keys, data, dt_update, ids_project_update} = response;

							for (const taskId in data) {
								let id = +taskId;
								callback_tasks[id] = { id };
								keys.forEach((key, i) => {
									callback_tasks[id][key] = data[taskId][i];
								});
								self.queue.tasks[id] = callback_tasks[id];
							}

							await self.openDB();

							if (!self.allowed) return resolve();

							for (const id of ids_project_update) {
								self.queue.projects_sync[id] = dt_update;
							}
							self.queue.run(); // no wait, async

							const ids_project_not_updated = ids_project_batch.filter(id => !ids_project_update.includes(id));
							if (Object.keys(ids_project_not_updated).length) {

								await self.store.projects_sync().bulkPut(ids_project_not_updated.map(id => ({id, dt_update})));
								const ids_project_queue = ids_project_not_updated.filter(id => id in self.queue.projects_sync);
								const ids_project_local = ids_project_not_updated.filter(id => !(id in self.queue.projects_sync));
								self.read_projects_from_queue(ids_project_queue, callback_tasks);
								await self.read_projects_from_indexedDB(ids_project_local, callback_tasks);
							}

							resolve();
						},
					}).catch(reject);
				}));
			}

			await Promise.all(jobs.map((job, i) => {
				return new Promise((resolve, reject) => job(i, resolve, reject));
			}));

			callback?.(callback_tasks);
		},

		/**
		 * @param {Array<number>} ids_project_load - List of project IDs to load
		 * @param {Object.<number, number>} project_sizes - Object with project approximate size
		 * @returns {number[][]} array with MAX_BATCH_COUNT subarrays
		 */
		split_projects_to_batches: function(ids_project_load, project_sizes) {
			// Дозаповнюємо project_sizes нулями для всіх id
			for (const id of ids_project_load) {
				project_sizes[id] ||= 0;
			}

			const total_size = ids_project_load.reduce((sum, id) => sum + project_sizes[id], 0);

			if (total_size <= MAX_BATCH_SIZE) {
				return [ids_project_load];
			}

			const batches = Array.from({ length: MAX_BATCH_COUNT }, () => []);
			const batchSizes = Array(MAX_BATCH_COUNT).fill(0);

			const ids_project_sorted = [...ids_project_load].sort(
				(a, b) => project_sizes[b] - project_sizes[a]
			);

			for (const id of ids_project_sorted) {
				const size = project_sizes[id];
				const targetIndex = batchSizes.indexOf(Math.min(...batchSizes));
				batches[targetIndex].push(id);
				batchSizes[targetIndex] += size;
			}

			return batches;
		},

		/**
		 * @param {Array<number>} ids_project - List of project IDs to fetch tasks for.
		 * @param {Object.<number, number>} project_remote_dates - Object with project remote timestamps
		 * @param {Object.<number, number>} project_sizes - Object with project approximate size
		 * @param {Function|undefined} callback - Callback function to handle the result.
		 */
		get_projects_tasks: async function (ids_project, project_remote_dates, project_sizes, callback) {
			while (self.in_progress) {
				await self.in_progress.catch(() => {});
			}

			if (!ids_project.length) {
				callback?.([]);
				return;
			}

			let resolveWrapper;
			self.in_progress = new Promise(res => resolveWrapper = res);

			let project_local_dates = {};
			let ids_project_load = [], ids_project_local = [], ids_project_queue = [];

			if (!self.allowed) {
				ids_project_load = ids_project;
				ids_project.forEach(id => project_local_dates[id] = 0);
				await self.load_projects_tasks(ids_project, ids_project_load, project_local_dates, project_sizes, {}, callback);
				self.in_progress = null;
				resolveWrapper();
				return;
			}

			await self.openDB();

			self.queue.await();

			// Exclude Queue projects from ids_project_load
			const queue_projects = self.queue.projects_sync;
			for (const id_project in queue_projects) {
				if (ids_project.includes(id_project)) {
					project_local_dates[id_project] = queue_projects[id_project].dt_update;
					const remoteDate = project_remote_dates?.[id_project] || 0;
					if (remoteDate <= queue_projects[id_project].dt_update) {
						ids_project_queue.push(id_project);
					}
				}
			}

			// Exclude IndexedDB projects from ids_project_load
			const local_projects = await self.store.projects_sync().toArray();
			for (const project of local_projects) {
				if (ids_project.includes(project.id)) {
					project_local_dates[project.id] = project.dt_update;
					const remoteDate = project_remote_dates?.[project.id] || 0;
					if (remoteDate <= project.dt_update) {
						ids_project_local.push(project.id);
					}
				}
			}

			ids_project_load = ids_project.filter(id => !ids_project_local.includes(id) && !ids_project_queue.includes(id));

			const callback_tasks = {};
			self.read_projects_from_queue(ids_project_queue, callback_tasks);
			await self.read_projects_from_indexedDB(ids_project_local, callback_tasks);

			if (!ids_project_load.length) { // all projects cached - Read all from local cache

				callback?.(callback_tasks);
			} else {
				await self.load_projects_tasks(ids_project, ids_project_load, project_local_dates, project_sizes, callback_tasks, callback);
			}
			self.in_progress = null;
			resolveWrapper();
		},

		read_projects_from_queue: function(ids_project_queue, callback_tasks) {
			if (!ids_project_queue.length) return;
			// Load Queue projects from ids_project_queue
			for (const id_task in self.queue.tasks) {
				const task = self.queue.tasks[id_task];
				if (ids_project_queue.includes(task.id_project)) callback_tasks[task.id] = task;
			}
		},

		read_projects_from_indexedDB: async function(ids_project_local, callback_tasks) {
			if (!ids_project_local.length) return;
			// Load IndexedDB projects from ids_project_local
			const cached_tasks = await self.store.tasks().where('p').anyOf(ids_project_local).toArray();
			cached_tasks.forEach(task_mapped => {
				const task = self.mapping.task.unmap(task_mapped);
				callback_tasks[task.id] = task;
			});
		},

		get_projects_tasks_from_combined_data: async function (combined_data, callback) {
			const {ids_project, project_remote_dates, project_sizes} = self.parse_project_data(combined_data);
			return self.get_projects_tasks(ids_project, project_remote_dates, project_sizes, callback);
		},

		parse_project_data: function(combined_data) {
			const ids_project = Object.keys(combined_data).map(Number);
			const project_remote_dates = {};
			const project_sizes = {};

			for (const [id_project, {dt, size}] of Object.entries(combined_data)) {
				project_remote_dates[+id_project] = dt;
				project_sizes[+id_project] = size || 0;
			}
			return {
				ids_project,
				project_remote_dates,
				project_sizes
			}
		},

		silent_loaded: false,
		silent_projects_sync: async function (combined_data) {
			if (!self.allowed) return;
			const {ids_project,	project_remote_dates, project_sizes} = self.parse_project_data(combined_data);

			if (ids_project.length && !self.silent_loaded) await self.get_projects_tasks(ids_project, project_remote_dates, project_sizes);
			self.silent_loaded = true;
		},

		get_projects: async function () {
			await self.openDB();
			if (!self.allowed) return [];

			return self.store.projects().toArray();
		},

		queue: {
			tasks: {},
			projects_sync: {},
			running: 0,

			clear_all: function() {
				this.tasks = {};
				this.projects_sync = {};
				this.running = 0;
			},

			run: async function () {
				if (self.queue.running) return;

				const ids_project = Object.keys(self.queue.projects_sync);
				if (ids_project.length > 0) {
					const id_project = +ids_project[0];
					const dt_update = self.queue.projects_sync[id_project];

					self.queue.running = id_project;

					console.log('IndexedDB project.', id_project);

					const tasks = [];
					for (const id_task in self.queue.tasks) {
						if (self.queue.tasks[id_task].id_project === id_project) {
							tasks[id_task] = self.queue.tasks[id_task];
							delete self.queue.tasks[id_task];
						}
					}
					await self.put_project(id_project, dt_update, tasks);
					delete self.queue.projects_sync[id_project];
					setTimeout(self.queue.run, 100);
				}

				self.queue.running = 0;
			},

			await: async function () {
				while (self.queue.running) {
					await new Promise(resolve => setTimeout(resolve, 10));
				}
				return Promise.resolve();
			}
		},

		put_project: async function (id, dt_update, tasks) {
			if (!self.allowed) return;

			await self.store.tasks().where('p').equals(id).delete();
			await self.store.tasks().bulkPut(Object.values(tasks.map(self.mapping.task.map)));

			await self.store.projects_sync().put({ id, dt_update });
		},

		delete_project: async function (id) {
			if (!self.allowed) return;

			await self.store.tasks().where('p').equals(id).delete();
			await self.store.projects_sync().delete(id);
		},

		put_task: async function (id, task, dt_update) {
			await self.openDB();
			if (!self.allowed) return;
			task.id = id;
			const id_project = task.id_project;

			await self.queue.await();

			// Put into queue
			if (id_project in self.queue.projects_sync) {

				self.queue.tasks[id] = task;
				self.queue.projects_sync[id_project] = dt_update;
				return;
			}

			// Put into IndexedDB
			await self.store.tasks().put(self.mapping.task.map(task));

			if (dt_update && typeof dt_update === 'number' && id_project) {
				await self.store.projects_sync().put({ id: id_project, dt_update });
			}
		},

		update_task: async function (id_task, get_updated_data, dt_update) {
			await self.openDB();
			if (!self.allowed) return;

			let id_project, id_project_updated = null;
			if (typeof dt_update !== 'number') dt_update = null;
			if (!get_updated_data) get_updated_data = () => ({});

			await self.queue.await();

			// Update in queue
			if (id_task in self.queue.tasks) {
				const task = self.queue.tasks[id_task];

				id_project = task.id_project;

				if (dt_update) self.queue.projects_sync[id_project] = dt_update;

				const updated = App.helper.object.clone(task, get_updated_data(task));
				if (updated && JSON.stringify(updated) !== JSON.stringify(task)) {
					id_project_updated = updated.id_project;
					if (id_project_updated === id_project) { // same project
						self.queue.tasks[id_task] = updated;
						if (dt_update && id_project_updated !== id_project) self.queue.projects_sync[id_project_updated] = dt_update;
					} else if (id_project_updated in self.queue.projects_sync) {// both projects are not synced - good
						self.queue.tasks[id_task] = updated;
						if (dt_update) self.queue.projects_sync[id_project_updated] = dt_update;
					} else {
						delete self.queue.tasks[id_task];
						const project_updated = await self.store.projects_sync().get(id_project_updated);
						if (project_updated) { // new project is in IndexedDb
							await self.store.tasks().put(self.mapping.task.map(updated));
							if (dt_update) await self.store.projects_sync().put({ id: id_project_updated, dt_update });
						} else {
							// new project is not loaded yet - do nothing
						}
					}
				}
				return;
			}

			// Update in IndexedDB
			const task = self.mapping.task.unmap(await self.store.tasks().get(id_task));
			if (task == null) return;

			id_project = task.id_project;

			if (dt_update) await self.store.projects_sync().put({ id: id_project, dt_update });

			const updated = App.helper.object.clone(task, get_updated_data(task));

			App.core.log('task_db::update_task', 'Calculate updated data', {task, updated});

			if (updated && JSON.stringify(updated) !== JSON.stringify(task)) {
				id_project_updated = updated.id_project;
				if (id_project_updated === id_project) { // same project
					await self.store.tasks().put(self.mapping.task.map(updated));
				} else if (id_project_updated in self.queue.projects_sync) { // new project is not synced - good
					self.queue.tasks[id_task] = updated;
					if (dt_update && id_project_updated !== id_project) self.queue.projects_sync[id_project_updated] = dt_update;
				} else {
					const project_updated = await self.store.projects_sync().get(id_project_updated);
					if (project_updated) { // new project is in IndexedDb
						await self.store.tasks().put(self.mapping.task.map(updated));
						if (dt_update) await self.store.projects_sync().put({ id: id_project_updated, dt_update });
					} else {
						// new project is not loaded yet
						await self.store.tasks().delete(id_task);
					}
				}
			}
		},

		delete_task: async function (id_task, dt_update) {
			await self.openDB();
			if (!self.allowed) return;

			await self.queue.await();

			// Delete from queue
			if (id_task in self.queue.tasks) {
				const task = self.queue.tasks[id_task];
				if (dt_update && typeof dt_update === 'number' && task.id_project) {
					self.queue.projects_sync[task.id_project] = dt_update;
				}
				delete self.queue.tasks[id_task];
				return;
			}

			// Delete from IndexedDB
			const task = self.mapping.task.unmap(await self.store.tasks().get(id_task));
			if (task == null) return;

			await self.store.tasks().delete(id_task);

			if (dt_update && typeof dt_update === 'number' && task.id_project) {
				await self.store.projects_sync().put({ id: task.id_project, dt_update });
			}
		},

		mapping: {
			task: {
				map: function(obj) {
					if (!obj) return null;
					return {
						t: obj.id,
						p: obj.id_project,
						d: TASK_FIELDS.map(key => obj.hasOwnProperty(key) ? obj[key] : null)
					};
				},

				unmap: function (mapped) {
					if (!mapped) return null;
					const obj = {
						id: mapped.t,
						id_project: mapped.p
					};

					TASK_FIELDS.forEach((key, index) => {
						const value = mapped.d[index];
						if (value !== null && value !== undefined) {
							obj[key] = value;
						}
					});

					return obj;
				}
			}
		},

		notice_task_event: {
			map: new Map(),
			add: function (id_task, dt_update) {
				if (!self.allowed) return;
				self.notice_task_event.map.set(id_task, dt_update);
				self.notice_task_event.run();
			},
			run: App.helper.throttle(function () {
				for (const entry of self.notice_task_event.map.entries()) {
					self.update_task(entry[0], null, entry[1]);
				}
				self.notice_task_event.map.clear();
			}, 5000),
			skip_events: [
				"priority", "tag", "status", "user_to", "user_from", "terms", "name", "done_date",
				"attach", "limits", "costs", "bookmark", "subscribers", "seen", "delete", "add"
			]
		},

		touch_dateact: {
			map: new Map(),
			watch_events: {
				task: [
					"name", "priority", "tag", "status", "user_to", "user_from", "terms", "done_date", "attach",
					"limits", "costs", "like", "relations", "descr", "todo", "custom_field"
				],
				comment: ["add"]
			},
			effect: function (id_task, dt) {
				if (!self.allowed) return;
				self.touch_dateact.map.set(id_task, dt);
				self.touch_dateact.run();
			},
			run: App.helper.throttle(function () {
				for (const entry of self.touch_dateact.map.entries()) {
					let id_task = entry[0], dateact = entry[1];

					self.update_task(id_task, null, { dateact });
				}
				self.touch_dateact.map.clear();
			}, 5000)
		},

		update_task_queue: {
			jobs: [],
			is_busy: false,
			push: function (id_task, get_updated_data, dt_update) {
				self.update_task_queue.jobs.push({ id_task, get_updated_data, dt_update});
				self.update_task_queue.run();
			},
			run: App.helper.debounce(function () {
				if (self.update_task_queue.is_busy) return;

				const job = self.update_task_queue.jobs.shift();
				if (!job) return;

				self.update_task_queue.is_busy = true;
				self.update_task(job.id_task, job.get_updated_data, job.dt_update).catch(function (err) {
					App.core.error('task_db::update_task_queue', err);
				}).finally(function () {
					self.update_task_queue.is_busy = false;
					self.update_task_queue.run();
				});
			}, 100),
			clear: function () {
				self.update_task_queue.is_busy = false;
				self.update_task_queue.jobs = [];
				self.update_task_queue.run.clear();
			}
		},

		onLogin: function () {
			self.init();

			App.bus.state.on('task', function (payload, ctx) {
				if (!self.allowed) return;

				let id_task = payload.id, data = payload.data, fields = Object.keys(data);

				if (ctx.event_dt && fields.some(f => self.touch_dateact.watch_events.task.includes(f))) {
					self.touch_dateact.effect(id_task, ctx.event_dt);
				}

				if (ctx.source === App.object_state.FROM_WEBSOCKET) return;

				if (data.add) self.put_task(id_task, data.add, ctx.event_dt);

				if (data.delete) self.delete_task(id_task, ctx.event_dt);

				if (ctx.event_dt && fields.some(f => !self.notice_task_event.skip_events.includes(f))) {
					self.notice_task_event.add(id_task, ctx.event_dt);
				}
			}).on('task_updated', function (payload, ctx) {
				if (!self.allowed) return;
				if (ctx.source === App.object_state.FROM_WEBSOCKET) return;

				self.update_task_queue.push(payload.id_task, payload.get_updated_data, ctx.event_dt);
			}).on('comment', function (payload, ctx) {
				if (!self.allowed) return;
				if (!ctx.event_dt) return;

				Object.keys(payload.data).forEach(field => {
					if (!self.touch_dateact.watch_events.comment.includes(field)) return;
					if (payload.data[field].id_task) self.touch_dateact.effect(payload.data[field].id_task, ctx.event_dt);
				});
			}).on('project',function (payload) {
				if (!self.allowed) return;
				let id_project = payload.id, data = payload.data;

				if (data.add || data.import || data.mass) {
					self.delete_project(id_project);
				}
			});
		},
		onLogout: function () {
			self.update_task_queue.clear();
			self.clear_all();
			self.allowed = false;
		}
	};

})();

;(function() {
	let self = App.controls.task_online = {
		data: {
			modal: {
				id_task: 0,
				hash: ''
			},
			view: {
				id_task: 0,
				hash: ''
			},
		},
		active: false,
		view_type: 'view',
		timeout: null,
		online: function() {
			if (!App.core.is_active()) return;
			if (self.timeout) clearTimeout(self.timeout);
			self.timeout = setTimeout(self.expired, 60000);
			self.active = true;
			self.state = self.data[self.view_type].id_task + '_online';
			self.send_state();
		},
		expired: function() {
			self.timeout = null;
			self.active = false;
			self.state = self.data[self.view_type].id_task + '_expired';
			self.send_state();
		},
		offline: function() {
			if (self.timeout) clearTimeout(self.timeout);
			self.timeout = null;
			self.state = 'offline';
			self.send_state();
		},
		register_task: function(id_task, hash, modal) {
			App.controls.task_online.data[modal ? 'modal' : 'view'] = {id_task, hash};
			self.view_type = modal ? 'modal' : 'view';
			if (App.core.is_active()) self.online();
		},

		state: 'offline',
		sent_state: 'offline',
		send_state: function(force) {
			if (App.core.websocket.ready && ((force && App.core.is_active()) || self.sent_state !== self.state)) {
				self.sent_state = self.state;
				let data;
				if (self.state === 'offline') {
					data = {
						action: 'view_task',
						id_task: 0
					};
					App.core.call_queue.delete('task_online');
					App.core.websocket.postMessage(data);
				} else {
					data = {
						action: 'view_task',
						id_task: self.data[self.view_type].id_task,
						active: self.active,
					};
					if (self.active && self.state.indexOf('online') !== -1) data['hash'] = self.data[self.view_type].hash;
					App.core.call_queue.add('task_online', function() {
						App.core.websocket.postMessage(data);
					}, App, null, 1);
				}
			}
		},
		onBoot: function() {
			if (!App.core.is_active()) self.sent_state = 'offline';

			App.bus.ws.on('online', function () {
				App.controls.task_online.send_state(true);
			});

			App.bus.window
				.on('active', self.online)
				.on('mousemove scroll mousewheel touchmove touchstart keyup', self.online)
				.on('inactive beforeunload', self.offline);

			App.bus.app
				.on('task_view_ready', function({target}) {
					if (target.id) self.register_task(target.id, target.hash);
				})
				.on('modal_onload', self.online)
				.on('modal_onunload', function() {
					if (!App.modal.is_shown()) {
						self.data['modal'] = null;
						self.view_type = 'view';
					}
					self.online();
				});
		}
	};
})();

;(function() {
	let self = App.controls.task_view_indicator = {
		data: {},
		data_online: {},
		set: function(id_task, ids_user, ids_users_online) {
			this.data[id_task] = ids_user;
			this.data_online[id_task] = ids_users_online;
			App.core.call_queue.add('taskView' + id_task, () => this.draw(id_task), App, null, 1);
		},
		draw: function(id_task) {
			let ids_user = this.data[id_task] || [];
			let ids_users_online = this.data_online[id_task] || [];
			if (App.task_view.is_shown() && App.task_view.id == id_task)  {
				let html = '';
				ids_user.forEach(function(id_user) {
					if (id_user !== App.me.id && id_user in App.team && ids_users_online.includes(id_user)) {
						html += '<span class="online"' + ' data-title="' + App.helper.html.encode(App.helper.team(id_user, 'name')) + ' %G' + App.helper.html.encode(App.object_state.locale['viewing']) + 'G%">' + App.helper.team(id_user, 'avatar') + '</span>';
					}
				});
				App.task_view.obj_window.find('.taskView__viewing').toggleClass('taskView__viewing-active', html !== '').html(html);
			}
		},
		clear_all: function() {
			$('.taskView__viewing').removeClass('taskView__viewing-active').html('');
		},

		onLogin: function () {
			App.bus.msg.on('task_view', function (data, ctx) {
				self.set(data.id_task, data.ids_user, data.ids_users_online);
				if (ctx.scope === App.bus.SCOPE_WEBSOCKET) App.core.send_message_to_other_tabs({command: 'task_view', data: data});
			});

			App.bus.ws.on('offline', function () {
				App.controls.task_view_indicator.clear_all();
			});
		},
	};
})();



;(function() {
	let self = App.controls.time_input = {

		selected: {},
		return_to: {},
		last_event: {},
		last_selected: {},

		init: function() {
			App.modal.obj_window.find('input.time_input').each(function() {
				self.initInput(this);
			});
		},
		initInput: function(input) {
			input = $(input);
			let value = input.val();
			if (value.includes('.')) input.val(App.helper.time.time2string(value));

			if (value === '' || value === '0:00') input.addClass('time_input-empty')

			if (!input.attr('id')) {
				console.error('Time input don\'t have id');
				input.toggleDisabled(true).hide();
				return;
			}

			input.on('keydown', function(event) {
				let cursorPosition = input[0].selectionStart;

				if (event.keyCode === App.keycode.ArrowRight || event.keyCode === App.keycode.ArrowLeft || event.keyCode === App.keycode.Tab) {
					event.preventDefault();
					self.switchPart(input);
				}

				if (event.keyCode === App.keycode.ArrowUp || event.keyCode === App.keycode.ArrowDown) {
					event.preventDefault();
					self.arrowChangeValue(input, event.keyCode);
				}

				if (event.keyCode === App.keycode.Backspace || event.keyCode === App.keycode.Delete) {
					event.preventDefault();
					self.clearNum(input, event.keyCode);
				}

				if (event.key >= '0' && event.key <= '9') {
					let selectedPart = cursorPosition < 2 ? 'hour' : 'minute';
					self.handleDigitInput(input, event.key, selectedPart);
					event.preventDefault();
				}

				if ((event.key < '0' || event.key > '9') && event.keyCode !== App.keycode.ArrowLeft && event.keyCode !== App.keycode.ArrowRight && event.keyCode !== App.keycode.Tab) {
					event.preventDefault();
				}

				self.last_event[input.attr('id')] = 'keydown';
			});

			input.on('focus', function () {
				if (input.val() === '') input.val('0:00');
				self.switchPart(input, false, self.last_event[input.attr('id')] === 'blur' ? self.last_selected[input.attr('id')] : 'hour');
				self.last_event[input.attr('id')] = 'focus';
				if (!self.last_selected[input.attr('id')]) self.last_selected[input.attr('id')] = 'hour';
			});

			input.on('blur', function () {
				let selectedPart = input[0].selectionStart < 2 ? 'hour' : 'minute';
				if (input.val() === '0:00') input.val('');
				self.last_event[input.attr('id')] = 'blur';
				self.last_selected[input.attr('id')] = selectedPart;
			});

			input.on('click', function(e) {
				let part = input[0].selectionStart === input[0].selectionEnd ? self.getPartClicked(input, input[0].selectionStart) : '';
				if (self.last_event[input.attr('id')] === 'focus' && self.last_selected[input.attr('id')]) {
					part = self.last_selected[input.attr('id')];
				}
				self.switchPart(input, false, part);
				e.preventDefault();
				self.last_event[input.attr('id')] = 'click';
			});
			self.return_to[input.attr('id')] = {'hour': false, 'minute': false};
		},
		arrowChangeValue: function(input, code) {
			let cursorPosition = input[0].selectionStart;
			let selectedPart = cursorPosition < 2 ? 'hour' : 'minute';
			let currentValue = input.val();
			let partValue = Number(currentValue.split(':')[selectedPart === 'hour' ? 0 : 1]);
			let newValue;
			if (code === App.keycode.ArrowUp) { partValue++; } else { if (partValue>0) partValue--; }
			if (selectedPart === 'hour') {
				if (partValue>999) partValue = 999;
				newValue = partValue + ':' + currentValue.split(':')[1];
			} else {
				let newHour = Number(currentValue.split(':')[0]);
				if (partValue>=60 && newHour<999) {
					partValue = '00'; newHour++;
				} else if (partValue>=60 && newHour === 999) {
					newHour = '999';
					partValue = '59';
				} else {
					if (partValue<10) partValue = '0' + partValue;
					if (partValue<1 && newHour>0) {
						partValue = '59';
						newHour--;
					} else if (partValue<1 && newHour === 0) {
						newHour = '0';
						partValue = '00';
					}
				}
				newValue = newHour + ':' + partValue;
			}
			input.val(newValue);
			self.switchPart(input, true, selectedPart);
			input.toggleClass('time_input-empty', (input.val() === '' || input.val() === '0:00'));
			input.trigger('change');
		},

		clearNum(input, code) {
			let cursorPosition = input[0].selectionStart;
			let selectedPart = cursorPosition < 2 ? 'hour' : 'minute';
			let currentValue = input.val();
			let partValue = currentValue.split(':')[selectedPart === 'hour' ? 0 : 1];
			if (selectedPart === 'minute') {
				if (code === App.keycode.Backspace) {
					if (partValue.endsWith('0')) {
						partValue = '00';
					} else {
						partValue = partValue.slice(0, -1) + '0';
					}
				} else {
					if (partValue.startsWith('0')) {
						partValue = '00';
					} else {
						partValue = '0' + String(Number(partValue.substring(1)));
					}
				}
				input.val(currentValue.split(':')[0] + ':' + partValue);
				this.switchPart(input, true);
			} else {
				if (code === App.keycode.Backspace) {
					if (partValue.endsWith('0')) {
						if (partValue.length >= 2) {
							partValue = partValue.slice(0, -1);
						} else {
							partValue = '0';
						}
					} else {
						partValue = partValue.slice(0, -1);
					}
				} else {
					if (partValue.startsWith('0')) {
						if (partValue.length === 2) {
							partValue = '0';
						} else {
							partValue = partValue.slice(1);
						}
					} else {
						partValue = '0' + String(Number(partValue.substring(1)));
					}
				}
				input.val(String(Number(partValue)) + ':' + currentValue.split(':')[1]);
				this.switchPart(input, true);
			}
			input.toggleClass('time_input-empty', (input.val() === '' || input.val() === '0:00'));
			input.trigger('change');
		},

		getPartClicked: function(input, cursorPosition) {
			let separatorIndex = input.val().indexOf(':');

			if (cursorPosition <= separatorIndex) {
				return 'hour';
			} else {
				return 'minute';
			}
		},

		switchPart: function(input, keepSelection = false, part) {
			if (!part) {
				if (!self.selected[input.attr('id')]) {
					part = 'hour';
				} else {
					if (!keepSelection) {
						part = self.selected[input.attr('id')] === 'minute' ? 'hour' : 'minute';
					} else {
						part = self.selected[input.attr('id')];
					}
				}
			}
			let start, end;
			let value = input.val();
			if (part === 'hour') {
				start = 0;
				end = value.indexOf(':');
			} else if (part === 'minute') {
				start = value.indexOf(':') + 1;
				end = value.length;
			}
			input[0].setSelectionRange(start, end);
			if (!keepSelection) {
				self.selected[input.attr('id')] = part;
				self.return_to[input.attr('id')]['hour'] = input.val().split(':')[0];
				self.return_to[input.attr('id')]['minute'] = input.val().split(':')[1];
			}
			delete self.last_selected[input.attr('id')];
		},

		handleDigitInput: function(input, digit, part) {
			let currentValue = input.val();
			let addH = 0;
			if (part === 'hour') {
				let hours = currentValue.split(':')[0];
				if (self.return_to[input.attr('id')]['hour'] === hours) {
					hours = '';
					self.return_to[input.attr('id')]['hour'] = '';
				}
				hours = (hours.length > 0 ? String(Number(hours)) : '') + digit;
				if ( hours.length>3 ) {
					hours = hours.slice(-1);
				}
				input.val(hours + ':' + currentValue.split(':')[1]);
				self.switchPart(input, true);
			} else if (part === 'minute') {
				let minutes = currentValue.split(':')[1];
				if (self.return_to[input.attr('id')]['minute'] === minutes) {
					minutes = '0';
					self.return_to[input.attr('id')]['minute'] = '0';
				}
				minutes = String(Number(minutes)) + digit;
				if ( minutes.length>2 ) {
					minutes = '0' + minutes.slice(-1);
				}
				if (Number(minutes) >= 60) {
					addH = Math.floor(minutes/60);
					minutes = minutes - (addH*60);
					if (minutes<10) minutes = '0' + minutes;
					input.val(String(Number(currentValue.split(':')[0])+addH) + ':' + minutes);
					self.return_to[input.attr('id')]['minute'] = minutes;
				} else {
					input.val(currentValue.split(':')[0] + ':' + minutes);
				}
				self.switchPart(input, true);
			}
			input.toggleClass('time_input-empty', (input.val() === '' || input.val() === '0:00'));
			input.trigger('change');
			input.get(0).dispatchEvent(new Event('input'));
		}
	};
})();
;(function() {
	let self = App.controls.title_float = {
		onLoadPage: function () {
			$('#title_float .in, #mass_n_filt .filter, .commentListPanel .in').bind('click', function (e) {
				if (App.page.where() === 'gantt' && App.page.chart.is_hide_header) {
					$('body').removeClass('hide_header');
					App.page.chart.is_hide_header = false;
				}
				if (!$(e.target).parents().addBack().is('a, input, label, [onclick], .noscroll') && $('body').hasClass('quick_nav')) {
					if ($(window).scrollTop() > 0) $('#anch_top').trigger('click'); else $('#anch_foot').trigger('click');
				}
			});
		},
	}
})();

;(function() {
	let self = App.controls.todo = {
		apply: function (el, event) {
			if (App.offline_mode.is_on()) return;
			if (!$(event.target).is('input') && !$(event.target).is('a') && !$(event.target).parent().is('a') && !$(event.target).parent().parent().is('a') && !App.helper.selection.is_not_empty()) {
				$.ajax({
					url: App.helper.endpoint.primary() +  '?' + App.actions.get('todo_done:do') + '&' + $.param({
						todo: $(el).attr('rel'),
						is_on: $(el).hasClass('done') ? 0 : 1
					}),
					dataType: 'script'
				});
			}
		}
	}
})();

;(function() { // seems to be unused
	let self = App.controls.top_bottom_scrollers = {
		onLoadPage: function () {
			$('#goto_top').bind('click', function () {
				$('body').removeClass('doscroll doscroll2');
				$(window).scrollTop(0);
				$(this).hide();
				clearTimeout(window.scrolltm);
				window.scrollpos = -1;
				return false;
			});
			$('#goto_foot').bind('click', function () {
				$('body').removeClass('doscroll doscroll2');
				$(window).scrollTop(App.helper.doc.content_height());
				$(this).hide();
				clearTimeout(window.scrolltm);
				window.scrollpos = -1;
				return false;
			});
		}
	}
})();

;(function() {
	let self = App.controls.typing = {
		data: {},
		timeout: {},
		add: function(id_task, id_user) {
			if (!App.team[id_user] || id_user == App.me.id) return false;
			if (!self.data[id_task]) self.data[id_task] = {};
			self.data[id_task][id_user] = new Date();
			self.draw_task(id_task, true);
		},
		delete: function(id_task, id_user) {
			if (id_task in self.data && id_user in self.data[id_task]) {
				delete (self.data[id_task][id_user]);
				self.draw_task(id_task, true);
			}
		},
		draw_task(id_task, draw) {
			if (self.timeout[id_task]) {
				clearTimeout(self.timeout[id_task]);
				self.timeout[id_task] = null;
			}
			let o = $('.sidePanel__list__item-chat[data-chat=' + id_task + ']');
			let is_view = App.task_view.is_shown() && App.task_view.id == id_task;
			if (is_view || o.length) {
				let ids_user = [];
				let dt = new Date();
				for (let id_user in self.data[id_task]) {
					if (dt.getTime() - self.data[id_task][id_user].getTime() > 15000) {
						delete (self.data[id_task][id_user]);
						draw = true;
					} else {
						ids_user.push(id_user);
					}
				}
				if (ids_user.length) self.timeout[id_task] = setTimeout(self.draw_task, 1000, id_task);

				if (is_view && draw) {
					App.core.call_queue.add('taskView' + id_task, () => App.controls.task_view_indicator.draw(id_task), App, null, 0.05);
					let o_line = App.task_view.obj_window.find('.taskView__typing');
					if (o_line.length) {
						if (ids_user.length) {

							let template_many = 'task_view_typing_many';
							let template_single = 'task_view_typing';
							if (App.device.is_mobile() && App.task_view.is_chat) {
								template_many = 'chat_view_typing_many_mobile';
								template_single = 'chat_view_typing_mobile';
							}

							let html = ids_user.length > 1
								? App.helper.template.fill(template_many, {
									'users': ids_user.map(i => ({
										avatar: App.helper.team(i, 'avatar'),
										name: App.helper.team(i, 'name'),
									})),
								})
								: App.helper.template.fill(template_single, {
									'avatar': App.helper.team(ids_user[0], 'avatar'),
									'name': App.helper.team(ids_user[0], 'name'),
								});

							o_line.addClass('taskView__typing-active').html(html);
						} else {
							o_line.removeClass('taskView__typing-active').html('');
						}
					}
				}
				if (o.length && draw) {
					if (ids_user.length) {
						let html = '';
						if (ids_user.length > 1) ids_user.forEach(function (id_user) {
							html += '<span class="place" data-title="'+App.helper.html.encode(App.helper.team(id_user, 'name'))+'">' + App.helper.team(id_user, 'avatar') + '</span>';
						}); else {
							let id_user = ids_user[0];
							html = '<span class="name">'+App.helper.html.encode(App.helper.team(id_user, 'name'))+'</span>' + '<span class="place">'+App.helper.team(id_user, 'avatar')+'</span>';
						}
						html = App.helper.template.fill('chat_typing', {
							'html': html,
						});
						o.find('.typing').remove();
						o.find('.details .in').before(html);
					} else {
						o.find('.typing').remove();
					}
				}
			}
		},

		last_typing_date: null,
		last_typing_task: null,
		send_event: function(id_task) {
			let dt = new Date();
			if (!self.last_typing_date || self.last_typing_task !== id_task || dt.getTime() > self.last_typing_date.getTime() + 10000) {
				self.last_typing_date = dt;
				self.last_typing_task = id_task;
				let data = {
					action: 'typing',
					id_task: id_task,
				};
				let o = $('.sidePanel__list__item-chat[data-chat=' + id_task + ']');
				if (o.length) {
					data.ids_user = o.attr('data-users');
				}
				App.core.websocket.postMessage(data)
			}
		},

		onLogin: function () {
			App.bus.msg.on('typing', function (data, ctx) {
				self.add(data.id_task, data.id_user);
				if (ctx.scope === App.bus.SCOPE_WEBSOCKET) App.core.send_message_to_other_tabs({command: 'typing', data: data});
			});
		}
	};
})();

;const SLOT_COUNT = 288;

(function() {
	let self = App.controls.user_activity_log = {
		sessions: {},
		id_day: null,
		state: {
			activity: null,
			pages: null,
		},

		get_index: function(){
			let dt = new Date();
			let id_day = App.helper.date.to_input(dt);
			if (id_day !== self.id_day) {
				self.id_day = id_day;
				self.state = { // start new session
					activity: {
						open: new Array(SLOT_COUNT).fill(0),           // просто відкрито
						visible: new Array(SLOT_COUNT).fill(0),        // вкладка активна
						light: new Array(SLOT_COUNT).fill(0),          // скрол або миша
						active: new Array(SLOT_COUNT).fill(0),         // кліки або клавіатура
					},
					pages: {}
				}
			}

			return Math.floor((dt.getHours() * 60 + dt.getMinutes()) / 5);
		},

		save: function() {
			if (!App.me.id) return;
			self.storage.load();

			if (self.sessions[self.id_day] && self.sessions[self.id_day].activity) {
				const keys = ['open', 'visible', 'light', 'active'];
				keys.forEach(key => {
					for (let i = 0; i < SLOT_COUNT; i++) {
						self.state.activity[key][i] = (self.sessions[self.id_day].activity[key][i] || self.state.activity[key][i]) ? 1 : 0;
					}
				});
				for (let page in self.sessions[self.id_day].pages) {
					if (page in self.state.pages) {
						for (let i = 0; i < SLOT_COUNT; i++) {
							self.state.pages[page][i] = (self.sessions[self.id_day].pages[page][i] || self.state.pages[page][i]) ? 1 : 0;
						}
					} else {
						self.state.pages[page] = self.sessions[self.id_day].pages[page];
					}
				}
			}
			let need_save = false;
			let dt_stamp = App.helper.date.to_timestamp(new Date());
			self.sessions[self.id_day] = self.state;
			if (!self.sessions.dt_save) {
				self.sessions.dt_save =  dt_stamp;
			} else if (dt_stamp - self.sessions.dt_save > 3600) {
				self.sessions.dt_save =  dt_stamp;
				need_save = true;
			}
			self.storage.save();

			for (let id_day in self.sessions) if (id_day == 'dt_save') {} else if (id_day !== self.id_day) {
				self.db.save_day(id_day, true);
			} else if (need_save) {
				self.db.save_day(id_day);
			}
		},

		log_activity: function(type) {
			if (!App.me.id) return;
			const index = self.get_index();
			if (!self.state.activity[type][index]) {
				self.state.activity[type][index] = 1;
				self.save();
			}
		},

		log_state: function() {
			if (!App.me.id) return;
			const index = self.get_index();
			let need_save = false;
			if (!self.state.activity.open[index]) {
				self.state.activity.open[index] = 1;
				need_save = true;
			}
			if (document.visibilityState === 'visible') {
				if (!self.state.activity.visible[index]) {
					self.state.activity.visible[index] = 1;
					need_save = true;
				}
				let page = self.get_active_page();
				if (page) {
					self.state.pages[page] ||= new Array(SLOT_COUNT).fill(0);
					if (!self.state.pages[page][index]) {
						self.state.pages[page][index] = 1;
						need_save = true;
					}
				}
			}
			if (need_save) self.save();
		},

		get_active_page: function() {
			let page = '';
			let body = $('body');
			if (App.task_view.is_shown()) {
				page = 'task';
			} else {
				page = body.attr('data-page');
			}
			return page;
		},


		storage: {
			get_id: function() {
				return 'user_activity:' + App.me.id;
			},
			load: function () {
				let json = localStorage.getItem(self.storage.get_id());
				self.sessions = json ? JSON.parse(json) : {}
			},
			save: function () {
				localStorage.setItem(self.storage.get_id(), JSON.stringify(self.sessions));
			}
		},

		db: {
			save_day: function(id_day, del) {
				$.ajax({
					url: '/ajax/?' + App.actions.get('user_activity:do'),
					type: 'POST',
					data: {id_day, data: JSON.stringify(self.sessions[id_day])},
					success: function () {
						if (del) delete(self.sessions[id_day]);
						self.storage.save();
					}
				});
			}
		},

		onBoot: function() {
			$(window).bind('mousemove scroll mousewheel DOMMouseScroll', () => self.log_activity('light'));
			$(window).bind('keyup click', () => self.log_activity('active'));

			App.bus.app.on('task_view_ready', self.log_state);
			App.bus.window.on('active inactive beforeunload', self.log_state);
		},

		onLogin: function () {
			App.helper.cron.add('user_activity_log', self.log_state, 15);
		},
		onLogout: function () {
			App.helper.cron.remove('user_activity_log');
		},

		onLoadPage: function() {
			self.log_state();
		}
	}
})();



;(function() {
	let self = App.controls.view_list = {
		obj_window: null,
		obj_items: null,

		edit: {
			view_id: null,
			obj: null,
			content: null,
			pending_name: null,
			start: function(view_id) {
				if (self.edit.obj) self.edit.end();

				const item = self.get_item(view_id);
				if (!item.length) return;

				if (!item.is(':visible') || App.device.is_mobile()) {
					self.edit.menu.show(view_id);
					return;
				}

				App.menu.hide();
				self.edit.view_id = view_id;
				self.edit.obj = item;
				self.edit.content = self.edit.obj.children().detach();
				const old_value = self.edit.content.filter('.in').text();
				const input = $('<input type="text" maxlength="50" />');

				input
					.val(old_value)
					.appendTo(self.edit.obj)
					.focus().select()
					.on('keydown', function(e) {
						let key = e.keyCode || e.charCode;
						e.stopPropagation();
						if (key === App.keycode.Enter) {
							if (this.value.trim() && this.value.trim() != old_value) {
								self.edit.save(this.value.trim());
								input.off('blur');
							} else self.edit.end();
							return false;
						} else if (key === App.keycode.Escape) {
							self.edit.end();
							return false;
						}
					})
					.on('blur', function () {
						if (this.value.trim() && this.value.trim() != old_value) {
							self.edit.save(this.value.trim());
							input.off('blur');
						} else self.edit.end();
					})
					.on('click', e => e.stopPropagation());
			},
			save: function(value) {
				const anchor = self.edit.obj.get(0);
				const endpoint = App.helper.url.add_query(self.edit.obj.attr('data-href'), App.actions.get('view_edit:save_name')) + '&name=' + encodeURIComponent(value);
				const save = () => {
					self.edit.end(value);
					$.getScript(endpoint);
				}

				if (!self.edit.pending_name) {
					save();
					return;
				}

				if (self.edit.pending_name != value) {
					let status = false;
					App.controls.confirm.menu(anchor, {
						menu_type: 'parent center',
						onconfirm: () => {
							status = true;
							save();
						},
						onhide: () => {
							setTimeout(() => {
								if (status) return;
								self.edit.end();
							}, 50);
						},
						message: App.object_state.locale.edit_conflict_confirm,
					});
					return;
				}
			},
			end: function(name) {
				if (self.edit.obj) self.edit.obj.html('').append(self.edit.content);

				const view_id = self.edit.view_id;
				const pending_name = self.edit.pending_name;

				if (!view_id) throw new Error('Probably called twice');

				self.edit.view_id = null;
				self.edit.obj = null;
				self.edit.content = null;
				self.edit.pending_name = null;

				if (name || pending_name) self.item.set_name(view_id, name || pending_name);
			},

			menu: {
				show: function(view_id) {

					const anchor = App.menu.is_shown() ? self.get_menu_item_menu(view_id) : self.get_item(view_id);
					if (!anchor.length) return;

					const menu_item = self.get_menu_item(view_id);
					if (!menu_item.length) return;

					self.edit.view_id = view_id;

					const old_name = menu_item.text().trim();

					App.menu.show({
						anchor,
						box: '#viewEditNameMenu',
						type: 'submenu',
						replace: true,
						onshow: function () {
							const menu = $(this);
							menu.off('before_hide.edit').on('before_hide.edit', () => {
								menu.off('before_hide.edit');
								self.edit.end();
							});
							menu.find('input[name=view_name]').val(old_name).select();
							menu.find('ws-btn').off('click').on('click', function () {
								menu.off('before_hide.edit');
								const new_name = menu.find('input[name=view_name]').val().trim();
								if (new_name && new_name != old_name) {
									self.edit.menu.save(anchor, new_name);
								} else {
									App.menu.hide();
								}
							});
						}
					});
				},

				save: function(anchor, value) {
					const endpoint = App.helper.url.add_query(anchor.attr('data-href'), App.actions.get('view_edit:save_name')) + '&name=' + encodeURIComponent(value);
					const save = () => {
						App.menu.hide();
						self.edit.end(value);
						$.getScript(endpoint);
					}

					if (!self.edit.pending_name) {
						save();
						return;
					}

					if (self.edit.pending_name != value) {
						let status = false;
						App.controls.confirm.menu(anchor, {
							replace: true,
							onshow: function () {
								const menu = $(this);
								menu.off('before_hide.edit').on('before_hide.edit', () => {
									setTimeout(() => {
										menu.off('before_hide.edit');
										if (status) return;
										self.edit.end();
									}, 50);
								});
							},
							onconfirm: () => {
								status = true;
								save();
							},
							message: App.object_state.locale.edit_conflict_confirm,
						});
						return;
					}
				}
			},

			destructor: function () {
				this.view_id = null;
				this.obj = null;
				this.content = null;
				this.pending_name = null;
			}
		},

		show_menu: function(el, params) {
			params ||= {};
			let o = $(el);
			App.menu.show({
				anchor: params.menu_anchor || o,
				url: App.helper.url.add_query(o.attr('data-href'), App.actions.get(o.attr('data-tmp-id') ? 'view_tmp_edit:show' : 'view_edit:show'), {id: o.attr('data-tmp-id') ? o.attr('data-tmp-id') : o.attr('data-id')}),
				cache_trigger: 'view:add,view:' + o.attr('data-id'),
				type: params.type || '',
				backup: params.backup || false,
				// replace: params.replace || false,
				onshow: function () {
					const menu = $(this);

					const items = self.obj_window.find('.viewsList__item[data-id]');
					const item = items.filter('[data-id=' + o.attr('data-id') + ']');

					if (items.length < 2) {
						menu.find('.menu__group-move').addClass('menu__group-hidden');
						return;
					}

					menu.find('.menu__group-move').removeClass('menu__group-hidden');

					const is_first = item.get(0) === items.first().get(0);
					const is_last = item.get(0) === items.last().get(0);

					menu.find('.menu__item[data-route]').each(function () {
						const route = $(this).attr('data-route');
						if (route === 'prev' || route === 'start') $(this).toggleClass('menu__item-notPossible', is_first);
						else if (route === 'next' || route === 'end') $(this).toggleClass('menu__item-notPossible', is_last);
					});
				},
				onload: function () {
					const menu = $(this);

					menu.find('.menu__item[data-route]').on('click', function() {

						self.commands.move(o.attr('data-id'), $(this).attr('data-route'));
						App.menu.hide();
					});
				}
			});
		},

		delete: function(view_id) {
			let o = self.get_item(view_id);
			App.menu.hide();
			$.getScript(App.helper.url.add_query(o.attr('data-href'), App.actions.get('view_edit:delete')));
		},

		duplicate: function(view_id) {
			let o = self.obj_window.find('.viewsList__item[data-id="' + view_id +'"]');
			App.menu.hide();
			$.getScript(App.helper.url.add_query(o.attr('data-href'), App.actions.get('view_edit:duplicate')));
		},

		share: function(el, view_id) {
			let o = self.get_item(view_id);
			$.ajax({
				url: App.helper.url.add_query(o.attr('data-href'), App.actions.get('view_edit:share')),
				success: function(url) {
					App.core.share(url, document.title, () => App.core.clipboard_from_menu(el, url));
				}
			});
		},

		expose: function(el, view_id) {
			let o = self.get_item(view_id);
			let ids = []; // $(el).attr('data-ids').split(',').map(Number);
			App.controls.user_select_and_go.show_context(el, App.helper.url.add_query(
				App.current_page.project ? App.helper.endpoint.project(App.current_page.project) : App.helper.endpoint.primary(), App.actions.get('user_select_and_go:show')), {
				backup: true,
				request: {
					multiple: true,
					type: 'view_share',
				},
				onshow: function() {
					let menu = $(this);
					menu.data('anchor_el', el);
					menu.find('.menu__item[data-id]').each(function() {
						$(this).toggleClass('menu__item-active', ids.includes($(this).attr('data-id').toInt()));
					});
				},
				onload() {
					let menu = $(this);
					App.controls.menu.init(menu);
					$(this).on('click', '.menu__group-head ws-btn', function () {
						let ids = [];
						menu.find('.menu__item-active').each(function() {
							ids.push($(this).attr('data-id'));
						});
						$(menu.data('anchor_el')).attr('data-ids', ids.join(','));
						$.ajax({
							url: App.helper.url.add_query(o.attr('data-href'), App.actions.get('view_edit:expose'), {ids: ids.join(',')}),
							success: function(url) {
								App.menu.hide_all();
							}
						});
					})
				}
			});
		},

		save: function(view_id, is_new) {
			let o = self.get_item(view_id);
			App.menu.hide();
			$.getScript(App.helper.url.add_query(o.attr('data-href'), App.actions.get('view_edit:save') + (is_new ? '&is_new=1' : '')));
		},

		reset: function(view_id) {
			let o = view_id ? self.obj_window.find('.viewsList__item[data-id="' + view_id +'"]') : self.obj_window.find('.viewsList__item-active');
			App.menu.hide();
			$.getScript(App.helper.url.add_query(o.attr('data-href'), App.actions.get('view_edit:reset')));
		},

		// default: function(view_id) {
		// 	let o = view_id ? self.obj_window.find('.viewsList__item[data-id="' + view_id +'"]') : self.obj_window.find('.viewsList__item-active');
		// 	App.menu.hide();
		// 	$.getScript(App.helper.url.add_query(o.attr('data-href'), App.actions.get('view_edit:default')), function() {
		// 		o.removeClass('viewsList__item-updated');
		// 	});
		// },

		change_type: function(view_id, page) {
			let o = view_id ? self.obj_window.find('.viewsList__item[data-id="' + view_id +'"]') : self.obj_window.find('.viewsList__item-active');
			App.menu.hide();
			$.getScript(App.helper.url.add_query(o.attr('data-href'), App.actions.get('view_edit:change_type')) + '&page=' + page);
		},

		// mark_as_updated(id, tmp, state = true) {
		// 	let o = self.obj_window.find('.viewsList__item').filter(tmp ? '[data-tmp-id='+id+']' : '[data-id='+id+']');
		// 	o.toggleClass('viewsList__item-updated', state);
		// },

		onresize: function() {
			if (!self.obj_window?.length) return;

			const format_more = (cnt) => {
				return App.object_state.locale.more.replace('%s', '<font>'+cnt+'</font>')+'…';
			};

			const resize = function() {
				let w_items = 0, w_add = 0, w_more = 0, w_act = 0, count_items_hidden = 0, w = self.obj_window.width();
				self.obj_window.find('.viewsList__item').each(function() {
					if ($(this).hasClass('viewsList__item-more')) {
						w_more = $(this).outerWidth(true);
					} else if ($(this).hasClass('viewsList__item-active')) {
						w_act = $(this).outerWidth(true);
					} else if ($(this).hasClass('viewsList__item-plus')) {
						w_add = $(this).outerWidth(true);
					} else {
						w_items += $(this).outerWidth(true);
					}
				});
				if (w_items + w_add + w_act <= w) {
					self.obj_window.find('.viewsList__item').show().filter('.viewsList__item-more').hide();
					if ($('#viewsMoreMenu.menu-active').length) {
						App.menu.hide_all();
					}
				} else {
					w_items = 0;
					count_items_hidden = 0;
					let last_visible_item;
					$('#viewsMoreMenu .menu__group-searchable .menu__item').addClass('menu__item-notPossible');
					self.obj_window.find('.viewsList__item').each(function() {
						if ($(this).hasClass('viewsList__item-more') || $(this).hasClass('viewsList__item-plus') || $(this).hasClass('viewsList__item-active')) {
							$(this).show();
						} else {
							w_items += $(this).outerWidth(true);
							let is_shown = w_items + w_more + w_add + w_act <= w;
							$(this).toggle(is_shown);
							if (!is_shown) {
								$('#viewsMoreMenu .menu__item' + ($(this).attr('data-id') ? '[data-id=' + $(this).attr('data-id') + ']' : '[data-tmp-id=' + $(this).attr('data-tmp-id') + ']')).removeClass('menu__item-notPossible');
								count_items_hidden++;
							} else {
								last_visible_item = $(this);
							}
						}
					});
					self.obj_window.find('.viewsList__item-more .in').html(format_more(count_items_hidden));

					// треба знову порахувати, бо могла змінитися ширина у More таба
					if (last_visible_item) {
						const w_more_new = self.obj_window.find('.viewsList__item-more').outerWidth(true);
						if (w_more_new > w_more) {
							const is_shown = w_items + w_more_new + w_add + w_act <= w;
							last_visible_item.toggle(is_shown);
							if (!is_shown) {
								$('#viewsMoreMenu .menu__item' + (last_visible_item.attr('data-id') ? '[data-id=' + last_visible_item.attr('data-id') + ']' : '[data-tmp-id=' + last_visible_item.attr('data-tmp-id') + ']')).removeClass('menu__item-notPossible');
								count_items_hidden++;
								self.obj_window.find('.viewsList__item-more .in').html(format_more(count_items_hidden));
							}
						}
					}
				}

				self.obj_window.removeClass('viewsList-recalc');
			};

			resize();

			// через це буває видно "скакання" табів, не дуже зрозумів, нащо це додавалося
			// провсяк випадок в sidebar.js додав виконання через nextTick, бо це було в одному комміті b9623876
			// setTimeout(resize, 0);
		},

		update_visibility: function() {

			const obj_window = App.core.obj_window.find('#viewsList');
			if (!obj_window.length) return;

			self.obj_window = obj_window;
			self.onresize();
		},

		configure: {
			show: function(menu_anchor, params) {
				params ||= {};
				App.menu.show({
					anchor: menu_anchor,
					url: App.helper.url.add_query(App.page.url.base, App.actions.get('view_list:add')),
					cache_trigger: 'page,view:delete,view:add',
					type: params.type || '',
					backup: params.backup || false,
					onload: function() {
						let menu = $(this);
						menu.on('click', '.menu__item[data-id]', function () {
							App.controls.views.add($(this).attr('data-id'));
							App.menu.hide_all();
						});
					}
				})
			}
		},

		more: {
			show: function(menu_anchor, params) {
				App.menu.show({
					anchor: menu_anchor,
					box: '#viewsMoreMenu',
					onload: function () {
						const menu = $(this);
						menu.on('click', '.menu__item-menu', function (e) {
							e.preventDefault();
							self.show_menu(this, {
								type: 'submenu',
								backup: true,
								// replace: true,
							});
						});
					}
				});
			}
		},

		// не пригодиловся, легше перезавантажити всі таби, бо інкрементуємо manual_order
		// update_order: function () {
		// 	const items = self.obj_window.find('.viewsList__item');
		// 	const system_items = items.filter('.viewsList__item-more, .viewsList__item-plus, .viewsList__item-tmp');
		// 	const normal_items = items.not('.viewsList__item-more, .viewsList__item-plus, .viewsList__item-tmp');

		// 	const sort_func = (a, b) => {
		// 		a = $(a);
		// 		b = $(b);

		// 		const order_a = Number(a.attr('data-order')) || 0;
		// 		const order_b = Number(b.attr('data-order')) || 0;
		// 		if (order_a !== order_b) return order_a - order_b;

		// 		const id_a = Number(a.attr('data-id'));
		// 		const id_b = Number(b.attr('data-id'));
		// 		return id_a - id_b;
		// 	};

		// 	const sorted_normal_items = normal_items.sort(sort_func);
		// 	self.obj_window.html(sorted_normal_items).append(system_items);

		// 	const menu_items = $('#viewsMoreMenu .menu__group-searchable .menu__items-row');
		// 	const sorted_menu_items = menu_items.sort(sort_func);
		// 	$('#viewsMoreMenu .menu__group-searchable').html(sorted_menu_items);

		// 	self.onresize();
		// },

		reload: function() {
			let item = self.get_active_item();
			// нам потрібен повний url, щоб правильно підсвітити активний елемент
			const url = item.length ? (item.attr('data-full-href') || App.page.url.base) : App.page.url.base;
			$('#viewsList__wrapper').load(App.helper.url.add_query(url, App.actions.get('view_list:show'))+' #viewsList__wrapper > *', () => {
				self.onload();

				// обробимо кейс, коли урл перестав бути дефолтним і його треба помістити правильно
				if (!item.length) return;
				item = self.get_item(item.attr('data-id'));
				if (!item.length) return;
				if (item.attr('data-href') && App.page.url.base != item.attr('data-href')) {

					const new_href = item.attr('data-href');
					const replace_path = function(base_url, old_path, new_path) {
						const url = new URL(base_url, location.origin);
						if (url.pathname == old_path) {
							url.pathname = new_path;
						}
						return url.toString().replace(location.origin, '');
					}

					// console.log('Before: ', { ... App.page.url });

					// TODO може підміну page.url треба помістити в метод history.replace?
					if (App.page.url.filter) App.page.url.filter = replace_path(App.page.url.filter, App.page.url.base, new_href);
					if (App.page.url.filter_advanced) App.page.url.filter_advanced = replace_path(App.page.url.filter_advanced, App.page.url.base, new_href);
					App.page.url.base = new_href;

					// console.log('After: ', { ... App.page.url });

					if (App.page.url.base == App.page.url.base.filter) App.page.url.filter = item.attr('data-href');
					if (App.page.url.base == App.page.url.base.filter_advanced) App.page.url.filter_advanced = item.attr('data-href');
					App.page.url.base = item.attr('data-href');
					App.core.history.replace(item.attr('data-href'), document.title, false);
				}
			});
		},

		onload: function () {
			self.obj_window = $('#viewsList');
			$('#menuContainer').find('#viewsMoreMenu, #viewsTmpMenu, #viewEditNameMenu').remove();

			App.ui.onMouse(self.obj_window, '.viewsList__item[data-id], .viewsList__item[data-tmp-id]', {
				onBefore(e) {
					e.cancel = e.target.closest('a, input') != null;
					e.data.is_active = $(e.el).hasClass('viewsList__item-active');
					e.data.href = $(e.el).attr('data-href');
					e.data.id = $(e.el).attr('data-id');

					e.skip_dblclick = !e.data.is_active || $(e.el).hasClass('viewsList__item-protected') || $(e.el).is('[data-tmp-id]');
				},
				click: (e) => e.data.is_active ? App.controls.view_list.show_menu(e.el) : App.core.goto(e.data.href),
				context: (e) => App.controls.view_list.show_menu(e.el),
				dblclick: (e) => App.controls.view_list.edit.start(e.data.id)
			});


			self.onresize();
		},

		onInitPage: function() {
			App.bus.state.on('view', function (payload, ctx) {
				const id_view = payload.id, fields = payload.data;

				if (ctx.active_tab && fields.add) {
					App.core.context.add('view_list.onload_page', id_view);
					App.core.goto(fields.add.url);
				}
			});
		},

		onLoadPage: function() {
			self.onload();
			App.bus.window.on('resize', App.helper.throttle(self.onresize));

			let id_edit_start = App.core.context.use('view_list.onload_page');
			if (id_edit_start) {
				App.helper.nextTick(() => self.edit.start(id_edit_start));
			}
		},

		is_shown: function (id_project, page_group) {
			if (id_project > 0) {
				if (id_project == self.obj_window.attr('data-id-project')) return true;
			}
			else if (page_group && page_group == self.obj_window.attr('data-page-group')) return true;
			return false;
		},

		get_active_item: function () {
			return self.obj_window?.find('.viewsList__item-active[data-id]') ?? $();
		},

		get_item: function (id) {
			return self.obj_window?.find('.viewsList__item[data-id="'+id+'"]') ?? $();
		},

		get_tmp_item: function (id) {
			return self.obj_window?.find('.viewsList__item[data-tmp-id="'+id+'"]') ?? $();
		},

		get_menu_item: function (id) {
			return $('#viewsMoreMenu').find('.menu__item-view[data-id="'+id+'"]');
		},

		get_menu_item_menu: function (id) {
			return $('#viewsMoreMenu').find('.menu__item-menu[data-id="'+id+'"]');
		},

		get_menu_items_row: function (id) {
			return $('#viewsMoreMenu').find('.menu__items-row[data-id="'+id+'"]');
		},

		item: {
			set_name: function (id, name) {
				const item = self.get_item(id);
				if (!item.length) return;

				const menu_item = self.get_menu_item(id);
				if (!menu_item.length) return;

				const old_name = item.find('.in').text();
				if (old_name != name) {

					item.find('.in').text(name);
					menu_item.find('.in').text(name);
					self.onresize();

					item.animate_css('blink');
					menu_item.animate_css('blink');
				}
			},
		},

		commands: {
			move: function(view_id, route) {
				let o = self.get_item(view_id);
				if (!o.length) return;

				App.menu.hide();
				$.getScript(App.helper.url.add_query(o.attr('data-href'), App.actions.get('view_edit:drag'), {mo: route}));
			},
		},

		tmp: {
			commands: {
				delete: function() {
					let o = self.obj_window.find('.viewsList__item-tmp.viewsList__item-active');
					if (!o.length) return;

					App.menu.hide();
					$.getScript(App.helper.url.add_query(o.attr('data-href'), App.actions.get('view_tmp_edit:delete')));
				},

				save: function() {
					let o = self.obj_window.find('.viewsList__item-tmp.viewsList__item-active');
					if (!o.length) return;

					App.menu.hide();
					$.getScript(App.helper.url.add_query(o.attr('data-href'), App.actions.get('view_tmp_edit:save')), function() {
						App.menu.invalidate_cache_by_trigger('view' + $('.viewsList__item-active').attr('data-id'));
						$('.viewsList__item-active').removeClass('viewsList__item-updated');
					});
				},

				share: function(el) {
					let o = self.obj_window.find('.viewsList__item-tmp.viewsList__item-active');
					if (!o.length) return;

					$.ajax({
						url: App.helper.url.add_query(o.attr('data-href'), App.actions.get('view_tmp_edit:share')),
						success: function(url) {
							App.core.share(url, document.title, () => App.core.clipboard_from_menu(el, url));
						}
					});
				}
			}
		},

		destructor: function () {
			self.edit.destructor();
			self.obj_window = null;
			self.obj_items = null;
		},

		onLogout: () => self.destructor(),
	}
})();

;// do not use self in cloned objects
App.controls.views = {
	active_obj: null,
	override: {},
	type: 'page',

	loader: {
		start: function () {
			// implement in child class
		},
		stop: function () {
			// implement in child class
		},
	},

	endpoint: function() {
		App.controls.views.active_obj = this;
		return this.override.endpoint || App.page.url.base;
	},

	reload: function() {
		if (this.override.right_panel) App.right_panel.reload();
		else if (this.override.left_panel) App.mymenu.reload();
		else App.core.reload();
	},

	add: function(page) {
		$.getScript(App.helper.url.add_query(App.page.url.base, App.actions.get('view_list:apply') + '&operation=add&page=' + page))
	},

	delete: function(page) {
		debugger; // не знайшов чи це десь використовується?
		$.getScript(App.helper.url.add_query(App.page.url.base, App.actions.get('view_list:apply') + '&operation=delete&page=' + page))
	},

	set_option: function (options, filter, silent) {
		let url = this.endpoint();
		if (!silent) url = App.helper.url.add_query(url, 'reload=1');
		if (!silent) this.loader.start();
		url = App.helper.url.add_query(url, App.actions.get('view_set_option:do'));
		$.ajax({
			url: url,
			type: 'POST',
			dataType: 'script',
			data: 'data=' +  encodeURIComponent(JSON.stringify({
				options: options || [],
				filter: filter || [],
			}))
		});
	},

	save_order: function (order, desc, silent) {
		let url = this.endpoint();
		url = App.helper.url.add_query(url, 'order=' + order);
		url = App.helper.url.add_query(url, 'desc=' + (desc || 0));
		if (!silent) url = App.helper.url.add_query(url, 'reload=1');
		if (!silent) this.loader.start();
		url = App.helper.url.add_query(url, App.actions.get('view_save_order:do'));
		$.getScript(url);
	},

	set_option_silent: function (options, filter) {
		this.set_option(options, filter, true);
	},

	save_order_silent: function (order, desc) {
		this.save_order(order, desc, true);
	},

	save_filter: function (data, silent) {
		let url = this.endpoint();
		if (!silent) url = App.helper.url.add_query(url, 'reload=1');
		if (!silent) this.loader.start();
		url = App.helper.url.add_query(url, App.actions.get('view_save_filter:do'));
		$.ajax({
			url: url,
			type: 'POST',
			dataType: 'script',
			data: data
		});
	},

	save_filter_advanced: function (data, silent) {
		let url = this.endpoint();
		if (!silent || !('process_filter_and_search' in App.page)) url = App.helper.url.add_query(url, 'reload=1');
		if (!silent) this.loader.start();
		url = App.helper.url.add_query(url, App.actions.get('view_save_filter_advanced:do'));
		$.ajax({
			url: url,
			type: 'POST',
			dataType: 'script',
			data: data
		});
	},

	clear_filter: function(silent) {
		this.save_filter('clear=both', silent);
	},

	clear_filter_advanced: function(silent) {
		this.save_filter_advanced('', silent);
	},

	/**
	 * Transfers view parameters (options, filter, and page) to another view for cross-linkage.
	 *
	 * @param {Object} options - The options of the current view to transfer.
	 * @param {Array} filter - The filter criteria of the current view to transfer.
	 * @param {number} page - The page number of the current view to transfer.
	 */
	dig_in: function(options, filter, page) {
		options = options ? App.helper.object.filter_nulls(options) : [];
		filter = filter ? App.helper.object.filter_nulls(filter) : [];
		page = page || 0;
		let url = this.endpoint();
		url = App.helper.url.add_query(url, App.actions.get('view_dig_in:do') );
		$.ajax({
			url: url,
			type: 'POST',
			dataType: 'script',
			data: 'data=' +  encodeURIComponent(JSON.stringify({
				options,
				filter,
				page,
				operation: 'dig_in',
			}))
		});
	},

	switch_project_data: {},

	switch_project: function(anchor, id_project, options, filter) {
		App.controls.views.switch_project_data = {anchor, options, filter};
		if (id_project === null || id_project === undefined) {
			App.controls.project_select_and_go.show_context(anchor, null, {
				backup: true,
				type: 'submenu',
				onload: function () {
					let menu = $(this);
					App.controls.menu.init(menu);
					menu.on('click', '.menu__item', function() {
						App.menu.hide();
						let {anchor, options, filter} = App.controls.views.switch_project_data;
						App.controls.views.switch_project(anchor, $(this).attr('data-id'), options, filter)
					});
				},
			});
			return false;
		}

		let url = this.endpoint();
		url = App.helper.url.add_query(url, App.actions.get('view_dig_in:do') );
		$.ajax({
			url: url,
			type: 'POST',
			dataType: 'script',
			data: 'data=' +  encodeURIComponent(JSON.stringify({
				options,
				filter,
				id_project,
				operation: 'switch_project',
			}))
		});
	}
}

App.controls.views_right_panel = App.helper.object.clone(App.controls.views, {
	type: 'r-panel',
	override_endpoint: '',
	init: function(endpoint) {
		this.override_endpoint = endpoint;
	},
	endpoint: function() {
		App.controls.views.active_obj = this;
		return this.override_endpoint;
	},

	reload: function() {
		App.right_panel.reload();
	},

}); // same structure

App.controls.views_left_panel = App.helper.object.clone(App.controls.views, {
	type: 'l-panel',
	override_endpoint: '',

	loader: {
		start: function () {
			App.mymenu.loader.start();
		},
		stop: function () {
			App.mymenu.loader.stop();
		},
	},

	init: function(endpoint) {
		this.override_endpoint = endpoint;
	},
	endpoint: function() {
		App.controls.views.active_obj = this;
		return this.override_endpoint;
	},

	reload: function() {
		App.mymenu.reload();
	},

}); // same structure
;(function() {
	let self = App.controls.visibility_switch_and_go = {
		callback: null,
		show_context: function(menu_anchor, endpoint, params, callback) {
			params ||= {};
			params['request'] ||= {};
			params['request']['template'] = 'menu';
			self.callback = callback;
			App.menu.show({
				anchor: menu_anchor,
				url: App.helper.url.add_query(endpoint, $.param(params['request'])),
				onload: function() {
					self.init.call(this);
					params.onload?.call(this);
				},
				onshow: function() {
					let menu = $(this);
					params.onshow?.call(this);
					menu.find('.menu__item-group, .menu__item-subset').trigger('draw_sw_status');
					menu.trigger('after_interaction');
				},
				type: params.type || '',
				backup: params.backup || false,
				replace: params.replace || false,
				title: App.object_state.locale['user'],
				cache_trigger: 'user',
				width: params.width || 324,
				class: 'menu-type-visibility',
				onhide: params.onhide,
			});
		},

		init: function() {
			let menu = $(this);

			menu.on('draw_sw_status', '.menu__group', function() {
				$(this).find('.menu__item-group').toggleClass('menu__item-active sw_act', !$(this).find('.menu__item[data-id]').not('.menu__item-active').length);
				$(this).find('.menu__item-group').toggleClass('sw_partial', !$(this).find('.menu__item[data-id]').not('.menu__item-guest').not('.menu__item-active').length);
			});
			menu.on('draw_sw_status', '.menu__group__subset', function() {
				$(this).find('.menu__item-subset').toggleClass('menu__item-active sw_act', !$(this).find('.menu__item[data-id]').not('.menu__item-active').length);
				$(this).find('.menu__item-subset').toggleClass('sw_partial', !$(this).find('.menu__item[data-id]').not('.menu__item-guest').not('.menu__item-active').length);
			});

			menu.on('click', '.menu__item-group', function() {
				let group = $(this).closest('.menu__group');
				if ($(this).hasClass('sw_act')) {
					group.find('.menu__item').not('.menu__item-default').removeClass('menu__item-active');
				} else if ($(this).hasClass('sw_partial')) {
					group.find('.menu__item').addClass('menu__item-active');
				} else{
					group.find('.menu__item').not('.menu__item-guest').addClass('menu__item-active');
				}
				group.find('.menu__group__subset').addBack().trigger('draw_sw_status');
				menu.trigger('after_interaction');
			});
			menu.on('click', '.menu__item-subset', function() {
				let subset = $(this).closest('.menu__group__subset');
				if ($(this).hasClass('sw_act')) {
					subset.find('.menu__item').not('.menu__item-default').removeClass('menu__item-active');
				} else if ($(this).hasClass('sw_partial')) {
					subset.find('.menu__item').addClass('menu__item-active');
				} else{
					subset.find('.menu__item').not('.menu__item-guest').addClass('menu__item-active');
				}
				subset.closest('.menu__group').addBack().trigger('draw_sw_status');
				menu.trigger('after_interaction');
			});

			menu.on('click', '.menu__item[data-id]:not(.menu__item-default)', function() {
				$(this).toggleClass('menu__item-active');
				$(this).closest('.menu__group, .menu__group__subset').trigger('draw_sw_status');
				menu.trigger('after_interaction');
			});

			// if it is "preset" menu, we don't need a counter and btn disabling
			if (menu.find('.menu__item[data-id]').length) {
				menu.bind('after_interaction', function() {
					let overhead = menu.find('.menu__group-head');
					let defaultText = overhead.attr('data-default-text');
					let changeText = overhead.attr('data-change-text');
					let cnt = menu.find('.menu__item-active[data-id]').length;
					if (cnt) {
						if (defaultText && changeText) {
							let tmpTxt = App.format.quantity(cnt, changeText);
							menu.find('.checkboxCount').html('<b>' + cnt + '</b> ' + tmpTxt.charAt(0).toUpperCase() + tmpTxt.slice(1));
						} else menu.find('.checkboxCount .cnt').html(cnt);
						overhead.addClass('active');
						overhead.find('ws-btn').toggleDisabled(false);
					} else {
						if (defaultText && changeText) menu.find('.checkboxCount').html(defaultText);
						else menu.find('.checkboxCount .cnt').html();
						overhead.removeClass('active');
						overhead.find('ws-btn').toggleDisabled(true);
					}
				}).trigger('after_interaction');
			}
		},
	}
})();
;(function() {
	let self = App.controls.wait_post = {

		el: function () {
			return $('#wait_post');
		},

		init: function () {
			if (!self.el().attr('data-wait-start')) self.el().attr('data-wait-start', App.helper.time.now());

			App.helper.cron.add_if_not_exists('wait_post_prolong', self.prolong, 59, true);
		},

		calc_time_left: function () {
			let el = self.el();
			if (el.length === 0) return null;

			let wait = parseInt(el.attr('data-wait') || '0'),
				start = parseInt(el.attr('data-wait-start') || '0');

			return wait - App.helper.time.now() + start;
		},

		prolong: function () {
			let diff = self.calc_time_left(),
				url = self.el().attr('data-prolong-url');
			if (diff == null || url == null) return App.helper.cron.remove('wait_post_prolong')

			console.log('prolong', diff, 'sec')

			if (diff > 300) return;

			App.core.async_task.ajax(App.helper.url.add_query(url, 'type=edit'));
		},

		reset: function (wait) {
			self.el().attr('data-wait', wait).attr('data-wait-start', App.helper.time.now());
		},

		remove: function () {
			self.el().remove();
		},

		onLogout: function () {
			App.helper.cron.remove('wait_post_prolong');
		}
	}
})();

;(function() {
	let self = App.controls.wizard = {
		mass: {
			next_page: function (operation, options = {}) {

				if ( ! App.modal.is_shown() ) return;

				let query = options.wizard ? $.param({wizard: options.wizard}) : App.modal.obj_window.find('input[name^="wizard"]').serialize();
				if (!query) return;

				const query_params = new URLSearchParams(query);
				const page = parseInt(query_params.get('wizard[page]'));
				const pages = parseInt(query_params.get('wizard[pages]'));
				if (page == pages) {
					App.modal.hide();
					return;
				}

				query_params.set('wizard[page]', page + 1);
				query = query_params.toString();

				if (operation === 'close') {
					App.modal.show({
						url: App.helper.url.add_query(App.mass.action_url('done'), 'ids=' + App.mass.ids['close'] + '&' + query.toString()),
						width: 500,
						group: 'close'
					});
				} else if (operation === 'reopen') {
					App.modal.show({
						url: App.helper.url.add_query(App.mass.action_url('reopen'), 'ids=' + App.mass.ids['reopen'] + '&' + query.toString()),
						width: 500,
						group: 'reopen'
					});
				}
			}
		},
	}
})();

;(function() {
	let self = App.controls.chat_action = {
		archive: function (anchor, endpoint) {
			App.controls.confirm.menu(anchor, {
				message: App.object_state.locale.chat_controls.confirm_archive,
				onconfirm: () => $.getScript(endpoint)
			});
		},
		clear: function (anchor, endpoint) {
			App.controls.confirm.menu(anchor, {
				message: App.object_state.locale.chat_controls.confirm_clear,
				onconfirm: () => $.getScript(endpoint)
			});
		},
		leave: function (anchor, endpoint) {
			App.controls.confirm.menu(anchor, {
				message: App.object_state.locale.chat_controls.confirm_leave,
				ok_label: App.object_state.locale.yes_leave,
				onconfirm: () => $.getScript(endpoint)
			});
		},
		delete: function (anchor, endpoint) {
			App.controls.confirm.menu(anchor, {
				message: App.object_state.locale.chat_controls.confirm_delete,
				ok_label: App.object_state.locale.yes_delete,
				onconfirm: () => $.getScript(endpoint)
			});
		},
		remove_user: function (anchor, endpoint) {
			App.controls.confirm.menu(anchor, {
				message: App.object_state.locale.chat_controls.confirm_remove_user,
				ok_label: App.object_state.locale.yes_delete,
				onconfirm: () => $.getScript(endpoint)
			});
		},
		delete_message: function (anchor, endpoint) {
			App.controls.confirm.menu(anchor, {
				message: App.object_state.locale.chat_controls.confirm_delete_message,
				ok_label: App.object_state.locale.yes_delete,
				with_notify: false,
				onconfirm: () => {
					$.getScript(endpoint);
				}
			});
		},
		edit_author: function (anchor, endpoint) {
			let params = {
				field: 'id_user_from',
			};
			App.controls.user_select_and_go.show_context(anchor, endpoint, {
				onload: function () {
					let menu = $(this);
					menu.find('.menu__group-head ws-btn, .menu__group-search ws-btn').click(function () {
						App.core.form_submit(menu.find('form'));
					});
					menu.find('.menu__item[data-id]').click(function () {
						App.controls.menu.item_set_active_by_id(menu, $(this).attr('data-id'));
						App.controls.menu.process_select_box(menu);
						menu.find('input[name=' + params.field + ']').val($(this).attr('data-id'));
					});
					App.controls.menu.init_select_box(menu, {
						on_remove: (menu, select_box, placeholder) => {
							const placeholder_item = placeholder.find('.menu__item[data-id]');
							menu.find('input[name='+params.field+']').val(placeholder_item.attr('data-id'));
						}
					});
				},
				onshow: function () {
					let menu = $(this);
					$(this).find('ws-btn input[name=skip_notify]').val('');
					let id = $(this).find('input[name=' + params.field + ']').length ? $(this).find('input[name=' + params.field + ']').val() : 0;
					$(this).find('.menu__item').each(function () {
						$(this).toggleClass('menu__item-active', $(this).attr('data-id') == id)
					});
					App.controls.menu.item_set_active_by_id(menu, id);
					App.controls.menu.process_select_box(menu, { animate_selectbox: false });
				}
			})
		}
	}
})();

;(function() {
	let self = App.controls.chat_add_users = {
		show: function(menu_anchor, endpoint, params) {
			params ||= {};
			App.menu.show({
				anchor: menu_anchor,
				url: endpoint,
				width: 360,
				backup: params.backup || false,
				replace: params.replace || false,
				type: params.type || '',
				cache_trigger: 'chat_add_users',
				onload: function() {
					let menu = $(this);
					App.controls.menu.init(menu);

					if (params.initial_search && params.initial_search.trim().length) {
						menu.find('.menu__group-search input').val(params.initial_search).trigger('change');
					}

					menu.find('.menu__group-head ws-btn').on('click', function() {
						if ($(this).closest('.menu__group-head').hasClass('active')) {
							let ids = [];
							menu.find('.menu__item-active').each(function() {
								ids.push($(this).attr('data-id'));
							});
							if (ids.length) {
								menu.find('input[name=ids]').val(ids.join(','));
								App.core.form_submit(menu.find('form'), function() {
									App.menu.hide();
									if (params['onsuccess']) params['onsuccess']();
								});
							}
						}
					});
				}
			});
		}
	}
})();

;(function() {
	let self = App.controls.chat_edit = {
		obj: null,
		init: function () {
			self.obj = $('#chatEdit');
			const input = App.modal.obj_window.find('input[name="ids"]');
			const get_ids = () => {
				return input.val().split(',').filter(Number);
			};
			App.controls.editBlock_picker.init(
				App.modal.obj_window.find('#menuChatMembers'),
				App.modal.obj_window.find('.editBlock__picker-fake'),
				function(ids) {
					App.modal.obj_window.find('input[name="ids"]').val(ids.join(','));
					self.update_counter();
				},
				{
					search_selector: '.menu__item[data-picker-group="true"], .menu__item[data-id]',
					on_menu_load: function(menu, pickerFake, callback, params) {
						App.controls.editBlock_picker.on_menu_load(menu, pickerFake, callback, params);
						menu.find('.select-all').click(function () {
							App.menu.hide();
							App.modal.obj_window.find('.editBlock__bigSwitch').show().next().hide();
							input.val(input.attr('data-ids-max'));
							return false;
						});
					},
					before_group_processing_callback: function(ids) {
						const menu = $('#menuChatMembers');
						const all_item = menu.find('.menu__item.pick_all_my_team');
						if (all_item.length) {
							const is_user_picked = menu.find('.menu__group-users:not(.menu__group-clients, .menu__group-onlySearch)').is(':has(.menu__item-picked:not(.menu__item-default))');
							all_item.toggleClass('menu__item-notPossible', is_user_picked);
						}
					}
				}
			);
			App.modal.obj_window.find('.editBlock__bigSwitch').click(function () {
				$(this).hide().next().show();
				input.val(input.attr('data-ids-min'));
				self.update_counter();
				const ids = get_ids();
				$('#menuChatMembers').find('.editBlock__picker__item').each(function () {
					if (!ids.includes($(this).attr('data-id'))) {
						$(this).trigger('click', [{delete: true}]);
						return;
					}
				});
			});

			let name_input = self.obj.find('.editBlock__input input');
			let tmp = name_input.val();
			name_input.focus().val('').val(tmp);

			App.controls.editblock.init({ variant: 'leave' });
		},

		update_counter: function () {
			App.controls.editblock.set_updated_state();
			const ids = App.modal.obj_window.find('input[name="ids"]').val().split(',').filter(Number)
			const cnt_user = ids.length;
			const menu = $('#menuChatMembers');
			menu.add(App.modal.obj_window).find('.editBlock__picker__counter').html(cnt_user);
		},

		submit: function(form) {
			if (!$(form).find('input[name=ids]').val()) {
				self.obj.find('.editBlock__picker').blink();
				return false;
			}
			let name_len = $(form).find('input[name=name]').val().trim().length;
			if (name_len === 0 || name_len > 80) {
				self.obj.find('.editBlock__input').blink();
				return false;
			}
			App.core.form_submit(form);
		}
	}
})();

;(function() {
	let self = App.controls.chat_members = {
		timeout: {},
		obj: null,
		count: 0,
		show_dept: false,
		init: function(count) {
			self.count = count;
			self.obj = App.chat_info.obj_wrapper.find('#obj-chat-modal-members' + App.chat_info.id);
			let tab = App.chat_info.obj_wrapper.find('.modal__tabs__item[data-type="members"]');
			let counter = tab.find('.modal__tabs__item-counter');
			if (counter.length) counter.addClass('init').html(self.count);

			self.obj.find('.membersList__user .delete .confirm').bind('click', function() {
				$.ajax({
					type: 'POST',
					url: $(this).closest('.delete').attr('data-endpoint'),
					success: function() {
						App.chat_info.tab_reload('members,view');
					}
				});
			});
			self.obj.find('.membersList__user .delete .close').bind('click', function() {
				let userDel = $(this).parent();
				let isActive = userDel.hasClass('delete-active');
				self.obj.find('.membersList__user .delete').removeClass('delete-active');
				if (isActive) {
					userDel.removeClass('delete-active');
				} else {
					userDel.addClass('delete-active');
					userDel.closest('.membersList__user').bind('mouseleave', function() {
						let me = $(this);
						if (self.timeout) clearTimeout(self.timeout);
						self.timeout = setTimeout(function() {
							if (!me.is(':hover')) userDel.removeClass('delete-active');
						}, 2000);
						userDel.closest('.membersList__user').unbind('mouseleave');
					});
				}
			});
			self.obj.find('.membersList__user').bind('mouseenter', function() {
				if (App.scroll_listener.is_scrolling) return;
				let userObj = $(this);
				let userDel = userObj.find('.delete');
				if (userDel.hasClass('delete-active')) {
					userObj.bind('mouseleave', function() {
						let me = ($(this));
						if (self.timeout) clearTimeout(self.timeout);
						self.timeout = setTimeout(function() {
							if (!me.is(':hover')) userDel.removeClass('delete-active');
						}, 2000);
						userObj.unbind('mouseleave');
					});
				}
			});
			self.obj.find('.membersList__user').bind('click', function(e) {
				if($(e.target).closest('.ava_place').length) return;
				if($(e.target).closest('.delete').length) return;

				let hot_el = $(e.target).closest('.hot[data-url]');

				$(this).closest('.membersList__user').find('.ava_place').click();
			});
			self.obj.find('.dept_btn').bind('click', function() {
				self.show_dept = !self.show_dept;
				self.update_dept_visibility();
			});
			self.update_dept_visibility();
			setTimeout(function() {self.obj.find('.membersList').addClass('membersList-loaded');}, 100);
		},
		update_dept_visibility: function () {
			self.obj.find('.membersList__group').toggleClass('membersList__group-withDept', self.show_dept);
			let dept_btn = self.obj.find('.dept_btn');
			let text, ico;
			if (self.show_dept) {
				text = dept_btn.attr('data-text-hide');
				ico = dept_btn.attr('data-ico-hide');
			} else {
				text = dept_btn.attr('data-text-show');
				ico = dept_btn.attr('data-ico-show');
			}
			dept_btn.find('.text').html(text);
			dept_btn.find('ws-icon').replaceWith('<ws-icon name="' + ico + '"></ws-icon>');
		}
	}
})();

;(function() {
	let self = App.controls.chat_menu = {
		id: 0,
		show: function (anchor, endpoint, params) {
			params ||= {}
			params['request'] ||= {};
			App.menu.show({
				anchor: anchor,
				url: endpoint + '?' + App.actions.get('task_menu:show') + '&' + $.param(params['request']),
				backup: params.backup || false,
				replace: params.replace || false,
				type: params.type,
				onload: self.init,
				onshow: self.onshow,
				width: App.device.is_mobile() ? 300 : 280,
				force_dropdown: true
			});
		},
		init: function () {
			let menu = $(this);
			let endpoint = menu.find('#chatMenu').attr('data-url');

			menu.find('.menu__group-projColors .menu__item-color').bind('click', function() {
				let me = this;
				let id_color = $(this).attr('data-id-color');

				$.getScript(endpoint + '?' + App.actions.get('chat_edit_color:do') + '&id_color=' + id_color).done(function() {
					menu.find('.menu__group-projColors').find('ws-icon').remove();
					$(me).append('<ws-icon name="check_alt"></ws-icon>');
					let item = $('#chatMenu .menu__group-projIco .menu__item');
					$('#chatMenu .menu__item-emoji span:first-child').attr('class', 'proj_color' + id_color);
					item.removeClassRegex(/proj_color\d{1,2}/);
					item.addClass('proj_color' + id_color);
				});
			});

			menu.find('.menu__group-projIco .menu__item a').bind('click', function() {
				let me = this;
				$.getScript(endpoint + '?' + App.actions.get('chat_edit_color:do') + '&emoji=').done(function() {
					menu.find('.menu__group-projIco ws-emoji').attr('id', '');
					$(me).hide();
				});
			});
		},
		onshow: function () {
			const menu = $(this);
			const id_chat = parseInt(menu.find('#chatMenu').attr('data-chat'), 10);
			const is_shown = Boolean(App.chat_view.is_shown()) && App.task_view.id === id_chat;
			const minimize = menu.find('.menu__item-minimize');

			minimize.toggleClass('menu__item-hidden', !is_shown);
		},
	}
})();

;(function() {
	let self = App.controls.project_action = {
		archive: function (anchor, endpoint) {
			App.controls.confirm.menu(anchor, {
				message: App.object_state.locale.project_controls.confirm_archive,
				onconfirm: () => $.getScript(endpoint)
			});
		},
		unarchive: function (anchor, endpoint) {
			App.controls.confirm.menu(anchor, {
				variant: 'a',
				message: App.object_state.locale.project_controls.confirm_unarchive,
				onconfirm: () => $.getScript(endpoint)
			});
		},
		leave: function (anchor, endpoint) {
			App.controls.confirm.menu(anchor, {
				message: App.object_state.locale.project_controls.confirm_leave,
				ok_label: App.object_state.locale.yes_leave,
				onconfirm: () => $.getScript(endpoint)
			});
		},
		delete: function (anchor, endpoint) {
			App.controls.confirm.menu(anchor, {
				message: App.object_state.locale.project_controls.confirm_delete,
				ok_label: App.object_state.locale.yes_delete,
				onconfirm: () => $.getScript(endpoint)
			});
		}
	}
})();

;(function() {
	let self = App.controls.project_add_users = {
		show: function(menu_anchor, endpoint, params) {
			params ||= {};
			App.menu.show({
				anchor: menu_anchor,
				url: endpoint,
				width: 360,
				backup: params.backup || false,
				replace: params.replace || false,
				type: params.type || '',
				onload: function() {
					let menu = $(this);
					App.controls.menu.init(menu);

					if (params.initial_search && params.initial_search.trim().length) {
						menu.find('.menu__group-search input').val(params.initial_search).trigger('change');
					}

					menu.find('.menu__group-head ws-btn').on('click', function() {
						if ($(this).closest('.menu__group-head').hasClass('active')) {
							let ids = [];
							menu.find('.menu__item-active').each(function() {
								ids.push($(this).attr('data-id'));
							});
							if (ids.length) {
								menu.find('input[name=ids]').val(ids.join(','));
								App.core.form_submit(menu.find('form'), function() {
									App.menu.hide();
									if (params['onsuccess']) params['onsuccess']();
								});
							}
						}
					});
				}
			});
		}
	}
})();

;(function() {
	let self = App.controls.project_color = {
		obj: null,
		show: function (el, params) {
			params = params || {};
			self.obj = $(el);
			let id_project = self.obj.attr('data-project');
			let id_chat = self.obj.attr('data-chat');
			let id_color = self.obj.attr('data-color');
			let emoji = self.obj.attr('data-emoji');
			const rel = id_chat !== undefined ? 'chat' : 'project';

			let menu = $('<div>').addClass('menu menu-static menu-colors-emoji').append(
				$('<div>')
					.addClass('menu__columns')
					.append(
						$('<div>')
							.addClass('menu__group menu__group-projIco')
							.append(
								$('<div>')
									.addClass('menu__item proj_color' + id_color)
									.append('<ws-emoji' + (emoji ? ' id="' + emoji + '"' : '') + ' rel="' + rel + '"></ws-emoji>')
									.append('<a data-title="Reset emoji"><ws-icon name="input-circle-solid-cancel"></ws-icon></a>')
							)
					).append(
						$('<div>')
							.addClass('menu__group menu__group-projColors')
							.append($('<div>').addClass('menu__group__row flex_row'))
							.append($('<div>').addClass('menu__group__row flex_row'))
					)
			).append(
				$('<div>').addClass('menu__group-emoji')
			);

			if (!emoji) menu.find('.menu__group-projIco .menu__item a').hide();
			menu.find('.menu__group__row').each(function(index) {
				for (let i = 9 * index; i < 9 * (index + 1); i++) {
					$(this).append($('<div>').addClass('menu__item-color proj_color' + i).attr('data-id-color', i));
					if (parseInt(id_color) === i) {
						$(this).find('.proj_color' + i).append('<ws-icon name="check_alt"></ws-icon>');
					}
				}
			});

			$('#globalMenu').empty().append(menu);
			App.menu.show({anchor: el, box: '#globalMenu', type: params.type || 'mymenu', backup: params.backup, force_dropdown: true });
			self.init(id_project, id_chat);
		},
		init: function (id_project, id_chat) {
			let menu = $('#globalMenu .menu-colors-emoji');
			let endpoint = id_project
				? App.helper.endpoint.ajax(id_project) + '?' + App.actions.get('project_edit_color:do')
				: App.helper.endpoint.primary() + '?id=' + id_chat + '&' + App.actions.get('chat_edit_color:do');

			if (!menu.find('.menu__group-emoji em-emoji-picker').length) {
				menu.find('.menu__group-emoji').append(App.controls.emoji.getPicker(function(el) {
					let icoItem = menu.find('.menu__group-projIco .menu__item');
					let emoji = el.id + ':' + el.unified;

					icoItem.parent().attr('data-emoji', emoji);
					if (id_project || id_chat) {
						$.getScript(endpoint + '&emoji=' + emoji).done(function() {
							self.obj.attr('data-emoji', emoji);
							if (icoItem.find('ws-emoji').length) icoItem.find('ws-emoji').attr('id', emoji);
							$('.menu__group-projIco .menu__item a').show();
						});
					} else {
						self.obj.attr('data-emoji', emoji);
						if (icoItem.find('ws-emoji').length) {
							icoItem.find('ws-emoji').attr('id', emoji);
						}
						App.modal.obj_window.find('.proj_color').attr('data-emoji', emoji);
						App.modal.obj_window.find('.proj_color ws-emoji').attr('id', emoji);
						App.modal.obj_window.find('input[name="emoji"]').val(emoji);
						$('.menu__group-projIco .menu__item a').show();
					}
				}));
			}
			self.bind(menu, endpoint, id_project, id_chat);
		},
		bind: function(menu, endpoint, id_project, id_chat) {
			menu.find('.menu__group-projColors .menu__item-color').bind('click', function() {
				let el = this;
				let id_color = $(this).attr('data-id-color');

				if (id_project || id_chat) {
					$.getScript(endpoint + '&id_color=' + id_color).done(function() {
						self.obj.attr('data-color', id_color);
						menu.find('.menu__group-projColors').find('ws-icon').remove();
						$(el).append('<ws-icon name="check_alt"></ws-icon>');
						let item = menu.find('.menu__group-projIco .menu__item');
						menu.find('.menu__item-emoji span:first-child').attr('class', 'proj_color' + id_color);
						item.removeClassRegex(/proj_color\d{1,2}/);
						item.addClass('proj_color' + id_color);
					});
				} else {
					self.obj.attr('data-color', id_color);
					menu.find('.menu__group-projColors').find('ws-icon').remove();
					$(el).append('<ws-icon name="check_alt"></ws-icon>');
					let item = menu.find('.menu__group-projIco .menu__item');
					item.removeClassRegex(/proj_color\d{1,2}/);
					item.addClass('proj_color' + id_color);
					App.modal.obj_window.find('.proj_color').removeClassRegex(/proj_color\d{1,2}/).addClass('proj_color' + id_color).attr('data-color', id_color);
					App.modal.obj_window.find('input[name="id_color"]').val(id_color);
				}
			});
			menu.find('.menu__group-projIco .menu__item a').bind('click', function() {
				let el = this;

				if (id_project || id_chat) {
					$.getScript(endpoint + '&emoji=').done(function() {
						self.obj.attr('data-emoji', '');
						menu.find('.menu__group-projIco ws-emoji').attr('id', '');
						$(el).hide();
					});
				} else {
					self.obj.attr('data-emoji', '');
					menu.find('.menu__group-projIco ws-emoji').attr('id', '');
					App.modal.obj_window.find('.proj_color').attr('data-emoji', '');
					App.modal.obj_window.find('.proj_color ws-emoji').attr('id', '');
					App.modal.obj_window.find('input[name="emoji"]').val('');
					$(el).hide();
				}
			});
		},
	}
})();

;(function() {
	let self = App.controls.project_create = {
		obj: null,
		locale: {}, // from template
		init: function (params) {
			self.locale = params.locale;
			self.obj = $('.projectCreate');

			self.users.init();
			self.tags.init();

			let name_input = self.obj.find('.editBlock__input input');
			let tmp = name_input.val();
			name_input.focus().val('').val(tmp);

			App.controls.editblock.init();
		},
		update_counter: function () {
			App.controls.editblock.set_updated_state();
			const ids = App.modal.obj_window.find('input[name="ids"]').val().split(',').filter(Number)
			const cnt_user = ids.length;
			const menu = $('#menuProjectCreateMembers');
			menu.add(App.modal.obj_window.find('#pickerProjectCreateMembers')).find('.editBlock__picker__counter').html(cnt_user);
		},

		users: {
			init: function () {
				const input = App.modal.obj_window.find('input[name="ids"]');
				const get_ids = () => {
					return input.val().split(',').filter(Number);
				};
				App.controls.editBlock_picker.init(
					App.modal.obj_window.find('#menuProjectCreateMembers'),
					App.modal.obj_window.find('#pickerProjectCreateMembers'),
					function(ids) {
						App.modal.obj_window.find('input[name="ids"]').val(ids.join(','));
						self.update_counter();
					},
					{
						search_selector: '.menu__item[data-picker-group="true"], .menu__item[data-id]',
						on_menu_load: function(menu, pickerFake, callback, params) {
							App.controls.editBlock_picker.on_menu_load(menu, pickerFake, callback, params);
							menu.find('.select-all').click(function () {
								App.menu.hide();
								App.modal.obj_window.find('.editBlock__bigSwitch').show().next().hide();
								input.val(input.attr('data-ids-max'));
								return false;
							});
						},
						before_group_processing_callback: function(ids) {
							const menu = $('#menuProjectCreateMembers');
							const all_item = menu.find('.menu__item.pick_all_my_team');
							if (all_item.length) {
								const is_user_picked = menu.find('.menu__group-users:not(.menu__group-clients, .menu__group-onlySearch)').is(':has(.menu__item-picked:not(.menu__item-default))');
								all_item.toggleClass('menu__item-notPossible', is_user_picked);
							}
						}
					}
				);
				App.modal.obj_window.find('.editBlock__bigSwitch').click(function () {
					$(this).hide().next().show();
					input.val(input.attr('data-ids-min'));
					self.update_counter();
					const ids = get_ids();
					$('#menuProjectCreateMembers').find('.editBlock__picker__item').each(function () {
						if (!ids.includes($(this).attr('data-id'))) {
							$(this).trigger('click', [{delete: true}]);
							return;
						}
					});
				});
				App.modal.obj_window.find('.select-all').click(function () {
					App.modal.obj_window.find('.editBlock__bigSwitch').show().next().hide();
					input.val(input.attr('data-ids-max'));
					self.update_counter();
					return false;
				});
			},

			picker: {
				item_append: function (id, template_data) {

					const pickerFake = App.modal.obj_window.find('#pickerProjectCreateMembers');
					const input = App.modal.obj_window.find('input[name="ids"]');
					const ids = input.val().split(',').filter(Number)
					const item = App.helper.template.fill('editBlock_picker_item', template_data);

					input.val([...ids, id].join(','));
					pickerFake.find('.editBlock__picker__add').before(item);

					self.update_counter();
				}
			}
		},

		tags: {
			init: function () {

				const pickerFake = App.modal.obj_window.find('#pickerProjectCreateTags');
				const menu_box = App.modal.obj_window.find('#menuProjectCreateTags');
				const picker_input = App.modal.obj_window.find('input[name="'+pickerFake.attr('data-input')+'"]');

				const update_counter = () => {
					App.controls.editblock.set_updated_state();
					const ids = picker_input.val().split(',').filter(Number);
					pickerFake.add(menu_box).find('.editBlock__picker__header .label')
						.replaceWith(App.helper.template.fill('editBlock_picker_label', {
							label: self.locale.tags_label+':',
							count: ids.length,
						}));
				};

				pickerFake.on('click', function () {
					App.controls.project_task_labels_and_go.show_context(pickerFake, null, {
						type: 'picker',
						box: menu_box,

						onload: function() {

							const menu = $(this);

							menu.bind('after_interaction', function() {
								const picker = App.modal.obj_window.find('[data-container=labels]');
								const selected_items = menu.closest('.menu').find('.menu__item-picked');
								picker.find('.editBlock__picker__item').remove();

								const ids = [];
								selected_items.each(function(index, item) {

									const id_tag = $(item).attr('data-id');
									ids.push(id_tag);

									const item_group_req = picker.find('.editBlock__picker__item-group-required');

									item_group_req.filter('[data-group="'+App.tags[id_tag].id_group+'"]').addClass('ws-utility-hidden');
									item_group_req.add(picker.find('.editBlock__picker__item')).last().after(App.helper.template.fill('editBlock_picker_tag', {
										'data-id': id_tag,
										name: App.tags[id_tag].name,
										color: App.tags[id_tag].color,
										hidden: App.tags_group[App.tags[id_tag].id_group].hidden ? 1 : 0,
										delete: false
									}));
								});
								picker_input.val(ids.join(','))
								picker_input.closest('form').trigger('change');
								update_counter();
								return false;
							})
						},

						onshow: function() {
							let menu = $(this);
							menu.find('.editBlock__picker__item').remove();
							let ids = picker_input.val().split(',').map(Number);
							menu.find('.menu__item[data-id]').removeClass('menu__item-picked').filter(function() {
								return ids.includes($(this).attr('data-id').toInt());
							}).trigger('preset');
						}
					});
				});
			},

			validate: function (picker_input) {
				const ids = picker_input.val().split(',').filter(Number);
				let error_text = null;
				$.each(App.tags_group, function (id_tags_group, tags_group) {
					if (tags_group.required && !tags_group.stage && tags_group.inst == 1) {
						// console.log({ id_tags_group, tags_group });
						let exists = false;
						$.each(App.tags, function (id_tag, tag) {
							if (tag.id_group == id_tags_group) {
								// console.log({ id_tag, tag, ids });
								if (ids.includes(id_tag)) {
									exists = true;
									return false;
								}
							}
						});

						if (!exists) {
							error_text = self.locale.tags_required.replace('%s', tags_group.name);
							return false;
						}
					}
				});

				return error_text;
			},
		},

		onLogin: function () {
			App.bus.app.on('modal_load', () => App.core.context.when('modal_project_create', self.init))
		}
	}
})();

;(function() {
	let self = App.controls.project_description = {
		obj: null,
		objEdit: null,
		button_place: null,
		is_empty: function () {
			return !this.has_text() && this.count_files() === 0;
		},
		has_text: function () {
			return self.obj.find('.projectDescr .projectView__group__content .descr').attr('data-empty') !== 'yes';
		},
		count_files: function () {
			return self.obj.find('.projectDescr .projectView__group__content .fileItem').length;
		},
		get_file_names: function () {
			return self.obj.find('.projectDescr .projectView__group__content .fileItem .name').toArray().map(i => i.innerText);
		},
		init: function() {
			self.obj = App.modal.obj_window.find('.projectView');

			self.obj.find('.btn-files').bind('click', function() {
				if (self.objEdit != null) {
					const id_menu_attach = self.objEdit.find('.editor-btn.attach').attr('data-menu-id') || 'projectDescrFormFileMenu';
					App.menu.show({anchor: this, box: '#'+id_menu_attach, type: 'top left'});
				} else {
					let content = self.obj.find('.projectView__group__content');
					content.animate({scrollTop: content.find('.page_content').height()}, 300);
					self.obj.find('.page_files').shortblink();
				}
			});
			App.controls.editblock.init({ variant:'save' });
			App.controls.editblock.on('ok', function () {
				self.obj.find('.commentForm__buttons .btn-ok').click();
			});

			self.obj.on('click', '.page_content.descr', function (e) {
				if (self.is_empty() && $(e.target).closest('a, button, ws-btn').length === 0) self.obj.find('.btn-edit').click();
			})

			self.update();
		},
		update: function () {
			let fileCount = self.count_files();
			let btnFiles = self.obj.find('.btn-files');
			if (btnFiles.length) { // not implied for chat
				btnFiles.attr('data-title', self.get_file_names().join(', '));
				btnFiles.attr('text', fileCount + ' ' + App.format.quantity(fileCount, btnFiles.attr('data-label')));
				btnFiles.toggleClass('hiddenBlock', fileCount === 0);
			}

			let btnEdit = self.obj.find('.btn-edit');
			if (btnEdit.length) {
				btnEdit.attr('text', self.is_empty() ? btnEdit.attr('data-add-label') : btnEdit.attr('data-edit-label'))
			}

			self.obj.find('ws-btn.btn-files button').toggleClass('btn-plain', self.objEdit == null).toggleClass('btn-fill', self.objEdit != null);

			self.obj.find('.projectDescr').toggleClass('projectDescr-empty', self.is_empty());
			self.obj.find('.page_content.descr').toggleClass('hiddenBlock', !self.has_text() && self.count_files() > 0);
		},
		edit_inline_start: function(type, endpoint) {

			if (App.offline_mode.is_on()) return;

			App.core.async_task.ajax({
				id: 'project_description_edit_inline_start',
				url: endpoint,
				success: function(html) {
					if (type  === 'descr') {
						let obj_detach = self.obj.find('.projectDescr .projectView__group').addClass('projectView__group-editing').find('.projectView__group__content');
						self.obj.find('.projectDescr').addClass('projectDescr-editing');
						self.objEdit = $('<div />').attr('class', 'projectView__group__contentEdit').html(html).insertAfter(obj_detach);
						App.modal.init_scroll_zones();
						App.editor.init(self.objEdit);
						App.upload.init(self.obj.find('.drop_zone_body'));
						self.objEdit.find('form').on('change', function () {
							App.controls.editblock.set_updated_state()
						});

						self.button_place = self.obj.find('.projectDescr .projectView__group__head .button_place').clone();
						self.obj.find('.projectDescr .projectView__group__head .button_place').replaceWith(self.objEdit.find('.place_button'));
						App.editor.focus();
						setTimeout(() => self.update(), 50);
					}
				}
			});
		},
		edit_inline_end: function() {
			if (self.button_place != null) {
				self.obj.find('.projectDescr .projectView__group__head .place_button').replaceWith(self.button_place);
				self.button_place = null;
			}

			App.controls.editblock.set_updated_state(false)
			self.objEdit.prev().parents('.projectView__group-editing').removeClass('projectView__group-editing');
			self.obj.find('.projectDescr').removeClass('projectDescr-editing');
			self.objEdit.find('.scrollZone').each(function() {
				if (this.scrollBars) this.scrollBars.destroy();
			});
			self.objEdit.remove();
			self.objEdit = null;

			self.update();
		},
		edit_inline_save: function () {
			App.core.form_submit(self.objEdit.children('form'));
		}
	}
})();

;(function() {
	let self = App.controls.project_folder_create = {
		obj: null,
		init: function () {
			self.obj = $('.projectFolderCreate');

			let input = self.obj.find('.editBlock__input input');
			let tmp = input.val();
			input.focus().val('').val(tmp);

			App.controls.editblock.init();

			self.obj.find('.proj_folder_color_input').on('click', '.menu__item', function () {
				$('.proj_folder_color_input .menu__item').removeClass('menu__item-active');
				$(this).addClass('menu__item-active');
				self.obj.closest('form').find('input[name=id_color]').val($(this).attr('data-id'));
			});
		},

		/* TODO menu */
		show: function (menu_anchor, endpoint, params) {
			App.modal.show({ url: endpoint, ...params });
		},
	}
})();

;(function() {
	let self = App.controls.project_folder_delete = {
		menu: function (anchor, url, params) {
			params ||= {};
			params.confirm ||= {};

			let endpoint = url || $(anchor).attr('data-url');

			App.controls.confirm.menu(anchor, {
				...params.confirm,
				on_confirm: function () {
					App.menu.hide_all();
					$.getScript(endpoint, function () {
						$('#obj-group'+params.id_group).remove();
					});
				}
			});
		},
		show: function (anchor, url, params) {
			params = params || {};

			App.modal.show({
				url: url,
				width: params.width ?? 510,
				title: params.title ?? '',
			});
		}
	}
})();

;(function() {
	let self = App.controls.project_group_select_and_go = {
		callback: null,
		show_context: function(menu_anchor, endpoint, params) {
			params ||= {};
			params['request'] ||= {};
			params['request']['template'] = 'menu';
			endpoint ||= $(menu_anchor).attr('data-url');
			App.menu.show({
				anchor: menu_anchor,
				url: App.helper.url.add_query(endpoint, $.param(params['request'])),
				onload: params.onload || null,
				onshow: params.onshow || null,
				replace: params.replace || false,
				backup: params.backup || false,
				type: params.type || '',
				width: params.width || 240,
			});
		},
	}
})();

;(function() {
	let self = App.controls.project_members = {
		timeout: {},
		obj: null,
		count: 0,
		show_dept: false,
		init: function(count) {
			self.count = count;
			self.obj = App.project_view.obj_wrapper.find('#obj-project-modal-members' + App.project_view.id);
			let tab = App.project_view.obj_wrapper.find('.modal__tabs__item[data-type="members"]');
			let counter = tab.find('.modal__tabs__item-counter');
			if (counter.length) counter.addClass('init').html(self.count);

			self.obj.find('.membersList__user .delete:not([onclick]) .close').bind('click', function() {
				const loader = $(this).find('ws-icon').addClass('loader loader--sm loader--curling');
				self.users.remove($(this).closest('.delete').attr('data-endpoint'), {
					anchor: $(this),
					complete_callback: () => {
						loader.removeClass('loader loader--sm loader--curling');
					}
				});
			});

			const updateSize = () => {
				let maxOgSize = 0;
				self.obj.find('.membersList__user .rate input[data-og-size]').each(function () {
					const ogSize = parseFloat(this.dataset.ogSize) || 0;
					if (ogSize > maxOgSize) maxOgSize = ogSize;
					if (maxOgSize >= 6) return false; // break
				});
				maxOgSize = maxOgSize.clamp(4, 6);
				self.obj.find('.membersList__user .rate input[data-og-size]').attr('size', maxOgSize);
			};
			const updateOgSize = App.helper.just_throttle((input) => {
				input.dataset.ogSize = input.value.replace(/\D/u, '').length;
				updateSize();
			});
			updateSize();

			self.obj.find('.membersList__user .rate input').bind('focus', function(e) {
				this.select();
				// якогось фіга інколи скидається до курсора
				setTimeout(() => {
					this.select();
				}, 100);
			});
			self.obj.find('.membersList__user .rate input').bind('keyup blur paste', function(e) {
				if (e.type === 'keyup' && App.keyboard_listener.helper_enter_esc_blur(this, e)) return;
				if (e.type === 'keyup') {
					App.controls.rate.sanitize_input(this);
				} else {
					App.controls.rate.sanitize_change(this);
					if (this.value === '') {
						this.value = $(this).attr('data-default');
					}
				}
				updateOgSize(this);
				let rate = this.value;
				let o = $(this);
				let url = o.attr('data-endpoint');
				o.closest('.rate')
					.toggleClass('rate-diff', this.value !== '' && +this.value !== +o.attr('data-default'))
					.toggleClass('rate-up', this.value !== '' && +this.value > +o.attr('data-default'))
					.toggleClass('rate-dn', this.value !== '' && +this.value < +o.attr('data-default'));
				App.core.call_queue.add('rate_' + o.attr('data-id'), () => {
					if (o.attr('data-saved') === rate) return;
					o.attr('data-saved', rate);
					$.ajax({
						url,
						method: 'GET',
						dataType: 'script',
						data: {rate},
					});
				}, this, null, 1);
			});

			self.obj.find('.membersList__user').bind('click', function(e) {
				if ($(e.target).closest('.ava_place, .delete, .rate').length) return;

				let hot_el = $(e.target).closest('.hot[data-url]');

				if (hot_el.length) {
					App.core.goto(hot_el.attr('data-url'));
				} else {
					$(this).closest('.membersList__user').find('.ava_place').click();
				}
			});
			self.obj.find('.dept_btn').bind('click', function() {
				self.show_dept = !self.show_dept;
				self.update_dept_visibility();
			});
			self.update_dept_visibility();
			setTimeout(function() {self.obj.find('.membersList').addClass('membersList-loaded');}, 100);
		},
		update_dept_visibility: function () {
			self.obj.find('.membersList__group').toggleClass('membersList__group-withDept', self.show_dept);
			let dept_btn = self.obj.find('.dept_btn');
			let text, ico;
			if (self.show_dept) {
				text = dept_btn.attr('data-text-hide');
				ico = dept_btn.attr('data-ico-hide');
			} else {
				text = dept_btn.attr('data-text-show');
				ico = dept_btn.attr('data-ico-show');
			}
			dept_btn.find('.text').html(text);
			dept_btn.find('ws-icon').replaceWith('<ws-icon name="' + ico + '"></ws-icon>');
		},

		users: {
			remove: function (endpoint, options = {}) {

				options = $.extend({
					anchor: $(),
					complete_callback: () => {}
				}, options);

				$.ajax({
					type: 'GET',
					url: endpoint,
					dataType: 'json',
					success: function (res) {
						if (!res.type) throw new Error('Unexpected response');

						switch (res.type) {
							case 'confirm':
								if (!res.endpoint) throw new Error('Unexpected response');
								App.controls.confirm.menu(options.anchor.get(0), {
									message: App.object_state.locale.ask_delete,
									ok_label: App.object_state.locale.yes_delete,
									onconfirm: function () {
										$.ajax({
											type: 'POST',
											url: res.endpoint
										});
									}
								});
								break;
							case 'modal':
							default:
								if (!res.html || !res.title) throw new Error('Unexpected response');
								App.modal.show({
									title: res.title,
									html: res.html,
									backup: true
								});
								break;
						}
					},
					complete: function () {
						options.complete_callback();
					}
				});
			}
		}
	}
})();

;(function() {
	let self = App.controls.project_menu = {
		show: function (anchor, endpoint, params) {
			params ||= {}
			App.menu.show({
				anchor: anchor,
				url: endpoint + '?' + App.actions.get('project_menu:show') + '&project_view=' + App.current_page.project + '&context_menu=' + (params.context_menu===true?1:0),
				backup: params.backup || false,
				replace: params.replace || false,
				type: params.type || 'left',
				onload: self.init
			});
		},
		init: function () {
			let menu = $(this);
			let endpoint = menu.find('#projectMenu').attr('data-url');

			menu.find('#menuProjectFav').bind('click', function() {
				let is_on = $(this).attr('data-is-on');
				$.getScript(endpoint + '?' + App.actions.get('project_bookmark:do') + '&is_on=' + is_on).done(function() {
					App.menu.hide();
					App.sidebar.need_reload('projects');
				});
			});

			menu.find('#menuProjectSleep').bind('click', function() {
				let url = $(this).attr('data-action');
				$.getScript(url).done(function() {
					App.menu.hide();
					App.sidebar.need_reload('projects');
				});
			});

			menu.find('#menuProjectMove').bind('click', function() {
				let id_active = $(this).attr('data-group');
				App.controls.project_group_select_and_go.show_context(this, null, {
					backup: true,
					type: 'submenu',
					onload: function() {
						let menu = $(this);
						menu.find('.menu__item[data-id]').bind('click', function() {
							if ($(this).hasClass('menu__item-active')) return false;
							let id_group = $(this).attr('data-id');
							$.getScript(endpoint + '?drag_to=' + id_group + '&' + App.actions.get('project_drag:do')).done(function() {
								App.menu.hide_all();
							});
						});

						menu.find('#menuCreateTeam ws-btn').click(function () {
							let name = $(this).closest('.menu').find('input[name=name]').val().trim();
							if (name) {
								$.getScript(endpoint + '?drag_to=-1&name=' + encodeURIComponent(name) + '&' + App.actions.get('project_drag:do')).done(function() {
									App.menu.hide_all();
								});
							}
						});
					},
					onshow: function() {
						$(this).find('.menu__item[data-id]').each(function() {
							$(this).toggleClass('menu__item-active', $(this).attr('data-id') == id_active).find('.space ws-icon').toggleClass('withHover', $(this).attr('data-id') != id_active);
						});
					}
				});
			});

			menu.find('.menu__group-projColors .menu__item-color').bind('click', function() {
				let me = this;
				let id_color = $(this).attr('data-id-color');

				$.getScript(endpoint + '?' + App.actions.get('project_edit_color:do') + '&id_color=' + id_color).done(function() {
					menu.find('.menu__group-projColors').find('ws-icon').remove();
					$(me).append('<ws-icon name="check_alt"></ws-icon>');
					let item = $('#projectMenu .menu__group-projIco .menu__item');
					$('#projectMenu .menu__item-emoji span:first-child').attr('class', 'proj_color' + id_color);
					item.removeClassRegex(/proj_color\d{1,2}/);
					item.addClass('proj_color' + id_color);
				});
			});

			menu.find('.menu__group-projIco .menu__item a').bind('click', function() {
				let me = this;
				$.getScript(endpoint + '?' + App.actions.get('project_edit_color:do') + '&emoji=').done(function() {
					menu.find('.menu__group-projIco ws-emoji').attr('id', '');
					$(me).hide();
				});
			});
		}
	}
})();

;(function() {
	let self = App.controls.project_name = {
		nameLength: 80,
		obj: null,
		init: function () {
			self.obj = $('.editBlock');
			let input = self.obj.find('.editBlock__input input');
			let apply = self.obj.find('.editBlock__buttons-right .btn-ok')
			let tmp = input.val();
			input.focus().val('').val(tmp);

			App.controls.editblock.init({ variant: 'save' });
			App.controls.editblock.on('ok', function () {
				apply.click();
			})
		}
	}
})();

;(function() {
	let self = App.controls.project_note = {
		last_state: new Map(),
		obj: null,
		defaultHeight: '50% - 14px',
		touch_start_y: 0,
		touch_end_h: 0,

		_debouncedSaves: new WeakMap(),

		save(el) {
			if (!this._debouncedSaves.has(el)) {
				const fn = App.helper.debounce((element) => {
					let value = element.value;
					let url = $(element).attr('data-action');

					if (self.last_state.get(url) === value) return;

					$(element).parent().parent().find('.loader_sm, .loader').show().next().hide();

					$.ajax({
						type: 'POST',
						url: url,
						data: 'note=' + encodeURIComponent(value),
						success: () => {
							self.last_state.set(url, value);
							$(element).parent().parent().find('.loader_sm, .loader').hide().next().show();
						}
					});
				}, 999);

				this._debouncedSaves.set(el, fn);
			}
			this._debouncedSaves.get(el)(el);
		},
		init: function() {
			self.touch_end_h = 0;
			self.last_state.clear();
			self.obj = App.project_view.obj_wrapper.find('.note').parent();
			self.obj.find('.drag_line').bind('mousedown.page touchstart.page', self.ontouchstart_height);
			self.obj.find('textarea[data-action]').each(function() {
				self.last_state.set($(this).attr('data-action'), this.value);
			});
			self.obj.find('textarea').on('focus.page', function() {
				self.obj.find('.note').removeClass('note--lastFocused');
				$(this).closest('.note').addClass('note--lastFocused');
			});
			$(document)
				.unbind('mouseup.page', self.ontouchend_height)
				.unbind('touchend.page', self.ontouchend_height)
				.unbind('mousemove.page', self.ontouchmove_height)
				.unbind('touchmove.page', self.ontouchmove_height)
				.bind('mouseup.page touchend.page', self.ontouchend_height)
				.bind('mousemove.page touchmove.page', self.ontouchmove_height);
		},

		ontouchstart_height: function (e) {
			if (e.type != 'touchstart' && e.which != 1) return true;
			e.preventDefault();
			e.stopPropagation();
			let touch = e;
			if (e.type == 'touchstart') touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e;
			self.touch_start_y = touch.pageY;
		},
		ontouchmove_height: function (e) {
			if (self.touch_start_y && $(window).height() > 550) {
				let change_h = $(window).height() / ($(window).height() < 700 ? 16 : 10);
				let touch = e;
				if (e.type == 'touchmove') touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e;
				let this_h = self.touch_end_h + touch.pageY - self.touch_start_y;
				if (this_h > change_h) this_h = change_h;
				if (this_h < -change_h) this_h = -change_h;

				if (this_h < 0) {
					self.obj.find('.privateNote').css({height: 'calc(' + self.defaultHeight + ' - ' + Math.abs(this_h) + 'px)'});
					self.obj.find('.adminNote').css({height: 'calc(' + self.defaultHeight + ' + ' + Math.abs(this_h) + 'px)'});
				} else {
					self.obj.find('.privateNote').css({height: 'calc(' + self.defaultHeight + ' + ' + Math.abs(this_h) + 'px)'});
					self.obj.find('.adminNote').css({height: 'calc(' + self.defaultHeight + ' - ' + Math.abs(this_h) + 'px)'});
				}
			}
		},
		ontouchend_height: function (e) {
			if (self.touch_start_y && $(window).height() > 550) {
				let change_h = $(window).height() / ($(window).height() < 700 ? 16 : 10);
				let touch = e;
				if (e.type == 'touchend') touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e;
				let this_h = self.touch_end_h + touch.pageY - self.touch_start_y;
				if (this_h > change_h) this_h = change_h;
				if (this_h < -change_h) this_h = -change_h;
				self.touch_start_y = 0;
				self.touch_end_h = this_h;
			}
		},
	}
})();

;(function() {
	let self = App.controls.project_permissions = {
		timeout: {},
		obj: null,
		init: function() {
			self.obj = App.project_view.obj_wrapper.find('#obj-project-modal-permissions' + App.project_view.id);

			App.controls.form_autosave.init();

			self.obj.find('.btn-reset').bind('click', function() {
				let obj = $(this).closest('.projectView__group');
				obj.find('.setupBlock__item input[type=checkbox]').each(function() {
					$(this).prop('checked', !!$(this).closest('.setupBlock__item').attr('data-default'));
					$(this).trigger('change');
				});
			});

			self.obj.find('.setupBlock__item input[type=checkbox]').on('change', function () {
				self.update_reset_btn($(this).closest('.projectView__group'));
			});

			self.obj.find('.projectView__group').each(function () {
				self.update_reset_btn($(this));
			})
		},
		update_reset_btn: function (group) {
			let has_custom_values = group.find('.setupBlock__item input[type=checkbox]').get().map(function (el) {
				return el.checked !== ($(el).closest('.setupBlock__item').attr('data-default') === '1')
			});
			let show_reset = has_custom_values.find(i => i === true);

			group.find('.btn-reset').css('display', show_reset?'inline-flex':'none')
		}
	}
})();

;(function() {
	let self = App.controls.project_quick_menu = {
		show: function (anchor, id_project, params) {
			params ||= {}

			const url = window.location.origin + App.helper.url.project(id_project);
			const menu = $('#quickProjectMenu');
			const is_current_view = String(App.current_page.project) === String(id_project);

			const item_open = menu.find('.menu__item[data-key=open]');
			item_open.find('ws-icon').toggleClass('ws-utility-hidden', is_current_view);
			item_open.find('.in').text( is_current_view ? item_open.attr('data-opened-text') : item_open.attr('data-default-text') );

			$(menu).off('click').on('click','.menu__item', function() {
				App.menu.hide();
				switch ($(this).attr('data-key')) {
					case 'open':
						App.core.goto(url);
						break;
					case 'info':
						App.project_view.show(id_project, 'info');
						break;
				}
			});

			App.menu.show({
				anchor: anchor,
				type: params.type || 'left',
				replace: params.replace || false,
				backup: params.backup || false,
				box: '#quickProjectMenu',
				width: 'auto',
				force_dropdown: true,
			})
		},
	};
})();

;(function() {
	let self = App.controls.project_select_and_go = {
		callback: null,
		show_context: function(menu_anchor, endpoint, params) {
			params ||= {};
			params['request'] ||= {};
			params['request']['template'] = 'menu';
			App.menu.show({
				anchor: menu_anchor,
				url: endpoint || App.helper.url.add_query(App.helper.endpoint.ajax(), App.actions.get('project_select_and_go:show') + '&' + $.param(params['request'])),
				onload: params.onload || null,
				onshow: params.onshow || null,
				noblur: params.noblur || null,
				text_position: params.text_position || null,
				onhide: params.onhide || null,
				type: params.type || '',
				backup: params.backup || '',
				replace: params.replace || false,
				title: App.object_state.locale['project'],
				cache_trigger: 'project'
			});
		},
		show: function(callback, options) {
			self.callback = callback;
			App.modal.show({
				url: App.helper.url.add_query(App.helper.endpoint.ajax(), App.actions.get('project_select_and_go:show')),
				width: 500,
			});
		},
	}
})();

;(function() {

	const TASK = 0;
	const PROJECT = 1;
	const CONTACT = 2;

	let self = App.controls.project_task_labels_and_go = {
		callback: null,
		show_context: function(menu_anchor, endpoint, params) {
			params ||= {};
			params['request'] ||= {};
			params['request']['template'] = 'menu';
			App.menu.show({
				anchor: menu_anchor,
				url: params.box ? null : App.helper.url.add_query(endpoint, $.param(params['request'])),
				box: params.box || null,
				onload: function() {
					self.init.call(this);
					params.onload?.call(this);
					if (!$(this).hasClass('menu-picker') && $(this).find('.menu__group-picker').length) {
						$(this).addClass('menu-picker menu-pickerGuessed');
					}
				},
				onshow: params.onshow || null,
				backup: params.backup || false,
				replace: params.replace || false,
				type: params.type || '',
				title: App.object_state.locale['stage'],
				width: 400,
				cache_trigger: 'tags'
			});
		},

		init: function(params) {
			params ||= {};
			let menu = $(this);
			let picker = menu.find('.editBlock__picker');

			let menu_keyboardZone = params.detached_picker ? menu.parent() : menu.find('.keyboardZone:not(.editBlock__picker__body)'); // Case: detached picker in mass modal
			let picker_keyboardZone = picker.find('.editBlock__picker__body');

			let run_search = function() {
				App.context_search.menu.apply(this, menu, {
					title: '.tag',
					allow_empty_groups: true,
					callback: params.search_callback || null,
					skip_selection: picker_keyboardZone.hasClass('keyboardZone-active')
				});
			}

			menu.on('click preset', '.menu__group-searchable .menu__item', function(e) {
				let id_tag = $(this).attr('data-id').toInt();
				if (e.type === 'click') {
					let group = $(this).closest('.tagsSingleSelect__group');
					let is_once = group.attr('data-group-once').toInt();
					if (is_once && group.find('.menu__item-picked').length) {
						group.find('.menu__item-picked').each(function() {
							$(this).removeClass('menu__item-picked');
							picker.find('.editBlock__picker__item[data-id="'+$(this).attr('data-id').toInt()+'"]').remove();
						});
					}
				}

				App.keyboard_selection.set_active_container(menu_keyboardZone);
				$(this).addClass('menu__item-picked');

				picker.find('.editBlock__picker__item-selected').removeClass('.editBlock__picker__item-selected');
				picker.find('.editBlock__picker__search').before(App.helper.template.fill('editBlock_picker_tag', {
					'data-id': id_tag,
					name: App.tags[id_tag].name,
					color: App.tags[id_tag].color,
					hidden: App.tags_group[App.tags[id_tag].id_group].hidden ? 1 : 0,
					delete: true
				}));

				/** this will hide empty groups and reset keyboard selection */
				App.keyboard_selection.move_to_closest(menu_keyboardZone);
				picker.find('.editBlock__picker__search input').val('').focus_desktop().each(run_search);

				menu.trigger('after_interaction');
			});

			menu.bind('after_interaction', function() { // this = menu
				let cnt = $(this).find('.menu__item-picked').length;
				let o_counter = $(this).find('.checkboxCount');
				if (!o_counter.length) return;
				const is_once = $(this).hasClass('menu-tagOnce');
				if (cnt && !is_once) {
					let tmpTxt = App.format.quantity(cnt, o_counter.attr('data-change-text'));
					o_counter.html('<b>' + cnt + '</b> ' + tmpTxt.charAt(0).toUpperCase() + tmpTxt.slice(1));
				} else {
					o_counter.html(o_counter.attr('data-default-text'));
				}
			});

			picker.on('click', '.editBlock__picker__item', function(e, data) {
				data ||= {};
				let id_tag = $(this).attr('data-id').toInt();
				App.keyboard_selection.set_active_container(picker_keyboardZone);

				const is_mobile_delete = App.device.is_mobile() && $(this).hasClass('selected'); // на мобілці видаляється при дабл тапі (якщо не в хрестик)
				const is_button_delete = $(e.target).closest('.delete').length > 0;
				if (!data.delete && !data.enter && !is_button_delete && !is_mobile_delete) {
					if ($(this).hasClass('selected')) {
						$(this).toggleSelected(false);
						if (!picker_keyboardZone.find('.editBlock__picker__item').length) {
							App.keyboard_selection.set_active_container(menu_keyboardZone);
						}
					}
					else {
						// треба щоб фокус ставився в поле, але не скролило до нього
						picker.find('.editBlock__picker__search input').focus_enhanced({
							desktop_only: true,
							restore_scroll: true,
							callback: () => {
								picker_keyboardZone.find('.selected').toggleSelected(false);
								$(this).toggleSelected(true);
							}
						});
						picker_keyboardZone.find('.selected').toggleSelected(false);
						$(this).toggleSelected(true);
					}
					return false;
				}

				// обирати щось взамін, тільки якщо це дія з клавіатури
				let closest_sibling_item;
				if (data.delete || data.enter) {
					closest_sibling_item = App.keyboard_selection.find_closest_sibling(picker_keyboardZone, data.backward || false);
				}

				let item = menu.find('.menu__group-searchable, .menu__group-hidden').find('.menu__item[data-id="'+id_tag+'"]');
				let group = item.closest('.tagsSingleSelect__group');

				let is_required = group.attr('data-group-required').toInt();
				if (is_required && group.find('.menu__item-picked').length === 1
					&& id_tag === group.find('.menu__item-picked').attr('data-id').toInt()) {
					$(this).shortblink();
					group.shortblink();
					return false;
				}

				item.removeClass('menu__item-picked');
				$(this).remove();

				if (closest_sibling_item && closest_sibling_item.length) {
					closest_sibling_item.toggleSelected(true);
				}
				if (!picker_keyboardZone.find('.editBlock__picker__item').length) {
					App.keyboard_selection.set_active_container(menu_keyboardZone);
				}

				/** this will hide empty groups and reset keyboard selection */
				picker.find('.editBlock__picker__search input').focus_enhanced({
					desktop_only: true,
					restore_scroll: true
				}).each(run_search);
				// при додаванні група "поглинає" обрані елементи, котрі в неї входять
				// тому треба оновити висоту скролзони
				picker_keyboardZone.closest('.scrollZone').scrollUpdate();
				// на мобілі без автофокуса в поле вводу,
				// тому вручну скролимо до низу, щоб бачити, що елемент додався
				if (App.device.is_mobile()) {
					picker_keyboardZone.closest('.scrollZone').scrollBottom();
				}
				menu.trigger('after_interaction');

				// щоб не прокидувалась подія далі (де ставиться фокус в поле, що заважає на мобілці)
				return false;
			});

			picker.bind('click', function(e) {
				if ($(e.target).closest('.ps__rail-y, .ps__rail-x').length) return true;
				if (!$(e.target).parents().addBack().filter('.editBlock__picker__item').length && picker.find('.selected').length) {
					picker.find('.selected').toggleSelected(false);
					App.keyboard_selection.set_active_container(menu_keyboardZone);
				}
				picker.find('.editBlock__picker__search input').focus();
			});

			let stop_event = false;
			picker.find('.editBlock__picker__search input').bind('keydown', function(e, data) {
				let keyCode = e.which || e.keyCode || e.charCode;
				if (keyCode === App.keycode.Escape) {
					if (this.value) {
						this.value = '';
						picker_keyboardZone.find('.selected').toggleSelected(false);
						run_search.call(this);
						return false;
					} else if (picker_keyboardZone.hasClass('keyboardZone-active')) {
						App.keyboard_selection.set_active_container(menu_keyboardZone);
						return false;
					}
				}
				if (keyCode === App.keycode.Tab) {
				}
				if (!this.value && !picker_keyboardZone.find('.selected').length && keyCode === App.keycode.Backspace) {
					App.keyboard_selection.set_active_container(picker_keyboardZone);
					App.keyboard_selection.init_container(picker_keyboardZone, true);
					stop_event = true;
					return false;
				}

				// уникаємо авто-проскрола до поля вводу
				if (
					picker_keyboardZone.hasClass('keyboardZone-active')
					&& picker_keyboardZone.find('.selected').length
					&& (keyCode === App.keycode.Backspace || keyCode === App.keycode.Delete)
				) return false;
			});

			picker.find('.editBlock__picker__search input').bind('keyup', function(e) {
				let keyCode = e.which || e.keyCode || e.charCode;

				// це не введення, а навігація між зонами
				if (keyCode === App.keycode.Tab) return false;

				if (this.value || menu.hasClass('search_started')) {

					// це навігація курсора по написаному
					if (keyCode === App.keycode.ArrowLeft || keyCode === App.keycode.ArrowRight) return false;
					if (keyCode === App.keycode.ArrowUp || keyCode === App.keycode.ArrowDown) return false;

					App.keyboard_selection.set_active_container(menu_keyboardZone);
					run_search.call(this);

				} else {
					if (
						picker_keyboardZone.hasClass('keyboardZone-active')
						&& picker_keyboardZone.find('.selected').length
						&& (keyCode === App.keycode.Backspace || keyCode === App.keycode.Delete)
						&& !stop_event
					) {
						picker_keyboardZone.find('.selected').trigger('click', [{delete: true, backward: keyCode === App.keycode.Backspace}]);
						if (!picker.find('.editBlock__picker__item').length) {
							App.keyboard_selection.set_active_container(menu_keyboardZone);
						}
						return false;
					}

				}
				stop_event = false;
			});

			picker.on('onselect', '.editBlock__picker__item', function () {

				// з клавіатури там своя система
				if (!App.keyboard_selection.is_mouse_moved) return true;

				$(this).scrollIntoViewIfNeeded({
					offset_top: 2,
					offset_bottom: 2,
				});
			});
		},

		show_admin: function (anchor, event) {
			const menu_selector = '#tags_open_admin_menu';
			const menu = $(menu_selector);

			anchor = $(event.target).closest('.chip').get(0) || anchor;

			const id_group = $(anchor).closest('[data-group]').attr('data-group');
			const inst = App.tags_group[id_group]?.inst;
			let tab = inst == PROJECT ? 'project' : (inst == CONTACT ? 'contact' : '');

			menu.find('a').on('click', function (event) {
				event.preventDefault();
				const url = App.helper.url.add_query('/account/labels/', '', {
					tab,
					id_group
				});
				App.core.new_window(url);
				App.menu.hide();
			});

			App.menu.show({
				anchor: anchor,
				type: 'left',
				replace: false,
				backup: true,
				box: menu_selector,
				force_dropdown: true
			});

			menu.one('before_hide', () => {
				menu.find('a').off('click');
			});
		},
	}
})();

;(function() {
	let self = App.controls.project_task_stage_and_go = {
		callback: null,
		show_context: function(menu_anchor, endpoint, params) {
			params ||= {};
			params['request'] ||= {};
			params['request']['template'] = 'menu';

			const url = App.helper.url.add_query(endpoint, $.param(params['request']));

			// extract id_task from url, to proper cache_trigger
			const parser = new URL(url, window.location.origin);
			const match = parser.pathname.match(App.helper.validate.task_url);
			const id_task = match ? parseInt(match[1]) : null;

			App.menu.show({
				anchor: menu_anchor,
				url,
				onload: params.onload || null,
				onshow: params.onshow || null,
				type: params.type || '',
				backup: params.backup || false,
				replace: params.replace || false,
				title: App.object_state.locale['stage'],
				cache_trigger: 'tags'+(id_task ? ',task'+id_task : ''),
			});
		},
	}
})();

;(function() {
	let self = App.controls.project_terms_on_edit = {
		locale: {},
		onselect_range: function (range) {
			let date_arr = range.split(' - ');
			let date = date_arr[1];
			let date_st = date_arr[0];
			date_arr = $('#dateend_').val().split(' - ');
			let date_nice = date_arr[1];
			let date_st_nice = date_arr[0];
			$('#dateend').val(date);
			$('#datestart').val(date_st);
			let adt = date_st_nice.split('.');
			$('#dateend_nice .start').html('<font class="w360">' + adt[4] + ' </font><b>' + adt[1] + ' ' + adt[5] + '</b>' + ((new Date()).getFullYear() == adt[3] ? '' : ' ' + adt[3]));
			App.controls.task_terms.helper_option_events('on', 'dt_date');
			if (date) {
				let adt = date_nice.split('.');
				$('#dateend_nice .end').stop().css({opacity: 1}).html('<font class="w360">' + adt[4] + ' </font><b>' + adt[1] + ' ' + adt[5] + '</b>' + ((new Date()).getFullYear() == adt[3] ? '' : ' ' + adt[3]));
				App.controls.task_terms.get_modal_date_diff_range(true);
				if (!App.controls.task_terms.stop_diff_calc_events) $('#datelen').focus_select_desktop();
			} else if (App.controls.task_terms.stop_diff_calc_events && App.helper.validate.number.test($('#datelen').val()) && 1 * $('#datelen').val()) {
				let dt_i = 1 * $('#datelen').val() - 1;
				let dt_s = App.helper.date.from_input(date_st);
				let dt = App.helper.work_days.add(dt_s, dt_i);
				$('#dateend').val(App.helper.date.to_input(dt));
				$('#dateend_nice .end').stop().css({opacity: 1}).html(App.format.date(dt, DATE_EDIT_SHORT));
			} else {
				if (!App.controls.task_terms.stop_diff_calc_events) {
					$('#datelen').val('').focus_desktop();
					$('#datelen2').val('');
				}
				$('#dateend_nice .end').html('_______').blink();
			}
		},
		onselect_date: function (date) {
			$('#dateend').val(date);
			let date_nice = $('#dateend_').val();
			if (date) {
				App.controls.task_terms.helper_option_events('on', 'dt_date');
				let adt = date_nice.split('.');
				$('#dateend_nice .end').html('<font class="w360">' + adt[0] + ' </font><b>' + adt[1] + ' ' + adt[2] + '</b>' + ((new Date()).getFullYear() == adt[3] ? '' : ' ' + adt[3]));
				App.controls.task_terms.get_modal_date_diff(true);
				if (!App.controls.task_terms.stop_diff_calc_events) $('#datelen2').focus_select_desktop();
			} else App.controls.task_terms.helper_option_events('off', 'dt_date');
		},
		init: function(tab) {
			if (tab === App.controls.task_terms.START_END) {
				$("#dateend_div").datepicker({
					rangeSelect: true,
					numberOfMonths: 2,
					altField: '#dateend_',
					altFormat: 'DD.d.LL.yy.D.L.w',
					onSelect: self.onselect_range,
					beforeShowDay: App.controls.datepicker.config.disable_holidays ? App.controls.datepicker.helper_disable_holidays : App.controls.datepicker.helper_draw_holidays
				});
				if (self.config['datestart_js'] && self.config['dateend_js']) {
					$.datepicker._setDateDatepicker($('#dateend_div').get(0), new Date(self.config['datestart_js']), new Date(self.config['dateend_js']));
				} else if (self.config['datestart_js']) {
					$.datepicker._setDateDatepicker($('#dateend_div').get(0), new Date(self.config['datestart_js']), 'free');
				} else {
					$.datepicker._gotoToday('#dateend_div');
				}
			} else {
				$("#dateend_div").datepicker({
					rangeSelect: false,
					numberOfMonths: 2,
					minDate_: self.config['min_date_js'] ? new Date(self.config['min_date_js']) : null,
					maxDate_: self.config['max_date_js'] ? new Date(self.config['max_date_js']) : null,
					defaultDate: self.config['dateend_js'] ? new Date(self.config['dateend_js']) : null,
					altField: '#dateend_',
					altFormat: 'DD.d.LL.yy.D.L.w',
					onSelect: self.onselect_date,
					beforeShowDay: App.controls.datepicker.config.disable_holidays ? App.controls.datepicker.helper_disable_holidays : App.controls.datepicker.helper_draw_holidays
				});
			}
			if (!App.device.is_mobile()) setTimeout(function () {
				$('#dateend_nice .datelen .input').focus_select_desktop();
			}, 100);
		}
	}
})();

;(function() {
	let self = App.controls.project_topic = {
		nameLength: 250,
		obj: null,
		init: function () {
			self.obj = $('.editBlock');
			let textarea = self.obj.find('.editBlock__textarea textarea');
			let tmp = textarea.val();
			textarea.bind('input', function() {
				let counter = self.nameLength - $(this).val().length;
				let text = self.obj.find('.editBlock__text');
				if (counter < 0) {
					if (text.attr('data-text-error')) text.html(text.attr('data-text-error'));
				} else {
					if (text.attr('data-text')) text.html(text.attr('data-text'));
				}
			});
			App.controls.editblock.init({ variant: 'save' });
			textarea.focus().val('').val(tmp);
		}
	}
})();

;(function() {
	let self = App.controls.task_action = {
		deleting_anchor: null,
		deleting: function (anchor, endpoint) {
			this.deleting_anchor = anchor;
			$.getScript(endpoint);
		},
		delete: function (anchor, endpoint, params) {
			params ||= {};

			App.controls.confirm.menu(anchor, {
				message: App.object_state.locale.task_controls.confirm_delete,
				ok_label: App.object_state.locale.yes_delete,
				onconfirm: function () {
					$.getScript(endpoint + '&notify_action='+App.config.notify_action);
				},
				with_notify: params.with_notify ?? true,
				template: 'old',
			});
		},
		delete_comment: function (anchor, endpoint, params) {
			params ||= {};

			App.controls.confirm.menu(anchor, {
				message: App.object_state.locale.task_controls.confirm_delete_comment,
				ok_label: App.object_state.locale.yes_delete,
				with_notify: params.with_notify ?? true,
				onconfirm: () => {
					$.getScript(endpoint);
				}
			});
		},
	}
})();

;(function() {
	let self = App.controls.task_copy = {
		init_datepicker: function(options) {
			options ||= {};
			const onchange = options.onchange;
			App.modal.obj_window.find('input[name^="dateend["]').parent().find('a').on('click', function() {
				let me = this;
				let inp = $(this).parent().find('input');
				let config = {
					rangeSelect: false,
					numberOfMonths: 1,
					monthPicker: true,
					firstDay: App.datepicker_firstDay,
					beforeShowDay: App.controls.datepicker.config.disable_holidays ? App.controls.datepicker.helper_disable_holidays : App.controls.datepicker.helper_draw_holidays,
					onSelect: function(date) {
						$(me).html(date);
						if (typeof onchange === 'function') onchange(inp.get(0));
					}
				};
				if (inp.attr('data-maxdate')) config.maxDate_ = new Date(inp.attr('data-maxdate'));
				if (inp.attr('data-mindate')) config.minDate_ = new Date(inp.attr('data-mindate'));
				inp.datepicker(config).focus();
			});
		},

		init_user_select: function(options) {
			options ||= {};
			const onchange = options.onchange;
			App.modal.obj_window.find('.menu[data-ref=task_copy] .menu__item').bind('click', function () {
				const inp = $(App.menu.active_anchor).next();
				$(App.menu.active_anchor).attr('data-title', $(this).find('.in').text()).html($(this).find('.space-ava').html()).next().val($(this).attr('data-id'));
				if (typeof onchange === 'function') onchange(inp.get(0));
				App.menu.hide();
			});
		},

		init_name_edit: function(options) {
			options ||= {};
			const onchange = options.onchange;
			App.modal.obj_window.find('.modal__dataTable').on('change', '.td_name input', function() {
				if (typeof onchange === 'function') onchange(this, $(this).val());
			});
			App.modal.obj_window.find('.modal__dataTable').on('click', '.td_name a.onch', function() {
				const name = $(this).text();
				const parent = $(this).parent();
				const input = $('<input type="text">')
					.attr('id', 'name['+$(this).attr('data-id')+']')
					.attr('name', 'name['+$(this).attr('data-id')+']')
					.val(name).attr('class', 'input2 wide2').attr('data-skip-enter', true);
				parent.html('').append(input);
				input.focus();
			});
		},

		init: function (options) {
			options ||= {};

			self.init_datepicker(options.datepicker);
			self.init_user_select(options.user_select);
			self.init_name_edit(options.name_edit);
		}
	}
})();

;(function() {
	let self = App.controls.task_done = {
		require_costs: false,
		preset_costs: {
			time: 0,
			money: 0,
		},
		locale: {}, // from template
		validate_form: function () {
			let cost_block = App.modal.obj_window.find('.inputBlock__costs'),
				hours = cost_block.find('input[name="set_time"]'),
				money = cost_block.find('input[name="set_money"]'),
				hoursVal = hours.val(), moneyVal = money.val();

			//if (hoursVal) hoursVal = hoursVal.replace(/\s+/g, '').replace(/[:,\-]/g, '.');
			if (moneyVal) moneyVal = moneyVal.replace(/\s+/g, '').replace(/[:,\-]/g, '.');
			if (cost_block.find('textarea[name="name"]').val() && !parseFloat(hoursVal) && !parseFloat(moneyVal)) {

				if (!parseFloat(hoursVal)) {
					hours.parent().parent().shortblink();
					setTimeout(function() {cost_block.find('#tm_time').focus().val('0:00')}, 500);
				} else if (!parseFloat(moneyVal)) {
					money.parent().parent().shortblink();
					setTimeout(function() {cost_block.find('#tm_money').focus()}, 500);
				}
				cost_block.find('.btns-row ws-btn').shakeRight(3, 3, 300);
				return false;
			}
			return true;
		},

		validate_form_costs: function() {
			if (!$('#tm_time').length && !$('#tm_money').length) {
				return true;
			}
			if ( !$('#tm_time').val() && !$('#tm_money').val() ) {
				$('#tm_time, #tm_money').addClass('input_error');
				$('.inputBlock__costs-warning').show().shortblink();
				return false;
			}
			return true;
		},

		init: function() {

			App.modal.obj_window.find('[data-container=date]').datepicker({
				rangeSelect: false,
				numberOfMonths: 1,
				monthPicker: true,
				firstDay: App.datepicker_firstDay,
				maxDate: new Date(),
				onSelect: function (dateText, inst) {
					App.modal.obj_window.find('[data-container=date]').val(dateText).next().attr('text', dateText);
				},
				beforeShowDay: App.controls.datepicker.config.disable_holidays ? App.controls.datepicker.helper_draw_holidays : null
			});

			App.modal.obj_window.find('[data-container=user]').bind('click', function () {
				App.controls.user_select_and_go.show_context(this, null, {
					load_always: true,
					request: {
						type: 'costs'
					},
					onload: function() {
						$(this).on('click', '.menu__item', function() {
							App.controls.menu.item_set_active(this);
							self.set_user($(this).attr('data-id'), {
								avatar: $(this).find('.space-ava').html(),
								name: App.helper.html.encode($(this).find('.in').text()),
								rate: $(this).attr('data-rate')
							});
							App.menu.hide();
						})
					},
					onshow: function() {
						$(this).find('.menu__item').each(function() {
							$(this).toggleClass('menu__item-active', $(this).attr('data-id') == App.modal.obj_window.find('[data-container=user]').next().val());
						});
					}
				});
			});

			let cost_block = $('.inputBlock__costs');
			cost_block.find('#tm_time').on('change', App.controls.rate.time_to_money);
			cost_block.find('#tm_time, #tm_money, textarea').on('input', function () {
				if ($(this).prop('tagName') === 'INPUT') this.value = this.value.replace(/[^0-9.,:;-]/g, '').replace(/([.,:;].*?)[.,:;]/g, '$1');
				let hours = cost_block.find('input[name="set_time"]').val();
				let money = cost_block.find('input[name="set_money"]').val();
				let done = cost_block.find('textarea[name="name"]').val();
				/*if (!hours && !money && !done) {
					cost_block.removeClass('inputBlock__costs-timeListHide');
				} else {
					cost_block.addClass('inputBlock__costs-timeListHide');
				}*/
			});

			cost_block.find('.inputBlock-tdPlan').on('click', function() {
				if (self.preset_costs.time) {
					$('#tm_time').val(App.helper.time.time2string(self.preset_costs.time)).removeClass('time_input-empty').trigger('blur');
					App.modal.obj_window.find('.inputBlock__costs-warning').hide();
					if ($('#tm_rate').length) $('#tm_rate').val(1).parent().find('.sw_pre').addClass('sw_act').parent().prev().prev().toggleDisabled(false);
					if (!self.preset_costs.money) $('#tm_time').trigger('change').trigger('input');
				}
				if (self.preset_costs.money) {
					$('#tm_money').val(self.preset_costs.money).trigger('blur');
					$('#tm_rate').val(0).parent().find('.sw_pre').removeClass('sw_act').parent().prev().prev().toggleDisabled(true);
					App.modal.obj_window.find('.inputBlock__costs-warning').hide();
				}
			});

			if (self.require_costs) {
				let time_money = $('#tm_time, #tm_money');
				App.modal.obj_window.find('.inputBlock__costs-warning').show();
				time_money.bind('keyup blur', function () {
					let is_ok = false;
					if (/[0-9]{0,3}:[0-9]{2}/.test($('#tm_time').value) && /[1-9.]/.test($('#tm_money').value)) is_ok = true;
					App.modal.obj_window.find('.btns-row').toggleClass('hidden', !is_ok);
				}).bind('focus', function () {
					App.modal.obj_window.find('input:text').removeClass('input_error');
				});
			}

			setTimeout(function() {
				let title = App.modal.obj_window.find('.modal__header > .in');
				let limits_but = App.modal.obj_window.find('#modal__headerAppend');
				if (limits_but.length) {
					title.find('.av_place').remove();
					title.append(limits_but);
				}
				App.fatforms.init();
				App.controls.time_input.init();
			}, 100);
		},

		set_user: function(id, options) {
			options ||= {};
			const avatar = options.avatar || App.helper.team(id, 'avatar');
			const name = options.name || App.helper.team(id, 'name');
			App.modal.obj_window.find('[data-container=user] .space-ava').html(avatar).next().html(name);
			App.modal.obj_window.find('[data-container=user]').parent().next().val(id);

			if (options.rate != null) App.modal.obj_window.find('input[name=rate]').val(options.rate);
		},

		stage_select: function(el) {
			const el_sub = App.modal.obj_window.find('.taskStageList__item[data-type=' + $(el).closest('.menu__group').attr('data-type') + '][data-group=' + $(el).closest('.menu__group').attr('data-group') + ']').hide()
				.filter('[data-id='+ $(el).attr('data-id') +']').show();
			el_sub.find('input').prop('checked', true);
			self.stage_select_sub(el_sub);
		},

		stage_select_sub: function(el) {
			let o = App.modal.obj_window.find('.taskStageList__item-subtask');
			o.find('input').val($(el).attr('data-id'));
			o.find('.in').find('> .tag, > .name, > .div, > .data-toggle, > .data').remove();
			let o_clone = App.modal.obj_window.find('.taskStageList__item[data-id='+$(el).attr('data-id')+']').clone();
			o.find('.in').prepend(o_clone.find('.in').find('> .tag, > .name, > .div, > .data-toggle, > .data'));
			o_clone.remove();
			o.find('.in').find('> .data-toggle').find('ws-icon').last().remove();
			o.find('.in').find('> .data-toggle').attr(
				'data-title',
				$(o.find('.in').find('> .data-toggle').attr('data-title')).find('[data-role=user]').remove().end().prop('outerHTML')
			);
			if ($(el).attr('data-btn-icon')) {
				App.modal.obj_window.find('.buttons ws-btn.ws-btn-type2 .btn-left-icon').attr('name', $(el).attr('data-btn-icon'));
			}
			if ($(el).attr('data-btn-title')) {
				App.modal.obj_window.find('.buttons ws-btn.ws-btn-type2 span').html($(el).attr('data-btn-title'));
				if (App.modal.obj_window.hasClass('.modal-massTaskDone')) self.btn_append_counter();
			}
			App.menu.hide();
		},

		btn_append_counter: function () {
			const cnt = App.modal.obj_window.find('.menuFake .menu__item-task').length;
			const text_el = App.modal.obj_window.find('.buttons ws-btn.ws-btn-type2 span');
			if (text_el.find('i').length) return;
			text_el.append(' <i>('+cnt+')</i>');
		},

		submit: function(form) {
			if (!self.validate_form()) return false;
			if (self.require_costs && !self.validate_form_costs()) return false;
			App.core.form_submit(form);
		},
	}
})();

;(function() {
	let self = App.controls.task_limits_select_and_go = {
		callback: null,
		show: function(endpoint, params) {
			params ||= {}
			self.callback = params.onsuccess;
			App.modal.show({
				url: endpoint,
				width: 450,
				onload: params.onload || null
			});
		},
	}
})();

;(function () {
	let self = App.controls.task_mass = {
		close(ctx, el) {
			App.modal.show({
				url: App.helper.url.add_query(App.mass.action_url('done'), 'ids=' + App.mass.ids['close']),
				title: $(el).attr('data-modal-title') ? $(el).attr('data-modal-title') : $(el).attr('title'),
				group: 'close'
			});
		},
		reopen(ctx, el) {
			App.modal.show({
				url: App.helper.url.add_query(App.mass.action_url('reopen'), 'ids=' + App.mass.ids['reopen']),
				title: $(el).attr('data-modal-title') ? $(el).attr('data-modal-title') : $(el).attr('title'),
				group: 'reopen'
			});
		},
		bill(ctx, el) {
			App.modal.show({
				url: App.helper.url.add_query(App.mass.action_url('bill'), 'ids=' + App.mass.ids['all']),
				title: $(el).attr('data-modal-title') ? $(el).attr('data-modal-title') : $(el).attr('title'),
				group: 'white'
			});
		},
		stage(ctx, el) {
			App.modal.show({
				url: App.helper.url.add_query(App.mass.action_url('stage'), 'ids=' + (App.mass.count['stage_undone'] ? App.mass.ids['stage_undone'] : App.mass.ids['stage_done'])),
				title: $(el).attr('data-modal-title') ? $(el).attr('data-modal-title') : $(el).attr('title'),
				group: 'stage'
			});
		},
		label(ctx, el) {
			App.modal.show({
				url: App.helper.url.add_query(App.mass.action_url('labels'), 'ids=' + App.mass.ids['label']),
				title: $(el).attr('data-modal-title') ? $(el).attr('data-modal-title') : $(el).attr('title'),
				group: 'labels'
			});
		},
		subs(ctx, el) {
			App.modal.show({
				url: App.helper.url.add_query(App.mass.action_url('subs'), 'ids=' + App.mass.ids['act']),
				title: $(el).attr('data-modal-title') ? $(el).attr('data-modal-title') : $(el).attr('title'),
				group: 'subs'
			});
		},
		hidden(ctx, el) {
			App.modal.show({
				url: App.helper.url.add_query(App.mass.action_url('hidden'), 'ids=' + App.mass.ids['act']),
				title: $(el).attr('data-modal-title') ? $(el).attr('data-modal-title') : $(el).attr('title'),
				group: 'hidden'
			});
		},
		term(ctx, el) {
			App.modal.show({
				url: App.helper.url.add_query(App.mass.action_url('terms'), 'ids=' + App.mass.ids['term']),
				title: $(el).attr('data-modal-title') ? $(el).attr('data-modal-title') : $(el).attr('title'),
				group: 'dateend'
			});
		},
		user(ctx, el) {
			App.modal.show({
				url: App.helper.url.add_query(App.mass.action_url('users'), 'ids=' + App.mass.ids['user']),
				title: $(el).attr('data-modal-title') ? $(el).attr('data-modal-title') : $(el).attr('title'),
				group: 'userto'
			});
		},
		copy(ctx, el) {
			App.modal.show({
				url: App.helper.url.add_query(App.mass.action_url('copy'), 'ids=' + App.mass.ids['all']),
				title: $(el).attr('data-modal-title') ? $(el).attr('data-modal-title') : $(el).attr('title'),
				group: ''
			});
		},
		move(ctx, el) {
			App.modal.show({
				url: App.helper.url.add_query(App.mass.action_url('move'), 'ids=' + App.mass.ids['move']),
				title: $(el).attr('data-modal-title') ? $(el).attr('data-modal-title') : $(el).attr('title'),
				group: ''
			});
		},
		delete(ctx, el) {
			App.modal.show({
				url: App.helper.url.add_query(App.mass.action_url('delete'), 'ids=' + App.mass.ids['delete']),
				title: $(el).attr('data-modal-title') ? $(el).attr('data-modal-title') : $(el).attr('title'),
				group: 'delete'
			});
		},
		priority(ctx, el) {
			App.modal.show({
				url: App.helper.url.add_query(App.mass.action_url('priority'), 'ids=' + App.mass.ids['priority']),
				title: $(el).attr('data-modal-title') ? $(el).attr('data-modal-title') : $(el).attr('title'),
				group: 'priority'
			});
		},
		export(ctx, el) {
			App.classes.workflows.export_report.run({delivery: 'download', ids: App.mass.ids['all'].split(',').filter((val) => val.length)});
		}
	}
})();
;(function () {
	let self = App.controls.task_meet = {
		obj: null,

		time_conf: {}, // from template
		date_conf: {}, // from template
		locale: {}, // from template
		config: {
			today: '',
			today_work: 0,
			workday: '',
			time_start: '',
			time_end: '',
			provider_default_duration: {},
		},
		_durationMinutes: null,

		loader: function (state = 'start') {
			App.controls.loader.overlay[state](self.obj);
		},
		date_to_string: function (date, now = false) {
			let date_check = new Date();
			if (App.helper.date.to_format(date, 'ymd') === App.helper.date.to_format(date_check, 'ymd')) {
				return now ? self.locale['now'] : self.locale['today'];
			}
			date_check.setDate(date_check.getDate() + 1);
			if (App.helper.date.to_format(date, 'ymd') === App.helper.date.to_format(date_check, 'ymd')) return self.locale['tomorrow'];
			return App.format.date(date, DATE_DEFAULT);
		},

		onhideTimepicker: function () {
			window.ignore_drophide = true;
			setTimeout(function () {
				window.ignore_drophide = false;
			}, 300);
			let date_check = new Date();
			if (App.helper.date.to_input(date_check) === self.obj.find('input[name=date]').val() && this.value < App.helper.date.to_format(date_check, 'H:i')) {
				let date = new Date();
				date.setMinutes(date.getMinutes() + 1);
				self.obj.find('input[name=date]').val(App.helper.date.to_input(date)).next().html(self.date_to_string(date));
				self.obj.find('input[name=timestart]').val(App.helper.date.to_format(date, 'H:i'));
			}
		},

		onShowTimepicker: function () {
			const input = $(this);
			const timepicker_list = input.data('timepickerList');
			if (!timepicker_list) return;

			timepicker_list.find('.ui-timepicker-disabled').toggleClass('ui-timepicker-disabled ui-timepicker-disabled-fake');

			if (!self.time_conf.minWorkTime && !self.time_conf.maxWorkTime) return;
			if (self.time_conf.workHoursRestrict !== true) return;

			const toMinutes = function(timeStr) {
				let [h, m] = timeStr.split(':').map(Number);
				return h * 60 + m;
			};
			const minWorkTimeMinutes = self.time_conf.minWorkTime ? toMinutes(self.time_conf.minWorkTime) : 0;
			const maxWorkTimeMinutes = self.time_conf.maxWorkTime ? toMinutes(self.time_conf.maxWorkTime) : 24 * 60;

			timepicker_list.find('li .in').each(function () {
				const list_time = $(this).html();
				const listTimeMinutes = toMinutes(list_time);
				if (listTimeMinutes < minWorkTimeMinutes || listTimeMinutes > maxWorkTimeMinutes) {
					$(this).parent().removeClass('ui-timepicker-disabled-fake').addClass('ui-timepicker-disabled');
				}
			});
		},

		show_menu: function (el) {
			App.menu.show({
				anchor: el,
				box: '#taskMeet__users',
				type: 'left text'
			});
		},
		get_default_duration_quarters: function (type = null) {
			const providerType = parseInt(type || self.obj.find('input[name=type]').val(), 10);
			const duration = self.config.provider_default_duration && self.config.provider_default_duration[providerType];
			return parseInt(duration, 10) || 4;
		},
		_get_duration_minutes: function () {
			if (self._durationMinutes != null && self._durationMinutes >= 15) return self._durationMinutes;
			const te = self.obj.find('input[name=timeend]').val();
			const ts = self.obj.find('input[name=timestart]').val();
			if (ts && te) {
				const sp = App.helper.parseTime(ts);
				const ep = App.helper.parseTime(te);
				const d = (ep.hours * 60 + ep.minutes) - (sp.hours * 60 + sp.minutes);
				return d >= 15 ? d : 15;
			}
			return self.get_default_duration_quarters() * 15;
		},
		_apply_end_from_start_and_duration: function () {
			const timestart = self.obj.find('input[name=timestart]').val();
			if (!timestart) return;
			const duration = self._get_duration_minutes();
			self._durationMinutes = duration;
			const [hours, minutes] = timestart.split(':').map(Number);
			const endDate = new Date();
			endDate.setHours(hours, minutes, 0, 0);
			endDate.setMinutes(endDate.getMinutes() + duration);
			self.obj.find('input[name=timeend]').val(App.helper.date.to_time(endDate));
		},
		apply_default_duration: function () {
			const meetId = parseInt(App.modal.obj_window.find('input[name=id]').val(), 10) || 0;
			if (meetId) return;

			const timestart = self.obj.find('input[name=timestart]').val();
			if (!timestart) return;

			const [hours, minutes] = timestart.split(':').map(Number);
			const timeend = new Date();
			timeend.setHours(hours, minutes, 0, 0);
			timeend.setMinutes(timeend.getMinutes() + self.get_default_duration_quarters() * 15);

			self.obj.find('input[name=timeend]').val(App.helper.date.to_time(timeend));
			self._durationMinutes = self.get_default_duration_quarters() * 15;
			self.helper_time_start_end(self.obj.find('input[name=timestart]'));
		},
		init: function () {
			self.obj = $('#taskMeet');
			self.obj.find('input[name=timestart]').timepicker(self.time_conf)
				.bind('hideTimepicker', function () { self.onhideTimepicker.call(this); })
				.bind('showTimepicker', function () { self.onShowTimepicker.call(this); })
				.on('change', function () {
					if ($(this).val().trim() == '' && $(this).attr('data-defaultTime')) {
						$(this).val($(this).attr('data-defaultTime'));
					}
					const timestart = $(this).val();
					if (timestart) {
						self._apply_end_from_start_and_duration();
					}
				});
			self.obj.find('input[name=timeend]').timepicker(self.time_conf)
				.bind('hideTimepicker', function () { self.onhideTimepicker.call(this); })
				.bind('showTimepicker', function () { self.onShowTimepicker.call(this); })
				.on('change', function () {
					if ($(this).val().trim() == '' && $(this).attr('data-defaultTime')) {
						$(this).val($(this).attr('data-defaultTime'));
					}
				});
			self.obj.find('input[name=date]').datepicker($.extend({
				rangeSelect: false,
				numberOfMonths: 1,
				monthPicker: true,
				firstDay: App.datepicker_firstDay,
				minDate: new Date(self.locale['today_mdy']),
				minDate_: new Date(self.locale['today_mdy']),
				maxDate: new Date(self.locale['month_mdy']),
				maxDate_: new Date(self.locale['month_mdy']),
				onSelect: self.set_date,
				onClose: function () {
					window.ignore_drophide = true;
					setTimeout(function () {
						window.ignore_drophide = false;
					}, 300);
				},
				beforeShowDay: function (date) {
					let override_class = '';
					let override_title = '';
					let override_weekend = '';
					let date_str = App.helper.date.to_input(date);
					if (App.controls.datepicker.config.holidays && (date_str in App.controls.datepicker.config.holidays)) {
						override_weekend = 'holiday';
						override_class = 'ui-datepicker-holiday ';
						override_title = self.locale['holiday']
					}
					return [true, override_class, override_title, override_weekend];
				}
			}, Object.fromEntries(
				Object.entries(self.date_conf).map(([key, value]) =>
					(key === "maxDate" || key === "minDate" || key === "maxDate_" || key === "minDate_") ? [key, new Date(value)] : [key, value]
				)
			)));

			const meetId = parseInt(App.modal.obj_window.find('input[name=id]').val(), 10) || 0;
			const selectedDate = self.obj.find('input[name=date]').val();
			if (selectedDate === App.helper.date.to_input(new Date())) {
				self.set_date(selectedDate, false, !!meetId);
			}

			App.modal.obj_window.find('.btn-delete').on('click', function () {

				const url = $(this).closest('form').attr('action');
				const id = $(this).closest('form').find('input[name=id]').val();
				const endpoint = App.helper.url.add_query(url, App.actions.get('task_meet:delete'), {
					id,
					is_ajax: 'modal'
				});

				App.controls.confirm.menu(this, {
					ok_label: App.object_state.locale.yes_delete,
					message: App.object_state.locale.ask_delete,
					onconfirm: function () {
						self.loader();
						$.ajax({
							url: endpoint,
							dataType: 'script',
							complete: function () {
								self.loader('stop');
							}
						});
					}
				})
			});

			const input = App.modal.obj_window.find('input[name="ids"]');

			App.controls.editBlock_picker.init(
				App.modal.obj_window.find('#menuTaskMeetMembers'),
				App.modal.obj_window.find('.editBlock__picker-fake'),
				function (ids) {
					App.controls.editblock.set_updated_state();
					input.val(ids.join(','));
					self.users._render_label_once();
				}
			);
			$('.timepicker').on('change', function() {
				self.helper_time_start_end($(this));
			});
			const ts = self.obj.find('input[name=timestart]').val();
			const te = self.obj.find('input[name=timeend]').val();
			if (ts && te) {
				const sp = App.helper.parseTime(ts);
				const ep = App.helper.parseTime(te);
				const d = (ep.hours * 60 + ep.minutes) - (sp.hours * 60 + sp.minutes);
				self._durationMinutes = d >= 15 ? d : 15;
			}
			self.helper_timepicker_limit();

			App.fatforms.init();
		},
		set_date: function (date_str, now = false, preserveTimeValues = false) {
			App.modal.obj_window.find('input[name=now]').val('');
			self.obj.find('.taskMeet__time').show();
			let date = App.helper.date.from_input(date_str);
			let date_check = new Date();
			if (App.helper.date.to_format(date, 'ymd') === App.helper.date.to_format(date_check, 'ymd')) {
				date = new Date();

				let step = parseInt(self.time_conf.step, 10) || 15; // just in case
				let minAdd = 1; // min + 1 minute

				let currentMinutes = date.getHours() * 60 + date.getMinutes();

				let nextSlot = Math.ceil((currentMinutes + minAdd) / step) * step;
				let minutesToAdd = nextSlot - currentMinutes;

				date.setMinutes(date.getMinutes() + minutesToAdd);

				// Calculate max time for timestart (end of working day minus 15 minutes)
				let maxStartTime = self.time_conf.show2400 === 'true' ? '24:00' : '23:' + String(60 - self.time_conf.step);
				if (self.time_conf.workHoursRestrict && self.config.time_end) {
					let endTime = App.helper.parseTime(self.config.time_end);
					let timeDate = new Date();
					timeDate.setHours(endTime.hours, endTime.minutes - 15, 0);
					if (timeDate.getMinutes() < 0) {
						timeDate.setHours(timeDate.getHours() - 1);
						timeDate.setMinutes(timeDate.getMinutes() + 60);
					}
					maxStartTime = App.format.digits_2(timeDate.getHours()) + ':' + App.format.digits_2(timeDate.getMinutes());
				}

				self.obj.find('input[name=timestart]').timepicker('option', {
					'minTime': date.getHours() + ':' + String(date.getMinutes()).padStart(2, '0'),
					'maxTime': maxStartTime
				});
				self.obj.find('input[name=timeend]').timepicker('option', {
					'minTime': date.getHours() + ':' + String(date.getMinutes()).padStart(2, '0'),
					'maxTime': self.time_conf.show2400 === 'true' ? '24:00' : '23:' + String(60 - self.time_conf.step)
				});
				if(now) self.obj.find('.taskMeet__time').hide();
			} else {
				// Calculate max time for timestart (end of working day minus 15 minutes)
				let maxStartTime = self.time_conf.show2400 === 'true' ? '24:00' : '23:' + String(60 - self.time_conf.step);
				if (self.time_conf.workHoursRestrict && self.config.time_end) {
					let endTime = App.helper.parseTime(self.config.time_end);
					let timeDate = new Date();
					timeDate.setHours(endTime.hours, endTime.minutes - 15, 0);
					if (timeDate.getMinutes() < 0) {
						timeDate.setHours(timeDate.getHours() - 1);
						timeDate.setMinutes(timeDate.getMinutes() + 60);
					}
					maxStartTime = App.format.digits_2(timeDate.getHours()) + ':' + App.format.digits_2(timeDate.getMinutes());
				}
				
				self.obj.find('input[name=timestart]').timepicker('option', {
					'minTime': self.time_conf.minTime,
					'maxTime': maxStartTime
				});
				self.obj.find('input[name=timeend]').timepicker('option', {
					'minTime': self.time_conf.minTime
				});

				let t = App.helper.parseTime(self.config.time_start);

				date.setHours(t.hours);
				date.setMinutes(t.minutes);

			}

			self.obj.find('input[name=date]').val(date_str).next().html(self.date_to_string(date, now));
			if (!preserveTimeValues) {
				self.obj.find('input[name=timestart]').val(App.helper.date.to_format(date, 'H:i'));
				self.obj.find('input[name=timestart]').val(App.helper.date.to_time(date));
				self.obj.find('input[name=timeend]').val(
					App.helper.date.to_time(new Date(date.getTime() + self.get_default_duration_quarters() * 15 * 60 * 1000))
				);
				self._durationMinutes = self.get_default_duration_quarters() * 15;
			}
		},
		submit: function (form) {
			if (!$(form).find('input[name=ids]').val() || $(form).find('.btn-ok').hasClass('btn-disabled')) {

				self.users._render_label_empty();
				$(form).find('.btn-primary').animate_css('head-shake');

				return false;
			}

			self.loader();
			App.core.form_submit(form);
		},

		helper_time_start_end: function (el) {
			let time = el.val() || '';
			let name = el.attr('name') || el[0]?.name;
			let timeDate = new Date();
			
			// Calculate max time for timestart (end of working day minus 15 minutes)
			let maxStartTime = '24:00';
			if (self.time_conf.workHoursRestrict && self.config.time_end) {
				let endTime = App.helper.parseTime(self.config.time_end);
				timeDate.setHours(endTime.hours, endTime.minutes - 15, 0);
				if (timeDate.getMinutes() < 0) {
					timeDate.setHours(timeDate.getHours() - 1);
					timeDate.setMinutes(timeDate.getMinutes() + 60);
				}
				maxStartTime = App.format.digits_2(timeDate.getHours()) + ':' + App.format.digits_2(timeDate.getMinutes());
			}
			
			if (name === 'timestart') {
				if (time !== '') {
					let [hours, minutes] = time.split(':').map(Number);
					timeDate.setHours(hours, minutes + 15, 0);
					let newTime = timeDate.toTimeString().substring(0, 5);
					if (newTime === '00:00') newTime = '24:00';
					
					// Set maxTime for timestart to end of working day minus 15 minutes
					$("#taskMeet__dates input[name=timestart]").timepicker('option', {
						'maxTime': maxStartTime
					});
					
					// Set minTime for timeend and auto-adjust if needed
					$("#taskMeet__dates input[name=timeend]").timepicker('option', {
						'minTime': newTime,
						'maxTime': '24:00'
					});
					
					// Auto-adjust timeend if it's less than timestart + 15 minutes
					let currentTimeend = self.obj.find('input[name=timeend]').val();
					if (currentTimeend) {
						let [endHours, endMinutes] = currentTimeend.split(':').map(Number);
						let endTimeMinutes = endHours * 60 + endMinutes;
						let minEndTimeMinutes = hours * 60 + minutes + 15;
						
						if (endTimeMinutes < minEndTimeMinutes) {
							let adjustedTime = new Date();
							adjustedTime.setHours(hours, minutes + 15, 0);
							let adjustedTimeStr = App.format.digits_2(adjustedTime.getHours()) + ':' + App.format.digits_2(adjustedTime.getMinutes());
							self.obj.find('input[name=timeend]').val(adjustedTimeStr);
						}
					}
				} else {
					$("#taskMeet__dates input[name=timestart]").timepicker('option', {
						'maxTime': maxStartTime
					});
					$("#taskMeet__dates input[name=timeend]").timepicker('option', self.config.timeend || self.time_conf);
				}
			} else if (name === 'timeend') {
				if (time !== '') {
					const ts = self.obj.find('input[name=timestart]').val();
					if (ts) {
						const sp = App.helper.parseTime(ts);
						const ep = App.helper.parseTime(time);
						const d = (ep.hours * 60 + ep.minutes) - (sp.hours * 60 + sp.minutes);
						self._durationMinutes = d >= 15 ? d : 15;
					}
					let [hours, minutes] = time.split(':').map(Number);
					timeDate.setHours(hours, minutes - 15, 0);
					let newTime = timeDate.toTimeString().substring(0, 5);
					// Don't limit timestart by timeend, only by working day end
					$("#taskMeet__dates input[name=timestart]").timepicker('option', {
						'maxTime': maxStartTime
					});
				} else {
					$("#taskMeet__dates input[name=timestart]").timepicker('option', {
						'maxTime': maxStartTime
					});
				}
			}
		},

		helper_timepicker_limit: function () {
			self.helper_time_start_end(self.obj.find('input[name=timestart]'));
			self.helper_time_start_end(self.obj.find('input[name=timeend]'));
		},

		users: {
			_render_label_once: function () {
				if (!$('#taskMeet > .editBlock__picker-users .editBlock__picker__header .label').hasClass('label-error')) return;
				$('#taskMeet > .editBlock__picker-users .editBlock__picker__header .label')
					.add('#menuTaskMeetMembers .editBlock__picker-users .editBlock__picker__header .label')
					.replaceWith(App.helper.template.fill('editBlock_picker_label', {
						label: self.locale.user_picker_label,
						count: ''
					}));
			},

			_render_label_empty: function () {
				$('#taskMeet > .editBlock__picker-users .editBlock__picker__header .label')
					.add('#menuTaskMeetMembers .editBlock__picker-users .editBlock__picker__header .label')
					.replaceWith(App.helper.template.fill('editBlock_picker_label_error', {
						label: self.locale.user_picker_label_empty
					}));
			},
		},
		show_datepicker: function () {
			self.obj.find('input[name=date]').datepicker('show');
			App.menu.hide();
		},
		popup_handler: function (popup_url, providerType = null) {
			if(!popup_url || !providerType) return;

			const w = App.core.popup(popup_url, '_popup', 800, 600);
			let messageReceived = false;

			// One-time message handler
			const handler = function (event) {
				if (!event.data) return;

				let data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
				if (!data || !data.message) return;

				messageReceived = true;
				window.removeEventListener('message', handler);

				// Hide button on success, show on error
				if(providerType === App.object_state.locale['TYPE_TEAMS']) self.auth_btn_state(data.status !== 'success');

				if (data.status === 'success' && data.auth_source === 'admin' && Number(data.source) === App.object_state.locale['TYPE_GOOGLE']) {
					$('#setup_google_meet .setupBlock').removeClass('setupBlock__muted');
					$('#google_meet_switch').addClass('sw_act sw_act_saved');
				}
				const messageMethod = App.message[data.status] || App.message.success;
				messageMethod.call(App.message, data.message);

				if (data.auth_source === 'task') {
					self.loader('stop');
					if (data.status !== 'success') return;
					self.reload_task_meets_fragment(data.id_task);
					if (data.join_url) {
						App.core.new_window(data.join_url);
						return;
					}
					if (App.modal.is_shown()) {
						const form = App.modal.obj_window.find('form').get(0);
						if (form) self.submit(form);
					}
				}
			};

			window.addEventListener('message', handler);

			// Check for manual close only
			const t = setInterval(function () {
				if (!w || w.closed) {
					clearInterval(t);
					window.removeEventListener('message', handler);
					if (!messageReceived) {
						App.message.error(App.object_state.locale['auth_popup_closed'][providerType]);
						if(providerType === App.object_state.locale['TYPE_TEAMS']) self.auth_btn_state(true);
						self.loader('stop');
					}
				}
			}, 500);
		},
		reload_task_meets_fragment: function (idTask) {
			idTask = parseInt(idTask, 10);
			if (!(idTask > 0)) return;

			for (let cUrl in App.task_view_cache.data) {
				let td = App.task_view_cache.data[cUrl];
				if (td.id !== idTask) continue;
				App.helper.reload_html_fragment(td.url, $(td.obj_window), '.taskView__params__item[data-key=meets]', function () {
					if (App.task_view.is_shown() && App.task_view.id === idTask) {
						App.task_view.meets.init();
					}
				});
			}
		},
		auth_btn_state: function (show) {
			$('.setupBlock__teams').toggleClass('hidden', !show);
		},
	}
})();

;(function() {
	let self = App.controls.task_menu = {
		id: 0,
		show: function (anchor, endpoint, params) {
			params ||= {}
			params['request'] ||= {};
			App.menu.show({
				anchor: anchor,
				url: endpoint + '?' + App.actions.get('task_menu:show') + '&' + $.param(params['request']),
				backup: params.backup || false,
				replace: params.replace || false,
				onhide: params.onhide || null,
				type: params.type || 'fixed right',
				class: 'menu-autoWidthMax',
				onload: self.init,
				onshow: self.onshow,
			});
		},
		init: function () {

		},
		onshow: function () {
			let task_buts = $(this).find('.menu__group-taskButs');
			if (App.timer.is_active(task_buts.attr('data-task'))) {
				task_buts.find('ws-btn[name*=start_timer]').addClass('hiddenBlock');
				task_buts.find('ws-btn[name*=stop_timer]').removeClass('hiddenBlock');
			} else {
				task_buts.find('ws-btn[name*=start_timer]').removeClass('hiddenBlock');
				task_buts.find('ws-btn[name*=stop_timer]').addClass('hiddenBlock');
			}
		}
	}
})();

;(function() {
	let self = App.controls.task_name = {
		obj: null,
		init: function () {
			self.obj = $('.editBlock');
			let input = self.obj.find('.editBlock__input input');
			let apply = self.obj.find('.editBlock__buttons-right .btn-ok')
			let tmp = input.val();
			input.focus().val('').val(tmp);

			App.controls.editblock.init({ variant: 'save' });
			App.controls.editblock.on('ok', function () {
				apply.click();
			})
		}
	}
})();

;(function () {
	let self = App.controls.task_quick_menu = {
		data: {},

		show: function (anchor, id_task, params) {
			params ||= {}

			self.data = { anchor, id_task, id_user: params.id_user || App.me.id };

			const url = window.location.origin + App.helper.url.task(id_task);
			const box = '#quickTaskMenu';
			const menu = $(box);

			const is_current_view = String(App.task_view.id) === String(id_task);
			const is_from_current_view = Boolean(is_current_view && App.task_view.is_shown() && App.task_view.obj_window.get(0).contains(anchor));
			if (is_current_view && is_from_current_view && params.name == null) {
				params.name = $('.taskView .taskView__name').text().trim();
			}

			const visible = {
				link: true,
				id: true,
				name: params.name != null && params.no_access !== true,
				open: !is_from_current_view && params.no_access !== true,
			};

			Object.entries(visible).forEach(function ([key, is_visible]) {
				menu.find(`.menu__item[data-key=${key}]`).toggleClass('menu__item-hidden', !is_visible);
			});

			menu.find('.menu__item[data-key=id]').attr('data-copy-val', '#' + id_task);
			menu.find('.menu__item[data-key=link]').attr('data-copy-val', url);
			menu.find('.menu__item[data-key=name]').attr('data-copy-val', params.name || null);

			App.menu.show({
				anchor: anchor,
				type: params.type || 'left',
				replace: params.replace || false,
				backup: params.backup || false,
				box: box,
				width: 350,
				force_dropdown: true,
			});
		},

		onLogin: function () {
			let menu = $('#quickTaskMenu');
			menu.on('click','[data-key]', function() {
				const { anchor, id_task, id_user } = self.data;
				switch ($(this).attr('data-key')) {
					case 'open':
						App.menu.hide();
						App.core.goto(App.helper.url.task(id_task));
						break;
					case 'id':
					case 'link':
					case 'name':
						const val = $(this).attr('data-copy-val');
						if (val == null || val.trim() === '') {
							$(this).animate_css('head-shake');
							return;
						}
						App.core.clipboard_from_menu(this, val);
						break;
				}
			});
		},

		destructor: function() {
			self.data = {};
		},
		onLogout: () => self.destructor(),
	};
})();

;(function() {
	let self = App.controls.task_reminder = {
		obj: null,

		time_conf: {}, // from template
		date_conf: {}, // from template
		locale: {}, // from template
		config: {
			today: '',
			today_work: 0,
			workday: '',
			time_start: '',
			time_end: '',
		},

		date_to_string: function (date) {
			let date_check = new Date();
			if (App.helper.date.to_format(date, 'ymd') === App.helper.date.to_format(date_check, 'ymd')) return self.locale['today'];
			date_check.setDate(date_check.getDate() + 1);
			if (App.helper.date.to_format(date, 'ymd') === App.helper.date.to_format(date_check, 'ymd')) return self.locale['tomorrow'];
			return App.format.date(date, DATE_DEFAULT);
		},

		onhideTimepicker: function () {
			window.ignore_drophide = true;
			setTimeout(function () {
				window.ignore_drophide = false;
			}, 300);
			let date_check = new Date();
			if (App.helper.date.to_input(date_check) === $('#taskReminder__dates input[name=date]').val() && this.value < App.helper.date.to_format(date_check, 'H:i')) {
				let date = new Date();
				date.setMinutes(date.getMinutes() + 10);
				$('#taskReminder__dates input[name=date]').val(App.helper.date.to_input(date)).next().html(self.date_to_string(date));
				$('#taskReminder__dates input[name=time]').val(App.helper.date.to_format(date, 'H:i'));
			}
		},

		onShowTimepicker: function () {
			const timepicker_list = $('#taskReminder__dates input[name=time]').data('timepickerList');
			timepicker_list && timepicker_list.find('.ui-timepicker-disabled').toggleClass('ui-timepicker-disabled ui-timepicker-disabled-fake');
		},

		show_menu: function (el) {
			App.menu.show({anchor: el, box: '#taskReminder__users', type: 'left text'});
		},
		init: function () {
			self.obj = $('#taskReminder');
			$('#taskReminder__dates input[name=time]').timepicker(self.time_conf)
				.bind('hideTimepicker', () => self.onhideTimepicker.call(this))
				.bind('showTimepicker', () => self.onShowTimepicker.call(this))
				.on('change', function () {
					if ($(this).val().trim() == '' && $(this).attr('data-defaultTime')) {
						$(this).val($(this).attr('data-defaultTime'));
					}
				});
			$('#taskReminder__dates input[name=date]').datepicker($.extend({
				rangeSelect: false,
				numberOfMonths: 1,
				monthPicker: true,
				firstDay: App.datepicker_firstDay,
				minDate: new Date(self.locale['today_mdy']),
				minDate_: new Date(self.locale['today_mdy']),
				maxDate: new Date(self.locale['month_mdy']),
				maxDate_: new Date(self.locale['month_mdy']),
				onSelect: self.set_date,
				onClose: function () {
					window.ignore_drophide = true;
					setTimeout(function () {
						window.ignore_drophide = false;
					}, 300);
				},
				beforeShowDay: function (date) {
					let override_class = '';
					let override_title = '';
					let override_weekend = '';
					let date_str = App.helper.date.to_input(date);
					if (App.controls.datepicker.config.holidays && (date_str in App.controls.datepicker.config.holidays)) {
						override_weekend = 'holiday';
						override_class = 'ui-datepicker-holiday ';
						override_title = self.locale['holiday']
					}
					return [true, override_class, override_title, override_weekend];
				}
			}, Object.fromEntries(
				Object.entries(self.date_conf).map(([key, value]) =>
					(key === "maxDate" || key === "minDate" || key === "maxDate_" || key === "minDate_") ? [key, new Date(value)] : [key, value]
				)
			)));

			App.modal.obj_window.find('.btn-delete').on('click', function () {

				const url = $(this).closest('form').attr('action');
				const id = $(this).closest('form').find('input[name=id]').val();
				const endpoint = App.helper.url.add_query(url, App.actions.get('task_reminder:delete'), {
					id,
					is_ajax: 'modal'
				});

				App.controls.confirm.menu(this, {
					ok_label: App.object_state.locale.yes_delete,
					message: App.object_state.locale.ask_delete,
					onconfirm: function () {
						$.getScript(endpoint);
					}
				})
			});

			const input = App.modal.obj_window.find('input[name="ids"]');

			App.controls.editBlock_picker.init_bigSwitch(
				App.modal.obj_window.find('.editBlock__picker-fake'),
				App.modal.obj_window.find('.editBlock__bigSwitch'),
				{input}
			);

			App.controls.editBlock_picker.init(
				App.modal.obj_window.find('#menuTaskReminderMembers'),
				App.modal.obj_window.find('.editBlock__picker-fake'),
				function (ids) {
					App.controls.editblock.set_updated_state();
					input.val(ids.join(','));
					self.users._render_label_once();
				}
			);

			App.fatforms.init();
		},
		set_date: function (date_str) {
			App.modal.obj_window.find('input[name=is_relate]').val(0);
			App.modal.obj_window.find('input[name=relate_shift]').val(0);
			let date = App.helper.date.from_input(date_str);
			let date_check = new Date();
			if (App.helper.date.to_format(date, 'ymd') === App.helper.date.to_format(date_check, 'ymd')) {
				date = new Date();

				let step = parseInt(self.time_conf.step, 10) || 15; // на всяк випадок
				let minAdd = 5; // мінімум +5 хвилин

				let currentMinutes = date.getHours() * 60 + date.getMinutes();

				let nextSlot = Math.ceil((currentMinutes + minAdd) / step) * step;
				let minutesToAdd = nextSlot - currentMinutes;

				date.setMinutes(date.getMinutes() + minutesToAdd);

				$('#taskReminder__dates input[name=time]').timepicker('option',  {
					'minTime': date.getHours() + ':' + String(date.getMinutes()).padStart(2, '0'),
					'maxTime': self.time_conf.show2400 === 'true' ? '24:00' : '23:'+String(60-self.time_conf.step)
				});
			} else {
				$('#taskReminder__dates input[name=time]').timepicker('option',  {
					'minTime': self.time_conf.minTime
				});

				let t = App.helper.parseTime(self.config.time_start);
				date.setHours(t.hours);
				date.setMinutes(t.minutes);
			}
			$('#taskReminder__dates input[name=date]').val(date_str).next().html(self.date_to_string(date));
			$('#taskReminder__dates input[name=time]').val(App.helper.date.to_time(date));
		},
		set_relation: function (date_str, text, type, days) {
			App.modal.obj_window.find('input[name=is_relate]').val(type);
			App.modal.obj_window.find('input[name=relate_shift]').val(days);
			let date = App.helper.date.from_input(date_str);
			$('#taskReminder__dates input[name=date]').val(date_str).next().html(text);
		},
		submit: function (form) {
			if (!$(form).find('input[name=ids]').val() || $(form).find('.btn-ok').hasClass('btn-disabled')) {

				self.users._render_label_empty();
				$(form).find('.btn-primary').animate_css('head-shake');

				return false;
			}
			App.core.form_submit(form);
		},
		users: {
			_render_label_once: function () {
				if (!$('#taskReminder > .editBlock__picker-users .editBlock__picker__header .label').hasClass('label-error')) return;
				$('#taskReminder > .editBlock__picker-users .editBlock__picker__header .label')
					.add('#menuTaskReminderMembers .editBlock__picker-users .editBlock__picker__header .label')
					.replaceWith(App.helper.template.fill('editBlock_picker_label', {
						label: self.locale.user_picker_label,
						count: ''
					}));
			},

			_render_label_empty: function () {
				$('#taskReminder > .editBlock__picker-users .editBlock__picker__header .label')
					.add('#menuTaskReminderMembers .editBlock__picker-users .editBlock__picker__header .label')
					.replaceWith(App.helper.template.fill('editBlock_picker_label_error', {
						label: self.locale.user_picker_label_empty
					}));
			},
		},
		show_datepicker: function () {
			$('#taskReminder__dates input[name=date]').datepicker('show');
			App.menu.hide();
		}
	}
})();

;(function() {

	const REPEAT_DAYS_NUM = 0;
	const REPEAT_WEEKLY = 1;
	const REPEAT_MONTHLY = 2;
	const REPEAT_QUARTERLY = 3;
	const REPEAT_YEARLY = 4;
	let self = App.controls.task_repeat = {
		date_start: 0,
		date_end: 0,
		days: 0,
		numrepeat: 0,
		repeat_block_html: {},
		allow_intersect: false,

		next_date: function () {
			let dt_a = self.date_start.clone();
			let dt_a_ = null;
			let dt_return = null;
			if (!self.today_dt) {
				self.today_dt = new Date();
				self.today_dt.setHours(0);
				self.today_dt.setMinutes(0);
				self.today_dt.setSeconds(0);
				self.today_dt.setMilliseconds(0);
			}
			let task_dateend = self.allow_intersect ? self.date_start.clone() : self.date_end.clone();
			let task_datestart = dt_a.clone();
			if (self.today_dt.getTime() > task_dateend.getTime()) task_dateend = self.today_dt.clone();
			let rep_num = /^[1-9]\d*$/.test($('#rep_num').val()) ? 1 * $('#rep_num').val() : 1;
			let try_num;
			switch (1 * $('#rep_type').val()) {
				case REPEAT_DAYS_NUM: // Days
					return App.helper.work_days.add(task_dateend, rep_num);
					break;
				case REPEAT_WEEKLY: // Weeks
					while (dt_a.getDay() != 1) // Monday
					{
						dt_a.setDate(dt_a.getDate() - 1);
					}
					if ($('#rep_wday').val().indexOf(',') === -1) dt_a.setDate(dt_a.getDate() + 7 * rep_num);
					try_num = 0;
					while (try_num < 50) {
						$('#rep_wday').val().split(',').forEach(function (wday) {
							wday = 1 * wday - 1;
							dt_a_ = dt_a.clone();
							if (wday > 0) dt_a_.setDate(dt_a_.getDate() + wday);
							if (dt_a_.getTime() >= task_dateend.getTime() && dt_a_.getTime() > task_datestart.getTime()) {
								if (!dt_return) dt_return = dt_a_.clone();
							}
						});
						if (dt_return) return dt_return;
						dt_a.setDate(dt_a.getDate() + 7 * rep_num);
						try_num++;
					}
					break;
				case REPEAT_MONTHLY: // Months
				case REPEAT_QUARTERLY: // Quarter
				case REPEAT_YEARLY: // Years
					let dt_multy = 1;
					if (1 * $('#rep_type').val() === REPEAT_QUARTERLY) dt_multy = 3;
					if (1 * $('#rep_type').val() === REPEAT_YEARLY) dt_multy = 12;
					dt_multy = dt_multy * rep_num;
					dt_a.setDate(1); // 1st day of the month
					if ($('#rep_mday').val().indexOf(',') === -1) dt_a.setMonth(dt_a.getMonth() + dt_multy);
					try_num = 0;
					while (try_num < 50) {
						$('#rep_mday').val().split(',').forEach(function (mday) {
							mday = 1 * mday;
							dt_a_ = dt_a.clone();
							if (mday > 0) {
								dt_a_.setDate(mday);
								if (dt_a_.getMonth() != dt_a.getMonth()) {
									dt_a_.setMonth(dt_a_.getMonth() + 1);
									dt_a_.setDate(0);
								}
							} else {
								dt_a_.setMonth(dt_a.getMonth() + 1);
								dt_a_.setDate(1 + mday);
							}
							if (dt_a_.getTime() >= task_dateend.getTime() && dt_a_.getTime() > task_datestart.getTime()) {
								if (!dt_return) dt_return = dt_a_.clone();
							}
						});
						if (dt_return) return dt_return;
						dt_a.setMonth(dt_a.getMonth() + dt_multy);
						try_num++;
					}
					break;
				default:
			}
			return self.date_start;
		},

		update_names: function () {
			self.date_start = App.helper.date.from_input($('#datestart').val() ? $('#datestart').val() : $('#dateend').val());
			self.date_end = App.helper.date.from_input($('#dateend').val() ? $('#dateend').val() : $('#datestart').val());
			self.days = App.helper.work_days.diff(self.date_start, self.date_end, true);
			let dt_txt = '';
			$('.modalTerms__params__item #dt_rep').once_by_criteria('bind_menus').on('click', '.formSimple + span', function (){
				App.menu.show({
					anchor: this,
					box: '#drop_drepeatmenu',
					onshow: function() {
						$(this).find('.menu__group').first().addClass('menu__group-hidden');
					},
					onhide: function () {
						$(this).find('.menu__group').first().removeClass('menu__group-hidden');
					},
				});
			});
			$('#rep_namemenu .menu__group .item').each(function () {
				self.numrepeat = 1 * $(this).attr('rel') + 1 * $('#rep_name').attr('data-numrepeat') - 1;
				let prev_date_start = self.date_start.clone();
				self.date_start = self.next_date();
				self.date_end = self.date_start.clone();
				if (self.days > 1) self.date_end = App.helper.work_days.add(self.date_end, self.days - 1);
				let rep_this_name = $('#rep_name').val() ? $('#rep_name').val() : $('#rep_name').attr('rel');
				let rep_slice_pos = rep_this_name.search(/%(n+|[dmyqDMYQ]+)/);
				rep_this_name = App.helper.html.encode(rep_this_name.replace(/%(n+|[dmyqDMYQ]+)(([\+\-])(\d+))?/g, self.prepare_name));
				const rep_length = 60;
				if (rep_this_name.length>rep_length) {
					let first_slice = rep_this_name.substring(0, rep_slice_pos);
					let second_slice = rep_this_name.substring(rep_slice_pos);
					let ellipsis = '… ', fp = '', sp = '', start = 0, end = first_slice.length - 1;
					while (start <= end) {
						fp = fp + first_slice[start];
						sp = first_slice[end] + sp;
						start++;
						end--;
						if ((fp.length + ellipsis.length + sp.length + second_slice.length) > rep_length) {
							break;
						}
					}
					rep_this_name = fp + ellipsis + sp + second_slice;
				}

				$(this).find('span, a').html(rep_this_name);
				let real_date_start = self.date_start.clone();
				// Маємо зберегти довжину задачі в робочих днях, тож старт треба рухати вперед, а фініш назад якщо попадає на вихідний
				if ($('#datestart').val()) { // tab == START_END
					while (App.helper.date.is_week_end(real_date_start)) real_date_start.setDate(real_date_start.getDate() + 1);
				} else {
					while (App.helper.date.is_week_end(real_date_start)) real_date_start.setDate(real_date_start.getDate() - 1);
				}
				dt_txt = App.format.digits_2(real_date_start.getDate()) + '.' + App.format.digits_2(real_date_start.getMonth() + 1) + '.' + real_date_start.getFullYear();
				if (real_date_start.getTime() <= prev_date_start.getTime()) dt_txt = 'X';
				if (1 * $('#rep_type').val() === 0) dt_txt = '~ ' + dt_txt;
				$(this).find('i').html(dt_txt).removeClass('we');
				if (real_date_start.getTime() != self.date_start.getTime()) $(this).find('i').addClass('we');
			});
		},

		prepare_name: function (arr0, arr1, arr2, arr3, arr4, offset, s) {
			if (arr4) arr4 = 1 * arr4; else arr4 = 0;
			if (arr1 === 'n') return self.numrepeat + (arr2 ? (arr3 === '+' ? 1 : -1) * arr4 : 0);
			else if (arr1[0] === 'n') return App.format.digits_n(self.numrepeat + (arr2 ? (arr3 === '+' ? 1 : -1) * arr4 : 0), arr1.length);
			else {
				let quarters = ['I', 'II', 'III', 'IV'];
				let dt = self.date_start.clone();
				if (arr2) {
					if (arr1.toLowerCase().indexOf('d') !== -1) dt.setDate(dt.getDate() + (arr3 === '+' ? 1 : -1) * arr4);
					else {
						let d = dt.getDate();
						dt.setDate(1);
						if (arr1.toLowerCase().indexOf('m') !== -1) dt.setMonth(dt.getMonth() + (arr3 === '+' ? 1 : -1) * arr4);
						else if (arr1.toLowerCase().indexOf('q') !== -1) dt.setMonth(dt.getMonth() + 3 * (arr3 === '+' ? 1 : -1) * arr4);
						else dt.setFullYear(dt.getFullYear() + (arr3 === '+' ? 1 : -1) * arr4);
						let dt_ = dt.clone();
						dt.setDate(d);
						dt_.setMonth(dt_.getMonth() + 1);
						dt_.setDate(dt_.getDate() - 1);
						if (dt.getTime() > dt_.getTime()) dt = dt_;
					}
				}
				arr1 = arr1.replace(/([dmyqDMYQ])/g, '%$1 ');
				arr1 = arr1.replace(/(%[dmyqY]) (%[dmyqY])/g, '$1.$2');
				arr1 = arr1.replace(/(%[dmyqY]) (%[dmyqY])/g, '$1.$2');
				arr1 = arr1.replace('%d %M', dt.getDate() + ' ' + $.datepicker._defaults.monthNamesL[dt.getMonth()].toLowerCase());
				arr1 = arr1.replace('%D %M', App.format.digits_2(dt.getDate()) + ' ' + $.datepicker._defaults.monthNamesL[dt.getMonth()].toLowerCase());
				arr1 = arr1.replace('%d', dt.getDate());
				arr1 = arr1.replace('%D', App.format.digits_2(dt.getDate()));
				arr1 = arr1.replace('%m', App.format.digits_2(dt.getMonth() + 1));
				arr1 = arr1.replace('%M', $.datepicker._defaults.monthNames[dt.getMonth()]);
				arr1 = arr1.replace('%y', App.format.digits_2(dt.getYear() - 100));
				arr1 = arr1.replace('%Y', dt.getFullYear());
				arr1 = arr1.replace('%q', quarters[Math.floor(dt.getMonth() / 3)]);
				arr1 = arr1.replace('%Q', quarters[Math.floor(dt.getMonth() / 3)] + ' ' + $('#rep_qname').val());
			}
			return arr1.trim();
		},

		helper_on_period_save: function (o, text_to, text_to2) {
			let str = '';
			let str2 = '';
			let is_num = true;
			let is_many = 0;
			o.find('.menu__item-active').each(function () {
				is_many++;
				if (str != '') str = str + ',';
				if (str2 != '') str2 = str2 + ', ';
				str += $(this).attr('rel');
				str2 += App.helper.html.encode(($(this).attr('data-name') ? $(this).attr('data-name') : $(this).find('.in').text()));
				if (!App.helper.validate.number.test($(this).find('.in').text())) is_num = false;
			});
			$(o.attr('rel')).val(str);
			if (text_to) $(text_to).attr('text', is_num ? str2 + ' ' + text_to2 : str2);
			if (is_many > 1 && $('#rep_name').val().indexOf('%d') === -1) {
				$('#rep_name').val($('#rep_name').attr('rel') + ' %dMY');
			}
		},

		helper_template_click: function(el) {
			$('#rep_name').val($('#rep_name').val() + ' ' + $(el).attr('rel'));
			App.menu.hide();
			self.update_names();
			$('#rep_name').focus();
		},

		helper_renew_highlight: function() {
			$('#dt_rep').parent().addClass('modalTerms__highlight');
			setTimeout(function() {
				$('#dt_rep').parent().removeClass('modalTerms__highlight');
			}, 1000)
		},

		helper_renew_click: function() {
			$('#rep_isupd').val('');
			['#dt_rep', '#drop_dmdaymenu', '#drop_dwdaymenu', '#drop_dmday_endmenu'].forEach(id => {
				$(id).html(self.repeat_block_html[id]);
			});
			self.helper_renew_highlight();
			self.helper_renew_toggle();
		},
		helper_renew_toggle: function() {
			if (!$('#option_al').length) return;
			const rep_isupd = $('#rep_isupd').val() == 1;
			const rep_ison = $('#rep_ison').val() == 1;
			// console.trace({ rep_isupd, rep_ison });
			$('#option_al').toggle(rep_isupd && rep_ison);
			$('#terms_reset_btn').toggle(!rep_isupd || !rep_ison);
		},
		helper_adt: function(adt) {
			if (true) {
				$('#rep_mday, #rep_def_mday').val(adt[1] > 28 ? -1 : adt[1]);
				$('#rep_wday, #rep_def_wday').val(adt[6]);
				$('#drop_dmdaymenu .menu__item').removeClass('menu__item-active').filter('[rel=' + (adt[1] > 28 ? -1 : adt[1]) + ']').addClass('menu__item-active');
				$('#drop_dwdaymenu .menu__item').removeClass('menu__item-active').filter('[rel=' + adt[6] + ']').addClass('menu__item-active');
				if (adt[1] > 28) $('.modalTerms ws-btn.m2').attr('text', App.controls.task_terms.locale['last_day']);
				else $('.modalTerms ws-btn.m2').attr('text', adt[1] + ' ' + App.controls.task_terms.locale['some_day']);
				$('.modalTerms ws-btn.m3').attr('text', App.object_state.locale.day['short'][adt[6]]);
			}
			if ($('#modalTerms').hasClass('dt_rep')) {
				App.controls.task_repeat.update_names();
				$('#rep_isupd').val('1');
				App.controls.task_repeat.helper_renew_toggle();
			}
			if ($('#rep_ison').val() == 1) {
				self.helper_renew_highlight();
			}
		},
		helper_repeat_names_menu: function() {

			if (App.device.is_mobile()) {
				$('#btn_rep_name').on('click', function () {
					App.menu.show({
						anchor: this,
						box: '#rep_namemenu',
						type: 'bottom box_max parent2',
					});
				});
				return;
			}

			$('#rep_name').on('focus', function() {
				if (!App.menu.is_shown()) {
					setTimeout(App.menu.show({
						anchor: this,
						box: '',
						type: 'bottom box_max parent2',
						onshow: () => { this.focus(); }
					}), 100);
				}
			});
		},

		helper_on_period_select: function() {
			let box_id = $(this).attr('id');
			let text_to = '';
			let text_to2 = '';

			switch (box_id) {
				case 'drop_dmdaymenu':
					text_to = '#dt_rep .m2';
					text_to2 = App.controls.task_terms.locale['some_day'];
					break;
				case 'drop_dmday_endmenu':
					text_to = '#dt_rep .m4';
					text_to2 = App.controls.task_terms.locale['some_day'];
					break;
				case 'drop_dwdaymenu':
					text_to = '#dt_rep .m3';
					break;
			}
			App.controls.task_repeat.helper_on_period_save($(this), text_to, text_to2);
			App.controls.task_repeat.update_names();
		}
	}
})();

;(function() {
	let self = App.controls.task_schedule_menu = {
		show: function (anchor, id_task, params) {
			params ||= {}
			params['request'] ||= {};

			const endpoint = App.helper.url.task(id_task);

			const id_user = params.id_user;
			if (id_user) {
				params['request']['id_user'] = id_user;
			}

			App.menu.show({
				anchor: anchor,
				type: params.type || 'left',
				replace: params.replace || false,
				backup: params.backup || false,
				url: endpoint + '?' + App.actions.get('task_schedule_menu:show') + '&' + $.param(params['request']),
				class: 'menu-autoWidthMax',
				force_dropdown: true,
				// onload: self.init,
				// onshow: self.onshow,
			});
		},
		// init: function () {
		// 	const menu = $(this);
		// 	console.log('init', menu);
		// },
		// onshow: function () {
		// 	const menu = $(this);
		// 	console.log('init', menu);
		// }
	}
})();

;(function() {
	let self = App.controls.task_select_and_go = {
		callback: null,
		callback_project: null,
		last_shown_context: null,
		init_search_ajax: null,
		do_search_ajax: null,
		is_server_mode: false,

		/**
		 * Task-select-from-project controller
		 * process tree-view, can switch project, may switch to global task search
		 * @param {object} menu_anchor
		 * @param {string} endpoint
		 * @param {object} params (params.request goes to server-side)
		 * @events onshow, onload, on_project_change, on_server_search
		 */

		show_context: function(menu_anchor, endpoint, params) {
			self.is_server_mode = false;
			App.core.call_queue.delete('controls.task_select_and_go.search');
			self.last_shown_context = [menu_anchor, endpoint, params];
			self.onkeyup.reset();
			params ||= {};
			params['request'] ||= {};
			params['request']['template'] = 'menu';
			if (endpoint.indexOf('action=') === -1) endpoint = App.helper.url.add_query(endpoint, App.actions.get('project_task_select_and_go:context'));
			App.menu.show({
				anchor: menu_anchor,
				url: App.helper.url.add_query(endpoint, $.param(params['request'])),
				onload: function() {
					self.init.call(this, menu_anchor, params);
					params.onload?.call(this, this);
				},
				onshow: params.onshow || self.draw_tree.call(App.menu.obj_window),
				type: params.type || '',
				text_position: params.text_position || null,
				replace: params.replace || false,
				reload: params.reload || false,
				backup: params.backup || false,
				title: App.object_state.locale['task'],
				width: params.width || 450,
				load_always: params.load_always || false,
				use_prev_height: params.use_prev_height || false,
			});
		},
		show: function(endpoint, callback, callback_project) {
			self.callback = callback;
			self.callback_project = callback_project;
			App.core.call_queue.delete('controls.task_select_and_go.search');
			self.onkeyup.reset();
			App.modal.show({
				url: App.helper.url.add_query(endpoint, App.actions.get('project_task_select_and_go:show')),
				width: 500,
			});
		},
		init: function(menu_anchor, params) {
			let menu = $(this);

			menu.on('before_hide', function () {
				App.core.call_queue.delete('controls.task_select_and_go.search');
				self.is_server_mode = false;
				self.onkeyup.reset();
				self.init_search_ajax.abort();
				self.do_search_ajax.abort();
				menu.find('ws-btn.back').off('click');
				menu.find('.menu__group-search input').off('keyup');
			});

			if (menu.find('.menu__item[data-id]').length === 0) {
				menu.removeClass('menu-withEditorSearch');
				params['on_server_search']?.call(this);
				let search = '';
				params['skip_back'] = true;
				self.init_server_search(menu, [params, search])
				return false;
			}
			menu.find('.other_project').click(function() {
				App.controls.project_select_and_go.show_context(this, null, {
					backup: true,
					type: 'submenu',
					onload: function () {
						let menu = $(this);
						App.controls.menu.init(menu);
						menu.on('click', '.menu__item', function() {
							let endpoint = App.helper.endpoint.ajax($(this).attr('data-id'));
							App.menu.hide();
							params.replace = true;
							params.backup = false;
							self.show_context(menu_anchor, endpoint, params);
							params['on_project_change']?.call(this);
						});
					},
				});
			});
			menu.find('.switch_search_mode').click(function(e) {
				menu.removeClass('menu-withEditorSearch');
				params['on_server_search']?.call(this);
				let search = $(this).find('b').text() || '';
				self.init_server_search(menu, [params, search])
				e.stopPropagation();
				return false;
			});
		},

		init_server_search: function(menu, vars) {
			let [params, search] = vars;

			self.is_server_mode = true;

			menu.addClass('menu-unloading');
			self.init_search_ajax.ajax({
				type: 'GET',
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('task_search:show') + '&search=' + encodeURIComponent(search) + '&init=1' + (params['skip_back'] === true ? '' : '&back=1') + '&' + $.param(params['request'])),
				dataType: 'html',
			}).then(function (html) {
				menu.invalidateMenu();
				menu.html(html);
				menu.find('.menu__group').not('.menu__group-search, .menu__group-head, .menu__group-bottom').wrapAll('<div class="scrollZone keyboardZone" data-select=".menu__item"></div>');
				App.menu.init_scroll_zones();
				if (!params.text_position) {
					menu.find('.menu__group-search input').bind('keyup', function(e) {
						if (this.value === '' && self.last_shown_context != null) {
							menu.find('.menu__group-search input').off('keyup');
							return menu.find('ws-btn.back').click();
						}
						let key = e.keyCode || e.charCode;

						if (key === App.keycode.Enter && menu.find('.menu__group-empty').is(':visible') && !menu.find('.menu__item.selected').length) {
							menu.find('.menu__group-search input').val('').trigger('keyup').trigger('click');
							return false;
						}

						App.core.call_queue.add('controls.task_select_and_go.search', self.helper_server_search, menu, [$(this), params], key === App.keycode.Enter ? 0 : 0.5);
					}).val(search).attr('data-last-value', search).focus();
				} else {
					menu.find('.menu__group-search input').val(search).attr('data-last-value', search);
				}
				menu.on('click', '#toggle_global_search', function() {
					params['request']['global_search'] = true;
					params['force'] = true;
					App.core.call_queue.add('controls.task_select_and_go.search', self.helper_server_search, menu, [menu.find('.menu__group-search input'), params], 0);
				});
				App.keyboard_selection.init_container(menu.find('.scrollZone'));
				menu.find('ws-btn.back').toggleClass('hiddenBlock', self.last_shown_context == null).on('click', function () {
					if (self.last_shown_context) self.last_shown_context[2].replace = true;
					self.show_context.apply(self, self.last_shown_context);
				});
			}).finally(() => {
				if (self.init_search_ajax.is_idle()) menu.removeClass('menu-unloading');
			});
		},

		handle_server_search: function(search) {
			const menu = App.menu.obj_window;
			const input = menu.find('.menu__group-search input').val(search);
			const params = App.controls.task_select_and_go.last_shown_context[2];
			App.core.call_queue.add('controls.task_select_and_go.search', self.helper_server_search, menu, [input, params], 0.5);
		},

		helper_server_search: function(vars) {
			let [input, params] = vars;
			let menu = $(this);
			if (params['force'] || (input.val().trim() !==  input.attr('data-last-value')?.trim())) {
				params['force'] = false;
				input.attr('data-last-value', input.val());

				menu.addClass('menu-unloading');
				self.do_search_ajax
					.ajax(App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('task_search:show') + '&search=' + encodeURIComponent(input.val()) + '&' + $.param(params['request'])))
					.then(function(res) {
						menu.find('.scrollZone').html(res);
						App.keyboard_selection.init_container(menu.find('.scrollZone'));
					}).finally(() => {
						if (self.do_search_ajax.is_idle()) menu.removeClass('menu-unloading');
					});
			}
		},

		draw_tree: function() {
			let menu = $(this);
			menu.find('.parent_line').addClass('parent_line-hidden');
			menu.find('.menu__item-level1').not('.menu__item-hidden').each(function() {
				let o = $(this).prev();
				while ((o.hasClass('menu__item-level1') && o.hasClass('menu__item-hidden')) || (o.hasClass('menu__item-level2') && !o.hasClass('menu__item-hidden'))) {
					o.find('.parent_line').removeClass('parent_line-hidden');
					o = o.prev();
				}
			});
		},

		onkeyup: App.helper.debounce(function(input_el, event) {
			App.context_search.menu.apply(input_el, App.menu.obj_window, {
				callback: function (has_results) {
					App.controls.task_select_and_go.draw_tree.bind(App.menu.obj_window);

					if (!has_results) {
						App.menu.obj_window.find('.switch_search_mode:visible').trigger('click');
					}
				}
			});
		}, 150),

		destructor: function() {
			self.is_server_mode = false;
		},
		onLogout: () => self.destructor(),

		onBoot: function () {
			self.init_search_ajax = App.core.async_task.context('controls.task_select_and_go.init_search');
			self.do_search_ajax = App.core.async_task.context('controls.task_select_and_go.do_search');

			App.bus.app.on('modal_load', function () {
				App.modal.obj_window.find('.menuFake').each(function () {
					if ($(this).find('.menu__item-level1, .menu__item-level2').length) {
						self.draw_tree.call($(this));
					}
				});
			});
		}
	}
})();

;(function() {
	let self = App.controls.task_terms = {

		ONLY_END: 1,
		START_END: 2,

		timeout: null,

		locale: {},

		timeout_call: function (func) {
			if (self.timeout) clearTimeout(self.timeout);
			self.timeout = setTimeout(func, 200);
		},

		init_qty_focus: function() {
			$('#modalTerms').on('focus', 'input.qty', function() {
				window.select_this = this;
				setTimeout(function () {
					window.select_this.select();
				}, 50);
			});
		},

		init_modal_date_diff: function () {
			$('#datelen2').bind('keyup', function () {
				self.timeout_call(self.get_modal_date_diff);
			}).bind('focus', function () {
				window.select_this = this;
				setTimeout(function () {
					window.select_this.select();
				}, 50);
			});
		},

		init_modal_date_diff_range: function () {
			$('#datelen').bind('keyup', function () {
				self.timeout_call(self.get_modal_date_diff_range);
			}).bind('focus', function () {
				window.select_this = this;
				setTimeout(function () {
					window.select_this.select();
				}, 50);
			});
		},

		init_modal_format_qty: function() {
			$('#datelen, #datelen2').bind('input focus blur', function () {
				self.days_format_qty($(this));
			});
		},

		days_format_qty: function (el) {
			let label = el.next();
			let val = el.val().toInt();
			let modifyer = $('#datelen_we').val().toInt() === 1 ? self.locale['wday_modifyer'] : self.locale['day_modifyer'];
			label.html(App.format.quantity(val, modifyer, false));
		},

		init_date_diff: function () {
			$('#ed_datelen2').bind('keyup', function () {
				self.timeout_call(self.get_date_diff);
			}).bind('focus', function () {
				window.select_this = this;
				setTimeout(function () {
					window.select_this.select();
				}, 50);
			});
		},

		init_date_diff_range: function () {
			$('#ed_datelen').bind('keyup', function () {
				self.timeout_call(self.get_date_diff_range);
			}).bind('focus', function () {
				window.select_this = this;
				setTimeout(function () {
					window.select_this.select();
				}, 50);
			});
		},

		get_modal_date_diff_range: function (back) {
			if (self.stop_diff_calc_events || !$('#dateend').length) return;
			if (back) {
				if ($('#dateend').val() && $('#datestart').val()) {
					$('#datelen').val(App.format.no_zero(App.helper.work_days.diff(App.helper.date.from_input($('#datestart').val()), App.helper.date.from_input($('#dateend').val()), true)));
				} else {
					$('#datelen').val('');
				}
			} else {
				let dt_s = App.helper.date.from_input($('#datestart').val() ? $('#datestart').val() : $('#datestart_def').val());
				let inst = $.data($('#dateend_div')[0], 'datepicker');
				self.stop_events();
				if (App.helper.validate.number.test($('#datelen').val()) && 1 * $('#datelen').val()) {
					let dt_i = 1 * $('#datelen').val() - 1;
					let dt = App.helper.work_days.add(dt_s, dt_i);
					$.datepicker._setDateDatepicker($('#dateend_div').get(0), dt_s, dt);
					inst.rangeStart = $.datepicker._daylightSavingAdjust(dt_s);
					$.datepicker._stayOpen = true;
					$.datepicker._selectDate('#dateend_div', $.datepicker._formatDate(inst, dt.getDate(), dt.getMonth(), dt.getFullYear()));
					inst.rangeStart = null;
					$.datepicker._setDateDatepicker($('#dateend_div').get(0), dt_s, dt);
					$.datepicker._stayOpen = false;
					self.get_modal_date_diff(true);
				} else {
					$('#dateend_nice .end').stop().html('_______').blink();
					$('#dateend').val('');
					$('#datelen2').val('');
					$.datepicker._setDateDatepicker($('#dateend_div').get(0), dt_s, 'free');
				}
				self.resume_events();
			}
		},

		get_modal_date_diff: function (back) {
			if (self.stop_diff_calc_events || !$('#dateend').length) return;
			if (back) {
				if ($('#dateend').val()) {
					$('#datelen2').val(App.format.no_zero(App.helper.work_days.diff(App.helper.date.from_input($('#datestart_def').val()), App.helper.date.from_input($('#dateend').val()), true)));
				} else {
					$('#datelen2').val('');
				}
			} else {
				let dt_i = 0;
				if (App.helper.validate.number.test($('#datelen2').val()) && 1 * $('#datelen2').val()) dt_i = 1 * $('#datelen2').val() - 1;
				let dt = App.helper.work_days.add(App.helper.date.from_input($('#datestart_def').val()), dt_i);
				self.stop_events();
				let inst = $.data($('#dateend_div')[0], 'datepicker');
				$.datepicker._setDateDatepicker($('#dateend_div').get(0), dt);
				$.datepicker._selectDate('#dateend_div', $.datepicker._formatDate(inst, dt.getDate(), dt.getMonth(), dt.getFullYear()));
				self.resume_events();
				$('#datelen').val(1);
				$('#datestart').val(App.helper.date.to_input(dt));
			}
		},

		update_nice: function(el) {
			let inst = $.data($('#dateend_div')[0], 'datepicker');
			let dt = App.helper.date.from_input(el.val());
			dt = App.controls.datepicker.closest_workday(dt);
			self.stop_events();
			$.datepicker._setDateDatepicker($('#dateend_div').get(0), dt);
			$.datepicker._selectDate('#dateend_div', $.datepicker._formatDate(inst, dt.getDate(), dt.getMonth(), dt.getFullYear()));
			self.resume_events();
			self.get_modal_date_diff(true);
		},
		update_nice_range: function(el) {
			let inst = $.data($('#dateend_div')[0], 'datepicker');
			let name = $(el).attr('name');
			let dt_el = $('#'+name);
			let dt, dt_s;

			dt = App.helper.date.from_input($('#dateend').val());
			dt = App.controls.datepicker.closest_workday(dt);
			dt_s = App.helper.date.from_input($('#datestart').val());
			dt_s = App.controls.datepicker.closest_workday(dt_s);

			if (dt < dt_s) {
				dt = dt_s;
				$('#dateend').val(App.helper.date.to_input(dt_s));
			}

			self.stop_events();
			$.datepicker._setDateDatepicker($('#dateend_div').get(0), dt_s, dt);
			inst.rangeStart = $.datepicker._daylightSavingAdjust(dt_s);
			$.datepicker._stayOpen = true;
			$.datepicker._selectDate('#dateend_div', $.datepicker._formatDate(inst, dt.getDate(), dt.getMonth(), dt.getFullYear()));
			inst.rangeStart = null;
			$.datepicker._setDateDatepicker($('#dateend_div').get(0), dt_s, dt);
			$.datepicker._stayOpen = false;
			self.resume_events();
			self.get_modal_date_diff_range(true);
		},

		get_date_diff_range: function (back) {
			if (self.stop_diff_calc_events) return;
			if (back) {
				if ($('#ed_dateend').val() && $('#ed_datestart').val()) {
					let dt_i = App.helper.work_days.diff(App.helper.date.from_input($('#ed_datestart').val()), App.helper.date.from_input($('#ed_dateend').val()), true);
					$('#ed_datelen').val(dt_i ? dt_i : '');
				} else {
					$('#ed_datelen').val('');
				}
			} else {
				if (App.helper.validate.number.test($('#ed_datelen').val()) && 1 * $('#ed_datelen').val()) {
					let dt_i = 1 * $('#ed_datelen').val() - 1;
					let dt = App.helper.work_days.add(App.helper.date.from_input($('#ed_datestart').val()), dt_i);
					$('#ed_dateend').val(App.helper.date.to_input(dt));
					$('#term_tab1 .end').html(App.format.date(dt, DATE_EDIT_LONG) + ($('#ed_timeend').length ? $('#ed_timeend').attr('data-txt') : ''));
					$('#term_tab2 .end').html(App.format.date(dt, DATE_EDIT_SHORT) + ($('#ed_timeend').length ? $('#ed_timeend').attr('data-txt') : ''));
					self.get_date_diff(true);
				} else {
					$('#ed_dateend').val('');
					$('#ed_datelen2').val('');
					$('#term_tab1 .end').html('<span class="nodate">_______</span>');
					$('#term_tab2 .end').html('<span class="nodate">_______</span>');
				}
			}
		},

		get_date_diff: function (back) {
			if (self.stop_diff_calc_events) return;
			if (back) {
				if ($('#ed_dateend').val()) {
					let dt_i = App.helper.work_days.diff(App.helper.date.from_input($('#ed_datestart_def').val()), App.helper.date.from_input($('#ed_dateend').val()), true);
					$('#ed_datelen2').val(dt_i ? dt_i : '');
				} else {
					$('#ed_datelen2').val('');
				}
			} else {
				let dt_i = 0;
				if (App.helper.validate.number.test($('#ed_datelen2').val()) && 1 * $('#ed_datelen2').val()) dt_i = 1 * $('#ed_datelen2').val() - 1;
				let dt = App.helper.work_days.add(App.helper.date.from_input($('#ed_datestart_def').val()), dt_i);
				$('#ed_dateend, #ed_datestart').val(App.helper.date.to_input(dt));
				$('#ed_datelen').val(1);
				$('#term_tab1 .end').html(App.format.date(dt, DATE_EDIT_LONG) + ($('#ed_timeend').length ? $('#ed_timeend').attr('data-txt') : ''));
				$('#term_tab2 .start').html(App.format.date(dt, DATE_EDIT_SHORT));
				$('#term_tab2 .end').html(App.format.date(dt, DATE_EDIT_SHORT) + ($('#ed_timeend').length ? $('#ed_timeend').attr('data-txt') : ''));
			}
		},

		set_relation_limit: function (str) {
			if (str) {
				if (!$('#datestart').val() || App.helper.date.from_input(str) > App.helper.date.from_input($('#datestart').val())) {
					$('#datestart').val(str);
					self.get_modal_date_diff_range();
					$.datepicker._changeDatepicker($('#dateend_div').get(0), 'minDate', App.helper.date.from_input(str));
				} else {
					$.datepicker._changeDatepicker($('#dateend_div').get(0), 'minDate', App.helper.date.from_input(str));
					$('#datestart').val(str);
					self.get_modal_date_diff_range();
				}
			} else {
				$.datepicker._changeDatepicker($('#dateend_div').get(0), 'minDate', App.helper.date.from_input($('#datestart_def').val()));
				$('#datestart').val($('#datestart_def').val());
				self.get_modal_date_diff_range();
			}
		},

		helper_option_events: function (type, className) {
			switch (type) {
				case 'is':
					return $('#modalTerms').hasClass(className);
					break;
				case 'set':
					$('#modalTerms').attr('class', className);
					App.controls.slider.init();
					break;
				case 'on':
					$('#modalTerms').addClass(className);
					App.controls.slider.init();
					break;
				case 'off':
					$('#modalTerms').removeClass(className);
					break;
			}
		},

		preset: function (dateend, timeend, timeend_pre) {
			let dt = App.helper.date.from_input(dateend);
			$('#term_tab1 .end').html(App.format.date(dt, DATE_EDIT_LONG) + (timeend ? timeend_pre + '<b>' + timeend + '</b>' : ''));
			$('#term_tab2 .start').html(App.format.date(dt, DATE_EDIT_SHORT));
			$('#term_tab2 .end').html(App.format.date(dt, DATE_EDIT_SHORT) + (timeend ? timeend_pre + '<b>' + timeend + '</b>' : ''));
			$('#ed_datestart, #ed_dateend').val(dateend);
			$('#ed_datelen').val(1);
			$('#ed_timeend').val(timeend).attr('data-txt', timeend ? timeend_pre + '<b>' + timeend + '</b>' : '');
			self.skip_tab_onclick = true;
			$('#top_tab1').trigger('click');
			self.get_date_diff(true);
		},

		skip_tab_onclick: false,
		set_tab: function (el) {
			if (!self.skip_tab_onclick && $(el).attr('rel') == 1 && $('#ed_dt_term').val() == 0) {
				$('#modal_term1').trigger('click');
				return false;
			}
			if (!self.skip_tab_onclick && $(el).attr('rel') == 2 && $('#ed_dt_term').val() == 0) {
				$('#modal_term2').trigger('click');
				return false;
			}
			$(el).parent().find('a.act').removeClass('act');
			$(el).addClass('act');
			$('.dataadd_out .terms .tab').hide().filter('#term_tab' + $(el).attr('rel')).show();
			$('#ed_dt_term').val($(el).attr('rel'));
			if (!App.device.is_mobile()) {
				if ($(el).attr('rel') == 1) $('#ed_datelen2').trigger('focus');
				if ($(el).attr('rel') == 2) $('#ed_datelen').trigger('focus');
			}
			self.skip_tab_onclick = false;
		},

		helper_repeat: {
			weekly: function () {
				$('#rep_wday').val($('#rep_def_wday').val());
				$('#drop_dwdaymenu .menu__item').removeClass('menu__item-active').filter('[rel=' + $('#rep_def_wday').val() + ']').addClass('menu__item-active');
			},

			monthly: function (single) {
				$('#rep_mday').val($('#rep_def_mday').val());
				$('#drop_dmdaymenu').toggleClass('menu-singleSelect', !!single)
					.find('.menu__item').removeClass('menu__item-active').filter('[rel=' + $('#rep_def_mday').val() + ']').addClass('menu__item-active');
				$('#drop_dmday_endmenu').addClass('menu-singleSelect')
					.find('.menu__item').removeClass('menu__item-active').filter('[rel=' + $('#rep_def_mday_end').val() + ']').addClass('menu__item-active');
			}
		},

		stop_diff_calc_events: false,
		stop_events: function () {
			self.stop_diff_calc_events = true;
		},
		resume_events: function () {
			self.stop_diff_calc_events = false;
		},

		init_repeat_day_clicks() {
			$('#drop_dwdaymenu, #drop_dmdaymenu, #drop_dmday_endmenu').on('click', '.chech_links_ .menu__item', function (e) {
				if ($(this).hasClass('menu__item-disabled')) return false;
				let menu = $(this).closest('.menu');
				const isMultiSelect = e.ctrlKey || e.metaKey;
				if (menu.hasClass('menu-singleSelect') || !isMultiSelect) {
					menu.find('.menu__item-active').removeClass('menu__item-active');
					$(this).addClass('menu__item-active');
				} else if ($(this).hasClass('menu__item-active')) {
					if (menu.find('.menu__item-active').length === 1) return false;
					else $(this).removeClass('menu__item-active');
				} else {
					$(this).addClass('menu__item-active');
				}
				return false;
			});
		},

		onLoadPage: function () {
			self.init_date_diff_range()
			self.init_date_diff()
			self.init_qty_focus()
		}
	}
})();

;(function() {
	let self = App.controls.task_terms_on_create = {
		is_term: 0,
		locale: {},
		onselect_range: function (range) {
			let date_arr = range.split(' - ');
			let date = date_arr[1];
			let date_st = date_arr[0];
			date_arr = $('#dateend_').val().split(' - ');
			let date_nice = date_arr[1];
			let date_st_nice = date_arr[0];
			$('#dateend').val(date);
			$('#datestart').val(date_st);
			let adt = date_st_nice.split('.');
			App.controls.task_repeat.helper_adt(adt);
			App.controls.task_terms.helper_option_events('on', 'dt_date');
			if (date) {
				let adt = date_nice.split('.');
				App.controls.task_terms.get_modal_date_diff_range(true);
				$('#dt_relate').not('.dt_relate_del_').removeClass('dt_relate_del');
				$('#dt_relate2').show();
				$('#option_sv font').show();
				App.controls.task_repeat.helper_renew_toggle();
				if (!App.controls.task_terms.stop_diff_calc_events) $('#datelen').focus_select_desktop();
			} else if (App.controls.task_terms.stop_diff_calc_events && App.helper.validate.number.test($('#datelen').val()) && 1 * $('#datelen').val()) {
				let dt_i = 1 * $('#datelen').val() - 1;
				let dt_s = App.helper.date.from_input(date_st);
				let dt = App.helper.work_days.add(dt_s, dt_i);
				$('#dateend').val(App.helper.date.to_input(dt));
				$('#dateend_nice .end').stop().css({opacity: 1}).html(App.format.date(dt, DATE_EDIT_SHORT));
			} else {
				if (!App.controls.task_terms.stop_diff_calc_events) {
					$('#datelen').val('').focus_desktop();
					$('#datelen2').val('');
				}
				$('#dateend_nice .end').html('_______').blink();
			}
			self.helper_timepicker_limit();
		},
		onselect_date: function (date) {
			$('#dateend').val(date);
			let date_nice = $('#dateend_').val();
			if (date) {
				App.controls.task_terms.helper_option_events('on', 'dt_date');
				let adt = date_nice.split('.');
				App.controls.task_repeat.helper_adt(adt);
				$('#option_sv font').show();
				App.controls.task_repeat.helper_renew_toggle();
				App.controls.task_terms.get_modal_date_diff(true);
				if (!App.controls.task_terms.stop_diff_calc_events) $('#datelen2').focus_select_desktop();
			} else App.controls.task_terms.helper_option_events('off', 'dt_date');
		},
		init_relations: function() {
			App.modal.obj_window.on('click', 'ws-btn[data-refer=relation]', function() {
				App.controls.task_select_and_go.show_context(this, App.modal.obj_window.find('form').attr('data-project-endpoint'), {
					request: {
						type: 'relation',
						relation_type: 2, // TaskRelate::END
						id_skip: App.modal.obj_window.find('form').attr('data-id')
					},
					type: $(this).parent().attr('id') === 'dt_relate' ? 'top' : 'left',
					load_always: true,
					onload: function() {
						let menu = $(this);
						menu.on('click', '.menu__item[data-id]', function() {
							let url = $('#dt_relate_pre').attr('data-url');
							let id = $(this).attr('data-id');
							if (url.indexOf('&no_relate[]=' + id) !== -1) {
								url = url.replace('&no_relate[]=' + id, '');
							} else {
								url = url.replace('&only_relate=1', '&do_relate[]='+id+'&only_relate=1');
							}
							$('#dt_relate_pre').load(url, ()=>{ App.controls.task_terms.helper_option_events('on', 'dt_rel') }).attr('data-url', url);
							App.menu.hide(true);
						});
						menu.find('.menu__group-search input').bind('keyup', function () {
							menu.find('.switch_search_mode b').text(this.value);
							App.context_search.menu.apply(this.value, menu);
						});
					},
					on_project_change: function() {},
					on_server_search: function() {}
				});
			});

			App.modal.obj_window.find('.relationsListing').on('click', 'ws-btn.delete', function() {
				let url = $('#dt_relate_pre').attr('data-url');
				let id = $(this).parents('.relationsListing__item').attr('data-relation');
				if (url.indexOf('&do_relate[]=' + id) !== -1) {
					url = url.replace('&do_relate[]=' + id, '');
				} else {
					url = url.replace('&only_relate=1', '&no_relate[]='+id+'&only_relate=1');
				}
				$('#dt_relate_pre').load(url, ()=>{ if ( $('#dt_relate_pre').find('.relationsListing__item').length < 1 ) App.controls.task_terms.helper_option_events('off', 'dt_rel') }).attr('data-url', url);
			});
		},
		init: function(tab) {
			self.is_term = tab;
			if (tab === App.controls.task_terms.START_END) {
				$("#dateend_div").datepicker({
					rangeSelect: true,
					numberOfMonths: 2,
					minDate_: self.config['min_date_js'] ? new Date(self.config['min_date_js']) : null,
					minDate: self.config['min_date_real_js'] ? new Date(self.config['min_date_real_js']) : null,
					maxDate_: self.config['max_date_js'] ? new Date(self.config['max_date_js']) : null,
					altField: '#dateend_',
					altFormat: 'DD.d.LL.yy.D.L.w',
					onSelect: self.onselect_range,
					firstDay: App.datepicker_firstDay || 0,
					hideIfNoPrevNext: true,
					beforeShowDay: we_coloringFunc
				});
				if (self.config['datestart_js'] && self.config['dateend_js']) {
					$.datepicker._setDateDatepicker($('#dateend_div').get(0), new Date(self.config['datestart_js']), new Date(self.config['dateend_js']));
				} else if (self.config['datestart_js']) {
					$.datepicker._setDateDatepicker($('#dateend_div').get(0), new Date(self.config['datestart_js']), 'free');
				} else {
					$.datepicker._gotoToday('#dateend_div');
				}
				if (self.config['real_dateend_js'] === '0') $('#dateend_div .ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
				$('.timepicker').on('change', function() {
					self.helper_time_start_end($(this));
				});
				self.helper_timepicker_limit();
				self.init_relations();
			} else {
				$("#dateend_div").datepicker({
					rangeSelect: false,
					numberOfMonths: 2,
					minDate_: self.config['min_date_js'] ? new Date(self.config['min_date_js']) : null,
					maxDate_: self.config['max_date_js'] ? new Date(self.config['max_date_js']) : null,
					defaultDate: self.config['dateend_js'] ? new Date(self.config['dateend_js']) : null,
					altField: '#dateend_',
					altFormat: 'DD.d.LL.yy.D.L.w',
					monthNames: App.object_state.locale.month['long'],
					dayNames: App.object_state.locale.day['long'],
					dayNamesMin: App.object_state.locale.day['short'],
					currentText: App.object_state.locale.today,
					onSelect: self.onselect_date,
					firstDay: App.datepicker_firstDay || 0,
					hideIfNoPrevNext: true,
					beforeShowDay: we_coloringFunc
				});
			}
			if (self.config['real_dateend_js'] === '0') $('#dateend_div .ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
			if (!App.device.is_mobile()) setTimeout(function () {
				$('#dateend_nice .datelen .input').focus_select_desktop();
			}, 100);
			App.controls.task_terms.init_repeat_day_clicks();
			if (self.config['is_rep']) {
				App.controls.task_repeat.repeat_block_html = Object.fromEntries(
					['#dt_rep', '#drop_dmdaymenu', '#drop_dwdaymenu', '#drop_dmday_endmenu'].map(selector => [selector, $(selector).html()])
				);
				App.controls.task_repeat.update_names();
				$('#rep_isupd').val(1);
				App.controls.task_repeat.helper_renew_toggle();
			}
			App.controls.task_repeat.helper_repeat_names_menu();
		},

		callback: null,
		saved_params: {},
		show: function(params_container, tab, params, callback) {
			if (params) self.saved_params = params;
			self.callback = callback || null;
			App.modal.show({
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('set_date_oncreate:show') + (tab ? '&is_term=' + tab : '') + '&' + $.param(self.saved_params)),
				width: 450,
				params: params_container,
			});
		},
		submit: function () {
			if (self.is_term === App.controls.task_terms.START_END) {
				if ($('#datestart').val() && !$('#dateend').val()) {
					$('#dateend_nice .end').blink();
					return false
				}
			}
			App.modal.obj_window.find('.modal__content input[id][name]').each(function () {
				App.modal.obj_params.find('input[name=' + this.name + ']').val($(this).val());
			});
			let data = {
				is_repeat: 1 * $('#rep_ison').val(),
				repeat_txt: '',
				timeend: $('#timeend').val(),
				timestart: $('#timestart').val(),
				dateend: $('#dateend').val(),
				datestart: $('#datestart').val(),
				is_term: self.is_term,
			};
			if (data.is_repeat) {
				let o = $('#dt_rep').clone();
				$(o).find('input').each(function () {
					$(this).replaceWith($('#rep_type').val() == 0 || 1 * $(this).val() > 1 ? ' ' + $(this).val() : '');
				});
				data.repeat_txt = App.helper.html.encode(o.text())
				o.remove();
			}
			if (self.callback) {
				self.callback(data);
				return;
			}
			App.modal.hide();
		},

		helper_time_start_end: function(el) {
			let dateStart = $('#datestart').val();
			let dateEnd = $('#dateend').val();
			let time = el.val();
			let [hours, minutes] = time.split(':').map(Number);
			let timeDate = new Date();
			if (el.attr('id') === 'timestart') {
				if (dateStart === dateEnd && time !== '') {
					timeDate.setHours(hours, minutes + 15, 0);
					let newTime = timeDate.toTimeString().substring(0, 5);
					if (newTime === '00:00') newTime = '24:00';
					$("#timeend").timepicker('option', {'minTime': newTime, 'maxTime': '24:00'});
					$('#drop_endtimemenu .menu__item[data-filter]').each(function(){
						if (App.format.HHMM_to_time($(this).attr('data-filter'))<App.format.HHMM_to_time(newTime)) $(this).addClass('menu__item-disabled');
					});
				} else {
					$("#timeend").timepicker('option', self.config.timeend);
					$('#drop_endtimemenu .menu__item[data-filter]').removeClass('menu__item-disabled');
				}
			} else if (el.attr('id') === 'timeend') {
				if (dateStart === dateEnd && time !== '') {
					timeDate.setHours(hours, minutes - 15, 0);
					let newTime = timeDate.toTimeString().substring(0, 5);
					$("#timestart").timepicker('option', {'maxTime': newTime});
					$('#drop_starttimemenu .menu__item[data-filter]').each(function(){
						if (App.format.HHMM_to_time($(this).attr('data-filter'))>App.format.HHMM_to_time(newTime)) $(this).addClass('menu__item-disabled');
					});
				} else {
					$("#timestart").timepicker('option', self.config.timestart);
					$('#drop_starttimemenu .menu__item[data-filter]').removeClass('menu__item-disabled');
				}
			}
		},

		helper_timepicker_limit: function() {
			self.helper_time_start_end($('#timestart'));
			self.helper_time_start_end($('#timeend'));
		},
	}
})();

;(function() {
	let self = App.controls.task_terms_on_edit = {
		locale: {},
		onselect_range: function (range) {
			let date_arr = range.split(' - ');
			let date = date_arr[1];
			let date_st = date_arr[0];
			date_arr = $('#dateend_').val().split(' - ');
			let date_nice = date_arr[1];
			let date_st_nice = date_arr[0];
			$('#dateend').val(date);
			$('#datestart').val(date_st);
			let adt = date_st_nice.split('.');
			App.controls.task_repeat.helper_adt(adt);
			App.controls.task_terms.helper_option_events('on', 'dt_date');
			if (date) {
				let adt = date_nice.split('.');
				App.controls.task_terms.get_modal_date_diff_range(true);
				$('#dt_relate').not('.dt_relate_del_').removeClass('dt_relate_del');
				$('#dt_relate2').show();
				$('#option_sv font').show();
				App.controls.task_repeat.helper_renew_toggle();
				if (!App.controls.task_terms.stop_diff_calc_events) $('#datelen').focus_select_desktop();
			} else if (App.controls.task_terms.stop_diff_calc_events && App.helper.validate.number.test($('#datelen').val()) && 1 * $('#datelen').val()) {
				let dt_i = 1 * $('#datelen').val() - 1;
				let dt_s = App.helper.date.from_input(date_st);
				let dt = App.helper.work_days.add(dt_s, dt_i);
				$('#dateend').val(App.helper.date.to_input(dt));
				$('#dateend_nice .end').stop().css({opacity: 1}).html(App.format.date(dt, DATE_EDIT_SHORT));
			} else {
				if (!App.controls.task_terms.stop_diff_calc_events) {
					$('#datelen').val('').focus_desktop();
					$('#datelen2').val('');
				}
				$('#dateend_nice .end').html('_______').blink();
			}
			self.helper_timepicker_limit();
		},
		onselect_date: function (date) {
			$('#dateend').val(date);
			let date_nice = $('#dateend_').val();
			if (date) {
				App.controls.task_terms.helper_option_events('on', 'dt_date');
				let adt = date_nice.split('.');
				App.controls.task_repeat.helper_adt(adt);
				$('#option_sv font').show();
				App.controls.task_repeat.helper_renew_toggle();
				App.controls.task_terms.get_modal_date_diff(true);
				if (!App.controls.task_terms.stop_diff_calc_events) $('#datelen2').focus_select_desktop();
			} else App.controls.task_terms.helper_option_events('off', 'dt_date');
		},
		init_relations: function() {
			App.modal.obj_window.on('click', 'ws-btn[data-refer=relation]', function() {
				App.controls.task_select_and_go.show_context(this, App.modal.obj_window.find('form').attr('data-project-endpoint'), {
					request: {
						type: 'relation',
						relation_type: 2, // TaskRelate::END
						id_skip: App.modal.obj_window.find('form').attr('data-id')
					},
					type: $(this).parent().attr('id') === 'dt_relate' ? 'top' : 'left',
					load_always: true,
					onload: function() {
						let menu = $(this);
						menu.on('click', '.menu__item[data-id]', function() {
							let url = $('#dt_relate_pre').attr('data-url');
							let id = $(this).attr('data-id');
							if (url.indexOf('&no_relate[]=' + id) !== -1) {
								url = url.replace('&no_relate[]=' + id, '');
							} else {
								url = url.replace('&only_relate=1', '&do_relate[]='+id+'&only_relate=1');
							}
							$('#dt_relate_pre').load(url, ()=>{ App.controls.task_terms.helper_option_events('on', 'dt_rel') }).attr('data-url', url);
							App.menu.hide(true);
						});
						menu.find('.menu__group-search input').bind('keyup', function () {
							menu.find('.switch_search_mode b').text(this.value);
							App.context_search.menu.apply(this.value, menu);
						});
					},
					on_project_change: function() {},
					on_server_search: function() {}
				});
			});

			App.modal.obj_window.find('.relationsListing').on('click', 'ws-btn.delete', function() {
				let url = $('#dt_relate_pre').attr('data-url');
				let id = $(this).parents('.relationsListing__item').attr('data-relation');
				if (url.indexOf('&do_relate[]=' + id) !== -1) {
					url = url.replace('&do_relate[]=' + id, '');
				} else {
					url = url.replace('&only_relate=1', '&no_relate[]='+id+'&only_relate=1');
				}
				$('#dt_relate_pre').load(url, ()=>{ if ( $('#dt_relate_pre').find('.relationsListing__item').length < 1 ) App.controls.task_terms.helper_option_events('off', 'dt_rel') }).attr('data-url', url);
			});
		},
		init: function (tab) {
			if (tab === App.controls.task_terms.START_END) {
				$("#dateend_div").datepicker({
					rangeSelect: true,
					numberOfMonths: 2,
					minDate_: self.config['min_date_js'] ? new Date(self.config['min_date_js']) : null,
					minDate: self.config['min_date_real_js'] ? new Date(self.config['min_date_real_js']) : null,
					maxDate_: self.config['max_date_js'] ? new Date(self.config['max_date_js']) : null,
					altField: '#dateend_',
					altFormat: 'DD.d.LL.yy.D.L.w',
					monthNames: App.object_state.locale.month['long'],
					dayNames: App.object_state.locale.day['long'],
					dayNamesMin: App.object_state.locale.day['short'],
					currentText: App.object_state.locale.today,
					onSelect: self.onselect_range,
					firstDay: App.datepicker_firstDay || 0,
					hideIfNoPrevNext: true,
					beforeShowDay: we_coloringFunc
				});
				if (self.config['datestart_js'] && self.config['dateend_js']) {
					$.datepicker._setDateDatepicker($('#dateend_div').get(0), new Date(self.config['datestart_js']), new Date(self.config['dateend_js']));
				} else if (self.config['datestart_js']) {
					$.datepicker._setDateDatepicker($('#dateend_div').get(0), new Date(self.config['datestart_js']), 'free');
				} else {
					$.datepicker._gotoToday('#dateend_div');
				}
				if (self.config['real_dateend_js'] === '0' && self.config['real_datestart_js'] === '0') $('#dateend_div .ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
				$('.timepicker').on('change', function() {
					self.helper_time_start_end($(this));
				});
				self.helper_timepicker_limit();
				self.init_relations();
			} else {
				$("#dateend_div").datepicker({
					rangeSelect: false,
					numberOfMonths: 2,
					minDate_: self.config['min_date_js'] ? new Date(self.config['min_date_js']) : null,
					maxDate_: self.config['max_date_js'] ? new Date(self.config['max_date_js']) : null,
					defaultDate: self.config['dateend_js'] ? new Date(self.config['dateend_js']) : null,
					altField: '#dateend_',
					altFormat: 'DD.d.LL.yy.D.L.w',
					monthNames: App.object_state.locale.month['long'],
					dayNames: App.object_state.locale.day['long'],
					dayNamesMin: App.object_state.locale.day['short'],
					currentText: App.object_state.locale.today,
					onSelect: self.onselect_date,
					firstDay: App.datepicker_firstDay || 0,
					hideIfNoPrevNext: true,
					beforeShowDay: we_coloringFunc
				});
				if (self.config['real_dateend_js'] === '0') $('#dateend_div .ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
			}
			if (!App.device.is_mobile()) setTimeout(function () {
				$('#dateend_nice .datelen .input').focus_select_desktop();
			}, 100);
			App.controls.task_terms.init_repeat_day_clicks();
			if (self.config['is_rep']) {
				App.controls.task_repeat.repeat_block_html = Object.fromEntries(
					['#dt_rep', '#drop_dmdaymenu', '#drop_dwdaymenu', '#drop_dmday_endmenu'].map(selector => [selector, $(selector).html()])
				);
				App.controls.task_repeat.update_names();
				$('#rep_isupd').val(1);
			}
			App.controls.task_repeat.helper_repeat_names_menu();
		},

		helper_time_start_end: function(el) {
			let dateStart = $('#datestart').val();
			let dateEnd = $('#dateend').val();
			let time = el.val();
			let [hours, minutes] = time.split(':').map(Number);
			let timeDate = new Date();
			if (el.attr('id') === 'timestart') {
				if (dateStart === dateEnd && time !== '') {
					timeDate.setHours(hours, minutes + 15, 0);
					let newTime = timeDate.toTimeString().substring(0, 5);
					if (newTime === '00:00') newTime = '24:00';
					$("#timeend").timepicker('option', {'minTime': newTime, 'maxTime': '24:00'});
					$('#drop_endtimemenu .menu__item[data-filter]').each(function(){
						if (App.format.HHMM_to_time($(this).attr('data-filter'))<App.format.HHMM_to_time(newTime)) $(this).addClass('menu__item-disabled');
					});
				} else {
					$("#timeend").timepicker('option', self.config.timeend);
					$('#drop_endtimemenu .menu__item[data-filter]').removeClass('menu__item-disabled');
				}
			} else if (el.attr('id') === 'timeend') {
				if (dateStart === dateEnd && time !== '') {
					timeDate.setHours(hours, minutes - 15, 0);
					let newTime = timeDate.toTimeString().substring(0, 5);
					$("#timestart").timepicker('option', {'maxTime': newTime});
					$('#drop_starttimemenu .menu__item[data-filter]').each(function(){
						if (App.format.HHMM_to_time($(this).attr('data-filter'))>App.format.HHMM_to_time(newTime)) $(this).addClass('menu__item-disabled');
					});
				} else {
					$("#timestart").timepicker('option', self.config.timestart);
					$('#drop_starttimemenu .menu__item[data-filter]').removeClass('menu__item-disabled');
				}
			}
		},

		helper_timepicker_limit: function() {
			self.helper_time_start_end($('#timestart'));
			self.helper_time_start_end($('#timeend'));
		}
	}
})();

;(function() {
	let self = App.controls.task_terms_select_and_go = {
		callback: null,
		show_context: function(menu_anchor, endpoint, params) {
			params ||= {};
			params['request'] ||= {};
			params['request']['template'] = 'menu';

			App.menu.show({
				anchor: menu_anchor,
				url: App.helper.url.add_query(endpoint, $.param(params['request'])),
				onload: params.onload || null,
				onshow: params.onshow || null,
				type: params.type || '',
				backup: params.backup || false,
				replace: params.replace || false,
				title: App.object_state.locale['stage'],
				cache_trigger: 'tags'
			});
		},
	}
})();

;(function() {
	let self = App.controls.task_workflow_quick_menu = {
		show: function (anchor) {
			const menu_selector = '#task_workflow_quick_menu';
			const menu = $(menu_selector);

			const id_tag = $(anchor).attr('data-id-tag');
			const id_group = $(anchor).attr('data-id-group');

			menu.find('a').on('click', function (event) {
				event.preventDefault();
				const url = App.helper.url.add_query('/account/stages/', '', {
					id_tag,
					id_group
				});
				App.core.new_window(url);
				App.menu.hide();
			});

			App.menu.show({
				anchor: anchor,
				type: 'left',
				replace: false,
				backup: false,
				box: menu_selector,
				force_dropdown: true,
			});

			menu.one('before_hide', () => {
				menu.find('a').off('click');
			});
		}
	}
})();

;(function () {
	let self = App.controls.contact_add_menu = {
		show: function (anchor) {
			App.menu.show({
				anchor,
				type: 'left fixed',
				onload: function () {
					const menu = $(this);
					App.controls.contact_group_add.onload.call(menu.find('#menuCreateTeam').get(0));
				},
				onshow: function () {
					const menu = $(this);
					App.controls.contact_group_add.onshow.call(menu.find('#menuCreateTeam').get(0));
				},
			});
		}
	};
})();

;(function () {
	let self = App.controls.contact_group_add = {

		is_shown: function (menu) {
			return App.menu.is_shown() && App.menu.active_box === $(menu).get(0);
		},
		onload: function () {
			// const menu = $(this);
		},
		onshow: function () {
			const menu = $(this);

			menu.find('ws-btn').off('click').on('click', function (e) {
				e.preventDefault();
				e.stopPropagation();

				const btn = $(this).find('.btn'), name = $(this).closest('.menu').find('input[name=name]').val().trim();

				if (!name) {
					btn.animate_css('head-shake');
					return;
				}

				if (App.core.async_task.is_loading('contact_group_add_submit')) return;

				App.core.async_task.ajax({
					id: 'contact_group_add_submit',
					method: 'POST',
					url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('contact_group_add:apply')),
					data: { name },
					before_start: function () {
						btn.ws_loading('start');
					}
				}).then(function () {
					if (self.is_shown(menu)) App.menu.hide_all();
				}).catch(function (err) {
					if (self.is_shown(menu) && !err.is_aborted) btn.animate_css('head-shake');
				}).finally(function() {
					btn.ws_loading('stop');
				});
			});
		},
	};
})();

;(function () {
	let self = App.controls.contact_group_select = {
		init: function () { },
		onshow: function () {
			let menu = $(this);
			let place_group = $(App.menu.active_anchor).closest('#' + menu.attr('data-prefix') + '_gr');
			let data_group = place_group.attr('data-form') ? $(eval(place_group.attr('data-form'))) : place_group;
			let id = data_group.find('input[name=id_group]').val();

			if (id !== '') {
				menu.find('.menu__item[data-id]').each(function () {
					$(this).toggleClass('menu__item-active', $(this).attr('data-id') == id)
				});
			}

			menu.find('.menu__item[data-id]').off('click').on('click', function () {
				App.controls.menu.item_set_active(this);
				place_group.find('.in').text($(this).find('.in').text());
				data_group.find('input[name=id_group]').val($(this).attr('data-id'))
				data_group.find('input[name=add_group]').val('');
				if (menu.attr('data-copy-icon')) place_group.prev().replaceWith($(this).find('.space:first-child').html());

				place_group.closest('form').trigger('change');

				App.menu.hide();
			});
			menu.find('#menuCreateTeam ws-btn').off('click').on('click', function () {
				let name = $(this).closest('.menu').find('input[name=name]').val().trim();

				if (name) {
					place_group.find('.in').text(name);
					data_group.find('input[name=id_group]').val('');
					data_group.find('input[name=add_group]').val(name);
					$('#' + menu.attr('data-prefix') + '_gsmenu').remove();
					if (menu.attr('data-copy-icon')) place_group.prev().replaceWith('<ws-icon name="folder_alt"></ws-icon>');

					place_group.closest('form').trigger('change');
				}

				App.menu.hide();
				App.menu.hide();
			});
		},
	};

	App.controls.project_group_select = App.helper.object.clone(App.controls.contact_group_select); // same structure
	App.controls.tag_group_select = App.helper.object.clone(App.controls.contact_group_select); // same structure

	App.controls.contacts_grid_group_menu = {
		applied: function (id_contact, id_group, group_name) {
			id_contact = parseInt(id_contact, 10);
			id_group = parseInt(id_group, 10);
			if (!id_contact || !id_group) return;

			if (App.current_page.page === 'contacts' && App.page.grid_settings.group_by === 'group_name') {
				App.core.reload();
				return;
			}

			let row = $('#obj-user' + id_contact);
			if (!row.length) return;

			row.find('td[data-name=group_name] .in').first().text(group_name || '').attr('data-group', id_group);

			row.attr('class', (row.attr('class') || '').replace(/\bg\d+\b/g, 'g' + id_group));
		},
		show: function (anchor) {
			App.menu.show({
				anchor: anchor,
				box: '#idc_grmenu',
				width: 256,
				type: 'left',
				onshow: function () {
					let menu = $(this);
					let a = $(anchor);
					let id_contact = a.attr('data-id');
					let id_current = a.attr('data-group');

					App.keyboard_selection.select_by_click(anchor);

					menu.attr('data-id-contact', id_contact || '');
					menu.attr('data-selected-id', id_current || '');

					menu.find('.menu__item[data-id]').each(function () {
						$(this).toggleClass('menu__item-active', $(this).attr('data-id') == id_current)
					});

					menu.find('ws-btn[data-role=ok]').toggleDisabled(true);

					menu.find('.menu__item[data-id]').off('click').on('click', function () {
						App.controls.menu.item_set_active(this);
						menu.attr('data-selected-id', $(this).attr('data-id'));
						menu.find('ws-btn[data-role=ok]').toggleDisabled($(this).attr('data-id') == id_current);
					});

					menu.find('ws-btn[data-role=ok]').off('click').on('click', function () {
						let id = menu.attr('data-id-contact');
						let id_group = menu.attr('data-selected-id');
						if (!id || !id_group) return;

						App.menu.hide();
						$.getScript(App.helper.url.add_query('/ajax/user/', App.actions.get('contact_edit_group:apply'), {
							single_user: 1,
							edit_user: id,
							id_group: id_group
						}));
					});
				}
			});
			return false;
		},
	};
})();

;(function() {
	let self = App.controls.contact_select_and_go = {
		callback: null,
		do_search_ajax: null,

		show_context: function(menu_anchor, endpoint, params) {
			params ||= {};
			params['request'] ||= {};
			self.params_request  = params['request'];
			endpoint ||= App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('contact_search:show'));
			App.menu.show({
				anchor: menu_anchor,
				url: endpoint + '&' + $.param(params['request']),
				type: params.type || '',
				text_position: params.text_position || null,
				replace: params.replace || false,
				backup: params.backup || false,
				width: params.width || 480,
				cache_trigger: params.cache_trigger || 'contact',
				use_prev_height: params.use_prev_height || false,
				onload: function() {
					const { init: _, ...request } = params['request'];
					self.init.call(this, request);
					params.onload?.call(this);
				},
				onshow: params.onshow,
			});
		},
		init: function(request) {
			request ||= {};
			let menu = $(this);

			menu.on('before_hide', function () {
				App.core.call_queue.delete('editor_contact_search');
				self.do_search_ajax.abort();
			});

			menu.find('.menu__group-search input').off('keyup').bind('keyup', function (e) {
				let input = $(this);
				let key = e.keyCode || e.charCode;

				if (key === App.keycode.Enter && menu.find('.menu__group-empty').is(':visible')) {
					menu.find('.menu__group-search input').val('');
					const search_params = {
						search: '',
						request,
					};
					App.core.call_queue.add('editor_contact_search', self.helper_server_search, menu, search_params, 0);
					return;
				}

				const search_params = {
					search: input.val(),
					request,
				};
				App.core.call_queue.add('editor_contact_search', self.helper_server_search, menu, search_params, key === App.keycode.Enter ? 0 : 0.3);
			});
		},
		helper_server_search: function(params) {
			let menu = $(this);
			let last_val = (menu.attr('data-last-search') || '').trim();
			let request = typeof params === 'object' &&  params.request ? params.request : {};
			let search = typeof params === 'string' ? params : params.search;

			search = search.trim();

			if (search === last_val) return;

			const url = request.url ?? App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('contact_search:show'));

			if (search.length > 2) request = {...request, search};
			else request = {...request, init: 2};

			menu.addClass('menu-unloading');
			self.do_search_ajax
				.ajax(App.helper.url.add_query(url, '', request))
				.then(function(res) {
					menu.find('.scrollZone').html(res);
					App.keyboard_selection.init_container(menu.find('.scrollZone'));
				}).finally(() => {
					if (self.do_search_ajax.is_idle()) menu.removeClass('menu-unloading');
				});

			menu.attr('data-last-search', search);
		},

		onBoot: function () {
			self.do_search_ajax = App.core.async_task.context('controls.contact_select_and_go.do_search');
		}
	}
})();

;(function() {
	let self = App.controls.members_usermenu = {
		show: function (anchor, id_user) {
			App.menu.show({
				anchor: anchor,
				box: null,
				url: '/ajax/?' + App.actions.get('members_usermenu:show') + '&user=' + id_user,
				type: 'right'
			});
		}
	}
})();
;(function() {
	let self = App.controls.user_collapse = {

		data: {},

		default_on: {
			custom: true,
			task: true,
			tag_card: true,
			user_card: true,
			report_group: false,
			report_group_sub: false,
			gantt_project: false,
			gantt_user: false,
			gantt_project_exp: true,
			gantt_user_exp: true,
			schedule_card: true,
			sidebar_folder: true,
			sidebar_folder_extra: false,
			sidebar_chat_group: true,
		},

		is_collapsed: function (id, type) {
			type ||= 'custom';
			id = parseInt(id);
			this.data[type] ||= new Set();
			let res = this.default_on[type] ^ !this.data[type].has(id);
			return !!res;
		},

		init: function(type, data) {
			this.data[type] = new Set(data);
		},

		save: function (id, type, is_on) {
			let is_save = this.default_on[type] ^ is_on;
			id = parseInt(id);
			this.data[type] ||= new Set();
			if (is_save) {
				this.data[type].add(id);
			} else {
				this.data[type].delete(id);
			}
			$.ajax({url: App.helper.endpoint.primary() + '?' + App.actions.get('process:collapse') + '&type=' + type + '&id=' + id + '&is_on=' + (is_on ? 1 : 0)});
		},
		save_all: function (ids, type, is_on) {
			ids.forEach(id => {
				const is_save = this.default_on[type] ^ is_on;
				id = parseInt(id);
				this.data[type] ||= new Set();
				if (is_save) {
					this.data[type].add(id);
				} else {
					this.data[type].delete(id);
				}
			});
			$.ajax({
				type: 'POST',
				url: App.helper.endpoint.primary() + '?' + App.actions.get('process:collapse_all'),
				data: {type, ids, is_on}
			});
		}
	}
})();
;(function () {
		let self = App.controls.user_group = {
			deleteGroup: function (id, action) {
				$.ajax({
					url: App.helper.url.ajax.user_group(id) + '?' + action,
					success: function () {
						$('#obj-group' + id).remove();
					}
				});
				App.menu.hide();
				return false
			},
			deleteSubGroup: function (id_group, id_group_sub, action) {
				$.ajax({
					url: App.helper.url.ajax.user_group(id_group) + '?' + action,
					success: function () {
						$('#obj-department' + id_group_sub).remove();
					}
				});
				App.menu.hide();
				return false;
			}
		}
	}
)
();
;(function () {
	let self = App.controls.user_group_select = {
		init: function () {
			let menu = $(this);
			let place_group = $('#' + menu.attr('data-prefix') + '_gr');
			let place_subgroup = $('#' + menu.attr('data-prefix') + '_gs');
			menu.find('.menu__item[data-id]').click(function () {
				App.controls.menu.item_set_active(this);
				place_group.find('.in').text($(this).find('.in').justtext());
				place_group.find('input[name=id_group]').val($(this).attr('data-id'))
				place_group.find('input[name=add_group]').val('');
				place_group.find('input[name=add_group_my]').val('0');
				if (place_group.prev().attr('name') === 'office' || place_group.prev().attr('name') === 'shop') place_group.prev().attr('name', $(this).attr('data-is-office') ? 'office' : 'shop');
				place_group.closest('.inputBlock__label').toggleClass('inputBlock__label-client', $(this).attr('data-is-office') ? false : true);
				$('#invite_group .inputBlock-subset').load(menu.attr('data-subset-url') + '&prefix=' + menu.attr('data-prefix') + '&edit_group=' + $(this).attr('data-id'), function () {
					App.invite.role.validate();
				});
				$('#' + menu.attr('data-prefix') + '_gsmenu').remove();
				App.menu.hide();
			});
			menu.find('#menuCreateTeam ws-btn').click(function () {
				let name = $(this).closest('.menu').find('input[name=name]').val().trim();
				let is_my = $(this).closest('.menu').find('input[name=is_my]').val();
				if (name) {
					place_group.find('.in').text(name);
					place_group.find('input[name=id_group]').val('');
					place_group.find('input[name=add_group]').val(name);
					place_group.find('input[name=add_group_my]').val(is_my);
					$('#invite_group .inputBlock-subset').load(menu.attr('data-subset-url') + '&prefix=' + menu.attr('data-prefix'));
					place_subgroup.find('.in').text(place_subgroup.find('.in').attr('data-txt-default'));
					place_subgroup.find('input[name=id_group_sub]').val(0);
					place_subgroup.find('input[name=add_group_sub]').val('');
					App.invite.role.validate();
					place_subgroup.addClass('drop_select_gray').prev().css({opacity: 0});
					$('#' + menu.attr('data-prefix') + '_gsmenu').remove();
				}
				App.menu.hide();
				App.menu.hide();
			});
		},

		onshow: function () {
			let menu = $(this);
			let place_group = $('#' + menu.attr('data-prefix') + '_gr');
			let id = place_group.find('input[name=id_group]').val();
			menu.find('.menu__item[data-id]').each(function () {
				$(this).toggleClass('menu__item-active', $(this).attr('data-id') == id)
			});
		},

		init_subset: function () {
			let menu = $(this);
			let place_subgroup = $('#' + menu.attr('data-prefix') + '_gs');
			menu.find('.menu__item[data-id]').click(function () {
				App.controls.menu.item_set_active(this);
				let id = $(this).attr('data-id');
				place_subgroup.find('.in').text($(this).find('.in').text())
				place_subgroup.find('input[name=id_group_sub]').val(id);
				place_subgroup.find('input[name=add_group_sub]').val('');
				place_subgroup.toggleClass('drop_select_gray', !!id).prev().css({opacity: id ? 1 : 0});
				App.menu.hide();
				App.invite.role.validate();
				return false;
			});
			menu.find('#menuCreateDepartment ws-btn').click(function (e) {
				e.stopPropagation();
				let name = $(this).closest('.menu').find('input').val().trim();
				if (name) {
					place_subgroup.find('.in').text(name);
					place_subgroup.find('input[name=id_group_sub]').val('');
					place_subgroup.find('input[name=add_group_sub]').val(name);
					place_subgroup.removeClass('drop_select_gray').prev().css({opacity: 1});
					App.invite.role.validate();
				}
				App.menu.hide();
				App.menu.hide();
			});
		},

		onshow_subset: function () {
			let menu = $(this);
			let place_subgroup = $('#' + menu.attr('data-prefix') + '_gs');
			let id = place_subgroup.find('input[name=id_group_sub]').val();
			menu.find('.menu__item[data-id]').each(function () {
				$(this).toggleClass('menu__item-active', $(this).attr('data-id') == id)
			});
		},
		users_grid_menu_helper: {
			bindSelectableItems: function (scope, selector, targetMenu) {
				let target = targetMenu || scope;
				scope.find(selector).off('click').on('click', function () {
					App.controls.menu.item_set_active(this);
					target.attr('data-selected-id', $(this).attr('data-id'));
				});
			},
			runScriptAction: function (action, data) {
				$.getScript(App.helper.url.add_query('/ajax/user/', App.actions.get(action), data));
			},
			showMenu: function (config) {
				App.menu.show({
					anchor: config.anchor,
					box: config.box,
					width: 256,
					type: 'left',
					onshow: function () {
						config.onshow($(this), $(config.anchor));
					}
				});
				return false;
			},
		}
	};

	self.users_grid_team_menu = {
		show: function (anchor) {
			return self.users_grid_menu_helper.showMenu({
				anchor: anchor,
				box: '#idugt_grmenu',
			onshow: function (menu, anchorEl) {
				let id_user = anchorEl.attr('data-id');
				let id_current = anchorEl.attr('data-group');
				let teamItemsSelector = '.menu__item-team[data-id]';

				menu.attr('data-id-user', id_user || '');
				menu.attr('data-selected-id', id_current || '');

				let okBtn = menu.find('ws-btn[data-role=ok]').toggleDisabled(true);
				menu.find(teamItemsSelector).each(function () {
					$(this).toggleClass('menu__item-active', $(this).attr('data-id') == id_current);
				});
				self.users_grid_menu_helper.bindSelectableItems(menu, teamItemsSelector);
				menu.find(teamItemsSelector).on('click', function () {
					okBtn.toggleDisabled($(this).attr('data-id') == id_current);
				});

				okBtn.off('click').on('click', function () {
					let id = menu.attr('data-id-user');
					let id_group = menu.attr('data-selected-id');
					if (!id || !id_group) return;

					App.menu.hide();
					self.users_grid_menu_helper.runScriptAction('user_edit_grid_team:apply', {
						single_user: 1,
						edit_user: id,
						id_group: id_group
					});
				});
			},
			});
		},
	};

	self.users_grid_department_menu = {
		show: function (anchor) {
			return self.users_grid_menu_helper.showMenu({
				anchor: anchor,
				box: '#idugd_grmenu',
				onshow: function (menu, anchorEl) {
					let id_user = anchorEl.attr('data-id');
					let id_team = anchorEl.attr('data-team');
					let id_sub = anchorEl.attr('data-sub') || '0';

					menu.attr('data-id-user', id_user || '');
					menu.attr('data-selected-id', id_sub);
					menu.attr('data-id-team', id_team || '');

				let host = menu.find('.users_grid_department_menu__items');
				host.html('<div class="menu__group menu__group-search flex_row"><span class="in flex_content">…</span></div>');

				let okBtn = menu.find('ws-btn[data-role=ok]').toggleDisabled(true);

				$.get(
					App.helper.url.add_query('/ajax/user/', App.actions.get('user_grid_department_items:show'), {
						id_group: id_team,
						id_current_sub: id_sub
					}),
					function (html) {
						host.html(html);
						App.menu.init_submenu(menu);
						self.users_grid_menu_helper.bindSelectableItems(host, '.menu__item[data-id]', menu);
						host.find('.menu__item[data-id]').on('click', function () {
							okBtn.toggleDisabled($(this).attr('data-id') == id_sub);
						});
					}
				);

				okBtn.off('click').on('click', function () {
					let id = menu.attr('data-id-user');
					let id_group_sub = menu.attr('data-selected-id');
					if (!id || id_group_sub === undefined || id_group_sub === '') return;

					App.menu.hide();
					self.users_grid_menu_helper.runScriptAction('user_edit_grid_department:apply', {
						single_user: 1,
						edit_user: id,
						id_group_sub: id_group_sub
					});
				});
				},
			});
		},
	};

	App.controls.users_grid_team_menu = self.users_grid_team_menu;
	App.controls.users_grid_department_menu = self.users_grid_department_menu;
})();

;(function() {
	let self = App.controls.user_menu = {
		show: function (el, id, menu_type, id_project = null, options = {}) {
			if (!menu_type) menu_type = '';
			if (!id_project && !options.no_auto_find_project) id_project = App.current_page.project;
			if (id >= App.config.real_user_id) {
				App.menu.show({
					anchor: el,
					url: '/ajax/user/?' + App.actions.get('user_card:show') + '&id=' + id + (id_project ? '&id_project=' + id_project : ''),
					box: '#dropuser' + id + '_' + id_project + 'menu',
					type: menu_type,
					load_always: true,
					backup: options.backup ?? false,
					replace: options.replace ?? false,
					onshow: function () {
						const menu = $(this);
						const icon_open = menu.find('.menu__item-lastActivity ws-icon.onhover');
						icon_open.toggleClass( 'ws-utility-hidden', !App.modal.is_shown() );

						// find ".l .user_card" selector and set height
						if (!App.device.is_mobile()) {
							const container = menu.find('.l');
							const user_card = container.find('.user_card');
							if (user_card.length && container.length) {
								user_card.height(container.outerHeight());
							}
						}
					}
				});
			}
		},

		context_handler: function(target) {
			let o = $(target).closest('[data-member], [data-user-card], .av[data-user], .av_nm[data-user], .av_sm[data-user], .av[data-user], .membersPage__table tr[data-user], .sidePanel__list__item-user[data-user]');
			if (o.length === 0) return false;

			let id_user = +(o.attr('data-member') || o.attr('data-user-card') || +o.attr('data-user') || +o.attr('data-user-id') || 0);
			if (!id_user || isNaN(id_user) || id_user < 11) return false;

			App.controls.user_menu.show(o, id_user, '', 0, {
				backup: true
			});

			return true;
		}
	}
})();

$(document).on('click', '[data-user-card]', function (e) {
	e.stopPropagation();
	let el = $(e.target).closest('[data-user-card]');
	App.menu.log_mouse_position(e);
	App.controls.user_menu.show(el.get(0), el.attr('data-user-card'), 'left', App.current_page.project, {
		backup: true,
	});
})

;/*
 * Worksection Engine Class user_quick_menu.js
 * -----------------------------------------------------
 * Copyright (c) 2025. Worksection TM (https://worksection.com)
 * Valeriy Galyant (Valeriy.Galyant@gmail.com)
 * Kyiv, Ukraine
 * This copyright notice MUST stay intact for legal use
 */

(function() {
	let self = App.controls.user_quick_menu = {
		data: {},
		show: function (anchor, id_user, params) {
			params ||= {}
			self.data = {anchor, id_user}
			App.menu.show({
					anchor: anchor,
					type: params.type || 'left',
					replace: params.replace || false,
					backup: params.backup || false,
					profile: params.profile || false,
					box: '#quickUserMenu',
					width: 350,
					force_dropdown: true,
					onshow: function () {
						const {only} = params;
						const menu = $(this);

						const waits_invite = Boolean(App.helper.team(id_user, 'waits_invite') && App.helper.team(id_user, 'can_edit'));
						const is_profile = $(App.menu.active_anchor).attr('data-profile') === 'true';
						const onlySet = only && only.length ? new Set(only) : null;

						menu.find('.menu__item[data-key]').each(function () {
							const key = this.dataset.key;
							let hidden;

							if (waits_invite) {
								hidden = !(key === 'card' || key === 'reinvite');
							} else {
								if (key === 'reinvite') {
									hidden = true;
								} else if (key === 'profile') {
									hidden = !(is_profile || onlySet?.has('profile'));
								} else if (!onlySet) {
									hidden = false;
								} else {
									hidden = !onlySet.has(key);
								}
							}

							this.classList.toggle('menu__item-hidden', hidden);
						});

						//if isset param.is_dashboard add menu class
						if (params.is_dashboard && !App.device.is_mobile()) {
							menu.addClass('menu__dashboard');
						}

						if (menu.find('.menu__itemFake-userCard').length) {
							const sub_id = id_user;
							// @see js/inc/comment_form.js
							menu.find('.menu__itemFake-userCard .av').html(App.helper.team(sub_id, 'avatar'));
							menu.find('.menu__itemFake-userCard .name').text(App.helper.team(sub_id, 'name'));
							// menu.find('.menu__itemFake-userCard > ws-btn').attr('data-user-card', sub_id);
						}
					}
			})
		},

		onLogin: function () {
			let menu = $('#quickUserMenu');
			menu.on('click','[data-key]', function() {
				const {anchor, id_user} = self.data;
				switch ($(this).attr('data-key')) {
					case 'open':
						App.menu.hide();
						App.core.goto(App.helper.url.user(id_user));
						break;
					case 'chat':
						App.menu.hide();
						App.chat_view.show({url: App.helper.url.chat_personal(id_user)});
						break;
					case 'card':
						App.menu.hide();
						App.controls.user_menu.show(anchor, id_user);
						break;
					case 'activity':
						App.menu.hide();
						App.mymenu.show_activity(this, id_user);
						break;
					case 'profile':
						if (App.device.is_mobile()) {
							App.profile.show_menu(this, { backup: true, id_user });
						} else {
							App.menu.hide();
							App.profile.modal.show(App.helper.endpoint.user(id_user) + '?' + App.actions.get('user_profile:show'));
						}
						break;
					case 'reinvite':
						App.menu.hide();
						App.invite_again.show(anchor, { id_user });
						break;
				}
			});
		}
	};
})();

;(function () {
	let self = App.controls.user_role_select = {
		config: {},
		
		init: function (config) {
			self.config = config;
			if (!$('.roleBox').hasClass('role_my')) {
				$('#dropaccessmenu .menu__item[data-id]').bind('click', function () {
					const is_contact = $(this).attr('data-contact');
					const roleBox = $('#dropaccess').closest('.roleBox');
					const roleId = parseInt($(this).attr('data-id'), 10);
					App.controls.menu.item_set_active(this);
					App.menu.hide(true);
					self.role_hints(roleId);
					roleBox.find('.roleIcon').html($(this).find('.space').html());
					roleBox.find('.roleTitle').text($(this).find('.in').text());
					roleBox.find('input[name=id_role]').val(roleId).closest('form').trigger('change');
					let tmpName = $(App.modal.obj_window).find('.btns-row ws-btn').attr('name');
					if (is_contact) {
						roleBox.find('input[name=id_role]').parent().addClass('drop_seldel');
						$(document.modfrm).removeClass('frm_dis');
						$(App.modal.obj_window).find('.btns-row ws-btn').toggleDisabled(false).attr('name', tmpName.replace(/btn-a/, 'btn-w')).attr('text', self.config.txt_contact);
						$('#admrole_descr > .setupBlock').addClass('setupBlock__bg-alert');
						roleBox.addClass('roleBox-contact');
					} else {
						roleBox.find('input[name=id_role]').parent().removeClass('drop_seldel');
						$(document.modfrm).removeClass('frm_dis');
						$(App.modal.obj_window).find('.btns-row ws-btn').toggleDisabled(false).attr('name', tmpName.replace(/btn-w/, 'btn-a')).attr('text', self.config.txt_update);
						$('#admrole_descr > .setupBlock').removeClass('setupBlock__bg-alert');
						roleBox.removeClass('roleBox-contact');
					}
					if (self.config.noticed.includes(roleId)) {
						$('#admrole_descr > .setupBlock').addClass('setupBlock__bg-notice');
					} else {
						$('#admrole_descr > .setupBlock').removeClass('setupBlock__bg-notice');
					}
					if (self.config.is_profile) App.profile.helper.formSubmitToggle();
				});
			}
			setTimeout(function () {
				self.role_hints(self.config.id_role);
			}, 0); // after modal shown
		},

		role_hints: function (role) {
			const hints_block = $('#admrole_descr > .setupBlock');
			hints_block.removeClass('ws-utility-hidden');

			$('#admrole_out [data-role]').hide().each(function() {
				let str = ',' + $(this).attr('data-role') +',';
				if (str.indexOf(',' + role + ',') != -1) $(this).show();
				if (role == self.config.team_admin && !$('#ta_scope_gr').prop('checked') && str.indexOf(',' + role + '_TM,') != -1) $(this).show();
				if (role == self.config.team_admin && $('#ta_scope_gr').prop('checked') && str.indexOf(',' + role + '_GR,') != -1) $(this).show();
			});

			const has_content = hints_block.children(':visible').length > 0;
			hints_block.toggleClass('ws-utility-hidden', !has_content);
		},

	};
})();

;(function() {
	let self = App.controls.user_select_and_go = {
		callback: null,
		last_value_target: null,
		show_context: function(menu_anchor, endpoint, params) {
			params ||= {};
			params['request'] ||= {};
			params['request']['template'] = 'menu';
			endpoint ||= $(menu_anchor).attr('data-url');
			App.menu.show({
				anchor: params.anchor || menu_anchor,
				url: App.helper.url.add_query(endpoint, $.param(params['request'])),
				onload: function() {
					if (params.onload) params.onload.call(this, this);
				},
				onshow: function() {
					self.onshow(this, params);
				},
				type: params.type || '',
				text_position: params.text_position || null,
				backup: params.backup || false,
				replace: params.replace || false,
				title: App.object_state.locale['user'],
				cache_trigger: params.cache_trigger || 'user',
				width: params.width || 324,
				force_dropdown: params.force_dropdown ?? false,
				load_always: params.load_always ?? false,
				use_prev_height: params.use_prev_height || false,
				onhide: params.onhide,
			});
		},
		onshow: function(menu, params = {}) {

			self.last_value_target = params.last_value_target || null;

			if (params.onshow) params.onshow.call(menu, menu);

			let last_value_handler = function (init) {
				if (self.last_value_target == null) return;

				if (init === true) $(self.last_value_target).attr('data-real-value', self.get_value_from_menu(menu).join(','));

				let last_value = $(self.last_value_target).attr('data-last-value');
				let real_value = $(self.last_value_target).attr('data-real-value');
				let is_diff = last_value != null && last_value !== real_value;

				if (init === true && is_diff) {
					let last_value_ids = last_value.split(',');
					$(menu).find('.menu__item[data-id]').each(function() {
						$(this).toggleClass('menu__item-active', last_value_ids.includes($(this).attr('data-id')));
					});
					$(menu).trigger('after_interaction');
				}

				if (is_diff) {
					$(menu).find('.menu__group-head ws-btn').attr('name', 'btn btn-28 btn-a btn-solid btn-primary');
				} else {
					$(menu).find('.menu__group-head ws-btn').attr('name', 'btn btn-28 btn-g btn-fill btn-primary');
				}
			};

			last_value_handler(true);
			$(menu).once_by_criteria('last_value_apply').on('click', '.menu__group-head ws-btn', () => {
				$(self.last_value_target).attr('data-real-value', null).attr('data-last-value', null);
				last_value_handler();
			});
			$(menu).once_by_criteria('last_value_change').on('click', '.menu__item', function () {
				$(self.last_value_target).attr('data-last-value', self.get_value_from_menu(menu).join(','));
				last_value_handler();
			});
		},
		get_value_from_menu: function (menu) {
			return App.controls.menu.get_active_item(menu).get()
				.map(i => $(i).attr('data-id').toInt())
				.sort(App.helper.sort.compare);
		},
		show: function(endpoint, callback) {
			self.callback = callback;
			App.modal.show({
				url: endpoint,
				width: 500,
			});
		},
		team: function(endpoint, callback) {
			$.ajax({
				url: endpoint,
				dataType: 'json',
				success: function(json) {
					callback(json);
				}
			});
		}
	}
})();

;(function () {
	const self = App.controls.user_template = {
		/**
		 * @enum UserTemplateType
		 */
		types: Object.freeze({
			grid_page: 1,
		}),
		/**
		 * @param {Pick<UserTemplate, 'name' | 'visibility' | 'type'>} fields
		 * @param {{onSuccess: OnSavedCallback}} callbacks
		 */
		save_template({name, visibility, type}, {onSuccess}) {
			$.ajax({
				url: App.helper.endpoint.ajax() + '?'
					+ App.actions.get('user_template:save'),
				type: 'POST',
				data: {
					name,
					visibility,
					type
				},
				success(data) {
					onSuccess(data)
					App.menu.invalidate_cache_by_trigger(self.construct_menu_cache_trigger())
				},
			});
		},
		/**
		 * @param {Number} id
		 * @param {{onSuccess: (response: {message: String}) => {}}} callbacks
		 */
		delete_template(id, {onSuccess}) {
			$.ajax({
				url: App.helper.endpoint.ajax() + '?'
					+ App.actions.get('user_template:delete'),
				type: 'POST',
				data: {
					id
				},
				success(data) {
					onSuccess(data);
					App.menu.invalidate_cache_by_trigger(self.construct_menu_cache_trigger())
				},
			});
		},
		/**
		 * @param {Number} id
		 * @param {Pick<UserTemplate, 'name'>} fields
		 * @param {{onSuccess: (response: {message: String}) => {}}} callbacks
		 */
		update_template(id, {name}, {onSuccess}) {
			$.ajax({
				url: App.helper.endpoint.ajax() + '?'
					+ App.actions.get('user_template:update'),
				type: 'POST',
				data: {
					id,
					name
				},
				success(data) {
					onSuccess(data);
					App.menu.invalidate_cache_by_trigger(self.construct_menu_cache_trigger())
				},
			});
		},
		/**
		 * @param {Pick<MenuShowData, 'anchor' | 'backup' | 'replace'>} args
		 * @param {Pick<UserTemplate, 'type'>} request
		 * @param {{onSelect: (data: Pick<UserTemplate, 'id'|'name'|'id_user'>) => void}} callbacks
		 */
		select_template_and_go({anchor, backup = false, replace = false, }, {type}, {onSelect}) {
			App.menu.show({
				anchor: anchor,
				backup,
				replace,

				cache_trigger: self.construct_menu_cache_trigger({type}),
				url: App.helper.endpoint.ajax() + '?'
					+ App.actions.get('user_template_select_and_go:show') + '&type=' + type,
				onload(menu) {
					App.controls.menu.init(menu);
				},
				onshow(menu) {
					const {unbind: unbindSelect} = menu.addDelegatedEventListener('click', '[data-id]', (e, el) => {
						onSelect({
							id: Number(el.dataset.id),
							name: el.dataset.name,
							id_user: Number(el.dataset.idUser),
						});
					});
					menu.unbind = unbindSelect;
				},
				onhide(menu) {
					menu.unbind?.();
				},
				oninvalidate(menu) {
					menu.unbind?.();
					!menu.isHidden() && self.select_template_and_go({anchor, backup, replace: true}, {type}, {onSelect})
				}
			})
		},
		/**
		 * @param {Pick<UserTemplate, 'type'>} [cacheValues]
		 */
		construct_menu_cache_trigger({type} = {}) {
			let cacheTrigger = 'select_template_and_go';
			type && (cacheTrigger += `,${type}_select_template_and_go`);
			return cacheTrigger;
		}
	};
})();

/**
 * @typedef {1}  UserTemplateType
 */
/**
 * @typedef {0|1|2|3} UserTemplateVisibility
 */
/**
 * @typedef {Object} UserTemplate
 * @property {Number} id
 * @property {String} name
 * @property {Number} id_user
 * @property {UserTemplateType} type
 * @property {UserTemplateVisibility} visibility
 */

/**
 * @typedef {(response: {message: String, data: Pick<UserTemplate, 'id'|'name'|'user'>}) => {}} OnSavedCallback
 */
;// Purpose: Context menu to select and apply user's topic status
(function () {
    let self = App.controls.user_topic_status = {
        show_method: 'user_topic_status:show',
        apply_method: 'user_topic_status:apply',
        wipe_status_method: 'user_topic_status:wipe_status',

        //entry point
        click: function (el, anchor, endpoint, params) {
            let target = el.target;

            // Check if delete was clicked
            if (target.closest('.delete')) {
                self.clear_status(endpoint);
                return;
            }

            // open context menu
            self.show_context(anchor, endpoint, params);
        },

        // Wipe status daily
        wipe_status: function (el, endpoint) {

            const active_class = 'sw_act';
            const wipe_status = el.classList.contains(active_class) ? 0 : 1;

            //toggle active class
            el.classList.toggle(active_class);

            endpoint = App.helper.url.add_query(endpoint, App.actions.get(self.wipe_status_method) + '&wipe_status=' + wipe_status);
            $.ajax({
                type: 'POST',
                url: endpoint
            });
        },

        clear_status: function (endpoint) {
            endpoint = App.helper.url.add_query(endpoint, App.actions.get(self.apply_method));
            $.ajax({
                type: 'POST',
                url: endpoint
            });
        },

        show_context: function (anchor, endpoint, params) {

            params ||= {};
            params.request ||= {};
            // Server expects menu template
            params.request.template = 'menu';
            let temp_endpoint = endpoint;

            // Ensure action is present
            if (endpoint.indexOf('action=') === -1) {
                endpoint = App.helper.url.add_query(endpoint, App.actions.get(self.show_method));
            }

            App.menu.show({
                anchor: anchor,
                box: params.box || '#topicStatus',
                url: App.helper.url.add_query(endpoint, $.param(params.request)),
                type: params.type || 'right',
                width: params.width || 260,
                force_dropdown: true,
                backup: true,
                load_always: true,

                // Called once after menu HTML loaded into DOM
                onshow: function () {
                    const menu = $(this);
                    const form = menu.find('form');
                    const menu_active_class = 'menu__item-active';

                    // Delegate clicks to menu items
                    menu.on('click', '.menu__item[data-id]', function (e) {

                        let menu_item = $(this);
                        let id = menu_item.attr('data-id');

                        // The active class clears the status and closes the menu.
                        if(menu_item.hasClass(menu_active_class)) {
                            self.clear_status(temp_endpoint);
                            App.menu.hide();
                            return;
                        }

                        // active class
                        menu.find('.menu__item').removeClass(menu_active_class);
                        menu_item.addClass(menu_active_class);

                        //add action to form
                        if (form.length) {
                            form.find('input[name="id_topic_status"]').val(id);
                            App.core.form_submit(form);
                        }
                        App.menu.hide();
                    });
                },

            });
        },

    };
})();

;const WORKDAY = 100; // 8 hours
const HOLIDAY = 101; // 0 hours
const ILLDAY = 102; // 0 hours
const DAYOFF = 103; // 0 hours

App.holidays = {
	types: [
		WORKDAY,
		HOLIDAY,
		ILLDAY,
		DAYOFF,
	],

	holiday_types: [
		HOLIDAY,
		ILLDAY,
		DAYOFF,
	],

	type_index: {
		[WORKDAY]: 'extraday',
		[HOLIDAY]: 'holiday',
		[ILLDAY]: 'illday',
		[DAYOFF]: 'dayoff'
	},
};
(function() {
	
	
	let self = App.controls.user_workday = {
		is_updated: false,

		config: {
			is_allow_set_vacation: false,
			is_allow_user_edit: false,
			datestart: '', // user 1st day
			dateend: '', // user last day

			firstDay: 0,

			holidays : {},
			extraday : {},
			user_config: {},
			saturday_work: false,
			disable_holidays: 0,
			is_set: null,
		},
		current_datepicker: null,
		uncountable: 0,
		last_day: '',
		last_state: '',
		memo: {},
		locale: {}, // from template

		calc_uncountable: function() {
			setTimeout(()=> {
				self.uncountable = 0;
					for (let type of App.holidays.holiday_types) {
						self.uncountable += $('#dateend_div .ui-datepicker-week-end-cell.ui-datepicker-us-' + App.holidays.type_index[type]).length;
					}
			}, 300);
		},

		helper_set_current_config: function (val) {
			self.config.is_set = val;
		},

		helper_draw_holidays: function (date) {
			let override_weekend = '';
			let override_class = '';
			let override_title = '';
			let is_weekend = date.getDay() === 0 || (!self.config.saturday_work && date.getDay() === 6);
			let match = date >= App.helper.date.from_input($('#ed_datestart').val());
			if (match && $('#ed_dateend').val() && date > App.helper.date.from_input($('#ed_dateend').val())) match = false;
			let date_str = App.helper.date.to_input(date);
			if (date_str in self.config.extraday && !is_weekend) delete self.config.extraday[date_str];
			if (date_str in self.config.user_config[WORKDAY] && !(is_weekend || date_str in self.config.holidays)) delete self.config.user_config[WORKDAY][date_str];
			if (self.config.is_allow_set_vacation) {
				if (self.config.is_set) override_title = self.locale['as_' + App.holidays.type_index[self.config.is_set]];
				let is_weekend = date.getDay() === 0 || (!self.config.saturday_work && date.getDay() === 6);
				if (self.config.extraday && (date_str in self.config.extraday)) {
					override_class += ' ui-datepicker-extraday';
					override_title = self.locale['workday'];
				}
				if (is_weekend && self.config.is_set == WORKDAY && !(date_str in self.config.extraday)) override_title = self.locale['as_' + App.holidays.type_index[WORKDAY]];
			}
			if (self.config.holidays && (date_str in self.config.holidays)) {
				override_weekend = 'holiday';
				override_class = 'ui-datepicker-holiday ' + (is_weekend ? 'ui-datepicker-force-weekend ' : '');
				override_title = self.locale['holiday'] +	(self.config.is_set ? '\n'+self.locale['as_' + App.holidays.type_index[self.config.is_set]] : '');
			} else if (self.config.extraday && (date_str in self.config.extraday)) override_weekend = 'workday';
			if (match) {
				let found = false;
				for (let type of App.holidays.holiday_types) {
					if (self.config.user_config[type] && (date_str in self.config.user_config[type])) {
						override_class += ' ui-datepicker-us-' + App.holidays.type_index[type];
						override_title = self.locale['user_' + App.holidays.type_index[type]];
						if (self.helper_first_last(self.config.user_config[type], 'first').includes(date_str)) override_class += ' first';
						if (self.helper_first_last(self.config.user_config[type], 'last').includes(date_str)) override_class += ' last';
						found = true;
						break;
					}
				}
				if (!found && self.config.user_config[WORKDAY] && (date_str in self.config.user_config[WORKDAY])) {
					override_class += ' ui-datepicker-us-' + App.holidays.type_index[WORKDAY];
					override_title = self.locale['user_' + App.holidays.type_index[WORKDAY]];
				}
			}
			if (self.config.is_set && App.holidays.holiday_types.includes(self.config.is_set))
			{
				let found_other_type = false;
				for (let type of App.holidays.holiday_types) {
					if (type !== self.config.is_set && override_class.includes('ui-datepicker-us-' + App.holidays.type_index[type])) found_other_type = true;
				}
				if (found_other_type) override_class += ' '+$.datepicker._unselectableClass;
			}
			if (self.config.is_set == WORKDAY) {
				let found_holiday_type = false;
				for (let type of App.holidays.holiday_types) {
					if (override_class.includes('ui-datepicker-us-' + App.holidays.type_index[type])) found_holiday_type = true;
				}
				if (
					override_class.includes('ui-datepicker-extraday') ||
					found_holiday_type ||
					(!is_weekend && !override_class.includes('ui-datepicker-holiday'))
				) override_class += ' '+$.datepicker._unselectableClass;
			}
			if (date_str === $('#ed_datestart').val()) {
				override_class += ' ui-datepicker-us-firstday';
				override_title = self.locale['user_datestart'];
			}
			if (date_str === $('#ed_dateend').val()) {
				override_class += ' ui-datepicker-us-lastday';
				override_title = self.locale['user_dateend'];
			}
			return [true, override_class, override_title, override_weekend];
		},

		sync_account_holidays: function() {
			self.config.holidays = App.controls.account_holidays.config.holidays;
			self.config.extraday = App.controls.account_holidays.config.extraday;
			$.datepicker._changeDatepicker($('#dateend_div').get(0), 'hack_update', 1);
		},

		last_we_counter: null,
		update_counters: function (we_counter) {
			if (we_counter) self.last_we_counter = we_counter; else we_counter = self.last_we_counter;
			self.calc_uncountable();

			self.helper_update_counters($('#wd_cnt_work'), we_counter[0]);
			self.helper_update_counters($('#wd_cnt_nonwork'), we_counter[1]);
			let counter_diff = 0;
			for (let type of App.holidays.types) {
				self.helper_update_counters($('#wd_cnt' + type), we_counter[type]);
				if (type === WORKDAY) counter_diff += we_counter[type]; else counter_diff -= we_counter[type];
			}
			setTimeout(()=> {
				self.helper_update_counters($('#wd_cnt_year_hours'), (we_counter[0] + counter_diff + self.uncountable) * 1*$('#wd_work_hrs').val()*$('#wd_is_work_hrs').val());
			}, 500);
			let hrs_pre_day = 1*$('#wd_is_work_hrs').val() ? 1*$('#wd_work_hrs').val() : 0;
			$('.workday_head .total').toggle(hrs_pre_day!=0).prev().toggleClass('name_1str', hrs_pre_day==0);
			if ($('.wd_work_hrs').length) $('.wd_work_hrs').html(App.format.quantity(parseInt($('#wd_work_hrs').text()), App.object_state.locale.hrs));
			if ($('#wd_cnt_year_hours').text() === 'NaN') {
				$('#wd_cnt_year_hours').parent().hide(); $('#wd_work_hrs').toggleDisabled(true);
			} else {
				$('#wd_cnt_year_hours').parent().show(); $('#wd_work_hrs').toggleDisabled(false);
			}
		},

		helper_update_counters: function (o, qty) {
			o.html(qty);
			if (o.next().attr('data-txt')) {
				o.next().html(App.format.quantity(qty, o.next().attr('data-txt')));
			}
		},

		save_form_data: function() {
			let str;
			for (let type of App.holidays.types) {
				str = '';
				for (let i in self.config.user_config[type]) str += (str === '' ? '' : ',') + i;
				$('#ids_usr_' + App.holidays.type_index[type]).val(str);
			}
		},

		set_work_period_date: function(date) {
			self.helper_prevent_scroll();
			self.is_updated = true;
			let date_nice = $('#date_nice').val();
			let adt = date_nice.split('.');
			$(self.current_datepicker).html('<i>' + adt[1] + ' ' + adt[5] + '</i> ' + adt[3]).next().val(date);
			$(self.current_datepicker).parent().find('ws-icon[name*=close]').show();
			$.datepicker._changeDatepicker($('#dateend_div').get(0), $(self.current_datepicker).next().attr('data-param') + '_', App.helper.date.from_input(date));
			$.datepicker._changeDatepicker($('#dateend_div').get(0), $(self.current_datepicker).next().attr('data-param'), App.helper.date.from_input(date));
			App.modal.obj_window.addClass('withCalChanges');
			if (App.profile.is_shown) App.profile.helper.formSubmitToggle();
		},

		clear_work_period_date: function() {
			self.helper_prevent_scroll();
			self.is_updated = true;
			App.modal.obj_window.addClass('withCalChanges');
			$.datepicker._changeDatepicker($('#dateend_div').get(0), 'maxDate_', null);
			$.datepicker._changeDatepicker($('#dateend_div').get(0), 'maxDate', null);
		},

		helper_prevent_scroll: function() {
			$("#dateend_div").css({height: $("#dateend_div").height()}); // prevent scroll
			setTimeout(function() {
				$("#dateend_div").css({height: ''});
			}, 50);
		},

		helper_first_last: function(dates, position) {
			const dateStrings = Object.keys(dates).sort((a, b) => {
				const dateA = App.helper.date.from_input(a);
				const dateB = App.helper.date.from_input(b);
				return dateA - dateB;
			});

			const oneDay = 24 * 60 * 60 * 1000;
			const sequenceDates = [];

			dateStrings.reduce((prevDateStr, currentDateStr, i) => {
				const prevDate = prevDateStr ? App.helper.date.from_input(prevDateStr) : null;
				const currentDate = App.helper.date.from_input(currentDateStr);

				if (i === 0 || currentDate - prevDate > oneDay) {
					if (i > 0 && position === 'last') {
						sequenceDates.push(prevDateStr);
					}
					if (position === 'first') {
						sequenceDates.push(currentDateStr);
					}
				}
				if (i === dateStrings.length - 1 && position === 'last') {
					sequenceDates.push(currentDateStr);
				}
				return currentDateStr;
			}, null);

			return sequenceDates;
		},

		init_holidays: function() {
			$("#dateend_div").datepicker({
				rangeSelect: false,
				numberOfMonths: 12,
				minDate_: self.config.datestart ? new Date(self.config.datestart) : null,
				minDate: self.config.datestart ? new Date(self.config.datestart) : null,
				maxDate_: self.config.dateend ? new Date(self.config.dateend) : null,
				maxDate: self.config.dateend ? new Date(self.config.dateend) : null,
				stepMonths: 12,
				firstDay: App.datepicker_firstDay || 0,
				monthNames: App.object_state.locale.month.long,
				altField: '#usr_date_nice',
				altFormat: 'd.m.yy.w',
				counterFunc: self.update_counters,
				beforeShowDay: self.helper_draw_holidays,
				markCurrentDay: false,
				shiftFunc: self.config.is_allow_set_vacation ? function(inst, id, td, shift) {
					if (!shift) {
						if (!$(td).hasClass('ui-datepicker-week-end-cell')) {
							// Use the selected type if set, otherwise default to HOLIDAY
							let set_type = self.config.is_set || HOLIDAY;
							self.last_state = $(td).hasClass('ui-datepicker-us-' + App.holidays.type_index[set_type]);
							self.last_day = $(td).attr('data-day');
						} else {
							self.last_day = '';
						}
					} else if (self.last_day) {
						let fl = false;
						$(id).find('td[data-day]').filter(function() {
							if ($(this).attr('data-day') == self.last_day || $(this).attr('data-day') == $(td).attr('data-day')) {
								if (fl) { fl = false; return true; }
								fl = true;
							}
							return fl;
						}).filter(function() {
							return $(this).attr('data-day') != self.last_day;
						}).each(function() {
							let do_day, dt;
							dt = $(this).attr('data-day');
							// Use the selected type if set, otherwise default to HOLIDAY
							let set_type = self.config.is_set || HOLIDAY;
							if (self.last_state) {
								for (let type of App.holidays.types) {
									if (dt in self.config.user_config[type]) delete self.config.user_config[type][dt];
								}
							} else {
								self.config.user_config[set_type][dt] = 1;
								for (let type of App.holidays.types) {
									if (type !== set_type && dt in self.config.user_config[WORKDAY]) delete self.config.user_config[WORKDAY][dt];
								}
							}
						});
						self.save_form_data();
						self.last_day = '';
						$.datepicker._updateDatepicker(inst);
						return false;
					}
					return true;
				} : null,
				onSelect: self.config.is_allow_set_vacation ? function(date) {
					self.helper_prevent_scroll();
					$('#dateint').val(date);
					if (date) {
						self.is_updated = true;
						App.modal.obj_window.addClass('withCalChanges');
						let date_nice = $('#usr_date_nice').val();
						let adt = date_nice.split('.');
						let dt = App.format.digits_2(adt[0]) + '.' + App.format.digits_2(adt[1]) + '.' + adt[2];
						let is_weekend = adt[3] == 7 || (!self.config.saturday_work && adt[3] == 6);
						if (self.config.holidays && (dt in self.config.holidays)) is_weekend = true;
						else if (self.config.extraday && (dt in self.config.extraday)) is_weekend = false;
						let js_date = App.helper.date.from_input(date);
						js_date.setDate(js_date.getDate()-1);
						let dt_prev = App.helper.date.to_input(js_date);
						js_date.setDate(js_date.getDate()+2);
						let dt_next = App.helper.date.to_input(js_date);
						if (self.config.is_set && App.holidays.holiday_types.includes(self.config.is_set)) {
							if (dt in self.config.user_config[self.config.is_set]) {
								delete self.config.user_config[self.config.is_set][dt];
								if (dt in self.memo) {
									self.config.user_config[WORKDAY][dt] = 1;
									delete self.memo[dt];
								}
							} else {
								if ((dt in self.config.user_config[WORKDAY])) {
									self.memo[dt] = 1;
									delete self.config.user_config[WORKDAY][dt];
								}
								self.config.user_config[self.config.is_set][dt] = 1;
							}
						}
						if (self.config.is_set === WORKDAY) {
							if (dt in self.config.user_config[WORKDAY]) {
								delete self.config.user_config[WORKDAY][dt];
							} else {
								self.config.user_config[WORKDAY][dt] = 1;
							}
						}
						self.save_form_data();
					}
				} : null,
				defaultDate: new Date(new Date().getFullYear(), 0, 1),
				fullScreen: true
			});
			$('#dateend_div').parent().scrollTop($('#dateend_div .ui-datepicker-today').closest('.ui-datepicker-one-month').position().top);
		},

		init_work_period: function() {
			$('.workday_foot a.inline').click(function () {
				self.current_datepicker = this;
				$(this).next().focus();
			}).next().each(function () {
				$(this).datepicker({
					rangeSelect: false,
					numberOfMonths: 1,
					monthPicker: true,
					beforeShowDay: null,
					altField: '#date_nice',
					altFormat: 'DD.d.LL.yy.D.L.w',
					firstDay: App.datepicker_firstDay || 0,
					onSelect: self.set_work_period_date,
				})
			});
		},

		init_scroll_zone_pointer: function() {
			if (!App.modal.is_shown()) return;

			const scrollZone = App.modal.obj_window.find('.scrollZone').get(0), scrollPointer = $('<div class="scrollPointer"></div>');
			if (scrollZone && $(scrollZone).next('.scrollPointer').length === 0) {
				scrollPointer.append('<ws-icon name="arrows/chevron-down"></ws-icon>');
				$(scrollZone).on('ps-ready', function() {
					const ps = scrollZone.scrollBars;
					scrollPointer.toggleClass('scrollPointer-on', ps.contentHeight > ps.containerHeight);
					scrollZone.addEventListener('ps-scroll-up', function () {
						scrollPointer.addClass('scrollPointer-on');
					});
					scrollZone.addEventListener('ps-y-reach-end', function () {
						scrollPointer.removeClass('scrollPointer-on');
					});
					scrollPointer.click(function () {
						if (scrollPointer.hasClass('scrollPointer-on')) {
							App.controls.js_scrollbars.waitSmoothScrolling(ps);
							scrollZone.scrollTo({top: scrollZone.scrollHeight, behavior: 'smooth'});
						}
					});

					$('#dateend_div').parent().scrollTop($('#dateend_div .ui-datepicker-today').closest('.ui-datepicker-one-month').position().top);
				}).after(scrollPointer);
			}
		},

		init: function() {
			self.is_updated = false;
			self.calc_uncountable();

			self.init_holidays();
			if (self.config.is_allow_user_edit) {
				$("input[name=work_hrs]").inputFilter(function(value) {
					return /^\d*$/.test(value) && (value === "" || parseInt(value) <= 24);
				});
				self.init_work_period();
			}
		}
	}
})();
